/*!
 * jQuery JavaScript Library v3.5.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2020-05-04T22:49Z
 */
!function (a, b) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = a.document ? b(a, !0) : function (a) {
        if (!a.document) throw new Error("jQuery requires a window with a document");
        return b(a)
    } : b(a)
}("undefined" != typeof window ? window : this, function (a, b) {
    function c(a, b, c) {
        c = c || va;
        var d, e, f = c.createElement("script");
        if (f.text = a, b) for (d in wa) e = b[d] || b.getAttribute && b.getAttribute(d), e && f.setAttribute(d, e);
        c.head.appendChild(f).parentNode.removeChild(f)
    }

    function d(a) {
        return null == a ? a + "" : "object" == typeof a || "function" == typeof a ? na[oa.call(a)] || "object" : typeof a
    }

    function e(a) {
        var b = !!a && "length" in a && a.length, c = d(a);
        return !ta(a) && !ua(a) && ("array" === c || 0 === b || "number" == typeof b && b > 0 && b - 1 in a)
    }

    function f(a, b) {
        return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase()
    }

    function g(a, b, c) {
        return ta(b) ? ya.grep(a, function (a, d) {
            return !!b.call(a, d, a) !== c
        }) : b.nodeType ? ya.grep(a, function (a) {
            return a === b !== c
        }) : "string" != typeof b ? ya.grep(a, function (a) {
            return ma.call(b, a) > -1 !== c
        }) : ya.filter(b, a, c)
    }

    function h(a, b) {
        for (; (a = a[b]) && 1 !== a.nodeType;) ;
        return a
    }

    function i(a) {
        var b = {};
        return ya.each(a.match(Ja) || [], function (a, c) {
            b[c] = !0
        }), b
    }

    function j(a) {
        return a
    }

    function k(a) {
        throw a
    }

    function l(a, b, c, d) {
        var e;
        try {
            a && ta(e = a.promise) ? e.call(a).done(b).fail(c) : a && ta(e = a.then) ? e.call(a, b, c) : b.apply(void 0, [a].slice(d))
        } catch (a) {
            c.apply(void 0, [a])
        }
    }

    function m() {
        va.removeEventListener("DOMContentLoaded", m), a.removeEventListener("load", m), ya.ready()
    }

    function n(a, b) {
        return b.toUpperCase()
    }

    function o(a) {
        return a.replace(Na, "ms-").replace(Oa, n)
    }

    function p() {
        this.expando = ya.expando + p.uid++
    }

    function q(a) {
        return "true" === a || "false" !== a && ("null" === a ? null : a === +a + "" ? +a : Sa.test(a) ? JSON.parse(a) : a)
    }

    function r(a, b, c) {
        var d;
        if (void 0 === c && 1 === a.nodeType) if (d = "data-" + b.replace(Ta, "-$&").toLowerCase(), c = a.getAttribute(d), "string" == typeof c) {
            try {
                c = q(c)
            } catch (a) {
            }
            Ra.set(a, b, c)
        } else c = void 0;
        return c
    }

    function s(a, b, c, d) {
        var e, f, g = 20, h = d ? function () {
                return d.cur()
            } : function () {
                return ya.css(a, b, "")
            }, i = h(), j = c && c[3] || (ya.cssNumber[b] ? "" : "px"),
            k = a.nodeType && (ya.cssNumber[b] || "px" !== j && +i) && Va.exec(ya.css(a, b));
        if (k && k[3] !== j) {
            for (i /= 2, j = j || k[3], k = +i || 1; g--;) ya.style(a, b, k + j), (1 - f) * (1 - (f = h() / i || .5)) <= 0 && (g = 0), k /= f;
            k *= 2, ya.style(a, b, k + j), c = c || []
        }
        return c && (k = +k || +i || 0, e = c[1] ? k + (c[1] + 1) * c[2] : +c[2], d && (d.unit = j, d.start = k, d.end = e)), e
    }

    function t(a) {
        var b, c = a.ownerDocument, d = a.nodeName, e = _a[d];
        return e ? e : (b = c.body.appendChild(c.createElement(d)), e = ya.css(b, "display"), b.parentNode.removeChild(b), "none" === e && (e = "block"), _a[d] = e, e)
    }

    function u(a, b) {
        for (var c, d, e = [], f = 0, g = a.length; f < g; f++) d = a[f], d.style && (c = d.style.display, b ? ("none" === c && (e[f] = Qa.get(d, "display") || null, e[f] || (d.style.display = "")), "" === d.style.display && $a(d) && (e[f] = t(d))) : "none" !== c && (e[f] = "none", Qa.set(d, "display", c)));
        for (f = 0; f < g; f++) null != e[f] && (a[f].style.display = e[f]);
        return a
    }

    function v(a, b) {
        var c;
        return c = "undefined" != typeof a.getElementsByTagName ? a.getElementsByTagName(b || "*") : "undefined" != typeof a.querySelectorAll ? a.querySelectorAll(b || "*") : [], void 0 === b || b && f(a, b) ? ya.merge([a], c) : c
    }

    function w(a, b) {
        for (var c = 0, d = a.length; c < d; c++) Qa.set(a[c], "globalEval", !b || Qa.get(b[c], "globalEval"))
    }

    function x(a, b, c, e, f) {
        for (var g, h, i, j, k, l, m = b.createDocumentFragment(), n = [], o = 0, p = a.length; o < p; o++) if (g = a[o], g || 0 === g) if ("object" === d(g)) ya.merge(n, g.nodeType ? [g] : g); else if (eb.test(g)) {
            for (h = h || m.appendChild(b.createElement("div")), i = (bb.exec(g) || ["", ""])[1].toLowerCase(), j = db[i] || db._default, h.innerHTML = j[1] + ya.htmlPrefilter(g) + j[2], l = j[0]; l--;) h = h.lastChild;
            ya.merge(n, h.childNodes), h = m.firstChild, h.textContent = ""
        } else n.push(b.createTextNode(g));
        for (m.textContent = "", o = 0; g = n[o++];) if (e && ya.inArray(g, e) > -1) f && f.push(g); else if (k = Ya(g), h = v(m.appendChild(g), "script"), k && w(h), c) for (l = 0; g = h[l++];) cb.test(g.type || "") && c.push(g);
        return m
    }

    function y() {
        return !0
    }

    function z() {
        return !1
    }

    function A(a, b) {
        return a === B() == ("focus" === b)
    }

    function B() {
        try {
            return va.activeElement
        } catch (a) {
        }
    }

    function C(a, b, c, d, e, f) {
        var g, h;
        if ("object" == typeof b) {
            "string" != typeof c && (d = d || c, c = void 0);
            for (h in b) C(a, h, c, d, b[h], f);
            return a
        }
        if (null == d && null == e ? (e = c, d = c = void 0) : null == e && ("string" == typeof c ? (e = d, d = void 0) : (e = d, d = c, c = void 0)), e === !1) e = z; else if (!e) return a;
        return 1 === f && (g = e, e = function (a) {
            return ya().off(a), g.apply(this, arguments)
        }, e.guid = g.guid || (g.guid = ya.guid++)), a.each(function () {
            ya.event.add(this, b, e, d, c)
        })
    }

    function D(a, b, c) {
        return c ? (Qa.set(a, b, !1), void ya.event.add(a, b, {
            namespace: !1, handler: function (a) {
                var d, e, f = Qa.get(this, b);
                if (1 & a.isTrigger && this[b]) {
                    if (f.length) (ya.event.special[b] || {}).delegateType && a.stopPropagation(); else if (f = ja.call(arguments), Qa.set(this, b, f), d = c(this, b), this[b](), e = Qa.get(this, b), f !== e || d ? Qa.set(this, b, !1) : e = {}, f !== e) return a.stopImmediatePropagation(), a.preventDefault(), e.value
                } else f.length && (Qa.set(this, b, {value: ya.event.trigger(ya.extend(f[0], ya.Event.prototype), f.slice(1), this)}), a.stopImmediatePropagation())
            }
        })) : void (void 0 === Qa.get(a, b) && ya.event.add(a, b, y))
    }

    function E(a, b) {
        return f(a, "table") && f(11 !== b.nodeType ? b : b.firstChild, "tr") ? ya(a).children("tbody")[0] || a : a
    }

    function F(a) {
        return a.type = (null !== a.getAttribute("type")) + "/" + a.type, a
    }

    function G(a) {
        return "true/" === (a.type || "").slice(0, 5) ? a.type = a.type.slice(5) : a.removeAttribute("type"), a
    }

    function H(a, b) {
        var c, d, e, f, g, h, i;
        if (1 === b.nodeType) {
            if (Qa.hasData(a) && (f = Qa.get(a), i = f.events)) {
                Qa.remove(b, "handle events");
                for (e in i) for (c = 0, d = i[e].length; c < d; c++) ya.event.add(b, e, i[e][c])
            }
            Ra.hasData(a) && (g = Ra.access(a), h = ya.extend({}, g), Ra.set(b, h))
        }
    }

    function I(a, b) {
        var c = b.nodeName.toLowerCase();
        "input" === c && ab.test(a.type) ? b.checked = a.checked : "input" !== c && "textarea" !== c || (b.defaultValue = a.defaultValue)
    }

    function J(a, b, d, e) {
        b = ka(b);
        var f, g, h, i, j, k, l = 0, m = a.length, n = m - 1, o = b[0], p = ta(o);
        if (p || m > 1 && "string" == typeof o && !sa.checkClone && jb.test(o)) return a.each(function (c) {
            var f = a.eq(c);
            p && (b[0] = o.call(this, c, f.html())), J(f, b, d, e)
        });
        if (m && (f = x(b, a[0].ownerDocument, !1, a, e), g = f.firstChild, 1 === f.childNodes.length && (f = g), g || e)) {
            for (h = ya.map(v(f, "script"), F), i = h.length; l < m; l++) j = f, l !== n && (j = ya.clone(j, !0, !0), i && ya.merge(h, v(j, "script"))), d.call(a[l], j, l);
            if (i) for (k = h[h.length - 1].ownerDocument, ya.map(h, G), l = 0; l < i; l++) j = h[l], cb.test(j.type || "") && !Qa.access(j, "globalEval") && ya.contains(k, j) && (j.src && "module" !== (j.type || "").toLowerCase() ? ya._evalUrl && !j.noModule && ya._evalUrl(j.src, {nonce: j.nonce || j.getAttribute("nonce")}, k) : c(j.textContent.replace(kb, ""), j, k))
        }
        return a
    }

    function K(a, b, c) {
        for (var d, e = b ? ya.filter(b, a) : a, f = 0; null != (d = e[f]); f++) c || 1 !== d.nodeType || ya.cleanData(v(d)), d.parentNode && (c && Ya(d) && w(v(d, "script")), d.parentNode.removeChild(d));
        return a
    }

    function L(a, b, c) {
        var d, e, f, g, h = a.style;
        return c = c || mb(a), c && (g = c.getPropertyValue(b) || c[b], "" !== g || Ya(a) || (g = ya.style(a, b)), !sa.pixelBoxStyles() && lb.test(g) && ob.test(b) && (d = h.width, e = h.minWidth, f = h.maxWidth, h.minWidth = h.maxWidth = h.width = g, g = c.width, h.width = d, h.minWidth = e, h.maxWidth = f)), void 0 !== g ? g + "" : g
    }

    function M(a, b) {
        return {
            get: function () {
                return a() ? void delete this.get : (this.get = b).apply(this, arguments)
            }
        }
    }

    function N(a) {
        for (var b = a[0].toUpperCase() + a.slice(1), c = pb.length; c--;) if (a = pb[c] + b, a in qb) return a
    }

    function O(a) {
        var b = ya.cssProps[a] || rb[a];
        return b ? b : a in qb ? a : rb[a] = N(a) || a
    }

    function P(a, b, c) {
        var d = Va.exec(b);
        return d ? Math.max(0, d[2] - (c || 0)) + (d[3] || "px") : b
    }

    function Q(a, b, c, d, e, f) {
        var g = "width" === b ? 1 : 0, h = 0, i = 0;
        if (c === (d ? "border" : "content")) return 0;
        for (; g < 4; g += 2) "margin" === c && (i += ya.css(a, c + Wa[g], !0, e)), d ? ("content" === c && (i -= ya.css(a, "padding" + Wa[g], !0, e)), "margin" !== c && (i -= ya.css(a, "border" + Wa[g] + "Width", !0, e))) : (i += ya.css(a, "padding" + Wa[g], !0, e), "padding" !== c ? i += ya.css(a, "border" + Wa[g] + "Width", !0, e) : h += ya.css(a, "border" + Wa[g] + "Width", !0, e));
        return !d && f >= 0 && (i += Math.max(0, Math.ceil(a["offset" + b[0].toUpperCase() + b.slice(1)] - f - i - h - .5)) || 0), i
    }

    function R(a, b, c) {
        var d = mb(a), e = !sa.boxSizingReliable() || c, g = e && "border-box" === ya.css(a, "boxSizing", !1, d), h = g,
            i = L(a, b, d), j = "offset" + b[0].toUpperCase() + b.slice(1);
        if (lb.test(i)) {
            if (!c) return i;
            i = "auto"
        }
        return (!sa.boxSizingReliable() && g || !sa.reliableTrDimensions() && f(a, "tr") || "auto" === i || !parseFloat(i) && "inline" === ya.css(a, "display", !1, d)) && a.getClientRects().length && (g = "border-box" === ya.css(a, "boxSizing", !1, d), h = j in a, h && (i = a[j])), i = parseFloat(i) || 0, i + Q(a, b, c || (g ? "border" : "content"), h, d, i) + "px"
    }

    function S(a, b, c, d, e) {
        return new S.prototype.init(a, b, c, d, e)
    }

    function T() {
        xb && (va.hidden === !1 && a.requestAnimationFrame ? a.requestAnimationFrame(T) : a.setTimeout(T, ya.fx.interval), ya.fx.tick())
    }

    function U() {
        return a.setTimeout(function () {
            wb = void 0
        }), wb = Date.now()
    }

    function V(a, b) {
        var c, d = 0, e = {height: a};
        for (b = b ? 1 : 0; d < 4; d += 2 - b) c = Wa[d], e["margin" + c] = e["padding" + c] = a;
        return b && (e.opacity = e.width = a), e
    }

    function W(a, b, c) {
        for (var d, e = (Z.tweeners[b] || []).concat(Z.tweeners["*"]), f = 0, g = e.length; f < g; f++) if (d = e[f].call(c, b, a)) return d
    }

    function X(a, b, c) {
        var d, e, f, g, h, i, j, k, l = "width" in b || "height" in b, m = this, n = {}, o = a.style,
            p = a.nodeType && $a(a), q = Qa.get(a, "fxshow");
        c.queue || (g = ya._queueHooks(a, "fx"), null == g.unqueued && (g.unqueued = 0, h = g.empty.fire, g.empty.fire = function () {
            g.unqueued || h()
        }), g.unqueued++, m.always(function () {
            m.always(function () {
                g.unqueued--, ya.queue(a, "fx").length || g.empty.fire()
            })
        }));
        for (d in b) if (e = b[d], yb.test(e)) {
            if (delete b[d], f = f || "toggle" === e, e === (p ? "hide" : "show")) {
                if ("show" !== e || !q || void 0 === q[d]) continue;
                p = !0
            }
            n[d] = q && q[d] || ya.style(a, d)
        }
        if (i = !ya.isEmptyObject(b), i || !ya.isEmptyObject(n)) {
            l && 1 === a.nodeType && (c.overflow = [o.overflow, o.overflowX, o.overflowY], j = q && q.display, null == j && (j = Qa.get(a, "display")), k = ya.css(a, "display"), "none" === k && (j ? k = j : (u([a], !0), j = a.style.display || j, k = ya.css(a, "display"), u([a]))), ("inline" === k || "inline-block" === k && null != j) && "none" === ya.css(a, "float") && (i || (m.done(function () {
                o.display = j
            }), null == j && (k = o.display, j = "none" === k ? "" : k)), o.display = "inline-block")), c.overflow && (o.overflow = "hidden", m.always(function () {
                o.overflow = c.overflow[0], o.overflowX = c.overflow[1], o.overflowY = c.overflow[2]
            })), i = !1;
            for (d in n) i || (q ? "hidden" in q && (p = q.hidden) : q = Qa.access(a, "fxshow", {display: j}), f && (q.hidden = !p), p && u([a], !0), m.done(function () {
                p || u([a]), Qa.remove(a, "fxshow");
                for (d in n) ya.style(a, d, n[d])
            })), i = W(p ? q[d] : 0, d, m), d in q || (q[d] = i.start, p && (i.end = i.start, i.start = 0))
        }
    }

    function Y(a, b) {
        var c, d, e, f, g;
        for (c in a) if (d = o(c), e = b[d], f = a[c], Array.isArray(f) && (e = f[1], f = a[c] = f[0]), c !== d && (a[d] = f, delete a[c]), g = ya.cssHooks[d], g && "expand" in g) {
            f = g.expand(f), delete a[d];
            for (c in f) c in a || (a[c] = f[c], b[c] = e)
        } else b[d] = e
    }

    function Z(a, b, c) {
        var d, e, f = 0, g = Z.prefilters.length, h = ya.Deferred().always(function () {
            delete i.elem
        }), i = function () {
            if (e) return !1;
            for (var b = wb || U(), c = Math.max(0, j.startTime + j.duration - b), d = c / j.duration || 0, f = 1 - d, g = 0, i = j.tweens.length; g < i; g++) j.tweens[g].run(f);
            return h.notifyWith(a, [j, f, c]), f < 1 && i ? c : (i || h.notifyWith(a, [j, 1, 0]), h.resolveWith(a, [j]), !1)
        }, j = h.promise({
            elem: a,
            props: ya.extend({}, b),
            opts: ya.extend(!0, {specialEasing: {}, easing: ya.easing._default}, c),
            originalProperties: b,
            originalOptions: c,
            startTime: wb || U(),
            duration: c.duration,
            tweens: [],
            createTween: function (b, c) {
                var d = ya.Tween(a, j.opts, b, c, j.opts.specialEasing[b] || j.opts.easing);
                return j.tweens.push(d), d
            },
            stop: function (b) {
                var c = 0, d = b ? j.tweens.length : 0;
                if (e) return this;
                for (e = !0; c < d; c++) j.tweens[c].run(1);
                return b ? (h.notifyWith(a, [j, 1, 0]), h.resolveWith(a, [j, b])) : h.rejectWith(a, [j, b]), this
            }
        }), k = j.props;
        for (Y(k, j.opts.specialEasing); f < g; f++) if (d = Z.prefilters[f].call(j, a, k, j.opts)) return ta(d.stop) && (ya._queueHooks(j.elem, j.opts.queue).stop = d.stop.bind(d)), d;
        return ya.map(k, W, j), ta(j.opts.start) && j.opts.start.call(a, j), j.progress(j.opts.progress).done(j.opts.done, j.opts.complete).fail(j.opts.fail).always(j.opts.always), ya.fx.timer(ya.extend(i, {
            elem: a,
            anim: j,
            queue: j.opts.queue
        })), j
    }

    function $(a) {
        var b = a.match(Ja) || [];
        return b.join(" ")
    }

    function _(a) {
        return a.getAttribute && a.getAttribute("class") || ""
    }

    function aa(a) {
        return Array.isArray(a) ? a : "string" == typeof a ? a.match(Ja) || [] : []
    }

    function ba(a, b, c, e) {
        var f;
        if (Array.isArray(b)) ya.each(b, function (b, d) {
            c || Kb.test(a) ? e(a, d) : ba(a + "[" + ("object" == typeof d && null != d ? b : "") + "]", d, c, e)
        }); else if (c || "object" !== d(b)) e(a, b); else for (f in b) ba(a + "[" + f + "]", b[f], c, e)
    }

    function ca(a) {
        return function (b, c) {
            "string" != typeof b && (c = b, b = "*");
            var d, e = 0, f = b.toLowerCase().match(Ja) || [];
            if (ta(c)) for (; d = f[e++];) "+" === d[0] ? (d = d.slice(1) || "*", (a[d] = a[d] || []).unshift(c)) : (a[d] = a[d] || []).push(c)
        }
    }

    function da(a, b, c, d) {
        function e(h) {
            var i;
            return f[h] = !0, ya.each(a[h] || [], function (a, h) {
                var j = h(b, c, d);
                return "string" != typeof j || g || f[j] ? g ? !(i = j) : void 0 : (b.dataTypes.unshift(j), e(j), !1)
            }), i
        }

        var f = {}, g = a === Wb;
        return e(b.dataTypes[0]) || !f["*"] && e("*")
    }

    function ea(a, b) {
        var c, d, e = ya.ajaxSettings.flatOptions || {};
        for (c in b) void 0 !== b[c] && ((e[c] ? a : d || (d = {}))[c] = b[c]);
        return d && ya.extend(!0, a, d), a
    }

    function fa(a, b, c) {
        for (var d, e, f, g, h = a.contents, i = a.dataTypes; "*" === i[0];) i.shift(), void 0 === d && (d = a.mimeType || b.getResponseHeader("Content-Type"));
        if (d) for (e in h) if (h[e] && h[e].test(d)) {
            i.unshift(e);
            break
        }
        if (i[0] in c) f = i[0]; else {
            for (e in c) {
                if (!i[0] || a.converters[e + " " + i[0]]) {
                    f = e;
                    break
                }
                g || (g = e)
            }
            f = f || g
        }
        if (f) return f !== i[0] && i.unshift(f), c[f]
    }

    function ga(a, b, c, d) {
        var e, f, g, h, i, j = {}, k = a.dataTypes.slice();
        if (k[1]) for (g in a.converters) j[g.toLowerCase()] = a.converters[g];
        for (f = k.shift(); f;) if (a.responseFields[f] && (c[a.responseFields[f]] = b), !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)), i = f, f = k.shift()) if ("*" === f) f = i; else if ("*" !== i && i !== f) {
            if (g = j[i + " " + f] || j["* " + f], !g) for (e in j) if (h = e.split(" "), h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]])) {
                g === !0 ? g = j[e] : j[e] !== !0 && (f = h[0], k.unshift(h[1]));
                break
            }
            if (g !== !0) if (g && a.throws) b = g(b); else try {
                b = g(b)
            } catch (a) {
                return {state: "parsererror", error: g ? a : "No conversion from " + i + " to " + f}
            }
        }
        return {state: "success", data: b}
    }

    var ha = [], ia = Object.getPrototypeOf, ja = ha.slice, ka = ha.flat ? function (a) {
            return ha.flat.call(a)
        } : function (a) {
            return ha.concat.apply([], a)
        }, la = ha.push, ma = ha.indexOf, na = {}, oa = na.toString, pa = na.hasOwnProperty, qa = pa.toString,
        ra = qa.call(Object), sa = {}, ta = function (a) {
            return "function" == typeof a && "number" != typeof a.nodeType
        }, ua = function (a) {
            return null != a && a === a.window
        }, va = a.document, wa = {type: !0, src: !0, nonce: !0, noModule: !0}, xa = "3.5.1", ya = function (a, b) {
            return new ya.fn.init(a, b)
        };
    ya.fn = ya.prototype = {
        jquery: xa, constructor: ya, length: 0, toArray: function () {
            return ja.call(this)
        }, get: function (a) {
            return null == a ? ja.call(this) : a < 0 ? this[a + this.length] : this[a]
        }, pushStack: function (a) {
            var b = ya.merge(this.constructor(), a);
            return b.prevObject = this, b
        }, each: function (a) {
            return ya.each(this, a)
        }, map: function (a) {
            return this.pushStack(ya.map(this, function (b, c) {
                return a.call(b, c, b)
            }))
        }, slice: function () {
            return this.pushStack(ja.apply(this, arguments))
        }, first: function () {
            return this.eq(0)
        }, last: function () {
            return this.eq(-1)
        }, even: function () {
            return this.pushStack(ya.grep(this, function (a, b) {
                return (b + 1) % 2
            }))
        }, odd: function () {
            return this.pushStack(ya.grep(this, function (a, b) {
                return b % 2
            }))
        }, eq: function (a) {
            var b = this.length, c = +a + (a < 0 ? b : 0);
            return this.pushStack(c >= 0 && c < b ? [this[c]] : [])
        }, end: function () {
            return this.prevObject || this.constructor()
        }, push: la, sort: ha.sort, splice: ha.splice
    }, ya.extend = ya.fn.extend = function () {
        var a, b, c, d, e, f, g = arguments[0] || {}, h = 1, i = arguments.length, j = !1;
        for ("boolean" == typeof g && (j = g, g = arguments[h] || {}, h++), "object" == typeof g || ta(g) || (g = {}), h === i && (g = this, h--); h < i; h++) if (null != (a = arguments[h])) for (b in a) d = a[b], "__proto__" !== b && g !== d && (j && d && (ya.isPlainObject(d) || (e = Array.isArray(d))) ? (c = g[b], f = e && !Array.isArray(c) ? [] : e || ya.isPlainObject(c) ? c : {}, e = !1, g[b] = ya.extend(j, f, d)) : void 0 !== d && (g[b] = d));
        return g
    }, ya.extend({
        expando: "jQuery" + (xa + Math.random()).replace(/\D/g, ""), isReady: !0, error: function (a) {
            throw new Error(a)
        }, noop: function () {
        }, isPlainObject: function (a) {
            var b, c;
            return !(!a || "[object Object]" !== oa.call(a)) && (!(b = ia(a)) || (c = pa.call(b, "constructor") && b.constructor, "function" == typeof c && qa.call(c) === ra))
        }, isEmptyObject: function (a) {
            var b;
            for (b in a) return !1;
            return !0
        }, globalEval: function (a, b, d) {
            c(a, {nonce: b && b.nonce}, d)
        }, each: function (a, b) {
            var c, d = 0;
            if (e(a)) for (c = a.length; d < c && b.call(a[d], d, a[d]) !== !1; d++) ; else for (d in a) if (b.call(a[d], d, a[d]) === !1) break;
            return a
        }, makeArray: function (a, b) {
            var c = b || [];
            return null != a && (e(Object(a)) ? ya.merge(c, "string" == typeof a ? [a] : a) : la.call(c, a)), c
        }, inArray: function (a, b, c) {
            return null == b ? -1 : ma.call(b, a, c)
        }, merge: function (a, b) {
            for (var c = +b.length, d = 0, e = a.length; d < c; d++) a[e++] = b[d];
            return a.length = e, a
        }, grep: function (a, b, c) {
            for (var d, e = [], f = 0, g = a.length, h = !c; f < g; f++) d = !b(a[f], f), d !== h && e.push(a[f]);
            return e
        }, map: function (a, b, c) {
            var d, f, g = 0, h = [];
            if (e(a)) for (d = a.length; g < d; g++) f = b(a[g], g, c), null != f && h.push(f); else for (g in a) f = b(a[g], g, c), null != f && h.push(f);
            return ka(h)
        }, guid: 1, support: sa
    }), "function" == typeof Symbol && (ya.fn[Symbol.iterator] = ha[Symbol.iterator]), ya.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (a, b) {
        na["[object " + b + "]"] = b.toLowerCase()
    });
    var za =/*!
 * Sizzle CSS Selector Engine v2.3.5
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2020-03-14
 */
        function (a) {
            function b(a, b, c, d) {
                var e, f, g, h, i, j, k, m = b && b.ownerDocument, o = b ? b.nodeType : 9;
                if (c = c || [], "string" != typeof a || !a || 1 !== o && 9 !== o && 11 !== o) return c;
                if (!d && (G(b), b = b || H, J)) {
                    if (11 !== o && (i = ta.exec(a))) if (e = i[1]) {
                        if (9 === o) {
                            if (!(g = b.getElementById(e))) return c;
                            if (g.id === e) return c.push(g), c
                        } else if (m && (g = m.getElementById(e)) && N(b, g) && g.id === e) return c.push(g), c
                    } else {
                        if (i[2]) return _.apply(c, b.getElementsByTagName(a)), c;
                        if ((e = i[3]) && w.getElementsByClassName && b.getElementsByClassName) return _.apply(c, b.getElementsByClassName(e)), c
                    }
                    if (w.qsa && !V[a + " "] && (!K || !K.test(a)) && (1 !== o || "object" !== b.nodeName.toLowerCase())) {
                        if (k = a, m = b, 1 === o && (la.test(a) || ka.test(a))) {
                            for (m = ua.test(a) && l(b.parentNode) || b, m === b && w.scope || ((h = b.getAttribute("id")) ? h = h.replace(xa, ya) : b.setAttribute("id", h = O)), j = A(a), f = j.length; f--;) j[f] = (h ? "#" + h : ":scope") + " " + n(j[f]);
                            k = j.join(",")
                        }
                        try {
                            return _.apply(c, m.querySelectorAll(k)), c
                        } catch (b) {
                            V(a, !0)
                        } finally {
                            h === O && b.removeAttribute("id")
                        }
                    }
                }
                return C(a.replace(ia, "$1"), b, c, d)
            }

            function c() {
                function a(c, d) {
                    return b.push(c + " ") > x.cacheLength && delete a[b.shift()], a[c + " "] = d
                }

                var b = [];
                return a
            }

            function d(a) {
                return a[O] = !0, a
            }

            function e(a) {
                var b = H.createElement("fieldset");
                try {
                    return !!a(b)
                } catch (a) {
                    return !1
                } finally {
                    b.parentNode && b.parentNode.removeChild(b), b = null
                }
            }

            function f(a, b) {
                for (var c = a.split("|"), d = c.length; d--;) x.attrHandle[c[d]] = b
            }

            function g(a, b) {
                var c = b && a, d = c && 1 === a.nodeType && 1 === b.nodeType && a.sourceIndex - b.sourceIndex;
                if (d) return d;
                if (c) for (; c = c.nextSibling;) if (c === b) return -1;
                return a ? 1 : -1
            }

            function h(a) {
                return function (b) {
                    var c = b.nodeName.toLowerCase();
                    return "input" === c && b.type === a
                }
            }

            function i(a) {
                return function (b) {
                    var c = b.nodeName.toLowerCase();
                    return ("input" === c || "button" === c) && b.type === a
                }
            }

            function j(a) {
                return function (b) {
                    return "form" in b ? b.parentNode && b.disabled === !1 ? "label" in b ? "label" in b.parentNode ? b.parentNode.disabled === a : b.disabled === a : b.isDisabled === a || b.isDisabled !== !a && Aa(b) === a : b.disabled === a : "label" in b && b.disabled === a
                }
            }

            function k(a) {
                return d(function (b) {
                    return b = +b, d(function (c, d) {
                        for (var e, f = a([], c.length, b), g = f.length; g--;) c[e = f[g]] && (c[e] = !(d[e] = c[e]))
                    })
                })
            }

            function l(a) {
                return a && "undefined" != typeof a.getElementsByTagName && a
            }

            function m() {
            }

            function n(a) {
                for (var b = 0, c = a.length, d = ""; b < c; b++) d += a[b].value;
                return d
            }

            function o(a, b, c) {
                var d = b.dir, e = b.next, f = e || d, g = c && "parentNode" === f, h = R++;
                return b.first ? function (b, c, e) {
                    for (; b = b[d];) if (1 === b.nodeType || g) return a(b, c, e);
                    return !1
                } : function (b, c, i) {
                    var j, k, l, m = [Q, h];
                    if (i) {
                        for (; b = b[d];) if ((1 === b.nodeType || g) && a(b, c, i)) return !0
                    } else for (; b = b[d];) if (1 === b.nodeType || g) if (l = b[O] || (b[O] = {}), k = l[b.uniqueID] || (l[b.uniqueID] = {}), e && e === b.nodeName.toLowerCase()) b = b[d] || b; else {
                        if ((j = k[f]) && j[0] === Q && j[1] === h) return m[2] = j[2];
                        if (k[f] = m, m[2] = a(b, c, i)) return !0
                    }
                    return !1
                }
            }

            function p(a) {
                return a.length > 1 ? function (b, c, d) {
                    for (var e = a.length; e--;) if (!a[e](b, c, d)) return !1;
                    return !0
                } : a[0]
            }

            function q(a, c, d) {
                for (var e = 0, f = c.length; e < f; e++) b(a, c[e], d);
                return d
            }

            function r(a, b, c, d, e) {
                for (var f, g = [], h = 0, i = a.length, j = null != b; h < i; h++) (f = a[h]) && (c && !c(f, d, e) || (g.push(f), j && b.push(h)));
                return g
            }

            function s(a, b, c, e, f, g) {
                return e && !e[O] && (e = s(e)), f && !f[O] && (f = s(f, g)), d(function (d, g, h, i) {
                    var j, k, l, m = [], n = [], o = g.length, p = d || q(b || "*", h.nodeType ? [h] : h, []),
                        s = !a || !d && b ? p : r(p, m, a, h, i), t = c ? f || (d ? a : o || e) ? [] : g : s;
                    if (c && c(s, t, h, i), e) for (j = r(t, n), e(j, [], h, i), k = j.length; k--;) (l = j[k]) && (t[n[k]] = !(s[n[k]] = l));
                    if (d) {
                        if (f || a) {
                            if (f) {
                                for (j = [], k = t.length; k--;) (l = t[k]) && j.push(s[k] = l);
                                f(null, t = [], j, i)
                            }
                            for (k = t.length; k--;) (l = t[k]) && (j = f ? ba(d, l) : m[k]) > -1 && (d[j] = !(g[j] = l))
                        }
                    } else t = r(t === g ? t.splice(o, t.length) : t), f ? f(null, g, t, i) : _.apply(g, t)
                })
            }

            function t(a) {
                for (var b, c, d, e = a.length, f = x.relative[a[0].type], g = f || x.relative[" "], h = f ? 1 : 0, i = o(function (a) {
                    return a === b
                }, g, !0), j = o(function (a) {
                    return ba(b, a) > -1
                }, g, !0), k = [function (a, c, d) {
                    var e = !f && (d || c !== D) || ((b = c).nodeType ? i(a, c, d) : j(a, c, d));
                    return b = null, e
                }]; h < e; h++) if (c = x.relative[a[h].type]) k = [o(p(k), c)]; else {
                    if (c = x.filter[a[h].type].apply(null, a[h].matches), c[O]) {
                        for (d = ++h; d < e && !x.relative[a[d].type]; d++) ;
                        return s(h > 1 && p(k), h > 1 && n(a.slice(0, h - 1).concat({value: " " === a[h - 2].type ? "*" : ""})).replace(ia, "$1"), c, h < d && t(a.slice(h, d)), d < e && t(a = a.slice(d)), d < e && n(a))
                    }
                    k.push(c)
                }
                return p(k)
            }

            function u(a, c) {
                var e = c.length > 0, f = a.length > 0, g = function (d, g, h, i, j) {
                    var k, l, m, n = 0, o = "0", p = d && [], q = [], s = D, t = d || f && x.find.TAG("*", j),
                        u = Q += null == s ? 1 : Math.random() || .1, v = t.length;
                    for (j && (D = g == H || g || j); o !== v && null != (k = t[o]); o++) {
                        if (f && k) {
                            for (l = 0, g || k.ownerDocument == H || (G(k), h = !J); m = a[l++];) if (m(k, g || H, h)) {
                                i.push(k);
                                break
                            }
                            j && (Q = u)
                        }
                        e && ((k = !m && k) && n--, d && p.push(k))
                    }
                    if (n += o, e && o !== n) {
                        for (l = 0; m = c[l++];) m(p, q, g, h);
                        if (d) {
                            if (n > 0) for (; o--;) p[o] || q[o] || (q[o] = Z.call(i));
                            q = r(q)
                        }
                        _.apply(i, q), j && !d && q.length > 0 && n + c.length > 1 && b.uniqueSort(i)
                    }
                    return j && (Q = u, D = s), p
                };
                return e ? d(g) : g
            }

            var v, w, x, y, z, A, B, C, D, E, F, G, H, I, J, K, L, M, N, O = "sizzle" + 1 * new Date, P = a.document,
                Q = 0, R = 0, S = c(), T = c(), U = c(), V = c(), W = function (a, b) {
                    return a === b && (F = !0), 0
                }, X = {}.hasOwnProperty, Y = [], Z = Y.pop, $ = Y.push, _ = Y.push, aa = Y.slice, ba = function (a, b) {
                    for (var c = 0, d = a.length; c < d; c++) if (a[c] === b) return c;
                    return -1
                },
                ca = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                da = "[\\x20\\t\\r\\n\\f]",
                ea = "(?:\\\\[\\da-fA-F]{1,6}" + da + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                fa = "\\[" + da + "*(" + ea + ")(?:" + da + "*([*^$|!~]?=)" + da + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + ea + "))|)" + da + "*\\]",
                ga = ":(" + ea + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + fa + ")*)|.*)\\)|)",
                ha = new RegExp(da + "+", "g"),
                ia = new RegExp("^" + da + "+|((?:^|[^\\\\])(?:\\\\.)*)" + da + "+$", "g"),
                ja = new RegExp("^" + da + "*," + da + "*"),
                ka = new RegExp("^" + da + "*([>+~]|" + da + ")" + da + "*"), la = new RegExp(da + "|>"),
                ma = new RegExp(ga), na = new RegExp("^" + ea + "$"), oa = {
                    ID: new RegExp("^#(" + ea + ")"),
                    CLASS: new RegExp("^\\.(" + ea + ")"),
                    TAG: new RegExp("^(" + ea + "|[*])"),
                    ATTR: new RegExp("^" + fa),
                    PSEUDO: new RegExp("^" + ga),
                    CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + da + "*(even|odd|(([+-]|)(\\d*)n|)" + da + "*(?:([+-]|)" + da + "*(\\d+)|))" + da + "*\\)|)", "i"),
                    bool: new RegExp("^(?:" + ca + ")$", "i"),
                    needsContext: new RegExp("^" + da + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + da + "*((?:-\\d)?\\d*)" + da + "*\\)|)(?=[^-]|$)", "i")
                }, pa = /HTML$/i, qa = /^(?:input|select|textarea|button)$/i, ra = /^h\d$/i, sa = /^[^{]+\{\s*\[native \w/,
                ta = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, ua = /[+~]/,
                va = new RegExp("\\\\[\\da-fA-F]{1,6}" + da + "?|\\\\([^\\r\\n\\f])", "g"), wa = function (a, b) {
                    var c = "0x" + a.slice(1) - 65536;
                    return b ? b : c < 0 ? String.fromCharCode(c + 65536) : String.fromCharCode(c >> 10 | 55296, 1023 & c | 56320)
                }, xa = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, ya = function (a, b) {
                    return b ? "\0" === a ? "�" : a.slice(0, -1) + "\\" + a.charCodeAt(a.length - 1).toString(16) + " " : "\\" + a
                }, za = function () {
                    G()
                }, Aa = o(function (a) {
                    return a.disabled === !0 && "fieldset" === a.nodeName.toLowerCase()
                }, {dir: "parentNode", next: "legend"});
            try {
                _.apply(Y = aa.call(P.childNodes), P.childNodes), Y[P.childNodes.length].nodeType
            } catch (a) {
                _ = {
                    apply: Y.length ? function (a, b) {
                        $.apply(a, aa.call(b))
                    } : function (a, b) {
                        for (var c = a.length, d = 0; a[c++] = b[d++];) ;
                        a.length = c - 1
                    }
                }
            }
            w = b.support = {}, z = b.isXML = function (a) {
                var b = a.namespaceURI, c = (a.ownerDocument || a).documentElement;
                return !pa.test(b || c && c.nodeName || "HTML")
            }, G = b.setDocument = function (a) {
                var b, c, d = a ? a.ownerDocument || a : P;
                return d != H && 9 === d.nodeType && d.documentElement ? (H = d, I = H.documentElement, J = !z(H), P != H && (c = H.defaultView) && c.top !== c && (c.addEventListener ? c.addEventListener("unload", za, !1) : c.attachEvent && c.attachEvent("onunload", za)), w.scope = e(function (a) {
                    return I.appendChild(a).appendChild(H.createElement("div")), "undefined" != typeof a.querySelectorAll && !a.querySelectorAll(":scope fieldset div").length
                }), w.attributes = e(function (a) {
                    return a.className = "i", !a.getAttribute("className")
                }), w.getElementsByTagName = e(function (a) {
                    return a.appendChild(H.createComment("")), !a.getElementsByTagName("*").length
                }), w.getElementsByClassName = sa.test(H.getElementsByClassName), w.getById = e(function (a) {
                    return I.appendChild(a).id = O, !H.getElementsByName || !H.getElementsByName(O).length
                }), w.getById ? (x.filter.ID = function (a) {
                    var b = a.replace(va, wa);
                    return function (a) {
                        return a.getAttribute("id") === b
                    }
                }, x.find.ID = function (a, b) {
                    if ("undefined" != typeof b.getElementById && J) {
                        var c = b.getElementById(a);
                        return c ? [c] : []
                    }
                }) : (x.filter.ID = function (a) {
                    var b = a.replace(va, wa);
                    return function (a) {
                        var c = "undefined" != typeof a.getAttributeNode && a.getAttributeNode("id");
                        return c && c.value === b
                    }
                }, x.find.ID = function (a, b) {
                    if ("undefined" != typeof b.getElementById && J) {
                        var c, d, e, f = b.getElementById(a);
                        if (f) {
                            if (c = f.getAttributeNode("id"), c && c.value === a) return [f];
                            for (e = b.getElementsByName(a), d = 0; f = e[d++];) if (c = f.getAttributeNode("id"), c && c.value === a) return [f]
                        }
                        return []
                    }
                }), x.find.TAG = w.getElementsByTagName ? function (a, b) {
                    return "undefined" != typeof b.getElementsByTagName ? b.getElementsByTagName(a) : w.qsa ? b.querySelectorAll(a) : void 0
                } : function (a, b) {
                    var c, d = [], e = 0, f = b.getElementsByTagName(a);
                    if ("*" === a) {
                        for (; c = f[e++];) 1 === c.nodeType && d.push(c);
                        return d
                    }
                    return f
                }, x.find.CLASS = w.getElementsByClassName && function (a, b) {
                    if ("undefined" != typeof b.getElementsByClassName && J) return b.getElementsByClassName(a)
                }, L = [], K = [], (w.qsa = sa.test(H.querySelectorAll)) && (e(function (a) {
                    var b;
                    I.appendChild(a).innerHTML = "<a id='" + O + "'></a><select id='" + O + "-\r\\' msallowcapture=''><option selected=''></option></select>", a.querySelectorAll("[msallowcapture^='']").length && K.push("[*^$]=" + da + "*(?:''|\"\")"), a.querySelectorAll("[selected]").length || K.push("\\[" + da + "*(?:value|" + ca + ")"), a.querySelectorAll("[id~=" + O + "-]").length || K.push("~="), b = H.createElement("input"), b.setAttribute("name", ""), a.appendChild(b), a.querySelectorAll("[name='']").length || K.push("\\[" + da + "*name" + da + "*=" + da + "*(?:''|\"\")"), a.querySelectorAll(":checked").length || K.push(":checked"), a.querySelectorAll("a#" + O + "+*").length || K.push(".#.+[+~]"), a.querySelectorAll("\\\f"), K.push("[\\r\\n\\f]")
                }), e(function (a) {
                    a.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    var b = H.createElement("input");
                    b.setAttribute("type", "hidden"), a.appendChild(b).setAttribute("name", "D"), a.querySelectorAll("[name=d]").length && K.push("name" + da + "*[*^$|!~]?="), 2 !== a.querySelectorAll(":enabled").length && K.push(":enabled", ":disabled"), I.appendChild(a).disabled = !0, 2 !== a.querySelectorAll(":disabled").length && K.push(":enabled", ":disabled"), a.querySelectorAll("*,:x"), K.push(",.*:")
                })), (w.matchesSelector = sa.test(M = I.matches || I.webkitMatchesSelector || I.mozMatchesSelector || I.oMatchesSelector || I.msMatchesSelector)) && e(function (a) {
                    w.disconnectedMatch = M.call(a, "*"), M.call(a, "[s!='']:x"), L.push("!=", ga)
                }), K = K.length && new RegExp(K.join("|")), L = L.length && new RegExp(L.join("|")), b = sa.test(I.compareDocumentPosition), N = b || sa.test(I.contains) ? function (a, b) {
                    var c = 9 === a.nodeType ? a.documentElement : a, d = b && b.parentNode;
                    return a === d || !(!d || 1 !== d.nodeType || !(c.contains ? c.contains(d) : a.compareDocumentPosition && 16 & a.compareDocumentPosition(d)))
                } : function (a, b) {
                    if (b) for (; b = b.parentNode;) if (b === a) return !0;
                    return !1
                }, W = b ? function (a, b) {
                    if (a === b) return F = !0, 0;
                    var c = !a.compareDocumentPosition - !b.compareDocumentPosition;
                    return c ? c : (c = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1, 1 & c || !w.sortDetached && b.compareDocumentPosition(a) === c ? a == H || a.ownerDocument == P && N(P, a) ? -1 : b == H || b.ownerDocument == P && N(P, b) ? 1 : E ? ba(E, a) - ba(E, b) : 0 : 4 & c ? -1 : 1)
                } : function (a, b) {
                    if (a === b) return F = !0, 0;
                    var c, d = 0, e = a.parentNode, f = b.parentNode, h = [a], i = [b];
                    if (!e || !f) return a == H ? -1 : b == H ? 1 : e ? -1 : f ? 1 : E ? ba(E, a) - ba(E, b) : 0;
                    if (e === f) return g(a, b);
                    for (c = a; c = c.parentNode;) h.unshift(c);
                    for (c = b; c = c.parentNode;) i.unshift(c);
                    for (; h[d] === i[d];) d++;
                    return d ? g(h[d], i[d]) : h[d] == P ? -1 : i[d] == P ? 1 : 0
                }, H) : H
            }, b.matches = function (a, c) {
                return b(a, null, null, c)
            }, b.matchesSelector = function (a, c) {
                if (G(a), w.matchesSelector && J && !V[c + " "] && (!L || !L.test(c)) && (!K || !K.test(c))) try {
                    var d = M.call(a, c);
                    if (d || w.disconnectedMatch || a.document && 11 !== a.document.nodeType) return d
                } catch (a) {
                    V(c, !0)
                }
                return b(c, H, null, [a]).length > 0
            }, b.contains = function (a, b) {
                return (a.ownerDocument || a) != H && G(a), N(a, b)
            }, b.attr = function (a, b) {
                (a.ownerDocument || a) != H && G(a);
                var c = x.attrHandle[b.toLowerCase()],
                    d = c && X.call(x.attrHandle, b.toLowerCase()) ? c(a, b, !J) : void 0;
                return void 0 !== d ? d : w.attributes || !J ? a.getAttribute(b) : (d = a.getAttributeNode(b)) && d.specified ? d.value : null
            }, b.escape = function (a) {
                return (a + "").replace(xa, ya)
            }, b.error = function (a) {
                throw new Error("Syntax error, unrecognized expression: " + a)
            }, b.uniqueSort = function (a) {
                var b, c = [], d = 0, e = 0;
                if (F = !w.detectDuplicates, E = !w.sortStable && a.slice(0), a.sort(W), F) {
                    for (; b = a[e++];) b === a[e] && (d = c.push(e));
                    for (; d--;) a.splice(c[d], 1)
                }
                return E = null, a
            }, y = b.getText = function (a) {
                var b, c = "", d = 0, e = a.nodeType;
                if (e) {
                    if (1 === e || 9 === e || 11 === e) {
                        if ("string" == typeof a.textContent) return a.textContent;
                        for (a = a.firstChild; a; a = a.nextSibling) c += y(a)
                    } else if (3 === e || 4 === e) return a.nodeValue
                } else for (; b = a[d++];) c += y(b);
                return c
            }, x = b.selectors = {
                cacheLength: 50,
                createPseudo: d,
                match: oa,
                attrHandle: {},
                find: {},
                relative: {
                    ">": {dir: "parentNode", first: !0},
                    " ": {dir: "parentNode"},
                    "+": {dir: "previousSibling", first: !0},
                    "~": {dir: "previousSibling"}
                },
                preFilter: {
                    ATTR: function (a) {
                        return a[1] = a[1].replace(va, wa), a[3] = (a[3] || a[4] || a[5] || "").replace(va, wa), "~=" === a[2] && (a[3] = " " + a[3] + " "), a.slice(0, 4)
                    }, CHILD: function (a) {
                        return a[1] = a[1].toLowerCase(), "nth" === a[1].slice(0, 3) ? (a[3] || b.error(a[0]), a[4] = +(a[4] ? a[5] + (a[6] || 1) : 2 * ("even" === a[3] || "odd" === a[3])), a[5] = +(a[7] + a[8] || "odd" === a[3])) : a[3] && b.error(a[0]), a
                    }, PSEUDO: function (a) {
                        var b, c = !a[6] && a[2];
                        return oa.CHILD.test(a[0]) ? null : (a[3] ? a[2] = a[4] || a[5] || "" : c && ma.test(c) && (b = A(c, !0)) && (b = c.indexOf(")", c.length - b) - c.length) && (a[0] = a[0].slice(0, b), a[2] = c.slice(0, b)), a.slice(0, 3))
                    }
                },
                filter: {
                    TAG: function (a) {
                        var b = a.replace(va, wa).toLowerCase();
                        return "*" === a ? function () {
                            return !0
                        } : function (a) {
                            return a.nodeName && a.nodeName.toLowerCase() === b
                        }
                    }, CLASS: function (a) {
                        var b = S[a + " "];
                        return b || (b = new RegExp("(^|" + da + ")" + a + "(" + da + "|$)")) && S(a, function (a) {
                            return b.test("string" == typeof a.className && a.className || "undefined" != typeof a.getAttribute && a.getAttribute("class") || "")
                        })
                    }, ATTR: function (a, c, d) {
                        return function (e) {
                            var f = b.attr(e, a);
                            return null == f ? "!=" === c : !c || (f += "", "=" === c ? f === d : "!=" === c ? f !== d : "^=" === c ? d && 0 === f.indexOf(d) : "*=" === c ? d && f.indexOf(d) > -1 : "$=" === c ? d && f.slice(-d.length) === d : "~=" === c ? (" " + f.replace(ha, " ") + " ").indexOf(d) > -1 : "|=" === c && (f === d || f.slice(0, d.length + 1) === d + "-"))
                        }
                    }, CHILD: function (a, b, c, d, e) {
                        var f = "nth" !== a.slice(0, 3), g = "last" !== a.slice(-4), h = "of-type" === b;
                        return 1 === d && 0 === e ? function (a) {
                            return !!a.parentNode
                        } : function (b, c, i) {
                            var j, k, l, m, n, o, p = f !== g ? "nextSibling" : "previousSibling", q = b.parentNode,
                                r = h && b.nodeName.toLowerCase(), s = !i && !h, t = !1;
                            if (q) {
                                if (f) {
                                    for (; p;) {
                                        for (m = b; m = m[p];) if (h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType) return !1;
                                        o = p = "only" === a && !o && "nextSibling"
                                    }
                                    return !0
                                }
                                if (o = [g ? q.firstChild : q.lastChild], g && s) {
                                    for (m = q, l = m[O] || (m[O] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), j = k[a] || [], n = j[0] === Q && j[1], t = n && j[2], m = n && q.childNodes[n]; m = ++n && m && m[p] || (t = n = 0) || o.pop();) if (1 === m.nodeType && ++t && m === b) {
                                        k[a] = [Q, n, t];
                                        break
                                    }
                                } else if (s && (m = b, l = m[O] || (m[O] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), j = k[a] || [], n = j[0] === Q && j[1], t = n), t === !1) for (; (m = ++n && m && m[p] || (t = n = 0) || o.pop()) && ((h ? m.nodeName.toLowerCase() !== r : 1 !== m.nodeType) || !++t || (s && (l = m[O] || (m[O] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), k[a] = [Q, t]), m !== b));) ;
                                return t -= e, t === d || t % d === 0 && t / d >= 0
                            }
                        }
                    }, PSEUDO: function (a, c) {
                        var e, f = x.pseudos[a] || x.setFilters[a.toLowerCase()] || b.error("unsupported pseudo: " + a);
                        return f[O] ? f(c) : f.length > 1 ? (e = [a, a, "", c], x.setFilters.hasOwnProperty(a.toLowerCase()) ? d(function (a, b) {
                            for (var d, e = f(a, c), g = e.length; g--;) d = ba(a, e[g]), a[d] = !(b[d] = e[g])
                        }) : function (a) {
                            return f(a, 0, e)
                        }) : f
                    }
                },
                pseudos: {
                    not: d(function (a) {
                        var b = [], c = [], e = B(a.replace(ia, "$1"));
                        return e[O] ? d(function (a, b, c, d) {
                            for (var f, g = e(a, null, d, []), h = a.length; h--;) (f = g[h]) && (a[h] = !(b[h] = f))
                        }) : function (a, d, f) {
                            return b[0] = a, e(b, null, f, c), b[0] = null, !c.pop()
                        }
                    }), has: d(function (a) {
                        return function (c) {
                            return b(a, c).length > 0
                        }
                    }), contains: d(function (a) {
                        return a = a.replace(va, wa), function (b) {
                            return (b.textContent || y(b)).indexOf(a) > -1
                        }
                    }), lang: d(function (a) {
                        return na.test(a || "") || b.error("unsupported lang: " + a), a = a.replace(va, wa).toLowerCase(), function (b) {
                            var c;
                            do if (c = J ? b.lang : b.getAttribute("xml:lang") || b.getAttribute("lang")) return c = c.toLowerCase(), c === a || 0 === c.indexOf(a + "-"); while ((b = b.parentNode) && 1 === b.nodeType);
                            return !1
                        }
                    }), target: function (b) {
                        var c = a.location && a.location.hash;
                        return c && c.slice(1) === b.id
                    }, root: function (a) {
                        return a === I
                    }, focus: function (a) {
                        return a === H.activeElement && (!H.hasFocus || H.hasFocus()) && !!(a.type || a.href || ~a.tabIndex)
                    }, enabled: j(!1), disabled: j(!0), checked: function (a) {
                        var b = a.nodeName.toLowerCase();
                        return "input" === b && !!a.checked || "option" === b && !!a.selected
                    }, selected: function (a) {
                        return a.parentNode && a.parentNode.selectedIndex, a.selected === !0
                    }, empty: function (a) {
                        for (a = a.firstChild; a; a = a.nextSibling) if (a.nodeType < 6) return !1;
                        return !0
                    }, parent: function (a) {
                        return !x.pseudos.empty(a)
                    }, header: function (a) {
                        return ra.test(a.nodeName)
                    }, input: function (a) {
                        return qa.test(a.nodeName)
                    }, button: function (a) {
                        var b = a.nodeName.toLowerCase();
                        return "input" === b && "button" === a.type || "button" === b
                    }, text: function (a) {
                        var b;
                        return "input" === a.nodeName.toLowerCase() && "text" === a.type && (null == (b = a.getAttribute("type")) || "text" === b.toLowerCase())
                    }, first: k(function () {
                        return [0]
                    }), last: k(function (a, b) {
                        return [b - 1]
                    }), eq: k(function (a, b, c) {
                        return [c < 0 ? c + b : c]
                    }), even: k(function (a, b) {
                        for (var c = 0; c < b; c += 2) a.push(c);
                        return a
                    }), odd: k(function (a, b) {
                        for (var c = 1; c < b; c += 2) a.push(c);
                        return a
                    }), lt: k(function (a, b, c) {
                        for (var d = c < 0 ? c + b : c > b ? b : c; --d >= 0;) a.push(d);
                        return a
                    }), gt: k(function (a, b, c) {
                        for (var d = c < 0 ? c + b : c; ++d < b;) a.push(d);
                        return a
                    })
                }
            }, x.pseudos.nth = x.pseudos.eq;
            for (v in {radio: !0, checkbox: !0, file: !0, password: !0, image: !0}) x.pseudos[v] = h(v);
            for (v in {submit: !0, reset: !0}) x.pseudos[v] = i(v);
            return m.prototype = x.filters = x.pseudos, x.setFilters = new m, A = b.tokenize = function (a, c) {
                var d, e, f, g, h, i, j, k = T[a + " "];
                if (k) return c ? 0 : k.slice(0);
                for (h = a, i = [], j = x.preFilter; h;) {
                    d && !(e = ja.exec(h)) || (e && (h = h.slice(e[0].length) || h), i.push(f = [])), d = !1, (e = ka.exec(h)) && (d = e.shift(), f.push({
                        value: d,
                        type: e[0].replace(ia, " ")
                    }), h = h.slice(d.length));
                    for (g in x.filter) !(e = oa[g].exec(h)) || j[g] && !(e = j[g](e)) || (d = e.shift(), f.push({
                        value: d,
                        type: g,
                        matches: e
                    }), h = h.slice(d.length));
                    if (!d) break
                }
                return c ? h.length : h ? b.error(a) : T(a, i).slice(0)
            }, B = b.compile = function (a, b) {
                var c, d = [], e = [], f = U[a + " "];
                if (!f) {
                    for (b || (b = A(a)), c = b.length; c--;) f = t(b[c]), f[O] ? d.push(f) : e.push(f);
                    f = U(a, u(e, d)), f.selector = a
                }
                return f
            }, C = b.select = function (a, b, c, d) {
                var e, f, g, h, i, j = "function" == typeof a && a, k = !d && A(a = j.selector || a);
                if (c = c || [], 1 === k.length) {
                    if (f = k[0] = k[0].slice(0), f.length > 2 && "ID" === (g = f[0]).type && 9 === b.nodeType && J && x.relative[f[1].type]) {
                        if (b = (x.find.ID(g.matches[0].replace(va, wa), b) || [])[0], !b) return c;
                        j && (b = b.parentNode), a = a.slice(f.shift().value.length)
                    }
                    for (e = oa.needsContext.test(a) ? 0 : f.length; e-- && (g = f[e], !x.relative[h = g.type]);) if ((i = x.find[h]) && (d = i(g.matches[0].replace(va, wa), ua.test(f[0].type) && l(b.parentNode) || b))) {
                        if (f.splice(e, 1), a = d.length && n(f), !a) return _.apply(c, d), c;
                        break
                    }
                }
                return (j || B(a, k))(d, b, !J, c, !b || ua.test(a) && l(b.parentNode) || b), c
            }, w.sortStable = O.split("").sort(W).join("") === O, w.detectDuplicates = !!F, G(), w.sortDetached = e(function (a) {
                return 1 & a.compareDocumentPosition(H.createElement("fieldset"))
            }), e(function (a) {
                return a.innerHTML = "<a href='#'></a>", "#" === a.firstChild.getAttribute("href")
            }) || f("type|href|height|width", function (a, b, c) {
                if (!c) return a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2)
            }), w.attributes && e(function (a) {
                return a.innerHTML = "<input/>", a.firstChild.setAttribute("value", ""), "" === a.firstChild.getAttribute("value")
            }) || f("value", function (a, b, c) {
                if (!c && "input" === a.nodeName.toLowerCase()) return a.defaultValue
            }), e(function (a) {
                return null == a.getAttribute("disabled")
            }) || f(ca, function (a, b, c) {
                var d;
                if (!c) return a[b] === !0 ? b.toLowerCase() : (d = a.getAttributeNode(b)) && d.specified ? d.value : null
            }), b
        }(a);
    ya.find = za, ya.expr = za.selectors, ya.expr[":"] = ya.expr.pseudos, ya.uniqueSort = ya.unique = za.uniqueSort, ya.text = za.getText, ya.isXMLDoc = za.isXML, ya.contains = za.contains, ya.escapeSelector = za.escape;
    var Aa = function (a, b, c) {
        for (var d = [], e = void 0 !== c; (a = a[b]) && 9 !== a.nodeType;) if (1 === a.nodeType) {
            if (e && ya(a).is(c)) break;
            d.push(a)
        }
        return d
    }, Ba = function (a, b) {
        for (var c = []; a; a = a.nextSibling) 1 === a.nodeType && a !== b && c.push(a);
        return c
    }, Ca = ya.expr.match.needsContext, Da = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    ya.filter = function (a, b, c) {
        var d = b[0];
        return c && (a = ":not(" + a + ")"), 1 === b.length && 1 === d.nodeType ? ya.find.matchesSelector(d, a) ? [d] : [] : ya.find.matches(a, ya.grep(b, function (a) {
            return 1 === a.nodeType
        }))
    }, ya.fn.extend({
        find: function (a) {
            var b, c, d = this.length, e = this;
            if ("string" != typeof a) return this.pushStack(ya(a).filter(function () {
                for (b = 0; b < d; b++) if (ya.contains(e[b], this)) return !0
            }));
            for (c = this.pushStack([]), b = 0; b < d; b++) ya.find(a, e[b], c);
            return d > 1 ? ya.uniqueSort(c) : c
        }, filter: function (a) {
            return this.pushStack(g(this, a || [], !1))
        }, not: function (a) {
            return this.pushStack(g(this, a || [], !0))
        }, is: function (a) {
            return !!g(this, "string" == typeof a && Ca.test(a) ? ya(a) : a || [], !1).length
        }
    });
    var Ea, Fa = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, Ga = ya.fn.init = function (a, b, c) {
        var d, e;
        if (!a) return this;
        if (c = c || Ea, "string" == typeof a) {
            if (d = "<" === a[0] && ">" === a[a.length - 1] && a.length >= 3 ? [null, a, null] : Fa.exec(a), !d || !d[1] && b) return !b || b.jquery ? (b || c).find(a) : this.constructor(b).find(a);
            if (d[1]) {
                if (b = b instanceof ya ? b[0] : b, ya.merge(this, ya.parseHTML(d[1], b && b.nodeType ? b.ownerDocument || b : va, !0)), Da.test(d[1]) && ya.isPlainObject(b)) for (d in b) ta(this[d]) ? this[d](b[d]) : this.attr(d, b[d]);
                return this
            }
            return e = va.getElementById(d[2]), e && (this[0] = e, this.length = 1), this
        }
        return a.nodeType ? (this[0] = a, this.length = 1, this) : ta(a) ? void 0 !== c.ready ? c.ready(a) : a(ya) : ya.makeArray(a, this)
    };
    Ga.prototype = ya.fn, Ea = ya(va);
    var Ha = /^(?:parents|prev(?:Until|All))/, Ia = {children: !0, contents: !0, next: !0, prev: !0};
    ya.fn.extend({
        has: function (a) {
            var b = ya(a, this), c = b.length;
            return this.filter(function () {
                for (var a = 0; a < c; a++) if (ya.contains(this, b[a])) return !0
            })
        }, closest: function (a, b) {
            var c, d = 0, e = this.length, f = [], g = "string" != typeof a && ya(a);
            if (!Ca.test(a)) for (; d < e; d++) for (c = this[d]; c && c !== b; c = c.parentNode) if (c.nodeType < 11 && (g ? g.index(c) > -1 : 1 === c.nodeType && ya.find.matchesSelector(c, a))) {
                f.push(c);
                break
            }
            return this.pushStack(f.length > 1 ? ya.uniqueSort(f) : f)
        }, index: function (a) {
            return a ? "string" == typeof a ? ma.call(ya(a), this[0]) : ma.call(this, a.jquery ? a[0] : a) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        }, add: function (a, b) {
            return this.pushStack(ya.uniqueSort(ya.merge(this.get(), ya(a, b))))
        }, addBack: function (a) {
            return this.add(null == a ? this.prevObject : this.prevObject.filter(a))
        }
    }), ya.each({
        parent: function (a) {
            var b = a.parentNode;
            return b && 11 !== b.nodeType ? b : null
        }, parents: function (a) {
            return Aa(a, "parentNode")
        }, parentsUntil: function (a, b, c) {
            return Aa(a, "parentNode", c)
        }, next: function (a) {
            return h(a, "nextSibling")
        }, prev: function (a) {
            return h(a, "previousSibling")
        }, nextAll: function (a) {
            return Aa(a, "nextSibling")
        }, prevAll: function (a) {
            return Aa(a, "previousSibling")
        }, nextUntil: function (a, b, c) {
            return Aa(a, "nextSibling", c)
        }, prevUntil: function (a, b, c) {
            return Aa(a, "previousSibling", c)
        }, siblings: function (a) {
            return Ba((a.parentNode || {}).firstChild, a)
        }, children: function (a) {
            return Ba(a.firstChild)
        }, contents: function (a) {
            return null != a.contentDocument && ia(a.contentDocument) ? a.contentDocument : (f(a, "template") && (a = a.content || a), ya.merge([], a.childNodes))
        }
    }, function (a, b) {
        ya.fn[a] = function (c, d) {
            var e = ya.map(this, b, c);
            return "Until" !== a.slice(-5) && (d = c), d && "string" == typeof d && (e = ya.filter(d, e)), this.length > 1 && (Ia[a] || ya.uniqueSort(e), Ha.test(a) && e.reverse()), this.pushStack(e)
        }
    });
    var Ja = /[^\x20\t\r\n\f]+/g;
    ya.Callbacks = function (a) {
        a = "string" == typeof a ? i(a) : ya.extend({}, a);
        var b, c, e, f, g = [], h = [], j = -1, k = function () {
            for (f = f || a.once, e = b = !0; h.length; j = -1) for (c = h.shift(); ++j < g.length;) g[j].apply(c[0], c[1]) === !1 && a.stopOnFalse && (j = g.length, c = !1);
            a.memory || (c = !1), b = !1, f && (g = c ? [] : "")
        }, l = {
            add: function () {
                return g && (c && !b && (j = g.length - 1, h.push(c)), function b(c) {
                    ya.each(c, function (c, e) {
                        ta(e) ? a.unique && l.has(e) || g.push(e) : e && e.length && "string" !== d(e) && b(e)
                    })
                }(arguments), c && !b && k()), this
            }, remove: function () {
                return ya.each(arguments, function (a, b) {
                    for (var c; (c = ya.inArray(b, g, c)) > -1;) g.splice(c, 1), c <= j && j--
                }), this
            }, has: function (a) {
                return a ? ya.inArray(a, g) > -1 : g.length > 0
            }, empty: function () {
                return g && (g = []), this
            }, disable: function () {
                return f = h = [], g = c = "", this
            }, disabled: function () {
                return !g
            }, lock: function () {
                return f = h = [], c || b || (g = c = ""), this
            }, locked: function () {
                return !!f
            }, fireWith: function (a, c) {
                return f || (c = c || [], c = [a, c.slice ? c.slice() : c], h.push(c), b || k()), this
            }, fire: function () {
                return l.fireWith(this, arguments), this
            }, fired: function () {
                return !!e
            }
        };
        return l
    }, ya.extend({
        Deferred: function (b) {
            var c = [["notify", "progress", ya.Callbacks("memory"), ya.Callbacks("memory"), 2], ["resolve", "done", ya.Callbacks("once memory"), ya.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", ya.Callbacks("once memory"), ya.Callbacks("once memory"), 1, "rejected"]],
                d = "pending", e = {
                    state: function () {
                        return d
                    }, always: function () {
                        return f.done(arguments).fail(arguments), this
                    }, catch: function (a) {
                        return e.then(null, a)
                    }, pipe: function () {
                        var a = arguments;
                        return ya.Deferred(function (b) {
                            ya.each(c, function (c, d) {
                                var e = ta(a[d[4]]) && a[d[4]];
                                f[d[1]](function () {
                                    var a = e && e.apply(this, arguments);
                                    a && ta(a.promise) ? a.promise().progress(b.notify).done(b.resolve).fail(b.reject) : b[d[0] + "With"](this, e ? [a] : arguments)
                                })
                            }), a = null
                        }).promise()
                    }, then: function (b, d, e) {
                        function f(b, c, d, e) {
                            return function () {
                                var h = this, i = arguments, l = function () {
                                    var a, l;
                                    if (!(b < g)) {
                                        if (a = d.apply(h, i), a === c.promise()) throw new TypeError("Thenable self-resolution");
                                        l = a && ("object" == typeof a || "function" == typeof a) && a.then, ta(l) ? e ? l.call(a, f(g, c, j, e), f(g, c, k, e)) : (g++, l.call(a, f(g, c, j, e), f(g, c, k, e), f(g, c, j, c.notifyWith))) : (d !== j && (h = void 0, i = [a]), (e || c.resolveWith)(h, i))
                                    }
                                }, m = e ? l : function () {
                                    try {
                                        l()
                                    } catch (a) {
                                        ya.Deferred.exceptionHook && ya.Deferred.exceptionHook(a, m.stackTrace), b + 1 >= g && (d !== k && (h = void 0, i = [a]), c.rejectWith(h, i))
                                    }
                                };
                                b ? m() : (ya.Deferred.getStackHook && (m.stackTrace = ya.Deferred.getStackHook()), a.setTimeout(m))
                            }
                        }

                        var g = 0;
                        return ya.Deferred(function (a) {
                            c[0][3].add(f(0, a, ta(e) ? e : j, a.notifyWith)), c[1][3].add(f(0, a, ta(b) ? b : j)), c[2][3].add(f(0, a, ta(d) ? d : k))
                        }).promise()
                    }, promise: function (a) {
                        return null != a ? ya.extend(a, e) : e
                    }
                }, f = {};
            return ya.each(c, function (a, b) {
                var g = b[2], h = b[5];
                e[b[1]] = g.add, h && g.add(function () {
                    d = h
                }, c[3 - a][2].disable, c[3 - a][3].disable, c[0][2].lock, c[0][3].lock), g.add(b[3].fire), f[b[0]] = function () {
                    return f[b[0] + "With"](this === f ? void 0 : this, arguments), this
                }, f[b[0] + "With"] = g.fireWith
            }), e.promise(f), b && b.call(f, f), f
        }, when: function (a) {
            var b = arguments.length, c = b, d = Array(c), e = ja.call(arguments), f = ya.Deferred(), g = function (a) {
                return function (c) {
                    d[a] = this, e[a] = arguments.length > 1 ? ja.call(arguments) : c, --b || f.resolveWith(d, e)
                }
            };
            if (b <= 1 && (l(a, f.done(g(c)).resolve, f.reject, !b), "pending" === f.state() || ta(e[c] && e[c].then))) return f.then();
            for (; c--;) l(e[c], g(c), f.reject);
            return f.promise()
        }
    });
    var Ka = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    ya.Deferred.exceptionHook = function (b, c) {
        a.console && a.console.warn && b && Ka.test(b.name) && a.console.warn("jQuery.Deferred exception: " + b.message, b.stack, c)
    }, ya.readyException = function (b) {
        a.setTimeout(function () {
            throw b
        })
    };
    var La = ya.Deferred();
    ya.fn.ready = function (a) {
        return La.then(a).catch(function (a) {
            ya.readyException(a)
        }), this
    }, ya.extend({
        isReady: !1, readyWait: 1, ready: function (a) {
            (a === !0 ? --ya.readyWait : ya.isReady) || (ya.isReady = !0, a !== !0 && --ya.readyWait > 0 || La.resolveWith(va, [ya]))
        }
    }), ya.ready.then = La.then, "complete" === va.readyState || "loading" !== va.readyState && !va.documentElement.doScroll ? a.setTimeout(ya.ready) : (va.addEventListener("DOMContentLoaded", m), a.addEventListener("load", m));
    var Ma = function (a, b, c, e, f, g, h) {
        var i = 0, j = a.length, k = null == c;
        if ("object" === d(c)) {
            f = !0;
            for (i in c) Ma(a, b, i, c[i], !0, g, h)
        } else if (void 0 !== e && (f = !0, ta(e) || (h = !0), k && (h ? (b.call(a, e), b = null) : (k = b, b = function (a, b, c) {
            return k.call(ya(a), c)
        })), b)) for (; i < j; i++) b(a[i], c, h ? e : e.call(a[i], i, b(a[i], c)));
        return f ? a : k ? b.call(a) : j ? b(a[0], c) : g
    }, Na = /^-ms-/, Oa = /-([a-z])/g, Pa = function (a) {
        return 1 === a.nodeType || 9 === a.nodeType || !+a.nodeType
    };
    p.uid = 1, p.prototype = {
        cache: function (a) {
            var b = a[this.expando];
            return b || (b = {}, Pa(a) && (a.nodeType ? a[this.expando] = b : Object.defineProperty(a, this.expando, {
                value: b,
                configurable: !0
            }))), b
        }, set: function (a, b, c) {
            var d, e = this.cache(a);
            if ("string" == typeof b) e[o(b)] = c; else for (d in b) e[o(d)] = b[d];
            return e
        }, get: function (a, b) {
            return void 0 === b ? this.cache(a) : a[this.expando] && a[this.expando][o(b)]
        }, access: function (a, b, c) {
            return void 0 === b || b && "string" == typeof b && void 0 === c ? this.get(a, b) : (this.set(a, b, c), void 0 !== c ? c : b)
        }, remove: function (a, b) {
            var c, d = a[this.expando];
            if (void 0 !== d) {
                if (void 0 !== b) {
                    Array.isArray(b) ? b = b.map(o) : (b = o(b), b = b in d ? [b] : b.match(Ja) || []), c = b.length;
                    for (; c--;) delete d[b[c]]
                }
                (void 0 === b || ya.isEmptyObject(d)) && (a.nodeType ? a[this.expando] = void 0 : delete a[this.expando])
            }
        }, hasData: function (a) {
            var b = a[this.expando];
            return void 0 !== b && !ya.isEmptyObject(b)
        }
    };
    var Qa = new p, Ra = new p, Sa = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, Ta = /[A-Z]/g;
    ya.extend({
        hasData: function (a) {
            return Ra.hasData(a) || Qa.hasData(a)
        }, data: function (a, b, c) {
            return Ra.access(a, b, c)
        }, removeData: function (a, b) {
            Ra.remove(a, b)
        }, _data: function (a, b, c) {
            return Qa.access(a, b, c)
        }, _removeData: function (a, b) {
            Qa.remove(a, b)
        }
    }), ya.fn.extend({
        data: function (a, b) {
            var c, d, e, f = this[0], g = f && f.attributes;
            if (void 0 === a) {
                if (this.length && (e = Ra.get(f), 1 === f.nodeType && !Qa.get(f, "hasDataAttrs"))) {
                    for (c = g.length; c--;) g[c] && (d = g[c].name, 0 === d.indexOf("data-") && (d = o(d.slice(5)), r(f, d, e[d])));
                    Qa.set(f, "hasDataAttrs", !0)
                }
                return e
            }
            return "object" == typeof a ? this.each(function () {
                Ra.set(this, a)
            }) : Ma(this, function (b) {
                var c;
                if (f && void 0 === b) {
                    if (c = Ra.get(f, a), void 0 !== c) return c;
                    if (c = r(f, a), void 0 !== c) return c
                } else this.each(function () {
                    Ra.set(this, a, b)
                })
            }, null, b, arguments.length > 1, null, !0)
        }, removeData: function (a) {
            return this.each(function () {
                Ra.remove(this, a)
            })
        }
    }), ya.extend({
        queue: function (a, b, c) {
            var d;
            if (a) return b = (b || "fx") + "queue", d = Qa.get(a, b), c && (!d || Array.isArray(c) ? d = Qa.access(a, b, ya.makeArray(c)) : d.push(c)), d || []
        }, dequeue: function (a, b) {
            b = b || "fx";
            var c = ya.queue(a, b), d = c.length, e = c.shift(), f = ya._queueHooks(a, b), g = function () {
                ya.dequeue(a, b)
            };
            "inprogress" === e && (e = c.shift(), d--), e && ("fx" === b && c.unshift("inprogress"), delete f.stop, e.call(a, g, f)), !d && f && f.empty.fire()
        }, _queueHooks: function (a, b) {
            var c = b + "queueHooks";
            return Qa.get(a, c) || Qa.access(a, c, {
                empty: ya.Callbacks("once memory").add(function () {
                    Qa.remove(a, [b + "queue", c])
                })
            })
        }
    }), ya.fn.extend({
        queue: function (a, b) {
            var c = 2;
            return "string" != typeof a && (b = a, a = "fx", c--), arguments.length < c ? ya.queue(this[0], a) : void 0 === b ? this : this.each(function () {
                var c = ya.queue(this, a, b);
                ya._queueHooks(this, a), "fx" === a && "inprogress" !== c[0] && ya.dequeue(this, a)
            })
        }, dequeue: function (a) {
            return this.each(function () {
                ya.dequeue(this, a)
            })
        }, clearQueue: function (a) {
            return this.queue(a || "fx", [])
        }, promise: function (a, b) {
            var c, d = 1, e = ya.Deferred(), f = this, g = this.length, h = function () {
                --d || e.resolveWith(f, [f])
            };
            for ("string" != typeof a && (b = a, a = void 0), a = a || "fx"; g--;) c = Qa.get(f[g], a + "queueHooks"), c && c.empty && (d++, c.empty.add(h));
            return h(), e.promise(b)
        }
    });
    var Ua = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, Va = new RegExp("^(?:([+-])=|)(" + Ua + ")([a-z%]*)$", "i"),
        Wa = ["Top", "Right", "Bottom", "Left"], Xa = va.documentElement, Ya = function (a) {
            return ya.contains(a.ownerDocument, a)
        }, Za = {composed: !0};
    Xa.getRootNode && (Ya = function (a) {
        return ya.contains(a.ownerDocument, a) || a.getRootNode(Za) === a.ownerDocument
    });
    var $a = function (a, b) {
        return a = b || a, "none" === a.style.display || "" === a.style.display && Ya(a) && "none" === ya.css(a, "display")
    }, _a = {};
    ya.fn.extend({
        show: function () {
            return u(this, !0)
        }, hide: function () {
            return u(this)
        }, toggle: function (a) {
            return "boolean" == typeof a ? a ? this.show() : this.hide() : this.each(function () {
                $a(this) ? ya(this).show() : ya(this).hide()
            })
        }
    });
    var ab = /^(?:checkbox|radio)$/i, bb = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, cb = /^$|^module$|\/(?:java|ecma)script/i;
    !function () {
        var a = va.createDocumentFragment(), b = a.appendChild(va.createElement("div")), c = va.createElement("input");
        c.setAttribute("type", "radio"), c.setAttribute("checked", "checked"), c.setAttribute("name", "t"), b.appendChild(c), sa.checkClone = b.cloneNode(!0).cloneNode(!0).lastChild.checked, b.innerHTML = "<textarea>x</textarea>", sa.noCloneChecked = !!b.cloneNode(!0).lastChild.defaultValue, b.innerHTML = "<option></option>", sa.option = !!b.lastChild
    }();
    var db = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    db.tbody = db.tfoot = db.colgroup = db.caption = db.thead, db.th = db.td, sa.option || (db.optgroup = db.option = [1, "<select multiple='multiple'>", "</select>"]);
    var eb = /<|&#?\w+;/, fb = /^key/, gb = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        hb = /^([^.]*)(?:\.(.+)|)/;
    ya.event = {
        global: {}, add: function (a, b, c, d, e) {
            var f, g, h, i, j, k, l, m, n, o, p, q = Qa.get(a);
            if (Pa(a)) for (c.handler && (f = c, c = f.handler, e = f.selector), e && ya.find.matchesSelector(Xa, e), c.guid || (c.guid = ya.guid++), (i = q.events) || (i = q.events = Object.create(null)), (g = q.handle) || (g = q.handle = function (b) {
                return "undefined" != typeof ya && ya.event.triggered !== b.type ? ya.event.dispatch.apply(a, arguments) : void 0
            }), b = (b || "").match(Ja) || [""], j = b.length; j--;) h = hb.exec(b[j]) || [], n = p = h[1], o = (h[2] || "").split(".").sort(), n && (l = ya.event.special[n] || {}, n = (e ? l.delegateType : l.bindType) || n, l = ya.event.special[n] || {}, k = ya.extend({
                type: n,
                origType: p,
                data: d,
                handler: c,
                guid: c.guid,
                selector: e,
                needsContext: e && ya.expr.match.needsContext.test(e),
                namespace: o.join(".")
            }, f), (m = i[n]) || (m = i[n] = [], m.delegateCount = 0, l.setup && l.setup.call(a, d, o, g) !== !1 || a.addEventListener && a.addEventListener(n, g)), l.add && (l.add.call(a, k), k.handler.guid || (k.handler.guid = c.guid)), e ? m.splice(m.delegateCount++, 0, k) : m.push(k), ya.event.global[n] = !0)
        }, remove: function (a, b, c, d, e) {
            var f, g, h, i, j, k, l, m, n, o, p, q = Qa.hasData(a) && Qa.get(a);
            if (q && (i = q.events)) {
                for (b = (b || "").match(Ja) || [""], j = b.length; j--;) if (h = hb.exec(b[j]) || [], n = p = h[1], o = (h[2] || "").split(".").sort(), n) {
                    for (l = ya.event.special[n] || {}, n = (d ? l.delegateType : l.bindType) || n, m = i[n] || [], h = h[2] && new RegExp("(^|\\.)" + o.join("\\.(?:.*\\.|)") + "(\\.|$)"), g = f = m.length; f--;) k = m[f], !e && p !== k.origType || c && c.guid !== k.guid || h && !h.test(k.namespace) || d && d !== k.selector && ("**" !== d || !k.selector) || (m.splice(f, 1), k.selector && m.delegateCount--, l.remove && l.remove.call(a, k));
                    g && !m.length && (l.teardown && l.teardown.call(a, o, q.handle) !== !1 || ya.removeEvent(a, n, q.handle), delete i[n])
                } else for (n in i) ya.event.remove(a, n + b[j], c, d, !0);
                ya.isEmptyObject(i) && Qa.remove(a, "handle events")
            }
        }, dispatch: function (a) {
            var b, c, d, e, f, g, h = new Array(arguments.length), i = ya.event.fix(a),
                j = (Qa.get(this, "events") || Object.create(null))[i.type] || [], k = ya.event.special[i.type] || {};
            for (h[0] = i, b = 1; b < arguments.length; b++) h[b] = arguments[b];
            if (i.delegateTarget = this, !k.preDispatch || k.preDispatch.call(this, i) !== !1) {
                for (g = ya.event.handlers.call(this, i, j), b = 0; (e = g[b++]) && !i.isPropagationStopped();) for (i.currentTarget = e.elem, c = 0; (f = e.handlers[c++]) && !i.isImmediatePropagationStopped();) i.rnamespace && f.namespace !== !1 && !i.rnamespace.test(f.namespace) || (i.handleObj = f, i.data = f.data, d = ((ya.event.special[f.origType] || {}).handle || f.handler).apply(e.elem, h), void 0 !== d && (i.result = d) === !1 && (i.preventDefault(), i.stopPropagation()));
                return k.postDispatch && k.postDispatch.call(this, i), i.result
            }
        }, handlers: function (a, b) {
            var c, d, e, f, g, h = [], i = b.delegateCount, j = a.target;
            if (i && j.nodeType && !("click" === a.type && a.button >= 1)) for (; j !== this; j = j.parentNode || this) if (1 === j.nodeType && ("click" !== a.type || j.disabled !== !0)) {
                for (f = [], g = {}, c = 0; c < i; c++) d = b[c], e = d.selector + " ", void 0 === g[e] && (g[e] = d.needsContext ? ya(e, this).index(j) > -1 : ya.find(e, this, null, [j]).length), g[e] && f.push(d);
                f.length && h.push({elem: j, handlers: f})
            }
            return j = this, i < b.length && h.push({elem: j, handlers: b.slice(i)}), h
        }, addProp: function (a, b) {
            Object.defineProperty(ya.Event.prototype, a, {
                enumerable: !0, configurable: !0, get: ta(b) ? function () {
                    if (this.originalEvent) return b(this.originalEvent)
                } : function () {
                    if (this.originalEvent) return this.originalEvent[a]
                }, set: function (b) {
                    Object.defineProperty(this, a, {enumerable: !0, configurable: !0, writable: !0, value: b})
                }
            })
        }, fix: function (a) {
            return a[ya.expando] ? a : new ya.Event(a)
        }, special: {
            load: {noBubble: !0}, click: {
                setup: function (a) {
                    var b = this || a;
                    return ab.test(b.type) && b.click && f(b, "input") && D(b, "click", y), !1
                }, trigger: function (a) {
                    var b = this || a;
                    return ab.test(b.type) && b.click && f(b, "input") && D(b, "click"), !0
                }, _default: function (a) {
                    var b = a.target;
                    return ab.test(b.type) && b.click && f(b, "input") && Qa.get(b, "click") || f(b, "a")
                }
            }, beforeunload: {
                postDispatch: function (a) {
                    void 0 !== a.result && a.originalEvent && (a.originalEvent.returnValue = a.result)
                }
            }
        }
    }, ya.removeEvent = function (a, b, c) {
        a.removeEventListener && a.removeEventListener(b, c)
    }, ya.Event = function (a, b) {
        return this instanceof ya.Event ? (a && a.type ? (this.originalEvent = a, this.type = a.type, this.isDefaultPrevented = a.defaultPrevented || void 0 === a.defaultPrevented && a.returnValue === !1 ? y : z, this.target = a.target && 3 === a.target.nodeType ? a.target.parentNode : a.target, this.currentTarget = a.currentTarget, this.relatedTarget = a.relatedTarget) : this.type = a, b && ya.extend(this, b), this.timeStamp = a && a.timeStamp || Date.now(), void (this[ya.expando] = !0)) : new ya.Event(a, b)
    }, ya.Event.prototype = {
        constructor: ya.Event,
        isDefaultPrevented: z,
        isPropagationStopped: z,
        isImmediatePropagationStopped: z,
        isSimulated: !1,
        preventDefault: function () {
            var a = this.originalEvent;
            this.isDefaultPrevented = y, a && !this.isSimulated && a.preventDefault()
        },
        stopPropagation: function () {
            var a = this.originalEvent;
            this.isPropagationStopped = y, a && !this.isSimulated && a.stopPropagation()
        },
        stopImmediatePropagation: function () {
            var a = this.originalEvent;
            this.isImmediatePropagationStopped = y, a && !this.isSimulated && a.stopImmediatePropagation(), this.stopPropagation()
        }
    }, ya.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function (a) {
            var b = a.button;
            return null == a.which && fb.test(a.type) ? null != a.charCode ? a.charCode : a.keyCode : !a.which && void 0 !== b && gb.test(a.type) ? 1 & b ? 1 : 2 & b ? 3 : 4 & b ? 2 : 0 : a.which
        }
    }, ya.event.addProp), ya.each({focus: "focusin", blur: "focusout"}, function (a, b) {
        ya.event.special[a] = {
            setup: function () {
                return D(this, a, A), !1
            }, trigger: function () {
                return D(this, a), !0
            }, delegateType: b
        }
    }), ya.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function (a, b) {
        ya.event.special[a] = {
            delegateType: b, bindType: b, handle: function (a) {
                var c, d = this, e = a.relatedTarget, f = a.handleObj;
                return e && (e === d || ya.contains(d, e)) || (a.type = f.origType, c = f.handler.apply(this, arguments), a.type = b), c
            }
        }
    }), ya.fn.extend({
        on: function (a, b, c, d) {
            return C(this, a, b, c, d)
        }, one: function (a, b, c, d) {
            return C(this, a, b, c, d, 1)
        }, off: function (a, b, c) {
            var d, e;
            if (a && a.preventDefault && a.handleObj) return d = a.handleObj, ya(a.delegateTarget).off(d.namespace ? d.origType + "." + d.namespace : d.origType, d.selector, d.handler), this;
            if ("object" == typeof a) {
                for (e in a) this.off(e, b, a[e]);
                return this
            }
            return b !== !1 && "function" != typeof b || (c = b, b = void 0), c === !1 && (c = z), this.each(function () {
                ya.event.remove(this, a, c, b)
            })
        }
    });
    var ib = /<script|<style|<link/i, jb = /checked\s*(?:[^=]|=\s*.checked.)/i,
        kb = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    ya.extend({
        htmlPrefilter: function (a) {
            return a
        }, clone: function (a, b, c) {
            var d, e, f, g, h = a.cloneNode(!0), i = Ya(a);
            if (!(sa.noCloneChecked || 1 !== a.nodeType && 11 !== a.nodeType || ya.isXMLDoc(a))) for (g = v(h), f = v(a), d = 0, e = f.length; d < e; d++) I(f[d], g[d]);
            if (b) if (c) for (f = f || v(a), g = g || v(h), d = 0, e = f.length; d < e; d++) H(f[d], g[d]); else H(a, h);
            return g = v(h, "script"), g.length > 0 && w(g, !i && v(a, "script")), h
        }, cleanData: function (a) {
            for (var b, c, d, e = ya.event.special, f = 0; void 0 !== (c = a[f]); f++) if (Pa(c)) {
                if (b = c[Qa.expando]) {
                    if (b.events) for (d in b.events) e[d] ? ya.event.remove(c, d) : ya.removeEvent(c, d, b.handle);
                    c[Qa.expando] = void 0
                }
                c[Ra.expando] && (c[Ra.expando] = void 0)
            }
        }
    }), ya.fn.extend({
        detach: function (a) {
            return K(this, a, !0)
        }, remove: function (a) {
            return K(this, a)
        }, text: function (a) {
            return Ma(this, function (a) {
                return void 0 === a ? ya.text(this) : this.empty().each(function () {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = a)
                })
            }, null, a, arguments.length)
        }, append: function () {
            return J(this, arguments, function (a) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var b = E(this, a);
                    b.appendChild(a)
                }
            })
        }, prepend: function () {
            return J(this, arguments, function (a) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var b = E(this, a);
                    b.insertBefore(a, b.firstChild)
                }
            })
        }, before: function () {
            return J(this, arguments, function (a) {
                this.parentNode && this.parentNode.insertBefore(a, this)
            })
        }, after: function () {
            return J(this, arguments, function (a) {
                this.parentNode && this.parentNode.insertBefore(a, this.nextSibling)
            })
        }, empty: function () {
            for (var a, b = 0; null != (a = this[b]); b++) 1 === a.nodeType && (ya.cleanData(v(a, !1)), a.textContent = "");
            return this
        }, clone: function (a, b) {
            return a = null != a && a, b = null == b ? a : b, this.map(function () {
                return ya.clone(this, a, b)
            })
        }, html: function (a) {
            return Ma(this, function (a) {
                var b = this[0] || {}, c = 0, d = this.length;
                if (void 0 === a && 1 === b.nodeType) return b.innerHTML;
                if ("string" == typeof a && !ib.test(a) && !db[(bb.exec(a) || ["", ""])[1].toLowerCase()]) {
                    a = ya.htmlPrefilter(a);
                    try {
                        for (; c < d; c++) b = this[c] || {}, 1 === b.nodeType && (ya.cleanData(v(b, !1)), b.innerHTML = a);
                        b = 0
                    } catch (a) {
                    }
                }
                b && this.empty().append(a)
            }, null, a, arguments.length)
        }, replaceWith: function () {
            var a = [];
            return J(this, arguments, function (b) {
                var c = this.parentNode;
                ya.inArray(this, a) < 0 && (ya.cleanData(v(this)), c && c.replaceChild(b, this))
            }, a)
        }
    }), ya.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function (a, b) {
        ya.fn[a] = function (a) {
            for (var c, d = [], e = ya(a), f = e.length - 1, g = 0; g <= f; g++) c = g === f ? this : this.clone(!0), ya(e[g])[b](c), la.apply(d, c.get());
            return this.pushStack(d)
        }
    });
    var lb = new RegExp("^(" + Ua + ")(?!px)[a-z%]+$", "i"), mb = function (b) {
        var c = b.ownerDocument.defaultView;
        return c && c.opener || (c = a), c.getComputedStyle(b)
    }, nb = function (a, b, c) {
        var d, e, f = {};
        for (e in b) f[e] = a.style[e], a.style[e] = b[e];
        d = c.call(a);
        for (e in b) a.style[e] = f[e];
        return d
    }, ob = new RegExp(Wa.join("|"), "i");
    !function () {
        function b() {
            if (k) {
                j.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", k.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", Xa.appendChild(j).appendChild(k);
                var b = a.getComputedStyle(k);
                d = "1%" !== b.top, i = 12 === c(b.marginLeft), k.style.right = "60%", g = 36 === c(b.right), e = 36 === c(b.width), k.style.position = "absolute", f = 12 === c(k.offsetWidth / 3), Xa.removeChild(j), k = null
            }
        }

        function c(a) {
            return Math.round(parseFloat(a))
        }

        var d, e, f, g, h, i, j = va.createElement("div"), k = va.createElement("div");
        k.style && (k.style.backgroundClip = "content-box", k.cloneNode(!0).style.backgroundClip = "", sa.clearCloneStyle = "content-box" === k.style.backgroundClip, ya.extend(sa, {
            boxSizingReliable: function () {
                return b(), e
            }, pixelBoxStyles: function () {
                return b(), g
            }, pixelPosition: function () {
                return b(), d
            }, reliableMarginLeft: function () {
                return b(), i
            }, scrollboxSize: function () {
                return b(), f
            }, reliableTrDimensions: function () {
                var b, c, d, e;
                return null == h && (b = va.createElement("table"), c = va.createElement("tr"), d = va.createElement("div"), b.style.cssText = "position:absolute;left:-11111px", c.style.height = "1px", d.style.height = "9px", Xa.appendChild(b).appendChild(c).appendChild(d), e = a.getComputedStyle(c), h = parseInt(e.height) > 3, Xa.removeChild(b)), h
            }
        }))
    }();
    var pb = ["Webkit", "Moz", "ms"], qb = va.createElement("div").style, rb = {}, sb = /^(none|table(?!-c[ea]).+)/,
        tb = /^--/, ub = {position: "absolute", visibility: "hidden", display: "block"},
        vb = {letterSpacing: "0", fontWeight: "400"};
    ya.extend({
        cssHooks: {
            opacity: {
                get: function (a, b) {
                    if (b) {
                        var c = L(a, "opacity");
                        return "" === c ? "1" : c
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function (a, b, c, d) {
            if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
                var e, f, g, h = o(b), i = tb.test(b), j = a.style;
                return i || (b = O(h)), g = ya.cssHooks[b] || ya.cssHooks[h], void 0 === c ? g && "get" in g && void 0 !== (e = g.get(a, !1, d)) ? e : j[b] : (f = typeof c, "string" === f && (e = Va.exec(c)) && e[1] && (c = s(a, b, e), f = "number"), null != c && c === c && ("number" !== f || i || (c += e && e[3] || (ya.cssNumber[h] ? "" : "px")), sa.clearCloneStyle || "" !== c || 0 !== b.indexOf("background") || (j[b] = "inherit"), g && "set" in g && void 0 === (c = g.set(a, c, d)) || (i ? j.setProperty(b, c) : j[b] = c)), void 0)
            }
        },
        css: function (a, b, c, d) {
            var e, f, g, h = o(b), i = tb.test(b);
            return i || (b = O(h)), g = ya.cssHooks[b] || ya.cssHooks[h], g && "get" in g && (e = g.get(a, !0, c)), void 0 === e && (e = L(a, b, d)), "normal" === e && b in vb && (e = vb[b]), "" === c || c ? (f = parseFloat(e), c === !0 || isFinite(f) ? f || 0 : e) : e
        }
    }), ya.each(["height", "width"], function (a, b) {
        ya.cssHooks[b] = {
            get: function (a, c, d) {
                if (c) return !sb.test(ya.css(a, "display")) || a.getClientRects().length && a.getBoundingClientRect().width ? R(a, b, d) : nb(a, ub, function () {
                    return R(a, b, d)
                })
            }, set: function (a, c, d) {
                var e, f = mb(a), g = !sa.scrollboxSize() && "absolute" === f.position, h = g || d,
                    i = h && "border-box" === ya.css(a, "boxSizing", !1, f), j = d ? Q(a, b, d, i, f) : 0;
                return i && g && (j -= Math.ceil(a["offset" + b[0].toUpperCase() + b.slice(1)] - parseFloat(f[b]) - Q(a, b, "border", !1, f) - .5)), j && (e = Va.exec(c)) && "px" !== (e[3] || "px") && (a.style[b] = c, c = ya.css(a, b)), P(a, c, j)
            }
        }
    }), ya.cssHooks.marginLeft = M(sa.reliableMarginLeft, function (a, b) {
        if (b) return (parseFloat(L(a, "marginLeft")) || a.getBoundingClientRect().left - nb(a, {marginLeft: 0}, function () {
            return a.getBoundingClientRect().left
        })) + "px"
    }), ya.each({margin: "", padding: "", border: "Width"}, function (a, b) {
        ya.cssHooks[a + b] = {
            expand: function (c) {
                for (var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [c]; d < 4; d++) e[a + Wa[d] + b] = f[d] || f[d - 2] || f[0];
                return e
            }
        }, "margin" !== a && (ya.cssHooks[a + b].set = P)
    }), ya.fn.extend({
        css: function (a, b) {
            return Ma(this, function (a, b, c) {
                var d, e, f = {}, g = 0;
                if (Array.isArray(b)) {
                    for (d = mb(a), e = b.length; g < e; g++) f[b[g]] = ya.css(a, b[g], !1, d);
                    return f
                }
                return void 0 !== c ? ya.style(a, b, c) : ya.css(a, b)
            }, a, b, arguments.length > 1)
        }
    }), ya.Tween = S, S.prototype = {
        constructor: S, init: function (a, b, c, d, e, f) {
            this.elem = a, this.prop = c, this.easing = e || ya.easing._default, this.options = b, this.start = this.now = this.cur(), this.end = d, this.unit = f || (ya.cssNumber[c] ? "" : "px")
        }, cur: function () {
            var a = S.propHooks[this.prop];
            return a && a.get ? a.get(this) : S.propHooks._default.get(this)
        }, run: function (a) {
            var b, c = S.propHooks[this.prop];
            return this.options.duration ? this.pos = b = ya.easing[this.easing](a, this.options.duration * a, 0, 1, this.options.duration) : this.pos = b = a, this.now = (this.end - this.start) * b + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), c && c.set ? c.set(this) : S.propHooks._default.set(this), this
        }
    }, S.prototype.init.prototype = S.prototype, S.propHooks = {
        _default: {
            get: function (a) {
                var b;
                return 1 !== a.elem.nodeType || null != a.elem[a.prop] && null == a.elem.style[a.prop] ? a.elem[a.prop] : (b = ya.css(a.elem, a.prop, ""), b && "auto" !== b ? b : 0)
            }, set: function (a) {
                ya.fx.step[a.prop] ? ya.fx.step[a.prop](a) : 1 !== a.elem.nodeType || !ya.cssHooks[a.prop] && null == a.elem.style[O(a.prop)] ? a.elem[a.prop] = a.now : ya.style(a.elem, a.prop, a.now + a.unit)
            }
        }
    }, S.propHooks.scrollTop = S.propHooks.scrollLeft = {
        set: function (a) {
            a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now)
        }
    }, ya.easing = {
        linear: function (a) {
            return a
        }, swing: function (a) {
            return .5 - Math.cos(a * Math.PI) / 2
        }, _default: "swing"
    }, ya.fx = S.prototype.init, ya.fx.step = {};
    var wb, xb, yb = /^(?:toggle|show|hide)$/, zb = /queueHooks$/;
    ya.Animation = ya.extend(Z, {
        tweeners: {
            "*": [function (a, b) {
                var c = this.createTween(a, b);
                return s(c.elem, a, Va.exec(b), c), c
            }]
        }, tweener: function (a, b) {
            ta(a) ? (b = a, a = ["*"]) : a = a.match(Ja);
            for (var c, d = 0, e = a.length; d < e; d++) c = a[d], Z.tweeners[c] = Z.tweeners[c] || [], Z.tweeners[c].unshift(b)
        }, prefilters: [X], prefilter: function (a, b) {
            b ? Z.prefilters.unshift(a) : Z.prefilters.push(a)
        }
    }), ya.speed = function (a, b, c) {
        var d = a && "object" == typeof a ? ya.extend({}, a) : {
            complete: c || !c && b || ta(a) && a,
            duration: a,
            easing: c && b || b && !ta(b) && b
        };
        return ya.fx.off ? d.duration = 0 : "number" != typeof d.duration && (d.duration in ya.fx.speeds ? d.duration = ya.fx.speeds[d.duration] : d.duration = ya.fx.speeds._default), null != d.queue && d.queue !== !0 || (d.queue = "fx"), d.old = d.complete, d.complete = function () {
            ta(d.old) && d.old.call(this), d.queue && ya.dequeue(this, d.queue)
        }, d
    }, ya.fn.extend({
        fadeTo: function (a, b, c, d) {
            return this.filter($a).css("opacity", 0).show().end().animate({opacity: b}, a, c, d)
        }, animate: function (a, b, c, d) {
            var e = ya.isEmptyObject(a), f = ya.speed(b, c, d), g = function () {
                var b = Z(this, ya.extend({}, a), f);
                (e || Qa.get(this, "finish")) && b.stop(!0)
            };
            return g.finish = g, e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g)
        }, stop: function (a, b, c) {
            var d = function (a) {
                var b = a.stop;
                delete a.stop, b(c)
            };
            return "string" != typeof a && (c = b, b = a, a = void 0), b && this.queue(a || "fx", []), this.each(function () {
                var b = !0, e = null != a && a + "queueHooks", f = ya.timers, g = Qa.get(this);
                if (e) g[e] && g[e].stop && d(g[e]); else for (e in g) g[e] && g[e].stop && zb.test(e) && d(g[e]);
                for (e = f.length; e--;) f[e].elem !== this || null != a && f[e].queue !== a || (f[e].anim.stop(c), b = !1, f.splice(e, 1));
                !b && c || ya.dequeue(this, a)
            })
        }, finish: function (a) {
            return a !== !1 && (a = a || "fx"), this.each(function () {
                var b, c = Qa.get(this), d = c[a + "queue"], e = c[a + "queueHooks"], f = ya.timers,
                    g = d ? d.length : 0;
                for (c.finish = !0, ya.queue(this, a, []), e && e.stop && e.stop.call(this, !0), b = f.length; b--;) f[b].elem === this && f[b].queue === a && (f[b].anim.stop(!0), f.splice(b, 1));
                for (b = 0; b < g; b++) d[b] && d[b].finish && d[b].finish.call(this);
                delete c.finish
            })
        }
    }), ya.each(["toggle", "show", "hide"], function (a, b) {
        var c = ya.fn[b];
        ya.fn[b] = function (a, d, e) {
            return null == a || "boolean" == typeof a ? c.apply(this, arguments) : this.animate(V(b, !0), a, d, e)
        }
    }), ya.each({
        slideDown: V("show"),
        slideUp: V("hide"),
        slideToggle: V("toggle"),
        fadeIn: {opacity: "show"},
        fadeOut: {opacity: "hide"},
        fadeToggle: {opacity: "toggle"}
    }, function (a, b) {
        ya.fn[a] = function (a, c, d) {
            return this.animate(b, a, c, d)
        }
    }), ya.timers = [], ya.fx.tick = function () {
        var a, b = 0, c = ya.timers;
        for (wb = Date.now(); b < c.length; b++) a = c[b], a() || c[b] !== a || c.splice(b--, 1);
        c.length || ya.fx.stop(), wb = void 0
    }, ya.fx.timer = function (a) {
        ya.timers.push(a), ya.fx.start()
    }, ya.fx.interval = 13, ya.fx.start = function () {
        xb || (xb = !0, T())
    }, ya.fx.stop = function () {
        xb = null
    }, ya.fx.speeds = {slow: 600, fast: 200, _default: 400}, ya.fn.delay = function (b, c) {
        return b = ya.fx ? ya.fx.speeds[b] || b : b, c = c || "fx", this.queue(c, function (c, d) {
            var e = a.setTimeout(c, b);
            d.stop = function () {
                a.clearTimeout(e)
            }
        })
    }, function () {
        var a = va.createElement("input"), b = va.createElement("select"),
            c = b.appendChild(va.createElement("option"));
        a.type = "checkbox", sa.checkOn = "" !== a.value, sa.optSelected = c.selected, a = va.createElement("input"), a.value = "t", a.type = "radio", sa.radioValue = "t" === a.value
    }();
    var Ab, Bb = ya.expr.attrHandle;
    ya.fn.extend({
        attr: function (a, b) {
            return Ma(this, ya.attr, a, b, arguments.length > 1)
        }, removeAttr: function (a) {
            return this.each(function () {
                ya.removeAttr(this, a)
            })
        }
    }), ya.extend({
        attr: function (a, b, c) {
            var d, e, f = a.nodeType;
            if (3 !== f && 8 !== f && 2 !== f) return "undefined" == typeof a.getAttribute ? ya.prop(a, b, c) : (1 === f && ya.isXMLDoc(a) || (e = ya.attrHooks[b.toLowerCase()] || (ya.expr.match.bool.test(b) ? Ab : void 0)), void 0 !== c ? null === c ? void ya.removeAttr(a, b) : e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : (a.setAttribute(b, c + ""), c) : e && "get" in e && null !== (d = e.get(a, b)) ? d : (d = ya.find.attr(a, b), null == d ? void 0 : d))
        }, attrHooks: {
            type: {
                set: function (a, b) {
                    if (!sa.radioValue && "radio" === b && f(a, "input")) {
                        var c = a.value;
                        return a.setAttribute("type", b), c && (a.value = c), b
                    }
                }
            }
        }, removeAttr: function (a, b) {
            var c, d = 0, e = b && b.match(Ja);
            if (e && 1 === a.nodeType) for (; c = e[d++];) a.removeAttribute(c)
        }
    }), Ab = {
        set: function (a, b, c) {
            return b === !1 ? ya.removeAttr(a, c) : a.setAttribute(c, c), c
        }
    }, ya.each(ya.expr.match.bool.source.match(/\w+/g), function (a, b) {
        var c = Bb[b] || ya.find.attr;
        Bb[b] = function (a, b, d) {
            var e, f, g = b.toLowerCase();
            return d || (f = Bb[g], Bb[g] = e, e = null != c(a, b, d) ? g : null, Bb[g] = f), e
        }
    });
    var Cb = /^(?:input|select|textarea|button)$/i, Db = /^(?:a|area)$/i;
    ya.fn.extend({
        prop: function (a, b) {
            return Ma(this, ya.prop, a, b, arguments.length > 1)
        }, removeProp: function (a) {
            return this.each(function () {
                delete this[ya.propFix[a] || a]
            })
        }
    }), ya.extend({
        prop: function (a, b, c) {
            var d, e, f = a.nodeType;
            if (3 !== f && 8 !== f && 2 !== f) return 1 === f && ya.isXMLDoc(a) || (b = ya.propFix[b] || b, e = ya.propHooks[b]), void 0 !== c ? e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : a[b] = c : e && "get" in e && null !== (d = e.get(a, b)) ? d : a[b]
        }, propHooks: {
            tabIndex: {
                get: function (a) {
                    var b = ya.find.attr(a, "tabindex");
                    return b ? parseInt(b, 10) : Cb.test(a.nodeName) || Db.test(a.nodeName) && a.href ? 0 : -1
                }
            }
        }, propFix: {for: "htmlFor", class: "className"}
    }), sa.optSelected || (ya.propHooks.selected = {
        get: function (a) {
            var b = a.parentNode;
            return b && b.parentNode && b.parentNode.selectedIndex, null
        }, set: function (a) {
            var b = a.parentNode;
            b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex)
        }
    }), ya.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
        ya.propFix[this.toLowerCase()] = this
    }), ya.fn.extend({
        addClass: function (a) {
            var b, c, d, e, f, g, h, i = 0;
            if (ta(a)) return this.each(function (b) {
                ya(this).addClass(a.call(this, b, _(this)))
            });
            if (b = aa(a), b.length) for (; c = this[i++];) if (e = _(c), d = 1 === c.nodeType && " " + $(e) + " ") {
                for (g = 0; f = b[g++];) d.indexOf(" " + f + " ") < 0 && (d += f + " ");
                h = $(d), e !== h && c.setAttribute("class", h)
            }
            return this
        }, removeClass: function (a) {
            var b, c, d, e, f, g, h, i = 0;
            if (ta(a)) return this.each(function (b) {
                ya(this).removeClass(a.call(this, b, _(this)))
            });
            if (!arguments.length) return this.attr("class", "");
            if (b = aa(a), b.length) for (; c = this[i++];) if (e = _(c), d = 1 === c.nodeType && " " + $(e) + " ") {
                for (g = 0; f = b[g++];) for (; d.indexOf(" " + f + " ") > -1;) d = d.replace(" " + f + " ", " ");
                h = $(d), e !== h && c.setAttribute("class", h)
            }
            return this
        }, toggleClass: function (a, b) {
            var c = typeof a, d = "string" === c || Array.isArray(a);
            return "boolean" == typeof b && d ? b ? this.addClass(a) : this.removeClass(a) : ta(a) ? this.each(function (c) {
                ya(this).toggleClass(a.call(this, c, _(this), b), b)
            }) : this.each(function () {
                var b, e, f, g;
                if (d) for (e = 0, f = ya(this), g = aa(a); b = g[e++];) f.hasClass(b) ? f.removeClass(b) : f.addClass(b); else void 0 !== a && "boolean" !== c || (b = _(this), b && Qa.set(this, "__className__", b), this.setAttribute && this.setAttribute("class", b || a === !1 ? "" : Qa.get(this, "__className__") || ""))
            })
        }, hasClass: function (a) {
            var b, c, d = 0;
            for (b = " " + a + " "; c = this[d++];) if (1 === c.nodeType && (" " + $(_(c)) + " ").indexOf(b) > -1) return !0;
            return !1
        }
    });
    var Eb = /\r/g;
    ya.fn.extend({
        val: function (a) {
            var b, c, d, e = this[0];
            {
                if (arguments.length) return d = ta(a), this.each(function (c) {
                    var e;
                    1 === this.nodeType && (e = d ? a.call(this, c, ya(this).val()) : a, null == e ? e = "" : "number" == typeof e ? e += "" : Array.isArray(e) && (e = ya.map(e, function (a) {
                        return null == a ? "" : a + ""
                    })), b = ya.valHooks[this.type] || ya.valHooks[this.nodeName.toLowerCase()], b && "set" in b && void 0 !== b.set(this, e, "value") || (this.value = e))
                });
                if (e) return b = ya.valHooks[e.type] || ya.valHooks[e.nodeName.toLowerCase()], b && "get" in b && void 0 !== (c = b.get(e, "value")) ? c : (c = e.value, "string" == typeof c ? c.replace(Eb, "") : null == c ? "" : c)
            }
        }
    }), ya.extend({
        valHooks: {
            option: {
                get: function (a) {
                    var b = ya.find.attr(a, "value");
                    return null != b ? b : $(ya.text(a))
                }
            }, select: {
                get: function (a) {
                    var b, c, d, e = a.options, g = a.selectedIndex, h = "select-one" === a.type, i = h ? null : [],
                        j = h ? g + 1 : e.length;
                    for (d = g < 0 ? j : h ? g : 0; d < j; d++) if (c = e[d], (c.selected || d === g) && !c.disabled && (!c.parentNode.disabled || !f(c.parentNode, "optgroup"))) {
                        if (b = ya(c).val(), h) return b;
                        i.push(b)
                    }
                    return i
                }, set: function (a, b) {
                    for (var c, d, e = a.options, f = ya.makeArray(b), g = e.length; g--;) d = e[g], (d.selected = ya.inArray(ya.valHooks.option.get(d), f) > -1) && (c = !0);
                    return c || (a.selectedIndex = -1), f
                }
            }
        }
    }), ya.each(["radio", "checkbox"], function () {
        ya.valHooks[this] = {
            set: function (a, b) {
                if (Array.isArray(b)) return a.checked = ya.inArray(ya(a).val(), b) > -1
            }
        }, sa.checkOn || (ya.valHooks[this].get = function (a) {
            return null === a.getAttribute("value") ? "on" : a.value
        })
    }), sa.focusin = "onfocusin" in a;
    var Fb = /^(?:focusinfocus|focusoutblur)$/, Gb = function (a) {
        a.stopPropagation()
    };
    ya.extend(ya.event, {
        trigger: function (b, c, d, e) {
            var f, g, h, i, j, k, l, m, n = [d || va], o = pa.call(b, "type") ? b.type : b,
                p = pa.call(b, "namespace") ? b.namespace.split(".") : [];
            if (g = m = h = d = d || va, 3 !== d.nodeType && 8 !== d.nodeType && !Fb.test(o + ya.event.triggered) && (o.indexOf(".") > -1 && (p = o.split("."), o = p.shift(), p.sort()), j = o.indexOf(":") < 0 && "on" + o, b = b[ya.expando] ? b : new ya.Event(o, "object" == typeof b && b), b.isTrigger = e ? 2 : 3, b.namespace = p.join("."), b.rnamespace = b.namespace ? new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, b.result = void 0, b.target || (b.target = d), c = null == c ? [b] : ya.makeArray(c, [b]), l = ya.event.special[o] || {}, e || !l.trigger || l.trigger.apply(d, c) !== !1)) {
                if (!e && !l.noBubble && !ua(d)) {
                    for (i = l.delegateType || o, Fb.test(i + o) || (g = g.parentNode); g; g = g.parentNode) n.push(g), h = g;
                    h === (d.ownerDocument || va) && n.push(h.defaultView || h.parentWindow || a)
                }
                for (f = 0; (g = n[f++]) && !b.isPropagationStopped();) m = g, b.type = f > 1 ? i : l.bindType || o, k = (Qa.get(g, "events") || Object.create(null))[b.type] && Qa.get(g, "handle"), k && k.apply(g, c), k = j && g[j], k && k.apply && Pa(g) && (b.result = k.apply(g, c), b.result === !1 && b.preventDefault());
                return b.type = o, e || b.isDefaultPrevented() || l._default && l._default.apply(n.pop(), c) !== !1 || !Pa(d) || j && ta(d[o]) && !ua(d) && (h = d[j], h && (d[j] = null), ya.event.triggered = o, b.isPropagationStopped() && m.addEventListener(o, Gb), d[o](), b.isPropagationStopped() && m.removeEventListener(o, Gb), ya.event.triggered = void 0, h && (d[j] = h)), b.result
            }
        }, simulate: function (a, b, c) {
            var d = ya.extend(new ya.Event, c, {type: a, isSimulated: !0});
            ya.event.trigger(d, null, b)
        }
    }), ya.fn.extend({
        trigger: function (a, b) {
            return this.each(function () {
                ya.event.trigger(a, b, this)
            })
        }, triggerHandler: function (a, b) {
            var c = this[0];
            if (c) return ya.event.trigger(a, b, c, !0)
        }
    }), sa.focusin || ya.each({focus: "focusin", blur: "focusout"}, function (a, b) {
        var c = function (a) {
            ya.event.simulate(b, a.target, ya.event.fix(a))
        };
        ya.event.special[b] = {
            setup: function () {
                var d = this.ownerDocument || this.document || this, e = Qa.access(d, b);
                e || d.addEventListener(a, c, !0), Qa.access(d, b, (e || 0) + 1)
            }, teardown: function () {
                var d = this.ownerDocument || this.document || this, e = Qa.access(d, b) - 1;
                e ? Qa.access(d, b, e) : (d.removeEventListener(a, c, !0), Qa.remove(d, b))
            }
        }
    });
    var Hb = a.location, Ib = {guid: Date.now()}, Jb = /\?/;
    ya.parseXML = function (b) {
        var c;
        if (!b || "string" != typeof b) return null;
        try {
            c = (new a.DOMParser).parseFromString(b, "text/xml")
        } catch (a) {
            c = void 0
        }
        return c && !c.getElementsByTagName("parsererror").length || ya.error("Invalid XML: " + b), c
    };
    var Kb = /\[\]$/, Lb = /\r?\n/g, Mb = /^(?:submit|button|image|reset|file)$/i,
        Nb = /^(?:input|select|textarea|keygen)/i;
    ya.param = function (a, b) {
        var c, d = [], e = function (a, b) {
            var c = ta(b) ? b() : b;
            d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(null == c ? "" : c)
        };
        if (null == a) return "";
        if (Array.isArray(a) || a.jquery && !ya.isPlainObject(a)) ya.each(a, function () {
            e(this.name, this.value)
        }); else for (c in a) ba(c, a[c], b, e);
        return d.join("&")
    }, ya.fn.extend({
        serialize: function () {
            return ya.param(this.serializeArray())
        }, serializeArray: function () {
            return this.map(function () {
                var a = ya.prop(this, "elements");
                return a ? ya.makeArray(a) : this
            }).filter(function () {
                var a = this.type;
                return this.name && !ya(this).is(":disabled") && Nb.test(this.nodeName) && !Mb.test(a) && (this.checked || !ab.test(a))
            }).map(function (a, b) {
                var c = ya(this).val();
                return null == c ? null : Array.isArray(c) ? ya.map(c, function (a) {
                    return {name: b.name, value: a.replace(Lb, "\r\n")}
                }) : {name: b.name, value: c.replace(Lb, "\r\n")}
            }).get()
        }
    });
    var Ob = /%20/g, Pb = /#.*$/, Qb = /([?&])_=[^&]*/, Rb = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Sb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, Tb = /^(?:GET|HEAD)$/, Ub = /^\/\//, Vb = {},
        Wb = {}, Xb = "*/".concat("*"), Yb = va.createElement("a");
    Yb.href = Hb.href, ya.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: Hb.href,
            type: "GET",
            isLocal: Sb.test(Hb.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Xb,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/},
            responseFields: {xml: "responseXML", text: "responseText", json: "responseJSON"},
            converters: {"* text": String, "text html": !0, "text json": JSON.parse, "text xml": ya.parseXML},
            flatOptions: {url: !0, context: !0}
        },
        ajaxSetup: function (a, b) {
            return b ? ea(ea(a, ya.ajaxSettings), b) : ea(ya.ajaxSettings, a)
        },
        ajaxPrefilter: ca(Vb),
        ajaxTransport: ca(Wb),
        ajax: function (b, c) {
            function d(b, c, d, h) {
                var j, m, n, u, v, w = c;
                k || (k = !0, i && a.clearTimeout(i), e = void 0, g = h || "", x.readyState = b > 0 ? 4 : 0, j = b >= 200 && b < 300 || 304 === b, d && (u = fa(o, x, d)), !j && ya.inArray("script", o.dataTypes) > -1 && (o.converters["text script"] = function () {
                }), u = ga(o, u, x, j), j ? (o.ifModified && (v = x.getResponseHeader("Last-Modified"), v && (ya.lastModified[f] = v), v = x.getResponseHeader("etag"), v && (ya.etag[f] = v)), 204 === b || "HEAD" === o.type ? w = "nocontent" : 304 === b ? w = "notmodified" : (w = u.state, m = u.data, n = u.error, j = !n)) : (n = w, !b && w || (w = "error", b < 0 && (b = 0))), x.status = b, x.statusText = (c || w) + "", j ? r.resolveWith(p, [m, w, x]) : r.rejectWith(p, [x, w, n]), x.statusCode(t), t = void 0, l && q.trigger(j ? "ajaxSuccess" : "ajaxError", [x, o, j ? m : n]), s.fireWith(p, [x, w]), l && (q.trigger("ajaxComplete", [x, o]), --ya.active || ya.event.trigger("ajaxStop")))
            }

            "object" == typeof b && (c = b, b = void 0), c = c || {};
            var e, f, g, h, i, j, k, l, m, n, o = ya.ajaxSetup({}, c), p = o.context || o,
                q = o.context && (p.nodeType || p.jquery) ? ya(p) : ya.event, r = ya.Deferred(),
                s = ya.Callbacks("once memory"), t = o.statusCode || {}, u = {}, v = {}, w = "canceled", x = {
                    readyState: 0, getResponseHeader: function (a) {
                        var b;
                        if (k) {
                            if (!h) for (h = {}; b = Rb.exec(g);) h[b[1].toLowerCase() + " "] = (h[b[1].toLowerCase() + " "] || []).concat(b[2]);
                            b = h[a.toLowerCase() + " "]
                        }
                        return null == b ? null : b.join(", ")
                    }, getAllResponseHeaders: function () {
                        return k ? g : null
                    }, setRequestHeader: function (a, b) {
                        return null == k && (a = v[a.toLowerCase()] = v[a.toLowerCase()] || a, u[a] = b), this
                    }, overrideMimeType: function (a) {
                        return null == k && (o.mimeType = a), this
                    }, statusCode: function (a) {
                        var b;
                        if (a) if (k) x.always(a[x.status]); else for (b in a) t[b] = [t[b], a[b]];
                        return this
                    }, abort: function (a) {
                        var b = a || w;
                        return e && e.abort(b), d(0, b), this
                    }
                };
            if (r.promise(x), o.url = ((b || o.url || Hb.href) + "").replace(Ub, Hb.protocol + "//"), o.type = c.method || c.type || o.method || o.type, o.dataTypes = (o.dataType || "*").toLowerCase().match(Ja) || [""], null == o.crossDomain) {
                j = va.createElement("a");
                try {
                    j.href = o.url, j.href = j.href, o.crossDomain = Yb.protocol + "//" + Yb.host != j.protocol + "//" + j.host
                } catch (a) {
                    o.crossDomain = !0
                }
            }
            if (o.data && o.processData && "string" != typeof o.data && (o.data = ya.param(o.data, o.traditional)), da(Vb, o, c, x), k) return x;
            l = ya.event && o.global, l && 0 === ya.active++ && ya.event.trigger("ajaxStart"), o.type = o.type.toUpperCase(), o.hasContent = !Tb.test(o.type), f = o.url.replace(Pb, ""), o.hasContent ? o.data && o.processData && 0 === (o.contentType || "").indexOf("application/x-www-form-urlencoded") && (o.data = o.data.replace(Ob, "+")) : (n = o.url.slice(f.length), o.data && (o.processData || "string" == typeof o.data) && (f += (Jb.test(f) ? "&" : "?") + o.data, delete o.data), o.cache === !1 && (f = f.replace(Qb, "$1"), n = (Jb.test(f) ? "&" : "?") + "_=" + Ib.guid++ + n), o.url = f + n), o.ifModified && (ya.lastModified[f] && x.setRequestHeader("If-Modified-Since", ya.lastModified[f]), ya.etag[f] && x.setRequestHeader("If-None-Match", ya.etag[f])), (o.data && o.hasContent && o.contentType !== !1 || c.contentType) && x.setRequestHeader("Content-Type", o.contentType), x.setRequestHeader("Accept", o.dataTypes[0] && o.accepts[o.dataTypes[0]] ? o.accepts[o.dataTypes[0]] + ("*" !== o.dataTypes[0] ? ", " + Xb + "; q=0.01" : "") : o.accepts["*"]);
            for (m in o.headers) x.setRequestHeader(m, o.headers[m]);
            if (o.beforeSend && (o.beforeSend.call(p, x, o) === !1 || k)) return x.abort();
            if (w = "abort", s.add(o.complete), x.done(o.success), x.fail(o.error), e = da(Wb, o, c, x)) {
                if (x.readyState = 1, l && q.trigger("ajaxSend", [x, o]), k) return x;
                o.async && o.timeout > 0 && (i = a.setTimeout(function () {
                    x.abort("timeout")
                }, o.timeout));
                try {
                    k = !1, e.send(u, d)
                } catch (a) {
                    if (k) throw a;
                    d(-1, a)
                }
            } else d(-1, "No Transport");
            return x
        },
        getJSON: function (a, b, c) {
            return ya.get(a, b, c, "json")
        },
        getScript: function (a, b) {
            return ya.get(a, void 0, b, "script")
        }
    }), ya.each(["get", "post"], function (a, b) {
        ya[b] = function (a, c, d, e) {
            return ta(c) && (e = e || d, d = c, c = void 0), ya.ajax(ya.extend({
                url: a,
                type: b,
                dataType: e,
                data: c,
                success: d
            }, ya.isPlainObject(a) && a))
        }
    }), ya.ajaxPrefilter(function (a) {
        var b;
        for (b in a.headers) "content-type" === b.toLowerCase() && (a.contentType = a.headers[b] || "")
    }), ya._evalUrl = function (a, b, c) {
        return ya.ajax({
            url: a,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            converters: {
                "text script": function () {
                }
            },
            dataFilter: function (a) {
                ya.globalEval(a, b, c)
            }
        })
    }, ya.fn.extend({
        wrapAll: function (a) {
            var b;
            return this[0] && (ta(a) && (a = a.call(this[0])), b = ya(a, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && b.insertBefore(this[0]), b.map(function () {
                for (var a = this; a.firstElementChild;) a = a.firstElementChild;
                return a
            }).append(this)), this
        }, wrapInner: function (a) {
            return ta(a) ? this.each(function (b) {
                ya(this).wrapInner(a.call(this, b))
            }) : this.each(function () {
                var b = ya(this), c = b.contents();
                c.length ? c.wrapAll(a) : b.append(a)
            })
        }, wrap: function (a) {
            var b = ta(a);
            return this.each(function (c) {
                ya(this).wrapAll(b ? a.call(this, c) : a)
            })
        }, unwrap: function (a) {
            return this.parent(a).not("body").each(function () {
                ya(this).replaceWith(this.childNodes)
            }), this
        }
    }), ya.expr.pseudos.hidden = function (a) {
        return !ya.expr.pseudos.visible(a)
    }, ya.expr.pseudos.visible = function (a) {
        return !!(a.offsetWidth || a.offsetHeight || a.getClientRects().length)
    }, ya.ajaxSettings.xhr = function () {
        try {
            return new a.XMLHttpRequest
        } catch (a) {
        }
    };
    var Zb = {0: 200, 1223: 204}, $b = ya.ajaxSettings.xhr();
    sa.cors = !!$b && "withCredentials" in $b, sa.ajax = $b = !!$b, ya.ajaxTransport(function (b) {
        var c, d;
        if (sa.cors || $b && !b.crossDomain) return {
            send: function (e, f) {
                var g, h = b.xhr();
                if (h.open(b.type, b.url, b.async, b.username, b.password), b.xhrFields) for (g in b.xhrFields) h[g] = b.xhrFields[g];
                b.mimeType && h.overrideMimeType && h.overrideMimeType(b.mimeType), b.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest");
                for (g in e) h.setRequestHeader(g, e[g]);
                c = function (a) {
                    return function () {
                        c && (c = d = h.onload = h.onerror = h.onabort = h.ontimeout = h.onreadystatechange = null, "abort" === a ? h.abort() : "error" === a ? "number" != typeof h.status ? f(0, "error") : f(h.status, h.statusText) : f(Zb[h.status] || h.status, h.statusText, "text" !== (h.responseType || "text") || "string" != typeof h.responseText ? {binary: h.response} : {text: h.responseText}, h.getAllResponseHeaders()))
                    }
                }, h.onload = c(), d = h.onerror = h.ontimeout = c("error"), void 0 !== h.onabort ? h.onabort = d : h.onreadystatechange = function () {
                    4 === h.readyState && a.setTimeout(function () {
                        c && d()
                    })
                }, c = c("abort");
                try {
                    h.send(b.hasContent && b.data || null)
                } catch (a) {
                    if (c) throw a
                }
            }, abort: function () {
                c && c()
            }
        }
    }), ya.ajaxPrefilter(function (a) {
        a.crossDomain && (a.contents.script = !1)
    }), ya.ajaxSetup({
        accepts: {script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},
        contents: {script: /\b(?:java|ecma)script\b/},
        converters: {
            "text script": function (a) {
                return ya.globalEval(a), a
            }
        }
    }), ya.ajaxPrefilter("script", function (a) {
        void 0 === a.cache && (a.cache = !1), a.crossDomain && (a.type = "GET")
    }), ya.ajaxTransport("script", function (a) {
        if (a.crossDomain || a.scriptAttrs) {
            var b, c;
            return {
                send: function (d, e) {
                    b = ya("<script>").attr(a.scriptAttrs || {}).prop({
                        charset: a.scriptCharset,
                        src: a.url
                    }).on("load error", c = function (a) {
                        b.remove(), c = null, a && e("error" === a.type ? 404 : 200, a.type)
                    }), va.head.appendChild(b[0])
                }, abort: function () {
                    c && c()
                }
            }
        }
    });
    var _b = [], ac = /(=)\?(?=&|$)|\?\?/;
    ya.ajaxSetup({
        jsonp: "callback", jsonpCallback: function () {
            var a = _b.pop() || ya.expando + "_" + Ib.guid++;
            return this[a] = !0, a
        }
    }), ya.ajaxPrefilter("json jsonp", function (b, c, d) {
        var e, f, g,
            h = b.jsonp !== !1 && (ac.test(b.url) ? "url" : "string" == typeof b.data && 0 === (b.contentType || "").indexOf("application/x-www-form-urlencoded") && ac.test(b.data) && "data");
        if (h || "jsonp" === b.dataTypes[0]) return e = b.jsonpCallback = ta(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback, h ? b[h] = b[h].replace(ac, "$1" + e) : b.jsonp !== !1 && (b.url += (Jb.test(b.url) ? "&" : "?") + b.jsonp + "=" + e), b.converters["script json"] = function () {
            return g || ya.error(e + " was not called"), g[0]
        }, b.dataTypes[0] = "json", f = a[e], a[e] = function () {
            g = arguments
        }, d.always(function () {
            void 0 === f ? ya(a).removeProp(e) : a[e] = f, b[e] && (b.jsonpCallback = c.jsonpCallback, _b.push(e)), g && ta(f) && f(g[0]), g = f = void 0
        }), "script"
    }), sa.createHTMLDocument = function () {
        var a = va.implementation.createHTMLDocument("").body;
        return a.innerHTML = "<form></form><form></form>", 2 === a.childNodes.length
    }(), ya.parseHTML = function (a, b, c) {
        if ("string" != typeof a) return [];
        "boolean" == typeof b && (c = b, b = !1);
        var d, e, f;
        return b || (sa.createHTMLDocument ? (b = va.implementation.createHTMLDocument(""), d = b.createElement("base"), d.href = va.location.href, b.head.appendChild(d)) : b = va), e = Da.exec(a), f = !c && [], e ? [b.createElement(e[1])] : (e = x([a], b, f), f && f.length && ya(f).remove(), ya.merge([], e.childNodes))
    }, ya.fn.load = function (a, b, c) {
        var d, e, f, g = this, h = a.indexOf(" ");
        return h > -1 && (d = $(a.slice(h)), a = a.slice(0, h)), ta(b) ? (c = b, b = void 0) : b && "object" == typeof b && (e = "POST"), g.length > 0 && ya.ajax({
            url: a,
            type: e || "GET",
            dataType: "html",
            data: b
        }).done(function (a) {
            f = arguments, g.html(d ? ya("<div>").append(ya.parseHTML(a)).find(d) : a)
        }).always(c && function (a, b) {
            g.each(function () {
                c.apply(this, f || [a.responseText, b, a])
            })
        }), this
    }, ya.expr.pseudos.animated = function (a) {
        return ya.grep(ya.timers, function (b) {
            return a === b.elem
        }).length
    }, ya.offset = {
        setOffset: function (a, b, c) {
            var d, e, f, g, h, i, j, k = ya.css(a, "position"), l = ya(a), m = {};
            "static" === k && (a.style.position = "relative"), h = l.offset(), f = ya.css(a, "top"), i = ya.css(a, "left"), j = ("absolute" === k || "fixed" === k) && (f + i).indexOf("auto") > -1, j ? (d = l.position(), g = d.top, e = d.left) : (g = parseFloat(f) || 0, e = parseFloat(i) || 0), ta(b) && (b = b.call(a, c, ya.extend({}, h))), null != b.top && (m.top = b.top - h.top + g), null != b.left && (m.left = b.left - h.left + e), "using" in b ? b.using.call(a, m) : ("number" == typeof m.top && (m.top += "px"), "number" == typeof m.left && (m.left += "px"), l.css(m))
        }
    }, ya.fn.extend({
        offset: function (a) {
            if (arguments.length) return void 0 === a ? this : this.each(function (b) {
                ya.offset.setOffset(this, a, b)
            });
            var b, c, d = this[0];
            if (d) return d.getClientRects().length ? (b = d.getBoundingClientRect(), c = d.ownerDocument.defaultView, {
                top: b.top + c.pageYOffset,
                left: b.left + c.pageXOffset
            }) : {top: 0, left: 0}
        }, position: function () {
            if (this[0]) {
                var a, b, c, d = this[0], e = {top: 0, left: 0};
                if ("fixed" === ya.css(d, "position")) b = d.getBoundingClientRect(); else {
                    for (b = this.offset(), c = d.ownerDocument, a = d.offsetParent || c.documentElement; a && (a === c.body || a === c.documentElement) && "static" === ya.css(a, "position");) a = a.parentNode;
                    a && a !== d && 1 === a.nodeType && (e = ya(a).offset(), e.top += ya.css(a, "borderTopWidth", !0), e.left += ya.css(a, "borderLeftWidth", !0))
                }
                return {
                    top: b.top - e.top - ya.css(d, "marginTop", !0),
                    left: b.left - e.left - ya.css(d, "marginLeft", !0)
                }
            }
        }, offsetParent: function () {
            return this.map(function () {
                for (var a = this.offsetParent; a && "static" === ya.css(a, "position");) a = a.offsetParent;
                return a || Xa
            })
        }
    }), ya.each({scrollLeft: "pageXOffset", scrollTop: "pageYOffset"}, function (a, b) {
        var c = "pageYOffset" === b;
        ya.fn[a] = function (d) {
            return Ma(this, function (a, d, e) {
                var f;
                return ua(a) ? f = a : 9 === a.nodeType && (f = a.defaultView), void 0 === e ? f ? f[b] : a[d] : void (f ? f.scrollTo(c ? f.pageXOffset : e, c ? e : f.pageYOffset) : a[d] = e)
            }, a, d, arguments.length)
        }
    }), ya.each(["top", "left"], function (a, b) {
        ya.cssHooks[b] = M(sa.pixelPosition, function (a, c) {
            if (c) return c = L(a, b), lb.test(c) ? ya(a).position()[b] + "px" : c
        })
    }), ya.each({Height: "height", Width: "width"}, function (a, b) {
        ya.each({padding: "inner" + a, content: b, "": "outer" + a}, function (c, d) {
            ya.fn[d] = function (e, f) {
                var g = arguments.length && (c || "boolean" != typeof e),
                    h = c || (e === !0 || f === !0 ? "margin" : "border");
                return Ma(this, function (b, c, e) {
                    var f;
                    return ua(b) ? 0 === d.indexOf("outer") ? b["inner" + a] : b.document.documentElement["client" + a] : 9 === b.nodeType ? (f = b.documentElement, Math.max(b.body["scroll" + a], f["scroll" + a], b.body["offset" + a], f["offset" + a], f["client" + a])) : void 0 === e ? ya.css(b, c, h) : ya.style(b, c, e, h)
                }, b, g ? e : void 0, g)
            }
        })
    }), ya.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (a, b) {
        ya.fn[b] = function (a) {
            return this.on(b, a)
        }
    }), ya.fn.extend({
        bind: function (a, b, c) {
            return this.on(a, null, b, c)
        }, unbind: function (a, b) {
            return this.off(a, null, b)
        }, delegate: function (a, b, c, d) {
            return this.on(b, a, c, d)
        }, undelegate: function (a, b, c) {
            return 1 === arguments.length ? this.off(a, "**") : this.off(b, a || "**", c)
        }, hover: function (a, b) {
            return this.mouseenter(a).mouseleave(b || a)
        }
    }), ya.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (a, b) {
        ya.fn[b] = function (a, c) {
            return arguments.length > 0 ? this.on(b, null, a, c) : this.trigger(b)
        }
    });
    var bc = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    ya.proxy = function (a, b) {
        var c, d, e;
        if ("string" == typeof b && (c = a[b], b = a, a = c), ta(a)) return d = ja.call(arguments, 2), e = function () {
            return a.apply(b || this, d.concat(ja.call(arguments)))
        }, e.guid = a.guid = a.guid || ya.guid++, e
    }, ya.holdReady = function (a) {
        a ? ya.readyWait++ : ya.ready(!0)
    }, ya.isArray = Array.isArray, ya.parseJSON = JSON.parse, ya.nodeName = f, ya.isFunction = ta, ya.isWindow = ua, ya.camelCase = o, ya.type = d, ya.now = Date.now, ya.isNumeric = function (a) {
        var b = ya.type(a);
        return ("number" === b || "string" === b) && !isNaN(a - parseFloat(a))
    }, ya.trim = function (a) {
        return null == a ? "" : (a + "").replace(bc, "")
    }, "function" == typeof define && define.amd && define("jquery", [], function () {
        return ya
    });
    var cc = a.jQuery, dc = a.$;
    return ya.noConflict = function (b) {
        return a.$ === ya && (a.$ = dc), b && a.jQuery === ya && (a.jQuery = cc), ya
    }, "undefined" == typeof b && (a.jQuery = a.$ = ya), ya
}), function () {
    var a = "object" == typeof self && self.self === self && self || "object" == typeof global && global.global === global && global || this || {},
        b = a._, c = Array.prototype, d = Object.prototype, e = "undefined" != typeof Symbol ? Symbol.prototype : null,
        f = c.push, g = c.slice, h = d.toString, i = d.hasOwnProperty, j = Array.isArray, k = Object.keys,
        l = Object.create, m = function () {
        }, n = function (a) {
            return a instanceof n ? a : this instanceof n ? void (this._wrapped = a) : new n(a)
        };
    "undefined" == typeof exports || exports.nodeType ? a._ = n : ("undefined" != typeof module && !module.nodeType && module.exports && (exports = module.exports = n), exports._ = n), n.VERSION = "1.9.1";
    var o, p = function (a, b, c) {
        if (void 0 === b) return a;
        switch (null == c ? 3 : c) {
            case 1:
                return function (c) {
                    return a.call(b, c)
                };
            case 3:
                return function (c, d, e) {
                    return a.call(b, c, d, e)
                };
            case 4:
                return function (c, d, e, f) {
                    return a.call(b, c, d, e, f)
                }
        }
        return function () {
            return a.apply(b, arguments)
        }
    }, q = function (a, b, c) {
        return n.iteratee !== o ? n.iteratee(a, b) : null == a ? n.identity : n.isFunction(a) ? p(a, b, c) : n.isObject(a) && !n.isArray(a) ? n.matcher(a) : n.property(a)
    };
    n.iteratee = o = function (a, b) {
        return q(a, b, 1 / 0)
    };
    var r = function (a, b) {
        return b = null == b ? a.length - 1 : +b, function () {
            for (var c = Math.max(arguments.length - b, 0), d = Array(c), e = 0; e < c; e++) d[e] = arguments[e + b];
            switch (b) {
                case 0:
                    return a.call(this, d);
                case 1:
                    return a.call(this, arguments[0], d);
                case 2:
                    return a.call(this, arguments[0], arguments[1], d)
            }
            var f = Array(b + 1);
            for (e = 0; e < b; e++) f[e] = arguments[e];
            return f[b] = d, a.apply(this, f)
        }
    }, s = function (a) {
        if (!n.isObject(a)) return {};
        if (l) return l(a);
        m.prototype = a;
        var b = new m;
        return m.prototype = null, b
    }, t = function (a) {
        return function (b) {
            return null == b ? void 0 : b[a]
        }
    }, u = function (a, b) {
        return null != a && i.call(a, b)
    }, v = function (a, b) {
        for (var c = b.length, d = 0; d < c; d++) {
            if (null == a) return;
            a = a[b[d]]
        }
        return c ? a : void 0
    }, w = Math.pow(2, 53) - 1, x = t("length"), y = function (a) {
        var b = x(a);
        return "number" == typeof b && b >= 0 && b <= w
    };
    n.each = n.forEach = function (a, b, c) {
        b = p(b, c);
        var d, e;
        if (y(a)) for (d = 0, e = a.length; d < e; d++) b(a[d], d, a); else {
            var f = n.keys(a);
            for (d = 0, e = f.length; d < e; d++) b(a[f[d]], f[d], a)
        }
        return a
    }, n.map = n.collect = function (a, b, c) {
        b = q(b, c);
        for (var d = !y(a) && n.keys(a), e = (d || a).length, f = Array(e), g = 0; g < e; g++) {
            var h = d ? d[g] : g;
            f[g] = b(a[h], h, a)
        }
        return f
    };
    var z = function (a) {
        var b = function (b, c, d, e) {
            var f = !y(b) && n.keys(b), g = (f || b).length, h = a > 0 ? 0 : g - 1;
            for (e || (d = b[f ? f[h] : h], h += a); h >= 0 && h < g; h += a) {
                var i = f ? f[h] : h;
                d = c(d, b[i], i, b)
            }
            return d
        };
        return function (a, c, d, e) {
            var f = arguments.length >= 3;
            return b(a, p(c, e, 4), d, f)
        }
    };
    n.reduce = n.foldl = n.inject = z(1), n.reduceRight = n.foldr = z(-1), n.find = n.detect = function (a, b, c) {
        var d = y(a) ? n.findIndex : n.findKey, e = d(a, b, c);
        if (void 0 !== e && e !== -1) return a[e]
    }, n.filter = n.select = function (a, b, c) {
        var d = [];
        return b = q(b, c), n.each(a, function (a, c, e) {
            b(a, c, e) && d.push(a)
        }), d
    }, n.reject = function (a, b, c) {
        return n.filter(a, n.negate(q(b)), c)
    }, n.every = n.all = function (a, b, c) {
        b = q(b, c);
        for (var d = !y(a) && n.keys(a), e = (d || a).length, f = 0; f < e; f++) {
            var g = d ? d[f] : f;
            if (!b(a[g], g, a)) return !1
        }
        return !0
    }, n.some = n.any = function (a, b, c) {
        b = q(b, c);
        for (var d = !y(a) && n.keys(a), e = (d || a).length, f = 0; f < e; f++) {
            var g = d ? d[f] : f;
            if (b(a[g], g, a)) return !0
        }
        return !1
    }, n.contains = n.includes = n.include = function (a, b, c, d) {
        return y(a) || (a = n.values(a)), ("number" != typeof c || d) && (c = 0), n.indexOf(a, b, c) >= 0
    }, n.invoke = r(function (a, b, c) {
        var d, e;
        return n.isFunction(b) ? e = b : n.isArray(b) && (d = b.slice(0, -1), b = b[b.length - 1]), n.map(a, function (a) {
            var f = e;
            if (!f) {
                if (d && d.length && (a = v(a, d)), null == a) return;
                f = a[b]
            }
            return null == f ? f : f.apply(a, c)
        })
    }), n.pluck = function (a, b) {
        return n.map(a, n.property(b))
    }, n.where = function (a, b) {
        return n.filter(a, n.matcher(b))
    }, n.findWhere = function (a, b) {
        return n.find(a, n.matcher(b))
    }, n.max = function (a, b, c) {
        var d, e, f = -(1 / 0), g = -(1 / 0);
        if (null == b || "number" == typeof b && "object" != typeof a[0] && null != a) {
            a = y(a) ? a : n.values(a);
            for (var h = 0, i = a.length; h < i; h++) d = a[h], null != d && d > f && (f = d)
        } else b = q(b, c), n.each(a, function (a, c, d) {
            e = b(a, c, d), (e > g || e === -(1 / 0) && f === -(1 / 0)) && (f = a, g = e)
        });
        return f
    }, n.min = function (a, b, c) {
        var d, e, f = 1 / 0, g = 1 / 0;
        if (null == b || "number" == typeof b && "object" != typeof a[0] && null != a) {
            a = y(a) ? a : n.values(a);
            for (var h = 0, i = a.length; h < i; h++) d = a[h], null != d && d < f && (f = d)
        } else b = q(b, c), n.each(a, function (a, c, d) {
            e = b(a, c, d), (e < g || e === 1 / 0 && f === 1 / 0) && (f = a, g = e)
        });
        return f
    }, n.shuffle = function (a) {
        return n.sample(a, 1 / 0)
    }, n.sample = function (a, b, c) {
        if (null == b || c) return y(a) || (a = n.values(a)), a[n.random(a.length - 1)];
        var d = y(a) ? n.clone(a) : n.values(a), e = x(d);
        b = Math.max(Math.min(b, e), 0);
        for (var f = e - 1, g = 0; g < b; g++) {
            var h = n.random(g, f), i = d[g];
            d[g] = d[h], d[h] = i
        }
        return d.slice(0, b)
    }, n.sortBy = function (a, b, c) {
        var d = 0;
        return b = q(b, c), n.pluck(n.map(a, function (a, c, e) {
            return {value: a, index: d++, criteria: b(a, c, e)}
        }).sort(function (a, b) {
            var c = a.criteria, d = b.criteria;
            if (c !== d) {
                if (c > d || void 0 === c) return 1;
                if (c < d || void 0 === d) return -1
            }
            return a.index - b.index
        }), "value")
    };
    var A = function (a, b) {
        return function (c, d, e) {
            var f = b ? [[], []] : {};
            return d = q(d, e), n.each(c, function (b, e) {
                var g = d(b, e, c);
                a(f, b, g)
            }), f
        }
    };
    n.groupBy = A(function (a, b, c) {
        u(a, c) ? a[c].push(b) : a[c] = [b]
    }), n.indexBy = A(function (a, b, c) {
        a[c] = b
    }), n.countBy = A(function (a, b, c) {
        u(a, c) ? a[c]++ : a[c] = 1
    });
    var B = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
    n.toArray = function (a) {
        return a ? n.isArray(a) ? g.call(a) : n.isString(a) ? a.match(B) : y(a) ? n.map(a, n.identity) : n.values(a) : []
    }, n.size = function (a) {
        return null == a ? 0 : y(a) ? a.length : n.keys(a).length
    }, n.partition = A(function (a, b, c) {
        a[c ? 0 : 1].push(b)
    }, !0), n.first = n.head = n.take = function (a, b, c) {
        return null == a || a.length < 1 ? null == b ? void 0 : [] : null == b || c ? a[0] : n.initial(a, a.length - b)
    }, n.initial = function (a, b, c) {
        return g.call(a, 0, Math.max(0, a.length - (null == b || c ? 1 : b)))
    }, n.last = function (a, b, c) {
        return null == a || a.length < 1 ? null == b ? void 0 : [] : null == b || c ? a[a.length - 1] : n.rest(a, Math.max(0, a.length - b))
    }, n.rest = n.tail = n.drop = function (a, b, c) {
        return g.call(a, null == b || c ? 1 : b)
    }, n.compact = function (a) {
        return n.filter(a, Boolean)
    };
    var C = function (a, b, c, d) {
        d = d || [];
        for (var e = d.length, f = 0, g = x(a); f < g; f++) {
            var h = a[f];
            if (y(h) && (n.isArray(h) || n.isArguments(h))) if (b) for (var i = 0, j = h.length; i < j;) d[e++] = h[i++]; else C(h, b, c, d), e = d.length; else c || (d[e++] = h)
        }
        return d
    };
    n.flatten = function (a, b) {
        return C(a, b, !1)
    }, n.without = r(function (a, b) {
        return n.difference(a, b)
    }), n.uniq = n.unique = function (a, b, c, d) {
        n.isBoolean(b) || (d = c, c = b, b = !1), null != c && (c = q(c, d));
        for (var e = [], f = [], g = 0, h = x(a); g < h; g++) {
            var i = a[g], j = c ? c(i, g, a) : i;
            b && !c ? (g && f === j || e.push(i), f = j) : c ? n.contains(f, j) || (f.push(j), e.push(i)) : n.contains(e, i) || e.push(i)
        }
        return e
    }, n.union = r(function (a) {
        return n.uniq(C(a, !0, !0))
    }), n.intersection = function (a) {
        for (var b = [], c = arguments.length, d = 0, e = x(a); d < e; d++) {
            var f = a[d];
            if (!n.contains(b, f)) {
                var g;
                for (g = 1; g < c && n.contains(arguments[g], f); g++) ;
                g === c && b.push(f)
            }
        }
        return b
    }, n.difference = r(function (a, b) {
        return b = C(b, !0, !0), n.filter(a, function (a) {
            return !n.contains(b, a)
        })
    }), n.unzip = function (a) {
        for (var b = a && n.max(a, x).length || 0, c = Array(b), d = 0; d < b; d++) c[d] = n.pluck(a, d);
        return c
    }, n.zip = r(n.unzip), n.object = function (a, b) {
        for (var c = {}, d = 0, e = x(a); d < e; d++) b ? c[a[d]] = b[d] : c[a[d][0]] = a[d][1];
        return c
    };
    var D = function (a) {
        return function (b, c, d) {
            c = q(c, d);
            for (var e = x(b), f = a > 0 ? 0 : e - 1; f >= 0 && f < e; f += a) if (c(b[f], f, b)) return f;
            return -1
        }
    };
    n.findIndex = D(1), n.findLastIndex = D(-1), n.sortedIndex = function (a, b, c, d) {
        c = q(c, d, 1);
        for (var e = c(b), f = 0, g = x(a); f < g;) {
            var h = Math.floor((f + g) / 2);
            c(a[h]) < e ? f = h + 1 : g = h
        }
        return f
    };
    var E = function (a, b, c) {
        return function (d, e, f) {
            var h = 0, i = x(d);
            if ("number" == typeof f) a > 0 ? h = f >= 0 ? f : Math.max(f + i, h) : i = f >= 0 ? Math.min(f + 1, i) : f + i + 1; else if (c && f && i) return f = c(d, e), d[f] === e ? f : -1;
            if (e !== e) return f = b(g.call(d, h, i), n.isNaN), f >= 0 ? f + h : -1;
            for (f = a > 0 ? h : i - 1; f >= 0 && f < i; f += a) if (d[f] === e) return f;
            return -1
        }
    };
    n.indexOf = E(1, n.findIndex, n.sortedIndex), n.lastIndexOf = E(-1, n.findLastIndex), n.range = function (a, b, c) {
        null == b && (b = a || 0, a = 0), c || (c = b < a ? -1 : 1);
        for (var d = Math.max(Math.ceil((b - a) / c), 0), e = Array(d), f = 0; f < d; f++, a += c) e[f] = a;
        return e
    }, n.chunk = function (a, b) {
        if (null == b || b < 1) return [];
        for (var c = [], d = 0, e = a.length; d < e;) c.push(g.call(a, d, d += b));
        return c
    };
    var F = function (a, b, c, d, e) {
        if (!(d instanceof b)) return a.apply(c, e);
        var f = s(a.prototype), g = a.apply(f, e);
        return n.isObject(g) ? g : f
    };
    n.bind = r(function (a, b, c) {
        if (!n.isFunction(a)) throw new TypeError("Bind must be called on a function");
        var d = r(function (e) {
            return F(a, d, b, this, c.concat(e))
        });
        return d
    }), n.partial = r(function (a, b) {
        var c = n.partial.placeholder, d = function () {
            for (var e = 0, f = b.length, g = Array(f), h = 0; h < f; h++) g[h] = b[h] === c ? arguments[e++] : b[h];
            for (; e < arguments.length;) g.push(arguments[e++]);
            return F(a, d, this, this, g)
        };
        return d
    }), n.partial.placeholder = n, n.bindAll = r(function (a, b) {
        b = C(b, !1, !1);
        var c = b.length;
        if (c < 1) throw new Error("bindAll must be passed function names");
        for (; c--;) {
            var d = b[c];
            a[d] = n.bind(a[d], a)
        }
    }), n.memoize = function (a, b) {
        var c = function (d) {
            var e = c.cache, f = "" + (b ? b.apply(this, arguments) : d);
            return u(e, f) || (e[f] = a.apply(this, arguments)), e[f]
        };
        return c.cache = {}, c
    }, n.delay = r(function (a, b, c) {
        return setTimeout(function () {
            return a.apply(null, c)
        }, b)
    }), n.defer = n.partial(n.delay, n, 1), n.throttle = function (a, b, c) {
        var d, e, f, g, h = 0;
        c || (c = {});
        var i = function () {
            h = c.leading === !1 ? 0 : n.now(), d = null, g = a.apply(e, f), d || (e = f = null)
        }, j = function () {
            var j = n.now();
            h || c.leading !== !1 || (h = j);
            var k = b - (j - h);
            return e = this, f = arguments, k <= 0 || k > b ? (d && (clearTimeout(d), d = null), h = j, g = a.apply(e, f), d || (e = f = null)) : d || c.trailing === !1 || (d = setTimeout(i, k)), g
        };
        return j.cancel = function () {
            clearTimeout(d), h = 0, d = e = f = null
        }, j
    }, n.debounce = function (a, b, c) {
        var d, e, f = function (b, c) {
            d = null, c && (e = a.apply(b, c))
        }, g = r(function (g) {
            if (d && clearTimeout(d), c) {
                var h = !d;
                d = setTimeout(f, b), h && (e = a.apply(this, g))
            } else d = n.delay(f, b, this, g);
            return e
        });
        return g.cancel = function () {
            clearTimeout(d), d = null
        }, g
    }, n.wrap = function (a, b) {
        return n.partial(b, a)
    }, n.negate = function (a) {
        return function () {
            return !a.apply(this, arguments)
        }
    }, n.compose = function () {
        var a = arguments, b = a.length - 1;
        return function () {
            for (var c = b, d = a[b].apply(this, arguments); c--;) d = a[c].call(this, d);
            return d
        }
    }, n.after = function (a, b) {
        return function () {
            if (--a < 1) return b.apply(this, arguments)
        }
    }, n.before = function (a, b) {
        var c;
        return function () {
            return --a > 0 && (c = b.apply(this, arguments)), a <= 1 && (b = null), c
        }
    }, n.once = n.partial(n.before, 2), n.restArguments = r;
    var G = !{toString: null}.propertyIsEnumerable("toString"),
        H = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
        I = function (a, b) {
            var c = H.length, e = a.constructor, f = n.isFunction(e) && e.prototype || d, g = "constructor";
            for (u(a, g) && !n.contains(b, g) && b.push(g); c--;) g = H[c], g in a && a[g] !== f[g] && !n.contains(b, g) && b.push(g)
        };
    n.keys = function (a) {
        if (!n.isObject(a)) return [];
        if (k) return k(a);
        var b = [];
        for (var c in a) u(a, c) && b.push(c);
        return G && I(a, b), b
    }, n.allKeys = function (a) {
        if (!n.isObject(a)) return [];
        var b = [];
        for (var c in a) b.push(c);
        return G && I(a, b), b
    }, n.values = function (a) {
        for (var b = n.keys(a), c = b.length, d = Array(c), e = 0; e < c; e++) d[e] = a[b[e]];
        return d
    }, n.mapObject = function (a, b, c) {
        b = q(b, c);
        for (var d = n.keys(a), e = d.length, f = {}, g = 0; g < e; g++) {
            var h = d[g];
            f[h] = b(a[h], h, a)
        }
        return f
    }, n.pairs = function (a) {
        for (var b = n.keys(a), c = b.length, d = Array(c), e = 0; e < c; e++) d[e] = [b[e], a[b[e]]];
        return d
    }, n.invert = function (a) {
        for (var b = {}, c = n.keys(a), d = 0, e = c.length; d < e; d++) b[a[c[d]]] = c[d];
        return b
    }, n.functions = n.methods = function (a) {
        var b = [];
        for (var c in a) n.isFunction(a[c]) && b.push(c);
        return b.sort()
    };
    var J = function (a, b) {
        return function (c) {
            var d = arguments.length;
            if (b && (c = Object(c)), d < 2 || null == c) return c;
            for (var e = 1; e < d; e++) for (var f = arguments[e], g = a(f), h = g.length, i = 0; i < h; i++) {
                var j = g[i];
                b && void 0 !== c[j] || (c[j] = f[j])
            }
            return c
        }
    };
    n.extend = J(n.allKeys), n.extendOwn = n.assign = J(n.keys), n.findKey = function (a, b, c) {
        b = q(b, c);
        for (var d, e = n.keys(a), f = 0, g = e.length; f < g; f++) if (d = e[f], b(a[d], d, a)) return d
    };
    var K = function (a, b, c) {
        return b in c
    };
    n.pick = r(function (a, b) {
        var c = {}, d = b[0];
        if (null == a) return c;
        n.isFunction(d) ? (b.length > 1 && (d = p(d, b[1])), b = n.allKeys(a)) : (d = K, b = C(b, !1, !1), a = Object(a));
        for (var e = 0, f = b.length; e < f; e++) {
            var g = b[e], h = a[g];
            d(h, g, a) && (c[g] = h)
        }
        return c
    }), n.omit = r(function (a, b) {
        var c, d = b[0];
        return n.isFunction(d) ? (d = n.negate(d), b.length > 1 && (c = b[1])) : (b = n.map(C(b, !1, !1), String), d = function (a, c) {
            return !n.contains(b, c)
        }), n.pick(a, d, c)
    }), n.defaults = J(n.allKeys, !0), n.create = function (a, b) {
        var c = s(a);
        return b && n.extendOwn(c, b), c
    }, n.clone = function (a) {
        return n.isObject(a) ? n.isArray(a) ? a.slice() : n.extend({}, a) : a
    }, n.tap = function (a, b) {
        return b(a), a
    }, n.isMatch = function (a, b) {
        var c = n.keys(b), d = c.length;
        if (null == a) return !d;
        for (var e = Object(a), f = 0; f < d; f++) {
            var g = c[f];
            if (b[g] !== e[g] || !(g in e)) return !1
        }
        return !0
    };
    var L, M;
    L = function (a, b, c, d) {
        if (a === b) return 0 !== a || 1 / a === 1 / b;
        if (null == a || null == b) return !1;
        if (a !== a) return b !== b;
        var e = typeof a;
        return ("function" === e || "object" === e || "object" == typeof b) && M(a, b, c, d)
    }, M = function (a, b, c, d) {
        a instanceof n && (a = a._wrapped), b instanceof n && (b = b._wrapped);
        var f = h.call(a);
        if (f !== h.call(b)) return !1;
        switch (f) {
            case"[object RegExp]":
            case"[object String]":
                return "" + a == "" + b;
            case"[object Number]":
                return +a !== +a ? +b !== +b : 0 === +a ? 1 / +a === 1 / b : +a === +b;
            case"[object Date]":
            case"[object Boolean]":
                return +a === +b;
            case"[object Symbol]":
                return e.valueOf.call(a) === e.valueOf.call(b)
        }
        var g = "[object Array]" === f;
        if (!g) {
            if ("object" != typeof a || "object" != typeof b) return !1;
            var i = a.constructor, j = b.constructor;
            if (i !== j && !(n.isFunction(i) && i instanceof i && n.isFunction(j) && j instanceof j) && "constructor" in a && "constructor" in b) return !1
        }
        c = c || [], d = d || [];
        for (var k = c.length; k--;) if (c[k] === a) return d[k] === b;
        if (c.push(a), d.push(b), g) {
            if (k = a.length, k !== b.length) return !1;
            for (; k--;) if (!L(a[k], b[k], c, d)) return !1
        } else {
            var l, m = n.keys(a);
            if (k = m.length, n.keys(b).length !== k) return !1;
            for (; k--;) if (l = m[k], !u(b, l) || !L(a[l], b[l], c, d)) return !1
        }
        return c.pop(), d.pop(), !0
    }, n.isEqual = function (a, b) {
        return L(a, b)
    }, n.isEmpty = function (a) {
        return null == a || (y(a) && (n.isArray(a) || n.isString(a) || n.isArguments(a)) ? 0 === a.length : 0 === n.keys(a).length)
    }, n.isElement = function (a) {
        return !(!a || 1 !== a.nodeType)
    }, n.isArray = j || function (a) {
        return "[object Array]" === h.call(a)
    }, n.isObject = function (a) {
        var b = typeof a;
        return "function" === b || "object" === b && !!a
    }, n.each(["Arguments", "Function", "String", "Number", "Date", "RegExp", "Error", "Symbol", "Map", "WeakMap", "Set", "WeakSet"], function (a) {
        n["is" + a] = function (b) {
            return h.call(b) === "[object " + a + "]"
        }
    }), n.isArguments(arguments) || (n.isArguments = function (a) {
        return u(a, "callee")
    });
    var N = a.document && a.document.childNodes;
    "function" != typeof /./ && "object" != typeof Int8Array && "function" != typeof N && (n.isFunction = function (a) {
        return "function" == typeof a || !1
    }), n.isFinite = function (a) {
        return !n.isSymbol(a) && isFinite(a) && !isNaN(parseFloat(a))
    }, n.isNaN = function (a) {
        return n.isNumber(a) && isNaN(a)
    }, n.isBoolean = function (a) {
        return a === !0 || a === !1 || "[object Boolean]" === h.call(a)
    }, n.isNull = function (a) {
        return null === a
    }, n.isUndefined = function (a) {
        return void 0 === a
    }, n.has = function (a, b) {
        if (!n.isArray(b)) return u(a, b);
        for (var c = b.length, d = 0; d < c; d++) {
            var e = b[d];
            if (null == a || !i.call(a, e)) return !1;
            a = a[e]
        }
        return !!c
    }, n.noConflict = function () {
        return a._ = b, this
    }, n.identity = function (a) {
        return a
    }, n.constant = function (a) {
        return function () {
            return a
        }
    }, n.noop = function () {
    }, n.property = function (a) {
        return n.isArray(a) ? function (b) {
            return v(b, a)
        } : t(a)
    }, n.propertyOf = function (a) {
        return null == a ? function () {
        } : function (b) {
            return n.isArray(b) ? v(a, b) : a[b]
        }
    }, n.matcher = n.matches = function (a) {
        return a = n.extendOwn({}, a), function (b) {
            return n.isMatch(b, a)
        }
    }, n.times = function (a, b, c) {
        var d = Array(Math.max(0, a));
        b = p(b, c, 1);
        for (var e = 0; e < a; e++) d[e] = b(e);
        return d
    }, n.random = function (a, b) {
        return null == b && (b = a, a = 0), a + Math.floor(Math.random() * (b - a + 1))
    }, n.now = Date.now || function () {
        return (new Date).getTime()
    };
    var O = {"&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;"}, P = n.invert(O),
        Q = function (a) {
            var b = function (b) {
                return a[b]
            }, c = "(?:" + n.keys(a).join("|") + ")", d = RegExp(c), e = RegExp(c, "g");
            return function (a) {
                return a = null == a ? "" : "" + a, d.test(a) ? a.replace(e, b) : a
            }
        };
    n.escape = Q(O), n.unescape = Q(P), n.result = function (a, b, c) {
        n.isArray(b) || (b = [b]);
        var d = b.length;
        if (!d) return n.isFunction(c) ? c.call(a) : c;
        for (var e = 0; e < d; e++) {
            var f = null == a ? void 0 : a[b[e]];
            void 0 === f && (f = c, e = d), a = n.isFunction(f) ? f.call(a) : f
        }
        return a
    };
    var R = 0;
    n.uniqueId = function (a) {
        var b = ++R + "";
        return a ? a + b : b
    }, n.templateSettings = {evaluate: /<%([\s\S]+?)%>/g, interpolate: /<%=([\s\S]+?)%>/g, escape: /<%-([\s\S]+?)%>/g};
    var S = /(.)^/, T = {"'": "'", "\\": "\\", "\r": "r", "\n": "n", "\u2028": "u2028", "\u2029": "u2029"},
        U = /\\|'|\r|\n|\u2028|\u2029/g, V = function (a) {
            return "\\" + T[a]
        };
    n.template = function (a, b, c) {
        !b && c && (b = c), b = n.defaults({}, b, n.templateSettings);
        var d = RegExp([(b.escape || S).source, (b.interpolate || S).source, (b.evaluate || S).source].join("|") + "|$", "g"),
            e = 0, f = "__p+='";
        a.replace(d, function (b, c, d, g, h) {
            return f += a.slice(e, h).replace(U, V), e = h + b.length, c ? f += "'+\n((__t=(" + c + "))==null?'':_.escape(__t))+\n'" : d ? f += "'+\n((__t=(" + d + "))==null?'':__t)+\n'" : g && (f += "';\n" + g + "\n__p+='"), b
        }), f += "';\n", b.variable || (f = "with(obj||{}){\n" + f + "}\n"), f = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + f + "return __p;\n";
        var g;
        try {
            g = new Function(b.variable || "obj", "_", f)
        } catch (a) {
            throw a.source = f, a
        }
        var h = function (a) {
            return g.call(this, a, n)
        }, i = b.variable || "obj";
        return h.source = "function(" + i + "){\n" + f + "}", h
    }, n.chain = function (a) {
        var b = n(a);
        return b._chain = !0, b
    };
    var W = function (a, b) {
        return a._chain ? n(b).chain() : b
    };
    n.mixin = function (a) {
        return n.each(n.functions(a), function (b) {
            var c = n[b] = a[b];
            n.prototype[b] = function () {
                var a = [this._wrapped];
                return f.apply(a, arguments), W(this, c.apply(n, a))
            }
        }), n
    }, n.mixin(n), n.each(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (a) {
        var b = c[a];
        n.prototype[a] = function () {
            var c = this._wrapped;
            return b.apply(c, arguments), "shift" !== a && "splice" !== a || 0 !== c.length || delete c[0], W(this, c)
        }
    }), n.each(["concat", "join", "slice"], function (a) {
        var b = c[a];
        n.prototype[a] = function () {
            return W(this, b.apply(this._wrapped, arguments))
        }
    }), n.prototype.value = function () {
        return this._wrapped
    }, n.prototype.valueOf = n.prototype.toJSON = n.prototype.value, n.prototype.toString = function () {
        return String(this._wrapped)
    }, "function" == typeof define && define.amd && define("underscore", [], function () {
        return n
    })
}(), define("underscore-noconflict", ["underscore"], function (a) {
    "use strict";
    return a.noConflict()
}), function (a) {
    var b = "object" == typeof self && self.self === self && self || "object" == typeof global && global.global === global && global;
    if ("function" == typeof define && define.amd) define("backbone", ["underscore", "jquery", "exports"], function (c, d, e) {
        b.Backbone = a(b, e, c, d)
    }); else if ("undefined" != typeof exports) {
        var c, d = require("underscore");
        try {
            c = require("jquery")
        } catch (a) {
        }
        a(b, exports, d, c)
    } else b.Backbone = a(b, {}, b._, b.jQuery || b.Zepto || b.ender || b.$)
}(function (a, b, c, d) {
    var e = a.Backbone, f = Array.prototype.slice;
    b.VERSION = "1.4.0", b.$ = d, b.noConflict = function () {
        return a.Backbone = e, this
    }, b.emulateHTTP = !1, b.emulateJSON = !1;
    var g, h = b.Events = {}, i = /\s+/, j = function (a, b, d, e, f) {
        var g, h = 0;
        if (d && "object" == typeof d) {
            void 0 !== e && "context" in f && void 0 === f.context && (f.context = e);
            for (g = c.keys(d); h < g.length; h++) b = j(a, b, g[h], d[g[h]], f)
        } else if (d && i.test(d)) for (g = d.split(i); h < g.length; h++) b = a(b, g[h], e, f); else b = a(b, d, e, f);
        return b
    };
    h.on = function (a, b, c) {
        if (this._events = j(k, this._events || {}, a, b, {context: c, ctx: this, listening: g}), g) {
            var d = this._listeners || (this._listeners = {});
            d[g.id] = g, g.interop = !1
        }
        return this
    }, h.listenTo = function (a, b, d) {
        if (!a) return this;
        var e = a._listenId || (a._listenId = c.uniqueId("l")), f = this._listeningTo || (this._listeningTo = {}),
            h = g = f[e];
        h || (this._listenId || (this._listenId = c.uniqueId("l")), h = g = f[e] = new q(this, a));
        var i = l(a, b, d, this);
        if (g = void 0, i) throw i;
        return h.interop && h.on(b, d), this
    };
    var k = function (a, b, c, d) {
        if (c) {
            var e = a[b] || (a[b] = []), f = d.context, g = d.ctx, h = d.listening;
            h && h.count++, e.push({callback: c, context: f, ctx: f || g, listening: h})
        }
        return a
    }, l = function (a, b, c, d) {
        try {
            a.on(b, c, d)
        } catch (a) {
            return a
        }
    };
    h.off = function (a, b, c) {
        return this._events ? (this._events = j(m, this._events, a, b, {
            context: c,
            listeners: this._listeners
        }), this) : this
    }, h.stopListening = function (a, b, d) {
        var e = this._listeningTo;
        if (!e) return this;
        for (var f = a ? [a._listenId] : c.keys(e), g = 0; g < f.length; g++) {
            var h = e[f[g]];
            if (!h) break;
            h.obj.off(b, d, this), h.interop && h.off(b, d)
        }
        return c.isEmpty(e) && (this._listeningTo = void 0), this
    };
    var m = function (a, b, d, e) {
        if (a) {
            var f, g = e.context, h = e.listeners, i = 0;
            if (b || g || d) {
                for (f = b ? [b] : c.keys(a); i < f.length; i++) {
                    b = f[i];
                    var j = a[b];
                    if (!j) break;
                    for (var k = [], l = 0; l < j.length; l++) {
                        var m = j[l];
                        if (d && d !== m.callback && d !== m.callback._callback || g && g !== m.context) k.push(m); else {
                            var n = m.listening;
                            n && n.off(b, d)
                        }
                    }
                    k.length ? a[b] = k : delete a[b]
                }
                return a
            }
            for (f = c.keys(h); i < f.length; i++) h[f[i]].cleanup()
        }
    };
    h.once = function (a, b, c) {
        var d = j(n, {}, a, b, this.off.bind(this));
        return "string" == typeof a && null == c && (b = void 0), this.on(d, b, c)
    }, h.listenToOnce = function (a, b, c) {
        var d = j(n, {}, b, c, this.stopListening.bind(this, a));
        return this.listenTo(a, d)
    };
    var n = function (a, b, d, e) {
        if (d) {
            var f = a[b] = c.once(function () {
                e(b, f), d.apply(this, arguments)
            });
            f._callback = d
        }
        return a
    };
    h.trigger = function (a) {
        if (!this._events) return this;
        for (var b = Math.max(0, arguments.length - 1), c = Array(b), d = 0; d < b; d++) c[d] = arguments[d + 1];
        return j(o, this._events, a, void 0, c), this
    };
    var o = function (a, b, c, d) {
        if (a) {
            var e = a[b], f = a.all;
            e && f && (f = f.slice()), e && p(e, d), f && p(f, [b].concat(d))
        }
        return a
    }, p = function (a, b) {
        var c, d = -1, e = a.length, f = b[0], g = b[1], h = b[2];
        switch (b.length) {
            case 0:
                for (; ++d < e;) (c = a[d]).callback.call(c.ctx);
                return;
            case 1:
                for (; ++d < e;) (c = a[d]).callback.call(c.ctx, f);
                return;
            case 2:
                for (; ++d < e;) (c = a[d]).callback.call(c.ctx, f, g);
                return;
            case 3:
                for (; ++d < e;) (c = a[d]).callback.call(c.ctx, f, g, h);
                return;
            default:
                for (; ++d < e;) (c = a[d]).callback.apply(c.ctx, b);
                return
        }
    }, q = function (a, b) {
        this.id = a._listenId, this.listener = a, this.obj = b, this.interop = !0, this.count = 0, this._events = void 0
    };
    q.prototype.on = h.on, q.prototype.off = function (a, b) {
        var c;
        this.interop ? (this._events = j(m, this._events, a, b, {
            context: void 0,
            listeners: void 0
        }), c = !this._events) : (this.count--, c = 0 === this.count), c && this.cleanup()
    }, q.prototype.cleanup = function () {
        delete this.listener._listeningTo[this.obj._listenId], this.interop || delete this.obj._listeners[this.id]
    }, h.bind = h.on, h.unbind = h.off, c.extend(b, h);
    var r = b.Model = function (a, b) {
        var d = a || {};
        b || (b = {}), this.preinitialize.apply(this, arguments), this.cid = c.uniqueId(this.cidPrefix), this.attributes = {}, b.collection && (this.collection = b.collection), b.parse && (d = this.parse(d, b) || {});
        var e = c.result(this, "defaults");
        d = c.defaults(c.extend({}, e, d), e), this.set(d, b), this.changed = {}, this.initialize.apply(this, arguments)
    };
    c.extend(r.prototype, h, {
        changed: null, validationError: null, idAttribute: "id", cidPrefix: "c", preinitialize: function () {
        }, initialize: function () {
        }, toJSON: function (a) {
            return c.clone(this.attributes)
        }, sync: function () {
            return b.sync.apply(this, arguments)
        }, get: function (a) {
            return this.attributes[a]
        }, escape: function (a) {
            return c.escape(this.get(a))
        }, has: function (a) {
            return null != this.get(a)
        }, matches: function (a) {
            return !!c.iteratee(a, this)(this.attributes)
        }, set: function (a, b, d) {
            if (null == a) return this;
            var e;
            if ("object" == typeof a ? (e = a, d = b) : (e = {})[a] = b, d || (d = {}), !this._validate(e, d)) return !1;
            var f = d.unset, g = d.silent, h = [], i = this._changing;
            this._changing = !0, i || (this._previousAttributes = c.clone(this.attributes), this.changed = {});
            var j = this.attributes, k = this.changed, l = this._previousAttributes;
            for (var m in e) b = e[m], c.isEqual(j[m], b) || h.push(m), c.isEqual(l[m], b) ? delete k[m] : k[m] = b, f ? delete j[m] : j[m] = b;
            if (this.idAttribute in e && (this.id = this.get(this.idAttribute)), !g) {
                h.length && (this._pending = d);
                for (var n = 0; n < h.length; n++) this.trigger("change:" + h[n], this, j[h[n]], d)
            }
            if (i) return this;
            if (!g) for (; this._pending;) d = this._pending, this._pending = !1, this.trigger("change", this, d);
            return this._pending = !1, this._changing = !1, this
        }, unset: function (a, b) {
            return this.set(a, void 0, c.extend({}, b, {unset: !0}))
        }, clear: function (a) {
            var b = {};
            for (var d in this.attributes) b[d] = void 0;
            return this.set(b, c.extend({}, a, {unset: !0}))
        }, hasChanged: function (a) {
            return null == a ? !c.isEmpty(this.changed) : c.has(this.changed, a)
        }, changedAttributes: function (a) {
            if (!a) return !!this.hasChanged() && c.clone(this.changed);
            var b, d = this._changing ? this._previousAttributes : this.attributes, e = {};
            for (var f in a) {
                var g = a[f];
                c.isEqual(d[f], g) || (e[f] = g, b = !0)
            }
            return !!b && e
        }, previous: function (a) {
            return null != a && this._previousAttributes ? this._previousAttributes[a] : null
        }, previousAttributes: function () {
            return c.clone(this._previousAttributes)
        }, fetch: function (a) {
            a = c.extend({parse: !0}, a);
            var b = this, d = a.success;
            return a.success = function (c) {
                var e = a.parse ? b.parse(c, a) : c;
                return !!b.set(e, a) && (d && d.call(a.context, b, c, a), void b.trigger("sync", b, c, a))
            }, W(this, a), this.sync("read", this, a)
        }, save: function (a, b, d) {
            var e;
            null == a || "object" == typeof a ? (e = a, d = b) : (e = {})[a] = b, d = c.extend({
                validate: !0,
                parse: !0
            }, d);
            var f = d.wait;
            if (e && !f) {
                if (!this.set(e, d)) return !1
            } else if (!this._validate(e, d)) return !1;
            var g = this, h = d.success, i = this.attributes;
            d.success = function (a) {
                g.attributes = i;
                var b = d.parse ? g.parse(a, d) : a;
                return f && (b = c.extend({}, e, b)), !(b && !g.set(b, d)) && (h && h.call(d.context, g, a, d), void g.trigger("sync", g, a, d))
            }, W(this, d), e && f && (this.attributes = c.extend({}, i, e));
            var j = this.isNew() ? "create" : d.patch ? "patch" : "update";
            "patch" !== j || d.attrs || (d.attrs = e);
            var k = this.sync(j, this, d);
            return this.attributes = i, k
        }, destroy: function (a) {
            a = a ? c.clone(a) : {};
            var b = this, d = a.success, e = a.wait, f = function () {
                b.stopListening(), b.trigger("destroy", b, b.collection, a)
            };
            a.success = function (c) {
                e && f(), d && d.call(a.context, b, c, a), b.isNew() || b.trigger("sync", b, c, a)
            };
            var g = !1;
            return this.isNew() ? c.defer(a.success) : (W(this, a), g = this.sync("delete", this, a)), e || f(), g
        }, url: function () {
            var a = c.result(this, "urlRoot") || c.result(this.collection, "url") || V();
            if (this.isNew()) return a;
            var b = this.get(this.idAttribute);
            return a.replace(/[^\/]$/, "$&/") + encodeURIComponent(b)
        }, parse: function (a, b) {
            return a
        }, clone: function () {
            return new this.constructor(this.attributes)
        }, isNew: function () {
            return !this.has(this.idAttribute)
        }, isValid: function (a) {
            return this._validate({}, c.extend({}, a, {validate: !0}))
        }, _validate: function (a, b) {
            if (!b.validate || !this.validate) return !0;
            a = c.extend({}, this.attributes, a);
            var d = this.validationError = this.validate(a, b) || null;
            return !d || (this.trigger("invalid", this, d, c.extend(b, {validationError: d})), !1)
        }
    });
    var s = b.Collection = function (a, b) {
        b || (b = {}), this.preinitialize.apply(this, arguments), b.model && (this.model = b.model), void 0 !== b.comparator && (this.comparator = b.comparator), this._reset(), this.initialize.apply(this, arguments), a && this.reset(a, c.extend({silent: !0}, b))
    }, t = {add: !0, remove: !0, merge: !0}, u = {add: !0, remove: !1}, v = function (a, b, c) {
        c = Math.min(Math.max(c, 0), a.length);
        var d, e = Array(a.length - c), f = b.length;
        for (d = 0; d < e.length; d++) e[d] = a[d + c];
        for (d = 0; d < f; d++) a[d + c] = b[d];
        for (d = 0; d < e.length; d++) a[d + f + c] = e[d]
    };
    c.extend(s.prototype, h, {
        model: r, preinitialize: function () {
        }, initialize: function () {
        }, toJSON: function (a) {
            return this.map(function (b) {
                return b.toJSON(a)
            })
        }, sync: function () {
            return b.sync.apply(this, arguments)
        }, add: function (a, b) {
            return this.set(a, c.extend({merge: !1}, b, u))
        }, remove: function (a, b) {
            b = c.extend({}, b);
            var d = !c.isArray(a);
            a = d ? [a] : a.slice();
            var e = this._removeModels(a, b);
            return !b.silent && e.length && (b.changes = {
                added: [],
                merged: [],
                removed: e
            }, this.trigger("update", this, b)), d ? e[0] : e
        }, set: function (a, b) {
            if (null != a) {
                b = c.extend({}, t, b), b.parse && !this._isModel(a) && (a = this.parse(a, b) || []);
                var d = !c.isArray(a);
                a = d ? [a] : a.slice();
                var e = b.at;
                null != e && (e = +e), e > this.length && (e = this.length), e < 0 && (e += this.length + 1);
                var f, g, h = [], i = [], j = [], k = [], l = {}, m = b.add, n = b.merge, o = b.remove, p = !1,
                    q = this.comparator && null == e && b.sort !== !1,
                    r = c.isString(this.comparator) ? this.comparator : null;
                for (g = 0; g < a.length; g++) {
                    f = a[g];
                    var s = this.get(f);
                    if (s) {
                        if (n && f !== s) {
                            var u = this._isModel(f) ? f.attributes : f;
                            b.parse && (u = s.parse(u, b)), s.set(u, b), j.push(s), q && !p && (p = s.hasChanged(r))
                        }
                        l[s.cid] || (l[s.cid] = !0, h.push(s)), a[g] = s
                    } else m && (f = a[g] = this._prepareModel(f, b), f && (i.push(f), this._addReference(f, b), l[f.cid] = !0, h.push(f)))
                }
                if (o) {
                    for (g = 0; g < this.length; g++) f = this.models[g], l[f.cid] || k.push(f);
                    k.length && this._removeModels(k, b)
                }
                var w = !1, x = !q && m && o;
                if (h.length && x ? (w = this.length !== h.length || c.some(this.models, function (a, b) {
                    return a !== h[b]
                }), this.models.length = 0, v(this.models, h, 0), this.length = this.models.length) : i.length && (q && (p = !0), v(this.models, i, null == e ? this.length : e), this.length = this.models.length), p && this.sort({silent: !0}), !b.silent) {
                    for (g = 0; g < i.length; g++) null != e && (b.index = e + g), f = i[g], f.trigger("add", f, this, b);
                    (p || w) && this.trigger("sort", this, b), (i.length || k.length || j.length) && (b.changes = {
                        added: i,
                        removed: k,
                        merged: j
                    }, this.trigger("update", this, b))
                }
                return d ? a[0] : a
            }
        }, reset: function (a, b) {
            b = b ? c.clone(b) : {};
            for (var d = 0; d < this.models.length; d++) this._removeReference(this.models[d], b);
            return b.previousModels = this.models, this._reset(), a = this.add(a, c.extend({silent: !0}, b)), b.silent || this.trigger("reset", this, b), a
        }, push: function (a, b) {
            return this.add(a, c.extend({at: this.length}, b))
        }, pop: function (a) {
            var b = this.at(this.length - 1);
            return this.remove(b, a)
        }, unshift: function (a, b) {
            return this.add(a, c.extend({at: 0}, b))
        }, shift: function (a) {
            var b = this.at(0);
            return this.remove(b, a)
        }, slice: function () {
            return f.apply(this.models, arguments)
        }, get: function (a) {
            if (null != a) return this._byId[a] || this._byId[this.modelId(this._isModel(a) ? a.attributes : a)] || a.cid && this._byId[a.cid]
        }, has: function (a) {
            return null != this.get(a)
        }, at: function (a) {
            return a < 0 && (a += this.length), this.models[a]
        }, where: function (a, b) {
            return this[b ? "find" : "filter"](a)
        }, findWhere: function (a) {
            return this.where(a, !0)
        }, sort: function (a) {
            var b = this.comparator;
            if (!b) throw new Error("Cannot sort a set without a comparator");
            a || (a = {});
            var d = b.length;
            return c.isFunction(b) && (b = b.bind(this)), 1 === d || c.isString(b) ? this.models = this.sortBy(b) : this.models.sort(b), a.silent || this.trigger("sort", this, a), this
        }, pluck: function (a) {
            return this.map(a + "")
        }, fetch: function (a) {
            a = c.extend({parse: !0}, a);
            var b = a.success, d = this;
            return a.success = function (c) {
                var e = a.reset ? "reset" : "set";
                d[e](c, a), b && b.call(a.context, d, c, a), d.trigger("sync", d, c, a)
            }, W(this, a), this.sync("read", this, a)
        }, create: function (a, b) {
            b = b ? c.clone(b) : {};
            var d = b.wait;
            if (a = this._prepareModel(a, b), !a) return !1;
            d || this.add(a, b);
            var e = this, f = b.success;
            return b.success = function (a, b, c) {
                d && e.add(a, c), f && f.call(c.context, a, b, c)
            }, a.save(null, b), a
        }, parse: function (a, b) {
            return a
        }, clone: function () {
            return new this.constructor(this.models, {model: this.model, comparator: this.comparator})
        }, modelId: function (a) {
            return a[this.model.prototype.idAttribute || "id"]
        }, values: function () {
            return new x(this, y)
        }, keys: function () {
            return new x(this, z)
        }, entries: function () {
            return new x(this, A)
        }, _reset: function () {
            this.length = 0, this.models = [], this._byId = {}
        }, _prepareModel: function (a, b) {
            if (this._isModel(a)) return a.collection || (a.collection = this), a;
            b = b ? c.clone(b) : {}, b.collection = this;
            var d = new this.model(a, b);
            return d.validationError ? (this.trigger("invalid", this, d.validationError, b), !1) : d
        }, _removeModels: function (a, b) {
            for (var c = [], d = 0; d < a.length; d++) {
                var e = this.get(a[d]);
                if (e) {
                    var f = this.indexOf(e);
                    this.models.splice(f, 1), this.length--, delete this._byId[e.cid];
                    var g = this.modelId(e.attributes);
                    null != g && delete this._byId[g], b.silent || (b.index = f, e.trigger("remove", e, this, b)), c.push(e), this._removeReference(e, b)
                }
            }
            return c
        }, _isModel: function (a) {
            return a instanceof r
        }, _addReference: function (a, b) {
            this._byId[a.cid] = a;
            var c = this.modelId(a.attributes);
            null != c && (this._byId[c] = a), a.on("all", this._onModelEvent, this)
        }, _removeReference: function (a, b) {
            delete this._byId[a.cid];
            var c = this.modelId(a.attributes);
            null != c && delete this._byId[c], this === a.collection && delete a.collection, a.off("all", this._onModelEvent, this)
        }, _onModelEvent: function (a, b, c, d) {
            if (b) {
                if (("add" === a || "remove" === a) && c !== this) return;
                if ("destroy" === a && this.remove(b, d), "change" === a) {
                    var e = this.modelId(b.previousAttributes()), f = this.modelId(b.attributes);
                    e !== f && (null != e && delete this._byId[e], null != f && (this._byId[f] = b))
                }
            }
            this.trigger.apply(this, arguments)
        }
    });
    var w = "function" == typeof Symbol && Symbol.iterator;
    w && (s.prototype[w] = s.prototype.values);
    var x = function (a, b) {
        this._collection = a, this._kind = b, this._index = 0
    }, y = 1, z = 2, A = 3;
    w && (x.prototype[w] = function () {
        return this
    }), x.prototype.next = function () {
        if (this._collection) {
            if (this._index < this._collection.length) {
                var a = this._collection.at(this._index);
                this._index++;
                var b;
                if (this._kind === y) b = a; else {
                    var c = this._collection.modelId(a.attributes);
                    b = this._kind === z ? c : [c, a]
                }
                return {value: b, done: !1}
            }
            this._collection = void 0
        }
        return {value: void 0, done: !0}
    };
    var B = b.View = function (a) {
        this.cid = c.uniqueId("view"), this.preinitialize.apply(this, arguments), c.extend(this, c.pick(a, D)), this._ensureElement(), this.initialize.apply(this, arguments)
    }, C = /^(\S+)\s*(.*)$/, D = ["model", "collection", "el", "id", "attributes", "className", "tagName", "events"];
    c.extend(B.prototype, h, {
        tagName: "div", $: function (a) {
            return this.$el.find(a)
        }, preinitialize: function () {
        }, initialize: function () {
        }, render: function () {
            return this
        }, remove: function () {
            return this._removeElement(), this.stopListening(), this
        }, _removeElement: function () {
            this.$el.remove()
        }, setElement: function (a) {
            return this.undelegateEvents(), this._setElement(a), this.delegateEvents(), this
        }, _setElement: function (a) {
            this.$el = a instanceof b.$ ? a : b.$(a), this.el = this.$el[0]
        }, delegateEvents: function (a) {
            if (a || (a = c.result(this, "events")), !a) return this;
            this.undelegateEvents();
            for (var b in a) {
                var d = a[b];
                if (c.isFunction(d) || (d = this[d]), d) {
                    var e = b.match(C);
                    this.delegate(e[1], e[2], d.bind(this))
                }
            }
            return this
        }, delegate: function (a, b, c) {
            return this.$el.on(a + ".delegateEvents" + this.cid, b, c), this
        }, undelegateEvents: function () {
            return this.$el && this.$el.off(".delegateEvents" + this.cid), this
        }, undelegate: function (a, b, c) {
            return this.$el.off(a + ".delegateEvents" + this.cid, b, c), this
        }, _createElement: function (a) {
            return document.createElement(a)
        }, _ensureElement: function () {
            if (this.el) this.setElement(c.result(this, "el")); else {
                var a = c.extend({}, c.result(this, "attributes"));
                this.id && (a.id = c.result(this, "id")), this.className && (a.class = c.result(this, "className")), this.setElement(this._createElement(c.result(this, "tagName"))), this._setAttributes(a)
            }
        }, _setAttributes: function (a) {
            this.$el.attr(a)
        }
    });
    var E = function (a, b, c, d) {
        switch (b) {
            case 1:
                return function () {
                    return a[c](this[d])
                };
            case 2:
                return function (b) {
                    return a[c](this[d], b)
                };
            case 3:
                return function (b, e) {
                    return a[c](this[d], G(b, this), e)
                };
            case 4:
                return function (b, e, f) {
                    return a[c](this[d], G(b, this), e, f)
                };
            default:
                return function () {
                    var b = f.call(arguments);
                    return b.unshift(this[d]), a[c].apply(a, b)
                }
        }
    }, F = function (a, b, d, e) {
        c.each(d, function (c, d) {
            b[d] && (a.prototype[d] = E(b, c, d, e))
        })
    }, G = function (a, b) {
        return c.isFunction(a) ? a : c.isObject(a) && !b._isModel(a) ? H(a) : c.isString(a) ? function (b) {
            return b.get(a)
        } : a
    }, H = function (a) {
        var b = c.matches(a);
        return function (a) {
            return b(a.attributes)
        }
    }, I = {
        forEach: 3,
        each: 3,
        map: 3,
        collect: 3,
        reduce: 0,
        foldl: 0,
        inject: 0,
        reduceRight: 0,
        foldr: 0,
        find: 3,
        detect: 3,
        filter: 3,
        select: 3,
        reject: 3,
        every: 3,
        all: 3,
        some: 3,
        any: 3,
        include: 3,
        includes: 3,
        contains: 3,
        invoke: 0,
        max: 3,
        min: 3,
        toArray: 1,
        size: 1,
        first: 3,
        head: 3,
        take: 3,
        initial: 3,
        rest: 3,
        tail: 3,
        drop: 3,
        last: 3,
        without: 0,
        difference: 0,
        indexOf: 3,
        shuffle: 1,
        lastIndexOf: 3,
        isEmpty: 1,
        chain: 1,
        sample: 3,
        partition: 3,
        groupBy: 3,
        countBy: 3,
        sortBy: 3,
        indexBy: 3,
        findIndex: 3,
        findLastIndex: 3
    }, J = {keys: 1, values: 1, pairs: 1, invert: 1, pick: 0, omit: 0, chain: 1, isEmpty: 1};
    c.each([[s, I, "models"], [r, J, "attributes"]], function (a) {
        var b = a[0], d = a[1], e = a[2];
        b.mixin = function (a) {
            var d = c.reduce(c.functions(a), function (a, b) {
                return a[b] = 0, a
            }, {});
            F(b, a, d, e)
        }, F(b, c, d, e)
    }), b.sync = function (a, d, e) {
        var f = K[a];
        c.defaults(e || (e = {}), {emulateHTTP: b.emulateHTTP, emulateJSON: b.emulateJSON});
        var g = {type: f, dataType: "json"};
        if (e.url || (g.url = c.result(d, "url") || V()), null != e.data || !d || "create" !== a && "update" !== a && "patch" !== a || (g.contentType = "application/json", g.data = JSON.stringify(e.attrs || d.toJSON(e))), e.emulateJSON && (g.contentType = "application/x-www-form-urlencoded", g.data = g.data ? {model: g.data} : {}), e.emulateHTTP && ("PUT" === f || "DELETE" === f || "PATCH" === f)) {
            g.type = "POST", e.emulateJSON && (g.data._method = f);
            var h = e.beforeSend;
            e.beforeSend = function (a) {
                if (a.setRequestHeader("X-HTTP-Method-Override", f), h) return h.apply(this, arguments)
            }
        }
        "GET" === g.type || e.emulateJSON || (g.processData = !1);
        var i = e.error;
        e.error = function (a, b, c) {
            e.textStatus = b, e.errorThrown = c, i && i.call(e.context, a, b, c)
        };
        var j = e.xhr = b.ajax(c.extend(g, e));
        return d.trigger("request", d, j, e), j
    };
    var K = {create: "POST", update: "PUT", patch: "PATCH", delete: "DELETE", read: "GET"};
    b.ajax = function () {
        return b.$.ajax.apply(b.$, arguments)
    };
    var L = b.Router = function (a) {
        a || (a = {}), this.preinitialize.apply(this, arguments), a.routes && (this.routes = a.routes), this._bindRoutes(), this.initialize.apply(this, arguments)
    }, M = /\((.*?)\)/g, N = /(\(\?)?:\w+/g, O = /\*\w+/g, P = /[\-{}\[\]+?.,\\\^$|#\s]/g;
    c.extend(L.prototype, h, {
        preinitialize: function () {
        }, initialize: function () {
        }, route: function (a, d, e) {
            c.isRegExp(a) || (a = this._routeToRegExp(a)), c.isFunction(d) && (e = d, d = ""), e || (e = this[d]);
            var f = this;
            return b.history.route(a, function (c) {
                var g = f._extractParameters(a, c);
                f.execute(e, g, d) !== !1 && (f.trigger.apply(f, ["route:" + d].concat(g)), f.trigger("route", d, g), b.history.trigger("route", f, d, g))
            }), this
        }, execute: function (a, b, c) {
            a && a.apply(this, b)
        }, navigate: function (a, c) {
            return b.history.navigate(a, c), this
        }, _bindRoutes: function () {
            if (this.routes) {
                this.routes = c.result(this, "routes");
                for (var a, b = c.keys(this.routes); null != (a = b.pop());) this.route(a, this.routes[a])
            }
        }, _routeToRegExp: function (a) {
            return a = a.replace(P, "\\$&").replace(M, "(?:$1)?").replace(N, function (a, b) {
                return b ? a : "([^/?]+)"
            }).replace(O, "([^?]*?)"), new RegExp("^" + a + "(?:\\?([\\s\\S]*))?$")
        }, _extractParameters: function (a, b) {
            var d = a.exec(b).slice(1);
            return c.map(d, function (a, b) {
                return b === d.length - 1 ? a || null : a ? decodeURIComponent(a) : null
            })
        }
    });
    var Q = b.History = function () {
        this.handlers = [], this.checkUrl = this.checkUrl.bind(this), "undefined" != typeof window && (this.location = window.location, this.history = window.history)
    }, R = /^[#\/]|\s+$/g, S = /^\/+|\/+$/g, T = /#.*$/;
    Q.started = !1, c.extend(Q.prototype, h, {
        interval: 50, atRoot: function () {
            var a = this.location.pathname.replace(/[^\/]$/, "$&/");
            return a === this.root && !this.getSearch()
        }, matchRoot: function () {
            var a = this.decodeFragment(this.location.pathname), b = a.slice(0, this.root.length - 1) + "/";
            return b === this.root
        }, decodeFragment: function (a) {
            return decodeURI(a.replace(/%25/g, "%2525"))
        }, getSearch: function () {
            var a = this.location.href.replace(/#.*/, "").match(/\?.+/);
            return a ? a[0] : ""
        }, getHash: function (a) {
            var b = (a || this).location.href.match(/#(.*)$/);
            return b ? b[1] : ""
        }, getPath: function () {
            var a = this.decodeFragment(this.location.pathname + this.getSearch()).slice(this.root.length - 1);
            return "/" === a.charAt(0) ? a.slice(1) : a
        }, getFragment: function (a) {
            return null == a && (a = this._usePushState || !this._wantsHashChange ? this.getPath() : this.getHash()), a.replace(R, "")
        }, start: function (a) {
            if (Q.started) throw new Error("Backbone.history has already been started");
            if (Q.started = !0, this.options = c.extend({root: "/"}, this.options, a), this.root = this.options.root, this._wantsHashChange = this.options.hashChange !== !1, this._hasHashChange = "onhashchange" in window && (void 0 === document.documentMode || document.documentMode > 7), this._useHashChange = this._wantsHashChange && this._hasHashChange, this._wantsPushState = !!this.options.pushState, this._hasPushState = !(!this.history || !this.history.pushState), this._usePushState = this._wantsPushState && this._hasPushState, this.fragment = this.getFragment(), this.root = ("/" + this.root + "/").replace(S, "/"), this._wantsHashChange && this._wantsPushState) {
                if (!this._hasPushState && !this.atRoot()) {
                    var b = this.root.slice(0, -1) || "/";
                    return this.location.replace(b + "#" + this.getPath()), !0
                }
                this._hasPushState && this.atRoot() && this.navigate(this.getHash(), {replace: !0})
            }
            if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
                this.iframe = document.createElement("iframe"), this.iframe.src = "javascript:0", this.iframe.style.display = "none", this.iframe.tabIndex = -1;
                var d = document.body, e = d.insertBefore(this.iframe, d.firstChild).contentWindow;
                e.document.open(), e.document.close(), e.location.hash = "#" + this.fragment
            }
            var f = window.addEventListener || function (a, b) {
                return attachEvent("on" + a, b)
            };
            if (this._usePushState ? f("popstate", this.checkUrl, !1) : this._useHashChange && !this.iframe ? f("hashchange", this.checkUrl, !1) : this._wantsHashChange && (this._checkUrlInterval = setInterval(this.checkUrl, this.interval)), !this.options.silent) return this.loadUrl()
        }, stop: function () {
            var a = window.removeEventListener || function (a, b) {
                return detachEvent("on" + a, b)
            };
            this._usePushState ? a("popstate", this.checkUrl, !1) : this._useHashChange && !this.iframe && a("hashchange", this.checkUrl, !1), this.iframe && (document.body.removeChild(this.iframe), this.iframe = null), this._checkUrlInterval && clearInterval(this._checkUrlInterval), Q.started = !1
        }, route: function (a, b) {
            this.handlers.unshift({route: a, callback: b})
        }, checkUrl: function (a) {
            var b = this.getFragment();
            return b === this.fragment && this.iframe && (b = this.getHash(this.iframe.contentWindow)), b !== this.fragment && (this.iframe && this.navigate(b), void this.loadUrl())
        }, loadUrl: function (a) {
            return !!this.matchRoot() && (a = this.fragment = this.getFragment(a), c.some(this.handlers, function (b) {
                if (b.route.test(a)) return b.callback(a), !0
            }))
        }, navigate: function (a, b) {
            if (!Q.started) return !1;
            b && b !== !0 || (b = {trigger: !!b}), a = this.getFragment(a || "");
            var c = this.root;
            "" !== a && "?" !== a.charAt(0) || (c = c.slice(0, -1) || "/");
            var d = c + a;
            a = a.replace(T, "");
            var e = this.decodeFragment(a);
            if (this.fragment !== e) {
                if (this.fragment = e, this._usePushState) this.history[b.replace ? "replaceState" : "pushState"]({}, document.title, d); else {
                    if (!this._wantsHashChange) return this.location.assign(d);
                    if (this._updateHash(this.location, a, b.replace), this.iframe && a !== this.getHash(this.iframe.contentWindow)) {
                        var f = this.iframe.contentWindow;
                        b.replace || (f.document.open(), f.document.close()), this._updateHash(f.location, a, b.replace)
                    }
                }
                return b.trigger ? this.loadUrl(a) : void 0
            }
        }, _updateHash: function (a, b, c) {
            if (c) {
                var d = a.href.replace(/(javascript:|#).*$/, "");
                a.replace(d + "#" + b)
            } else a.hash = "#" + b
        }
    }), b.history = new Q;
    var U = function (a, b) {
        var d, e = this;
        return d = a && c.has(a, "constructor") ? a.constructor : function () {
            return e.apply(this, arguments)
        }, c.extend(d, e, b), d.prototype = c.create(e.prototype, a), d.prototype.constructor = d, d.__super__ = e.prototype, d
    };
    r.extend = s.extend = L.extend = B.extend = Q.extend = U;
    var V = function () {
        throw new Error('A "url" property or function must be specified')
    }, W = function (a, b) {
        var c = b.error;
        b.error = function (d) {
            c && c.call(b.context, a, d, b), a.trigger("error", a, d, b)
        }
    };
    return b
}), define("backbone-noconflict", ["backbone"], function (a) {
    "use strict";
    return a.noConflict()
}),/*!
 * js-logger - http://github.com/jonnyreeves/js-logger
 * Jonny Reeves, http://jonnyreeves.co.uk/
 * js-logger may be freely distributed under the MIT license.
 */
    function (a) {
        "use strict";
        var b = {};
        b.VERSION = "1.7.0-next";
        var c, d = {}, e = function (a, b) {
            return function () {
                return b.apply(a, arguments)
            }
        }, f = function () {
            var a, b, c = arguments, d = c[0];
            for (b = 1; b < c.length; b++) for (a in c[b]) a in d || !c[b].hasOwnProperty(a) || (d[a] = c[b][a]);
            return d
        }, g = function (a, b) {
            return {value: a, name: b}
        };
        b.TRACE = g(1, "TRACE"), b.DEBUG = g(2, "DEBUG"), b.INFO = g(3, "INFO"), b.TIME = g(4, "TIME"), b.WARN = g(5, "WARN"), b.ERROR = g(8, "ERROR"), b.OFF = g(99, "OFF");
        var h = function (a) {
            this.context = a, this.setLevel(a.filterLevel), this.log = this.info
        };
        h.prototype = {
            setLevel: function (a) {
                a && "value" in a && (this.context.filterLevel = a)
            }, getLevel: function () {
                return this.context.filterLevel
            }, enabledFor: function (a) {
                var b = this.context.filterLevel;
                return a.value >= b.value
            }, trace: function () {
                this.invoke(b.TRACE, arguments)
            }, debug: function () {
                this.invoke(b.DEBUG, arguments)
            }, info: function () {
                this.invoke(b.INFO, arguments)
            }, warn: function () {
                this.invoke(b.WARN, arguments)
            }, error: function () {
                this.invoke(b.ERROR, arguments)
            }, time: function (a) {
                "string" == typeof a && a.length > 0 && this.invoke(b.TIME, [a, "start"])
            }, timeEnd: function (a) {
                "string" == typeof a && a.length > 0 && this.invoke(b.TIME, [a, "end"])
            }, invoke: function (a, b) {
                c && this.enabledFor(a) && c(b, f({level: a}, this.context))
            }
        };
        var i = new h({filterLevel: b.OFF});
        !function () {
            var a = b;
            a.enabledFor = e(i, i.enabledFor), a.trace = e(i, i.trace), a.debug = e(i, i.debug), a.time = e(i, i.time), a.timeEnd = e(i, i.timeEnd), a.info = e(i, i.info), a.warn = e(i, i.warn), a.error = e(i, i.error), a.log = a.info
        }(), b.setHandler = function (a) {
            c = a
        }, b.setLevel = function (a) {
            i.setLevel(a);
            for (var b in d) d.hasOwnProperty(b) && d[b].setLevel(a)
        }, b.getLevel = function () {
            return i.getLevel()
        }, b.get = function (a) {
            return d[a] || (d[a] = new h(f({name: a}, i.context)))
        }, b.createDefaultHandler = function (a) {
            a = a || {}, a.formatter = a.formatter || function (a, b) {
                b.name && a.unshift("[" + b.name + "]")
            };
            var c = {}, d = function (a, b) {
                Function.prototype.apply.call(a, console, b)
            };
            return "undefined" == typeof console ? function () {
            } : function (e, f) {
                e = Array.prototype.slice.call(e);
                var g, h = console.log;
                f.level === b.TIME ? (g = (f.name ? "[" + f.name + "] " : "") + e[0], "start" === e[1] ? console.time ? console.time(g) : c[g] = (new Date).getTime() : console.timeEnd ? console.timeEnd(g) : d(h, [g + ": " + ((new Date).getTime() - c[g]) + "ms"])) : (f.level === b.WARN && console.warn ? h = console.warn : f.level === b.ERROR && console.error ? h = console.error : f.level === b.INFO && console.info ? h = console.info : f.level === b.DEBUG && console.debug ? h = console.debug : f.level === b.TRACE && console.trace && (h = console.trace), a.formatter(e, f), d(h, e))
            }
        }, b.useDefaults = function (a) {
            b.setLevel(a && a.defaultLevel || b.DEBUG), b.setHandler(b.createDefaultHandler(a))
        }, "function" == typeof define && define.amd ? define("logger", b) : "undefined" != typeof module && module.exports ? module.exports = b : (b._prevLogger = a.Logger, b.noConflict = function () {
            return a.Logger = b._prevLogger, b
        }, a.Logger = b)
    }(this), define("app/event-dispatcher", ["underscore", "backbone"], function (a, b) {
    "use strict";
    return function () {
        function c() {
            this.initialize()
        }

        var d;
        return c.prototype.initialize = function () {
            a.extend(this, b.Events)
        }, {
            getInstance: function () {
                return void 0 === d && (d = new c), d
            }
        }
    }()
}), define("app/browser-events", ["underscore"], function (a) {
    "use strict";
    return function () {
        function b() {
            this.initialize()
        }

        var c;
        return b.prototype.initialize = function () {
            this.eventDispatcher = window.app.eventDispatcher, window.addEventListener("scroll", a.throttle(this.onWindowScroll.bind(this), 100, {leading: !1})), window.addEventListener("resize", this.onWindowResize.bind(this))
        }, b.prototype.onWindowScroll = function (a) {
            this.eventDispatcher.trigger(window.app.applicationEvents.WINDOW_SCROLL, a)
        }, b.prototype.onWindowResize = function (a) {
            this.eventDispatcher.trigger(window.app.applicationEvents.WINDOW_RESIZE, a)
        }, {
            getInstance: function () {
                return void 0 === c && (c = new b), c
            }
        }
    }()
}), define("app/match-media", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    return function () {
        function d(a, b) {
            var c = window.getComputedStyle(a, b).getPropertyValue("content");
            return c && "none" !== c || (c = window.getComputedStyle(a).getPropertyValue("font-family")), c = c.trim(), c = c.replace(/^"|^'|"$|'$|\\/g, "")
        }

        function e() {
            var a = d(l, ":before");
            try {
                return JSON.parse(a)
            } catch (a) {
                return console.warn(a), JSON.parse("{}")
            }
        }

        function f() {
            return d(m, ":before")
        }

        function g() {
            this.initialize()
        }

        var h, i, j, k, l = document.getElementById("breakpoint-shim"), m = document.getElementById("media-query-shim");
        return g.prototype.initialize = function () {
            b.extend(this, c.Events);
            var d = a("body");
            l || (l = a('<div id="breakpoint-shim"/>').appendTo(d).get(0)), m || (m = a('<div id="media-query-shim"/>').appendTo(d).get(0)), k = e(), this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.updateMediaQueries()
        }, g.prototype.setupListeners = function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.updateMediaQueries.bind(this))
        }, g.prototype.updateMediaQueries = function () {
            var b = f();
            if (b !== i) {
                j = i, i = b;
                var c = a.Event("change", {lastMediaQuery: j, currentMediaQuery: i});
                this.eventDispatcher.trigger(window.app.applicationEvents.VIEWPORT_CHANGE, c)
            }
        }, g.prototype.getBreakpoints = function () {
            return k
        }, g.prototype.getBreakpoint = function (a) {
            return k[a]
        }, g.prototype.getMediaQueries = function () {
            return {currentMediaQuery: i, lastMediaQuery: j}
        }, g.prototype.getCurrentMediaQuery = function () {
            return i
        }, {
            getInstance: function () {
                return void 0 === h && (h = new g), h
            }
        }
    }()
}), define("app/lazy-images", ["jquery", "underscore"], function (a, b) {
    "use strict";

    function c(c) {
        var d = this;
        d.options = c || {}, d.timer = null, d.timeout = d.options.timeout || 300, d.callback = d.options.callback || b.noop, d.container = d.options.container || null, a(this.container).find("img").each(function () {
            this.onload = d.loaded.bind(d, this)
        })
    }

    return c.prototype.loaded = function (a) {
        this.timer && clearTimeout(this.timer), this.timer = setTimeout(function () {
            this.timer = null, this.callback(a, this.container)
        }.bind(this), this.timeout)
    }, function (a) {
        return this instanceof c ? this : new c(a)
    }
}), define("views/accordion-item-view", ["jquery", "underscore", "backbone", "logger", "app/lazy-images"], function (a, b, c, d, e) {
    "use strict";
    var f = "max-height", g = c.View.extend({
        logger: d.get("AccordionItemView"),
        parent: void 0,
        contentVisible: void 0,
        initialActive: !1,
        maxHeightLimit: !1,
        currentMaxHeightLimit: null,
        options: void 0,
        lazyImageTimer: void 0,
        lazyImageTimeout: 200,
        events: {"click .title": "toggleContent", "click .title a": "dontFollow"},
        initialize: function (c) {
            this.options = b.extend({}, this.defaults, b.omit(c, ["el", "$el"])), this.parent = this.options.parent, this.$content = this.$(".content"), this.initialActive = this.options.initialActive || this.$el.hasClass("initial-active"), this.maxHeightLimit = this.options.maxHeightLimit || this.maxHeightLimit, this.contentVisible = !1, this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.initialActive && window.setTimeout(this.toggleContent.bind(this, a.Event("click", {target: this.$(".title")})), 100)
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.ACCORDION_RESET, this.reset), this.listenTo(this.eventDispatcher, window.app.applicationEvents.ACCORDION_RECALCULATE, this.resize), this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.resize), this.listenTo(this.eventDispatcher, window.app.applicationEvents.ACCORDION_OPEN, this.maybeShowContent)
        },
        toggleContent: function (b) {
            var c = a(b.target);
            c.hasClass("favorite") || c.closest(".interactions").length || (b instanceof Event && b.preventDefault(), this.contentVisible === !0 ? this.hideContent(b, this) : this.showContent(b))
        },
        showContent: function (a) {
            this.contentVisible = !0, a.index = this.$el.index(), this.eventDispatcher.trigger(window.app.applicationEvents.ACCORDION_SHOW, a, this), this.initialActive && (this.$content.css(f, this.getAllowedMaxHeight("none")), this.initialActive = !1);
            var b = setInterval(function () {
                var c = this.$content.find("> :not(:empty)").filter(":last");
                if (this.$el.addClass("active"), this.eventDispatcher.trigger(window.app.applicationEvents.ACCORDION_SHOWN, a, this), e({
                    container: this.$content,
                    callback: this.onLazyImageLoaded.bind(this)
                }), c.outerHeight() > 0 && 0 !== c.length) {
                    var d = c.position().top + c.outerHeight() + parseInt(c.css("margin-top"), 10) + parseInt(c.css("margin-bottom"), 10);
                    this.$content.css(f, this.getAllowedMaxHeight(d)), clearInterval(b)
                }
            }.bind(this), 100)
        },
        hideContent: function (a, b) {
            if (b.parent === this.parent) {
                var c, d = this.$content;
                a.index = this.$el.index(), this.stopListening(this.eventDispatcher, window.app.applicationEvents.ACCORDION_SHOW), this.eventDispatcher.trigger(window.app.applicationEvents.ACCORDION_HIDE, a, this), c = d.css("transition"), d.css({
                    transition: "none",
                    maxHeight: this.getAllowedMaxHeight(this.$content.height())
                }), this.logger.info("flush", d[0].offsetHeight), d.css("transition", c), this.$el.removeClass("active"), d.css(f, 0), this.contentVisible = !1
            }
        },
        onLazyImageLoaded: function () {
            this.resize()
        },
        maybeShowContent: function (a, b) {
            a.availableOptions === this.parent && b === this && this.showContent(a)
        },
        reset: function (b) {
            a.contains(b.target, this.el) && (this.stopListening(this.eventDispatcher, window.app.applicationEvents.ACCORDION_SHOW), this.$el.removeClass("active"), this.$content.css(f, ""), this.contentVisible = !1, this.$el.off("click", ".title"))
        },
        resize: function () {
            var a, b;
            this.currentMaxHeightLimit = null, this.$el.hasClass("active") && (a = this.$content, b = a.css("transition"), a.css({
                transition: "none",
                maxHeight: this.getAllowedMaxHeight("none")
            }), this.logger.info("flush", a[0].offsetHeight), a.css("transition", b))
        },
        dontFollow: function (a) {
            a.preventDefault()
        },
        getAllowedMaxHeight: function (a) {
            var b = this.getCurrentMaxHeightLimit();
            return b ? "number" == typeof a && a < b ? a : b : a
        },
        getCurrentMaxHeightLimit: function () {
            return null === this.currentMaxHeightLimit && (this.currentMaxHeightLimit = "function" == typeof this.maxHeightLimit ? this.maxHeightLimit() : this.maxHeightLimit), this.currentMaxHeightLimit
        }
    });
    return function (a) {
        return this instanceof g ? this : new g(a)
    }
}), function (a) {
    "use strict";
    "function" == typeof define && define.amd ? define("slick-slider", ["jquery"], a) : "undefined" != typeof exports ? module.exports = a(require("jquery")) : a(jQuery)
}(function (a) {
    "use strict";
    var b = window.Slick || {};
    b = function () {
        function b(b, d) {
            var e, f = this;
            f.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: a(b),
                appendDots: a(b),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function (b, c) {
                    return a('<button type="button" />').text(c + 1)
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            }, f.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: !1,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                swiping: !1,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            }, a.extend(f, f.initials), f.activeBreakpoint = null, f.animType = null, f.animProp = null, f.breakpoints = [], f.breakpointSettings = [], f.cssTransitions = !1, f.focussed = !1, f.interrupted = !1, f.hidden = "hidden", f.paused = !0, f.positionProp = null, f.respondTo = null, f.rowCount = 1, f.shouldClick = !0, f.$slider = a(b), f.$slidesCache = null, f.transformType = null, f.transitionType = null, f.visibilityChange = "visibilitychange", f.windowWidth = 0, f.windowTimer = null, e = a(b).data("slick") || {}, f.options = a.extend({}, f.defaults, d, e), f.currentSlide = f.options.initialSlide, f.originalSettings = f.options, "undefined" != typeof document.mozHidden ? (f.hidden = "mozHidden", f.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.webkitHidden && (f.hidden = "webkitHidden", f.visibilityChange = "webkitvisibilitychange"), f.autoPlay = a.proxy(f.autoPlay, f), f.autoPlayClear = a.proxy(f.autoPlayClear, f), f.autoPlayIterator = a.proxy(f.autoPlayIterator, f), f.changeSlide = a.proxy(f.changeSlide, f), f.clickHandler = a.proxy(f.clickHandler, f), f.selectHandler = a.proxy(f.selectHandler, f), f.setPosition = a.proxy(f.setPosition, f), f.swipeHandler = a.proxy(f.swipeHandler, f), f.dragHandler = a.proxy(f.dragHandler, f), f.keyHandler = a.proxy(f.keyHandler, f), f.instanceUid = c++, f.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, f.registerBreakpoints(), f.init(!0)
        }

        var c = 0;
        return b
    }(), b.prototype.activateADA = function () {
        var a = this;
        a.$slideTrack.find(".slick-active").attr({"aria-hidden": "false"}).find("a, input, button, select").attr({tabindex: "0"})
    }, b.prototype.addSlide = b.prototype.slickAdd = function (b, c, d) {
        var e = this;
        if ("boolean" == typeof c) d = c, c = null; else if (c < 0 || c >= e.slideCount) return !1;
        e.unload(), "number" == typeof c ? 0 === c && 0 === e.$slides.length ? a(b).appendTo(e.$slideTrack) : d ? a(b).insertBefore(e.$slides.eq(c)) : a(b).insertAfter(e.$slides.eq(c)) : d === !0 ? a(b).prependTo(e.$slideTrack) : a(b).appendTo(e.$slideTrack), e.$slides = e.$slideTrack.children(this.options.slide), e.$slideTrack.children(this.options.slide).detach(), e.$slideTrack.append(e.$slides), e.$slides.each(function (b, c) {
            a(c).attr("data-slick-index", b)
        }), e.$slidesCache = e.$slides, e.reinit()
    }, b.prototype.animateHeight = function () {
        var a = this;
        if (1 === a.options.slidesToShow && a.options.adaptiveHeight === !0 && a.options.vertical === !1) {
            var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
            a.$list.animate({height: b}, a.options.speed)
        }
    }, b.prototype.animateSlide = function (b, c) {
        var d = {}, e = this;
        e.animateHeight(), e.options.rtl === !0 && e.options.vertical === !1 && (b = -b), e.transformsEnabled === !1 ? e.options.vertical === !1 ? e.$slideTrack.animate({left: b}, e.options.speed, e.options.easing, c) : e.$slideTrack.animate({top: b}, e.options.speed, e.options.easing, c) : e.cssTransitions === !1 ? (e.options.rtl === !0 && (e.currentLeft = -e.currentLeft), a({animStart: e.currentLeft}).animate({animStart: b}, {
            duration: e.options.speed,
            easing: e.options.easing,
            step: function (a) {
                a = Math.ceil(a), e.options.vertical === !1 ? (d[e.animType] = "translate(" + a + "px, 0px)", e.$slideTrack.css(d)) : (d[e.animType] = "translate(0px," + a + "px)", e.$slideTrack.css(d))
            },
            complete: function () {
                c && c.call()
            }
        })) : (e.applyTransition(), b = Math.ceil(b), e.options.vertical === !1 ? d[e.animType] = "translate3d(" + b + "px, 0px, 0px)" : d[e.animType] = "translate3d(0px," + b + "px, 0px)", e.$slideTrack.css(d), c && setTimeout(function () {
            e.disableTransition(), c.call()
        }, e.options.speed))
    }, b.prototype.getNavTarget = function () {
        var b = this, c = b.options.asNavFor;
        return c && null !== c && (c = a(c).not(b.$slider)), c
    }, b.prototype.asNavFor = function (b) {
        var c = this, d = c.getNavTarget();
        null !== d && "object" == typeof d && d.each(function () {
            var c = a(this).slick("getSlick");
            c.unslicked || c.slideHandler(b, !0)
        })
    }, b.prototype.applyTransition = function (a) {
        var b = this, c = {};
        b.options.fade === !1 ? c[b.transitionType] = b.transformType + " " + b.options.speed + "ms " + b.options.cssEase : c[b.transitionType] = "opacity " + b.options.speed + "ms " + b.options.cssEase, b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c)
    }, b.prototype.autoPlay = function () {
        var a = this;
        a.autoPlayClear(), a.slideCount > a.options.slidesToShow && (a.autoPlayTimer = setInterval(a.autoPlayIterator, a.options.autoplaySpeed))
    }, b.prototype.autoPlayClear = function () {
        var a = this;
        a.autoPlayTimer && clearInterval(a.autoPlayTimer)
    }, b.prototype.autoPlayIterator = function () {
        var a = this, b = a.currentSlide + a.options.slidesToScroll;
        a.paused || a.interrupted || a.focussed || (a.options.infinite === !1 && (1 === a.direction && a.currentSlide + 1 === a.slideCount - 1 ? a.direction = 0 : 0 === a.direction && (b = a.currentSlide - a.options.slidesToScroll, a.currentSlide - 1 === 0 && (a.direction = 1))), a.slideHandler(b))
    }, b.prototype.buildArrows = function () {
        var b = this;
        b.options.arrows === !0 && (b.$prevArrow = a(b.options.prevArrow).addClass("slick-arrow"), b.$nextArrow = a(b.options.nextArrow).addClass("slick-arrow"), b.slideCount > b.options.slidesToShow ? (b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.prependTo(b.options.appendArrows), b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.appendTo(b.options.appendArrows), b.options.infinite !== !0 && b.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : b.$prevArrow.add(b.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }, b.prototype.buildDots = function () {
        var b, c, d = this;
        if (d.options.dots === !0 && d.slideCount > d.options.slidesToShow) {
            for (d.$slider.addClass("slick-dotted"), c = a("<ul />").addClass(d.options.dotsClass), b = 0; b <= d.getDotCount(); b += 1) c.append(a("<li />").append(d.options.customPaging.call(this, d, b)));
            d.$dots = c.appendTo(d.options.appendDots), d.$dots.find("li").first().addClass("slick-active")
        }
    }, b.prototype.buildOut = function () {
        var b = this;
        b.$slides = b.$slider.children(b.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), b.slideCount = b.$slides.length, b.$slides.each(function (b, c) {
            a(c).attr("data-slick-index", b).data("originalStyling", a(c).attr("style") || "")
        }), b.$slider.addClass("slick-slider"), b.$slideTrack = 0 === b.slideCount ? a('<div class="slick-track"/>').appendTo(b.$slider) : b.$slides.wrapAll('<div class="slick-track"/>').parent(), b.$list = b.$slideTrack.wrap('<div class="slick-list"/>').parent(), b.$slideTrack.css("opacity", 0), b.options.centerMode !== !0 && b.options.swipeToSlide !== !0 || (b.options.slidesToScroll = 1), a("img[data-lazy]", b.$slider).not("[src]").addClass("slick-loading"), b.setupInfinite(), b.buildArrows(), b.buildDots(), b.updateDots(), b.setSlideClasses("number" == typeof b.currentSlide ? b.currentSlide : 0), b.options.draggable === !0 && b.$list.addClass("draggable")
    }, b.prototype.buildRows = function () {
        var a, b, c, d, e, f, g, h = this;
        if (d = document.createDocumentFragment(), f = h.$slider.children(), h.options.rows > 0) {
            for (g = h.options.slidesPerRow * h.options.rows, e = Math.ceil(f.length / g), a = 0; a < e; a++) {
                var i = document.createElement("div");
                for (b = 0; b < h.options.rows; b++) {
                    var j = document.createElement("div");
                    for (c = 0; c < h.options.slidesPerRow; c++) {
                        var k = a * g + (b * h.options.slidesPerRow + c);
                        f.get(k) && j.appendChild(f.get(k))
                    }
                    i.appendChild(j)
                }
                d.appendChild(i)
            }
            h.$slider.empty().append(d), h.$slider.children().children().children().css({
                width: 100 / h.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }, b.prototype.checkResponsive = function (b, c) {
        var d, e, f, g = this, h = !1, i = g.$slider.width(), j = window.innerWidth || a(window).width();
        if ("window" === g.respondTo ? f = j : "slider" === g.respondTo ? f = i : "min" === g.respondTo && (f = Math.min(j, i)), g.options.responsive && g.options.responsive.length && null !== g.options.responsive) {
            e = null;
            for (d in g.breakpoints) g.breakpoints.hasOwnProperty(d) && (g.originalSettings.mobileFirst === !1 ? f < g.breakpoints[d] && (e = g.breakpoints[d]) : f > g.breakpoints[d] && (e = g.breakpoints[d]));
            null !== e ? null !== g.activeBreakpoint ? (e !== g.activeBreakpoint || c) && (g.activeBreakpoint = e, "unslick" === g.breakpointSettings[e] ? g.unslick(e) : (g.options = a.extend({}, g.originalSettings, g.breakpointSettings[e]), b === !0 && (g.currentSlide = g.options.initialSlide), g.refresh(b)), h = e) : (g.activeBreakpoint = e, "unslick" === g.breakpointSettings[e] ? g.unslick(e) : (g.options = a.extend({}, g.originalSettings, g.breakpointSettings[e]), b === !0 && (g.currentSlide = g.options.initialSlide), g.refresh(b)), h = e) : null !== g.activeBreakpoint && (g.activeBreakpoint = null, g.options = g.originalSettings, b === !0 && (g.currentSlide = g.options.initialSlide), g.refresh(b), h = e), b || h === !1 || g.$slider.trigger("breakpoint", [g, h])
        }
    }, b.prototype.changeSlide = function (b, c) {
        var d, e, f, g = this, h = a(b.currentTarget);
        switch (h.is("a") && b.preventDefault(), h.is("li") || (h = h.closest("li")), f = g.slideCount % g.options.slidesToScroll !== 0, d = f ? 0 : (g.slideCount - g.currentSlide) % g.options.slidesToScroll, b.data.message) {
            case"previous":
                e = 0 === d ? g.options.slidesToScroll : g.options.slidesToShow - d, g.slideCount > g.options.slidesToShow && g.slideHandler(g.currentSlide - e, !1, c);
                break;
            case"next":
                e = 0 === d ? g.options.slidesToScroll : d, g.slideCount > g.options.slidesToShow && g.slideHandler(g.currentSlide + e, !1, c);
                break;
            case"index":
                var i = 0 === b.data.index ? 0 : b.data.index || h.index() * g.options.slidesToScroll;
                g.slideHandler(g.checkNavigable(i), !1, c), h.children().trigger("focus");
                break;
            default:
                return
        }
    }, b.prototype.checkNavigable = function (a) {
        var b, c, d = this;
        if (b = d.getNavigableIndexes(), c = 0, a > b[b.length - 1]) a = b[b.length - 1]; else for (var e in b) {
            if (a < b[e]) {
                a = c;
                break
            }
            c = b[e]
        }
        return a
    }, b.prototype.cleanUpEvents = function () {
        var b = this;
        b.options.dots && null !== b.$dots && (a("li", b.$dots).off("click.slick", b.changeSlide).off("mouseenter.slick", a.proxy(b.interrupt, b, !0)).off("mouseleave.slick", a.proxy(b.interrupt, b, !1)), b.options.accessibility === !0 && b.$dots.off("keydown.slick", b.keyHandler)), b.$slider.off("focus.slick blur.slick"), b.options.arrows === !0 && b.slideCount > b.options.slidesToShow && (b.$prevArrow && b.$prevArrow.off("click.slick", b.changeSlide), b.$nextArrow && b.$nextArrow.off("click.slick", b.changeSlide), b.options.accessibility === !0 && (b.$prevArrow && b.$prevArrow.off("keydown.slick", b.keyHandler), b.$nextArrow && b.$nextArrow.off("keydown.slick", b.keyHandler))), b.$list.off("touchstart.slick mousedown.slick", b.swipeHandler), b.$list.off("touchmove.slick mousemove.slick", b.swipeHandler), b.$list.off("touchend.slick mouseup.slick", b.swipeHandler), b.$list.off("touchcancel.slick mouseleave.slick", b.swipeHandler), b.$list.off("click.slick", b.clickHandler), a(document).off(b.visibilityChange, b.visibility), b.cleanUpSlideEvents(), b.options.accessibility === !0 && b.$list.off("keydown.slick", b.keyHandler), b.options.focusOnSelect === !0 && a(b.$slideTrack).children().off("click.slick", b.selectHandler), a(window).off("orientationchange.slick.slick-" + b.instanceUid, b.orientationChange), a(window).off("resize.slick.slick-" + b.instanceUid, b.resize), a("[draggable!=true]", b.$slideTrack).off("dragstart", b.preventDefault), a(window).off("load.slick.slick-" + b.instanceUid, b.setPosition)
    }, b.prototype.cleanUpSlideEvents = function () {
        var b = this;
        b.$list.off("mouseenter.slick", a.proxy(b.interrupt, b, !0)), b.$list.off("mouseleave.slick", a.proxy(b.interrupt, b, !1))
    }, b.prototype.cleanUpRows = function () {
        var a, b = this;
        b.options.rows > 0 && (a = b.$slides.children().children(), a.removeAttr("style"), b.$slider.empty().append(a))
    }, b.prototype.clickHandler = function (a) {
        var b = this;
        b.shouldClick === !1 && (a.stopImmediatePropagation(), a.stopPropagation(), a.preventDefault())
    }, b.prototype.destroy = function (b) {
        var c = this;
        c.autoPlayClear(), c.touchObject = {}, c.cleanUpEvents(), a(".slick-cloned", c.$slider).detach(), c.$dots && c.$dots.remove(), c.$prevArrow && c.$prevArrow.length && (c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), c.htmlExpr.test(c.options.prevArrow) && c.$prevArrow.remove()), c.$nextArrow && c.$nextArrow.length && (c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), c.htmlExpr.test(c.options.nextArrow) && c.$nextArrow.remove()), c.$slides && (c.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
            a(this).attr("style", a(this).data("originalStyling"))
        }), c.$slideTrack.children(this.options.slide).detach(), c.$slideTrack.detach(), c.$list.detach(), c.$slider.append(c.$slides)), c.cleanUpRows(), c.$slider.removeClass("slick-slider"), c.$slider.removeClass("slick-initialized"), c.$slider.removeClass("slick-dotted"), c.unslicked = !0, b || c.$slider.trigger("destroy", [c])
    }, b.prototype.disableTransition = function (a) {
        var b = this, c = {};
        c[b.transitionType] = "", b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c)
    }, b.prototype.fadeSlide = function (a, b) {
        var c = this;
        c.cssTransitions === !1 ? (c.$slides.eq(a).css({zIndex: c.options.zIndex}), c.$slides.eq(a).animate({opacity: 1}, c.options.speed, c.options.easing, b)) : (c.applyTransition(a), c.$slides.eq(a).css({
            opacity: 1,
            zIndex: c.options.zIndex
        }), b && setTimeout(function () {
            c.disableTransition(a), b.call()
        }, c.options.speed))
    }, b.prototype.fadeSlideOut = function (a) {
        var b = this;
        b.cssTransitions === !1 ? b.$slides.eq(a).animate({
            opacity: 0,
            zIndex: b.options.zIndex - 2
        }, b.options.speed, b.options.easing) : (b.applyTransition(a), b.$slides.eq(a).css({
            opacity: 0,
            zIndex: b.options.zIndex - 2
        }))
    }, b.prototype.filterSlides = b.prototype.slickFilter = function (a) {
        var b = this;
        null !== a && (b.$slidesCache = b.$slides, b.unload(), b.$slideTrack.children(this.options.slide).detach(), b.$slidesCache.filter(a).appendTo(b.$slideTrack), b.reinit())
    }, b.prototype.focusHandler = function () {
        var b = this;
        b.$slider.off("focus.slick blur.slick").on("focus.slick", "*", function (c) {
            var d = a(this);
            setTimeout(function () {
                b.options.pauseOnFocus && d.is(":focus") && (b.focussed = !0, b.autoPlay())
            }, 0)
        }).on("blur.slick", "*", function (c) {
            a(this);
            b.options.pauseOnFocus && (b.focussed = !1, b.autoPlay())
        })
    }, b.prototype.getCurrent = b.prototype.slickCurrentSlide = function () {
        var a = this;
        return a.currentSlide
    }, b.prototype.getDotCount = function () {
        var a = this, b = 0, c = 0, d = 0;
        if (a.options.infinite === !0) if (a.slideCount <= a.options.slidesToShow) ++d; else for (; b < a.slideCount;) ++d, b = c + a.options.slidesToScroll, c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow; else if (a.options.centerMode === !0) d = a.slideCount; else if (a.options.asNavFor) for (; b < a.slideCount;) ++d, b = c + a.options.slidesToScroll, c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow; else d = 1 + Math.ceil((a.slideCount - a.options.slidesToShow) / a.options.slidesToScroll);
        return d - 1
    }, b.prototype.getLeft = function (a) {
        var b, c, d, e, f = this, g = 0;
        return f.slideOffset = 0, c = f.$slides.first().outerHeight(!0), f.options.infinite === !0 ? (f.slideCount > f.options.slidesToShow && (f.slideOffset = f.slideWidth * f.options.slidesToShow * -1, e = -1, f.options.vertical === !0 && f.options.centerMode === !0 && (2 === f.options.slidesToShow ? e = -1.5 : 1 === f.options.slidesToShow && (e = -2)), g = c * f.options.slidesToShow * e), f.slideCount % f.options.slidesToScroll !== 0 && a + f.options.slidesToScroll > f.slideCount && f.slideCount > f.options.slidesToShow && (a > f.slideCount ? (f.slideOffset = (f.options.slidesToShow - (a - f.slideCount)) * f.slideWidth * -1, g = (f.options.slidesToShow - (a - f.slideCount)) * c * -1) : (f.slideOffset = f.slideCount % f.options.slidesToScroll * f.slideWidth * -1, g = f.slideCount % f.options.slidesToScroll * c * -1))) : a + f.options.slidesToShow > f.slideCount && (f.slideOffset = (a + f.options.slidesToShow - f.slideCount) * f.slideWidth, g = (a + f.options.slidesToShow - f.slideCount) * c), f.slideCount <= f.options.slidesToShow && (f.slideOffset = 0, g = 0), f.options.centerMode === !0 && f.slideCount <= f.options.slidesToShow ? f.slideOffset = f.slideWidth * Math.floor(f.options.slidesToShow) / 2 - f.slideWidth * f.slideCount / 2 : f.options.centerMode === !0 && f.options.infinite === !0 ? f.slideOffset += f.slideWidth * Math.floor(f.options.slidesToShow / 2) - f.slideWidth : f.options.centerMode === !0 && (f.slideOffset = 0, f.slideOffset += f.slideWidth * Math.floor(f.options.slidesToShow / 2)), b = f.options.vertical === !1 ? a * f.slideWidth * -1 + f.slideOffset : a * c * -1 + g, f.options.variableWidth === !0 && (d = f.slideCount <= f.options.slidesToShow || f.options.infinite === !1 ? f.$slideTrack.children(".slick-slide").eq(a) : f.$slideTrack.children(".slick-slide").eq(a + f.options.slidesToShow), b = f.options.rtl === !0 ? d[0] ? (f.$slideTrack.width() - d[0].offsetLeft - d.width()) * -1 : 0 : d[0] ? d[0].offsetLeft * -1 : 0, f.options.centerMode === !0 && (d = f.slideCount <= f.options.slidesToShow || f.options.infinite === !1 ? f.$slideTrack.children(".slick-slide").eq(a) : f.$slideTrack.children(".slick-slide").eq(a + f.options.slidesToShow + 1), b = f.options.rtl === !0 ? d[0] ? (f.$slideTrack.width() - d[0].offsetLeft - d.width()) * -1 : 0 : d[0] ? d[0].offsetLeft * -1 : 0, b += (f.$list.width() - d.outerWidth()) / 2)), b
    }, b.prototype.getOption = b.prototype.slickGetOption = function (a) {
        var b = this;
        return b.options[a]
    }, b.prototype.getNavigableIndexes = function () {
        var a, b = this, c = 0, d = 0, e = [];
        for (b.options.infinite === !1 ? a = b.slideCount : (c = b.options.slidesToScroll * -1, d = b.options.slidesToScroll * -1, a = 2 * b.slideCount); c < a;) e.push(c), c = d + b.options.slidesToScroll, d += b.options.slidesToScroll <= b.options.slidesToShow ? b.options.slidesToScroll : b.options.slidesToShow;
        return e
    }, b.prototype.getSlick = function () {
        return this
    }, b.prototype.getSlideCount = function () {
        var b, c, d, e, f = this;
        return e = f.options.centerMode === !0 ? Math.floor(f.$list.width() / 2) : 0, d = f.swipeLeft * -1 + e, f.options.swipeToSlide === !0 ? (f.$slideTrack.find(".slick-slide").each(function (b, e) {
            var g, h, i;
            if (g = a(e).outerWidth(), h = e.offsetLeft, f.options.centerMode !== !0 && (h += g / 2), i = h + g, d < i) return c = e, !1
        }), b = Math.abs(a(c).attr("data-slick-index") - f.currentSlide) || 1) : f.options.slidesToScroll
    }, b.prototype.goTo = b.prototype.slickGoTo = function (a, b) {
        var c = this;
        c.changeSlide({data: {message: "index", index: parseInt(a)}}, b)
    }, b.prototype.init = function (b) {
        var c = this;
        a(c.$slider).hasClass("slick-initialized") || (a(c.$slider).addClass("slick-initialized"), c.buildRows(), c.buildOut(), c.setProps(), c.startLoad(), c.loadSlider(), c.initializeEvents(), c.updateArrows(), c.updateDots(), c.checkResponsive(!0), c.focusHandler()), b && c.$slider.trigger("init", [c]), c.options.accessibility === !0 && c.initADA(), c.options.autoplay && (c.paused = !1, c.autoPlay())
    }, b.prototype.initADA = function () {
        var b = this, c = Math.ceil(b.slideCount / b.options.slidesToShow),
            d = b.getNavigableIndexes().filter(function (a) {
                return a >= 0 && a < b.slideCount
            });
        b.$slides.add(b.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({tabindex: "-1"}), null !== b.$dots && (b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function (c) {
            var e = d.indexOf(c);
            if (a(this).attr({role: "tabpanel", id: "slick-slide" + b.instanceUid + c, tabindex: -1}), e !== -1) {
                var f = "slick-slide-control" + b.instanceUid + e;
                a("#" + f).length && a(this).attr({"aria-describedby": f})
            }
        }), b.$dots.attr("role", "tablist").find("li").each(function (e) {
            var f = d[e];
            a(this).attr({role: "presentation"}), a(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + b.instanceUid + e,
                "aria-controls": "slick-slide" + b.instanceUid + f,
                "aria-label": e + 1 + " of " + c,
                "aria-selected": null,
                tabindex: "-1"
            })
        }).eq(b.currentSlide).find("button").attr({"aria-selected": "true", tabindex: "0"}).end());
        for (var e = b.currentSlide, f = e + b.options.slidesToShow; e < f; e++) b.options.focusOnChange ? b.$slides.eq(e).attr({tabindex: "0"}) : b.$slides.eq(e).removeAttr("tabindex");
        b.activateADA()
    }, b.prototype.initArrowEvents = function () {
        var a = this;
        a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.off("click.slick").on("click.slick", {message: "previous"}, a.changeSlide), a.$nextArrow.off("click.slick").on("click.slick", {message: "next"}, a.changeSlide), a.options.accessibility === !0 && (a.$prevArrow.on("keydown.slick", a.keyHandler), a.$nextArrow.on("keydown.slick", a.keyHandler)))
    }, b.prototype.initDotEvents = function () {
        var b = this;
        b.options.dots === !0 && b.slideCount > b.options.slidesToShow && (a("li", b.$dots).on("click.slick", {message: "index"}, b.changeSlide), b.options.accessibility === !0 && b.$dots.on("keydown.slick", b.keyHandler)), b.options.dots === !0 && b.options.pauseOnDotsHover === !0 && b.slideCount > b.options.slidesToShow && a("li", b.$dots).on("mouseenter.slick", a.proxy(b.interrupt, b, !0)).on("mouseleave.slick", a.proxy(b.interrupt, b, !1))
    }, b.prototype.initSlideEvents = function () {
        var b = this;
        b.options.pauseOnHover && (b.$list.on("mouseenter.slick", a.proxy(b.interrupt, b, !0)), b.$list.on("mouseleave.slick", a.proxy(b.interrupt, b, !1)))
    }, b.prototype.initializeEvents = function () {
        var b = this;
        b.initArrowEvents(), b.initDotEvents(), b.initSlideEvents(), b.$list.on("touchstart.slick mousedown.slick", {action: "start"}, b.swipeHandler), b.$list.on("touchmove.slick mousemove.slick", {action: "move"}, b.swipeHandler), b.$list.on("touchend.slick mouseup.slick", {action: "end"}, b.swipeHandler), b.$list.on("touchcancel.slick mouseleave.slick", {action: "end"}, b.swipeHandler), b.$list.on("click.slick", b.clickHandler), a(document).on(b.visibilityChange, a.proxy(b.visibility, b)), b.options.accessibility === !0 && b.$list.on("keydown.slick", b.keyHandler), b.options.focusOnSelect === !0 && a(b.$slideTrack).children().on("click.slick", b.selectHandler),
            a(window).on("orientationchange.slick.slick-" + b.instanceUid, a.proxy(b.orientationChange, b)), a(window).on("resize.slick.slick-" + b.instanceUid, a.proxy(b.resize, b)), a("[draggable!=true]", b.$slideTrack).on("dragstart", b.preventDefault), a(window).on("load.slick.slick-" + b.instanceUid, b.setPosition), a(b.setPosition)
    }, b.prototype.initUI = function () {
        var a = this;
        a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.show(), a.$nextArrow.show()), a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.show()
    }, b.prototype.keyHandler = function (a) {
        var b = this;
        a.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === a.keyCode && b.options.accessibility === !0 ? b.changeSlide({data: {message: b.options.rtl === !0 ? "next" : "previous"}}) : 39 === a.keyCode && b.options.accessibility === !0 && b.changeSlide({data: {message: b.options.rtl === !0 ? "previous" : "next"}}))
    }, b.prototype.lazyLoad = function () {
        function b(b) {
            a("img[data-lazy]", b).each(function () {
                var b = a(this), c = a(this).attr("data-lazy"), d = a(this).attr("data-srcset"),
                    e = a(this).attr("data-sizes") || g.$slider.attr("data-sizes"), f = document.createElement("img");
                f.onload = function () {
                    b.animate({opacity: 0}, 100, function () {
                        d && (b.attr("srcset", d), e && b.attr("sizes", e)), b.attr("src", c).animate({opacity: 1}, 200, function () {
                            b.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        }), g.$slider.trigger("lazyLoaded", [g, b, c])
                    })
                }, f.onerror = function () {
                    b.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), g.$slider.trigger("lazyLoadError", [g, b, c])
                }, f.src = c
            })
        }

        var c, d, e, f, g = this;
        if (g.options.centerMode === !0 ? g.options.infinite === !0 ? (e = g.currentSlide + (g.options.slidesToShow / 2 + 1), f = e + g.options.slidesToShow + 2) : (e = Math.max(0, g.currentSlide - (g.options.slidesToShow / 2 + 1)), f = 2 + (g.options.slidesToShow / 2 + 1) + g.currentSlide) : (e = g.options.infinite ? g.options.slidesToShow + g.currentSlide : g.currentSlide, f = Math.ceil(e + g.options.slidesToShow), g.options.fade === !0 && (e > 0 && e--, f <= g.slideCount && f++)), c = g.$slider.find(".slick-slide").slice(e, f), "anticipated" === g.options.lazyLoad) for (var h = e - 1, i = f, j = g.$slider.find(".slick-slide"), k = 0; k < g.options.slidesToScroll; k++) h < 0 && (h = g.slideCount - 1), c = c.add(j.eq(h)), c = c.add(j.eq(i)), h--, i++;
        b(c), g.slideCount <= g.options.slidesToShow ? (d = g.$slider.find(".slick-slide"), b(d)) : g.currentSlide >= g.slideCount - g.options.slidesToShow ? (d = g.$slider.find(".slick-cloned").slice(0, g.options.slidesToShow), b(d)) : 0 === g.currentSlide && (d = g.$slider.find(".slick-cloned").slice(g.options.slidesToShow * -1), b(d))
    }, b.prototype.loadSlider = function () {
        var a = this;
        a.setPosition(), a.$slideTrack.css({opacity: 1}), a.$slider.removeClass("slick-loading"), a.initUI(), "progressive" === a.options.lazyLoad && a.progressiveLazyLoad()
    }, b.prototype.next = b.prototype.slickNext = function () {
        var a = this;
        a.changeSlide({data: {message: "next"}})
    }, b.prototype.orientationChange = function () {
        var a = this;
        a.checkResponsive(), a.setPosition()
    }, b.prototype.pause = b.prototype.slickPause = function () {
        var a = this;
        a.autoPlayClear(), a.paused = !0
    }, b.prototype.play = b.prototype.slickPlay = function () {
        var a = this;
        a.autoPlay(), a.options.autoplay = !0, a.paused = !1, a.focussed = !1, a.interrupted = !1
    }, b.prototype.postSlide = function (b) {
        var c = this;
        if (!c.unslicked && (c.$slider.trigger("afterChange", [c, b]), c.animating = !1, c.slideCount > c.options.slidesToShow && c.setPosition(), c.swipeLeft = null, c.options.autoplay && c.autoPlay(), c.options.accessibility === !0 && (c.initADA(), c.options.focusOnChange))) {
            var d = a(c.$slides.get(c.currentSlide));
            d.attr("tabindex", 0).focus()
        }
    }, b.prototype.prev = b.prototype.slickPrev = function () {
        var a = this;
        a.changeSlide({data: {message: "previous"}})
    }, b.prototype.preventDefault = function (a) {
        a.preventDefault()
    }, b.prototype.progressiveLazyLoad = function (b) {
        b = b || 1;
        var c, d, e, f, g, h = this, i = a("img[data-lazy]", h.$slider);
        i.length ? (c = i.first(), d = c.attr("data-lazy"), e = c.attr("data-srcset"), f = c.attr("data-sizes") || h.$slider.attr("data-sizes"), g = document.createElement("img"), g.onload = function () {
            e && (c.attr("srcset", e), f && c.attr("sizes", f)), c.attr("src", d).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), h.options.adaptiveHeight === !0 && h.setPosition(), h.$slider.trigger("lazyLoaded", [h, c, d]), h.progressiveLazyLoad()
        }, g.onerror = function () {
            b < 3 ? setTimeout(function () {
                h.progressiveLazyLoad(b + 1)
            }, 500) : (c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), h.$slider.trigger("lazyLoadError", [h, c, d]), h.progressiveLazyLoad())
        }, g.src = d) : h.$slider.trigger("allImagesLoaded", [h])
    }, b.prototype.refresh = function (b) {
        var c, d, e = this;
        d = e.slideCount - e.options.slidesToShow, !e.options.infinite && e.currentSlide > d && (e.currentSlide = d), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), c = e.currentSlide, e.destroy(!0), a.extend(e, e.initials, {currentSlide: c}), e.init(), b || e.changeSlide({
            data: {
                message: "index",
                index: c
            }
        }, !1)
    }, b.prototype.registerBreakpoints = function () {
        var b, c, d, e = this, f = e.options.responsive || null;
        if ("array" === a.type(f) && f.length) {
            e.respondTo = e.options.respondTo || "window";
            for (b in f) if (d = e.breakpoints.length - 1, f.hasOwnProperty(b)) {
                for (c = f[b].breakpoint; d >= 0;) e.breakpoints[d] && e.breakpoints[d] === c && e.breakpoints.splice(d, 1), d--;
                e.breakpoints.push(c), e.breakpointSettings[c] = f[b].settings
            }
            e.breakpoints.sort(function (a, b) {
                return e.options.mobileFirst ? a - b : b - a
            })
        }
    }, b.prototype.reinit = function () {
        var b = this;
        b.$slides = b.$slideTrack.children(b.options.slide).addClass("slick-slide"), b.slideCount = b.$slides.length, b.currentSlide >= b.slideCount && 0 !== b.currentSlide && (b.currentSlide = b.currentSlide - b.options.slidesToScroll), b.slideCount <= b.options.slidesToShow && (b.currentSlide = 0), b.registerBreakpoints(), b.setProps(), b.setupInfinite(), b.buildArrows(), b.updateArrows(), b.initArrowEvents(), b.buildDots(), b.updateDots(), b.initDotEvents(), b.cleanUpSlideEvents(), b.initSlideEvents(), b.checkResponsive(!1, !0), b.options.focusOnSelect === !0 && a(b.$slideTrack).children().on("click.slick", b.selectHandler), b.setSlideClasses("number" == typeof b.currentSlide ? b.currentSlide : 0), b.setPosition(), b.focusHandler(), b.paused = !b.options.autoplay, b.autoPlay(), b.$slider.trigger("reInit", [b])
    }, b.prototype.resize = function () {
        var b = this;
        a(window).width() !== b.windowWidth && (clearTimeout(b.windowDelay), b.windowDelay = window.setTimeout(function () {
            b.windowWidth = a(window).width(), b.checkResponsive(), b.unslicked || b.setPosition()
        }, 50))
    }, b.prototype.removeSlide = b.prototype.slickRemove = function (a, b, c) {
        var d = this;
        return "boolean" == typeof a ? (b = a, a = b === !0 ? 0 : d.slideCount - 1) : a = b === !0 ? --a : a, !(d.slideCount < 1 || a < 0 || a > d.slideCount - 1) && (d.unload(), c === !0 ? d.$slideTrack.children().remove() : d.$slideTrack.children(this.options.slide).eq(a).remove(), d.$slides = d.$slideTrack.children(this.options.slide), d.$slideTrack.children(this.options.slide).detach(), d.$slideTrack.append(d.$slides), d.$slidesCache = d.$slides, void d.reinit())
    }, b.prototype.setCSS = function (a) {
        var b, c, d = this, e = {};
        d.options.rtl === !0 && (a = -a), b = "left" == d.positionProp ? Math.ceil(a) + "px" : "0px", c = "top" == d.positionProp ? Math.ceil(a) + "px" : "0px", e[d.positionProp] = a, d.transformsEnabled === !1 ? d.$slideTrack.css(e) : (e = {}, d.cssTransitions === !1 ? (e[d.animType] = "translate(" + b + ", " + c + ")", d.$slideTrack.css(e)) : (e[d.animType] = "translate3d(" + b + ", " + c + ", 0px)", d.$slideTrack.css(e)))
    }, b.prototype.setDimensions = function () {
        var a = this;
        a.options.vertical === !1 ? a.options.centerMode === !0 && a.$list.css({padding: "0px " + a.options.centerPadding}) : (a.$list.height(a.$slides.first().outerHeight(!0) * a.options.slidesToShow), a.options.centerMode === !0 && a.$list.css({padding: a.options.centerPadding + " 0px"})), a.listWidth = a.$list.width(), a.listHeight = a.$list.height(), a.options.vertical === !1 && a.options.variableWidth === !1 ? (a.slideWidth = Math.ceil(a.listWidth / a.options.slidesToShow), a.$slideTrack.width(Math.ceil(a.slideWidth * a.$slideTrack.children(".slick-slide").length))) : a.options.variableWidth === !0 ? a.$slideTrack.width(5e3 * a.slideCount) : (a.slideWidth = Math.ceil(a.listWidth), a.$slideTrack.height(Math.ceil(a.$slides.first().outerHeight(!0) * a.$slideTrack.children(".slick-slide").length)));
        var b = a.$slides.first().outerWidth(!0) - a.$slides.first().width();
        a.options.variableWidth === !1 && a.$slideTrack.children(".slick-slide").width(a.slideWidth - b)
    }, b.prototype.setFade = function () {
        var b, c = this;
        c.$slides.each(function (d, e) {
            b = c.slideWidth * d * -1, c.options.rtl === !0 ? a(e).css({
                position: "relative",
                right: b,
                top: 0,
                zIndex: c.options.zIndex - 2,
                opacity: 0
            }) : a(e).css({position: "relative", left: b, top: 0, zIndex: c.options.zIndex - 2, opacity: 0})
        }), c.$slides.eq(c.currentSlide).css({zIndex: c.options.zIndex - 1, opacity: 1})
    }, b.prototype.setHeight = function () {
        var a = this;
        if (1 === a.options.slidesToShow && a.options.adaptiveHeight === !0 && a.options.vertical === !1) {
            var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
            a.$list.css("height", b)
        }
    }, b.prototype.setOption = b.prototype.slickSetOption = function () {
        var b, c, d, e, f, g = this, h = !1;
        if ("object" === a.type(arguments[0]) ? (d = arguments[0], h = arguments[1], f = "multiple") : "string" === a.type(arguments[0]) && (d = arguments[0], e = arguments[1], h = arguments[2], "responsive" === arguments[0] && "array" === a.type(arguments[1]) ? f = "responsive" : "undefined" != typeof arguments[1] && (f = "single")), "single" === f) g.options[d] = e; else if ("multiple" === f) a.each(d, function (a, b) {
            g.options[a] = b
        }); else if ("responsive" === f) for (c in e) if ("array" !== a.type(g.options.responsive)) g.options.responsive = [e[c]]; else {
            for (b = g.options.responsive.length - 1; b >= 0;) g.options.responsive[b].breakpoint === e[c].breakpoint && g.options.responsive.splice(b, 1), b--;
            g.options.responsive.push(e[c])
        }
        h && (g.unload(), g.reinit())
    }, b.prototype.setPosition = function () {
        var a = this;
        a.setDimensions(), a.setHeight(), a.options.fade === !1 ? a.setCSS(a.getLeft(a.currentSlide)) : a.setFade(), a.$slider.trigger("setPosition", [a])
    }, b.prototype.setProps = function () {
        var a = this, b = document.body.style;
        a.positionProp = a.options.vertical === !0 ? "top" : "left", "top" === a.positionProp ? a.$slider.addClass("slick-vertical") : a.$slider.removeClass("slick-vertical"), void 0 === b.WebkitTransition && void 0 === b.MozTransition && void 0 === b.msTransition || a.options.useCSS === !0 && (a.cssTransitions = !0), a.options.fade && ("number" == typeof a.options.zIndex ? a.options.zIndex < 3 && (a.options.zIndex = 3) : a.options.zIndex = a.defaults.zIndex), void 0 !== b.OTransform && (a.animType = "OTransform", a.transformType = "-o-transform", a.transitionType = "OTransition", void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)), void 0 !== b.MozTransform && (a.animType = "MozTransform", a.transformType = "-moz-transform", a.transitionType = "MozTransition", void 0 === b.perspectiveProperty && void 0 === b.MozPerspective && (a.animType = !1)), void 0 !== b.webkitTransform && (a.animType = "webkitTransform", a.transformType = "-webkit-transform", a.transitionType = "webkitTransition", void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)), void 0 !== b.msTransform && (a.animType = "msTransform", a.transformType = "-ms-transform", a.transitionType = "msTransition", void 0 === b.msTransform && (a.animType = !1)), void 0 !== b.transform && a.animType !== !1 && (a.animType = "transform", a.transformType = "transform", a.transitionType = "transition"), a.transformsEnabled = a.options.useTransform && null !== a.animType && a.animType !== !1
    }, b.prototype.setSlideClasses = function (a) {
        var b, c, d, e, f = this;
        if (c = f.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), f.$slides.eq(a).addClass("slick-current"), f.options.centerMode === !0) {
            var g = f.options.slidesToShow % 2 === 0 ? 1 : 0;
            b = Math.floor(f.options.slidesToShow / 2), f.options.infinite === !0 && (a >= b && a <= f.slideCount - 1 - b ? f.$slides.slice(a - b + g, a + b + 1).addClass("slick-active").attr("aria-hidden", "false") : (d = f.options.slidesToShow + a, c.slice(d - b + 1 + g, d + b + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === a ? c.eq(c.length - 1 - f.options.slidesToShow).addClass("slick-center") : a === f.slideCount - 1 && c.eq(f.options.slidesToShow).addClass("slick-center")), f.$slides.eq(a).addClass("slick-center")
        } else a >= 0 && a <= f.slideCount - f.options.slidesToShow ? f.$slides.slice(a, a + f.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : c.length <= f.options.slidesToShow ? c.addClass("slick-active").attr("aria-hidden", "false") : (e = f.slideCount % f.options.slidesToShow, d = f.options.infinite === !0 ? f.options.slidesToShow + a : a, f.options.slidesToShow == f.options.slidesToScroll && f.slideCount - a < f.options.slidesToShow ? c.slice(d - (f.options.slidesToShow - e), d + e).addClass("slick-active").attr("aria-hidden", "false") : c.slice(d, d + f.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
        "ondemand" !== f.options.lazyLoad && "anticipated" !== f.options.lazyLoad || f.lazyLoad()
    }, b.prototype.setupInfinite = function () {
        var b, c, d, e = this;
        if (e.options.fade === !0 && (e.options.centerMode = !1), e.options.infinite === !0 && e.options.fade === !1 && (c = null, e.slideCount > e.options.slidesToShow)) {
            for (d = e.options.centerMode === !0 ? e.options.slidesToShow + 1 : e.options.slidesToShow, b = e.slideCount; b > e.slideCount - d; b -= 1) c = b - 1, a(e.$slides[c]).clone(!0).attr("id", "").attr("data-slick-index", c - e.slideCount).prependTo(e.$slideTrack).addClass("slick-cloned");
            for (b = 0; b < d + e.slideCount; b += 1) c = b, a(e.$slides[c]).clone(!0).attr("id", "").attr("data-slick-index", c + e.slideCount).appendTo(e.$slideTrack).addClass("slick-cloned");
            e.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
                a(this).attr("id", "")
            })
        }
    }, b.prototype.interrupt = function (a) {
        var b = this;
        a || b.autoPlay(), b.interrupted = a
    }, b.prototype.selectHandler = function (b) {
        var c = this, d = a(b.target).is(".slick-slide") ? a(b.target) : a(b.target).parents(".slick-slide"),
            e = parseInt(d.attr("data-slick-index"));
        return e || (e = 0), c.slideCount <= c.options.slidesToShow ? void c.slideHandler(e, !1, !0) : void c.slideHandler(e)
    }, b.prototype.slideHandler = function (a, b, c) {
        var d, e, f, g, h, i = null, j = this;
        if (b = b || !1, !(j.animating === !0 && j.options.waitForAnimate === !0 || j.options.fade === !0 && j.currentSlide === a)) {
            if (d = a, i = j.getLeft(d), g = j.getLeft(j.currentSlide), j.currentLeft = null === j.swipeLeft ? g : j.swipeLeft, j.options.infinite === !1 && j.options.centerMode === !1 && (a < 0 || a > j.getDotCount() * j.options.slidesToScroll)) return void (j.options.fade === !1 && (d = j.currentSlide, c !== !0 && j.slideCount > j.options.slidesToShow ? j.animateSlide(g, function () {
                j.postSlide(d)
            }) : j.postSlide(d)));
            if (j.options.infinite === !1 && j.options.centerMode === !0 && (a < 0 || a > j.slideCount - j.options.slidesToScroll)) return void (j.options.fade === !1 && (d = j.currentSlide, c !== !0 && j.slideCount > j.options.slidesToShow ? j.animateSlide(g, function () {
                j.postSlide(d)
            }) : j.postSlide(d)));
            j.options.autoplay && clearInterval(j.autoPlayTimer), e = d < 0 ? j.slideCount % j.options.slidesToScroll !== 0 ? j.slideCount - j.slideCount % j.options.slidesToScroll : j.slideCount + d : d >= j.slideCount ? j.slideCount % j.options.slidesToScroll !== 0 ? 0 : d - j.slideCount : d, j.animating = !0;
            var k = jQuery.Event("beforeChange");
            return j.$slider.trigger(k, [j, j.currentSlide, e]), k.isDefaultPrevented() ? void (j.animating = !1) : (b === !1 && j.asNavFor(a), f = j.currentSlide, j.currentSlide = e, j.setSlideClasses(j.currentSlide), j.options.asNavFor && (h = j.getNavTarget(), h = h.slick("getSlick"), h.slideCount <= h.options.slidesToShow && h.setSlideClasses(j.currentSlide)), j.updateDots(), j.updateArrows(), j.options.fade === !0 ? (c !== !0 ? (j.fadeSlideOut(f), j.fadeSlide(e, function () {
                j.postSlide(e)
            })) : j.postSlide(e), void j.animateHeight()) : void (c !== !0 && j.slideCount > j.options.slidesToShow ? j.animateSlide(i, function () {
                j.postSlide(e)
            }) : j.postSlide(e)))
        }
    }, b.prototype.startLoad = function () {
        var a = this;
        a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.hide(), a.$nextArrow.hide()), a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.hide(), a.$slider.addClass("slick-loading")
    }, b.prototype.swipeDirection = function () {
        var a, b, c, d, e = this;
        return a = e.touchObject.startX - e.touchObject.curX, b = e.touchObject.startY - e.touchObject.curY, c = Math.atan2(b, a), d = Math.round(180 * c / Math.PI), d < 0 && (d = 360 - Math.abs(d)), d <= 45 && d >= 0 ? e.options.rtl === !1 ? "left" : "right" : d <= 360 && d >= 315 ? e.options.rtl === !1 ? "left" : "right" : d >= 135 && d <= 225 ? e.options.rtl === !1 ? "right" : "left" : e.options.verticalSwiping === !0 ? d >= 35 && d <= 135 ? "down" : "up" : "vertical"
    }, b.prototype.swipeEnd = function (a) {
        var b, c, d = this;
        if (d.dragging = !1, d.swiping = !1, d.scrolling) return d.scrolling = !1, !1;
        if (d.interrupted = !1, d.shouldClick = !(d.touchObject.swipeLength > 10), void 0 === d.touchObject.curX) return !1;
        if (d.touchObject.edgeHit === !0 && d.$slider.trigger("edge", [d, d.swipeDirection()]), d.touchObject.swipeLength >= d.touchObject.minSwipe) {
            switch (c = d.swipeDirection()) {
                case"left":
                case"down":
                    b = d.options.swipeToSlide ? d.checkNavigable(d.currentSlide + d.getSlideCount()) : d.currentSlide + d.getSlideCount(), d.currentDirection = 0;
                    break;
                case"right":
                case"up":
                    b = d.options.swipeToSlide ? d.checkNavigable(d.currentSlide - d.getSlideCount()) : d.currentSlide - d.getSlideCount(), d.currentDirection = 1
            }
            "vertical" != c && (d.slideHandler(b), d.touchObject = {}, d.$slider.trigger("swipe", [d, c]))
        } else d.touchObject.startX !== d.touchObject.curX && (d.slideHandler(d.currentSlide), d.touchObject = {})
    }, b.prototype.swipeHandler = function (a) {
        var b = this;
        if (!(b.options.swipe === !1 || "ontouchend" in document && b.options.swipe === !1 || b.options.draggable === !1 && a.type.indexOf("mouse") !== -1)) switch (b.touchObject.fingerCount = a.originalEvent && void 0 !== a.originalEvent.touches ? a.originalEvent.touches.length : 1, b.touchObject.minSwipe = b.listWidth / b.options.touchThreshold, b.options.verticalSwiping === !0 && (b.touchObject.minSwipe = b.listHeight / b.options.touchThreshold), a.data.action) {
            case"start":
                b.swipeStart(a);
                break;
            case"move":
                b.swipeMove(a);
                break;
            case"end":
                b.swipeEnd(a)
        }
    }, b.prototype.swipeMove = function (a) {
        var b, c, d, e, f, g, h = this;
        return f = void 0 !== a.originalEvent ? a.originalEvent.touches : null, !(!h.dragging || h.scrolling || f && 1 !== f.length) && (b = h.getLeft(h.currentSlide), h.touchObject.curX = void 0 !== f ? f[0].pageX : a.clientX, h.touchObject.curY = void 0 !== f ? f[0].pageY : a.clientY, h.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(h.touchObject.curX - h.touchObject.startX, 2))), g = Math.round(Math.sqrt(Math.pow(h.touchObject.curY - h.touchObject.startY, 2))), !h.options.verticalSwiping && !h.swiping && g > 4 ? (h.scrolling = !0, !1) : (h.options.verticalSwiping === !0 && (h.touchObject.swipeLength = g), c = h.swipeDirection(), void 0 !== a.originalEvent && h.touchObject.swipeLength > 4 && (h.swiping = !0, a.preventDefault()), e = (h.options.rtl === !1 ? 1 : -1) * (h.touchObject.curX > h.touchObject.startX ? 1 : -1), h.options.verticalSwiping === !0 && (e = h.touchObject.curY > h.touchObject.startY ? 1 : -1), d = h.touchObject.swipeLength, h.touchObject.edgeHit = !1, h.options.infinite === !1 && (0 === h.currentSlide && "right" === c || h.currentSlide >= h.getDotCount() && "left" === c) && (d = h.touchObject.swipeLength * h.options.edgeFriction, h.touchObject.edgeHit = !0), h.options.vertical === !1 ? h.swipeLeft = b + d * e : h.swipeLeft = b + d * (h.$list.height() / h.listWidth) * e, h.options.verticalSwiping === !0 && (h.swipeLeft = b + d * e), h.options.fade !== !0 && h.options.touchMove !== !1 && (h.animating === !0 ? (h.swipeLeft = null, !1) : void h.setCSS(h.swipeLeft))))
    }, b.prototype.swipeStart = function (a) {
        var b, c = this;
        return c.interrupted = !0, 1 !== c.touchObject.fingerCount || c.slideCount <= c.options.slidesToShow ? (c.touchObject = {}, !1) : (c.touchObject.swipeLength = 0, void 0 !== a.originalEvent && void 0 !== a.originalEvent.touches && (b = a.originalEvent.touches[0]), c.touchObject.startX = c.touchObject.curX = void 0 !== b ? b.pageX : a.clientX, c.touchObject.startY = c.touchObject.curY = void 0 !== b ? b.pageY : a.clientY, void (c.dragging = !0))
    }, b.prototype.unfilterSlides = b.prototype.slickUnfilter = function () {
        var a = this;
        null !== a.$slidesCache && (a.unload(), a.$slideTrack.children(this.options.slide).detach(), a.$slidesCache.appendTo(a.$slideTrack), a.reinit())
    }, b.prototype.unload = function () {
        var b = this;
        a(".slick-cloned", b.$slider).remove(), b.$dots && b.$dots.remove(), b.$prevArrow && b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.remove(), b.$nextArrow && b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.remove(), b.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }, b.prototype.unslick = function (a) {
        var b = this;
        b.$slider.trigger("unslick", [b, a]), b.destroy()
    }, b.prototype.updateArrows = function () {
        var a, b = this;
        a = Math.floor(b.options.slidesToShow / 2), b.options.arrows === !0 && b.slideCount > b.options.slidesToShow && !b.options.infinite && (b.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), b.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === b.currentSlide ? (b.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), b.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : b.currentSlide >= b.slideCount - b.options.slidesToShow && b.options.centerMode === !1 ? (b.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), b.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : b.currentSlide >= b.slideCount - 1 && b.options.centerMode === !0 && (b.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), b.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }, b.prototype.updateDots = function () {
        var a = this;
        null !== a.$dots && (a.$dots.find("li").removeClass("slick-active").end(), a.$dots.find("li").eq(Math.floor(a.currentSlide / a.options.slidesToScroll)).addClass("slick-active"))
    }, b.prototype.visibility = function () {
        var a = this;
        a.options.autoplay && (document[a.hidden] ? a.interrupted = !0 : a.interrupted = !1)
    }, a.fn.slick = function () {
        var a, c, d = this, e = arguments[0], f = Array.prototype.slice.call(arguments, 1), g = d.length;
        for (a = 0; a < g; a++) if ("object" == typeof e || "undefined" == typeof e ? d[a].slick = new b(d[a], e) : c = d[a].slick[e].apply(d[a].slick, f), "undefined" != typeof c) return c;
        return d
    }
}), define("views/activity-view", ["jquery", "underscore", "backbone", "slick-slider"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.eventDispatcher = window.app.eventDispatcher, this.slickOptions = {
                adaptiveHeight: !0,
                accessibility: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !1,
                dots: !0,
                dotsClass: "slider-dots",
                appendDots: this.$el,
                mobileFirst: !0,
                responsive: [{breakpoint: 640, settings: "unslick"}],
                customPaging: function () {
                    return "<span></span>"
                }
            }, this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.onViewportChange), this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.onResize)
        }, render: function () {
            return this.$(".activities").slick(this.slickOptions), this.calcModuleHeight(), this
        }, onViewportChange: function () {
            this.currentMediaQuery = window.app.matchMedia.getCurrentMediaQuery(), "media-to-m" === this.currentMediaQuery ? this.$(".activities").slick(this.slickOptions) : window.setTimeout(this.unslick.bind(this), 500)
        }, unslick: function () {
            this.$el.find(".activities.slick-initialized").slick("unslick")
        }, onResize: function () {
            window.setTimeout(this.calcModuleHeight.bind(this), 500)
        }, calcModuleHeight: function () {
            this.currentMediaQuery = window.app.matchMedia.getCurrentMediaQuery();
            var a = this.$(".activity-container"), b = this.$(".activities"), c = this.$(".text-header");
            "media-from-m-to-l" === this.currentMediaQuery ? (c.height() > b.height() ? (b.addClass("align-bottom"), b = c) : b.removeClass("align-bottom"), this.$el.hasClass("has-copytext") ? a.height(b.height()) : a.removeAttr("style")) : (a.removeAttr("style"), b.removeClass("align-bottom"))
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}),/*!
 * VERSION: 2.0.1
 * DATE: 2018-05-30
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 */
    function (a, b) {
        "use strict";
        var c = {}, d = a.document, e = a.GreenSockGlobals = a.GreenSockGlobals || a, f = e[b];
        if (f) return "undefined" != typeof module && module.exports && (module.exports = f), f;
        var g, h, i, j, k, l = function (a) {
            var b, c = a.split("."), d = e;
            for (b = 0; b < c.length; b++) d[c[b]] = d = d[c[b]] || {};
            return d
        }, m = l("com.greensock"), n = 1e-10, o = function (a) {
            var b, c = [], d = a.length;
            for (b = 0; b !== d; c.push(a[b++])) ;
            return c
        }, p = function () {
        }, q = function () {
            var a = Object.prototype.toString, b = a.call([]);
            return function (c) {
                return null != c && (c instanceof Array || "object" == typeof c && !!c.push && a.call(c) === b)
            }
        }(), r = {}, s = function (d, f, g, h) {
            this.sc = r[d] ? r[d].sc : [], r[d] = this, this.gsClass = null, this.func = g;
            var i = [];
            this.check = function (j) {
                for (var k, m, n, o, p = f.length, q = p; --p > -1;) (k = r[f[p]] || new s(f[p], [])).gsClass ? (i[p] = k.gsClass, q--) : j && k.sc.push(this);
                if (0 === q && g) {
                    if (m = ("com.greensock." + d).split("."), n = m.pop(), o = l(m.join("."))[n] = this.gsClass = g.apply(g, i), h) if (e[n] = c[n] = o, "undefined" != typeof module && module.exports) if (d === b) {
                        module.exports = c[b] = o;
                        for (p in c) o[p] = c[p]
                    } else c[b] && (c[b][n] = o); else "function" == typeof define && define.amd && define((a.GreenSockAMDPath ? a.GreenSockAMDPath + "/" : "") + d.split(".").pop(), [], function () {
                        return o
                    });
                    for (p = 0; p < this.sc.length; p++) this.sc[p].check()
                }
            }, this.check(!0)
        }, t = a._gsDefine = function (a, b, c, d) {
            return new s(a, b, c, d)
        }, u = m._class = function (a, b, c) {
            return b = b || function () {
            }, t(a, [], function () {
                return b
            }, c), b
        };
        t.globals = e;
        var v = [0, 0, 1, 1], w = u("easing.Ease", function (a, b, c, d) {
            this._func = a, this._type = c || 0, this._power = d || 0, this._params = b ? v.concat(b) : v
        }, !0), x = w.map = {}, y = w.register = function (a, b, c, d) {
            for (var e, f, g, h, i = b.split(","), j = i.length, k = (c || "easeIn,easeOut,easeInOut").split(","); --j > -1;) for (f = i[j], e = d ? u("easing." + f, null, !0) : m.easing[f] || {}, g = k.length; --g > -1;) h = k[g], x[f + "." + h] = x[h + f] = e[h] = a.getRatio ? a : a[h] || new a
        };
        for (i = w.prototype, i._calcEnd = !1, i.getRatio = function (a) {
            if (this._func) return this._params[0] = a, this._func.apply(null, this._params);
            var b = this._type, c = this._power, d = 1 === b ? 1 - a : 2 === b ? a : a < .5 ? 2 * a : 2 * (1 - a);
            return 1 === c ? d *= d : 2 === c ? d *= d * d : 3 === c ? d *= d * d * d : 4 === c && (d *= d * d * d * d), 1 === b ? 1 - d : 2 === b ? d : a < .5 ? d / 2 : 1 - d / 2
        }, g = ["Linear", "Quad", "Cubic", "Quart", "Quint,Strong"], h = g.length; --h > -1;) i = g[h] + ",Power" + h, y(new w(null, null, 1, h), i, "easeOut", !0), y(new w(null, null, 2, h), i, "easeIn" + (0 === h ? ",easeNone" : "")), y(new w(null, null, 3, h), i, "easeInOut");
        x.linear = m.easing.Linear.easeIn, x.swing = m.easing.Quad.easeInOut;
        var z = u("events.EventDispatcher", function (a) {
            this._listeners = {}, this._eventTarget = a || this
        });
        i = z.prototype, i.addEventListener = function (a, b, c, d, e) {
            e = e || 0;
            var f, g, h = this._listeners[a], i = 0;
            for (this !== j || k || j.wake(), null == h && (this._listeners[a] = h = []), g = h.length; --g > -1;) f = h[g], f.c === b && f.s === c ? h.splice(g, 1) : 0 === i && f.pr < e && (i = g + 1);
            h.splice(i, 0, {c: b, s: c, up: d, pr: e})
        }, i.removeEventListener = function (a, b) {
            var c, d = this._listeners[a];
            if (d) for (c = d.length; --c > -1;) if (d[c].c === b) return void d.splice(c, 1)
        }, i.dispatchEvent = function (a) {
            var b, c, d, e = this._listeners[a];
            if (e) for (b = e.length, b > 1 && (e = e.slice(0)), c = this._eventTarget; --b > -1;) d = e[b], d && (d.up ? d.c.call(d.s || c, {
                type: a,
                target: c
            }) : d.c.call(d.s || c))
        };
        var A = a.requestAnimationFrame, B = a.cancelAnimationFrame, C = Date.now || function () {
            return (new Date).getTime()
        }, D = C();
        for (g = ["ms", "moz", "webkit", "o"], h = g.length; --h > -1 && !A;) A = a[g[h] + "RequestAnimationFrame"], B = a[g[h] + "CancelAnimationFrame"] || a[g[h] + "CancelRequestAnimationFrame"];
        u("Ticker", function (a, b) {
            var c, e, f, g, h, i = this, l = C(), m = !(b === !1 || !A) && "auto", o = 500, q = 33, r = "tick",
                s = function (a) {
                    var b, d, j = C() - D;
                    j > o && (l += j - q), D += j, i.time = (D - l) / 1e3, b = i.time - h, (!c || b > 0 || a === !0) && (i.frame++, h += b + (b >= g ? .004 : g - b), d = !0), a !== !0 && (f = e(s)), d && i.dispatchEvent(r)
                };
            z.call(i), i.time = i.frame = 0, i.tick = function () {
                s(!0)
            }, i.lagSmoothing = function (a, b) {
                return arguments.length ? (o = a || 1 / n, void (q = Math.min(b, o, 0))) : o < 1 / n
            }, i.sleep = function () {
                null != f && (m && B ? B(f) : clearTimeout(f), e = p, f = null, i === j && (k = !1))
            }, i.wake = function (a) {
                null !== f ? i.sleep() : a ? l += -D + (D = C()) : i.frame > 10 && (D = C() - o + 5), e = 0 === c ? p : m && A ? A : function (a) {
                    return setTimeout(a, 1e3 * (h - i.time) + 1 | 0)
                }, i === j && (k = !0), s(2)
            }, i.fps = function (a) {
                return arguments.length ? (c = a, g = 1 / (c || 60), h = this.time + g, void i.wake()) : c
            }, i.useRAF = function (a) {
                return arguments.length ? (i.sleep(), m = a, void i.fps(c)) : m
            }, i.fps(a), setTimeout(function () {
                "auto" === m && i.frame < 5 && "hidden" !== (d || {}).visibilityState && i.useRAF(!1)
            }, 1500)
        }), i = m.Ticker.prototype = new m.events.EventDispatcher, i.constructor = m.Ticker;
        var E = u("core.Animation", function (a, b) {
            if (this.vars = b = b || {}, this._duration = this._totalDuration = a || 0, this._delay = Number(b.delay) || 0, this._timeScale = 1, this._active = b.immediateRender === !0, this.data = b.data, this._reversed = b.reversed === !0, Y) {
                k || j.wake();
                var c = this.vars.useFrames ? X : Y;
                c.add(this, c._time), this.vars.paused && this.paused(!0)
            }
        });
        j = E.ticker = new m.Ticker, i = E.prototype, i._dirty = i._gc = i._initted = i._paused = !1, i._totalTime = i._time = 0, i._rawPrevTime = -1, i._next = i._last = i._onUpdate = i._timeline = i.timeline = null, i._paused = !1;
        var F = function () {
            k && C() - D > 2e3 && ("hidden" !== (d || {}).visibilityState || !j.lagSmoothing()) && j.wake();
            var a = setTimeout(F, 2e3);
            a.unref && a.unref()
        };
        F(), i.play = function (a, b) {
            return null != a && this.seek(a, b), this.reversed(!1).paused(!1)
        }, i.pause = function (a, b) {
            return null != a && this.seek(a, b), this.paused(!0)
        }, i.resume = function (a, b) {
            return null != a && this.seek(a, b), this.paused(!1)
        }, i.seek = function (a, b) {
            return this.totalTime(Number(a), b !== !1)
        }, i.restart = function (a, b) {
            return this.reversed(!1).paused(!1).totalTime(a ? -this._delay : 0, b !== !1, !0)
        }, i.reverse = function (a, b) {
            return null != a && this.seek(a || this.totalDuration(), b), this.reversed(!0).paused(!1)
        }, i.render = function (a, b, c) {
        }, i.invalidate = function () {
            return this._time = this._totalTime = 0, this._initted = this._gc = !1, this._rawPrevTime = -1, !this._gc && this.timeline || this._enabled(!0), this
        }, i.isActive = function () {
            var a, b = this._timeline, c = this._startTime;
            return !b || !this._gc && !this._paused && b.isActive() && (a = b.rawTime(!0)) >= c && a < c + this.totalDuration() / this._timeScale - 1e-7
        }, i._enabled = function (a, b) {
            return k || j.wake(), this._gc = !a, this._active = this.isActive(), b !== !0 && (a && !this.timeline ? this._timeline.add(this, this._startTime - this._delay) : !a && this.timeline && this._timeline._remove(this, !0)), !1
        }, i._kill = function (a, b) {
            return this._enabled(!1, !1)
        }, i.kill = function (a, b) {
            return this._kill(a, b), this
        }, i._uncache = function (a) {
            for (var b = a ? this : this.timeline; b;) b._dirty = !0, b = b.timeline;
            return this
        }, i._swapSelfInParams = function (a) {
            for (var b = a.length, c = a.concat(); --b > -1;) "{self}" === a[b] && (c[b] = this);
            return c
        }, i._callback = function (a) {
            var b = this.vars, c = b[a], d = b[a + "Params"], e = b[a + "Scope"] || b.callbackScope || this,
                f = d ? d.length : 0;
            switch (f) {
                case 0:
                    c.call(e);
                    break;
                case 1:
                    c.call(e, d[0]);
                    break;
                case 2:
                    c.call(e, d[0], d[1]);
                    break;
                default:
                    c.apply(e, d)
            }
        }, i.eventCallback = function (a, b, c, d) {
            if ("on" === (a || "").substr(0, 2)) {
                var e = this.vars;
                if (1 === arguments.length) return e[a];
                null == b ? delete e[a] : (e[a] = b, e[a + "Params"] = q(c) && c.join("").indexOf("{self}") !== -1 ? this._swapSelfInParams(c) : c, e[a + "Scope"] = d), "onUpdate" === a && (this._onUpdate = b)
            }
            return this
        }, i.delay = function (a) {
            return arguments.length ? (this._timeline.smoothChildTiming && this.startTime(this._startTime + a - this._delay), this._delay = a, this) : this._delay
        }, i.duration = function (a) {
            return arguments.length ? (this._duration = this._totalDuration = a, this._uncache(!0), this._timeline.smoothChildTiming && this._time > 0 && this._time < this._duration && 0 !== a && this.totalTime(this._totalTime * (a / this._duration), !0), this) : (this._dirty = !1, this._duration)
        }, i.totalDuration = function (a) {
            return this._dirty = !1, arguments.length ? this.duration(a) : this._totalDuration
        }, i.time = function (a, b) {
            return arguments.length ? (this._dirty && this.totalDuration(), this.totalTime(a > this._duration ? this._duration : a, b)) : this._time
        }, i.totalTime = function (a, b, c) {
            if (k || j.wake(), !arguments.length) return this._totalTime;
            if (this._timeline) {
                if (a < 0 && !c && (a += this.totalDuration()), this._timeline.smoothChildTiming) {
                    this._dirty && this.totalDuration();
                    var d = this._totalDuration, e = this._timeline;
                    if (a > d && !c && (a = d), this._startTime = (this._paused ? this._pauseTime : e._time) - (this._reversed ? d - a : a) / this._timeScale, e._dirty || this._uncache(!1), e._timeline) for (; e._timeline;) e._timeline._time !== (e._startTime + e._totalTime) / e._timeScale && e.totalTime(e._totalTime, !0), e = e._timeline
                }
                this._gc && this._enabled(!0, !1), this._totalTime === a && 0 !== this._duration || (K.length && $(), this.render(a, b, !1), K.length && $())
            }
            return this
        }, i.progress = i.totalProgress = function (a, b) {
            var c = this.duration();
            return arguments.length ? this.totalTime(c * a, b) : c ? this._time / c : this.ratio
        }, i.startTime = function (a) {
            return arguments.length ? (a !== this._startTime && (this._startTime = a, this.timeline && this.timeline._sortChildren && this.timeline.add(this, a - this._delay)), this) : this._startTime
        }, i.endTime = function (a) {
            return this._startTime + (0 != a ? this.totalDuration() : this.duration()) / this._timeScale
        }, i.timeScale = function (a) {
            if (!arguments.length) return this._timeScale;
            var b, c;
            for (a = a || n, this._timeline && this._timeline.smoothChildTiming && (b = this._pauseTime, c = b || 0 === b ? b : this._timeline.totalTime(), this._startTime = c - (c - this._startTime) * this._timeScale / a), this._timeScale = a, c = this.timeline; c && c.timeline;) c._dirty = !0, c.totalDuration(), c = c.timeline;
            return this
        }, i.reversed = function (a) {
            return arguments.length ? (a != this._reversed && (this._reversed = a, this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, !0)), this) : this._reversed
        }, i.paused = function (a) {
            if (!arguments.length) return this._paused;
            var b, c, d = this._timeline;
            return a != this._paused && d && (k || a || j.wake(), b = d.rawTime(), c = b - this._pauseTime, !a && d.smoothChildTiming && (this._startTime += c, this._uncache(!1)), this._pauseTime = a ? b : null, this._paused = a, this._active = this.isActive(), !a && 0 !== c && this._initted && this.duration() && (b = d.smoothChildTiming ? this._totalTime : (b - this._startTime) / this._timeScale, this.render(b, b === this._totalTime, !0))), this._gc && !a && this._enabled(!0, !1), this
        };
        var G = u("core.SimpleTimeline", function (a) {
            E.call(this, 0, a), this.autoRemoveChildren = this.smoothChildTiming = !0
        });
        i = G.prototype = new E, i.constructor = G, i.kill()._gc = !1, i._first = i._last = i._recent = null, i._sortChildren = !1, i.add = i.insert = function (a, b, c, d) {
            var e, f;
            if (a._startTime = Number(b || 0) + a._delay, a._paused && this !== a._timeline && (a._pauseTime = this.rawTime() - (a._timeline.rawTime() - a._pauseTime)), a.timeline && a.timeline._remove(a, !0), a.timeline = a._timeline = this, a._gc && a._enabled(!0, !0), e = this._last, this._sortChildren) for (f = a._startTime; e && e._startTime > f;) e = e._prev;
            return e ? (a._next = e._next, e._next = a) : (a._next = this._first, this._first = a), a._next ? a._next._prev = a : this._last = a, a._prev = e, this._recent = a, this._timeline && this._uncache(!0), this
        }, i._remove = function (a, b) {
            return a.timeline === this && (b || a._enabled(!1, !0), a._prev ? a._prev._next = a._next : this._first === a && (this._first = a._next), a._next ? a._next._prev = a._prev : this._last === a && (this._last = a._prev), a._next = a._prev = a.timeline = null, a === this._recent && (this._recent = this._last), this._timeline && this._uncache(!0)), this
        }, i.render = function (a, b, c) {
            var d, e = this._first;
            for (this._totalTime = this._time = this._rawPrevTime = a; e;) d = e._next, (e._active || a >= e._startTime && !e._paused && !e._gc) && (e._reversed ? e.render((e._dirty ? e.totalDuration() : e._totalDuration) - (a - e._startTime) * e._timeScale, b, c) : e.render((a - e._startTime) * e._timeScale, b, c)), e = d
        }, i.rawTime = function () {
            return k || j.wake(), this._totalTime
        };
        var H = u("TweenLite", function (b, c, d) {
            if (E.call(this, c, d), this.render = H.prototype.render, null == b) throw"Cannot tween a null target.";
            this.target = b = "string" != typeof b ? b : H.selector(b) || b;
            var e, f, g,
                h = b.jquery || b.length && b !== a && b[0] && (b[0] === a || b[0].nodeType && b[0].style && !b.nodeType),
                i = this.vars.overwrite;
            if (this._overwrite = i = null == i ? W[H.defaultOverwrite] : "number" == typeof i ? i >> 0 : W[i], (h || b instanceof Array || b.push && q(b)) && "number" != typeof b[0]) for (this._targets = g = o(b), this._propLookup = [], this._siblings = [], e = 0; e < g.length; e++) f = g[e], f ? "string" != typeof f ? f.length && f !== a && f[0] && (f[0] === a || f[0].nodeType && f[0].style && !f.nodeType) ? (g.splice(e--, 1), this._targets = g = g.concat(o(f))) : (this._siblings[e] = _(f, this, !1), 1 === i && this._siblings[e].length > 1 && ba(f, this, null, 1, this._siblings[e])) : (f = g[e--] = H.selector(f), "string" == typeof f && g.splice(e + 1, 1)) : g.splice(e--, 1); else this._propLookup = {}, this._siblings = _(b, this, !1), 1 === i && this._siblings.length > 1 && ba(b, this, null, 1, this._siblings);
            (this.vars.immediateRender || 0 === c && 0 === this._delay && this.vars.immediateRender !== !1) && (this._time = -n, this.render(Math.min(0, -this._delay)))
        }, !0), I = function (b) {
            return b && b.length && b !== a && b[0] && (b[0] === a || b[0].nodeType && b[0].style && !b.nodeType)
        }, J = function (a, b) {
            var c, d = {};
            for (c in a) V[c] || c in b && "transform" !== c && "x" !== c && "y" !== c && "width" !== c && "height" !== c && "className" !== c && "border" !== c || !(!S[c] || S[c] && S[c]._autoCSS) || (d[c] = a[c], delete a[c]);
            a.css = d
        };
        i = H.prototype = new E, i.constructor = H, i.kill()._gc = !1, i.ratio = 0, i._firstPT = i._targets = i._overwrittenProps = i._startAt = null, i._notifyPluginsOfEnabled = i._lazy = !1, H.version = "2.0.1", H.defaultEase = i._ease = new w(null, null, 1, 1), H.defaultOverwrite = "auto", H.ticker = j, H.autoSleep = 120, H.lagSmoothing = function (a, b) {
            j.lagSmoothing(a, b)
        }, H.selector = a.$ || a.jQuery || function (b) {
            var c = a.$ || a.jQuery;
            return c ? (H.selector = c, c(b)) : (d || (d = a.document), d ? d.querySelectorAll ? d.querySelectorAll(b) : d.getElementById("#" === b.charAt(0) ? b.substr(1) : b) : b)
        };
        var K = [], L = {}, M = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi, N = /[\+-]=-?[\.\d]/,
            O = function (a) {
                for (var b, c = this._firstPT, d = 1e-6; c;) b = c.blob ? 1 === a && null != this.end ? this.end : a ? this.join("") : this.start : c.c * a + c.s, c.m ? b = c.m.call(this._tween, b, this._target || c.t, this._tween) : b < d && b > -d && !c.blob && (b = 0), c.f ? c.fp ? c.t[c.p](c.fp, b) : c.t[c.p](b) : c.t[c.p] = b, c = c._next
            }, P = function (a, b, c, d) {
                var e, f, g, h, i, j, k, l = [], m = 0, n = "", o = 0;
                for (l.start = a, l.end = b, a = l[0] = a + "", b = l[1] = b + "", c && (c(l), a = l[0], b = l[1]), l.length = 0, e = a.match(M) || [], f = b.match(M) || [], d && (d._next = null, d.blob = 1, l._firstPT = l._applyPT = d), i = f.length, h = 0; h < i; h++) k = f[h], j = b.substr(m, b.indexOf(k, m) - m), n += j || !h ? j : ",", m += j.length, o ? o = (o + 1) % 5 : "rgba(" === j.substr(-5) && (o = 1), k === e[h] || e.length <= h ? n += k : (n && (l.push(n), n = ""), g = parseFloat(e[h]), l.push(g), l._firstPT = {
                    _next: l._firstPT,
                    t: l,
                    p: l.length - 1,
                    s: g,
                    c: ("=" === k.charAt(1) ? parseInt(k.charAt(0) + "1", 10) * parseFloat(k.substr(2)) : parseFloat(k) - g) || 0,
                    f: 0,
                    m: o && o < 4 ? Math.round : 0
                }), m += k.length;
                return n += b.substr(m), n && l.push(n), l.setRatio = O, N.test(b) && (l.end = null), l
            }, Q = function (a, b, c, d, e, f, g, h, i) {
                "function" == typeof d && (d = d(i || 0, a));
                var j, k = typeof a[b],
                    l = "function" !== k ? "" : b.indexOf("set") || "function" != typeof a["get" + b.substr(3)] ? b : "get" + b.substr(3),
                    m = "get" !== c ? c : l ? g ? a[l](g) : a[l]() : a[b], n = "string" == typeof d && "=" === d.charAt(1),
                    o = {
                        t: a,
                        p: b,
                        s: m,
                        f: "function" === k,
                        pg: 0,
                        n: e || b,
                        m: f ? "function" == typeof f ? f : Math.round : 0,
                        pr: 0,
                        c: n ? parseInt(d.charAt(0) + "1", 10) * parseFloat(d.substr(2)) : parseFloat(d) - m || 0
                    };
                if (("number" != typeof m || "number" != typeof d && !n) && (g || isNaN(m) || !n && isNaN(d) || "boolean" == typeof m || "boolean" == typeof d ? (o.fp = g, j = P(m, n ? parseFloat(o.s) + o.c + (o.s + "").replace(/[0-9\-\.]/g, "") : d, h || H.defaultStringFilter, o), o = {
                    t: j,
                    p: "setRatio",
                    s: 0,
                    c: 1,
                    f: 2,
                    pg: 0,
                    n: e || b,
                    pr: 0,
                    m: 0
                }) : (o.s = parseFloat(m), n || (o.c = parseFloat(d) - o.s || 0))), o.c) return (o._next = this._firstPT) && (o._next._prev = o), this._firstPT = o, o
            }, R = H._internals = {isArray: q, isSelector: I, lazyTweens: K, blobDif: P}, S = H._plugins = {},
            T = R.tweenLookup = {}, U = 0, V = R.reservedProps = {
                ease: 1,
                delay: 1,
                overwrite: 1,
                onComplete: 1,
                onCompleteParams: 1,
                onCompleteScope: 1,
                useFrames: 1,
                runBackwards: 1,
                startAt: 1,
                onUpdate: 1,
                onUpdateParams: 1,
                onUpdateScope: 1,
                onStart: 1,
                onStartParams: 1,
                onStartScope: 1,
                onReverseComplete: 1,
                onReverseCompleteParams: 1,
                onReverseCompleteScope: 1,
                onRepeat: 1,
                onRepeatParams: 1,
                onRepeatScope: 1,
                easeParams: 1,
                yoyo: 1,
                immediateRender: 1,
                repeat: 1,
                repeatDelay: 1,
                data: 1,
                paused: 1,
                reversed: 1,
                autoCSS: 1,
                lazy: 1,
                onOverwrite: 1,
                callbackScope: 1,
                stringFilter: 1,
                id: 1,
                yoyoEase: 1
            }, W = {none: 0, all: 1, auto: 2, concurrent: 3, allOnStart: 4, preexisting: 5, true: 1, false: 0},
            X = E._rootFramesTimeline = new G, Y = E._rootTimeline = new G, Z = 30, $ = R.lazyRender = function () {
                var a, b = K.length;
                for (L = {}; --b > -1;) a = K[b], a && a._lazy !== !1 && (a.render(a._lazy[0], a._lazy[1], !0), a._lazy = !1);
                K.length = 0
            };
        Y._startTime = j.time, X._startTime = j.frame, Y._active = X._active = !0, setTimeout($, 1), E._updateRoot = H.render = function () {
            var a, b, c;
            if (K.length && $(), Y.render((j.time - Y._startTime) * Y._timeScale, !1, !1), X.render((j.frame - X._startTime) * X._timeScale, !1, !1), K.length && $(), j.frame >= Z) {
                Z = j.frame + (parseInt(H.autoSleep, 10) || 120);
                for (c in T) {
                    for (b = T[c].tweens, a = b.length; --a > -1;) b[a]._gc && b.splice(a, 1);
                    0 === b.length && delete T[c]
                }
                if (c = Y._first, (!c || c._paused) && H.autoSleep && !X._first && 1 === j._listeners.tick.length) {
                    for (; c && c._paused;) c = c._next;
                    c || j.sleep()
                }
            }
        }, j.addEventListener("tick", E._updateRoot);
        var _ = function (a, b, c) {
            var d, e, f = a._gsTweenID;
            if (T[f || (a._gsTweenID = f = "t" + U++)] || (T[f] = {
                target: a,
                tweens: []
            }), b && (d = T[f].tweens, d[e = d.length] = b, c)) for (; --e > -1;) d[e] === b && d.splice(e, 1);
            return T[f].tweens
        }, aa = function (a, b, c, d) {
            var e, f, g = a.vars.onOverwrite;
            return g && (e = g(a, b, c, d)), g = H.onOverwrite, g && (f = g(a, b, c, d)), e !== !1 && f !== !1
        }, ba = function (a, b, c, d, e) {
            var f, g, h, i;
            if (1 === d || d >= 4) {
                for (i = e.length, f = 0; f < i; f++) if ((h = e[f]) !== b) h._gc || h._kill(null, a, b) && (g = !0); else if (5 === d) break;
                return g
            }
            var j, k = b._startTime + n, l = [], m = 0, o = 0 === b._duration;
            for (f = e.length; --f > -1;) (h = e[f]) === b || h._gc || h._paused || (h._timeline !== b._timeline ? (j = j || ca(b, 0, o), 0 === ca(h, j, o) && (l[m++] = h)) : h._startTime <= k && h._startTime + h.totalDuration() / h._timeScale > k && ((o || !h._initted) && k - h._startTime <= 2e-10 || (l[m++] = h)));
            for (f = m; --f > -1;) if (h = l[f], 2 === d && h._kill(c, a, b) && (g = !0), 2 !== d || !h._firstPT && h._initted) {
                if (2 !== d && !aa(h, b)) continue;
                h._enabled(!1, !1) && (g = !0)
            }
            return g
        }, ca = function (a, b, c) {
            for (var d = a._timeline, e = d._timeScale, f = a._startTime; d._timeline;) {
                if (f += d._startTime, e *= d._timeScale, d._paused) return -100;
                d = d._timeline
            }
            return f /= e, f > b ? f - b : c && f === b || !a._initted && f - b < 2 * n ? n : (f += a.totalDuration() / a._timeScale / e) > b + n ? 0 : f - b - n
        };
        i._init = function () {
            var a, b, c, d, e, f, g = this.vars, h = this._overwrittenProps, i = this._duration,
                j = !!g.immediateRender, k = g.ease;
            if (g.startAt) {
                this._startAt && (this._startAt.render(-1, !0), this._startAt.kill()), e = {};
                for (d in g.startAt) e[d] = g.startAt[d];
                if (e.data = "isStart", e.overwrite = !1, e.immediateRender = !0, e.lazy = j && g.lazy !== !1, e.startAt = e.delay = null, e.onUpdate = g.onUpdate, e.onUpdateParams = g.onUpdateParams, e.onUpdateScope = g.onUpdateScope || g.callbackScope || this, this._startAt = H.to(this.target || {}, 0, e), j) if (this._time > 0) this._startAt = null; else if (0 !== i) return
            } else if (g.runBackwards && 0 !== i) if (this._startAt) this._startAt.render(-1, !0), this._startAt.kill(), this._startAt = null; else {
                0 !== this._time && (j = !1), c = {};
                for (d in g) V[d] && "autoCSS" !== d || (c[d] = g[d]);
                if (c.overwrite = 0, c.data = "isFromStart", c.lazy = j && g.lazy !== !1, c.immediateRender = j, this._startAt = H.to(this.target, 0, c), j) {
                    if (0 === this._time) return
                } else this._startAt._init(), this._startAt._enabled(!1), this.vars.immediateRender && (this._startAt = null)
            }
            if (this._ease = k = k ? k instanceof w ? k : "function" == typeof k ? new w(k, g.easeParams) : x[k] || H.defaultEase : H.defaultEase, g.easeParams instanceof Array && k.config && (this._ease = k.config.apply(k, g.easeParams)), this._easeType = this._ease._type, this._easePower = this._ease._power, this._firstPT = null, this._targets) for (f = this._targets.length, a = 0; a < f; a++) this._initProps(this._targets[a], this._propLookup[a] = {}, this._siblings[a], h ? h[a] : null, a) && (b = !0); else b = this._initProps(this.target, this._propLookup, this._siblings, h, 0);
            if (b && H._onPluginEvent("_onInitAllProps", this), h && (this._firstPT || "function" != typeof this.target && this._enabled(!1, !1)), g.runBackwards) for (c = this._firstPT; c;) c.s += c.c, c.c = -c.c, c = c._next;
            this._onUpdate = g.onUpdate, this._initted = !0
        }, i._initProps = function (b, c, d, e, f) {
            var g, h, i, j, k, l;
            if (null == b) return !1;
            L[b._gsTweenID] && $(), this.vars.css || b.style && b !== a && b.nodeType && S.css && this.vars.autoCSS !== !1 && J(this.vars, b);
            for (g in this.vars) if (l = this.vars[g], V[g]) l && (l instanceof Array || l.push && q(l)) && l.join("").indexOf("{self}") !== -1 && (this.vars[g] = l = this._swapSelfInParams(l, this)); else if (S[g] && (j = new S[g])._onInitTween(b, this.vars[g], this, f)) {
                for (this._firstPT = k = {
                    _next: this._firstPT,
                    t: j,
                    p: "setRatio",
                    s: 0,
                    c: 1,
                    f: 1,
                    n: g,
                    pg: 1,
                    pr: j._priority,
                    m: 0
                }, h = j._overwriteProps.length; --h > -1;) c[j._overwriteProps[h]] = this._firstPT;
                (j._priority || j._onInitAllProps) && (i = !0), (j._onDisable || j._onEnable) && (this._notifyPluginsOfEnabled = !0), k._next && (k._next._prev = k)
            } else c[g] = Q.call(this, b, g, "get", l, g, 0, null, this.vars.stringFilter, f);
            return e && this._kill(e, b) ? this._initProps(b, c, d, e, f) : this._overwrite > 1 && this._firstPT && d.length > 1 && ba(b, this, c, this._overwrite, d) ? (this._kill(c, b), this._initProps(b, c, d, e, f)) : (this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration) && (L[b._gsTweenID] = !0), i)
        }, i.render = function (a, b, c) {
            var d, e, f, g, h = this._time, i = this._duration, j = this._rawPrevTime;
            if (a >= i - 1e-7 && a >= 0) this._totalTime = this._time = i, this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1, this._reversed || (d = !0, e = "onComplete", c = c || this._timeline.autoRemoveChildren), 0 === i && (this._initted || !this.vars.lazy || c) && (this._startTime === this._timeline._duration && (a = 0), (j < 0 || a <= 0 && a >= -1e-7 || j === n && "isPause" !== this.data) && j !== a && (c = !0, j > n && (e = "onReverseComplete")), this._rawPrevTime = g = !b || a || j === a ? a : n); else if (a < 1e-7) this._totalTime = this._time = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0, (0 !== h || 0 === i && j > 0) && (e = "onReverseComplete", d = this._reversed), a < 0 && (this._active = !1, 0 === i && (this._initted || !this.vars.lazy || c) && (j >= 0 && (j !== n || "isPause" !== this.data) && (c = !0), this._rawPrevTime = g = !b || a || j === a ? a : n)), (!this._initted || this._startAt && this._startAt.progress()) && (c = !0); else if (this._totalTime = this._time = a, this._easeType) {
                var k = a / i, l = this._easeType, m = this._easePower;
                (1 === l || 3 === l && k >= .5) && (k = 1 - k), 3 === l && (k *= 2), 1 === m ? k *= k : 2 === m ? k *= k * k : 3 === m ? k *= k * k * k : 4 === m && (k *= k * k * k * k), 1 === l ? this.ratio = 1 - k : 2 === l ? this.ratio = k : a / i < .5 ? this.ratio = k / 2 : this.ratio = 1 - k / 2
            } else this.ratio = this._ease.getRatio(a / i);
            if (this._time !== h || c) {
                if (!this._initted) {
                    if (this._init(), !this._initted || this._gc) return;
                    if (!c && this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration)) return this._time = this._totalTime = h, this._rawPrevTime = j, K.push(this), void (this._lazy = [a, b]);
                    this._time && !d ? this.ratio = this._ease.getRatio(this._time / i) : d && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1))
                }
                for (this._lazy !== !1 && (this._lazy = !1), this._active || !this._paused && this._time !== h && a >= 0 && (this._active = !0), 0 === h && (this._startAt && (a >= 0 ? this._startAt.render(a, !0, c) : e || (e = "_dummyGS")), this.vars.onStart && (0 === this._time && 0 !== i || b || this._callback("onStart"))), f = this._firstPT; f;) f.f ? f.t[f.p](f.c * this.ratio + f.s) : f.t[f.p] = f.c * this.ratio + f.s, f = f._next;
                this._onUpdate && (a < 0 && this._startAt && a !== -1e-4 && this._startAt.render(a, !0, c), b || (this._time !== h || d || c) && this._callback("onUpdate")), e && (this._gc && !c || (a < 0 && this._startAt && !this._onUpdate && a !== -1e-4 && this._startAt.render(a, !0, c), d && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !b && this.vars[e] && this._callback(e), 0 === i && this._rawPrevTime === n && g !== n && (this._rawPrevTime = 0)))
            }
        }, i._kill = function (a, b, c) {
            if ("all" === a && (a = null), null == a && (null == b || b === this.target)) return this._lazy = !1, this._enabled(!1, !1);
            b = "string" != typeof b ? b || this._targets || this.target : H.selector(b) || b;
            var d, e, f, g, h, i, j, k, l,
                m = c && this._time && c._startTime === this._startTime && this._timeline === c._timeline;
            if ((q(b) || I(b)) && "number" != typeof b[0]) for (d = b.length; --d > -1;) this._kill(a, b[d], c) && (i = !0); else {
                if (this._targets) {
                    for (d = this._targets.length; --d > -1;) if (b === this._targets[d]) {
                        h = this._propLookup[d] || {}, this._overwrittenProps = this._overwrittenProps || [], e = this._overwrittenProps[d] = a ? this._overwrittenProps[d] || {} : "all";
                        break
                    }
                } else {
                    if (b !== this.target) return !1;
                    h = this._propLookup, e = this._overwrittenProps = a ? this._overwrittenProps || {} : "all"
                }
                if (h) {
                    if (j = a || h, k = a !== e && "all" !== e && a !== h && ("object" != typeof a || !a._tempKill), c && (H.onOverwrite || this.vars.onOverwrite)) {
                        for (f in j) h[f] && (l || (l = []), l.push(f));
                        if ((l || !a) && !aa(this, c, b, l)) return !1
                    }
                    for (f in j) (g = h[f]) && (m && (g.f ? g.t[g.p](g.s) : g.t[g.p] = g.s, i = !0), g.pg && g.t._kill(j) && (i = !0), g.pg && 0 !== g.t._overwriteProps.length || (g._prev ? g._prev._next = g._next : g === this._firstPT && (this._firstPT = g._next), g._next && (g._next._prev = g._prev), g._next = g._prev = null), delete h[f]), k && (e[f] = 1);
                    !this._firstPT && this._initted && this._enabled(!1, !1)
                }
            }
            return i
        }, i.invalidate = function () {
            return this._notifyPluginsOfEnabled && H._onPluginEvent("_onDisable", this), this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null, this._notifyPluginsOfEnabled = this._active = this._lazy = !1, this._propLookup = this._targets ? {} : [], E.prototype.invalidate.call(this), this.vars.immediateRender && (this._time = -n, this.render(Math.min(0, -this._delay))), this
        }, i._enabled = function (a, b) {
            if (k || j.wake(), a && this._gc) {
                var c, d = this._targets;
                if (d) for (c = d.length; --c > -1;) this._siblings[c] = _(d[c], this, !0); else this._siblings = _(this.target, this, !0)
            }
            return E.prototype._enabled.call(this, a, b), !(!this._notifyPluginsOfEnabled || !this._firstPT) && H._onPluginEvent(a ? "_onEnable" : "_onDisable", this)
        }, H.to = function (a, b, c) {
            return new H(a, b, c)
        }, H.from = function (a, b, c) {
            return c.runBackwards = !0, c.immediateRender = 0 != c.immediateRender, new H(a, b, c)
        }, H.fromTo = function (a, b, c, d) {
            return d.startAt = c, d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender, new H(a, b, d)
        }, H.delayedCall = function (a, b, c, d, e) {
            return new H(b, 0, {
                delay: a,
                onComplete: b,
                onCompleteParams: c,
                callbackScope: d,
                onReverseComplete: b,
                onReverseCompleteParams: c,
                immediateRender: !1,
                lazy: !1,
                useFrames: e,
                overwrite: 0
            })
        }, H.set = function (a, b) {
            return new H(a, 0, b)
        }, H.getTweensOf = function (a, b) {
            if (null == a) return [];
            a = "string" != typeof a ? a : H.selector(a) || a;
            var c, d, e, f;
            if ((q(a) || I(a)) && "number" != typeof a[0]) {
                for (c = a.length, d = []; --c > -1;) d = d.concat(H.getTweensOf(a[c], b));
                for (c = d.length; --c > -1;) for (f = d[c], e = c; --e > -1;) f === d[e] && d.splice(c, 1)
            } else if (a._gsTweenID) for (d = _(a).concat(), c = d.length; --c > -1;) (d[c]._gc || b && !d[c].isActive()) && d.splice(c, 1);
            return d || []
        }, H.killTweensOf = H.killDelayedCallsTo = function (a, b, c) {
            "object" == typeof b && (c = b, b = !1);
            for (var d = H.getTweensOf(a, b), e = d.length; --e > -1;) d[e]._kill(c, a)
        };
        var da = u("plugins.TweenPlugin", function (a, b) {
            this._overwriteProps = (a || "").split(","), this._propName = this._overwriteProps[0], this._priority = b || 0, this._super = da.prototype
        }, !0);
        if (i = da.prototype, da.version = "1.19.0", da.API = 2, i._firstPT = null, i._addTween = Q, i.setRatio = O, i._kill = function (a) {
            var b, c = this._overwriteProps, d = this._firstPT;
            if (null != a[this._propName]) this._overwriteProps = []; else for (b = c.length; --b > -1;) null != a[c[b]] && c.splice(b, 1);
            for (; d;) null != a[d.n] && (d._next && (d._next._prev = d._prev), d._prev ? (d._prev._next = d._next, d._prev = null) : this._firstPT === d && (this._firstPT = d._next)), d = d._next;
            return !1
        }, i._mod = i._roundProps = function (a) {
            for (var b, c = this._firstPT; c;) b = a[this._propName] || null != c.n && a[c.n.split(this._propName + "_").join("")], b && "function" == typeof b && (2 === c.f ? c.t._applyPT.m = b : c.m = b), c = c._next
        }, H._onPluginEvent = function (a, b) {
            var c, d, e, f, g, h = b._firstPT;
            if ("_onInitAllProps" === a) {
                for (; h;) {
                    for (g = h._next, d = e; d && d.pr > h.pr;) d = d._next;
                    (h._prev = d ? d._prev : f) ? h._prev._next = h : e = h, (h._next = d) ? d._prev = h : f = h, h = g
                }
                h = b._firstPT = e
            }
            for (; h;) h.pg && "function" == typeof h.t[a] && h.t[a]() && (c = !0), h = h._next;
            return c
        }, da.activate = function (a) {
            for (var b = a.length; --b > -1;) a[b].API === da.API && (S[(new a[b])._propName] = a[b]);
            return !0
        }, t.plugin = function (a) {
            if (!(a && a.propName && a.init && a.API)) throw"illegal plugin definition.";
            var b, c = a.propName, d = a.priority || 0, e = a.overwriteProps, f = {
                init: "_onInitTween",
                set: "setRatio",
                kill: "_kill",
                round: "_mod",
                mod: "_mod",
                initAll: "_onInitAllProps"
            }, g = u("plugins." + c.charAt(0).toUpperCase() + c.substr(1) + "Plugin", function () {
                da.call(this, c, d), this._overwriteProps = e || []
            }, a.global === !0), h = g.prototype = new da(c);
            h.constructor = g, g.API = a.API;
            for (b in f) "function" == typeof a[b] && (h[f[b]] = a[b]);
            return g.version = a.version, da.activate([g]), g
        }, g = a._gsQueue) {
            for (h = 0; h < g.length; h++) g[h]();
            for (i in r) r[i].func || a.console.log("GSAP encountered missing dependency: " + i)
        }
        k = !1
    }("undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window, "TweenLite"), define("TweenLite", function () {
}),/*!
 * mustache.js - Logic-less {{mustache}} templates with JavaScript
 * http://github.com/janl/mustache.js
 */
    function (a, b) {
        "object" == typeof exports && exports && "string" != typeof exports.nodeName ? b(exports) : "function" == typeof define && define.amd ? define("mustache", ["exports"], b) : (a.Mustache = {}, b(a.Mustache))
    }(this, function (a) {
        function b(a) {
            return "function" == typeof a
        }

        function c(a) {
            return p(a) ? "array" : typeof a
        }

        function d(a) {
            return a.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&")
        }

        function e(a, b) {
            return null != a && "object" == typeof a && b in a
        }

        function f(a, b) {
            return q.call(a, b)
        }

        function g(a) {
            return !f(r, a)
        }

        function h(a) {
            return String(a).replace(/[&<>"'`=\/]/g, function (a) {
                return s[a]
            })
        }

        function i(b, c) {
            function e() {
                if (r && !s) for (; q.length;) delete o[q.pop()]; else q = [];
                r = !1, s = !1
            }

            function f(a) {
                if ("string" == typeof a && (a = a.split(u, 2)), !p(a) || 2 !== a.length) throw new Error("Invalid tags: " + a);
                h = new RegExp(d(a[0]) + "\\s*"), i = new RegExp("\\s*" + d(a[1])), m = new RegExp("\\s*" + d("}" + a[1]))
            }

            if (!b) return [];
            var h, i, m, n = [], o = [], q = [], r = !1, s = !1;
            f(c || a.tags);
            for (var y, z, A, B, C, D, E = new l(b); !E.eos();) {
                if (y = E.pos, A = E.scanUntil(h)) for (var F = 0, G = A.length; F < G; ++F) B = A.charAt(F), g(B) ? q.push(o.length) : s = !0, o.push(["text", B, y, y + 1]), y += 1, "\n" === B && e();
                if (!E.scan(h)) break;
                if (r = !0, z = E.scan(x) || "name", E.scan(t), "=" === z ? (A = E.scanUntil(v), E.scan(v), E.scanUntil(i)) : "{" === z ? (A = E.scanUntil(m), E.scan(w), E.scanUntil(i), z = "&") : A = E.scanUntil(i), !E.scan(i)) throw new Error("Unclosed tag at " + E.pos);
                if (C = [z, A, y, E.pos], o.push(C), "#" === z || "^" === z) n.push(C); else if ("/" === z) {
                    if (D = n.pop(), !D) throw new Error('Unopened section "' + A + '" at ' + y);
                    if (D[1] !== A) throw new Error('Unclosed section "' + D[1] + '" at ' + y)
                } else "name" === z || "{" === z || "&" === z ? s = !0 : "=" === z && f(A)
            }
            if (D = n.pop()) throw new Error('Unclosed section "' + D[1] + '" at ' + E.pos);
            return k(j(o))
        }

        function j(a) {
            for (var b, c, d = [], e = 0, f = a.length; e < f; ++e) b = a[e], b && ("text" === b[0] && c && "text" === c[0] ? (c[1] += b[1], c[3] = b[3]) : (d.push(b), c = b));
            return d
        }

        function k(a) {
            for (var b, c, d = [], e = d, f = [], g = 0, h = a.length; g < h; ++g) switch (b = a[g], b[0]) {
                case"#":
                case"^":
                    e.push(b), f.push(b), e = b[4] = [];
                    break;
                case"/":
                    c = f.pop(), c[5] = b[2], e = f.length > 0 ? f[f.length - 1][4] : d;
                    break;
                default:
                    e.push(b)
            }
            return d
        }

        function l(a) {
            this.string = a, this.tail = a, this.pos = 0
        }

        function m(a, b) {
            this.view = a, this.cache = {".": this.view}, this.parent = b
        }

        function n() {
            this.cache = {}
        }

        var o = Object.prototype.toString, p = Array.isArray || function (a) {
            return "[object Array]" === o.call(a)
        }, q = RegExp.prototype.test, r = /\S/, s = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
            "/": "&#x2F;",
            "`": "&#x60;",
            "=": "&#x3D;"
        }, t = /\s*/, u = /\s+/, v = /\s*=/, w = /\s*\}/, x = /#|\^|\/|>|\{|&|=|!/;
        l.prototype.eos = function () {
            return "" === this.tail
        }, l.prototype.scan = function (a) {
            var b = this.tail.match(a);
            if (!b || 0 !== b.index) return "";
            var c = b[0];
            return this.tail = this.tail.substring(c.length), this.pos += c.length, c
        }, l.prototype.scanUntil = function (a) {
            var b, c = this.tail.search(a);
            switch (c) {
                case-1:
                    b = this.tail, this.tail = "";
                    break;
                case 0:
                    b = "";
                    break;
                default:
                    b = this.tail.substring(0, c), this.tail = this.tail.substring(c)
            }
            return this.pos += b.length, b
        }, m.prototype.push = function (a) {
            return new m(a, this)
        }, m.prototype.lookup = function (a) {
            var c, d = this.cache;
            if (d.hasOwnProperty(a)) c = d[a]; else {
                for (var f, g, h = this, i = !1; h;) {
                    if (a.indexOf(".") > 0) for (c = h.view, f = a.split("."), g = 0; null != c && g < f.length;) g === f.length - 1 && (i = e(c, f[g])), c = c[f[g++]]; else c = h.view[a], i = e(h.view, a);
                    if (i) break;
                    h = h.parent
                }
                d[a] = c
            }
            return b(c) && (c = c.call(this.view)), c
        }, n.prototype.clearCache = function () {
            this.cache = {}
        }, n.prototype.parse = function (b, c) {
            var d = this.cache, e = d[b];
            return null == e && (e = d[b + ":" + (c || a.tags).join(":")] = i(b, c)), e
        }, n.prototype.render = function (a, b, c) {
            var d = this.parse(a), e = b instanceof m ? b : new m(b);
            return this.renderTokens(d, e, c, a)
        }, n.prototype.renderTokens = function (a, b, c, d) {
            for (var e, f, g, h = "", i = 0, j = a.length; i < j; ++i) g = void 0, e = a[i], f = e[0], "#" === f ? g = this.renderSection(e, b, c, d) : "^" === f ? g = this.renderInverted(e, b, c, d) : ">" === f ? g = this.renderPartial(e, b, c, d) : "&" === f ? g = this.unescapedValue(e, b) : "name" === f ? g = this.escapedValue(e, b) : "text" === f && (g = this.rawValue(e)), void 0 !== g && (h += g);
            return h
        }, n.prototype.renderSection = function (a, c, d, e) {
            function f(a) {
                return g.render(a, c, d)
            }

            var g = this, h = "", i = c.lookup(a[1]);
            if (i) {
                if (p(i)) for (var j = 0, k = i.length; j < k; ++j) h += this.renderTokens(a[4], c.push(i[j]), d, e); else if ("object" == typeof i || "string" == typeof i || "number" == typeof i) h += this.renderTokens(a[4], c.push(i), d, e); else if (b(i)) {
                    if ("string" != typeof e) throw new Error("Cannot use higher-order sections without the original template");
                    i = i.call(c.view, e.slice(a[3], a[5]), f), null != i && (h += i)
                } else h += this.renderTokens(a[4], c, d, e);
                return h
            }
        }, n.prototype.renderInverted = function (a, b, c, d) {
            var e = b.lookup(a[1]);
            if (!e || p(e) && 0 === e.length) return this.renderTokens(a[4], b, c, d)
        }, n.prototype.renderPartial = function (a, c, d) {
            if (d) {
                var e = b(d) ? d(a[1]) : d[a[1]];
                return null != e ? this.renderTokens(this.parse(e), c, d, e) : void 0
            }
        }, n.prototype.unescapedValue = function (a, b) {
            var c = b.lookup(a[1]);
            if (null != c) return c
        }, n.prototype.escapedValue = function (b, c) {
            var d = c.lookup(b[1]);
            if (null != d) return a.escape(d)
        }, n.prototype.rawValue = function (a) {
            return a[1]
        }, a.name = "mustache.js", a.version = "2.3.0", a.tags = ["{{", "}}"];
        var y = new n;
        return a.clearCache = function () {
            return y.clearCache()
        }, a.parse = function (a, b) {
            return y.parse(a, b)
        }, a.render = function (a, b, d) {
            if ("string" != typeof a) throw new TypeError('Invalid template! Template should be a "string" but "' + c(a) + '" was given as the first argument for mustache#render(template, view, partials)');
            return y.render(a, b, d)
        }, a.to_html = function (c, d, e, f) {
            var g = a.render(c, d, e);
            return b(f) ? void f(g) : g
        }, a.escape = h, a.Scanner = l, a.Context = m, a.Writer = n, a
    }), function (a) {
    "function" == typeof define && define.amd ? define("magnific-popup", ["jquery"], a) : a("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto)
}(function (a) {
    var b, c, d, e, f, g, h = "Close", i = "BeforeClose", j = "AfterClose", k = "BeforeAppend", l = "MarkupParse",
        m = "Open", n = "Change", o = "mfp", p = "." + o, q = "mfp-ready", r = "mfp-removing", s = "mfp-prevent-close",
        t = function () {
        }, u = !!window.jQuery, v = a(window), w = function (a, c) {
            b.ev.on(o + a + p, c)
        }, x = function (b, c, d, e) {
            var f = document.createElement("div");
            return f.className = "mfp-" + b, d && (f.innerHTML = d), e ? c && c.appendChild(f) : (f = a(f), c && f.appendTo(c)), f
        }, y = function (c, d) {
            b.ev.triggerHandler(o + c, d), b.st.callbacks && (c = c.charAt(0).toLowerCase() + c.slice(1), b.st.callbacks[c] && b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d]))
        }, z = function (c) {
            return c === g && b.currTemplate.closeBtn || (b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose)), g = c), b.currTemplate.closeBtn
        }, A = function () {
            a.magnificPopup.instance || (b = new t, b.init(), a.magnificPopup.instance = b)
        }, B = function () {
            var a = document.createElement("p").style, b = ["ms", "O", "Moz", "Webkit"];
            if (void 0 !== a.transition) return !0;
            for (; b.length;) if (b.pop() + "Transition" in a) return !0;
            return !1
        };
    t.prototype = {
        constructor: t, init: function () {
            var c = navigator.appVersion;
            b.isLowIE = b.isIE8 = document.all && !document.addEventListener, b.isAndroid = /android/gi.test(c), b.isIOS = /iphone|ipad|ipod/gi.test(c), b.supportsTransition = B(), b.probablyMobile = b.isAndroid || b.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), d = a(document), b.popupsCache = {}
        }, open: function (c) {
            var e;
            if (c.isObj === !1) {
                b.items = c.items.toArray(), b.index = 0;
                var g, h = c.items;
                for (e = 0; e < h.length; e++) if (g = h[e], g.parsed && (g = g.el[0]), g === c.el[0]) {
                    b.index = e;
                    break
                }
            } else b.items = a.isArray(c.items) ? c.items : [c.items], b.index = c.index || 0;
            if (b.isOpen) return void b.updateItemHTML();
            b.types = [], f = "", c.mainEl && c.mainEl.length ? b.ev = c.mainEl.eq(0) : b.ev = d, c.key ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}), b.currTemplate = b.popupsCache[c.key]) : b.currTemplate = {}, b.st = a.extend(!0, {}, a.magnificPopup.defaults, c), b.fixedContentPos = "auto" === b.st.fixedContentPos ? !b.probablyMobile : b.st.fixedContentPos, b.st.modal && (b.st.closeOnContentClick = !1, b.st.closeOnBgClick = !1, b.st.showCloseBtn = !1, b.st.enableEscapeKey = !1), b.bgOverlay || (b.bgOverlay = x("bg").on("click" + p, function () {
                b.close()
            }), b.wrap = x("wrap").attr("tabindex", -1).on("click" + p, function (a) {
                b._checkIfClose(a.target) && b.close()
            }), b.container = x("container", b.wrap)), b.contentContainer = x("content"), b.st.preloader && (b.preloader = x("preloader", b.container, b.st.tLoading));
            var i = a.magnificPopup.modules;
            for (e = 0; e < i.length; e++) {
                var j = i[e];
                j = j.charAt(0).toUpperCase() + j.slice(1), b["init" + j].call(b)
            }
            y("BeforeOpen"), b.st.showCloseBtn && (b.st.closeBtnInside ? (w(l, function (a, b, c, d) {
                c.close_replaceWith = z(d.type)
            }), f += " mfp-close-btn-in") : b.wrap.append(z())), b.st.alignTop && (f += " mfp-align-top"), b.fixedContentPos ? b.wrap.css({
                overflow: b.st.overflowY,
                overflowX: "hidden",
                overflowY: b.st.overflowY
            }) : b.wrap.css({
                top: v.scrollTop(),
                position: "absolute"
            }), (b.st.fixedBgPos === !1 || "auto" === b.st.fixedBgPos && !b.fixedContentPos) && b.bgOverlay.css({
                height: d.height(),
                position: "absolute"
            }), b.st.enableEscapeKey && d.on("keyup" + p, function (a) {
                27 === a.keyCode && b.close()
            }), v.on("resize" + p, function () {
                b.updateSize()
            }), b.st.closeOnContentClick || (f += " mfp-auto-cursor"), f && b.wrap.addClass(f);
            var k = b.wH = v.height(), n = {};
            if (b.fixedContentPos && b._hasScrollBar(k)) {
                var o = b._getScrollbarSize();
                o && (n.marginRight = o)
            }
            b.fixedContentPos && (b.isIE7 ? a("body, html").css("overflow", "hidden") : n.overflow = "hidden");
            var r = b.st.mainClass;
            return b.isIE7 && (r += " mfp-ie7"), r && b._addClassToMFP(r), b.updateItemHTML(), y("BuildControls"), a("html").css(n), b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)), b._lastFocusedEl = document.activeElement, setTimeout(function () {
                b.content ? (b._addClassToMFP(q), b._setFocus()) : b.bgOverlay.addClass(q), d.on("focusin" + p, b._onFocusIn)
            }, 16), b.isOpen = !0, b.updateSize(k), y(m), c
        }, close: function () {
            b.isOpen && (y(i), b.isOpen = !1, b.st.removalDelay && !b.isLowIE && b.supportsTransition ? (b._addClassToMFP(r), setTimeout(function () {
                b._close()
            }, b.st.removalDelay)) : b._close())
        }, _close: function () {
            y(h);
            var c = r + " " + q + " ";
            if (b.bgOverlay.detach(), b.wrap.detach(), b.container.empty(), b.st.mainClass && (c += b.st.mainClass + " "), b._removeClassFromMFP(c), b.fixedContentPos) {
                var e = {marginRight: ""};
                b.isIE7 ? a("body, html").css("overflow", "") : e.overflow = "", a("html").css(e)
            }
            d.off("keyup" + p + " focusin" + p), b.ev.off(p), b.wrap.attr("class", "mfp-wrap").removeAttr("style"), b.bgOverlay.attr("class", "mfp-bg"), b.container.attr("class", "mfp-container"), !b.st.showCloseBtn || b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0 || b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach(), b.st.autoFocusLast && b._lastFocusedEl && a(b._lastFocusedEl).focus(), b.currItem = null, b.content = null, b.currTemplate = null, b.prevHeight = 0, y(j)
        }, updateSize: function (a) {
            if (b.isIOS) {
                var c = document.documentElement.clientWidth / window.innerWidth, d = window.innerHeight * c;
                b.wrap.css("height", d), b.wH = d
            } else b.wH = a || v.height();
            b.fixedContentPos || b.wrap.css("height", b.wH), y("Resize")
        }, updateItemHTML: function () {
            var c = b.items[b.index];
            b.contentContainer.detach(), b.content && b.content.detach(), c.parsed || (c = b.parseEl(b.index));
            var d = c.type;
            if (y("BeforeChange", [b.currItem ? b.currItem.type : "", d]), b.currItem = c, !b.currTemplate[d]) {
                var f = !!b.st[d] && b.st[d].markup;
                y("FirstMarkupParse", f), f ? b.currTemplate[d] = a(f) : b.currTemplate[d] = !0
            }
            e && e !== c.type && b.container.removeClass("mfp-" + e + "-holder");
            var g = b["get" + d.charAt(0).toUpperCase() + d.slice(1)](c, b.currTemplate[d]);
            b.appendContent(g, d), c.preloaded = !0, y(n, c), e = c.type, b.container.prepend(b.contentContainer), y("AfterChange")
        }, appendContent: function (a, c) {
            b.content = a, a ? b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c] === !0 ? b.content.find(".mfp-close").length || b.content.append(z()) : b.content = a : b.content = "", y(k), b.container.addClass("mfp-" + c + "-holder"), b.contentContainer.append(b.content)
        }, parseEl: function (c) {
            var d, e = b.items[c];
            if (e.tagName ? e = {el: a(e)} : (d = e.type, e = {data: e, src: e.src}), e.el) {
                for (var f = b.types, g = 0; g < f.length; g++) if (e.el.hasClass("mfp-" + f[g])) {
                    d = f[g];
                    break
                }
                e.src = e.el.attr("data-mfp-src"), e.src || (e.src = e.el.attr("href"))
            }
            return e.type = d || b.st.type || "inline", e.index = c, e.parsed = !0, b.items[c] = e, y("ElementParse", e), b.items[c]
        }, addGroup: function (a, c) {
            var d = function (d) {
                d.mfpEl = this, b._openClick(d, a, c)
            };
            c || (c = {});
            var e = "click.magnificPopup";
            c.mainEl = a, c.items ? (c.isObj = !0, a.off(e).on(e, d)) : (c.isObj = !1, c.delegate ? a.off(e).on(e, c.delegate, d) : (c.items = a, a.off(e).on(e, d)))
        }, _openClick: function (c, d, e) {
            var f = void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick;
            if (f || !(2 === c.which || c.ctrlKey || c.metaKey || c.altKey || c.shiftKey)) {
                var g = void 0 !== e.disableOn ? e.disableOn : a.magnificPopup.defaults.disableOn;
                if (g) if (a.isFunction(g)) {
                    if (!g.call(b)) return !0
                } else if (v.width() < g) return !0;
                c.type && (c.preventDefault(), b.isOpen && c.stopPropagation()), e.el = a(c.mfpEl), e.delegate && (e.items = d.find(e.delegate)), b.open(e)
            }
        }, updateStatus: function (a, d) {
            if (b.preloader) {
                c !== a && b.container.removeClass("mfp-s-" + c), d || "loading" !== a || (d = b.st.tLoading);
                var e = {status: a, text: d};
                y("UpdateStatus", e), a = e.status, d = e.text, b.preloader.html(d), b.preloader.find("a").on("click", function (a) {
                    a.stopImmediatePropagation()
                }), b.container.addClass("mfp-s-" + a), c = a
            }
        }, _checkIfClose: function (c) {
            if (!a(c).hasClass(s)) {
                var d = b.st.closeOnContentClick, e = b.st.closeOnBgClick;
                if (d && e) return !0;
                if (!b.content || a(c).hasClass("mfp-close") || b.preloader && c === b.preloader[0]) return !0;
                if (c === b.content[0] || a.contains(b.content[0], c)) {
                    if (d) return !0
                } else if (e && a.contains(document, c)) return !0;
                return !1
            }
        }, _addClassToMFP: function (a) {
            b.bgOverlay.addClass(a), b.wrap.addClass(a)
        }, _removeClassFromMFP: function (a) {
            this.bgOverlay.removeClass(a), b.wrap.removeClass(a)
        }, _hasScrollBar: function (a) {
            return (b.isIE7 ? d.height() : document.body.scrollHeight) > (a || v.height())
        }, _setFocus: function () {
            (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus()
        }, _onFocusIn: function (c) {
            if (c.target !== b.wrap[0] && !a.contains(b.wrap[0], c.target)) return b._setFocus(), !1
        }, _parseMarkup: function (b, c, d) {
            var e;
            d.data && (c = a.extend(d.data, c)), y(l, [b, c, d]), a.each(c, function (c, d) {
                if (void 0 === d || d === !1) return !0;
                if (e = c.split("_"), e.length > 1) {
                    var f = b.find(p + "-" + e[0]);
                    if (f.length > 0) {
                        var g = e[1];
                        "replaceWith" === g ? f[0] !== d[0] && f.replaceWith(d) : "img" === g ? f.is("img") ? f.attr("src", d) : f.replaceWith(a("<img>").attr("src", d).attr("class", f.attr("class"))) : f.attr(e[1], d)
                    }
                } else b.find(p + "-" + c).html(d)
            })
        }, _getScrollbarSize: function () {
            if (void 0 === b.scrollbarSize) {
                var a = document.createElement("div");
                a.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(a), b.scrollbarSize = a.offsetWidth - a.clientWidth, document.body.removeChild(a)
            }
            return b.scrollbarSize
        }
    }, a.magnificPopup = {
        instance: null,
        proto: t.prototype,
        modules: [],
        open: function (b, c) {
            return A(), b = b ? a.extend(!0, {}, b) : {}, b.isObj = !0, b.index = c || 0, this.instance.open(b)
        },
        close: function () {
            return a.magnificPopup.instance && a.magnificPopup.instance.close()
        },
        registerModule: function (b, c) {
            c.options && (a.magnificPopup.defaults[b] = c.options), a.extend(this.proto, c.proto), this.modules.push(b)
        },
        defaults: {
            disableOn: 0,
            key: null,
            midClick: !1,
            mainClass: "",
            preloader: !0,
            focus: "",
            closeOnContentClick: !1,
            closeOnBgClick: !0,
            closeBtnInside: !0,
            showCloseBtn: !0,
            enableEscapeKey: !0,
            modal: !1,
            alignTop: !1,
            removalDelay: 0,
            prependTo: null,
            fixedContentPos: "auto",
            fixedBgPos: "auto",
            overflowY: "auto",
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
            tClose: "Close (Esc)",
            tLoading: "Loading...",
            autoFocusLast: !0
        }
    }, a.fn.magnificPopup = function (c) {
        A();
        var d = a(this);
        if ("string" == typeof c) if ("open" === c) {
            var e, f = u ? d.data("magnificPopup") : d[0].magnificPopup, g = parseInt(arguments[1], 10) || 0;
            f.items ? e = f.items[g] : (e = d, f.delegate && (e = e.find(f.delegate)), e = e.eq(g)), b._openClick({mfpEl: e}, d, f)
        } else b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1)); else c = a.extend(!0, {}, c), u ? d.data("magnificPopup", c) : d[0].magnificPopup = c, b.addGroup(d, c);
        return d
    };
    var C, D, E, F = "inline", G = function () {
        E && (D.after(E.addClass(C)).detach(), E = null)
    };
    a.magnificPopup.registerModule(F, {
        options: {hiddenClass: "hide", markup: "", tNotFound: "Content not found"},
        proto: {
            initInline: function () {
                b.types.push(F), w(h + "." + F, function () {
                    G()
                })
            }, getInline: function (c, d) {
                if (G(), c.src) {
                    var e = b.st.inline, f = a(c.src);
                    if (f.length) {
                        var g = f[0].parentNode;
                        g && g.tagName && (D || (C = e.hiddenClass, D = x(C), C = "mfp-" + C), E = f.after(D).detach().removeClass(C)), b.updateStatus("ready")
                    } else b.updateStatus("error", e.tNotFound), f = a("<div>");
                    return c.inlineElement = f, f
                }
                return b.updateStatus("ready"), b._parseMarkup(d, {}, c), d
            }
        }
    });
    var H, I = "ajax", J = function () {
        H && a(document.body).removeClass(H)
    }, K = function () {
        J(), b.req && b.req.abort()
    };
    a.magnificPopup.registerModule(I, {
        options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.'
        }, proto: {
            initAjax: function () {
                b.types.push(I), H = b.st.ajax.cursor, w(h + "." + I, K), w("BeforeChange." + I, K)
            }, getAjax: function (c) {
                H && a(document.body).addClass(H), b.updateStatus("loading");
                var d = a.extend({
                    url: c.src, success: function (d, e, f) {
                        var g = {data: d, xhr: f};
                        y("ParseAjax", g), b.appendContent(a(g.data), I), c.finished = !0, J(), b._setFocus(), setTimeout(function () {
                            b.wrap.addClass(q)
                        }, 16), b.updateStatus("ready"), y("AjaxContentAdded")
                    }, error: function () {
                        J(), c.finished = c.loadError = !0, b.updateStatus("error", b.st.ajax.tError.replace("%url%", c.src))
                    }
                }, b.st.ajax.settings);
                return b.req = a.ajax(d), ""
            }
        }
    });
    var L, M = function (c) {
        if (c.data && void 0 !== c.data.title) return c.data.title;
        var d = b.st.image.titleSrc;
        if (d) {
            if (a.isFunction(d)) return d.call(b, c);
            if (c.el) return c.el.attr(d) || ""
        }
        return ""
    };
    a.magnificPopup.registerModule("image", {
        options: {
            markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: !0,
            tError: '<a href="%url%">The image</a> could not be loaded.'
        }, proto: {
            initImage: function () {
                var c = b.st.image, d = ".image";
                b.types.push("image"), w(m + d, function () {
                    "image" === b.currItem.type && c.cursor && a(document.body).addClass(c.cursor)
                }), w(h + d, function () {
                    c.cursor && a(document.body).removeClass(c.cursor), v.off("resize" + p)
                }), w("Resize" + d, b.resizeImage), b.isLowIE && w("AfterChange", b.resizeImage)
            }, resizeImage: function () {
                var a = b.currItem;
                if (a && a.img && b.st.image.verticalFit) {
                    var c = 0;
                    b.isLowIE && (c = parseInt(a.img.css("padding-top"), 10) + parseInt(a.img.css("padding-bottom"), 10)), a.img.css("max-height", b.wH - c)
                }
            }, _onImageHasSize: function (a) {
                a.img && (a.hasSize = !0, L && clearInterval(L), a.isCheckingImgSize = !1, y("ImageHasSize", a), a.imgHidden && (b.content && b.content.removeClass("mfp-loading"), a.imgHidden = !1))
            }, findImageSize: function (a) {
                var c = 0, d = a.img[0], e = function (f) {
                    L && clearInterval(L), L = setInterval(function () {
                        return d.naturalWidth > 0 ? void b._onImageHasSize(a) : (c > 200 && clearInterval(L), c++, void (3 === c ? e(10) : 40 === c ? e(50) : 100 === c && e(500)))
                    }, f)
                };
                e(1)
            }, getImage: function (c, d) {
                var e = 0, f = function () {
                    c && (c.img[0].complete ? (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("ready")), c.hasSize = !0, c.loaded = !0, y("ImageLoadComplete")) : (e++, e < 200 ? setTimeout(f, 100) : g()))
                }, g = function () {
                    c && (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("error", h.tError.replace("%url%", c.src))), c.hasSize = !0, c.loaded = !0, c.loadError = !0)
                }, h = b.st.image, i = d.find(".mfp-img");
                if (i.length) {
                    var j = document.createElement("img");
                    j.className = "mfp-img", c.el && c.el.find("img").length && (j.alt = c.el.find("img").attr("alt")), c.img = a(j).on("load.mfploader", f).on("error.mfploader", g), j.src = c.src, i.is("img") && (c.img = c.img.clone()), j = c.img[0], j.naturalWidth > 0 ? c.hasSize = !0 : j.width || (c.hasSize = !1)
                }
                return b._parseMarkup(d, {
                    title: M(c),
                    img_replaceWith: c.img
                }, c), b.resizeImage(), c.hasSize ? (L && clearInterval(L), c.loadError ? (d.addClass("mfp-loading"), b.updateStatus("error", h.tError.replace("%url%", c.src))) : (d.removeClass("mfp-loading"), b.updateStatus("ready")), d) : (b.updateStatus("loading"), c.loading = !0, c.hasSize || (c.imgHidden = !0, d.addClass("mfp-loading"), b.findImageSize(c)), d)
            }
        }
    });
    var N, O = function () {
        return void 0 === N && (N = void 0 !== document.createElement("p").style.MozTransform), N
    };
    a.magnificPopup.registerModule("zoom", {
        options: {
            enabled: !1, easing: "ease-in-out", duration: 300, opener: function (a) {
                return a.is("img") ? a : a.find("img")
            }
        }, proto: {
            initZoom: function () {
                var a, c = b.st.zoom, d = ".zoom";
                if (c.enabled && b.supportsTransition) {
                    var e, f, g = c.duration, j = function (a) {
                        var b = a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                            d = "all " + c.duration / 1e3 + "s " + c.easing, e = {
                                position: "fixed",
                                zIndex: 9999,
                                left: 0,
                                top: 0,
                                "-webkit-backface-visibility": "hidden"
                            }, f = "transition";
                        return e["-webkit-" + f] = e["-moz-" + f] = e["-o-" + f] = e[f] = d, b.css(e), b
                    }, k = function () {
                        b.content.css("visibility", "visible")
                    };
                    w("BuildControls" + d, function () {
                        if (b._allowZoom()) {
                            if (clearTimeout(e), b.content.css("visibility", "hidden"), a = b._getItemToZoom(), !a) return void k();
                            f = j(a), f.css(b._getOffset()), b.wrap.append(f), e = setTimeout(function () {
                                f.css(b._getOffset(!0)), e = setTimeout(function () {
                                    k(), setTimeout(function () {
                                        f.remove(), a = f = null, y("ZoomAnimationEnded")
                                    }, 16)
                                }, g)
                            }, 16)
                        }
                    }), w(i + d, function () {
                        if (b._allowZoom()) {
                            if (clearTimeout(e), b.st.removalDelay = g, !a) {
                                if (a = b._getItemToZoom(), !a) return;
                                f = j(a)
                            }
                            f.css(b._getOffset(!0)), b.wrap.append(f), b.content.css("visibility", "hidden"), setTimeout(function () {
                                f.css(b._getOffset())
                            }, 16)
                        }
                    }), w(h + d, function () {
                        b._allowZoom() && (k(), f && f.remove(), a = null)
                    })
                }
            }, _allowZoom: function () {
                return "image" === b.currItem.type
            }, _getItemToZoom: function () {
                return !!b.currItem.hasSize && b.currItem.img
            }, _getOffset: function (c) {
                var d;
                d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
                var e = d.offset(), f = parseInt(d.css("padding-top"), 10), g = parseInt(d.css("padding-bottom"), 10);
                e.top -= a(window).scrollTop() - f;
                var h = {width: d.width(), height: (u ? d.innerHeight() : d[0].offsetHeight) - g - f};
                return O() ? h["-moz-transform"] = h.transform = "translate(" + e.left + "px," + e.top + "px)" : (h.left = e.left, h.top = e.top), h
            }
        }
    });
    var P = "iframe", Q = "//about:blank", R = function (a) {
        if (b.currTemplate[P]) {
            var c = b.currTemplate[P].find("iframe");
            c.length && (a || (c[0].src = Q), b.isIE8 && c.css("display", a ? "block" : "none"))
        }
    };
    a.magnificPopup.registerModule(P, {
        options: {
            markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
            srcAction: "iframe_src",
            patterns: {
                youtube: {index: "youtube.com", id: "v=", src: "//www.youtube.com/embed/%id%?autoplay=1"},
                vimeo: {index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1"},
                gmaps: {index: "//maps.google.", src: "%id%&output=embed"}
            }
        }, proto: {
            initIframe: function () {
                b.types.push(P), w("BeforeChange", function (a, b, c) {
                    b !== c && (b === P ? R() : c === P && R(!0))
                }), w(h + "." + P, function () {
                    R()
                })
            }, getIframe: function (c, d) {
                var e = c.src, f = b.st.iframe;
                a.each(f.patterns, function () {
                    if (e.indexOf(this.index) > -1) return this.id && (e = "string" == typeof this.id ? e.substr(e.lastIndexOf(this.id) + this.id.length, e.length) : this.id.call(this, e)), e = this.src.replace("%id%", e), !1
                });
                var g = {};
                return f.srcAction && (g[f.srcAction] = e), b._parseMarkup(d, g, c), b.updateStatus("ready"), d
            }
        }
    });
    var S = function (a) {
        var c = b.items.length;
        return a > c - 1 ? a - c : a < 0 ? c + a : a
    }, T = function (a, b, c) {
        return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c)
    };
    a.magnificPopup.registerModule("gallery", {
        options: {
            enabled: !1,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [0, 2],
            navigateByImgClick: !0,
            arrows: !0,
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%"
        }, proto: {
            initGallery: function () {
                var c = b.st.gallery, e = ".mfp-gallery";
                return b.direction = !0, !(!c || !c.enabled) && (f += " mfp-gallery", w(m + e, function () {
                    c.navigateByImgClick && b.wrap.on("click" + e, ".mfp-img", function () {
                        if (b.items.length > 1) return b.next(), !1
                    }), d.on("keydown" + e, function (a) {
                        37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next()
                    })
                }), w("UpdateStatus" + e, function (a, c) {
                    c.text && (c.text = T(c.text, b.currItem.index, b.items.length))
                }), w(l + e, function (a, d, e, f) {
                    var g = b.items.length;
                    e.counter = g > 1 ? T(c.tCounter, f.index, g) : ""
                }), w("BuildControls" + e, function () {
                    if (b.items.length > 1 && c.arrows && !b.arrowLeft) {
                        var d = c.arrowMarkup,
                            e = b.arrowLeft = a(d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, "left")).addClass(s),
                            f = b.arrowRight = a(d.replace(/%title%/gi, c.tNext).replace(/%dir%/gi, "right")).addClass(s);
                        e.click(function () {
                            b.prev()
                        }), f.click(function () {
                            b.next()
                        }), b.container.append(e.add(f))
                    }
                }), w(n + e, function () {
                    b._preloadTimeout && clearTimeout(b._preloadTimeout), b._preloadTimeout = setTimeout(function () {
                        b.preloadNearbyImages(), b._preloadTimeout = null
                    }, 16)
                }), void w(h + e, function () {
                    d.off(e), b.wrap.off("click" + e), b.arrowRight = b.arrowLeft = null
                }))
            }, next: function () {
                b.direction = !0, b.index = S(b.index + 1), b.updateItemHTML()
            }, prev: function () {
                b.direction = !1, b.index = S(b.index - 1), b.updateItemHTML()
            }, goTo: function (a) {
                b.direction = a >= b.index, b.index = a, b.updateItemHTML()
            }, preloadNearbyImages: function () {
                var a, c = b.st.gallery.preload, d = Math.min(c[0], b.items.length), e = Math.min(c[1], b.items.length);
                for (a = 1; a <= (b.direction ? e : d); a++) b._preloadItem(b.index + a);
                for (a = 1; a <= (b.direction ? d : e); a++) b._preloadItem(b.index - a)
            }, _preloadItem: function (c) {
                if (c = S(c), !b.items[c].preloaded) {
                    var d = b.items[c];
                    d.parsed || (d = b.parseEl(c)), y("LazyLoad", d), "image" === d.type && (d.img = a('<img class="mfp-img" />').on("load.mfploader", function () {
                        d.hasSize = !0
                    }).on("error.mfploader", function () {
                        d.hasSize = !0, d.loadError = !0, y("LazyLoadError", d)
                    }).attr("src", d.src)), d.preloaded = !0
                }
            }
        }
    });
    var U = "retina";
    a.magnificPopup.registerModule(U, {
        options: {
            replaceSrc: function (a) {
                return a.src.replace(/\.\w+$/, function (a) {
                    return "@2x" + a
                })
            }, ratio: 1
        }, proto: {
            initRetina: function () {
                if (window.devicePixelRatio > 1) {
                    var a = b.st.retina, c = a.ratio;
                    c = isNaN(c) ? c() : c, c > 1 && (w("ImageHasSize." + U, function (a, b) {
                        b.img.css({"max-width": b.img[0].naturalWidth / c, width: "100%"})
                    }), w("ElementParse." + U, function (b, d) {
                        d.src = a.replaceSrc(d, c)
                    }))
                }
            }
        }
    }), A()
}), define("views/add-to-cart-view", ["jquery", "underscore", "backbone", "TweenLite", "mustache", "magnific-popup"], function (a, b, c, d, e) {
    "use strict";
    var f = c.View.extend({
        successAnimationDuration: 2e3,
        tooltipDuration: 2e3,
        tooltipFadeAnimationSpeed: .3,
        tooltipTimeout: void 0,
        $tooltip: void 0,
        tooltipIsStashed: !1,
        blocked: !1,
        shoppingCartSelector: "#desktop-shopping-cart .user-shopping-cart",
        checkoutDialogTemplate: void 0,
        events: {
            click: "addItem",
            "click .btn-close-msg": "closeTooltip",
            "mouseenter .tooltip": "stashTooltip",
            "mouseleave .tooltip": "unStashTooltip"
        },
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.orderId = this.$el.data("orderId"), this.url = this.$el.data("url"), this.eventDispatcher = window.app.eventDispatcher;
            var c = document.getElementById("add-to-cart-checkout-dialog");
            c && (this.checkoutDialogTemplate = c.innerHTML)
        },
        addItem: function (b) {
            this.blocked || this.$tooltip && 0 !== this.$tooltip.length || (b.preventDefault(), b.stopPropagation(), this.blocked = !0, a.ajax({
                cache: !1,
                headers: {Accept: "application/json"},
                dataType: "json",
                method: "POST",
                url: this.url,
                data: {productId: this.orderId}
            }).done(this.onAddItemsSuccess.bind(this)).fail(this.onAddItemsError.bind(this)))
        },
        onAddItemsSuccess: function (a) {
            return a && b.isObject(a) ? void ("OK" === a.status ? this.afterAddItem() : a.message ? (this.showTooltip(a.message), this.blocked = !1) : this.onAddItemsError()) : void this.onAddItemsError()
        },
        onAddItemsError: function () {
            this.blocked = !1
        },
        afterAddItem: function () {
            this.$el.addClass("success"), setTimeout(function () {
                this.blocked = !1, this.$el.removeClass("success")
            }.bind(this), this.successAnimationDuration), this.showCheckoutDialog(), this.setTrackingInformation(), this.getCurrentItemCount() > 0 ? this.trackEvent("sc-add") : this.trackEvent("sc-open"), this.eventDispatcher.trigger("NavShoppingCart:Add")
        },
        showCheckoutDialog: function () {
            var b = this;
            b.checkoutDialogTemplate && (e.parse(b.checkoutDialogTemplate), a.magnificPopup.open({
                items: {
                    type: "inline",
                    src: e.render(b.checkoutDialogTemplate)
                }, callbacks: {
                    open: function () {
                        this.content.find(".button-secondary").click(b.onDialogSecondaryClick.bind(b))
                    }
                }
            }))
        },
        onDialogSecondaryClick: function (b) {
            b.preventDefault(), a.magnificPopup.instance && a.magnificPopup.instance.close()
        },
        getCurrentItemCount: function () {
            return parseInt(a(this.shoppingCartSelector).attr("data-items")) || 0
        },
        setTrackingInformation: function () {
            var a = window.digitalData || {}, b = this.$el.attr("data-price") || "",
                c = this.getCurrencyFromPriceString(b), d = this.getPriceFromPriceString(b);
            a.shoppingCart = a.shoppingCart || {}, a.shoppingCart.currency = a.shoppingCart.currency || c, a.shoppingCart.items = [{
                category: this.$el.attr("data-product-category") || "",
                product: this.$el.attr("data-product-name") || "",
                sku: this.orderId,
                price: d,
                quantity: 1
            }], window.digitalData = a
        },
        getCurrencyFromPriceString: function (a) {
            var b = a.match(/[A-Z]{3}/);
            return b && b[0] ? b[0] : ""
        },
        getPriceFromPriceString: function (a) {
            var b = a.match(/\d+/g);
            if (!b) return "";
            var c = parseInt(b.join(""));
            return isNaN(c) ? "" : (100 * c).toString()
        },
        trackEvent: function (a) {
            return b.isUndefined(window._satellite) ? void console.warn(a, "_satellite object not defined.") : void window._satellite.track(a)
        },
        showTooltip: function (b) {
            this.$tooltip = a('<div class="tooltip"><div class="tooltip-content">' + b + '<span class="btn-close-msg"></span></div></div>'), this.$el.append(this.$tooltip), d.to(this.$tooltip, this.tooltipFadeAnimationSpeed, {
                css: {opacity: 1},
                onComplete: this.initTooltipTimeout,
                onCompleteScope: this
            })
        },
        initTooltipTimeout: function () {
            !this.tooltipIsStashed && this.$tooltip && this.$tooltip.length > 0 && (this.tooltipTimeout = setTimeout(function () {
                this.closeTooltip()
            }.bind(this), this.tooltipDuration))
        },
        stashTooltip: function () {
            clearTimeout(this.tooltipTimeout), this.tooltipIsStashed = !0
        },
        unStashTooltip: function () {
            this.tooltipIsStashed = !1, this.initTooltipTimeout()
        },
        closeTooltip: function () {
            clearTimeout(this.tooltipTimeout), this.$tooltip && this.$tooltip.length > 0 && d.to(this.$tooltip, this.tooltipFadeAnimationSpeed, {
                css: {opacity: 0},
                onComplete: this.removeTooltip,
                onCompleteScope: this
            })
        },
        removeTooltip: function () {
            this.$tooltip && this.$tooltip.length > 0 && (this.$tooltip.remove(), this.$tooltip = null)
        }
    });
    return function (a) {
        return this instanceof f ? this : new f(a)
    }
}), define("views/app-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        events: {
            "click a.download-tracked, button.download-tracked": "onDownloadsClick",
            "click a.to-top, a.anchor-link": "onAnchorClick"
        }, initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"]))
        }, onDownloadsClick: function (a) {
            var b = a.currentTarget, c = b.getAttribute("data-filename") || "",
                d = b.getAttribute("data-filetitle") || "", e = b.getAttribute("data-filecategory") || "";
            window.app.trackEvent("download", {
                fileName: c.replace("'", ""),
                fileTitle: d.replace("'", ""),
                category: e.replace("'", "")
            }, ["DCSext.down_filename", c, "DCSext.down_filetitle", d, "DCSext.down_category", e, "WT.dl", "20"], !1)
        }, onAnchorClick: function (b) {
            b.preventDefault();
            var c = a(b.currentTarget).attr("href");
            if ("" !== c && c.indexOf("#") > -1) if (1 === c.length) a("html, body").animate({scrollTop: 0}); else {
                var d = a("#header");
                d.hasClass("fixed") ? a("html, body").animate({scrollTop: a(c).offset().top - d.outerHeight()}) : document.querySelector(c).scrollIntoView({behavior: "smooth"})
            }
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/form-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        form: void 0,
        $form: void 0,
        elements: void 0,
        trackedFocus: !1,
        isSuccess: !1,
        $messages: void 0,
        statesUrl: void 0,
        $country: void 0,
        $states: void 0,
        isInredForm: !1,
        formFieldSelector: ".form-field",
        statesSelectClass: "form-field-state form-field-select",
        inredFormStatesSelectClass: "form-field form-field-select",
        generalDataProtectionContainer: ".general-data-protection-container",
        events: {
            "submit form": "submitForm",
            "focus input, select, button, textarea": "focusField",
            "input .form-field.error input, .form-field.error textarea": "resetField",
            "change .form-field.error select": "resetField",
            "input form.success input, form.success textarea, form.error input, form.error textarea": "resetForm",
            "change form.success select, form.error select": "resetForm",
            "click .close": "resetForm",
            'change select[name="country"]': "getStatesFromUrl"
        },
        initialize: function (c) {
            this.options = b.extend({}, this.defaults, b.omit(c, ["el", "$el"])), this.form = this.el.querySelector("form"), this.$form = a(this.form), this.elements = this.form.elements, this.$messages = this.$(".form-message"),
                this.statesUrl = this.$el.data("states-url"), this.$country = a(this.elements.country), this.isInredForm = this.$el.hasClass("module-inred-form"), this.render(), this.elements.country && this.elements.country.value && this.$country.trigger("change")
        },
        render: function () {
            return this.$form.append('<div class="cover"><div class="loader"/></div>'), this.$messages.append('<div class="close"/>'), this
        },
        getStatesFromUrl: function (c) {
            var d = a(c.target);
            if (b.isObject(d) && d.length) {
                this.removeStatesField();
                var e = d.val();
                e && this.statesUrl && a.ajax({
                    cache: !1,
                    contentType: "application/json",
                    dataType: "json",
                    method: "GET",
                    url: this.statesUrl,
                    data: {country: e}
                }).done(this.onGetStatesComplete.bind(this)).fail(this.onGetStatesFailed.bind(this))
            }
        },
        onGetStatesComplete: function (c, d) {
            if ("success" !== d || !c || !b.isObject(c) || !b.isObject(c.data)) return void this.onGetStatesFailed();
            if (!c.data.items || 0 === c.data.items.length) return void this.removeStatesField();
            var e;
            if (this.isInredForm) {
                var f = this.$country.closest(this.formFieldSelector);
                c.data.text.label = c.data.text.label.replace("*", ""), e = this.createStatesField(c.data.items, c.data.text, f.attr("class")), f.after(e)
            } else e = this.createStatesField(c.data.items, c.data.text, this.statesSelectClass), this.$country.after(e);
            this.$states = a(e)
        },
        removeStatesField: function () {
            this.$states && (this.$states.remove(), this.$states = null)
        },
        createStatesField: function (a, c, d) {
            var e = this.form.name + "_state",
                f = this.createElement("select", {id: e, name: "state", required: "required"}),
                g = c.placeholder ? "<option value selected disabled hidden>" + c.placeholder + "</option>" : "";
            b.each(a, function (a) {
                var c = Object.keys(a)[0];
                g += '<option value="' + b.escape(c) + '">' + b.escape(a[c]) + "</option>"
            }), f.innerHTML = g;
            var h = this.createElement("label", null);
            h.setAttribute("for", e), h.textContent = c.label;
            var i = this.createElement("div", null);
            return i.className = d, i.appendChild(h), i.appendChild(f), i
        },
        createElement: function (a, c) {
            var d = document.createElement(a);
            return b.each(c, function (a, b) {
                d.setAttribute(b, a)
            }), d
        },
        onGetStatesFailed: function () {
            this.removeStatesField()
        },
        disable: function () {
            this.$form.addClass("disabled")
        },
        enable: function () {
            this.$form.removeClass("disabled")
        },
        resetField: function (b) {
            var c, d = a(b.target).closest(this.formFieldSelector),
                e = a(b.target).parents(this.generalDataProtectionContainer);
            e && e.length ? (e.find('input[name="' + a(b.target).attr("name") + '"]').removeClass("error"), e.find('.message[data-checkbox="' + a(b.target).attr("name") + '"]').addClass("hide"), c = e.find(".message[data-checkbox].hide").length, e.find(".message[data-checkbox]").length === c && e.find(".checkbox-container").removeClass("error"), a(b.target).removeClass("error")) : d.removeClass("error")
        },
        resetForm: function () {
            this.$form.removeClass("success error")
        },
        focusField: function (a) {
            this.isSuccess && a.target.classList.contains("mfp-close") || this.trackedFocus || (this.trackedFocus = !0, this.trackFormOpen(!0))
        },
        displaySuccess: function (a) {
            if (!b.isUndefined(a.feedback) && b.isString(a.feedback) && "" !== a.feedback) {
                var c = this.$messages.filter(".form-message-success");
                c.find(":not(.close)").remove(), c.prepend(a.feedback)
            }
            this.$form.addClass("success"), this.enable(), this.el.scrollIntoView({behavior: "smooth"})
        },
        displayError: function () {
            this.$form.addClass("error"), this.enable()
        },
        showValidationErrors: function (c) {
            var d = a(this.generalDataProtectionContainer);
            d.length && d.find(".message").remove(), b.each(this.elements, function (a) {
                "submit" !== a.type && c[a.name] !== !0 && this.renderFieldError(a)
            }.bind(this)), this.enable()
        },
        renderFieldError: function (b) {
            var c = a(b), d = c.closest(this.formFieldSelector);
            if (!(d.find(".message").length > 0)) {
                var e = a('<p class="message" />');
                e.text(c.attr("data-error-message")), this.isInredForm ? d.append(e) : a(b).after(e), c.parents(this.generalDataProtectionContainer).length > 0 && (c.addClass("error"), e.attr("data-checkbox", b.name)), setTimeout(d.addClass.bind(d, "error"), 0)
            }
        },
        onFormSubmitComplete: function (c, d) {
            var e = c;
            return c && b.isString(c) && (e = a.parseJSON(c)), "success" === d && b.isObject(e) ? b.contains(e.validation, !1) ? (this.showValidationErrors(e.validation), void this.trackFormError()) : (this.displaySuccess(e), this.trackFormSuccess(e), this.isSuccess = !0, void (this.trackedFocus = !1)) : void this.onFormSubmitFailed()
        },
        onFormSubmitFailed: function () {
            this.displayError(), this.trackFormError()
        },
        submitForm: function (b) {
            b.preventDefault(), this.trackedFocus || (this.trackedFocus = !0, this.trackFormOpen()), this.resetForm(), this.disable(), a.ajax({
                cache: !1,
                data: this.$form.serialize(),
                method: this.form.method,
                url: this.form.action
            }).done(this.onFormSubmitComplete.bind(this)).fail(this.onFormSubmitFailed.bind(this))
        },
        getAdobeTrackingData: function (a, c, d) {
            var e = {name: this.$form.attr("name"), stepName: a, stepNumber: c, status: d};
            return b.extend(e, window.app.getTrackingDataFromForm(this.form))
        },
        trackFormError: function () {
            window.app.addM4CDataToAdobeTrackingFromForm(this.form), window.app.trackEvent("form", this.getAdobeTrackingData("Form", 1, "Error"), ["WT.si_n", this.$form.attr("name"), "WT.si_p", "FormError", "WT.dl", "0"], !1)
        },
        trackFormSuccess: function (a) {
            window.app.addM4CDataToAdobeTrackingFromForm(this.form), window.app.addFormResponseDataToAdobeTracking(a), window.app.trackEvent("form", this.getAdobeTrackingData("Confirmation", 2, "Success"), ["WT.si_n", this.$form.attr("name"), "WT.si_p", "FormSuccess", "WT.si_cs", "1", "WT.dl", "0"], !1)
        },
        trackFormOpen: function (a) {
            window.app.addM4CDataToAdobeTrackingFromForm(this.form), window.app.trackEvent("form", this.getAdobeTrackingData("Form", 1, "Open"), a ? ["WT.si_n", this.$form.attr("name"), "WT.si_p", "Form", "WT.dl", "0"] : null, !1)
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/button-lightbox-view", ["jquery", "underscore", "backbone", "views/form-view", "magnific-popup"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        formView: void 0, views: [], $lightboxCover: void 0, initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.$el.magnificPopup({
                type: "ajax",
                ajax: {cache: !1},
                callbacks: {
                    open: this.onLightboxOpen.bind(this),
                    ajaxContentAdded: this.onLightboxContentLoaded.bind(this),
                    afterClose: this.onLightboxAfterClose.bind(this)
                },
                removalDelay: 300,
                tClose: ""
            })
        }, onLightboxOpen: function () {
            this.$lightboxCover = a('<div class="cover"><div class="loader"/></div>').appendTo(a(".mfp-container"))
        }, onLightboxContentLoaded: function () {
            this.$lightboxCover && b.isObject(this.$lightboxCover) && 0 !== this.$lightboxCover.length && (this.$lightboxCover.remove(), this.$lightboxCover = null), this.views = [];
            var a = window.app.initViews(this.views, document.querySelector(".mfp-content"));
            if (!(a > 0)) {
                var c = document.querySelector(".mfp-content .module-form");
                c && this.views.push(d({el: c}))
            }
        }, onLightboxAfterClose: function () {
            b.each(this.views, function (a) {
                a.remove()
            })
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("views/application-table-view", ["jquery", "underscore", "backbone", "views/accordion-item-view", "views/button-lightbox-view"], function (a, b, c, d, e) {
    "use strict";
    var f = c.View.extend({
        currentDisplay: void 0, isRendering: !1, accordionRendered: !1, tableRendered: !1, initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.render)
        }, render: function () {
            var a = window.app.matchMedia.getMediaQueries(), b = "media-from-l" !== a.currentMediaQuery;
            return this.isRendering === !0 || a.currentMediaQuery === a.lastMediaQuery || b === !0 && "accordion" === this.currentDisplay || b === !1 && "table" === this.currentDisplay ? this : (this.isRendering = !0, b ? ("table" === this.currentDisplay && this.resetCurrentDisplay(), this.renderAccordion()) : ("accordion" === this.currentDisplay && this.resetCurrentDisplay(), this.renderTable()), this.isRendering = !1, this)
        }, renderAccordion: function () {
            if (this.accordionRendered === !1) {
                var c = this.el.querySelectorAll(".application-table thead th");
                b.each(this.el.querySelectorAll(".module-accordion"), function (e, f) {
                    0 === f && e.classList.add("initial-active"), b.each(e.querySelectorAll(".content > div"), function (b, d) {
                        var e = a(c[d]).html();
                        0 !== d && 0 !== b.childElementCount && a('<div class="label"/>').html(e).prependTo(b)
                    }), d({el: e, parent: this})
                }), this.initButtonLightboxElements(), this.accordionRendered = !0
            }
            this.currentDisplay = "accordion"
        }, resetCurrentDisplay: function () {
            this.currentDisplay = null
        }, renderTable: function () {
            if (this.tableRendered === !1) {
                var a, c, d, e = this.el.querySelector(".application-table table"), f = document.createElement("tbody"),
                    g = this.el.querySelectorAll(".application-table thead th");
                e.appendChild(f), b.each(this.el.querySelectorAll(".module-accordion"), function (e) {
                    var h, i = e.querySelector(".title").cloneNode(!0);
                    a = f.insertRow(), c = a.insertCell(), c.appendChild(i), h = b.find(i.classList, function (a) {
                        return a.indexOf("icon-") !== -1
                    }), b.isUndefined(h) || c.classList.add("has-icon"), null !== i.querySelector("a") && c.classList.add("has-link"), b.each(e.querySelectorAll(".content > div"), function (e, f) {
                        0 !== f && (c = a.insertCell()), d = g[f].classList, b.contains(d, "text-centered") && c.classList.add("text-centered"), b.contains(d, "text-right") && c.classList.add("text-right"), b.each(e.children, function (a) {
                            c.appendChild(a.cloneNode(!0))
                        })
                    })
                }), this.initButtonLightboxElements(), this.tableRendered = !0
            }
            this.currentDisplay = "table"
        }, initButtonLightboxElements: function () {
            b.each(this.el.querySelectorAll('[data-view="button-lightbox"]'), function (a) {
                e({el: a})
            })
        }
    });
    return function (a) {
        return this instanceof f ? this : new f(a)
    }
}), define("views/available-options-view", ["jquery", "underscore", "backbone", "views/accordion-item-view"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        accordionElems: void 0,
        accordionItems: [],
        events: {"click .linked": "onModelsTableRowClick", "click .product-option-image a": "preventAction"},
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.accordionElems = this.el.querySelectorAll(".available-option-group"), this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render()
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.AVAILABLE_OPTIONS_CHANGE, this.onChangeState), this.listenTo(this.eventDispatcher, window.app.applicationEvents.ACCORDION_SHOW, this.onAccordionOpen), this.listenTo(this.eventDispatcher, window.app.applicationEvents.ACCORDION_HIDE, this.onAccordionClose)
        },
        render: function () {
            for (var a = 0, b = this.accordionElems.length; a < b; a++) this.accordionItems.push(d({
                el: this.accordionElems[a],
                parent: this
            }));
            return this
        },
        preventAction: function (a) {
            a.stopPropagation()
        },
        onModelsTableRowClick: function (a) {
            a.preventDefault();
            var b = a.currentTarget.querySelector(".product-option-name a");
            b && (location.href = b.href)
        },
        onChangeState: function (c) {
            if (c.availableOptions === this.el) {
                var d = this.$(".slide:not(.slick-cloned)").eq(c.slideIndex).find(".available-option-group").get(c.contentIndex),
                    e = b.findWhere(this.accordionItems, {el: d}), f = a.Event("changestate", {
                        availableOptions: this,
                        fragment: c.fragment,
                        index: c.contentIndex,
                        slideIndex: c.slideIndex
                    });
                window.setTimeout(this.eventDispatcher.trigger.bind(this.eventDispatcher, window.app.applicationEvents.ACCORDION_OPEN, f, e), 100)
            }
        },
        onAccordionOpen: function (c, d) {
            if ("changestate" !== c.type && !b.isUndefined(d.parent) && d.parent === this) {
                var e = a.Event("open", {availableOptions: this.el, accordionItem: d, contentIndex: c.index});
                this.eventDispatcher.trigger(window.app.applicationEvents.AVAILABLE_OPTIONS_CHANGED, e)
            }
        },
        onAccordionClose: function (c, d) {
            if ("changestate" !== c.type && !b.isUndefined(d.parent) && d.parent === this) {
                var e = a.Event("close", {availableOptions: this.el, accordionItem: d});
                this.eventDispatcher.trigger(window.app.applicationEvents.AVAILABLE_OPTIONS_CHANGED, e)
            }
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}),/*! nouislider - 11.1.0 - 2018-04-02 11:18:13 */
    function (a) {
        "function" == typeof define && define.amd ? define("noUiSlider", [], a) : "object" == typeof exports ? module.exports = a() : window.noUiSlider = a()
    }(function () {
        "use strict";

        function a(a) {
            return "object" == typeof a && "function" == typeof a.to && "function" == typeof a.from
        }

        function b(a) {
            a.parentElement.removeChild(a)
        }

        function c(a) {
            return null !== a && void 0 !== a
        }

        function d(a) {
            a.preventDefault()
        }

        function e(a) {
            return a.filter(function (a) {
                return !this[a] && (this[a] = !0)
            }, {})
        }

        function f(a, b) {
            return Math.round(a / b) * b
        }

        function g(a, b) {
            var c = a.getBoundingClientRect(), d = a.ownerDocument, e = d.documentElement, f = p(d);
            return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (f.x = 0), b ? c.top + f.y - e.clientTop : c.left + f.x - e.clientLeft
        }

        function h(a) {
            return "number" == typeof a && !isNaN(a) && isFinite(a)
        }

        function i(a, b, c) {
            c > 0 && (m(a, b), setTimeout(function () {
                n(a, b)
            }, c))
        }

        function j(a) {
            return Math.max(Math.min(a, 100), 0)
        }

        function k(a) {
            return Array.isArray(a) ? a : [a]
        }

        function l(a) {
            a = String(a);
            var b = a.split(".");
            return b.length > 1 ? b[1].length : 0
        }

        function m(a, b) {
            a.classList ? a.classList.add(b) : a.className += " " + b
        }

        function n(a, b) {
            a.classList ? a.classList.remove(b) : a.className = a.className.replace(new RegExp("(^|\\b)" + b.split(" ").join("|") + "(\\b|$)", "gi"), " ")
        }

        function o(a, b) {
            return a.classList ? a.classList.contains(b) : new RegExp("\\b" + b + "\\b").test(a.className)
        }

        function p(a) {
            var b = void 0 !== window.pageXOffset, c = "CSS1Compat" === (a.compatMode || ""),
                d = b ? window.pageXOffset : c ? a.documentElement.scrollLeft : a.body.scrollLeft,
                e = b ? window.pageYOffset : c ? a.documentElement.scrollTop : a.body.scrollTop;
            return {x: d, y: e}
        }

        function q() {
            return window.navigator.pointerEnabled ? {
                start: "pointerdown",
                move: "pointermove",
                end: "pointerup"
            } : window.navigator.msPointerEnabled ? {
                start: "MSPointerDown",
                move: "MSPointerMove",
                end: "MSPointerUp"
            } : {start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend"}
        }

        function r() {
            var a = !1;
            try {
                var b = Object.defineProperty({}, "passive", {
                    get: function () {
                        a = !0
                    }
                });
                window.addEventListener("test", null, b)
            } catch (a) {
            }
            return a
        }

        function s() {
            return window.CSS && CSS.supports && CSS.supports("touch-action", "none")
        }

        function t(a, b) {
            return 100 / (b - a)
        }

        function u(a, b) {
            return 100 * b / (a[1] - a[0])
        }

        function v(a, b) {
            return u(a, a[0] < 0 ? b + Math.abs(a[0]) : b - a[0])
        }

        function w(a, b) {
            return b * (a[1] - a[0]) / 100 + a[0]
        }

        function x(a, b) {
            for (var c = 1; a >= b[c];) c += 1;
            return c
        }

        function y(a, b, c) {
            if (c >= a.slice(-1)[0]) return 100;
            var d = x(c, a), e = a[d - 1], f = a[d], g = b[d - 1], h = b[d];
            return g + v([e, f], c) / t(g, h)
        }

        function z(a, b, c) {
            if (c >= 100) return a.slice(-1)[0];
            var d = x(c, b), e = a[d - 1], f = a[d], g = b[d - 1], h = b[d];
            return w([e, f], (c - g) * t(g, h))
        }

        function A(a, b, c, d) {
            if (100 === d) return d;
            var e = x(d, a), g = a[e - 1], h = a[e];
            return c ? d - g > (h - g) / 2 ? h : g : b[e - 1] ? a[e - 1] + f(d - a[e - 1], b[e - 1]) : d
        }

        function B(a, b, c) {
            var d;
            if ("number" == typeof b && (b = [b]), !Array.isArray(b)) throw new Error("noUiSlider (" + $ + "): 'range' contains invalid value.");
            if (d = "min" === a ? 0 : "max" === a ? 100 : parseFloat(a), !h(d) || !h(b[0])) throw new Error("noUiSlider (" + $ + "): 'range' value isn't numeric.");
            c.xPct.push(d), c.xVal.push(b[0]), d ? c.xSteps.push(!isNaN(b[1]) && b[1]) : isNaN(b[1]) || (c.xSteps[0] = b[1]), c.xHighestCompleteStep.push(0)
        }

        function C(a, b, c) {
            if (!b) return !0;
            c.xSteps[a] = u([c.xVal[a], c.xVal[a + 1]], b) / t(c.xPct[a], c.xPct[a + 1]);
            var d = (c.xVal[a + 1] - c.xVal[a]) / c.xNumSteps[a], e = Math.ceil(Number(d.toFixed(3)) - 1),
                f = c.xVal[a] + c.xNumSteps[a] * e;
            c.xHighestCompleteStep[a] = f
        }

        function D(a, b, c) {
            this.xPct = [], this.xVal = [], this.xSteps = [c || !1], this.xNumSteps = [!1], this.xHighestCompleteStep = [], this.snap = b;
            var d, e = [];
            for (d in a) a.hasOwnProperty(d) && e.push([a[d], d]);
            for (e.length && "object" == typeof e[0][0] ? e.sort(function (a, b) {
                return a[0][0] - b[0][0]
            }) : e.sort(function (a, b) {
                return a[0] - b[0]
            }), d = 0; d < e.length; d++) B(e[d][1], e[d][0], this);
            for (this.xNumSteps = this.xSteps.slice(0), d = 0; d < this.xNumSteps.length; d++) C(d, this.xNumSteps[d], this)
        }

        function E(b) {
            if (a(b)) return !0;
            throw new Error("noUiSlider (" + $ + "): 'format' requires 'to' and 'from' methods.")
        }

        function F(a, b) {
            if (!h(b)) throw new Error("noUiSlider (" + $ + "): 'step' is not numeric.");
            a.singleStep = b
        }

        function G(a, b) {
            if ("object" != typeof b || Array.isArray(b)) throw new Error("noUiSlider (" + $ + "): 'range' is not an object.");
            if (void 0 === b.min || void 0 === b.max) throw new Error("noUiSlider (" + $ + "): Missing 'min' or 'max' in 'range'.");
            if (b.min === b.max) throw new Error("noUiSlider (" + $ + "): 'range' 'min' and 'max' cannot be equal.");
            a.spectrum = new D(b, a.snap, a.singleStep)
        }

        function H(a, b) {
            if (b = k(b), !Array.isArray(b) || !b.length) throw new Error("noUiSlider (" + $ + "): 'start' option is incorrect.");
            a.handles = b.length, a.start = b
        }

        function I(a, b) {
            if (a.snap = b, "boolean" != typeof b) throw new Error("noUiSlider (" + $ + "): 'snap' option must be a boolean.")
        }

        function J(a, b) {
            if (a.animate = b, "boolean" != typeof b) throw new Error("noUiSlider (" + $ + "): 'animate' option must be a boolean.")
        }

        function K(a, b) {
            if (a.animationDuration = b, "number" != typeof b) throw new Error("noUiSlider (" + $ + "): 'animationDuration' option must be a number.")
        }

        function L(a, b) {
            var c, d = [!1];
            if ("lower" === b ? b = [!0, !1] : "upper" === b && (b = [!1, !0]), b === !0 || b === !1) {
                for (c = 1; c < a.handles; c++) d.push(b);
                d.push(!1)
            } else {
                if (!Array.isArray(b) || !b.length || b.length !== a.handles + 1) throw new Error("noUiSlider (" + $ + "): 'connect' option doesn't match handle count.");
                d = b
            }
            a.connect = d
        }

        function M(a, b) {
            switch (b) {
                case"horizontal":
                    a.ort = 0;
                    break;
                case"vertical":
                    a.ort = 1;
                    break;
                default:
                    throw new Error("noUiSlider (" + $ + "): 'orientation' option is invalid.")
            }
        }

        function N(a, b) {
            if (!h(b)) throw new Error("noUiSlider (" + $ + "): 'margin' option must be numeric.");
            if (0 !== b && (a.margin = a.spectrum.getMargin(b), !a.margin)) throw new Error("noUiSlider (" + $ + "): 'margin' option is only supported on linear sliders.")
        }

        function O(a, b) {
            if (!h(b)) throw new Error("noUiSlider (" + $ + "): 'limit' option must be numeric.");
            if (a.limit = a.spectrum.getMargin(b), !a.limit || a.handles < 2) throw new Error("noUiSlider (" + $ + "): 'limit' option is only supported on linear sliders with 2 or more handles.")
        }

        function P(a, b) {
            if (!h(b) && !Array.isArray(b)) throw new Error("noUiSlider (" + $ + "): 'padding' option must be numeric or array of exactly 2 numbers.");
            if (Array.isArray(b) && 2 !== b.length && !h(b[0]) && !h(b[1])) throw new Error("noUiSlider (" + $ + "): 'padding' option must be numeric or array of exactly 2 numbers.");
            if (0 !== b) {
                if (Array.isArray(b) || (b = [b, b]), a.padding = [a.spectrum.getMargin(b[0]), a.spectrum.getMargin(b[1])], a.padding[0] === !1 || a.padding[1] === !1) throw new Error("noUiSlider (" + $ + "): 'padding' option is only supported on linear sliders.");
                if (a.padding[0] < 0 || a.padding[1] < 0) throw new Error("noUiSlider (" + $ + "): 'padding' option must be a positive number(s).");
                if (a.padding[0] + a.padding[1] >= 100) throw new Error("noUiSlider (" + $ + "): 'padding' option must not exceed 100% of the range.")
            }
        }

        function Q(a, b) {
            switch (b) {
                case"ltr":
                    a.dir = 0;
                    break;
                case"rtl":
                    a.dir = 1;
                    break;
                default:
                    throw new Error("noUiSlider (" + $ + "): 'direction' option was not recognized.")
            }
        }

        function R(a, b) {
            if ("string" != typeof b) throw new Error("noUiSlider (" + $ + "): 'behaviour' must be a string containing options.");
            var c = b.indexOf("tap") >= 0, d = b.indexOf("drag") >= 0, e = b.indexOf("fixed") >= 0,
                f = b.indexOf("snap") >= 0, g = b.indexOf("hover") >= 0;
            if (e) {
                if (2 !== a.handles) throw new Error("noUiSlider (" + $ + "): 'fixed' behaviour must be used with 2 handles");
                N(a, a.start[1] - a.start[0])
            }
            a.events = {tap: c || f, drag: d, fixed: e, snap: f, hover: g}
        }

        function S(a, b) {
            if (b !== !1) if (b === !0) {
                a.tooltips = [];
                for (var c = 0; c < a.handles; c++) a.tooltips.push(!0)
            } else {
                if (a.tooltips = k(b), a.tooltips.length !== a.handles) throw new Error("noUiSlider (" + $ + "): must pass a formatter for all handles.");
                a.tooltips.forEach(function (a) {
                    if ("boolean" != typeof a && ("object" != typeof a || "function" != typeof a.to)) throw new Error("noUiSlider (" + $ + "): 'tooltips' must be passed a formatter or 'false'.")
                })
            }
        }

        function T(a, b) {
            a.ariaFormat = b, E(b)
        }

        function U(a, b) {
            a.format = b, E(b)
        }

        function V(a, b) {
            if ("string" != typeof b && b !== !1) throw new Error("noUiSlider (" + $ + "): 'cssPrefix' must be a string or `false`.");
            a.cssPrefix = b
        }

        function W(a, b) {
            if ("object" != typeof b) throw new Error("noUiSlider (" + $ + "): 'cssClasses' must be an object.");
            if ("string" == typeof a.cssPrefix) {
                a.cssClasses = {};
                for (var c in b) b.hasOwnProperty(c) && (a.cssClasses[c] = a.cssPrefix + b[c])
            } else a.cssClasses = b
        }

        function X(a) {
            var b = {margin: 0, limit: 0, padding: 0, animate: !0, animationDuration: 300, ariaFormat: _, format: _},
                d = {
                    step: {r: !1, t: F},
                    start: {r: !0, t: H},
                    connect: {r: !0, t: L},
                    direction: {r: !0, t: Q},
                    snap: {r: !1, t: I},
                    animate: {r: !1, t: J},
                    animationDuration: {r: !1, t: K},
                    range: {r: !0, t: G},
                    orientation: {r: !1, t: M},
                    margin: {r: !1, t: N},
                    limit: {r: !1, t: O},
                    padding: {r: !1, t: P},
                    behaviour: {r: !0, t: R},
                    ariaFormat: {r: !1, t: T},
                    format: {r: !1, t: U},
                    tooltips: {r: !1, t: S},
                    cssPrefix: {r: !0, t: V},
                    cssClasses: {r: !0, t: W}
                }, e = {
                    connect: !1,
                    direction: "ltr",
                    behaviour: "tap",
                    orientation: "horizontal",
                    cssPrefix: "noUi-",
                    cssClasses: {
                        target: "target",
                        base: "base",
                        origin: "origin",
                        handle: "handle",
                        handleLower: "handle-lower",
                        handleUpper: "handle-upper",
                        horizontal: "horizontal",
                        vertical: "vertical",
                        background: "background",
                        connect: "connect",
                        connects: "connects",
                        ltr: "ltr",
                        rtl: "rtl",
                        draggable: "draggable",
                        drag: "state-drag",
                        tap: "state-tap",
                        active: "active",
                        tooltip: "tooltip",
                        pips: "pips",
                        pipsHorizontal: "pips-horizontal",
                        pipsVertical: "pips-vertical",
                        marker: "marker",
                        markerHorizontal: "marker-horizontal",
                        markerVertical: "marker-vertical",
                        markerNormal: "marker-normal",
                        markerLarge: "marker-large",
                        markerSub: "marker-sub",
                        value: "value",
                        valueHorizontal: "value-horizontal",
                        valueVertical: "value-vertical",
                        valueNormal: "value-normal",
                        valueLarge: "value-large",
                        valueSub: "value-sub"
                    }
                };
            a.format && !a.ariaFormat && (a.ariaFormat = a.format), Object.keys(d).forEach(function (f) {
                if (!c(a[f]) && void 0 === e[f]) {
                    if (d[f].r) throw new Error("noUiSlider (" + $ + "): '" + f + "' is required.");
                    return !0
                }
                d[f].t(b, c(a[f]) ? a[f] : e[f])
            }), b.pips = a.pips;
            var f = document.createElement("div"), g = void 0 !== f.style.msTransform, h = void 0 !== f.style.transform;
            b.transformRule = h ? "transform" : g ? "msTransform" : "webkitTransform";
            var i = [["left", "top"], ["right", "bottom"]];
            return b.style = i[b.dir][b.ort], b
        }

        function Y(a, c, f) {/*! In this file: Construction of DOM elements; */
            function h(a, b) {
                var c = ya.createElement("div");
                return b && m(c, b), a.appendChild(c), c
            }

            function l(a, b) {
                var d = h(a, c.cssClasses.origin), e = h(d, c.cssClasses.handle);
                return e.setAttribute("data-handle", b), e.setAttribute("tabindex", "0"), e.setAttribute("role", "slider"), e.setAttribute("aria-orientation", c.ort ? "vertical" : "horizontal"), 0 === b ? m(e, c.cssClasses.handleLower) : b === c.handles - 1 && m(e, c.cssClasses.handleUpper), d
            }

            function t(a, b) {
                return !!b && h(a, c.cssClasses.connect)
            }

            function u(a, b) {
                var d = h(b, c.cssClasses.connects);
                ka = [], la = [], la.push(t(d, a[0]));
                for (var e = 0; e < c.handles; e++) ka.push(l(b, e)), ta[e] = e, la.push(t(d, a[e + 1]))
            }

            function v(a) {
                m(a, c.cssClasses.target), 0 === c.dir ? m(a, c.cssClasses.ltr) : m(a, c.cssClasses.rtl), 0 === c.ort ? m(a, c.cssClasses.horizontal) : m(a, c.cssClasses.vertical), ja = h(a, c.cssClasses.base)
            }

            function w(a, b) {
                return !!c.tooltips[b] && h(a.firstChild, c.cssClasses.tooltip)
            }

            function x() {
                var a = ka.map(w);
                Q("update", function (b, d, e) {
                    if (a[d]) {
                        var f = b[d];
                        c.tooltips[d] !== !0 && (f = c.tooltips[d].to(e[d])), a[d].innerHTML = f
                    }
                })
            }

            function y() {
                Q("update", function (a, b, d, e, f) {
                    ta.forEach(function (a) {
                        var b = ka[a], e = U(sa, a, 0, !0, !0, !0), g = U(sa, a, 100, !0, !0, !0), h = f[a],
                            i = c.ariaFormat.to(d[a]);
                        b.children[0].setAttribute("aria-valuemin", e.toFixed(1)), b.children[0].setAttribute("aria-valuemax", g.toFixed(1)), b.children[0].setAttribute("aria-valuenow", h.toFixed(1)), b.children[0].setAttribute("aria-valuetext", i)
                    })
                })
            }

            function z(a, b, c) {
                if ("range" === a || "steps" === a) return va.xVal;
                if ("count" === a) {
                    if (b < 2) throw new Error("noUiSlider (" + $ + "): 'values' (>= 2) required for mode 'count'.");
                    var d = b - 1, e = 100 / d;
                    for (b = []; d--;) b[d] = d * e;
                    b.push(100), a = "positions"
                }
                return "positions" === a ? b.map(function (a) {
                    return va.fromStepping(c ? va.getStep(a) : a)
                }) : "values" === a ? c ? b.map(function (a) {
                    return va.fromStepping(va.getStep(va.toStepping(a)))
                }) : b : void 0
            }

            function A(a, b, c) {
                function d(a, b) {
                    return (a + b).toFixed(7) / 1
                }

                var f = {}, g = va.xVal[0], h = va.xVal[va.xVal.length - 1], i = !1, j = !1, k = 0;
                return c = e(c.slice().sort(function (a, b) {
                    return a - b
                })), c[0] !== g && (c.unshift(g), i = !0), c[c.length - 1] !== h && (c.push(h), j = !0), c.forEach(function (e, g) {
                    var h, l, m, n, o, p, q, r, s, t, u = e, v = c[g + 1];
                    if ("steps" === b && (h = va.xNumSteps[g]), h || (h = v - u), u !== !1 && void 0 !== v) for (h = Math.max(h, 1e-7), l = u; l <= v; l = d(l, h)) {
                        for (n = va.toStepping(l), o = n - k, r = o / a, s = Math.round(r), t = o / s, m = 1; m <= s; m += 1) p = k + m * t, f[p.toFixed(5)] = ["x", 0];
                        q = c.indexOf(l) > -1 ? 1 : "steps" === b ? 2 : 0, !g && i && (q = 0), l === v && j || (f[n.toFixed(5)] = [l, q]), k = n
                    }
                }), f
            }

            function B(a, b, d) {
                function e(a, b) {
                    var d = b === c.cssClasses.value, e = d ? k : l, f = d ? i : j;
                    return b + " " + e[c.ort] + " " + f[a]
                }

                function f(a, f) {
                    f[1] = f[1] && b ? b(f[0], f[1]) : f[1];
                    var i = h(g, !1);
                    i.className = e(f[1], c.cssClasses.marker), i.style[c.style] = a + "%", f[1] && (i = h(g, !1), i.className = e(f[1], c.cssClasses.value), i.setAttribute("data-value", f[0]), i.style[c.style] = a + "%", i.innerText = d.to(f[0]))
                }

                var g = ya.createElement("div"),
                    i = [c.cssClasses.valueNormal, c.cssClasses.valueLarge, c.cssClasses.valueSub],
                    j = [c.cssClasses.markerNormal, c.cssClasses.markerLarge, c.cssClasses.markerSub],
                    k = [c.cssClasses.valueHorizontal, c.cssClasses.valueVertical],
                    l = [c.cssClasses.markerHorizontal, c.cssClasses.markerVertical];
                return m(g, c.cssClasses.pips), m(g, 0 === c.ort ? c.cssClasses.pipsHorizontal : c.cssClasses.pipsVertical), Object.keys(a).forEach(function (b) {
                    f(b, a[b])
                }), g
            }

            function C() {
                na && (b(na), na = null)
            }

            function D(a) {
                C();
                var b = a.mode, c = a.density || 1, d = a.filter || !1, e = a.values || !1, f = a.stepped || !1,
                    g = z(b, e, f), h = A(c, b, g), i = a.format || {to: Math.round};
                return na = ra.appendChild(B(h, d, i))
            }/*! In this file: Browser events (not slider events like slide, change); */
            function E() {
                var a = ja.getBoundingClientRect(), b = "offset" + ["Width", "Height"][c.ort];
                return 0 === c.ort ? a.width || ja[b] : a.height || ja[b]
            }

            function F(a, b, d, e) {
                var f = function (f) {
                    return !!(f = G(f, e.pageOffset, e.target || b)) && (!(ra.hasAttribute("disabled") && !e.doNotReject) && (!(o(ra, c.cssClasses.tap) && !e.doNotReject) && (!(a === oa.start && void 0 !== f.buttons && f.buttons > 1) && ((!e.hover || !f.buttons) && (qa || f.preventDefault(), f.calcPoint = f.points[c.ort], void d(f, e))))))
                }, g = [];
                return a.split(" ").forEach(function (a) {
                    b.addEventListener(a, f, !!qa && {passive: !0}), g.push([a, f])
                }), g
            }

            function G(a, b, c) {
                var d, e, f = 0 === a.type.indexOf("touch"), g = 0 === a.type.indexOf("mouse"),
                    h = 0 === a.type.indexOf("pointer");
                if (0 === a.type.indexOf("MSPointer") && (h = !0), f) {
                    var i = function (a) {
                        return a.target === c || c.contains(a.target)
                    };
                    if ("touchstart" === a.type) {
                        var j = Array.prototype.filter.call(a.touches, i);
                        if (j.length > 1) return !1;
                        d = j[0].pageX, e = j[0].pageY
                    } else {
                        var k = Array.prototype.find.call(a.changedTouches, i);
                        if (!k) return !1;
                        d = k.pageX, e = k.pageY
                    }
                }
                return b = b || p(ya), (g || h) && (d = a.clientX + b.x, e = a.clientY + b.y), a.pageOffset = b, a.points = [d, e], a.cursor = g || h, a
            }

            function H(a) {
                var b = a - g(ja, c.ort), d = 100 * b / E();
                return d = j(d), c.dir ? 100 - d : d
            }

            function I(a) {
                var b = 100, c = !1;
                return ka.forEach(function (d, e) {
                    if (!d.hasAttribute("disabled")) {
                        var f = Math.abs(sa[e] - a);
                        (f < b || 100 === f && 100 === b) && (c = e, b = f)
                    }
                }), c
            }

            function J(a, b) {
                "mouseout" === a.type && "HTML" === a.target.nodeName && null === a.relatedTarget && L(a, b)
            }

            function K(a, b) {
                if (navigator.appVersion.indexOf("MSIE 9") === -1 && 0 === a.buttons && 0 !== b.buttonsProperty) return L(a, b);
                var d = (c.dir ? -1 : 1) * (a.calcPoint - b.startCalcPoint), e = 100 * d / b.baseSize;
                W(d > 0, e, b.locations, b.handleNumbers)
            }

            function L(a, b) {
                b.handle && (n(b.handle, c.cssClasses.active), ua -= 1), b.listeners.forEach(function (a) {
                    za.removeEventListener(a[0], a[1])
                }), 0 === ua && (n(ra, c.cssClasses.drag), _(), a.cursor && (Aa.style.cursor = "", Aa.removeEventListener("selectstart", d))), b.handleNumbers.forEach(function (a) {
                    S("change", a), S("set", a), S("end", a)
                })
            }

            function M(a, b) {
                var e;
                if (1 === b.handleNumbers.length) {
                    var f = ka[b.handleNumbers[0]];
                    if (f.hasAttribute("disabled")) return !1;
                    e = f.children[0], ua += 1, m(e, c.cssClasses.active)
                }
                a.stopPropagation();
                var g = [], h = F(oa.move, za, K, {
                    target: a.target,
                    handle: e,
                    listeners: g,
                    startCalcPoint: a.calcPoint,
                    baseSize: E(),
                    pageOffset: a.pageOffset,
                    handleNumbers: b.handleNumbers,
                    buttonsProperty: a.buttons,
                    locations: sa.slice()
                }), i = F(oa.end, za, L, {
                    target: a.target,
                    handle: e,
                    listeners: g,
                    doNotReject: !0,
                    handleNumbers: b.handleNumbers
                }), j = F("mouseout", za, J, {
                    target: a.target,
                    handle: e,
                    listeners: g,
                    doNotReject: !0,
                    handleNumbers: b.handleNumbers
                });
                g.push.apply(g, h.concat(i, j)), a.cursor && (Aa.style.cursor = getComputedStyle(a.target).cursor, ka.length > 1 && m(ra, c.cssClasses.drag), Aa.addEventListener("selectstart", d, !1)), b.handleNumbers.forEach(function (a) {
                    S("start", a)
                })
            }

            function N(a) {
                a.stopPropagation();
                var b = H(a.calcPoint), d = I(b);
                return d !== !1 && (c.events.snap || i(ra, c.cssClasses.tap, c.animationDuration), aa(d, b, !0, !0), _(), S("slide", d, !0), S("update", d, !0), S("change", d, !0), S("set", d, !0), void (c.events.snap && M(a, {handleNumbers: [d]})))
            }

            function O(a) {
                var b = H(a.calcPoint), c = va.getStep(b), d = va.fromStepping(c);
                Object.keys(xa).forEach(function (a) {
                    "hover" === a.split(".")[0] && xa[a].forEach(function (a) {
                        a.call(ma, d)
                    })
                })
            }

            function P(a) {
                a.fixed || ka.forEach(function (a, b) {
                    F(oa.start, a.children[0], M, {handleNumbers: [b]})
                }), a.tap && F(oa.start, ja, N, {}), a.hover && F(oa.move, ja, O, {hover: !0}), a.drag && la.forEach(function (b, d) {
                    if (b !== !1 && 0 !== d && d !== la.length - 1) {
                        var e = ka[d - 1], f = ka[d], g = [b];
                        m(b, c.cssClasses.draggable), a.fixed && (g.push(e.children[0]), g.push(f.children[0])), g.forEach(function (a) {
                            F(oa.start, a, M, {handles: [e, f], handleNumbers: [d - 1, d]})
                        })
                    }
                })
            }/*! In this file: Slider events (not browser events); */
            function Q(a, b) {
                xa[a] = xa[a] || [], xa[a].push(b), "update" === a.split(".")[0] && ka.forEach(function (a, b) {
                    S("update", b)
                })
            }

            function R(a) {
                var b = a && a.split(".")[0], c = b && a.substring(b.length);
                Object.keys(xa).forEach(function (a) {
                    var d = a.split(".")[0], e = a.substring(d.length);
                    b && b !== d || c && c !== e || delete xa[a]
                })
            }

            function S(a, b, d) {
                Object.keys(xa).forEach(function (e) {
                    var f = e.split(".")[0];
                    a === f && xa[e].forEach(function (a) {
                        a.call(ma, wa.map(c.format.to), b, wa.slice(), d || !1, sa.slice())
                    })
                })
            }/*! In this file: Mechanics for slider operation */
            function T(a) {
                return a + "%"
            }

            function U(a, b, d, e, f, g) {
                return ka.length > 1 && (e && b > 0 && (d = Math.max(d, a[b - 1] + c.margin)), f && b < ka.length - 1 && (d = Math.min(d, a[b + 1] - c.margin))), ka.length > 1 && c.limit && (e && b > 0 && (d = Math.min(d, a[b - 1] + c.limit)), f && b < ka.length - 1 && (d = Math.max(d, a[b + 1] - c.limit))), c.padding && (0 === b && (d = Math.max(d, c.padding[0])), b === ka.length - 1 && (d = Math.min(d, 100 - c.padding[1]))), d = va.getStep(d), d = j(d), !(d === a[b] && !g) && d
            }

            function V(a, b) {
                var d = c.ort;
                return (d ? b : a) + ", " + (d ? a : b)
            }

            function W(a, b, c, d) {
                var e = c.slice(), f = [!a, a], g = [a, !a];
                d = d.slice(), a && d.reverse(), d.length > 1 ? d.forEach(function (a, c) {
                    var d = U(e, a, e[a] + b, f[c], g[c], !1);
                    d === !1 ? b = 0 : (b = d - e[a], e[a] = d)
                }) : f = g = [!0];
                var h = !1;
                d.forEach(function (a, d) {
                    h = aa(a, c[a] + b, f[d], g[d]) || h
                }), h && d.forEach(function (a) {
                    S("update", a), S("slide", a)
                })
            }

            function Y(a, b) {
                return c.dir ? 100 - a - b : a
            }

            function Z(a, b) {
                sa[a] = b, wa[a] = va.fromStepping(b);
                var d = "translate(" + V(T(Y(b, 0) - Ba), "0") + ")";
                ka[a].style[c.transformRule] = d, ba(a), ba(a + 1)
            }

            function _() {
                ta.forEach(function (a) {
                    var b = sa[a] > 50 ? -1 : 1, c = 3 + (ka.length + b * a);
                    ka[a].style.zIndex = c
                })
            }

            function aa(a, b, c, d) {
                return b = U(sa, a, b, c, d, !1), b !== !1 && (Z(a, b), !0)
            }

            function ba(a) {
                if (la[a]) {
                    var b = 0, d = 100;
                    0 !== a && (b = sa[a - 1]), a !== la.length - 1 && (d = sa[a]);
                    var e = d - b, f = "translate(" + V(T(Y(b, e)), "0") + ")", g = "scale(" + V(e / 100, "1") + ")";
                    la[a].style[c.transformRule] = f + " " + g
                }
            }/*! In this file: All methods eventually exposed in slider.noUiSlider... */
            function ca(a, b) {
                return null === a || a === !1 || void 0 === a ? sa[b] : ("number" == typeof a && (a = String(a)), a = c.format.from(a), a = va.toStepping(a), a === !1 || isNaN(a) ? sa[b] : a)
            }

            function da(a, b) {
                var d = k(a), e = void 0 === sa[0];
                b = void 0 === b || !!b, c.animate && !e && i(ra, c.cssClasses.tap, c.animationDuration), ta.forEach(function (a) {
                    aa(a, ca(d[a], a), !0, !1)
                }), ta.forEach(function (a) {
                    aa(a, sa[a], !0, !0)
                }), _(), ta.forEach(function (a) {
                    S("update", a), null !== d[a] && b && S("set", a)
                })
            }

            function ea(a) {
                da(c.start, a)
            }

            function fa() {
                var a = wa.map(c.format.to);
                return 1 === a.length ? a[0] : a
            }

            function ga() {
                for (var a in c.cssClasses) c.cssClasses.hasOwnProperty(a) && n(ra, c.cssClasses[a]);
                for (; ra.firstChild;) ra.removeChild(ra.firstChild);
                delete ra.noUiSlider
            }

            function ha() {
                return sa.map(function (a, b) {
                    var c = va.getNearbySteps(a), d = wa[b], e = c.thisStep.step, f = null;
                    e !== !1 && d + e > c.stepAfter.startValue && (e = c.stepAfter.startValue - d), f = d > c.thisStep.startValue ? c.thisStep.step : c.stepBefore.step !== !1 && d - c.stepBefore.highestStep, 100 === a ? e = null : 0 === a && (f = null);
                    var g = va.countStepDecimals();
                    return null !== e && e !== !1 && (e = Number(e.toFixed(g))), null !== f && f !== !1 && (f = Number(f.toFixed(g))), [f, e]
                })
            }

            function ia(a, b) {
                var d = fa(), e = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format"];
                e.forEach(function (b) {
                    void 0 !== a[b] && (f[b] = a[b])
                });
                var g = X(f);
                e.forEach(function (b) {
                    void 0 !== a[b] && (c[b] = g[b])
                }), va = g.spectrum, c.margin = g.margin, c.limit = g.limit, c.padding = g.padding, c.pips && D(c.pips), sa = [], da(a.start || d, b)
            }

            var ja, ka, la, ma, na, oa = q(), pa = s(), qa = pa && r(), ra = a, sa = [], ta = [], ua = 0,
                va = c.spectrum, wa = [], xa = {}, ya = a.ownerDocument, za = ya.documentElement, Aa = ya.body,
                Ba = "rtl" === ya.dir || 1 === c.ort ? 0 : 100;/*! In this file: Calls to functions. All other scope_ files define functions only; */
            return v(ra), u(c.connect, ja), P(c.events), da(c.start), ma = {
                destroy: ga,
                steps: ha,
                on: Q,
                off: R,
                get: fa,
                set: da,
                reset: ea,
                __moveHandles: function (a, b, c) {
                    W(a, b, sa, c)
                },
                options: f,
                updateOptions: ia,
                target: ra,
                removePips: C,
                pips: D
            }, c.pips && D(c.pips), c.tooltips && x(), y(), ma
        }

        function Z(a, b) {
            if (!a || !a.nodeName) throw new Error("noUiSlider (" + $ + "): create requires a single element, got: " + a);
            if (a.noUiSlider) throw new Error("noUiSlider (" + $ + "): Slider was already initialized.");
            var c = X(b, a), d = Y(a, c, b);
            return a.noUiSlider = d, d
        }

        var $ = "11.1.0";
        D.prototype.getMargin = function (a) {
            var b = this.xNumSteps[0];
            if (b && a / b % 1 !== 0) throw new Error("noUiSlider (" + $ + "): 'limit', 'margin' and 'padding' must be divisible by step.");
            return 2 === this.xPct.length && u(this.xVal, a)
        }, D.prototype.toStepping = function (a) {
            return a = y(this.xVal, this.xPct, a)
        }, D.prototype.fromStepping = function (a) {
            return z(this.xVal, this.xPct, a)
        }, D.prototype.getStep = function (a) {
            return a = A(this.xPct, this.xSteps, this.snap, a)
        }, D.prototype.getNearbySteps = function (a) {
            var b = x(a, this.xPct);
            return {
                stepBefore: {
                    startValue: this.xVal[b - 2],
                    step: this.xNumSteps[b - 2],
                    highestStep: this.xHighestCompleteStep[b - 2]
                },
                thisStep: {
                    startValue: this.xVal[b - 1],
                    step: this.xNumSteps[b - 1],
                    highestStep: this.xHighestCompleteStep[b - 1]
                },
                stepAfter: {
                    startValue: this.xVal[b - 0],
                    step: this.xNumSteps[b - 0],
                    highestStep: this.xHighestCompleteStep[b - 0]
                }
            }
        }, D.prototype.countStepDecimals = function () {
            var a = this.xNumSteps.map(l);
            return Math.max.apply(null, a)
        }, D.prototype.convert = function (a) {
            return this.getStep(this.toStepping(a))
        };
        var _ = {
            to: function (a) {
                return void 0 !== a && a.toFixed(2)
            }, from: Number
        };
        return {version: $, create: Z}
    }), define("views/captcha-slider-view", ["jquery", "underscore", "backbone", "noUiSlider"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        sliderValue: 0,
        msg: void 0,
        msgStart: void 0,
        msgProgress: void 0,
        msgDone: void 0,
        maxRange: void 0,
        hasHintText: !1,
        specialFieldSelector: ".special-field",
        initialize: function () {
            this.eventDispatcher = window.app.eventDispatcher, this.$sliderCaptcha = this.$(".slider-special-field"), this.$captchaHint = a('<div class="special-field-hint"></div>'), this.dataMsgStart = this.$el.data("msg-start"), this.dataMsgProgress = this.$el.data("msg-progress"), this.dataMsgDone = this.$el.data("msg-done"), this.dataExpectedValue = this.$el.data("expected-value"), this.msgStart = this.dataMsgStart ? this.dataMsgStart : "Swipe right to unlock!", this.msgProgress = this.dataMsgProgress ? this.dataMsgProgress : "Go ahead!", this.msgDone = this.dataMsgDone ? this.dataMsgDone : "Unlocked! Good job!", this.maxRange = this.dataExpectedValue ? parseFloat(this.dataExpectedValue) : 10, this.render()
        },
        render: function () {
            return d.create(this.$sliderCaptcha[0], {
                start: [0],
                range: {min: [0], max: [parseInt(this.maxRange)]},
                behaviour: "drag",
                animate: !0,
                animationDuration: 500,
                connect: [!0, !1]
            }), this.setupListeners(), this
        },
        setupListeners: function () {
            var a = this;
            this.$sliderCaptcha[0].noUiSlider.on("update", function (b) {
                a.onSliderUpdate(a, this, b)
            }), this.$sliderCaptcha[0].noUiSlider.on("end", this.onSlideEnd.bind(this))
        },
        onSlideEnd: function (a) {
            parseFloat(a[0]) < this.maxRange ? (this.$sliderCaptcha[0].noUiSlider.set(0), this.$(this.specialFieldSelector).prop("value", this.sliderValue)) : this.$(this.specialFieldSelector).prop("value", this.maxRange)
        },
        onSliderUpdate: function (b, c, d) {
            this.sliderValue = parseFloat(d[0]), this.sliderValue === this.maxRange ? (this.msg = this.msgDone, a(c.target).addClass("full")) : this.sliderValue >= .5 * this.maxRange && this.sliderValue < this.maxRange ? (this.msg = this.msgProgress, a(c.target).addClass("half"), a(c.target).removeClass("full")) : this.sliderValue < .5 * this.maxRange && (this.msg = this.msgStart, a(c.target).removeClass("full half")), this.hasHintText || (this.hasHintText = !0, b.$(".slider-special-field-label").append(this.$captchaHint), this.$(this.specialFieldSelector).prop("value", this.sliderValue)), this.$captchaHint.html(this.msg)
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("views/contact-grid-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        moduleSelector: ".module-contact-grid",
        itemSelector: ".item",
        collapseToggleClass: "collapse-toggle",
        activeCollapseClass: "show",
        events: {"click .collapse-toggle": "onCollapseToggleClick"},
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"]))
        },
        onCollapseToggleClick: function (b) {
            b.preventDefault(), b.stopPropagation();
            var c = a(b.target);
            c.hasClass(this.collapseToggleClass) || (c = c.parent());
            var d = c.closest(this.itemSelector);
            d.hasClass(this.activeCollapseClass) ? this.closeCollapse(d, !0) : (this.closeCollapse(a(document.body.querySelectorAll(this.itemSelector + "." + this.activeCollapseClass))), this.openCollapse(d))
        },
        openCollapse: function (b) {
            a(b).addClass(this.activeCollapseClass), this.initAutoCloseOnClickOutside(b)
        },
        closeCollapse: function (b, c) {
            var d = a(b);
            d.removeClass(this.activeCollapseClass), c && d.get(0).scrollIntoView()
        },
        initAutoCloseOnClickOutside: function (b) {
            a(document.body).one("click", this.autoClose.bind(this, b))
        },
        autoClose: function (b, c) {
            var d = a(b), e = a(c.target);
            return c.target === d.get(0) || e.closest(this.itemSelector).get(0) === d.get(0) ? void this.initAutoCloseOnClickOutside(b) : void (d.hasClass(this.activeCollapseClass) && this.closeCollapse(b))
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/google-maps-view", ["jquery", "underscore", "backbone", "logger"], function (a, b, c, d) {
    "use strict";
    var e = "labels.text.fill", f = "geometry", g = c.View.extend({
        logger: d.get("GoogleMapsView"),
        map: void 0,
        googleMaps: void 0,
        googleMapsData: void 0,
        autocomplete: void 0,
        autocompleteFields: ["address_components", "geometry"],
        input: void 0,
        currentBounds: void 0,
        mapSelector: ".map",
        allowMultipleInfoWindowsOpened: !0,
        infoWindows: [],
        markers: [],
        theme: {
            marker: {
                path: "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z",
                fillOpacity: 1,
                fillColor: "#009bea",
                strokeWeight: 0,
                scale: 2
            },
            map: [{elementType: f, stylers: [{color: "#f5f5f5"}]}, {
                elementType: "labels.icon",
                stylers: [{visibility: "off"}]
            }, {elementType: e, stylers: [{color: "#616161"}]}, {
                elementType: "labels.text.stroke",
                stylers: [{color: "#f5f5f5"}]
            }, {
                featureType: "administrative.land_parcel",
                elementType: e,
                stylers: [{color: "#bdbdbd"}]
            }, {featureType: "poi", elementType: f, stylers: [{color: "#eeeeee"}]}, {
                featureType: "poi",
                elementType: e,
                stylers: [{color: "#757575"}]
            }, {featureType: "poi.park", elementType: f, stylers: [{color: "#e5e5e5"}]}, {
                featureType: "poi.park",
                elementType: e,
                stylers: [{color: "#9e9e9e"}]
            }, {featureType: "road", elementType: f, stylers: [{color: "#ffffff"}]}, {
                featureType: "road.arterial",
                elementType: e,
                stylers: [{color: "#757575"}]
            }, {
                featureType: "road.highway",
                elementType: f,
                stylers: [{color: "#dadada"}]
            }, {featureType: "road.highway", elementType: e, stylers: [{color: "#616161"}]}, {
                featureType: "road.local",
                elementType: e,
                stylers: [{color: "#9e9e9e"}]
            }, {
                featureType: "transit.line",
                elementType: f,
                stylers: [{color: "#e5e5e5"}]
            }, {featureType: "transit.station", elementType: f, stylers: [{color: "#eeeeee"}]}, {
                featureType: "water",
                elementType: f,
                stylers: [{color: "#c9c9c9"}]
            }, {featureType: "water", elementType: e, stylers: [{color: "#9e9e9e"}]}]
        },
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.setGoogleMapsData(this.options.googleMapsData || window.rsGoogleMapSettings), b.isObject(this.googleMapsData) && (b.isUndefined(this.options.allowMultipleInfoWindowsOpened) || (this.allowMultipleInfoWindowsOpened = this.options.allowMultipleInfoWindowsOpened), this.setupApiPath(), require(["googleMaps"], function (a) {
                this.googleMaps = a, this.initMap()
            }.bind(this), this.onLoadingError.bind(this)))
        },
        setGoogleMapsData: function (a) {
            this.googleMapsData = a, this.geometry = this.googleMapsData.geometry
        },
        clearMarkers: function () {
            b.each(this.markers, function (a) {
                a.setMap(null)
            })
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.updateZoomFactor), this.listenTo(this.eventDispatcher, window.app.applicationEvents.GOOGLE_MAPS_OPEN_INFO_WINDOW, this.onInfoWindowOpen), this.googleMaps.event.addListenerOnce(this.map, "idle", this.onMapLoaded.bind(this))
        },
        setupApiPath: function () {
            var a = this.options.apiLanguage ? "&language=" + this.options.apiLanguage : "";
            require.config({
                paths: {googleMaps: "//maps.googleapis.com/maps/api/js?key=AIzaSyD_hFJV5EYNw7LJXLO3LyMR6_d9GfGDzKA&libraries=places" + a},
                shim: {googleMaps: {exports: "google.maps"}}
            })
        },
        onInfoWindowOpen: function (a) {
            this.el === a.target && b.isObject(a.infoWindow) && (this.allowMultipleInfoWindowsOpened || b.each(this.infoWindows, function (b) {
                b !== a.infoWindow && b.close()
            }))
        },
        onMapLoaded: function () {
            this.eventDispatcher.trigger(window.app.applicationEvents.GOOGLE_MAPS_LOAD, a.Event("load", {
                target: this.el,
                relatedTarget: this.el,
                map: this.map
            }))
        },
        onLoadingError: function (b) {
            this.eventDispatcher.trigger(window.app.applicationEvents.GOOGLE_MAPS_LOADING_ERROR), this.logger.error("Error while loading google maps: " + b.message), a(this.el.querySelector(".gm-err-container")).css("display", "table")
        },
        onPlaceChanged: function () {
            var b = this.autocomplete.getPlace(), c = this.logger, d = this.input;
            if (void 0 !== b.name) {
                var e = {input: b.name}, f = new this.googleMaps.places.AutocompleteService,
                    g = new this.googleMaps.places.PlacesService(this.map);
                f.getPlacePredictions(e, function (b, e) {
                    e === this.googleMaps.places.PlacesServiceStatus.OK && b && b.length > 0 ? (a(d).val(b[0].description), g.getDetails({
                        placeId: b[0].place_id,
                        fields: this.autocompleteFields
                    }, function (a) {
                        this.triggerPlaceLoadedEvent(a)
                    }.bind(this))) : c.error("Error in Google Maps PlacesService. Status: " + this.googleMaps.places.PlacesServiceStatus)
                }.bind(this))
            } else this.triggerPlaceLoadedEvent(b)
        },
        triggerPlaceLoadedEvent: function (b) {
            this.eventDispatcher.trigger(window.app.applicationEvents.GOOGLE_MAPS_PLACE_LOADED, a.Event("load", {
                target: this.el,
                map: this.map,
                place: b
            }))
        },
        initMap: function () {
            this.buildMapObject(), this.setupListeners(), this.updateMapComponents()
        },
        updateMapComponents: function () {
            this.buildMarker(), this.updateZoomFactor()
        },
        initPlacesSearchAutocomplete: function (a) {
            this.input = a, this.autocomplete = new this.googleMaps.places.Autocomplete(a), this.autocomplete.setFields(this.autocompleteFields), this.autocomplete.addListener("place_changed", this.onPlaceChanged.bind(this))
        },
        buildMapObject: function () {
            this.map = new this.googleMaps.Map(this.el.querySelector(this.mapSelector), {
                zoom: this.geometry.map.zoom,
                center: new this.googleMaps.LatLng(this.geometry.map.lat, this.geometry.map.long),
                mapTypeId: "roadmap",
                disableDefaultUI: !0,
                styles: this.theme.map
            })
        },
        buildMarker: function () {
            this.currentBounds = new this.googleMaps.LatLngBounds, this.infoWindows = [];
            var a = {
                size: new this.googleMaps.Size(25, 40),
                origin: new this.googleMaps.Point(0, 0),
                anchor: new this.googleMaps.Point(12, 24),
                scaledSize: new this.googleMaps.Size(25, 40)
            };
            this.markers = [], b.each(this.geometry.marker, function (b) {
                b.defaultIcon = this.buildMarkerIcon(a, b.icon), b.defaultActiveIcon = b.activeIcon ? this.buildMarkerIcon(a, b.activeIcon) : null, b.marker = this.createMarker(b.geometry, b.defaultIcon, b.hasLocation), this.markers.push(b.marker), b.content && this.infoWindows.push(this.createInfoWindow(b.marker, b.content, b.opened))
            }.bind(this))
        },
        resetMarkerIcons: function () {
            b.each(this.geometry.marker, function (a) {
                a.marker && a.defaultIcon && a.marker.setIcon(a.defaultIcon)
            })
        },
        buildMarkerIcon: function (a, c) {
            return "function" == typeof c ? c(this.googleMaps) : c ? b.extend({url: c}, a) : b.extend({}, a, this.theme.marker)
        },
        createMarker: function (a, b, c) {
            var d = new this.googleMaps.LatLng(a.lat, a.long);
            return this.currentBounds.extend(d), new this.googleMaps.Marker({
                position: d,
                map: this.map,
                icon: b,
                hasLocation: c
            })
        },
        createInfoWindow: function (a, b, c) {
            var d = new this.googleMaps.InfoWindow({content: b});
            return a.addListener("click", this.openInfoWindow.bind(this, d, a)), c && this.openInfoWindow(d, a), d
        },
        openInfoWindow: function (c, d) {
            c.open(this.map, d), b.each(this.geometry.marker, function (a) {
                a.marker && a.marker.setZIndex(1)
            }), d.setZIndex(100), this.eventDispatcher.trigger(window.app.applicationEvents.GOOGLE_MAPS_OPEN_INFO_WINDOW, a.Event("open", {
                target: this.el,
                infoWindow: c,
                marker: d,
                map: this.map
            }))
        },
        getInfoWindowIndex: function (a) {
            return this.infoWindows.indexOf(a)
        },
        getMarkerItemDataForMarker: function (a) {
            return b.findWhere(this.geometry.marker, {marker: a})
        },
        fitBounds: function (a) {
            a = a || {}, a.bounds ? (this.map.setCenter(a.bounds.getCenter()), this.map.fitBounds(a.bounds)) : (this.map.setCenter(this.currentBounds.getCenter()), this.map.fitBounds(this.currentBounds)), a.maxZoom ? this.googleMaps.event.addListenerOnce(this.map, "idle", function () {
                this.map.getZoom() > a.maxZoom && this.map.setZoom(a.maxZoom)
            }.bind(this)) : this.map.setZoom(this.map.getZoom() - 1)
        },
        updateZoomFactor: function () {
            var b = window.app.matchMedia.getMediaQueries();
            switch (b.currentMediaQuery) {
                case"media-to-m":
                    this.map.setZoom(Math.max(0, this.geometry.map.zoom - 2));
                    break;
                case"media-from-m-to-l":
                    this.map.setZoom(Math.max(0, this.geometry.map.zoom - 1));
                    break;
                default:
                    this.map.setZoom(this.geometry.map.zoom)
            }
            this.eventDispatcher.trigger(window.app.applicationEvents.GOOGLE_MAPS_UPDATE, a.Event("update", {
                target: this.el,
                relatedTarget: this.el,
                map: this.map
            }))
        },
        setZoomFactor: function (b) {
            this.map.setZoom(b), this.eventDispatcher.trigger(window.app.applicationEvents.GOOGLE_MAPS_UPDATE, a.Event("update", {
                target: this.el,
                relatedTarget: this.el,
                map: this.map
            }))
        },
        getLatLngWithOffset: function (a, b, c) {
            var d = this.map.getProjection();
            if (!d || !b && !c) return a;
            var e = Math.pow(2, this.map.getZoom()), f = d.fromLatLngToPoint(a),
                g = new this.googleMaps.Point(b / e || 0, c / e || 0),
                h = new this.googleMaps.Point(f.x - g.x, f.y + g.y);
            return d.fromPointToLatLng(h)
        }
    });
    return function (a) {
        return this instanceof g ? this : new g(a)
    }
}), define("views/contact-locator-view", ["jquery", "underscore", "backbone", "logger", "mustache", "views/google-maps-view", "views/accordion-item-view"], function (a, b, c, d, e, f, g) {
    "use strict";
    var h = c.View.extend({
        logger: d.get("ContactLocatorView"),
        map: void 0,
        googleMapsView: void 0,
        eventDispatcher: void 0,
        loadDataUrl: void 0,
        currentCountryCode: void 0,
        currentLocationLong: void 0,
        currentLocationLat: void 0,
        initialCountryCode: void 0,
        data: void 0,
        googleMapsData: void 0,
        lastZoomLevel: void 0,
        accordions: [],
        templateCache: {},
        templates: {markerInfoWindow: "contact-locator-marker-info-window", mainWindow: "contact-locator-main-window"},
        mapModuleSelector: ".module-google-maps",
        locatorContainerSelector: ".locator-container",
        locatorSelector: ".locator",
        accordionItemSelector: ".module-accordion",
        contactItemsVisible: 3,
        contactItemSelector: ".contact-item",
        contactItemActiveClass: "active",
        initialMapZoom: 16,
        maxMapZoom: 16,
        offsetX: 0,
        offsetY: 0,
        events: {"click .locator .contact-item": "onContactItemClick", "click #search_submit": "onSearch"},
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.loadDataUrl = this.$el.attr("data-url"), this.currentCountryCode = this.$el.attr("data-country"), this.initialCountryCode = this.currentCountryCode, this.setupListeners(), this.initTemplates(), this.loadData(this.currentCountryCode)
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.GOOGLE_MAPS_LOAD, this.onMapLoad), this.listenTo(this.eventDispatcher, window.app.applicationEvents.GOOGLE_MAPS_UPDATE, this.onMapUpdate), this.listenTo(this.eventDispatcher, window.app.applicationEvents.GOOGLE_MAPS_OPEN_INFO_WINDOW, this.onMapInfoWindowOpen), this.listenTo(this.eventDispatcher, window.app.applicationEvents.GOOGLE_MAPS_LOADING_ERROR, this.onGoogleMapsLoadingError), this.listenTo(this.eventDispatcher, window.app.applicationEvents.GOOGLE_MAPS_PLACE_LOADED, this.onAutocompletePlaceLoaded), this.listenTo(this.eventDispatcher, window.app.applicationEvents.ACCORDION_SHOW, this.onAccordionShow)
        },
        onMapLoad: function (a) {
            this.googleMapsView && a.target === this.googleMapsView.el && (this.googleMapsView.initPlacesSearchAutocomplete(document.getElementById("placesSearch")), this.onMapUpdate(a), this.googleMapsData.geometry && 0 !== this.googleMapsData.geometry.marker.length && this.googleMapsView.fitBounds({maxZoom: this.maxMapZoom}))
        },
        onMapUpdate: function (a) {
            this.googleMapsView && a.target === this.googleMapsView.el && this.updateOffset()
        },
        onMapInfoWindowOpen: function (c) {
            if (this.googleMapsView && c.target === this.googleMapsView.el && !b.isUndefined(c.marker) && !b.isUndefined(c.infoWindow)) {
                c.marker.hasLocation || (this.lastZoomLevel = this.googleMapsView.map.getZoom(), this.googleMapsView.setZoomFactor(3)), c.marker.hasLocation && this.lastZoomLevel && (this.googleMapsView.setZoomFactor(this.lastZoomLevel), this.lastZoomLevel = null), this.googleMapsView.map.panTo(this.googleMapsView.getLatLngWithOffset(c.marker.position, this.offsetX, this.offsetY)), this.googleMapsView.resetMarkerIcons(), this.setActiveMarkerIcon(c.marker);
                var d = this.googleMapsView.getInfoWindowIndex(c.infoWindow);
                if (!(d < 0)) {
                    var e = a(this.el.querySelector(this.contactItemSelector + '[data-pos="' + d + '"]'));
                    if (!e.hasClass(this.contactItemActiveClass)) {
                        this.activateContactItem(e);
                        var f = b.findWhere(this.accordions, {el: e.closest(this.accordionItemSelector).get(0)});
                        f && f.showContent(a.Event("show", {infoWindow: c.infoWindow}))
                    }
                }
            }
        },
        onAccordionShow: function (c, d) {
            d && d.parent === this.el && b.each(this.accordions, function (b) {
                b.$el.hasClass("active") && c.index !== b.$el.index() && (b.hideContent(c, d), a(b.$el).find("*").removeClass("active"))
            })
        },
        setActiveMarkerIcon: function (a) {
            if (this.googleMapsView) {
                var b = this.googleMapsView.getMarkerItemDataForMarker(a);
                b && b.defaultActiveIcon && a.setIcon(b.defaultActiveIcon)
            }
        },
        onContactItemClick: function (c) {
            var d = a(c.target);
            d.is(this.contactItemSelector) || (d = d.closest(this.contactItemSelector)), this.activateContactItem(d);
            var e = parseInt(d.attr("data-pos"));
            return b.isNaN(e) ? void this.logger.warn("Unknown position.") : ("media-to-m" === window.app.matchMedia.getCurrentMediaQuery() && document.getElementsByClassName("map")[0].scrollIntoView(), void this.clickMarker(e))
        },
        activateContactItem: function (b) {
            var c = a(b);
            c.siblings().removeClass(this.contactItemActiveClass), c.addClass(this.contactItemActiveClass)
        },
        clickMarker: function (a) {
            !this.googleMapsView.googleMaps || !this.googleMapsData.geometry || this.googleMapsData.geometry.marker.length <= a || this.googleMapsView.googleMaps.event.trigger(this.googleMapsData.geometry.marker[a].marker, "click")
        },
        initTemplates: function () {
            var a, b;
            for (a in this.templates) this.templates.hasOwnProperty(a) && (b = this.templates[a], this.templateCache[b] = document.getElementById(b).innerHTML)
        },
        initModule: function () {
            var a = this.el.querySelector(this.locatorContainerSelector);
            if (!a) return void this.logger.warn("Missing locator container");
            a.innerHTML = this.renderTemplate(this.templates.mainWindow, this.data);
            var c, d;
            this.accordions = [], b.each(a.querySelectorAll(this.accordionItemSelector), function (a, b) {
                c = a.querySelectorAll(this.contactItemSelector), d = c.length > this.contactItemsVisible && this.calcElementsOuterHeight.bind(null, c, 1, this.contactItemsVisible), this.accordions.push(new g({
                    el: a,
                    initialActive: 0 === b,
                    parent: this.el,
                    maxHeightLimit: d
                }))
            }.bind(this)), this.googleMapsView ? (this.googleMapsView.setGoogleMapsData(this.googleMapsData), this.googleMapsView.clearMarkers(), this.googleMapsView.updateMapComponents(), this.googleMapsView.initPlacesSearchAutocomplete(document.getElementById("placesSearch")), this.updateOffset(), this.googleMapsView.fitBounds({maxZoom: this.maxMapZoom}), this.clickMarker(0)) : this.googleMapsView = new f({
                el: this.el.querySelector(this.mapModuleSelector),
                googleMapsData: this.googleMapsData,
                allowMultipleInfoWindowsOpened: !1,
                apiLanguage: this.initialCountryCode
            })
        },
        updateOffset: function () {
            if (this.googleMapsView) {
                if ("media-to-m" === window.app.matchMedia.getCurrentMediaQuery()) return void (this.offsetX = 0);
                var b = a(this.el.querySelector(this.locatorSelector));
                return "media-from-l" === window.app.matchMedia.getCurrentMediaQuery() ? void (this.offsetX = .5 * b.width()) : void (this.offsetX = b.width() - (b.offset().left - this.googleMapsView.$el.offset().left))
            }
        },
        calcElementsOuterHeight: function (c, d, e) {
            var f = 0;
            return d = "number" == typeof d ? d : 0, e = e || c.length, b.each(c, function (b, c) {
                c < e && (f += a(b).outerHeight() - d || 0)
            }), Math.max(0, f)
        },
        loadData: function (a, b, c) {
            this.logger.info("Loading data for: " + a), window.app.api({
                url: this.loadDataUrl,
                data: {country: a, long: b, lat: c}
            }).done(this.onLoadDataDone.bind(this)).fail(this.logAjaxError.bind(this))
        },
        onLoadDataDone: function (a) {
            b.isObject(a) && "OK" === a.status && b.isObject(a.data) ? (this.prepareData(a.data), this.initModule()) : b.isObject(a.error) ? this.logAjaxError(a.error.message) : this.logAjaxError("Internal error.")
        },
        onAutocompletePlaceLoaded: function (a) {
            if (a.place && a.target === this.googleMapsView.el) {
                var c, d, e = a.place;
                e.geometry && e.geometry.location && (c = e.geometry.location.lng(), d = e.geometry.location.lat()), b.each(e.address_components, function (a) {
                    "country" === a.types[0] && this.switchPositionData(a.short_name, c, d)
                }.bind(this))
            }
        },
        logAjaxError: function (a, b, c) {
            this.logger.error("failed to load data", c || a)
        },
        prepareData: function (a) {
            this.data = a;
            var c = [], d = null, e = null, f = 0;
            b.each(a.categories, function (a) {
                a.icons = a.icons || {}, b.each(a.items, function (g) {
                    g.index = f, g.icons = a.icons || {}, g.content = this.renderTemplate(this.templates.markerInfoWindow, g), e = this.getItemLocation(g), c.push({
                        geometry: this.getItemGeometryData(e),
                        icon: this.createCustomMarkerIcon.bind(this, g.icons.marker, !1),
                        activeIcon: this.createCustomMarkerIcon.bind(this, g.icons.activeMarker, !0),
                        content: g.content,
                        hasLocation: b.isObject(e)
                    }), d = d || g, f++
                }.bind(this))
            }.bind(this));
            var g = this.getItemGeometryData(this.getItemLocation(d));
            g.zoom = this.initialMapZoom, this.googleMapsData = {geometry: {map: g, marker: c}}
        },
        createCustomMarkerIcon: function (a, b, c) {
            var d = {url: a, origin: new c.Point(0, 0)};
            return b ? (d.anchor = new c.Point(30, 80), d.size = new c.Size(60, 80), d.scaledSize = new c.Size(60, 80)) : (d.anchor = new c.Point(20, 80), d.size = new c.Size(40, 60), d.scaledSize = new c.Size(40, 60)), d
        },
        getItemLocation: function (a) {
            if (!a) return null;
            var c = a.location;
            return !c && a.address && a.address.location && (c = a.address.location), b.isObject(c) && b.isNull(c.lat) && b.isNull(c.lng) ? null : c
        },
        getItemGeometryData: function (a) {
            return b.isObject(a) ? {lat: a.lat, long: a.lng} : {lat: 48.1277981, long: 11.6118002}
        },
        renderTemplate: function (a, b) {
            var c = this.templateCache[a];
            return e.parse(c), e.render(c, b)
        },
        onSearch: function () {
            var a = document.getElementById("placesSearch");
            this.googleMapsView.googleMaps.event.trigger(a, "focus", {}), this.googleMapsView.googleMaps.event.trigger(a, "keydown", {
                keyCode: 40,
                stopPropagation: function () {
                },
                preventDefault: function () {
                }
            }), this.googleMapsView.googleMaps.event.trigger(a, "keydown", {keyCode: 13})
        },
        onGoogleMapsLoadingError: function () {
            this.googleMapsView && a(this.el.querySelector(".search-container")).hide()
        },
        switchPositionData: function (a, b, c) {
            a = a.toUpperCase(), this.currentCountryCode === a && this.currentLocationLong === b && this.currentLocationLat === c || (this.currentCountryCode = a, this.currentLocationLong = b, this.currentLocationLat = c, this.loadData(a, b, c))
        }
    });
    return function (a) {
        return this instanceof h ? this : new h(a)
    }
}), define("views/country-overview-view", ["jquery", "underscore", "backbone", "views/accordion-item-view"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        events: {"click .notification .deny": "closeNotification"}, initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.accordionElems = this.$(".continent"), this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.render)
        }, render: function () {
            var a = window.app.matchMedia.getMediaQueries(), b = "media-to-m" === a.currentMediaQuery;
            return a.currentMediaQuery === a.lastMediaQuery || b === !0 && "accordion" === this.currentDisplay ? this : (b ? this.renderAccordion() : "accordion" === this.currentDisplay && this.destroyAccordion(), this)
        }, renderAccordion: function () {
            for (var a = 0, b = this.accordionElems.length; a < b; a++) new d({
                el: this.accordionElems[a],
                parent: this
            });
            this.currentDisplay = "accordion"
        }, destroyAccordion: function () {
            var b = a.Event("reset", {target: this.el, relatedTarget: this.el});
            window.app.eventDispatcher.trigger(window.app.applicationEvents.ACCORDION_RESET, b, this), this.currentDisplay = null
        }, closeNotification: function () {
            this.$(".notification").fadeOut(500)
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("app/delayed-initialization", ["jquery", "underscore"], function (a, b) {
    "use strict";
    return {
        $cover: void 0, delayInitialization: function () {
            this.$el.offset().top - (window.pageYOffset + 1.5 * window.innerHeight) <= 0 ? this.delayedInitialization() : (this.$cover = a('<div class="cover"><div class="loader"/></div>').appendTo(this.$el), this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_SCROLL, this.waitForInitialization.bind(this)))
        }, waitForInitialization: function () {
            this.$el.offset().top - (window.pageYOffset + 1.5 * window.innerHeight) <= 0 && (this.stopListening(this.eventDispatcher, window.app.applicationEvents.WINDOW_SCROLL), this.delayedInitialization())
        }, uncover: function () {
            this.$cover && b.isObject(this.$cover) && 0 !== this.$cover.length && (this.$cover.remove(), this.$cover = null)
        }
    }
}), define("views/country-slider-view", ["jquery", "underscore", "backbone", "logger", "app/delayed-initialization", "mustache", "slick-slider"], function (a, b, c, d, e, f) {
    "use strict";
    var g = c.View.extend({
        $parent: void 0,
        $controls: void 0,
        $slider: void 0,
        initialSlide: 0,
        contentIndex: void 0,
        eventDispatcher: void 0,
        slickSliderOptions: void 0,
        countrySliderTemplate: void 0,
        logger: d.get("CountrySliderView"),
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.data = this.options.data, this.$parent = this.$el.parent(".module"), this.eventDispatcher = window.app.eventDispatcher, b.extend(g.prototype, e), this.delayInitialization()
        },
        delayedInitialization: function () {
            this.$controls = a('<div class="controls" />').prependTo(this.$el), this.slickSliderOptions = {
                rows: 0,
                adaptiveHeight: !0,
                accessibility: !1,
                dots: !0,
                infinite: !0,
                initialSlide: this.initialSlide,
                slidesToShow: 1,
                slidesToScroll: 1,
                touchThreshold: 4,
                easing: "ease-in",
                slide: ".slide",
                arrows: !1,
                appendDots: this.$controls,
                mobileFirst: !0,
                customPaging: function (b, c) {
                    var d = a(b.$slides[c]).data("title");
                    return "<div>" + d + "</div>"
                }
            }, this.render(), this.uncover()
        },
        render: function () {
            var c, d = this.data;
            return b.has(d, "regions") && b.isArray(d.regions) ? (this.countrySliderTemplate = a("#country-slider-tmpl").html(), b.isUndefined(this.countrySliderTemplate) || !b.isString(this.countrySliderTemplate) ? this : (c = f.render(this.countrySliderTemplate, d), this.$el.append(c), this.$slider = this.$el.slick(this.slickSliderOptions), this.$slider.on("beforeChange", this.onSliderBeforeChange.bind(this)), this.$slider.on("afterChange", this.onSliderAfterChange.bind(this)), this)) : (this.logger.warn("No regions data found."), this)
        },
        onSliderBeforeChange: function (b, c, d, e) {
            var f = a(c.$slides[e].querySelector(".countries"));
            window.setTimeout(f.css.bind(f, "column-width", "auto"), 0)
        },
        onSliderAfterChange: function (b, c, d) {
            var e = a(c.$slides[d].querySelector(".countries"));
            window.setTimeout(e.css.bind(e, "column-width", Math.floor(e.outerWidth() / e.css("column-count"))), 0), window.setTimeout(e.css.bind(e, "column-width", "auto"), 0)
        }
    });
    return function (a) {
        return this instanceof g ? this : new g(a)
    }
}), !function () {
    "use strict";
    var a, b = function (d, e) {
        function f(a) {
            return Math.floor(a)
        }

        function g() {
            var a = v.params.autoplay, b = v.slides.eq(v.activeIndex);
            b.attr("data-swiper-autoplay") && (a = b.attr("data-swiper-autoplay") || v.params.autoplay), v.autoplayTimeoutId = setTimeout(function () {
                v.params.loop ? (v.fixLoop(), v._slideNext(), v.emit("onAutoplay", v)) : v.isEnd ? e.autoplayStopOnLast ? v.stopAutoplay() : (v._slideTo(0), v.emit("onAutoplay", v)) : (v._slideNext(), v.emit("onAutoplay", v))
            }, a)
        }

        function h(b, c) {
            var d = a(b.target);
            if (!d.is(c)) if ("string" == typeof c) d = d.parents(c); else if (c.nodeType) {
                var e;
                return d.parents().each(function (a, b) {
                    b === c && (e = c)
                }), e ? c : void 0
            }
            if (0 !== d.length) return d[0]
        }

        function i(a, b) {
            b = b || {};
            var c = window.MutationObserver || window.WebkitMutationObserver, d = new c(function (a) {
                a.forEach(function (a) {
                    v.onResize(!0), v.emit("onObserverUpdate", v, a)
                })
            });
            d.observe(a, {
                attributes: void 0 === b.attributes || b.attributes,
                childList: void 0 === b.childList || b.childList,
                characterData: void 0 === b.characterData || b.characterData
            }), v.observers.push(d)
        }

        function j(a) {
            a.originalEvent && (a = a.originalEvent);
            var b = a.keyCode || a.charCode;
            if (!v.params.allowSwipeToNext && (v.isHorizontal() && 39 === b || !v.isHorizontal() && 40 === b)) return !1;
            if (!v.params.allowSwipeToPrev && (v.isHorizontal() && 37 === b || !v.isHorizontal() && 38 === b)) return !1;
            if (!(a.shiftKey || a.altKey || a.ctrlKey || a.metaKey || document.activeElement && document.activeElement.nodeName && ("input" === document.activeElement.nodeName.toLowerCase() || "textarea" === document.activeElement.nodeName.toLowerCase()))) {
                if (37 === b || 39 === b || 38 === b || 40 === b) {
                    var c = !1;
                    if (v.container.parents("." + v.params.slideClass).length > 0 && 0 === v.container.parents("." + v.params.slideActiveClass).length) return;
                    var d = {left: window.pageXOffset, top: window.pageYOffset}, e = window.innerWidth,
                        f = window.innerHeight, g = v.container.offset();
                    v.rtl && (g.left = g.left - v.container[0].scrollLeft);
                    for (var h = [[g.left, g.top], [g.left + v.width, g.top], [g.left, g.top + v.height], [g.left + v.width, g.top + v.height]], i = 0; i < h.length; i++) {
                        var j = h[i];
                        j[0] >= d.left && j[0] <= d.left + e && j[1] >= d.top && j[1] <= d.top + f && (c = !0)
                    }
                    if (!c) return
                }
                v.isHorizontal() ? (37 !== b && 39 !== b || (a.preventDefault ? a.preventDefault() : a.returnValue = !1), (39 === b && !v.rtl || 37 === b && v.rtl) && v.slideNext(), (37 === b && !v.rtl || 39 === b && v.rtl) && v.slidePrev()) : (38 !== b && 40 !== b || (a.preventDefault ? a.preventDefault() : a.returnValue = !1), 40 === b && v.slideNext(), 38 === b && v.slidePrev()), v.emit("onKeyPress", v, b)
            }
        }

        function k(a) {
            var b = 0, c = 0, d = 0, e = 0;
            return "detail" in a && (c = a.detail), "wheelDelta" in a && (c = -a.wheelDelta / 120), "wheelDeltaY" in a && (c = -a.wheelDeltaY / 120), "wheelDeltaX" in a && (b = -a.wheelDeltaX / 120), "axis" in a && a.axis === a.HORIZONTAL_AXIS && (b = c, c = 0), d = 10 * b, e = 10 * c, "deltaY" in a && (e = a.deltaY), "deltaX" in a && (d = a.deltaX), (d || e) && a.deltaMode && (1 === a.deltaMode ? (d *= 40, e *= 40) : (d *= 800, e *= 800)), d && !b && (b = d < 1 ? -1 : 1), e && !c && (c = e < 1 ? -1 : 1), {
                spinX: b,
                spinY: c,
                pixelX: d,
                pixelY: e
            }
        }

        function l(a) {
            a.originalEvent && (a = a.originalEvent);
            var b = 0, c = v.rtl ? -1 : 1, d = k(a);
            if (v.params.mousewheelForceToAxis) if (v.isHorizontal()) {
                if (!(Math.abs(d.pixelX) > Math.abs(d.pixelY))) return;
                b = d.pixelX * c
            } else {
                if (!(Math.abs(d.pixelY) > Math.abs(d.pixelX))) return;
                b = d.pixelY
            } else b = Math.abs(d.pixelX) > Math.abs(d.pixelY) ? -d.pixelX * c : -d.pixelY;
            if (0 !== b) {
                if (v.params.mousewheelInvert && (b = -b), v.params.freeMode) {
                    var e = v.getWrapperTranslate() + b * v.params.mousewheelSensitivity, f = v.isBeginning,
                        g = v.isEnd;
                    if (e >= v.minTranslate() && (e = v.minTranslate()), e <= v.maxTranslate() && (e = v.maxTranslate()), v.setWrapperTransition(0), v.setWrapperTranslate(e), v.updateProgress(), v.updateActiveIndex(), (!f && v.isBeginning || !g && v.isEnd) && v.updateClasses(), v.params.freeModeSticky ? (clearTimeout(v.mousewheel.timeout), v.mousewheel.timeout = setTimeout(function () {
                        v.slideReset()
                    }, 300)) : v.params.lazyLoading && v.lazy && v.lazy.load(), v.emit("onScroll", v, a), v.params.autoplay && v.params.autoplayDisableOnInteraction && v.stopAutoplay(), 0 === e || e === v.maxTranslate()) return
                } else {
                    if ((new window.Date).getTime() - v.mousewheel.lastScrollTime > 60) if (b < 0) if (v.isEnd && !v.params.loop || v.animating) {
                        if (v.params.mousewheelReleaseOnEdges) return !0
                    } else v.slideNext(), v.emit("onScroll", v, a); else if (v.isBeginning && !v.params.loop || v.animating) {
                        if (v.params.mousewheelReleaseOnEdges) return !0
                    } else v.slidePrev(), v.emit("onScroll", v, a);
                    v.mousewheel.lastScrollTime = (new window.Date).getTime()
                }
                return a.preventDefault ? a.preventDefault() : a.returnValue = !1, !1
            }
        }

        function m(b, c) {
            b = a(b);
            var d, e, f, g = v.rtl ? -1 : 1;
            d = b.attr("data-swiper-parallax") || "0", e = b.attr("data-swiper-parallax-x"), f = b.attr("data-swiper-parallax-y"), e || f ? (e = e || "0", f = f || "0") : v.isHorizontal() ? (e = d, f = "0") : (f = d, e = "0"), e = e.indexOf("%") >= 0 ? parseInt(e, 10) * c * g + "%" : e * c * g + "px", f = f.indexOf("%") >= 0 ? parseInt(f, 10) * c + "%" : f * c + "px", b.transform("translate3d(" + e + ", " + f + ",0px)")
        }

        function n(a) {
            return 0 !== a.indexOf("on") && (a = a[0] !== a[0].toUpperCase() ? "on" + a[0].toUpperCase() + a.substring(1) : "on" + a), a
        }

        if (!(this instanceof b)) return new b(d, e);
        var o = {
            direction: "horizontal",
            touchEventsTarget: "container",
            initialSlide: 0,
            speed: 300,
            autoplay: !1,
            autoplayDisableOnInteraction: !0,
            autoplayStopOnLast: !1,
            iOSEdgeSwipeDetection: !1,
            iOSEdgeSwipeThreshold: 20,
            freeMode: !1,
            freeModeMomentum: !0,
            freeModeMomentumRatio: 1,
            freeModeMomentumBounce: !0,
            freeModeMomentumBounceRatio: 1,
            freeModeMomentumVelocityRatio: 1,
            freeModeSticky: !1,
            freeModeMinimumVelocity: .02,
            autoHeight: !1,
            setWrapperSize: !1,
            virtualTranslate: !1,
            effect: "slide",
            coverflow: {rotate: 50, stretch: 0, depth: 100, modifier: 1, slideShadows: !0},
            flip: {slideShadows: !0, limitRotation: !0},
            cube: {slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: .94},
            fade: {crossFade: !1},
            parallax: !1,
            zoom: !1,
            zoomMax: 3,
            zoomMin: 1,
            zoomToggle: !0,
            scrollbar: null,
            scrollbarHide: !0,
            scrollbarDraggable: !1,
            scrollbarSnapOnRelease: !1,
            keyboardControl: !1,
            mousewheelControl: !1,
            mousewheelReleaseOnEdges: !1,
            mousewheelInvert: !1,
            mousewheelForceToAxis: !1,
            mousewheelSensitivity: 1,
            mousewheelEventsTarged: "container",
            hashnav: !1,
            hashnavWatchState: !1,
            history: !1,
            replaceState: !1,
            breakpoints: void 0,
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerColumnFill: "column",
            slidesPerGroup: 1,
            centeredSlides: !1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            roundLengths: !1,
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: !0,
            shortSwipes: !0,
            longSwipes: !0,
            longSwipesRatio: .5,
            longSwipesMs: 300,
            followFinger: !0,
            onlyExternal: !1,
            threshold: 0,
            touchMoveStopPropagation: !0,
            touchReleaseOnEdges: !1,
            uniqueNavElements: !0,
            pagination: null,
            paginationElement: "span",
            paginationClickable: !1,
            paginationHide: !1,
            paginationBulletRender: null,
            paginationProgressRender: null,
            paginationFractionRender: null,
            paginationCustomRender: null,
            paginationType: "bullets",
            resistance: !0,
            resistanceRatio: .85,
            nextButton: null,
            prevButton: null,
            watchSlidesProgress: !1,
            watchSlidesVisibility: !1,
            grabCursor: !1,
            preventClicks: !0,
            preventClicksPropagation: !0,
            slideToClickedSlide: !1,
            lazyLoading: !1,
            lazyLoadingInPrevNext: !1,
            lazyLoadingInPrevNextAmount: 1,
            lazyLoadingOnTransitionStart: !1,
            preloadImages: !0,
            updateOnImagesReady: !0,
            loop: !1,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            control: void 0,
            controlInverse: !1,
            controlBy: "slide",
            normalizeSlideIndex: !0,
            allowSwipeToPrev: !0,
            allowSwipeToNext: !0,
            swipeHandler: null,
            noSwiping: !0,
            noSwipingClass: "swiper-no-swiping",
            passiveListeners: !0,
            containerModifierClass: "swiper-container-",
            slideClass: "swiper-slide",
            slideActiveClass: "swiper-slide-active",
            slideDuplicateActiveClass: "swiper-slide-duplicate-active",
            slideVisibleClass: "swiper-slide-visible",
            slideDuplicateClass: "swiper-slide-duplicate",
            slideNextClass: "swiper-slide-next",
            slideDuplicateNextClass: "swiper-slide-duplicate-next",
            slidePrevClass: "swiper-slide-prev",
            slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
            wrapperClass: "swiper-wrapper",
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
            buttonDisabledClass: "swiper-button-disabled",
            paginationCurrentClass: "swiper-pagination-current",
            paginationTotalClass: "swiper-pagination-total",
            paginationHiddenClass: "swiper-pagination-hidden",
            paginationProgressbarClass: "swiper-pagination-progressbar",
            paginationClickableClass: "swiper-pagination-clickable",
            paginationModifierClass: "swiper-pagination-",
            lazyLoadingClass: "swiper-lazy",
            lazyStatusLoadingClass: "swiper-lazy-loading",
            lazyStatusLoadedClass: "swiper-lazy-loaded",
            lazyPreloaderClass: "swiper-lazy-preloader",
            notificationClass: "swiper-notification",
            preloaderClass: "preloader",
            zoomContainerClass: "swiper-zoom-container",
            observer: !1,
            observeParents: !1,
            a11y: !1,
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            runCallbacksOnInit: !0
        }, p = e && e.virtualTranslate;
        e = e || {};
        var q = {};
        for (var r in e) if ("object" != typeof e[r] || null === e[r] || e[r].nodeType || e[r] === window || e[r] === document || void 0 !== c && e[r] instanceof c || "undefined" != typeof jQuery && e[r] instanceof jQuery) q[r] = e[r]; else {
            q[r] = {};
            for (var s in e[r]) q[r][s] = e[r][s]
        }
        for (var t in o) if (void 0 === e[t]) e[t] = o[t]; else if ("object" == typeof e[t]) for (var u in o[t]) void 0 === e[t][u] && (e[t][u] = o[t][u]);
        var v = this;
        if (v.params = e, v.originalParams = q, v.classNames = [], void 0 !== a && void 0 !== c && (a = c), (void 0 !== a || (a = void 0 === c ? window.Dom7 || window.Zepto || window.jQuery : c)) && (v.$ = a, v.currentBreakpoint = void 0, v.getActiveBreakpoint = function () {
            if (!v.params.breakpoints) return !1;
            var a, b = !1, c = [];
            for (a in v.params.breakpoints) v.params.breakpoints.hasOwnProperty(a) && c.push(a);
            c.sort(function (a, b) {
                return parseInt(a, 10) > parseInt(b, 10)
            });
            for (var d = 0; d < c.length; d++) (a = c[d]) >= window.innerWidth && !b && (b = a);
            return b || "max"
        }, v.setBreakpoint = function () {
            var a = v.getActiveBreakpoint();
            if (a && v.currentBreakpoint !== a) {
                var b = a in v.params.breakpoints ? v.params.breakpoints[a] : v.originalParams,
                    c = v.params.loop && b.slidesPerView !== v.params.slidesPerView;
                for (var d in b) v.params[d] = b[d];
                v.currentBreakpoint = a, c && v.destroyLoop && v.reLoop(!0)
            }
        }, v.params.breakpoints && v.setBreakpoint(), v.container = a(d), 0 !== v.container.length)) {
            if (v.container.length > 1) {
                var w = [];
                return v.container.each(function () {
                    w.push(new b(this, e))
                }), w
            }
            v.container[0].swiper = v, v.container.data("swiper", v), v.classNames.push(v.params.containerModifierClass + v.params.direction), v.params.freeMode && v.classNames.push(v.params.containerModifierClass + "free-mode"), v.support.flexbox || (v.classNames.push(v.params.containerModifierClass + "no-flexbox"), v.params.slidesPerColumn = 1), v.params.autoHeight && v.classNames.push(v.params.containerModifierClass + "autoheight"), (v.params.parallax || v.params.watchSlidesVisibility) && (v.params.watchSlidesProgress = !0), v.params.touchReleaseOnEdges && (v.params.resistanceRatio = 0), ["cube", "coverflow", "flip"].indexOf(v.params.effect) >= 0 && (v.support.transforms3d ? (v.params.watchSlidesProgress = !0, v.classNames.push(v.params.containerModifierClass + "3d")) : v.params.effect = "slide"), "slide" !== v.params.effect && v.classNames.push(v.params.containerModifierClass + v.params.effect), "cube" === v.params.effect && (v.params.resistanceRatio = 0, v.params.slidesPerView = 1, v.params.slidesPerColumn = 1, v.params.slidesPerGroup = 1, v.params.centeredSlides = !1, v.params.spaceBetween = 0, v.params.virtualTranslate = !0), "fade" !== v.params.effect && "flip" !== v.params.effect || (v.params.slidesPerView = 1, v.params.slidesPerColumn = 1, v.params.slidesPerGroup = 1, v.params.watchSlidesProgress = !0, v.params.spaceBetween = 0, void 0 === p && (v.params.virtualTranslate = !0)), v.params.grabCursor && v.support.touch && (v.params.grabCursor = !1), v.wrapper = v.container.children("." + v.params.wrapperClass), v.params.pagination && (v.paginationContainer = a(v.params.pagination), v.params.uniqueNavElements && "string" == typeof v.params.pagination && v.paginationContainer.length > 1 && 1 === v.container.find(v.params.pagination).length && (v.paginationContainer = v.container.find(v.params.pagination)), "bullets" === v.params.paginationType && v.params.paginationClickable ? v.paginationContainer.addClass(v.params.paginationModifierClass + "clickable") : v.params.paginationClickable = !1, v.paginationContainer.addClass(v.params.paginationModifierClass + v.params.paginationType)), (v.params.nextButton || v.params.prevButton) && (v.params.nextButton && (v.nextButton = a(v.params.nextButton), v.params.uniqueNavElements && "string" == typeof v.params.nextButton && v.nextButton.length > 1 && 1 === v.container.find(v.params.nextButton).length && (v.nextButton = v.container.find(v.params.nextButton))), v.params.prevButton && (v.prevButton = a(v.params.prevButton), v.params.uniqueNavElements && "string" == typeof v.params.prevButton && v.prevButton.length > 1 && 1 === v.container.find(v.params.prevButton).length && (v.prevButton = v.container.find(v.params.prevButton)))), v.isHorizontal = function () {
                return "horizontal" === v.params.direction
            }, v.rtl = v.isHorizontal() && ("rtl" === v.container[0].dir.toLowerCase() || "rtl" === v.container.css("direction")), v.rtl && v.classNames.push(v.params.containerModifierClass + "rtl"), v.rtl && (v.wrongRTL = "-webkit-box" === v.wrapper.css("display")), v.params.slidesPerColumn > 1 && v.classNames.push(v.params.containerModifierClass + "multirow"), v.device.android && v.classNames.push(v.params.containerModifierClass + "android"), v.container.addClass(v.classNames.join(" ")), v.translate = 0, v.progress = 0, v.velocity = 0, v.lockSwipeToNext = function () {
                v.params.allowSwipeToNext = !1, v.params.allowSwipeToPrev === !1 && v.params.grabCursor && v.unsetGrabCursor()
            }, v.lockSwipeToPrev = function () {
                v.params.allowSwipeToPrev = !1, v.params.allowSwipeToNext === !1 && v.params.grabCursor && v.unsetGrabCursor()
            }, v.lockSwipes = function () {
                v.params.allowSwipeToNext = v.params.allowSwipeToPrev = !1, v.params.grabCursor && v.unsetGrabCursor()
            }, v.unlockSwipeToNext = function () {
                v.params.allowSwipeToNext = !0, v.params.allowSwipeToPrev === !0 && v.params.grabCursor && v.setGrabCursor()
            }, v.unlockSwipeToPrev = function () {
                v.params.allowSwipeToPrev = !0, v.params.allowSwipeToNext === !0 && v.params.grabCursor && v.setGrabCursor()
            }, v.unlockSwipes = function () {
                v.params.allowSwipeToNext = v.params.allowSwipeToPrev = !0, v.params.grabCursor && v.setGrabCursor()
            }, v.setGrabCursor = function (a) {
                v.container[0].style.cursor = "move", v.container[0].style.cursor = a ? "-webkit-grabbing" : "-webkit-grab", v.container[0].style.cursor = a ? "-moz-grabbin" : "-moz-grab", v.container[0].style.cursor = a ? "grabbing" : "grab"
            }, v.unsetGrabCursor = function () {
                v.container[0].style.cursor = ""
            }, v.params.grabCursor && v.setGrabCursor(), v.imagesToLoad = [], v.imagesLoaded = 0, v.loadImage = function (a, b, c, d, e, f) {
                function g() {
                    f && f()
                }

                var h;
                a.complete && e ? g() : b ? (h = new window.Image, h.onload = g, h.onerror = g, d && (h.sizes = d), c && (h.srcset = c), b && (h.src = b)) : g()
            }, v.preloadImages = function () {
                function a() {
                    void 0 !== v && null !== v && v && (void 0 !== v.imagesLoaded && v.imagesLoaded++, v.imagesLoaded === v.imagesToLoad.length && (v.params.updateOnImagesReady && v.update(), v.emit("onImagesReady", v)))
                }

                v.imagesToLoad = v.container.find("img");
                for (var b = 0; b < v.imagesToLoad.length; b++) v.loadImage(v.imagesToLoad[b], v.imagesToLoad[b].currentSrc || v.imagesToLoad[b].getAttribute("src"), v.imagesToLoad[b].srcset || v.imagesToLoad[b].getAttribute("srcset"), v.imagesToLoad[b].sizes || v.imagesToLoad[b].getAttribute("sizes"), !0, a)
            }, v.autoplayTimeoutId = void 0, v.autoplaying = !1, v.autoplayPaused = !1, v.startAutoplay = function () {
                return void 0 === v.autoplayTimeoutId && !!v.params.autoplay && !v.autoplaying && (v.autoplaying = !0, v.emit("onAutoplayStart", v), void g())
            }, v.stopAutoplay = function (a) {
                v.autoplayTimeoutId && (v.autoplayTimeoutId && clearTimeout(v.autoplayTimeoutId), v.autoplaying = !1, v.autoplayTimeoutId = void 0, v.emit("onAutoplayStop", v))
            }, v.pauseAutoplay = function (a) {
                v.autoplayPaused || (v.autoplayTimeoutId && clearTimeout(v.autoplayTimeoutId), v.autoplayPaused = !0, 0 === a ? (v.autoplayPaused = !1, g()) : v.wrapper.transitionEnd(function () {
                    v && (v.autoplayPaused = !1, v.autoplaying ? g() : v.stopAutoplay())
                }))
            }, v.minTranslate = function () {
                return -v.snapGrid[0]
            }, v.maxTranslate = function () {
                return -v.snapGrid[v.snapGrid.length - 1]
            }, v.updateAutoHeight = function () {
                var a, b = [], c = 0;
                if ("auto" !== v.params.slidesPerView && v.params.slidesPerView > 1) for (a = 0; a < Math.ceil(v.params.slidesPerView); a++) {
                    var d = v.activeIndex + a;
                    if (d > v.slides.length) break;
                    b.push(v.slides.eq(d)[0])
                } else b.push(v.slides.eq(v.activeIndex)[0]);
                for (a = 0; a < b.length; a++) if (void 0 !== b[a]) {
                    var e = b[a].offsetHeight;
                    c = e > c ? e : c
                }
                c && v.wrapper.css("height", c + "px")
            }, v.updateContainerSize = function () {
                var a, b;
                a = void 0 !== v.params.width ? v.params.width : v.container[0].clientWidth, b = void 0 !== v.params.height ? v.params.height : v.container[0].clientHeight, 0 === a && v.isHorizontal() || 0 === b && !v.isHorizontal() || (a = a - parseInt(v.container.css("padding-left"), 10) - parseInt(v.container.css("padding-right"), 10), b = b - parseInt(v.container.css("padding-top"), 10) - parseInt(v.container.css("padding-bottom"), 10), v.width = a, v.height = b, v.size = v.isHorizontal() ? v.width : v.height)
            }, v.updateSlidesSize = function () {
                v.slides = v.wrapper.children("." + v.params.slideClass), v.snapGrid = [], v.slidesGrid = [], v.slidesSizesGrid = [];
                var a, b = v.params.spaceBetween, c = -v.params.slidesOffsetBefore, d = 0, e = 0;
                if (void 0 !== v.size) {
                    "string" == typeof b && b.indexOf("%") >= 0 && (b = parseFloat(b.replace("%", "")) / 100 * v.size), v.virtualSize = -b, v.rtl ? v.slides.css({
                        marginLeft: "",
                        marginTop: ""
                    }) : v.slides.css({marginRight: "", marginBottom: ""});
                    var g;
                    v.params.slidesPerColumn > 1 && (g = Math.floor(v.slides.length / v.params.slidesPerColumn) === v.slides.length / v.params.slidesPerColumn ? v.slides.length : Math.ceil(v.slides.length / v.params.slidesPerColumn) * v.params.slidesPerColumn, "auto" !== v.params.slidesPerView && "row" === v.params.slidesPerColumnFill && (g = Math.max(g, v.params.slidesPerView * v.params.slidesPerColumn)));
                    var h, i = v.params.slidesPerColumn, j = g / i,
                        k = j - (v.params.slidesPerColumn * j - v.slides.length);
                    for (a = 0; a < v.slides.length; a++) {
                        h = 0;
                        var l = v.slides.eq(a);
                        if (v.params.slidesPerColumn > 1) {
                            var m, n, o;
                            "column" === v.params.slidesPerColumnFill ? (n = Math.floor(a / i), o = a - n * i, (n > k || n === k && o === i - 1) && ++o >= i && (o = 0, n++), m = n + o * g / i, l.css({
                                "-webkit-box-ordinal-group": m,
                                "-moz-box-ordinal-group": m,
                                "-ms-flex-order": m,
                                "-webkit-order": m,
                                order: m
                            })) : (o = Math.floor(a / j), n = a - o * j), l.css("margin-" + (v.isHorizontal() ? "top" : "left"), 0 !== o && v.params.spaceBetween && v.params.spaceBetween + "px").attr("data-swiper-column", n).attr("data-swiper-row", o)
                        }
                        "none" !== l.css("display") && ("auto" === v.params.slidesPerView ? (h = v.isHorizontal() ? l.outerWidth(!0) : l.outerHeight(!0), v.params.roundLengths && (h = f(h))) : (h = (v.size - (v.params.slidesPerView - 1) * b) / v.params.slidesPerView, v.params.roundLengths && (h = f(h)), v.isHorizontal() ? v.slides[a].style.width = h + "px" : v.slides[a].style.height = h + "px"), v.slides[a].swiperSlideSize = h, v.slidesSizesGrid.push(h), v.params.centeredSlides ? (c = c + h / 2 + d / 2 + b, 0 === d && 0 !== a && (c = c - v.size / 2 - b), 0 === a && (c = c - v.size / 2 - b), Math.abs(c) < .001 && (c = 0), e % v.params.slidesPerGroup == 0 && v.snapGrid.push(c), v.slidesGrid.push(c)) : (e % v.params.slidesPerGroup == 0 && v.snapGrid.push(c), v.slidesGrid.push(c), c = c + h + b), v.virtualSize += h + b, d = h, e++)
                    }
                    v.virtualSize = Math.max(v.virtualSize, v.size) + v.params.slidesOffsetAfter;
                    var p;
                    if (v.rtl && v.wrongRTL && ("slide" === v.params.effect || "coverflow" === v.params.effect) && v.wrapper.css({width: v.virtualSize + v.params.spaceBetween + "px"}), v.support.flexbox && !v.params.setWrapperSize || (v.isHorizontal() ? v.wrapper.css({width: v.virtualSize + v.params.spaceBetween + "px"}) : v.wrapper.css({height: v.virtualSize + v.params.spaceBetween + "px"})), v.params.slidesPerColumn > 1 && (v.virtualSize = (h + v.params.spaceBetween) * g, v.virtualSize = Math.ceil(v.virtualSize / v.params.slidesPerColumn) - v.params.spaceBetween, v.isHorizontal() ? v.wrapper.css({width: v.virtualSize + v.params.spaceBetween + "px"}) : v.wrapper.css({height: v.virtualSize + v.params.spaceBetween + "px"}), v.params.centeredSlides)) {
                        for (p = [], a = 0; a < v.snapGrid.length; a++) v.snapGrid[a] < v.virtualSize + v.snapGrid[0] && p.push(v.snapGrid[a]);
                        v.snapGrid = p
                    }
                    if (!v.params.centeredSlides) {
                        for (p = [], a = 0; a < v.snapGrid.length; a++) v.snapGrid[a] <= v.virtualSize - v.size && p.push(v.snapGrid[a]);
                        v.snapGrid = p, Math.floor(v.virtualSize - v.size) - Math.floor(v.snapGrid[v.snapGrid.length - 1]) > 1 && v.snapGrid.push(v.virtualSize - v.size)
                    }
                    0 === v.snapGrid.length && (v.snapGrid = [0]), 0 !== v.params.spaceBetween && (v.isHorizontal() ? v.rtl ? v.slides.css({marginLeft: b + "px"}) : v.slides.css({marginRight: b + "px"}) : v.slides.css({marginBottom: b + "px"})), v.params.watchSlidesProgress && v.updateSlidesOffset()
                }
            }, v.updateSlidesOffset = function () {
                for (var a = 0; a < v.slides.length; a++) v.slides[a].swiperSlideOffset = v.isHorizontal() ? v.slides[a].offsetLeft : v.slides[a].offsetTop
            }, v.currentSlidesPerView = function () {
                var a, b, c = 1;
                if (v.params.centeredSlides) {
                    var d, e = v.slides[v.activeIndex].swiperSlideSize;
                    for (a = v.activeIndex + 1; a < v.slides.length; a++) v.slides[a] && !d && (e += v.slides[a].swiperSlideSize, c++, e > v.size && (d = !0));
                    for (b = v.activeIndex - 1; b >= 0; b--) v.slides[b] && !d && (e += v.slides[b].swiperSlideSize, c++, e > v.size && (d = !0))
                } else for (a = v.activeIndex + 1; a < v.slides.length; a++) v.slidesGrid[a] - v.slidesGrid[v.activeIndex] < v.size && c++;
                return c
            }, v.updateSlidesProgress = function (a) {
                if (void 0 === a && (a = v.translate || 0), 0 !== v.slides.length) {
                    void 0 === v.slides[0].swiperSlideOffset && v.updateSlidesOffset();
                    var b = -a;
                    v.rtl && (b = a), v.slides.removeClass(v.params.slideVisibleClass);
                    for (var c = 0; c < v.slides.length; c++) {
                        var d = v.slides[c],
                            e = (b + (v.params.centeredSlides ? v.minTranslate() : 0) - d.swiperSlideOffset) / (d.swiperSlideSize + v.params.spaceBetween);
                        if (v.params.watchSlidesVisibility) {
                            var f = -(b - d.swiperSlideOffset), g = f + v.slidesSizesGrid[c];
                            (f >= 0 && f < v.size || g > 0 && g <= v.size || f <= 0 && g >= v.size) && v.slides.eq(c).addClass(v.params.slideVisibleClass)
                        }
                        d.progress = v.rtl ? -e : e
                    }
                }
            }, v.updateProgress = function (a) {
                void 0 === a && (a = v.translate || 0);
                var b = v.maxTranslate() - v.minTranslate(), c = v.isBeginning, d = v.isEnd;
                0 === b ? (v.progress = 0, v.isBeginning = v.isEnd = !0) : (v.progress = (a - v.minTranslate()) / b, v.isBeginning = v.progress <= 0, v.isEnd = v.progress >= 1), v.isBeginning && !c && v.emit("onReachBeginning", v), v.isEnd && !d && v.emit("onReachEnd", v), v.params.watchSlidesProgress && v.updateSlidesProgress(a), v.emit("onProgress", v, v.progress)
            }, v.updateActiveIndex = function () {
                var a, b, c, d = v.rtl ? v.translate : -v.translate;
                for (b = 0; b < v.slidesGrid.length; b++) void 0 !== v.slidesGrid[b + 1] ? d >= v.slidesGrid[b] && d < v.slidesGrid[b + 1] - (v.slidesGrid[b + 1] - v.slidesGrid[b]) / 2 ? a = b : d >= v.slidesGrid[b] && d < v.slidesGrid[b + 1] && (a = b + 1) : d >= v.slidesGrid[b] && (a = b);
                v.params.normalizeSlideIndex && (a < 0 || void 0 === a) && (a = 0), c = Math.floor(a / v.params.slidesPerGroup), c >= v.snapGrid.length && (c = v.snapGrid.length - 1), a !== v.activeIndex && (v.snapIndex = c, v.previousIndex = v.activeIndex, v.activeIndex = a, v.updateClasses(), v.updateRealIndex())
            }, v.updateRealIndex = function () {
                v.realIndex = parseInt(v.slides.eq(v.activeIndex).attr("data-swiper-slide-index") || v.activeIndex, 10)
            }, v.updateClasses = function () {
                v.slides.removeClass(v.params.slideActiveClass + " " + v.params.slideNextClass + " " + v.params.slidePrevClass + " " + v.params.slideDuplicateActiveClass + " " + v.params.slideDuplicateNextClass + " " + v.params.slideDuplicatePrevClass);
                var b = v.slides.eq(v.activeIndex);
                b.addClass(v.params.slideActiveClass), e.loop && (b.hasClass(v.params.slideDuplicateClass) ? v.wrapper.children("." + v.params.slideClass + ":not(." + v.params.slideDuplicateClass + ')[data-swiper-slide-index="' + v.realIndex + '"]').addClass(v.params.slideDuplicateActiveClass) : v.wrapper.children("." + v.params.slideClass + "." + v.params.slideDuplicateClass + '[data-swiper-slide-index="' + v.realIndex + '"]').addClass(v.params.slideDuplicateActiveClass));
                var c = b.next("." + v.params.slideClass).addClass(v.params.slideNextClass);
                v.params.loop && 0 === c.length && (c = v.slides.eq(0), c.addClass(v.params.slideNextClass));
                var d = b.prev("." + v.params.slideClass).addClass(v.params.slidePrevClass);
                if (v.params.loop && 0 === d.length && (d = v.slides.eq(-1), d.addClass(v.params.slidePrevClass)), e.loop && (c.hasClass(v.params.slideDuplicateClass) ? v.wrapper.children("." + v.params.slideClass + ":not(." + v.params.slideDuplicateClass + ')[data-swiper-slide-index="' + c.attr("data-swiper-slide-index") + '"]').addClass(v.params.slideDuplicateNextClass) : v.wrapper.children("." + v.params.slideClass + "." + v.params.slideDuplicateClass + '[data-swiper-slide-index="' + c.attr("data-swiper-slide-index") + '"]').addClass(v.params.slideDuplicateNextClass), d.hasClass(v.params.slideDuplicateClass) ? v.wrapper.children("." + v.params.slideClass + ":not(." + v.params.slideDuplicateClass + ')[data-swiper-slide-index="' + d.attr("data-swiper-slide-index") + '"]').addClass(v.params.slideDuplicatePrevClass) : v.wrapper.children("." + v.params.slideClass + "." + v.params.slideDuplicateClass + '[data-swiper-slide-index="' + d.attr("data-swiper-slide-index") + '"]').addClass(v.params.slideDuplicatePrevClass)), v.paginationContainer && v.paginationContainer.length > 0) {
                    var f,
                        g = v.params.loop ? Math.ceil((v.slides.length - 2 * v.loopedSlides) / v.params.slidesPerGroup) : v.snapGrid.length;
                    if (v.params.loop ? (f = Math.ceil((v.activeIndex - v.loopedSlides) / v.params.slidesPerGroup), f > v.slides.length - 1 - 2 * v.loopedSlides && (f -= v.slides.length - 2 * v.loopedSlides), f > g - 1 && (f -= g), f < 0 && "bullets" !== v.params.paginationType && (f = g + f)) : f = void 0 !== v.snapIndex ? v.snapIndex : v.activeIndex || 0, "bullets" === v.params.paginationType && v.bullets && v.bullets.length > 0 && (v.bullets.removeClass(v.params.bulletActiveClass), v.paginationContainer.length > 1 ? v.bullets.each(function () {
                        a(this).index() === f && a(this).addClass(v.params.bulletActiveClass)
                    }) : v.bullets.eq(f).addClass(v.params.bulletActiveClass)), "fraction" === v.params.paginationType && (v.paginationContainer.find("." + v.params.paginationCurrentClass).text(f + 1), v.paginationContainer.find("." + v.params.paginationTotalClass).text(g)), "progress" === v.params.paginationType) {
                        var h = (f + 1) / g, i = h, j = 1;
                        v.isHorizontal() || (j = h, i = 1), v.paginationContainer.find("." + v.params.paginationProgressbarClass).transform("translate3d(0,0,0) scaleX(" + i + ") scaleY(" + j + ")").transition(v.params.speed)
                    }
                    "custom" === v.params.paginationType && v.params.paginationCustomRender && (v.paginationContainer.html(v.params.paginationCustomRender(v, f + 1, g)), v.emit("onPaginationRendered", v, v.paginationContainer[0]))
                }
                v.params.loop || (v.params.prevButton && v.prevButton && v.prevButton.length > 0 && (v.isBeginning ? (v.prevButton.addClass(v.params.buttonDisabledClass), v.params.a11y && v.a11y && v.a11y.disable(v.prevButton)) : (v.prevButton.removeClass(v.params.buttonDisabledClass), v.params.a11y && v.a11y && v.a11y.enable(v.prevButton))), v.params.nextButton && v.nextButton && v.nextButton.length > 0 && (v.isEnd ? (v.nextButton.addClass(v.params.buttonDisabledClass), v.params.a11y && v.a11y && v.a11y.disable(v.nextButton)) : (v.nextButton.removeClass(v.params.buttonDisabledClass), v.params.a11y && v.a11y && v.a11y.enable(v.nextButton))))
            }, v.updatePagination = function () {
                if (v.params.pagination && v.paginationContainer && v.paginationContainer.length > 0) {
                    var a = "";
                    if ("bullets" === v.params.paginationType) {
                        for (var b = v.params.loop ? Math.ceil((v.slides.length - 2 * v.loopedSlides) / v.params.slidesPerGroup) : v.snapGrid.length, c = 0; c < b; c++) a += v.params.paginationBulletRender ? v.params.paginationBulletRender(v, c, v.params.bulletClass) : "<" + v.params.paginationElement + ' class="' + v.params.bulletClass + '"></' + v.params.paginationElement + ">";
                        v.paginationContainer.html(a), v.bullets = v.paginationContainer.find("." + v.params.bulletClass), v.params.paginationClickable && v.params.a11y && v.a11y && v.a11y.initPagination()
                    }
                    "fraction" === v.params.paginationType && (a = v.params.paginationFractionRender ? v.params.paginationFractionRender(v, v.params.paginationCurrentClass, v.params.paginationTotalClass) : '<span class="' + v.params.paginationCurrentClass + '"></span> / <span class="' + v.params.paginationTotalClass + '"></span>', v.paginationContainer.html(a)), "progress" === v.params.paginationType && (a = v.params.paginationProgressRender ? v.params.paginationProgressRender(v, v.params.paginationProgressbarClass) : '<span class="' + v.params.paginationProgressbarClass + '"></span>', v.paginationContainer.html(a)), "custom" !== v.params.paginationType && v.emit("onPaginationRendered", v, v.paginationContainer[0])
                }
            }, v.update = function (a) {
                function b() {
                    v.rtl, v.translate, c = Math.min(Math.max(v.translate, v.maxTranslate()), v.minTranslate()), v.setWrapperTranslate(c), v.updateActiveIndex(), v.updateClasses()
                }

                if (v) {
                    v.updateContainerSize(), v.updateSlidesSize(), v.updateProgress(), v.updatePagination(), v.updateClasses(), v.params.scrollbar && v.scrollbar && v.scrollbar.set();
                    var c;
                    a ? (v.controller && v.controller.spline && (v.controller.spline = void 0), v.params.freeMode ? (b(), v.params.autoHeight && v.updateAutoHeight()) : (("auto" === v.params.slidesPerView || v.params.slidesPerView > 1) && v.isEnd && !v.params.centeredSlides ? v.slideTo(v.slides.length - 1, 0, !1, !0) : v.slideTo(v.activeIndex, 0, !1, !0)) || b()) : v.params.autoHeight && v.updateAutoHeight()
                }
            }, v.onResize = function (a) {
                v.params.onBeforeResize && v.params.onBeforeResize(v), v.params.breakpoints && v.setBreakpoint();
                var b = v.params.allowSwipeToPrev, c = v.params.allowSwipeToNext;
                v.params.allowSwipeToPrev = v.params.allowSwipeToNext = !0, v.updateContainerSize(), v.updateSlidesSize(), ("auto" === v.params.slidesPerView || v.params.freeMode || a) && v.updatePagination(), v.params.scrollbar && v.scrollbar && v.scrollbar.set(), v.controller && v.controller.spline && (v.controller.spline = void 0);
                var d = !1;
                if (v.params.freeMode) {
                    var e = Math.min(Math.max(v.translate, v.maxTranslate()), v.minTranslate());
                    v.setWrapperTranslate(e), v.updateActiveIndex(), v.updateClasses(), v.params.autoHeight && v.updateAutoHeight()
                } else v.updateClasses(), d = ("auto" === v.params.slidesPerView || v.params.slidesPerView > 1) && v.isEnd && !v.params.centeredSlides ? v.slideTo(v.slides.length - 1, 0, !1, !0) : v.slideTo(v.activeIndex, 0, !1, !0);
                v.params.lazyLoading && !d && v.lazy && v.lazy.load(), v.params.allowSwipeToPrev = b, v.params.allowSwipeToNext = c, v.params.onAfterResize && v.params.onAfterResize(v)
            }, v.touchEventsDesktop = {
                start: "mousedown",
                move: "mousemove",
                end: "mouseup"
            }, window.navigator.pointerEnabled ? v.touchEventsDesktop = {
                start: "pointerdown",
                move: "pointermove",
                end: "pointerup"
            } : window.navigator.msPointerEnabled && (v.touchEventsDesktop = {
                start: "MSPointerDown",
                move: "MSPointerMove",
                end: "MSPointerUp"
            }), v.touchEvents = {
                start: v.support.touch || !v.params.simulateTouch ? "touchstart" : v.touchEventsDesktop.start,
                move: v.support.touch || !v.params.simulateTouch ? "touchmove" : v.touchEventsDesktop.move,
                end: v.support.touch || !v.params.simulateTouch ? "touchend" : v.touchEventsDesktop.end
            }, (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) && ("container" === v.params.touchEventsTarget ? v.container : v.wrapper).addClass("swiper-wp8-" + v.params.direction), v.initEvents = function (a) {
                var b = a ? "off" : "on", c = a ? "removeEventListener" : "addEventListener",
                    d = "container" === v.params.touchEventsTarget ? v.container[0] : v.wrapper[0],
                    f = v.support.touch ? d : document, g = !!v.params.nested;
                if (v.browser.ie) d[c](v.touchEvents.start, v.onTouchStart, !1), f[c](v.touchEvents.move, v.onTouchMove, g), f[c](v.touchEvents.end, v.onTouchEnd, !1); else {
                    if (v.support.touch) {
                        var h = !("touchstart" !== v.touchEvents.start || !v.support.passiveListener || !v.params.passiveListeners) && {
                            passive: !0,
                            capture: !1
                        };
                        d[c](v.touchEvents.start, v.onTouchStart, h), d[c](v.touchEvents.move, v.onTouchMove, g), d[c](v.touchEvents.end, v.onTouchEnd, h)
                    }
                    (e.simulateTouch && !v.device.ios && !v.device.android || e.simulateTouch && !v.support.touch && v.device.ios) && (d[c]("mousedown", v.onTouchStart, !1), document[c]("mousemove", v.onTouchMove, g), document[c]("mouseup", v.onTouchEnd, !1))
                }
                window[c]("resize", v.onResize), v.params.nextButton && v.nextButton && v.nextButton.length > 0 && (v.nextButton[b]("click", v.onClickNext), v.params.a11y && v.a11y && v.nextButton[b]("keydown", v.a11y.onEnterKey)), v.params.prevButton && v.prevButton && v.prevButton.length > 0 && (v.prevButton[b]("click", v.onClickPrev), v.params.a11y && v.a11y && v.prevButton[b]("keydown", v.a11y.onEnterKey)), v.params.pagination && v.params.paginationClickable && (v.paginationContainer[b]("click", "." + v.params.bulletClass, v.onClickIndex), v.params.a11y && v.a11y && v.paginationContainer[b]("keydown", "." + v.params.bulletClass, v.a11y.onEnterKey)), (v.params.preventClicks || v.params.preventClicksPropagation) && d[c]("click", v.preventClicks, !0)
            }, v.attachEvents = function () {
                v.initEvents()
            }, v.detachEvents = function () {
                v.initEvents(!0)
            }, v.allowClick = !0, v.preventClicks = function (a) {
                v.allowClick || (v.params.preventClicks && a.preventDefault(), v.params.preventClicksPropagation && v.animating && (a.stopPropagation(), a.stopImmediatePropagation()))
            }, v.onClickNext = function (a) {
                a.preventDefault(), v.isEnd && !v.params.loop || v.slideNext()
            }, v.onClickPrev = function (a) {
                a.preventDefault(), v.isBeginning && !v.params.loop || v.slidePrev()
            }, v.onClickIndex = function (b) {
                b.preventDefault();
                var c = a(this).index() * v.params.slidesPerGroup;
                v.params.loop && (c += v.loopedSlides), v.slideTo(c)
            }, v.updateClickedSlide = function (b) {
                var c = h(b, "." + v.params.slideClass), d = !1;
                if (c) for (var e = 0; e < v.slides.length; e++) v.slides[e] === c && (d = !0);
                if (!c || !d) return v.clickedSlide = void 0, void (v.clickedIndex = void 0);
                if (v.clickedSlide = c, v.clickedIndex = a(c).index(), v.params.slideToClickedSlide && void 0 !== v.clickedIndex && v.clickedIndex !== v.activeIndex) {
                    var f, g = v.clickedIndex,
                        i = "auto" === v.params.slidesPerView ? v.currentSlidesPerView() : v.params.slidesPerView;
                    if (v.params.loop) {
                        if (v.animating) return;
                        f = parseInt(a(v.clickedSlide).attr("data-swiper-slide-index"), 10), v.params.centeredSlides ? g < v.loopedSlides - i / 2 || g > v.slides.length - v.loopedSlides + i / 2 ? (v.fixLoop(), g = v.wrapper.children("." + v.params.slideClass + '[data-swiper-slide-index="' + f + '"]:not(.' + v.params.slideDuplicateClass + ")").eq(0).index(), setTimeout(function () {
                            v.slideTo(g)
                        }, 0)) : v.slideTo(g) : g > v.slides.length - i ? (v.fixLoop(), g = v.wrapper.children("." + v.params.slideClass + '[data-swiper-slide-index="' + f + '"]:not(.' + v.params.slideDuplicateClass + ")").eq(0).index(), setTimeout(function () {
                            v.slideTo(g)
                        }, 0)) : v.slideTo(g)
                    } else v.slideTo(g)
                }
            };
            var x, y, z, A, B, C, D, E, F, G, H = "input, select, textarea, button, video", I = Date.now(), J = [];
            v.animating = !1, v.touches = {startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0};
            var K, L;
            v.onTouchStart = function (b) {
                if (b.originalEvent && (b = b.originalEvent), (K = "touchstart" === b.type) || !("which" in b) || 3 !== b.which) {
                    if (v.params.noSwiping && h(b, "." + v.params.noSwipingClass)) return void (v.allowClick = !0);
                    if (!v.params.swipeHandler || h(b, v.params.swipeHandler)) {
                        var c = v.touches.currentX = "touchstart" === b.type ? b.targetTouches[0].pageX : b.pageX,
                            d = v.touches.currentY = "touchstart" === b.type ? b.targetTouches[0].pageY : b.pageY;
                        if (!(v.device.ios && v.params.iOSEdgeSwipeDetection && c <= v.params.iOSEdgeSwipeThreshold)) {
                            if (x = !0, y = !1, z = !0, B = void 0, L = void 0, v.touches.startX = c, v.touches.startY = d, A = Date.now(), v.allowClick = !0, v.updateContainerSize(), v.swipeDirection = void 0, v.params.threshold > 0 && (E = !1), "touchstart" !== b.type) {
                                var e = !0;
                                a(b.target).is(H) && (e = !1), document.activeElement && a(document.activeElement).is(H) && document.activeElement.blur(), e && b.preventDefault()
                            }
                            v.emit("onTouchStart", v, b)
                        }
                    }
                }
            }, v.onTouchMove = function (b) {
                if (b.originalEvent && (b = b.originalEvent), !K || "mousemove" !== b.type) {
                    if (b.preventedByNestedSwiper) return v.touches.startX = "touchmove" === b.type ? b.targetTouches[0].pageX : b.pageX, void (v.touches.startY = "touchmove" === b.type ? b.targetTouches[0].pageY : b.pageY);
                    if (v.params.onlyExternal) return v.allowClick = !1, void (x && (v.touches.startX = v.touches.currentX = "touchmove" === b.type ? b.targetTouches[0].pageX : b.pageX, v.touches.startY = v.touches.currentY = "touchmove" === b.type ? b.targetTouches[0].pageY : b.pageY, A = Date.now()));
                    if (K && v.params.touchReleaseOnEdges && !v.params.loop) if (v.isHorizontal()) {
                        if (v.touches.currentX < v.touches.startX && v.translate <= v.maxTranslate() || v.touches.currentX > v.touches.startX && v.translate >= v.minTranslate()) return
                    } else if (v.touches.currentY < v.touches.startY && v.translate <= v.maxTranslate() || v.touches.currentY > v.touches.startY && v.translate >= v.minTranslate()) return;
                    if (K && document.activeElement && b.target === document.activeElement && a(b.target).is(H)) return y = !0, void (v.allowClick = !1);
                    if (z && v.emit("onTouchMove", v, b), !(b.targetTouches && b.targetTouches.length > 1)) {
                        if (v.touches.currentX = "touchmove" === b.type ? b.targetTouches[0].pageX : b.pageX, v.touches.currentY = "touchmove" === b.type ? b.targetTouches[0].pageY : b.pageY, void 0 === B) {
                            var c;
                            v.isHorizontal() && v.touches.currentY === v.touches.startY || !v.isHorizontal() && v.touches.currentX === v.touches.startX ? B = !1 : (c = 180 * Math.atan2(Math.abs(v.touches.currentY - v.touches.startY), Math.abs(v.touches.currentX - v.touches.startX)) / Math.PI, B = v.isHorizontal() ? c > v.params.touchAngle : 90 - c > v.params.touchAngle)
                        }
                        if (B && v.emit("onTouchMoveOpposite", v, b), void 0 === L && (v.touches.currentX === v.touches.startX && v.touches.currentY === v.touches.startY || (L = !0)), x) {
                            if (B) return void (x = !1);
                            if (L) {
                                v.allowClick = !1, v.emit("onSliderMove", v, b), b.preventDefault(), v.params.touchMoveStopPropagation && !v.params.nested && b.stopPropagation(), y || (e.loop && v.fixLoop(), D = v.getWrapperTranslate(), v.setWrapperTransition(0), v.animating && v.wrapper.trigger("webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd"), v.params.autoplay && v.autoplaying && (v.params.autoplayDisableOnInteraction ? v.stopAutoplay() : v.pauseAutoplay()), G = !1, !v.params.grabCursor || v.params.allowSwipeToNext !== !0 && v.params.allowSwipeToPrev !== !0 || v.setGrabCursor(!0)), y = !0;
                                var d = v.touches.diff = v.isHorizontal() ? v.touches.currentX - v.touches.startX : v.touches.currentY - v.touches.startY;
                                d *= v.params.touchRatio, v.rtl && (d = -d), v.swipeDirection = d > 0 ? "prev" : "next", C = d + D;
                                var f = !0;
                                if (d > 0 && C > v.minTranslate() ? (f = !1, v.params.resistance && (C = v.minTranslate() - 1 + Math.pow(-v.minTranslate() + D + d, v.params.resistanceRatio))) : d < 0 && C < v.maxTranslate() && (f = !1, v.params.resistance && (C = v.maxTranslate() + 1 - Math.pow(v.maxTranslate() - D - d, v.params.resistanceRatio))), f && (b.preventedByNestedSwiper = !0), !v.params.allowSwipeToNext && "next" === v.swipeDirection && C < D && (C = D), !v.params.allowSwipeToPrev && "prev" === v.swipeDirection && C > D && (C = D), v.params.threshold > 0) {
                                    if (!(Math.abs(d) > v.params.threshold || E)) return void (C = D);
                                    if (!E) return E = !0, v.touches.startX = v.touches.currentX, v.touches.startY = v.touches.currentY, C = D, void (v.touches.diff = v.isHorizontal() ? v.touches.currentX - v.touches.startX : v.touches.currentY - v.touches.startY)
                                }
                                v.params.followFinger && ((v.params.freeMode || v.params.watchSlidesProgress) && v.updateActiveIndex(), v.params.freeMode && (0 === J.length && J.push({
                                    position: v.touches[v.isHorizontal() ? "startX" : "startY"],
                                    time: A
                                }), J.push({
                                    position: v.touches[v.isHorizontal() ? "currentX" : "currentY"],
                                    time: (new window.Date).getTime()
                                })), v.updateProgress(C), v.setWrapperTranslate(C))
                            }
                        }
                    }
                }
            }, v.onTouchEnd = function (b) {
                if (b.originalEvent && (b = b.originalEvent), z && v.emit("onTouchEnd", v, b), z = !1, x) {
                    v.params.grabCursor && y && x && (v.params.allowSwipeToNext === !0 || v.params.allowSwipeToPrev === !0) && v.setGrabCursor(!1);
                    var c = Date.now(), d = c - A;
                    if (v.allowClick && (v.updateClickedSlide(b), v.emit("onTap", v, b), d < 300 && c - I > 300 && (F && clearTimeout(F), F = setTimeout(function () {
                        v && (v.params.paginationHide && v.paginationContainer.length > 0 && !a(b.target).hasClass(v.params.bulletClass) && v.paginationContainer.toggleClass(v.params.paginationHiddenClass), v.emit("onClick", v, b))
                    }, 300)), d < 300 && c - I < 300 && (F && clearTimeout(F), v.emit("onDoubleTap", v, b))), I = Date.now(), setTimeout(function () {
                        v && (v.allowClick = !0)
                    }, 0), !x || !y || !v.swipeDirection || 0 === v.touches.diff || C === D) return void (x = y = !1);
                    x = y = !1;
                    var e;
                    if (e = v.params.followFinger ? v.rtl ? v.translate : -v.translate : -C, v.params.freeMode) {
                        if (e < -v.minTranslate()) return void v.slideTo(v.activeIndex);
                        if (e > -v.maxTranslate()) return void (v.slides.length < v.snapGrid.length ? v.slideTo(v.snapGrid.length - 1) : v.slideTo(v.slides.length - 1));
                        if (v.params.freeModeMomentum) {
                            if (J.length > 1) {
                                var f = J.pop(), g = J.pop(), h = f.position - g.position, i = f.time - g.time;
                                v.velocity = h / i, v.velocity = v.velocity / 2, Math.abs(v.velocity) < v.params.freeModeMinimumVelocity && (v.velocity = 0), (i > 150 || (new window.Date).getTime() - f.time > 300) && (v.velocity = 0)
                            } else v.velocity = 0;
                            v.velocity = v.velocity * v.params.freeModeMomentumVelocityRatio, J.length = 0;
                            var j = 1e3 * v.params.freeModeMomentumRatio, k = v.velocity * j, l = v.translate + k;
                            v.rtl && (l = -l);
                            var m, n = !1, o = 20 * Math.abs(v.velocity) * v.params.freeModeMomentumBounceRatio;
                            if (l < v.maxTranslate()) v.params.freeModeMomentumBounce ? (l + v.maxTranslate() < -o && (l = v.maxTranslate() - o), m = v.maxTranslate(), n = !0, G = !0) : l = v.maxTranslate(); else if (l > v.minTranslate()) v.params.freeModeMomentumBounce ? (l - v.minTranslate() > o && (l = v.minTranslate() + o), m = v.minTranslate(), n = !0, G = !0) : l = v.minTranslate(); else if (v.params.freeModeSticky) {
                                var p, q = 0;
                                for (q = 0; q < v.snapGrid.length; q += 1) if (v.snapGrid[q] > -l) {
                                    p = q;
                                    break
                                }
                                l = Math.abs(v.snapGrid[p] - l) < Math.abs(v.snapGrid[p - 1] - l) || "next" === v.swipeDirection ? v.snapGrid[p] : v.snapGrid[p - 1], v.rtl || (l = -l)
                            }
                            if (0 !== v.velocity) j = v.rtl ? Math.abs((-l - v.translate) / v.velocity) : Math.abs((l - v.translate) / v.velocity); else if (v.params.freeModeSticky) return void v.slideReset();
                            v.params.freeModeMomentumBounce && n ? (v.updateProgress(m), v.setWrapperTransition(j), v.setWrapperTranslate(l), v.onTransitionStart(), v.animating = !0, v.wrapper.transitionEnd(function () {
                                v && G && (v.emit("onMomentumBounce", v), v.setWrapperTransition(v.params.speed), v.setWrapperTranslate(m), v.wrapper.transitionEnd(function () {
                                    v && v.onTransitionEnd()
                                }))
                            })) : v.velocity ? (v.updateProgress(l), v.setWrapperTransition(j), v.setWrapperTranslate(l), v.onTransitionStart(), v.animating || (v.animating = !0, v.wrapper.transitionEnd(function () {
                                v && v.onTransitionEnd()
                            }))) : v.updateProgress(l), v.updateActiveIndex()
                        }
                        return void ((!v.params.freeModeMomentum || d >= v.params.longSwipesMs) && (v.updateProgress(), v.updateActiveIndex()))
                    }
                    var r, s = 0, t = v.slidesSizesGrid[0];
                    for (r = 0; r < v.slidesGrid.length; r += v.params.slidesPerGroup) void 0 !== v.slidesGrid[r + v.params.slidesPerGroup] ? e >= v.slidesGrid[r] && e < v.slidesGrid[r + v.params.slidesPerGroup] && (s = r, t = v.slidesGrid[r + v.params.slidesPerGroup] - v.slidesGrid[r]) : e >= v.slidesGrid[r] && (s = r, t = v.slidesGrid[v.slidesGrid.length - 1] - v.slidesGrid[v.slidesGrid.length - 2]);
                    var u = (e - v.slidesGrid[s]) / t;
                    if (d > v.params.longSwipesMs) {
                        if (!v.params.longSwipes) return void v.slideTo(v.activeIndex);
                        "next" === v.swipeDirection && (u >= v.params.longSwipesRatio ? v.slideTo(s + v.params.slidesPerGroup) : v.slideTo(s)), "prev" === v.swipeDirection && (u > 1 - v.params.longSwipesRatio ? v.slideTo(s + v.params.slidesPerGroup) : v.slideTo(s))
                    } else {
                        if (!v.params.shortSwipes) return void v.slideTo(v.activeIndex);
                        "next" === v.swipeDirection && v.slideTo(s + v.params.slidesPerGroup), "prev" === v.swipeDirection && v.slideTo(s)
                    }
                }
            }, v._slideTo = function (a, b) {
                return v.slideTo(a, b, !0, !0)
            }, v.slideTo = function (a, b, c, d) {
                void 0 === c && (c = !0), void 0 === a && (a = 0), a < 0 && (a = 0), v.snapIndex = Math.floor(a / v.params.slidesPerGroup), v.snapIndex >= v.snapGrid.length && (v.snapIndex = v.snapGrid.length - 1);
                var e = -v.snapGrid[v.snapIndex];
                if (v.params.autoplay && v.autoplaying && (d || !v.params.autoplayDisableOnInteraction ? v.pauseAutoplay(b) : v.stopAutoplay()), v.updateProgress(e), v.params.normalizeSlideIndex) for (var f = 0; f < v.slidesGrid.length; f++) -Math.floor(100 * e) >= Math.floor(100 * v.slidesGrid[f]) && (a = f);
                return !(!v.params.allowSwipeToNext && e < v.translate && e < v.minTranslate() || !v.params.allowSwipeToPrev && e > v.translate && e > v.maxTranslate() && (v.activeIndex || 0) !== a || (void 0 === b && (b = v.params.speed), v.previousIndex = v.activeIndex || 0, v.activeIndex = a, v.updateRealIndex(), v.rtl && -e === v.translate || !v.rtl && e === v.translate ? (v.params.autoHeight && v.updateAutoHeight(), v.updateClasses(), "slide" !== v.params.effect && v.setWrapperTranslate(e), 1) : (v.updateClasses(), v.onTransitionStart(c), 0 === b || v.browser.lteIE9 ? (v.setWrapperTranslate(e), v.setWrapperTransition(0), v.onTransitionEnd(c)) : (v.setWrapperTranslate(e), v.setWrapperTransition(b), v.animating || (v.animating = !0, v.wrapper.transitionEnd(function () {
                    v && v.onTransitionEnd(c)
                }))), 0)))
            }, v.onTransitionStart = function (a) {
                void 0 === a && (a = !0), v.params.autoHeight && v.updateAutoHeight(), v.lazy && v.lazy.onTransitionStart(), a && (v.emit("onTransitionStart", v), v.activeIndex !== v.previousIndex && (v.emit("onSlideChangeStart", v), v.activeIndex > v.previousIndex ? v.emit("onSlideNextStart", v) : v.emit("onSlidePrevStart", v)))
            }, v.onTransitionEnd = function (a) {
                v.animating = !1, v.setWrapperTransition(0), void 0 === a && (a = !0), v.lazy && v.lazy.onTransitionEnd(), a && (v.emit("onTransitionEnd", v), v.activeIndex !== v.previousIndex && (v.emit("onSlideChangeEnd", v), v.activeIndex > v.previousIndex ? v.emit("onSlideNextEnd", v) : v.emit("onSlidePrevEnd", v))), v.params.history && v.history && v.history.setHistory(v.params.history, v.activeIndex), v.params.hashnav && v.hashnav && v.hashnav.setHash()
            }, v.slideNext = function (a, b, c) {
                return v.params.loop ? !v.animating && (v.fixLoop(), v.container[0].clientLeft, v.slideTo(v.activeIndex + v.params.slidesPerGroup, b, a, c)) : v.slideTo(v.activeIndex + v.params.slidesPerGroup, b, a, c)
            }, v._slideNext = function (a) {
                return v.slideNext(!0, a, !0)
            }, v.slidePrev = function (a, b, c) {
                return v.params.loop ? !v.animating && (v.fixLoop(), v.container[0].clientLeft, v.slideTo(v.activeIndex - 1, b, a, c)) : v.slideTo(v.activeIndex - 1, b, a, c)
            }, v._slidePrev = function (a) {
                return v.slidePrev(!0, a, !0)
            }, v.slideReset = function (a, b, c) {
                return v.slideTo(v.activeIndex, b, a)
            }, v.disableTouchControl = function () {
                return v.params.onlyExternal = !0, !0
            }, v.enableTouchControl = function () {
                return v.params.onlyExternal = !1, !0
            }, v.setWrapperTransition = function (a, b) {
                v.wrapper.transition(a), "slide" !== v.params.effect && v.effects[v.params.effect] && v.effects[v.params.effect].setTransition(a), v.params.parallax && v.parallax && v.parallax.setTransition(a), v.params.scrollbar && v.scrollbar && v.scrollbar.setTransition(a), v.params.control && v.controller && v.controller.setTransition(a, b), v.emit("onSetTransition", v, a)
            }, v.setWrapperTranslate = function (a, b, c) {
                var d = 0, e = 0;
                v.isHorizontal() ? d = v.rtl ? -a : a : e = a, v.params.roundLengths && (d = f(d), e = f(e)), v.params.virtualTranslate || (v.support.transforms3d ? v.wrapper.transform("translate3d(" + d + "px, " + e + "px, 0px)") : v.wrapper.transform("translate(" + d + "px, " + e + "px)")), v.translate = v.isHorizontal() ? d : e;
                var g, h = v.maxTranslate() - v.minTranslate();
                g = 0 === h ? 0 : (a - v.minTranslate()) / h, g !== v.progress && v.updateProgress(a), b && v.updateActiveIndex(), "slide" !== v.params.effect && v.effects[v.params.effect] && v.effects[v.params.effect].setTranslate(v.translate), v.params.parallax && v.parallax && v.parallax.setTranslate(v.translate), v.params.scrollbar && v.scrollbar && v.scrollbar.setTranslate(v.translate), v.params.control && v.controller && v.controller.setTranslate(v.translate, c), v.emit("onSetTranslate", v, v.translate)
            }, v.getTranslate = function (a, b) {
                var c, d, e, f;
                return void 0 === b && (b = "x"), v.params.virtualTranslate ? v.rtl ? -v.translate : v.translate : (e = window.getComputedStyle(a, null), window.WebKitCSSMatrix ? (d = e.transform || e.webkitTransform, d.split(",").length > 6 && (d = d.split(", ").map(function (a) {
                    return a.replace(",", ".")
                }).join(", ")), f = new window.WebKitCSSMatrix("none" === d ? "" : d)) : (f = e.MozTransform || e.OTransform || e.MsTransform || e.msTransform || e.transform || e.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), c = f.toString().split(",")), "x" === b && (d = window.WebKitCSSMatrix ? f.m41 : 16 === c.length ? parseFloat(c[12]) : parseFloat(c[4])), "y" === b && (d = window.WebKitCSSMatrix ? f.m42 : 16 === c.length ? parseFloat(c[13]) : parseFloat(c[5])), v.rtl && d && (d = -d), d || 0)
            }, v.getWrapperTranslate = function (a) {
                return void 0 === a && (a = v.isHorizontal() ? "x" : "y"), v.getTranslate(v.wrapper[0], a)
            }, v.observers = [], v.initObservers = function () {
                if (v.params.observeParents) for (var a = v.container.parents(), b = 0; b < a.length; b++) i(a[b]);
                i(v.container[0], {childList: !1}), i(v.wrapper[0], {attributes: !1})
            }, v.disconnectObservers = function () {
                for (var a = 0; a < v.observers.length; a++) v.observers[a].disconnect();
                v.observers = []
            }, v.createLoop = function () {
                v.wrapper.children("." + v.params.slideClass + "." + v.params.slideDuplicateClass).remove();
                var b = v.wrapper.children("." + v.params.slideClass);
                "auto" !== v.params.slidesPerView || v.params.loopedSlides || (v.params.loopedSlides = b.length), v.loopedSlides = parseInt(v.params.loopedSlides || v.params.slidesPerView, 10), v.loopedSlides = v.loopedSlides + v.params.loopAdditionalSlides, v.loopedSlides > b.length && (v.loopedSlides = b.length);
                var c, d = [], e = [];
                for (b.each(function (c, f) {
                    var g = a(this);
                    c < v.loopedSlides && e.push(f), c < b.length && c >= b.length - v.loopedSlides && d.push(f), g.attr("data-swiper-slide-index", c)
                }), c = 0; c < e.length; c++) v.wrapper.append(a(e[c].cloneNode(!0)).addClass(v.params.slideDuplicateClass));
                for (c = d.length - 1; c >= 0; c--) v.wrapper.prepend(a(d[c].cloneNode(!0)).addClass(v.params.slideDuplicateClass))
            }, v.destroyLoop = function () {
                v.wrapper.children("." + v.params.slideClass + "." + v.params.slideDuplicateClass).remove(), v.slides.removeAttr("data-swiper-slide-index")
            }, v.reLoop = function (a) {
                var b = v.activeIndex - v.loopedSlides;
                v.destroyLoop(), v.createLoop(), v.updateSlidesSize(), a && v.slideTo(b + v.loopedSlides, 0, !1)
            }, v.fixLoop = function () {
                var a;
                v.activeIndex < v.loopedSlides ? (a = v.slides.length - 3 * v.loopedSlides + v.activeIndex, a += v.loopedSlides, v.slideTo(a, 0, !1, !0)) : ("auto" === v.params.slidesPerView && v.activeIndex >= 2 * v.loopedSlides || v.activeIndex > v.slides.length - 2 * v.params.slidesPerView) && (a = -v.slides.length + v.activeIndex + v.loopedSlides, a += v.loopedSlides, v.slideTo(a, 0, !1, !0))
            }, v.appendSlide = function (a) {
                if (v.params.loop && v.destroyLoop(), "object" == typeof a && a.length) for (var b = 0; b < a.length; b++) a[b] && v.wrapper.append(a[b]); else v.wrapper.append(a);
                v.params.loop && v.createLoop(), v.params.observer && v.support.observer || v.update(!0)
            }, v.prependSlide = function (a) {
                v.params.loop && v.destroyLoop();
                var b = v.activeIndex + 1;
                if ("object" == typeof a && a.length) {
                    for (var c = 0; c < a.length; c++) a[c] && v.wrapper.prepend(a[c]);
                    b = v.activeIndex + a.length
                } else v.wrapper.prepend(a);
                v.params.loop && v.createLoop(), v.params.observer && v.support.observer || v.update(!0), v.slideTo(b, 0, !1)
            }, v.removeSlide = function (a) {
                v.params.loop && (v.destroyLoop(), v.slides = v.wrapper.children("." + v.params.slideClass));
                var b, c = v.activeIndex;
                if ("object" == typeof a && a.length) {
                    for (var d = 0; d < a.length; d++) b = a[d], v.slides[b] && v.slides.eq(b).remove(), b < c && c--;
                    c = Math.max(c, 0)
                } else b = a, v.slides[b] && v.slides.eq(b).remove(), b < c && c--, c = Math.max(c, 0);
                v.params.loop && v.createLoop(), v.params.observer && v.support.observer || v.update(!0), v.params.loop ? v.slideTo(c + v.loopedSlides, 0, !1) : v.slideTo(c, 0, !1)
            }, v.removeAllSlides = function () {
                for (var a = [], b = 0; b < v.slides.length; b++) a.push(b);
                v.removeSlide(a)
            }, v.effects = {
                fade: {
                    setTranslate: function () {
                        for (var a = 0; a < v.slides.length; a++) {
                            var b = v.slides.eq(a), c = b[0].swiperSlideOffset, d = -c;
                            v.params.virtualTranslate || (d -= v.translate);
                            var e = 0;
                            v.isHorizontal() || (e = d, d = 0);
                            var f = v.params.fade.crossFade ? Math.max(1 - Math.abs(b[0].progress), 0) : 1 + Math.min(Math.max(b[0].progress, -1), 0);
                            b.css({opacity: f}).transform("translate3d(" + d + "px, " + e + "px, 0px)")
                        }
                    }, setTransition: function (a) {
                        if (v.slides.transition(a), v.params.virtualTranslate && 0 !== a) {
                            var b = !1;
                            v.slides.transitionEnd(function () {
                                if (!b && v) {
                                    b = !0, v.animating = !1;
                                    for (var a = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"], c = 0; c < a.length; c++) v.wrapper.trigger(a[c])
                                }
                            })
                        }
                    }
                }, flip: {
                    setTranslate: function () {
                        for (var b = 0; b < v.slides.length; b++) {
                            var c = v.slides.eq(b), d = c[0].progress;
                            v.params.flip.limitRotation && (d = Math.max(Math.min(c[0].progress, 1), -1));
                            var e = c[0].swiperSlideOffset, f = -180 * d, g = f, h = 0, i = -e, j = 0;
                            if (v.isHorizontal() ? v.rtl && (g = -g) : (j = i, i = 0, h = -g, g = 0), c[0].style.zIndex = -Math.abs(Math.round(d)) + v.slides.length, v.params.flip.slideShadows) {
                                var k = v.isHorizontal() ? c.find(".swiper-slide-shadow-left") : c.find(".swiper-slide-shadow-top"),
                                    l = v.isHorizontal() ? c.find(".swiper-slide-shadow-right") : c.find(".swiper-slide-shadow-bottom");
                                0 === k.length && (k = a('<div class="swiper-slide-shadow-' + (v.isHorizontal() ? "left" : "top") + '"></div>'), c.append(k)), 0 === l.length && (l = a('<div class="swiper-slide-shadow-' + (v.isHorizontal() ? "right" : "bottom") + '"></div>'), c.append(l)), k.length && (k[0].style.opacity = Math.max(-d, 0)), l.length && (l[0].style.opacity = Math.max(d, 0))
                            }
                            c.transform("translate3d(" + i + "px, " + j + "px, 0px) rotateX(" + h + "deg) rotateY(" + g + "deg)")
                        }
                    }, setTransition: function (b) {
                        if (v.slides.transition(b).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(b), v.params.virtualTranslate && 0 !== b) {
                            var c = !1;
                            v.slides.eq(v.activeIndex).transitionEnd(function () {
                                if (!c && v && a(this).hasClass(v.params.slideActiveClass)) {
                                    c = !0, v.animating = !1;
                                    for (var b = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"], d = 0; d < b.length; d++) v.wrapper.trigger(b[d])
                                }
                            })
                        }
                    }
                }, cube: {
                    setTranslate: function () {
                        var b, c = 0;
                        v.params.cube.shadow && (v.isHorizontal() ? (b = v.wrapper.find(".swiper-cube-shadow"), 0 === b.length && (b = a('<div class="swiper-cube-shadow"></div>'), v.wrapper.append(b)), b.css({height: v.width + "px"})) : (b = v.container.find(".swiper-cube-shadow"), 0 === b.length && (b = a('<div class="swiper-cube-shadow"></div>'), v.container.append(b))));
                        for (var d = 0; d < v.slides.length; d++) {
                            var e = v.slides.eq(d), f = 90 * d, g = Math.floor(f / 360);
                            v.rtl && (f = -f, g = Math.floor(-f / 360));
                            var h = Math.max(Math.min(e[0].progress, 1), -1), i = 0, j = 0, k = 0;
                            d % 4 == 0 ? (i = 4 * -g * v.size, k = 0) : (d - 1) % 4 == 0 ? (i = 0, k = 4 * -g * v.size) : (d - 2) % 4 == 0 ? (i = v.size + 4 * g * v.size, k = v.size) : (d - 3) % 4 == 0 && (i = -v.size, k = 3 * v.size + 4 * v.size * g), v.rtl && (i = -i), v.isHorizontal() || (j = i, i = 0);
                            var l = "rotateX(" + (v.isHorizontal() ? 0 : -f) + "deg) rotateY(" + (v.isHorizontal() ? f : 0) + "deg) translate3d(" + i + "px, " + j + "px, " + k + "px)";
                            if (h <= 1 && h > -1 && (c = 90 * d + 90 * h, v.rtl && (c = 90 * -d - 90 * h)), e.transform(l), v.params.cube.slideShadows) {
                                var m = v.isHorizontal() ? e.find(".swiper-slide-shadow-left") : e.find(".swiper-slide-shadow-top"),
                                    n = v.isHorizontal() ? e.find(".swiper-slide-shadow-right") : e.find(".swiper-slide-shadow-bottom");
                                0 === m.length && (m = a('<div class="swiper-slide-shadow-' + (v.isHorizontal() ? "left" : "top") + '"></div>'), e.append(m)), 0 === n.length && (n = a('<div class="swiper-slide-shadow-' + (v.isHorizontal() ? "right" : "bottom") + '"></div>'), e.append(n)), m.length && (m[0].style.opacity = Math.max(-h, 0)), n.length && (n[0].style.opacity = Math.max(h, 0))
                            }
                        }
                        if (v.wrapper.css({
                            "-webkit-transform-origin": "50% 50% -" + v.size / 2 + "px",
                            "-moz-transform-origin": "50% 50% -" + v.size / 2 + "px",
                            "-ms-transform-origin": "50% 50% -" + v.size / 2 + "px",
                            "transform-origin": "50% 50% -" + v.size / 2 + "px"
                        }), v.params.cube.shadow) if (v.isHorizontal()) b.transform("translate3d(0px, " + (v.width / 2 + v.params.cube.shadowOffset) + "px, " + -v.width / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + v.params.cube.shadowScale + ")"); else {
                            var o = Math.abs(c) - 90 * Math.floor(Math.abs(c) / 90),
                                p = 1.5 - (Math.sin(2 * o * Math.PI / 360) / 2 + Math.cos(2 * o * Math.PI / 360) / 2),
                                q = v.params.cube.shadowScale, r = v.params.cube.shadowScale / p,
                                s = v.params.cube.shadowOffset;
                            b.transform("scale3d(" + q + ", 1, " + r + ") translate3d(0px, " + (v.height / 2 + s) + "px, " + -v.height / 2 / r + "px) rotateX(-90deg)")
                        }
                        var t = v.isSafari || v.isUiWebView ? -v.size / 2 : 0;
                        v.wrapper.transform("translate3d(0px,0," + t + "px) rotateX(" + (v.isHorizontal() ? 0 : c) + "deg) rotateY(" + (v.isHorizontal() ? -c : 0) + "deg)")
                    }, setTransition: function (a) {
                        v.slides.transition(a).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(a), v.params.cube.shadow && !v.isHorizontal() && v.container.find(".swiper-cube-shadow").transition(a)
                    }
                }, coverflow: {
                    setTranslate: function () {
                        for (var b = v.translate, c = v.isHorizontal() ? -b + v.width / 2 : -b + v.height / 2, d = v.isHorizontal() ? v.params.coverflow.rotate : -v.params.coverflow.rotate, e = v.params.coverflow.depth, f = 0, g = v.slides.length; f < g; f++) {
                            var h = v.slides.eq(f), i = v.slidesSizesGrid[f], j = h[0].swiperSlideOffset,
                                k = (c - j - i / 2) / i * v.params.coverflow.modifier, l = v.isHorizontal() ? d * k : 0,
                                m = v.isHorizontal() ? 0 : d * k, n = -e * Math.abs(k),
                                o = v.isHorizontal() ? 0 : v.params.coverflow.stretch * k,
                                p = v.isHorizontal() ? v.params.coverflow.stretch * k : 0;
                            Math.abs(p) < .001 && (p = 0), Math.abs(o) < .001 && (o = 0), Math.abs(n) < .001 && (n = 0), Math.abs(l) < .001 && (l = 0), Math.abs(m) < .001 && (m = 0);
                            var q = "translate3d(" + p + "px," + o + "px," + n + "px)  rotateX(" + m + "deg) rotateY(" + l + "deg)";
                            if (h.transform(q), h[0].style.zIndex = 1 - Math.abs(Math.round(k)), v.params.coverflow.slideShadows) {
                                var r = v.isHorizontal() ? h.find(".swiper-slide-shadow-left") : h.find(".swiper-slide-shadow-top"),
                                    s = v.isHorizontal() ? h.find(".swiper-slide-shadow-right") : h.find(".swiper-slide-shadow-bottom");
                                0 === r.length && (r = a('<div class="swiper-slide-shadow-' + (v.isHorizontal() ? "left" : "top") + '"></div>'), h.append(r)), 0 === s.length && (s = a('<div class="swiper-slide-shadow-' + (v.isHorizontal() ? "right" : "bottom") + '"></div>'), h.append(s)), r.length && (r[0].style.opacity = k > 0 ? k : 0), s.length && (s[0].style.opacity = -k > 0 ? -k : 0)
                            }
                        }
                        v.browser.ie && (v.wrapper[0].style.perspectiveOrigin = c + "px 50%")
                    }, setTransition: function (a) {
                        v.slides.transition(a).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(a)
                    }
                }
            }, v.lazy = {
                initialImageLoaded: !1, loadImageInSlide: function (b, c) {
                    if (void 0 !== b && (void 0 === c && (c = !0), 0 !== v.slides.length)) {
                        var d = v.slides.eq(b),
                            e = d.find("." + v.params.lazyLoadingClass + ":not(." + v.params.lazyStatusLoadedClass + "):not(." + v.params.lazyStatusLoadingClass + ")");
                        !d.hasClass(v.params.lazyLoadingClass) || d.hasClass(v.params.lazyStatusLoadedClass) || d.hasClass(v.params.lazyStatusLoadingClass) || (e = e.add(d[0])), 0 !== e.length && e.each(function () {
                            var b = a(this);
                            b.addClass(v.params.lazyStatusLoadingClass);
                            var e = b.attr("data-background"), f = b.attr("data-src"), g = b.attr("data-srcset"),
                                h = b.attr("data-sizes");
                            v.loadImage(b[0], f || e, g, h, !1, function () {
                                if (void 0 !== v && null !== v && v) {
                                    if (e ? (b.css("background-image", 'url("' + e + '")'), b.removeAttr("data-background")) : (g && (b.attr("srcset", g), b.removeAttr("data-srcset")), h && (b.attr("sizes", h), b.removeAttr("data-sizes")), f && (b.attr("src", f), b.removeAttr("data-src"))), b.addClass(v.params.lazyStatusLoadedClass).removeClass(v.params.lazyStatusLoadingClass), d.find("." + v.params.lazyPreloaderClass + ", ." + v.params.preloaderClass).remove(), v.params.loop && c) {
                                        var a = d.attr("data-swiper-slide-index");
                                        if (d.hasClass(v.params.slideDuplicateClass)) {
                                            var i = v.wrapper.children('[data-swiper-slide-index="' + a + '"]:not(.' + v.params.slideDuplicateClass + ")");
                                            v.lazy.loadImageInSlide(i.index(), !1)
                                        } else {
                                            var j = v.wrapper.children("." + v.params.slideDuplicateClass + '[data-swiper-slide-index="' + a + '"]');
                                            v.lazy.loadImageInSlide(j.index(), !1)
                                        }
                                    }
                                    v.emit("onLazyImageReady", v, d[0], b[0])
                                }
                            }), v.emit("onLazyImageLoad", v, d[0], b[0])
                        })
                    }
                }, load: function () {
                    var b, c = v.params.slidesPerView;
                    if ("auto" === c && (c = 0), v.lazy.initialImageLoaded || (v.lazy.initialImageLoaded = !0), v.params.watchSlidesVisibility) v.wrapper.children("." + v.params.slideVisibleClass).each(function () {
                        v.lazy.loadImageInSlide(a(this).index())
                    }); else if (c > 1) for (b = v.activeIndex; b < v.activeIndex + c; b++) v.slides[b] && v.lazy.loadImageInSlide(b); else v.lazy.loadImageInSlide(v.activeIndex);
                    if (v.params.lazyLoadingInPrevNext) if (c > 1 || v.params.lazyLoadingInPrevNextAmount && v.params.lazyLoadingInPrevNextAmount > 1) {
                        var d = v.params.lazyLoadingInPrevNextAmount, e = c,
                            f = Math.min(v.activeIndex + e + Math.max(d, e), v.slides.length),
                            g = Math.max(v.activeIndex - Math.max(e, d), 0);
                        for (b = v.activeIndex + c; b < f; b++) v.slides[b] && v.lazy.loadImageInSlide(b);
                        for (b = g; b < v.activeIndex; b++) v.slides[b] && v.lazy.loadImageInSlide(b)
                    } else {
                        var h = v.wrapper.children("." + v.params.slideNextClass);
                        h.length > 0 && v.lazy.loadImageInSlide(h.index());
                        var i = v.wrapper.children("." + v.params.slidePrevClass);
                        i.length > 0 && v.lazy.loadImageInSlide(i.index())
                    }
                }, onTransitionStart: function () {
                    v.params.lazyLoading && (v.params.lazyLoadingOnTransitionStart || !v.params.lazyLoadingOnTransitionStart && !v.lazy.initialImageLoaded) && v.lazy.load()
                }, onTransitionEnd: function () {
                    v.params.lazyLoading && !v.params.lazyLoadingOnTransitionStart && v.lazy.load()
                }
            }, v.scrollbar = {
                isTouched: !1, setDragPosition: function (a) {
                    var b = v.scrollbar,
                        c = v.isHorizontal() ? "touchstart" === a.type || "touchmove" === a.type ? a.targetTouches[0].pageX : a.pageX || a.clientX : "touchstart" === a.type || "touchmove" === a.type ? a.targetTouches[0].pageY : a.pageY || a.clientY,
                        d = c - b.track.offset()[v.isHorizontal() ? "left" : "top"] - b.dragSize / 2,
                        e = -v.minTranslate() * b.moveDivider, f = -v.maxTranslate() * b.moveDivider;
                    d < e ? d = e : d > f && (d = f), d = -d / b.moveDivider, v.updateProgress(d), v.setWrapperTranslate(d, !0)
                }, dragStart: function (a) {
                    var b = v.scrollbar;
                    b.isTouched = !0, a.preventDefault(), a.stopPropagation(), b.setDragPosition(a), clearTimeout(b.dragTimeout), b.track.transition(0), v.params.scrollbarHide && b.track.css("opacity", 1), v.wrapper.transition(100), b.drag.transition(100), v.emit("onScrollbarDragStart", v)
                }, dragMove: function (a) {
                    var b = v.scrollbar;
                    b.isTouched && (a.preventDefault ? a.preventDefault() : a.returnValue = !1, b.setDragPosition(a), v.wrapper.transition(0), b.track.transition(0), b.drag.transition(0), v.emit("onScrollbarDragMove", v))
                }, dragEnd: function (a) {
                    var b = v.scrollbar;
                    b.isTouched && (b.isTouched = !1, v.params.scrollbarHide && (clearTimeout(b.dragTimeout), b.dragTimeout = setTimeout(function () {
                        b.track.css("opacity", 0), b.track.transition(400)
                    }, 1e3)), v.emit("onScrollbarDragEnd", v), v.params.scrollbarSnapOnRelease && v.slideReset())
                }, draggableEvents: function () {
                    return v.params.simulateTouch !== !1 || v.support.touch ? v.touchEvents : v.touchEventsDesktop
                }(), enableDraggable: function () {
                    var b = v.scrollbar, c = v.support.touch ? b.track : document;
                    a(b.track).on(b.draggableEvents.start, b.dragStart), a(c).on(b.draggableEvents.move, b.dragMove), a(c).on(b.draggableEvents.end, b.dragEnd)
                }, disableDraggable: function () {
                    var b = v.scrollbar, c = v.support.touch ? b.track : document;
                    a(b.track).off(b.draggableEvents.start, b.dragStart), a(c).off(b.draggableEvents.move, b.dragMove), a(c).off(b.draggableEvents.end, b.dragEnd)
                }, set: function () {
                    if (v.params.scrollbar) {
                        var b = v.scrollbar;
                        b.track = a(v.params.scrollbar), v.params.uniqueNavElements && "string" == typeof v.params.scrollbar && b.track.length > 1 && 1 === v.container.find(v.params.scrollbar).length && (b.track = v.container.find(v.params.scrollbar)), b.drag = b.track.find(".swiper-scrollbar-drag"), 0 === b.drag.length && (b.drag = a('<div class="swiper-scrollbar-drag"></div>'), b.track.append(b.drag)), b.drag[0].style.width = "", b.drag[0].style.height = "", b.trackSize = v.isHorizontal() ? b.track[0].offsetWidth : b.track[0].offsetHeight, b.divider = v.size / v.virtualSize, b.moveDivider = b.divider * (b.trackSize / v.size), b.dragSize = b.trackSize * b.divider, v.isHorizontal() ? b.drag[0].style.width = b.dragSize + "px" : b.drag[0].style.height = b.dragSize + "px", b.divider >= 1 ? b.track[0].style.display = "none" : b.track[0].style.display = "", v.params.scrollbarHide && (b.track[0].style.opacity = 0)
                    }
                }, setTranslate: function () {
                    if (v.params.scrollbar) {
                        var a, b = v.scrollbar, c = (v.translate, b.dragSize);
                        a = (b.trackSize - b.dragSize) * v.progress, v.rtl && v.isHorizontal() ? (a = -a, a > 0 ? (c = b.dragSize - a, a = 0) : -a + b.dragSize > b.trackSize && (c = b.trackSize + a)) : a < 0 ? (c = b.dragSize + a, a = 0) : a + b.dragSize > b.trackSize && (c = b.trackSize - a), v.isHorizontal() ? (v.support.transforms3d ? b.drag.transform("translate3d(" + a + "px, 0, 0)") : b.drag.transform("translateX(" + a + "px)"), b.drag[0].style.width = c + "px") : (v.support.transforms3d ? b.drag.transform("translate3d(0px, " + a + "px, 0)") : b.drag.transform("translateY(" + a + "px)"), b.drag[0].style.height = c + "px"), v.params.scrollbarHide && (clearTimeout(b.timeout), b.track[0].style.opacity = 1, b.timeout = setTimeout(function () {
                            b.track[0].style.opacity = 0, b.track.transition(400)
                        }, 1e3))
                    }
                }, setTransition: function (a) {
                    v.params.scrollbar && v.scrollbar.drag.transition(a)
                }
            }, v.controller = {
                LinearSpline: function (a, b) {
                    var c = function () {
                        var a, b, c;
                        return function (d, e) {
                            for (b = -1, a = d.length; a - b > 1;) d[c = a + b >> 1] <= e ? b = c : a = c;
                            return a
                        }
                    }();
                    this.x = a, this.y = b, this.lastIndex = a.length - 1;
                    var d, e;
                    this.x.length, this.interpolate = function (a) {
                        return a ? (e = c(this.x, a), d = e - 1, (a - this.x[d]) * (this.y[e] - this.y[d]) / (this.x[e] - this.x[d]) + this.y[d]) : 0
                    }
                }, getInterpolateFunction: function (a) {
                    v.controller.spline || (v.controller.spline = v.params.loop ? new v.controller.LinearSpline(v.slidesGrid, a.slidesGrid) : new v.controller.LinearSpline(v.snapGrid, a.snapGrid))
                }, setTranslate: function (a, c) {
                    function d(b) {
                        a = b.rtl && "horizontal" === b.params.direction ? -v.translate : v.translate, "slide" === v.params.controlBy && (v.controller.getInterpolateFunction(b), f = -v.controller.spline.interpolate(-a)), f && "container" !== v.params.controlBy || (e = (b.maxTranslate() - b.minTranslate()) / (v.maxTranslate() - v.minTranslate()), f = (a - v.minTranslate()) * e + b.minTranslate()), v.params.controlInverse && (f = b.maxTranslate() - f), b.updateProgress(f), b.setWrapperTranslate(f, !1, v), b.updateActiveIndex()
                    }

                    var e, f, g = v.params.control;
                    if (Array.isArray(g)) for (var h = 0; h < g.length; h++) g[h] !== c && g[h] instanceof b && d(g[h]); else g instanceof b && c !== g && d(g)
                }, setTransition: function (a, c) {
                    function d(b) {
                        b.setWrapperTransition(a, v), 0 !== a && (b.onTransitionStart(), b.wrapper.transitionEnd(function () {
                            f && (b.params.loop && "slide" === v.params.controlBy && b.fixLoop(), b.onTransitionEnd())
                        }))
                    }

                    var e, f = v.params.control;
                    if (Array.isArray(f)) for (e = 0; e < f.length; e++) f[e] !== c && f[e] instanceof b && d(f[e]); else f instanceof b && c !== f && d(f)
                }
            }, v.hashnav = {
                onHashCange: function (a, b) {
                    var c = document.location.hash.replace("#", "");
                    c !== v.slides.eq(v.activeIndex).attr("data-hash") && v.slideTo(v.wrapper.children("." + v.params.slideClass + '[data-hash="' + c + '"]').index())
                }, attachEvents: function (b) {
                    var c = b ? "off" : "on";
                    a(window)[c]("hashchange", v.hashnav.onHashCange)
                }, setHash: function () {
                    if (v.hashnav.initialized && v.params.hashnav) if (v.params.replaceState && window.history && window.history.replaceState) window.history.replaceState(null, null, "#" + v.slides.eq(v.activeIndex).attr("data-hash") || ""); else {
                        var a = v.slides.eq(v.activeIndex), b = a.attr("data-hash") || a.attr("data-history");
                        document.location.hash = b || ""
                    }
                }, init: function () {
                    if (v.params.hashnav && !v.params.history) {
                        v.hashnav.initialized = !0;
                        var a = document.location.hash.replace("#", "");
                        if (a) for (var b = 0, c = v.slides.length; b < c; b++) {
                            var d = v.slides.eq(b), e = d.attr("data-hash") || d.attr("data-history");
                            if (e === a && !d.hasClass(v.params.slideDuplicateClass)) {
                                var f = d.index();
                                v.slideTo(f, 0, v.params.runCallbacksOnInit, !0)
                            }
                        }
                        v.params.hashnavWatchState && v.hashnav.attachEvents()
                    }
                }, destroy: function () {
                    v.params.hashnavWatchState && v.hashnav.attachEvents(!0)
                }
            }, v.history = {
                init: function () {
                    if (v.params.history) {
                        if (!window.history || !window.history.pushState) return v.params.history = !1, void (v.params.hashnav = !0);
                        v.history.initialized = !0, this.paths = this.getPathValues(), (this.paths.key || this.paths.value) && (this.scrollToSlide(0, this.paths.value, v.params.runCallbacksOnInit), v.params.replaceState || window.addEventListener("popstate", this.setHistoryPopState))
                    }
                }, setHistoryPopState: function () {
                    v.history.paths = v.history.getPathValues(), v.history.scrollToSlide(v.params.speed, v.history.paths.value, !1)
                }, getPathValues: function () {
                    var a = window.location.pathname.slice(1).split("/"), b = a.length;
                    return {key: a[b - 2], value: a[b - 1]}
                }, setHistory: function (a, b) {
                    if (v.history.initialized && v.params.history) {
                        var c = v.slides.eq(b), d = this.slugify(c.attr("data-history"));
                        window.location.pathname.includes(a) || (d = a + "/" + d), v.params.replaceState ? window.history.replaceState(null, null, d) : window.history.pushState(null, null, d)
                    }
                }, slugify: function (a) {
                    return a.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "")
                }, scrollToSlide: function (a, b, c) {
                    if (b) for (var d = 0, e = v.slides.length; d < e; d++) {
                        var f = v.slides.eq(d), g = this.slugify(f.attr("data-history"));
                        if (g === b && !f.hasClass(v.params.slideDuplicateClass)) {
                            var h = f.index();
                            v.slideTo(h, a, c)
                        }
                    } else v.slideTo(0, a, c)
                }
            }, v.disableKeyboardControl = function () {
                v.params.keyboardControl = !1, a(document).off("keydown", j)
            }, v.enableKeyboardControl = function () {
                v.params.keyboardControl = !0, a(document).on("keydown", j)
            }, v.mousewheel = {
                event: !1,
                lastScrollTime: (new window.Date).getTime()
            }, v.params.mousewheelControl && (v.mousewheel.event = navigator.userAgent.indexOf("firefox") > -1 ? "DOMMouseScroll" : function () {
                var a = "onwheel" in document;
                if (!a) {
                    var b = document.createElement("div");
                    b.setAttribute("onwheel", "return;"), a = "function" == typeof b.onwheel
                }
                return !a && document.implementation && document.implementation.hasFeature && document.implementation.hasFeature("", "") !== !0 && (a = document.implementation.hasFeature("Events.wheel", "3.0")), a
            }() ? "wheel" : "mousewheel"), v.disableMousewheelControl = function () {
                if (!v.mousewheel.event) return !1;
                var b = v.container;
                return "container" !== v.params.mousewheelEventsTarged && (b = a(v.params.mousewheelEventsTarged)), b.off(v.mousewheel.event, l), v.params.mousewheelControl = !1, !0
            }, v.enableMousewheelControl = function () {
                if (!v.mousewheel.event) return !1;
                var b = v.container;
                return "container" !== v.params.mousewheelEventsTarged && (b = a(v.params.mousewheelEventsTarged)), b.on(v.mousewheel.event, l), v.params.mousewheelControl = !0, !0
            }, v.parallax = {
                setTranslate: function () {
                    v.container.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function () {
                        m(this, v.progress)
                    }), v.slides.each(function () {
                        var b = a(this);
                        b.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function () {
                            m(this, Math.min(Math.max(b[0].progress, -1), 1))
                        })
                    })
                }, setTransition: function (b) {
                    void 0 === b && (b = v.params.speed), v.container.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function () {
                        var c = a(this), d = parseInt(c.attr("data-swiper-parallax-duration"), 10) || b;
                        0 === b && (d = 0), c.transition(d)
                    })
                }
            }, v.zoom = {
                scale: 1,
                currentScale: 1,
                isScaling: !1,
                gesture: {
                    slide: void 0,
                    slideWidth: void 0,
                    slideHeight: void 0,
                    image: void 0,
                    imageWrap: void 0,
                    zoomMax: v.params.zoomMax
                },
                image: {
                    isTouched: void 0,
                    isMoved: void 0,
                    currentX: void 0,
                    currentY: void 0,
                    minX: void 0,
                    minY: void 0,
                    maxX: void 0,
                    maxY: void 0,
                    width: void 0,
                    height: void 0,
                    startX: void 0,
                    startY: void 0,
                    touchesStart: {},
                    touchesCurrent: {}
                },
                velocity: {x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0},
                getDistanceBetweenTouches: function (a) {
                    if (a.targetTouches.length < 2) return 1;
                    var b = a.targetTouches[0].pageX, c = a.targetTouches[0].pageY, d = a.targetTouches[1].pageX,
                        e = a.targetTouches[1].pageY;
                    return Math.sqrt(Math.pow(d - b, 2) + Math.pow(e - c, 2))
                },
                onGestureStart: function (b) {
                    var c = v.zoom;
                    if (!v.support.gestures) {
                        if ("touchstart" !== b.type || "touchstart" === b.type && b.targetTouches.length < 2) return;
                        c.gesture.scaleStart = c.getDistanceBetweenTouches(b)
                    }
                    return c.gesture.slide && c.gesture.slide.length || (c.gesture.slide = a(this), 0 === c.gesture.slide.length && (c.gesture.slide = v.slides.eq(v.activeIndex)), c.gesture.image = c.gesture.slide.find("img, svg, canvas"), c.gesture.imageWrap = c.gesture.image.parent("." + v.params.zoomContainerClass), c.gesture.zoomMax = c.gesture.imageWrap.attr("data-swiper-zoom") || v.params.zoomMax, 0 !== c.gesture.imageWrap.length) ? (c.gesture.image.transition(0),
                        void (c.isScaling = !0)) : void (c.gesture.image = void 0)
                },
                onGestureChange: function (a) {
                    var b = v.zoom;
                    if (!v.support.gestures) {
                        if ("touchmove" !== a.type || "touchmove" === a.type && a.targetTouches.length < 2) return;
                        b.gesture.scaleMove = b.getDistanceBetweenTouches(a)
                    }
                    b.gesture.image && 0 !== b.gesture.image.length && (v.support.gestures ? b.scale = a.scale * b.currentScale : b.scale = b.gesture.scaleMove / b.gesture.scaleStart * b.currentScale, b.scale > b.gesture.zoomMax && (b.scale = b.gesture.zoomMax - 1 + Math.pow(b.scale - b.gesture.zoomMax + 1, .5)), b.scale < v.params.zoomMin && (b.scale = v.params.zoomMin + 1 - Math.pow(v.params.zoomMin - b.scale + 1, .5)), b.gesture.image.transform("translate3d(0,0,0) scale(" + b.scale + ")"))
                },
                onGestureEnd: function (a) {
                    var b = v.zoom;
                    !v.support.gestures && ("touchend" !== a.type || "touchend" === a.type && a.changedTouches.length < 2) || b.gesture.image && 0 !== b.gesture.image.length && (b.scale = Math.max(Math.min(b.scale, b.gesture.zoomMax), v.params.zoomMin), b.gesture.image.transition(v.params.speed).transform("translate3d(0,0,0) scale(" + b.scale + ")"), b.currentScale = b.scale, b.isScaling = !1, 1 === b.scale && (b.gesture.slide = void 0))
                },
                onTouchStart: function (a, b) {
                    var c = a.zoom;
                    c.gesture.image && 0 !== c.gesture.image.length && (c.image.isTouched || ("android" === a.device.os && b.preventDefault(), c.image.isTouched = !0, c.image.touchesStart.x = "touchstart" === b.type ? b.targetTouches[0].pageX : b.pageX, c.image.touchesStart.y = "touchstart" === b.type ? b.targetTouches[0].pageY : b.pageY))
                },
                onTouchMove: function (a) {
                    var b = v.zoom;
                    if (b.gesture.image && 0 !== b.gesture.image.length && (v.allowClick = !1, b.image.isTouched && b.gesture.slide)) {
                        b.image.isMoved || (b.image.width = b.gesture.image[0].offsetWidth, b.image.height = b.gesture.image[0].offsetHeight, b.image.startX = v.getTranslate(b.gesture.imageWrap[0], "x") || 0, b.image.startY = v.getTranslate(b.gesture.imageWrap[0], "y") || 0, b.gesture.slideWidth = b.gesture.slide[0].offsetWidth, b.gesture.slideHeight = b.gesture.slide[0].offsetHeight, b.gesture.imageWrap.transition(0), v.rtl && (b.image.startX = -b.image.startX), v.rtl && (b.image.startY = -b.image.startY));
                        var c = b.image.width * b.scale, d = b.image.height * b.scale;
                        if (!(c < b.gesture.slideWidth && d < b.gesture.slideHeight)) {
                            if (b.image.minX = Math.min(b.gesture.slideWidth / 2 - c / 2, 0), b.image.maxX = -b.image.minX, b.image.minY = Math.min(b.gesture.slideHeight / 2 - d / 2, 0), b.image.maxY = -b.image.minY, b.image.touchesCurrent.x = "touchmove" === a.type ? a.targetTouches[0].pageX : a.pageX, b.image.touchesCurrent.y = "touchmove" === a.type ? a.targetTouches[0].pageY : a.pageY, !b.image.isMoved && !b.isScaling) {
                                if (v.isHorizontal() && Math.floor(b.image.minX) === Math.floor(b.image.startX) && b.image.touchesCurrent.x < b.image.touchesStart.x || Math.floor(b.image.maxX) === Math.floor(b.image.startX) && b.image.touchesCurrent.x > b.image.touchesStart.x) return void (b.image.isTouched = !1);
                                if (!v.isHorizontal() && Math.floor(b.image.minY) === Math.floor(b.image.startY) && b.image.touchesCurrent.y < b.image.touchesStart.y || Math.floor(b.image.maxY) === Math.floor(b.image.startY) && b.image.touchesCurrent.y > b.image.touchesStart.y) return void (b.image.isTouched = !1)
                            }
                            a.preventDefault(), a.stopPropagation(), b.image.isMoved = !0, b.image.currentX = b.image.touchesCurrent.x - b.image.touchesStart.x + b.image.startX, b.image.currentY = b.image.touchesCurrent.y - b.image.touchesStart.y + b.image.startY, b.image.currentX < b.image.minX && (b.image.currentX = b.image.minX + 1 - Math.pow(b.image.minX - b.image.currentX + 1, .8)), b.image.currentX > b.image.maxX && (b.image.currentX = b.image.maxX - 1 + Math.pow(b.image.currentX - b.image.maxX + 1, .8)), b.image.currentY < b.image.minY && (b.image.currentY = b.image.minY + 1 - Math.pow(b.image.minY - b.image.currentY + 1, .8)), b.image.currentY > b.image.maxY && (b.image.currentY = b.image.maxY - 1 + Math.pow(b.image.currentY - b.image.maxY + 1, .8)), b.velocity.prevPositionX || (b.velocity.prevPositionX = b.image.touchesCurrent.x), b.velocity.prevPositionY || (b.velocity.prevPositionY = b.image.touchesCurrent.y), b.velocity.prevTime || (b.velocity.prevTime = Date.now()), b.velocity.x = (b.image.touchesCurrent.x - b.velocity.prevPositionX) / (Date.now() - b.velocity.prevTime) / 2, b.velocity.y = (b.image.touchesCurrent.y - b.velocity.prevPositionY) / (Date.now() - b.velocity.prevTime) / 2, Math.abs(b.image.touchesCurrent.x - b.velocity.prevPositionX) < 2 && (b.velocity.x = 0), Math.abs(b.image.touchesCurrent.y - b.velocity.prevPositionY) < 2 && (b.velocity.y = 0), b.velocity.prevPositionX = b.image.touchesCurrent.x, b.velocity.prevPositionY = b.image.touchesCurrent.y, b.velocity.prevTime = Date.now(), b.gesture.imageWrap.transform("translate3d(" + b.image.currentX + "px, " + b.image.currentY + "px,0)")
                        }
                    }
                },
                onTouchEnd: function (a, b) {
                    var c = a.zoom;
                    if (c.gesture.image && 0 !== c.gesture.image.length) {
                        if (!c.image.isTouched || !c.image.isMoved) return c.image.isTouched = !1, void (c.image.isMoved = !1);
                        c.image.isTouched = !1, c.image.isMoved = !1;
                        var d = 300, e = 300, f = c.velocity.x * d, g = c.image.currentX + f, h = c.velocity.y * e,
                            i = c.image.currentY + h;
                        0 !== c.velocity.x && (d = Math.abs((g - c.image.currentX) / c.velocity.x)), 0 !== c.velocity.y && (e = Math.abs((i - c.image.currentY) / c.velocity.y));
                        var j = Math.max(d, e);
                        c.image.currentX = g, c.image.currentY = i;
                        var k = c.image.width * c.scale, l = c.image.height * c.scale;
                        c.image.minX = Math.min(c.gesture.slideWidth / 2 - k / 2, 0), c.image.maxX = -c.image.minX, c.image.minY = Math.min(c.gesture.slideHeight / 2 - l / 2, 0), c.image.maxY = -c.image.minY, c.image.currentX = Math.max(Math.min(c.image.currentX, c.image.maxX), c.image.minX), c.image.currentY = Math.max(Math.min(c.image.currentY, c.image.maxY), c.image.minY), c.gesture.imageWrap.transition(j).transform("translate3d(" + c.image.currentX + "px, " + c.image.currentY + "px,0)")
                    }
                },
                onTransitionEnd: function (a) {
                    var b = a.zoom;
                    b.gesture.slide && a.previousIndex !== a.activeIndex && (b.gesture.image.transform("translate3d(0,0,0) scale(1)"), b.gesture.imageWrap.transform("translate3d(0,0,0)"), b.gesture.slide = b.gesture.image = b.gesture.imageWrap = void 0, b.scale = b.currentScale = 1)
                },
                toggleZoom: function (b, c) {
                    var d = b.zoom;
                    if (d.gesture.slide || (d.gesture.slide = b.clickedSlide ? a(b.clickedSlide) : b.slides.eq(b.activeIndex), d.gesture.image = d.gesture.slide.find("img, svg, canvas"), d.gesture.imageWrap = d.gesture.image.parent("." + b.params.zoomContainerClass)), d.gesture.image && 0 !== d.gesture.image.length) {
                        var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
                        void 0 === d.image.touchesStart.x && c ? (e = "touchend" === c.type ? c.changedTouches[0].pageX : c.pageX, f = "touchend" === c.type ? c.changedTouches[0].pageY : c.pageY) : (e = d.image.touchesStart.x, f = d.image.touchesStart.y), d.scale && 1 !== d.scale ? (d.scale = d.currentScale = 1, d.gesture.imageWrap.transition(300).transform("translate3d(0,0,0)"), d.gesture.image.transition(300).transform("translate3d(0,0,0) scale(1)"), d.gesture.slide = void 0) : (d.scale = d.currentScale = d.gesture.imageWrap.attr("data-swiper-zoom") || b.params.zoomMax, c ? (u = d.gesture.slide[0].offsetWidth, v = d.gesture.slide[0].offsetHeight, g = d.gesture.slide.offset().left, h = d.gesture.slide.offset().top, i = g + u / 2 - e, j = h + v / 2 - f, m = d.gesture.image[0].offsetWidth, n = d.gesture.image[0].offsetHeight, o = m * d.scale, p = n * d.scale, q = Math.min(u / 2 - o / 2, 0), r = Math.min(v / 2 - p / 2, 0), s = -q, t = -r, k = i * d.scale, l = j * d.scale, k < q && (k = q), k > s && (k = s), l < r && (l = r), l > t && (l = t)) : (k = 0, l = 0), d.gesture.imageWrap.transition(300).transform("translate3d(" + k + "px, " + l + "px,0)"), d.gesture.image.transition(300).transform("translate3d(0,0,0) scale(" + d.scale + ")"))
                    }
                },
                attachEvents: function (b) {
                    var c = b ? "off" : "on";
                    if (v.params.zoom) {
                        var d = (v.slides, !("touchstart" !== v.touchEvents.start || !v.support.passiveListener || !v.params.passiveListeners) && {
                            passive: !0,
                            capture: !1
                        });
                        v.support.gestures ? (v.slides[c]("gesturestart", v.zoom.onGestureStart, d), v.slides[c]("gesturechange", v.zoom.onGestureChange, d), v.slides[c]("gestureend", v.zoom.onGestureEnd, d)) : "touchstart" === v.touchEvents.start && (v.slides[c](v.touchEvents.start, v.zoom.onGestureStart, d), v.slides[c](v.touchEvents.move, v.zoom.onGestureChange, d), v.slides[c](v.touchEvents.end, v.zoom.onGestureEnd, d)), v[c]("touchStart", v.zoom.onTouchStart), v.slides.each(function (b, d) {
                            a(d).find("." + v.params.zoomContainerClass).length > 0 && a(d)[c](v.touchEvents.move, v.zoom.onTouchMove)
                        }), v[c]("touchEnd", v.zoom.onTouchEnd), v[c]("transitionEnd", v.zoom.onTransitionEnd), v.params.zoomToggle && v.on("doubleTap", v.zoom.toggleZoom)
                    }
                },
                init: function () {
                    v.zoom.attachEvents()
                },
                destroy: function () {
                    v.zoom.attachEvents(!0)
                }
            }, v._plugins = [];
            for (var M in v.plugins) {
                var N = v.plugins[M](v, v.params[M]);
                N && v._plugins.push(N)
            }
            return v.callPlugins = function (a) {
                for (var b = 0; b < v._plugins.length; b++) a in v._plugins[b] && v._plugins[b][a](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5])
            }, v.emitterEventListeners = {}, v.emit = function (a) {
                v.params[a] && v.params[a](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                var b;
                if (v.emitterEventListeners[a]) for (b = 0; b < v.emitterEventListeners[a].length; b++) v.emitterEventListeners[a][b](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                v.callPlugins && v.callPlugins(a, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5])
            }, v.on = function (a, b) {
                return a = n(a), v.emitterEventListeners[a] || (v.emitterEventListeners[a] = []), v.emitterEventListeners[a].push(b), v
            }, v.off = function (a, b) {
                var c;
                if (a = n(a), void 0 === b) return v.emitterEventListeners[a] = [], v;
                if (v.emitterEventListeners[a] && 0 !== v.emitterEventListeners[a].length) {
                    for (c = 0; c < v.emitterEventListeners[a].length; c++) v.emitterEventListeners[a][c] === b && v.emitterEventListeners[a].splice(c, 1);
                    return v
                }
            }, v.once = function (a, b) {
                a = n(a);
                var c = function () {
                    b(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]), v.off(a, c)
                };
                return v.on(a, c), v
            }, v.a11y = {
                makeFocusable: function (a) {
                    return a.attr("tabIndex", "0"), a
                },
                addRole: function (a, b) {
                    return a.attr("role", b), a
                },
                addLabel: function (a, b) {
                    return a.attr("aria-label", b), a
                },
                disable: function (a) {
                    return a.attr("aria-disabled", !0), a
                },
                enable: function (a) {
                    return a.attr("aria-disabled", !1), a
                },
                onEnterKey: function (b) {
                    13 === b.keyCode && (a(b.target).is(v.params.nextButton) ? (v.onClickNext(b), v.isEnd ? v.a11y.notify(v.params.lastSlideMessage) : v.a11y.notify(v.params.nextSlideMessage)) : a(b.target).is(v.params.prevButton) && (v.onClickPrev(b), v.isBeginning ? v.a11y.notify(v.params.firstSlideMessage) : v.a11y.notify(v.params.prevSlideMessage)), a(b.target).is("." + v.params.bulletClass) && a(b.target)[0].click())
                },
                liveRegion: a('<span class="' + v.params.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>'),
                notify: function (a) {
                    var b = v.a11y.liveRegion;
                    0 !== b.length && (b.html(""), b.html(a))
                },
                init: function () {
                    v.params.nextButton && v.nextButton && v.nextButton.length > 0 && (v.a11y.makeFocusable(v.nextButton), v.a11y.addRole(v.nextButton, "button"), v.a11y.addLabel(v.nextButton, v.params.nextSlideMessage)), v.params.prevButton && v.prevButton && v.prevButton.length > 0 && (v.a11y.makeFocusable(v.prevButton), v.a11y.addRole(v.prevButton, "button"), v.a11y.addLabel(v.prevButton, v.params.prevSlideMessage)), a(v.container).append(v.a11y.liveRegion)
                },
                initPagination: function () {
                    v.params.pagination && v.params.paginationClickable && v.bullets && v.bullets.length && v.bullets.each(function () {
                        var b = a(this);
                        v.a11y.makeFocusable(b), v.a11y.addRole(b, "button"), v.a11y.addLabel(b, v.params.paginationBulletMessage.replace(/{{index}}/, b.index() + 1))
                    })
                },
                destroy: function () {
                    v.a11y.liveRegion && v.a11y.liveRegion.length > 0 && v.a11y.liveRegion.remove()
                }
            }, v.init = function () {
                v.params.loop && v.createLoop(), v.updateContainerSize(), v.updateSlidesSize(), v.updatePagination(), v.params.scrollbar && v.scrollbar && (v.scrollbar.set(), v.params.scrollbarDraggable && v.scrollbar.enableDraggable()), "slide" !== v.params.effect && v.effects[v.params.effect] && (v.params.loop || v.updateProgress(), v.effects[v.params.effect].setTranslate()), v.params.loop ? v.slideTo(v.params.initialSlide + v.loopedSlides, 0, v.params.runCallbacksOnInit) : (v.slideTo(v.params.initialSlide, 0, v.params.runCallbacksOnInit), 0 === v.params.initialSlide && (v.parallax && v.params.parallax && v.parallax.setTranslate(), v.lazy && v.params.lazyLoading && (v.lazy.load(), v.lazy.initialImageLoaded = !0))), v.attachEvents(), v.params.observer && v.support.observer && v.initObservers(), v.params.preloadImages && !v.params.lazyLoading && v.preloadImages(), v.params.zoom && v.zoom && v.zoom.init(), v.params.autoplay && v.startAutoplay(), v.params.keyboardControl && v.enableKeyboardControl && v.enableKeyboardControl(), v.params.mousewheelControl && v.enableMousewheelControl && v.enableMousewheelControl(), v.params.hashnavReplaceState && (v.params.replaceState = v.params.hashnavReplaceState), v.params.history && v.history && v.history.init(), v.params.hashnav && v.hashnav && v.hashnav.init(), v.params.a11y && v.a11y && v.a11y.init(), v.emit("onInit", v)
            }, v.cleanupStyles = function () {
                v.container.removeClass(v.classNames.join(" ")).removeAttr("style"), v.wrapper.removeAttr("style"), v.slides && v.slides.length && v.slides.removeClass([v.params.slideVisibleClass, v.params.slideActiveClass, v.params.slideNextClass, v.params.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-column").removeAttr("data-swiper-row"), v.paginationContainer && v.paginationContainer.length && v.paginationContainer.removeClass(v.params.paginationHiddenClass), v.bullets && v.bullets.length && v.bullets.removeClass(v.params.bulletActiveClass), v.params.prevButton && a(v.params.prevButton).removeClass(v.params.buttonDisabledClass), v.params.nextButton && a(v.params.nextButton).removeClass(v.params.buttonDisabledClass), v.params.scrollbar && v.scrollbar && (v.scrollbar.track && v.scrollbar.track.length && v.scrollbar.track.removeAttr("style"), v.scrollbar.drag && v.scrollbar.drag.length && v.scrollbar.drag.removeAttr("style"))
            }, v.destroy = function (a, b) {
                v.detachEvents(), v.stopAutoplay(), v.params.scrollbar && v.scrollbar && v.params.scrollbarDraggable && v.scrollbar.disableDraggable(), v.params.loop && v.destroyLoop(), b && v.cleanupStyles(), v.disconnectObservers(), v.params.zoom && v.zoom && v.zoom.destroy(), v.params.keyboardControl && v.disableKeyboardControl && v.disableKeyboardControl(), v.params.mousewheelControl && v.disableMousewheelControl && v.disableMousewheelControl(), v.params.a11y && v.a11y && v.a11y.destroy(), v.params.history && !v.params.replaceState && window.removeEventListener("popstate", v.history.setHistoryPopState), v.params.hashnav && v.hashnav && v.hashnav.destroy(), v.emit("onDestroy"), a !== !1 && (v = null)
            }, v.init(), v
        }
    };
    b.prototype = {
        isSafari: function () {
            var a = window.navigator.userAgent.toLowerCase();
            return a.indexOf("safari") >= 0 && a.indexOf("chrome") < 0 && a.indexOf("android") < 0
        }(),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent),
        isArray: function (a) {
            return "[object Array]" === Object.prototype.toString.apply(a)
        },
        browser: {
            ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
            ieTouch: window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1 || window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1,
            lteIE9: function () {
                var a = document.createElement("div");
                return a.innerHTML = "<!--[if lte IE 9]><i></i><![endif]-->", 1 === a.getElementsByTagName("i").length
            }()
        },
        device: function () {
            var a = window.navigator.userAgent, b = a.match(/(Android);?[\s\/]+([\d.]+)?/),
                c = a.match(/(iPad).*OS\s([\d_]+)/), d = a.match(/(iPod)(.*OS\s([\d_]+))?/),
                e = !c && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
            return {ios: c || e || d, android: b}
        }(),
        support: {
            touch: window.Modernizr && Modernizr.touch === !0 || function () {
                return !!("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch)
            }(), transforms3d: window.Modernizr && Modernizr.csstransforms3d === !0 || function () {
                var a = document.createElement("div").style;
                return "webkitPerspective" in a || "MozPerspective" in a || "OPerspective" in a || "MsPerspective" in a || "perspective" in a
            }(), flexbox: function () {
                for (var a = document.createElement("div").style, b = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "), c = 0; c < b.length; c++) if (b[c] in a) return !0
            }(), observer: function () {
                return "MutationObserver" in window || "WebkitMutationObserver" in window
            }(), passiveListener: function () {
                var a = !1;
                try {
                    var b = Object.defineProperty({}, "passive", {
                        get: function () {
                            a = !0
                        }
                    });
                    window.addEventListener("testPassiveListener", null, b)
                } catch (a) {
                }
                return a
            }(), gestures: function () {
                return "ongesturestart" in window
            }()
        },
        plugins: {}
    };
    for (var c = (function () {
        var a = function (a) {
            var b = this, c = 0;
            for (c = 0; c < a.length; c++) b[c] = a[c];
            return b.length = a.length, this
        }, b = function (b, c) {
            var d = [], e = 0;
            if (b && !c && b instanceof a) return b;
            if (b) if ("string" == typeof b) {
                var f, g, h = b.trim();
                if (h.indexOf("<") >= 0 && h.indexOf(">") >= 0) {
                    var i = "div";
                    for (0 === h.indexOf("<li") && (i = "ul"), 0 === h.indexOf("<tr") && (i = "tbody"), 0 !== h.indexOf("<td") && 0 !== h.indexOf("<th") || (i = "tr"), 0 === h.indexOf("<tbody") && (i = "table"), 0 === h.indexOf("<option") && (i = "select"), g = document.createElement(i), g.innerHTML = b, e = 0; e < g.childNodes.length; e++) d.push(g.childNodes[e])
                } else for (f = c || "#" !== b[0] || b.match(/[ .<>:~]/) ? (c || document).querySelectorAll(b) : [document.getElementById(b.split("#")[1])], e = 0; e < f.length; e++) f[e] && d.push(f[e])
            } else if (b.nodeType || b === window || b === document) d.push(b); else if (b.length > 0 && b[0].nodeType) for (e = 0; e < b.length; e++) d.push(b[e]);
            return new a(d)
        };
        return a.prototype = {
            addClass: function (a) {
                if (void 0 === a) return this;
                for (var b = a.split(" "), c = 0; c < b.length; c++) for (var d = 0; d < this.length; d++) this[d].classList.add(b[c]);
                return this
            }, removeClass: function (a) {
                for (var b = a.split(" "), c = 0; c < b.length; c++) for (var d = 0; d < this.length; d++) this[d].classList.remove(b[c]);
                return this
            }, hasClass: function (a) {
                return !!this[0] && this[0].classList.contains(a)
            }, toggleClass: function (a) {
                for (var b = a.split(" "), c = 0; c < b.length; c++) for (var d = 0; d < this.length; d++) this[d].classList.toggle(b[c]);
                return this
            }, attr: function (a, b) {
                if (1 === arguments.length && "string" == typeof a) return this[0] ? this[0].getAttribute(a) : void 0;
                for (var c = 0; c < this.length; c++) if (2 === arguments.length) this[c].setAttribute(a, b); else for (var d in a) this[c][d] = a[d], this[c].setAttribute(d, a[d]);
                return this
            }, removeAttr: function (a) {
                for (var b = 0; b < this.length; b++) this[b].removeAttribute(a);
                return this
            }, data: function (a, b) {
                if (void 0 !== b) {
                    for (var c = 0; c < this.length; c++) {
                        var d = this[c];
                        d.dom7ElementDataStorage || (d.dom7ElementDataStorage = {}), d.dom7ElementDataStorage[a] = b
                    }
                    return this
                }
                if (this[0]) {
                    var e = this[0].getAttribute("data-" + a);
                    return e ? e : this[0].dom7ElementDataStorage && a in this[0].dom7ElementDataStorage ? this[0].dom7ElementDataStorage[a] : void 0
                }
            }, transform: function (a) {
                for (var b = 0; b < this.length; b++) {
                    var c = this[b].style;
                    c.webkitTransform = c.MsTransform = c.msTransform = c.MozTransform = c.OTransform = c.transform = a
                }
                return this
            }, transition: function (a) {
                "string" != typeof a && (a += "ms");
                for (var b = 0; b < this.length; b++) {
                    var c = this[b].style;
                    c.webkitTransitionDuration = c.MsTransitionDuration = c.msTransitionDuration = c.MozTransitionDuration = c.OTransitionDuration = c.transitionDuration = a
                }
                return this
            }, on: function (a, c, d, e) {
                function f(a) {
                    var e = a.target;
                    if (b(e).is(c)) d.call(e, a); else for (var f = b(e).parents(), g = 0; g < f.length; g++) b(f[g]).is(c) && d.call(f[g], a)
                }

                var g, h, i = a.split(" ");
                for (g = 0; g < this.length; g++) if ("function" == typeof c || c === !1) for ("function" == typeof c && (d = arguments[1], e = arguments[2] || !1), h = 0; h < i.length; h++) this[g].addEventListener(i[h], d, e); else for (h = 0; h < i.length; h++) this[g].dom7LiveListeners || (this[g].dom7LiveListeners = []), this[g].dom7LiveListeners.push({
                    listener: d,
                    liveListener: f
                }), this[g].addEventListener(i[h], f, e);
                return this
            }, off: function (a, b, c, d) {
                for (var e = a.split(" "), f = 0; f < e.length; f++) for (var g = 0; g < this.length; g++) if ("function" == typeof b || b === !1) "function" == typeof b && (c = arguments[1], d = arguments[2] || !1), this[g].removeEventListener(e[f], c, d); else if (this[g].dom7LiveListeners) for (var h = 0; h < this[g].dom7LiveListeners.length; h++) this[g].dom7LiveListeners[h].listener === c && this[g].removeEventListener(e[f], this[g].dom7LiveListeners[h].liveListener, d);
                return this
            }, once: function (a, b, c, d) {
                function e(g) {
                    c(g), f.off(a, b, e, d)
                }

                var f = this;
                "function" == typeof b && (b = !1, c = arguments[1], d = arguments[2]), f.on(a, b, e, d)
            }, trigger: function (a, b) {
                for (var c = 0; c < this.length; c++) {
                    var d;
                    try {
                        d = new window.CustomEvent(a, {detail: b, bubbles: !0, cancelable: !0})
                    } catch (c) {
                        d = document.createEvent("Event"), d.initEvent(a, !0, !0), d.detail = b
                    }
                    this[c].dispatchEvent(d)
                }
                return this
            }, transitionEnd: function (a) {
                function b(f) {
                    if (f.target === this) for (a.call(this, f), c = 0; c < d.length; c++) e.off(d[c], b)
                }

                var c,
                    d = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"],
                    e = this;
                if (a) for (c = 0; c < d.length; c++) e.on(d[c], b);
                return this
            }, width: function () {
                return this[0] === window ? window.innerWidth : this.length > 0 ? parseFloat(this.css("width")) : null
            }, outerWidth: function (a) {
                return this.length > 0 ? a ? this[0].offsetWidth + parseFloat(this.css("margin-right")) + parseFloat(this.css("margin-left")) : this[0].offsetWidth : null
            }, height: function () {
                return this[0] === window ? window.innerHeight : this.length > 0 ? parseFloat(this.css("height")) : null
            }, outerHeight: function (a) {
                return this.length > 0 ? a ? this[0].offsetHeight + parseFloat(this.css("margin-top")) + parseFloat(this.css("margin-bottom")) : this[0].offsetHeight : null
            }, offset: function () {
                if (this.length > 0) {
                    var a = this[0], b = a.getBoundingClientRect(), c = document.body,
                        d = a.clientTop || c.clientTop || 0, e = a.clientLeft || c.clientLeft || 0,
                        f = window.pageYOffset || a.scrollTop, g = window.pageXOffset || a.scrollLeft;
                    return {top: b.top + f - d, left: b.left + g - e}
                }
                return null
            }, css: function (a, b) {
                var c;
                if (1 === arguments.length) {
                    if ("string" != typeof a) {
                        for (c = 0; c < this.length; c++) for (var d in a) this[c].style[d] = a[d];
                        return this
                    }
                    if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(a)
                }
                if (2 === arguments.length && "string" == typeof a) {
                    for (c = 0; c < this.length; c++) this[c].style[a] = b;
                    return this
                }
                return this
            }, each: function (a) {
                for (var b = 0; b < this.length; b++) a.call(this[b], b, this[b]);
                return this
            }, html: function (a) {
                if (void 0 === a) return this[0] ? this[0].innerHTML : void 0;
                for (var b = 0; b < this.length; b++) this[b].innerHTML = a;
                return this
            }, text: function (a) {
                if (void 0 === a) return this[0] ? this[0].textContent.trim() : null;
                for (var b = 0; b < this.length; b++) this[b].textContent = a;
                return this
            }, is: function (c) {
                if (!this[0]) return !1;
                var d, e;
                if ("string" == typeof c) {
                    var f = this[0];
                    if (f === document) return c === document;
                    if (f === window) return c === window;
                    if (f.matches) return f.matches(c);
                    if (f.webkitMatchesSelector) return f.webkitMatchesSelector(c);
                    if (f.mozMatchesSelector) return f.mozMatchesSelector(c);
                    if (f.msMatchesSelector) return f.msMatchesSelector(c);
                    for (d = b(c), e = 0; e < d.length; e++) if (d[e] === this[0]) return !0;
                    return !1
                }
                if (c === document) return this[0] === document;
                if (c === window) return this[0] === window;
                if (c.nodeType || c instanceof a) {
                    for (d = c.nodeType ? [c] : c, e = 0; e < d.length; e++) if (d[e] === this[0]) return !0;
                    return !1
                }
                return !1
            }, index: function () {
                if (this[0]) {
                    for (var a = this[0], b = 0; null !== (a = a.previousSibling);) 1 === a.nodeType && b++;
                    return b
                }
            }, eq: function (b) {
                if (void 0 === b) return this;
                var c, d = this.length;
                return b > d - 1 ? new a([]) : b < 0 ? (c = d + b, new a(c < 0 ? [] : [this[c]])) : new a([this[b]])
            }, append: function (b) {
                var c, d;
                for (c = 0; c < this.length; c++) if ("string" == typeof b) {
                    var e = document.createElement("div");
                    for (e.innerHTML = b; e.firstChild;) this[c].appendChild(e.firstChild)
                } else if (b instanceof a) for (d = 0; d < b.length; d++) this[c].appendChild(b[d]); else this[c].appendChild(b);
                return this
            }, prepend: function (b) {
                var c, d;
                for (c = 0; c < this.length; c++) if ("string" == typeof b) {
                    var e = document.createElement("div");
                    for (e.innerHTML = b, d = e.childNodes.length - 1; d >= 0; d--) this[c].insertBefore(e.childNodes[d], this[c].childNodes[0])
                } else if (b instanceof a) for (d = 0; d < b.length; d++) this[c].insertBefore(b[d], this[c].childNodes[0]); else this[c].insertBefore(b, this[c].childNodes[0]);
                return this
            }, insertBefore: function (a) {
                for (var c = b(a), d = 0; d < this.length; d++) if (1 === c.length) c[0].parentNode.insertBefore(this[d], c[0]); else if (c.length > 1) for (var e = 0; e < c.length; e++) c[e].parentNode.insertBefore(this[d].cloneNode(!0), c[e])
            }, insertAfter: function (a) {
                for (var c = b(a), d = 0; d < this.length; d++) if (1 === c.length) c[0].parentNode.insertBefore(this[d], c[0].nextSibling); else if (c.length > 1) for (var e = 0; e < c.length; e++) c[e].parentNode.insertBefore(this[d].cloneNode(!0), c[e].nextSibling)
            }, next: function (c) {
                return new a(this.length > 0 ? c ? this[0].nextElementSibling && b(this[0].nextElementSibling).is(c) ? [this[0].nextElementSibling] : [] : this[0].nextElementSibling ? [this[0].nextElementSibling] : [] : [])
            }, nextAll: function (c) {
                var d = [], e = this[0];
                if (!e) return new a([]);
                for (; e.nextElementSibling;) {
                    var f = e.nextElementSibling;
                    c ? b(f).is(c) && d.push(f) : d.push(f), e = f
                }
                return new a(d)
            }, prev: function (c) {
                return new a(this.length > 0 ? c ? this[0].previousElementSibling && b(this[0].previousElementSibling).is(c) ? [this[0].previousElementSibling] : [] : this[0].previousElementSibling ? [this[0].previousElementSibling] : [] : [])
            }, prevAll: function (c) {
                var d = [], e = this[0];
                if (!e) return new a([]);
                for (; e.previousElementSibling;) {
                    var f = e.previousElementSibling;
                    c ? b(f).is(c) && d.push(f) : d.push(f), e = f
                }
                return new a(d)
            }, parent: function (a) {
                for (var c = [], d = 0; d < this.length; d++) a ? b(this[d].parentNode).is(a) && c.push(this[d].parentNode) : c.push(this[d].parentNode);
                return b(b.unique(c))
            }, parents: function (a) {
                for (var c = [], d = 0; d < this.length; d++) for (var e = this[d].parentNode; e;) a ? b(e).is(a) && c.push(e) : c.push(e), e = e.parentNode;
                return b(b.unique(c))
            }, find: function (b) {
                for (var c = [], d = 0; d < this.length; d++) for (var e = this[d].querySelectorAll(b), f = 0; f < e.length; f++) c.push(e[f]);
                return new a(c)
            }, children: function (c) {
                for (var d = [], e = 0; e < this.length; e++) for (var f = this[e].childNodes, g = 0; g < f.length; g++) c ? 1 === f[g].nodeType && b(f[g]).is(c) && d.push(f[g]) : 1 === f[g].nodeType && d.push(f[g]);
                return new a(b.unique(d))
            }, remove: function () {
                for (var a = 0; a < this.length; a++) this[a].parentNode && this[a].parentNode.removeChild(this[a]);
                return this
            }, add: function () {
                var a, c, d = this;
                for (a = 0; a < arguments.length; a++) {
                    var e = b(arguments[a]);
                    for (c = 0; c < e.length; c++) d[d.length] = e[c], d.length++
                }
                return d
            }
        }, b.fn = a.prototype, b.unique = function (a) {
            for (var b = [], c = 0; c < a.length; c++) b.indexOf(a[c]) === -1 && b.push(a[c]);
            return b
        }, b
    }()), d = ["jQuery", "Zepto", "Dom7"], e = 0; e < d.length; e++) window[d[e]] && function (a) {
        a.fn.swiper = function (c) {
            var d;
            return a(this).each(function () {
                var a = new b(this, c);
                d || (d = a)
            }), d
        }
    }(window[d[e]]);
    var f;
    f = void 0 === c ? window.Dom7 || window.Zepto || window.jQuery : c, f && ("transitionEnd" in f.fn || (f.fn.transitionEnd = function (a) {
        function b(f) {
            if (f.target === this) for (a.call(this, f), c = 0; c < d.length; c++) e.off(d[c], b)
        }

        var c, d = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"],
            e = this;
        if (a) for (c = 0; c < d.length; c++) e.on(d[c], b);
        return this
    }), "transform" in f.fn || (f.fn.transform = function (a) {
        for (var b = 0; b < this.length; b++) {
            var c = this[b].style;
            c.webkitTransform = c.MsTransform = c.msTransform = c.MozTransform = c.OTransform = c.transform = a
        }
        return this
    }), "transition" in f.fn || (f.fn.transition = function (a) {
        "string" != typeof a && (a += "ms");
        for (var b = 0; b < this.length; b++) {
            var c = this[b].style;
            c.webkitTransitionDuration = c.MsTransitionDuration = c.msTransitionDuration = c.MozTransitionDuration = c.OTransitionDuration = c.transitionDuration = a
        }
        return this
    }), "outerWidth" in f.fn || (f.fn.outerWidth = function (a) {
        return this.length > 0 ? a ? this[0].offsetWidth + parseFloat(this.css("margin-right")) + parseFloat(this.css("margin-left")) : this[0].offsetWidth : null
    })), window.Swiper = b
}(), "undefined" != typeof module ? module.exports = window.Swiper : "function" == typeof define && define.amd && define("swiper", [], function () {
    "use strict";
    return window.Swiper
}), function (a) {
    "use strict";
    "function" == typeof define && define.amd ? define("equal-height", ["jquery"], a) : a(jQuery)
}(function (a) {
    "use strict";
    a.fn.setEqualHeight = function (b) {
        var c = a(this), d = 0;
        return c.each(function (c, e) {
            var f, g = a(e), h = getComputedStyle(e).height;
            e.style.height = "auto", f = g.outerHeight(), e.style.height = h, f > d && (d = f, b && (d += b.outerHeight()))
        }), c.outerHeight(d), c
    }, a.fn.initHeightBoxes = function (b) {
        function c() {
            return 1 === e.length ? void e.height("auto") : void ("undefined" != typeof b ? e.setEqualHeight(d.find(b)) : e.setEqualHeight())
        }

        var d = a(this), e = a(), f = 0;
        d.removeClass("calculated"), d.each(function (b, g) {
            var h = a(g), i = a(d[b - 1]);
            Math.floor(h.offset().top) !== f || i.hasClass("last") ? (i.addClass("last-in-row"), c(), e = h, f = Math.floor(h.offset().top)) : e = e.add(h)
        }), d.last().addClass("last-in-row"), c(), d.addClass("calculated")
    }
}), define("views/coverflow-teaser-view", ["jquery", "underscore", "backbone", "swiper", "equal-height"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.swiperOptions = {
                effect: "coverflow",
                loop: !0,
                loopedSlides: 3,
                centeredSlides: !0,
                slidesPerView: 3,
                initialSlide: 0,
                keyboardControl: !0,
                lazyLoading: !1,
                preventClicks: !1,
                preventClicksPropagation: !1,
                slideToClickedSlide: !0,
                lazyLoadingInPrevNext: !1,
                noSwiping: !1,
                pagination: ".swiper-pagination",
                roundLengths: !0,
                paginationHide: !1,
                paginationClickable: !0,
                bulletClass: "bullet",
                bulletActiveClass: "active",
                nextButton: ".next",
                prevButton: ".prev",
                paginationBulletRender: function (a, b, c) {
                    return '<li class="' + c + '"><span></span></li>'
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                        coverflow: {rotate: 0, stretch: 0, depth: 0, modifier: 0, slideShadows: !1}
                    },
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        coverflow: {rotate: 0, stretch: 200, depth: 250, modifier: 1, slideShadows: !1}
                    },
                    1200: {
                        slidesPerView: 2,
                        coverflow: {rotate: 0, stretch: 200, depth: 250, modifier: 1, slideShadows: !1}
                    },
                    4e3: {
                        slidesPerView: 2.4,
                        coverflow: {rotate: 0, stretch: 200, depth: 150, modifier: 1, slideShadows: !1}
                    }
                }
            }, this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.onResize.bind(this)), this.el.addEventListener("load", this.onImagesLoaded.bind(this), !0)
        }, render: function () {
            this.swiper = new Swiper(this.$(".coverflow-wrapper")[0], this.swiperOptions), this.$teasers = this.$(".swiper-slide"), this.teaserCount = this.$teasers.length, this.calculateTeaserHeight()
        }, onResize: function () {
            this.swiper.destroy(!0, !0), this.render()
        }, onImagesLoaded: function () {
            this.calculateTeaserHeight()
        }, calculateTeaserHeight: function () {
            var b, c = this.teaserCount;
            this.$teasers.each(function (d, e) {
                var f = a(e), g = f.find(".button-primary").length;
                0 === d ? b = f : 0 === Math.round(f.position().left) ? (b.setEqualHeight(), b = f) : (b = b.add(f), d === c - 1 && b.length > 1 && b.setEqualHeight()), g && b.addClass("sticky-button").find(".button-primary").parent().addClass("stick-to-bottom")
            }), this.calculateButtonSpaces()
        }, calculateButtonSpaces: function () {
            b.each(this.$teasers, function (b) {
                var c, d = a(b), e = d.find(".text"), f = 44;
                c = d.find(".stick-to-bottom a").outerHeight(), e.css("paddingBottom", f + c)
            })
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/editorial-images-view", ["jquery", "underscore", "backbone", "app/lazy-images", "slick-slider"], function (a, b, c, d) {
    "use strict";
    var e = ".media-item", f = c.View.extend({
        $slickContainer: void 0,
        $controlsWrapper: void 0,
        currentLightboxEvent: void 0,
        slideSelector: e,
        defaultSlickOptions: {
            rows: 0,
            adaptiveHeight: !0,
            accessibility: !1,
            dots: !1,
            appendDots: null,
            infinite: !0,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: !1,
            easing: "ease-in",
            slide: e,
            appendArrows: void 0,
            arrows: !0,
            mobileFirst: !0,
            prevArrow: '<span class="slick-prev media-arrow-prev-bold"></span>',
            nextArrow: '<span class="slick-next media-arrow-next-bold"></span>',
            responsive: [{breakpoint: 640, settings: {variableWidth: !0}}]
        },
        smallGallerySlickOptions: {
            rows: 0,
            adaptiveHeight: !0,
            accessibility: !1,
            dots: !0,
            appendDots: ".controls-dots",
            infinite: !0,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: !1,
            touchMove: !1,
            easing: "ease-in",
            slide: e,
            appendArrows: void 0,
            arrows: !0,
            mobileFirst: !0,
            prevArrow: '<div class="slick-prev media-arrow-prev-bold"></div>',
            nextArrow: '<div class="slick-next media-arrow-next-bold"></div>',
            customPaging: function () {
                return "<span></span>"
            }
        },
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.$slickContainer = this.$(".media-list"), this.$controlsWrapper = this.$(".controls-wrapper"), this.isSlider = this.$el.hasClass("slider"), this.setupListeners(), this.render()
        },
        setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.LIGHTBOX_BEFORE_OPEN, this.onLightboxBeforeOpen.bind(this)), this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.LIGHTBOX_GALLERY_READY, this.onLightboxGalleryReady.bind(this))
        },
        onLightboxBeforeOpen: function (b) {
            return b.view && 0 !== a(b.target).closest(this.el).length ? void (this.currentLightboxEvent = b) : void (this.currentLightboxEvent = null)
        },
        onLightboxGalleryReady: function (b) {
            this.isSlider || this.currentLightboxEvent && b.view === this.currentLightboxEvent.view && b.target === this.currentLightboxEvent.target && (b.view.setMediaGalleryPosition(a(b.target).closest(this.slideSelector).index()),
                this.currentLightboxEvent = null)
        },
        render: function () {
            this.isSlider && (this.$el.hasClass("small") ? (this.smallGallerySlickOptions.appendDots = this.$(".controls-dots"), this.initMediaGallery(this.smallGallerySlickOptions)) : (this.initMediaGalleryPageCounter(), this.initMediaGallery(this.defaultSlickOptions)))
        },
        initMediaGallery: function (a) {
            a.appendArrows = this.$controlsWrapper, this.$slickContainer.slick(a), d({
                container: this.$slickContainer,
                callback: this.onLazyImageLoaded.bind(this)
            })
        },
        onLazyImageLoaded: function () {
            this.$slickContainer.slick("refresh")
        },
        initMediaGalleryPageCounter: function () {
            this.$slickContainer.on("setPosition", function (a, b) {
                this.setSliderPaging(b.currentSlide + 1, b.$slides.length)
            }.bind(this))
        },
        setSliderPaging: function (a, b) {
            this.$(".header .page-counter").text(a + "/" + b)
        }
    });
    return function (a) {
        return this instanceof f ? this : new f(a)
    }
}), define("views/equal-height-view", ["jquery", "underscore", "backbone", "equal-height"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        currentDisplay: void 0, $targets: void 0, initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.$targets = this.options.$targets || this.$el.children(), this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, b.debounce(this.render, 300))
        }, render: function () {
            var a = window.app.matchMedia.getMediaQueries(),
                b = "media-to-m" === a.currentMediaQuery || "media-from-m-to-l" === a.currentMediaQuery;
            return b === !0 && "equalHeight" !== this.currentDisplay ? this : (b === !0 && "equalHeight" === this.currentDisplay ? this.removeEqualHeight() : this.setEqualHeight(), this)
        }, setEqualHeight: function () {
            this.$targets.setEqualHeight(), this.currentDisplay = "equalHeight"
        }, removeEqualHeight: function () {
            this.$targets.height(""), this.currentDisplay = null
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/facts-and-figures-view", ["jquery", "underscore", "backbone", "slick-slider"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.eventDispatcher = window.app.eventDispatcher, this.slickOptions = {
                adaptiveHeight: !1,
                accessibility: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !1,
                dots: !0,
                dotsClass: "slider-dots",
                appendDots: this.$el,
                mobileFirst: !0,
                responsive: [{breakpoint: 640, settings: {slidesToShow: 2, slidesToScroll: 2}}, {
                    breakpoint: 960,
                    settings: "unslick"
                }],
                customPaging: function () {
                    return "<span></span>"
                }
            }, this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.onViewportChange)
        }, render: function () {
            this.currentMediaQuery = window.app.matchMedia.getCurrentMediaQuery(), "media-from-m-to-l" === this.currentMediaQuery && this.$el.hasClass("facts-2") || this.$(".facts-and-figures").slick(this.slickOptions)
        }, onViewportChange: function () {
            return this.currentMediaQuery = window.app.matchMedia.getCurrentMediaQuery(), "media-from-m-to-l" === this.currentMediaQuery && this.$el.hasClass("facts-2") ? void window.setTimeout(this.unslick.bind(this), 500) : void ("media-from-l" === this.currentMediaQuery || this.$(".facts-and-figures").hasClass("slick-initialized") || this.$(".facts-and-figures").slick(this.slickOptions))
        }, unslick: function () {
            this.$(".facts-and-figures.slick-initialized").slick("unslick")
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/faq-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        eventDispatcher: void 0,
        $faqStickyContainer: void 0,
        $stickyFaqList: void 0,
        stickyHeaderTolerance: 80,
        lastPosTop: 0,
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render()
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_SCROLL, b.debounce(this.initStickyHeader.bind(this), 100)), this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.onResize.bind(this)), this.listenTo(this.eventDispatcher, window.app.applicationEvents.ACCORDION_SHOW, this.onAccordionOpen.bind(this))
        },
        render: function () {
            this.$(".faq-list a").on("click", this.scrollTo.bind(this)), window.addEventListener("scroll", this.onScroll.bind(this)), this.$faqStickyContainer = a(this.el.querySelector(".faq-sticky-container")), this.$stickyAccordion = a(this.el.querySelector("#sticky-accordion")), this.$stickyNavContainer = this.$faqStickyContainer.clone(!0).attr("id", "sticky-faq-list"), !this.getStickyFaqList().length && this.$stickyAccordion.length && (this.$stickyNavContainer.find(".faq-sticky-content").appendTo(this.$stickyAccordion.find(".content")), this.$stickyAccordion.addClass("visible").appendTo(this.$stickyNavContainer), this.$stickyNavContainer.appendTo("body"), this.initStickyHeader())
        },
        scrollTo: function (b) {
            b.preventDefault();
            var c = this.$('.anchor-flag[name="' + a(b.target).attr("href").substring(1) + '"]');
            if (c.length) {
                var d = !this.isLargeMedia(), e = a(document.getElementById("header")),
                    f = d ? e.outerHeight(!0) + 10 : 0;
                this.collapseStickyHeader(), this.hasVisibleStickyContent(c, d) && (f = this.$stickyAccordion.height(), d && (f += e.outerHeight()), f -= this.$stickyAccordion.find(".content").outerHeight(), 0 === this.$stickyAccordion.length && d && (f = 140)), isNaN(f) && (f = 0), a("html, body").animate({scrollTop: c.offset().top - f - 20}, 400, function () {
                }.bind(this))
            }
        },
        initStickyHeader: function () {
            this.isLargeMedia() ? this.getStickyFaqList().css("top", 0) : this.getStickyFaqList().css("top", a(document.getElementById("header")).outerHeight());
            var b = a(document).scrollTop() - (this.$faqStickyContainer.offset().top + this.$faqStickyContainer.outerHeight()) < this.stickyHeaderTolerance;
            b ? (this.deactivateStickyHeader(), this.$stickyAccordion.hasClass("active") && this.collapseStickyHeader()) : this.activateStickyHeader()
        },
        activateStickyHeader: function () {
            this.getStickyFaqList().addClass("active ready")
        },
        deactivateStickyHeader: function () {
            this.getStickyFaqList().removeClass("ready"), window.setTimeout(this.getStickyFaqList().removeClass.bind(this.getStickyFaqList(), "active"), 120)
        },
        collapseStickyHeader: function () {
            this.$stickyAccordion.find(".title").trigger("click")
        },
        hasVisibleStickyContent: function (a, b) {
            return a.offset().top > this.$faqStickyContainer.offset().top + this.$faqStickyContainer.outerHeight(!b) + this.stickyHeaderTolerance
        },
        onAccordionOpen: function () {
            this.lastPosTop = a("html, body").scrollTop(), this.calcAccordionMaxHeight()
        },
        calcAccordionMaxHeight: function () {
            var b = a(window).height(), c = a(document.getElementById("header")), d = c.outerHeight(),
                e = this.$stickyAccordion.find(".title").outerHeight(),
                f = this.$stickyAccordion.find(".faq-sticky-content"), g = e + f.height() + 20, h = 0;
            f.removeAttr("style"), d + g > b ? (h = b - (e + d), f.css({
                "max-height": h,
                overflow: "auto"
            })) : f.css("overflow", "hidden")
        },
        onResize: function () {
            this.isLargeMedia() || this.calcAccordionMaxHeight()
        },
        onScroll: function (b) {
            if (this.getStickyFaqList().hasClass("ready") && this.$stickyAccordion.hasClass("active")) {
                var c = a(b.target).scrollTop();
                if (!this.isLargeMedia() && a("#sticky-accordion.active").length) return;
                c > this.lastPosTop && this.collapseStickyHeader(), this.lastPosTop = c
            }
        },
        isLargeMedia: function () {
            return "media-from-l" === window.app.matchMedia.getCurrentMediaQuery()
        },
        getStickyFaqList: function () {
            return this.$stickyFaqList && this.$stickyFaqList.length || (this.$stickyFaqList = a(document.getElementById("sticky-faq-list"))), this.$stickyFaqList
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/footnote-item-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.render()
        }, render: function () {
            var b = a('<span class="footnote-anchor">' + this.options.footnoteId + "</span>");
            return this.$el.append(b), b.on("click", this.scrollToFootnote.bind(this)), this
        }, scrollToFootnote: function (b) {
            b.stopPropagation(), b.preventDefault();
            var c = this, d = window.app.matchMedia.getCurrentMediaQuery(), e = 0, f = a("#footnotes"),
                g = a(c.options.footnoteTarget);
            "media-from-l" !== d && (f = g.find(".footnote-no"), e = a("header").outerHeight(!0) + 50), a("html, body").animate({scrollTop: f.offset().top - e}, function () {
                var b = a("#footnotes"), c = 0;
                b && b.parents(".module-accordion").length && (b.parents(".module-accordion:not(.active)").find(".title").trigger("click"), c = 250), g.addClass("highlight"), window.setTimeout(g.removeClass.bind(g, "highlight"), 3e3 + c)
            })
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/footnote-view", ["jquery", "underscore", "backbone", "views/footnote-item-view"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        footnoteViews: [], footnoteTargets: {}, footnoteDataAttrStr: "footnote-target", initialize: function () {
            this.eventDispatcher = window.app.eventDispatcher, this.$footnoteItemElements = document.querySelectorAll("[data-" + this.footnoteDataAttrStr + "]"), this.$footnotesSrc = a("#footnote-src"), this.render()
        }, render: function () {
            this.initFootnoteItems(), this.populateFootnoteList()
        }, initFootnoteItems: function () {
            this.$footnoteItemElements.length || this.$el.parents(".module").remove(), a.each(this.$footnoteItemElements, function (b, c) {
                var e = a(c), f = e.data("footnote-target"), g = e.data("footnote-numeration-text"),
                    h = e.data("footnote-list-order") - 1;
                return 0 === a(f).length ? void a(e[0].childNodes[0]).unwrap() : (this.footnoteTargets[h] = [f, g], void this.footnoteViews.push(d({
                    el: e,
                    footnoteTarget: this.footnoteTargets[h][0],
                    footnoteId: this.footnoteTargets[h][1]
                })))
            }.bind(this))
        }, populateFootnoteList: function () {
            var b = ".";
            a.each(this.footnoteTargets, function (c, d) {
                isNaN(d[1]) && (b = ""), this.$el.append('<li id="' + d[0].replace("#", "") + '"><span class="footnote-no">' + d[1] + b + "</span><p>" + a(d[0]).html().trim() + "</p></li>")
            }.bind(this)), this.$footnotesSrc.remove()
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("views/generic-content-view", ["jquery", "underscore", "backbone", "app/lazy-images", "slick-slider", "equal-height"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.$slickContainer = this.$(".media-outer"), this.isTilesContainer = this.$el.hasClass("media-tiles"), this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.onResize.bind(this))
        }, render: function () {
            return this.initEqualButtonHeights(), this.initMediaGallery(), this
        }, onResize: function () {
            this.initEqualButtonHeights(), this.calculateSliderControls(300)
        }, initEqualButtonHeights: function () {
            this.$(".media-outer .controls a").initHeightBoxes()
        }, initMediaGallery: function () {
            if (!this.isTilesContainer) {
                var a = this;
                a.$slickContainer.on("setPosition", function (b, c) {
                    a.setSliderPaging(c.currentSlide + 1, c.$slides.length), a.calculateSliderControls(0)
                }), a.$slickContainer.slick({
                    rows: 0,
                    adaptiveHeight: !0,
                    accessibility: !1,
                    dots: !1,
                    infinite: !0,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    touchMove: !1,
                    easing: "ease-in",
                    slide: ".media-inner",
                    appendArrows: a.$(".media-outer .controls"),
                    arrows: !0,
                    mobileFirst: !0,
                    prevArrow: '<span class="slick-prev"></span>',
                    nextArrow: '<span class="slick-next"></span>'
                }), a.calculateSliderControls(0), d({
                    container: a.$slickContainer,
                    callback: a.onLazyImageLoaded.bind(a)
                })
            }
        }, onLazyImageLoaded: function () {
            this.$slickContainer.slick("refresh"), this.onResize()
        }, calculateSliderControls: function (a) {
            setTimeout(this.calculateDelayed.bind(this), a)
        }, calculateDelayed: function () {
            var a = this.$(".slick-slide.slick-active"), b = parseInt(a.find("img, video").height()),
                c = parseInt(this.$(".slick-arrow").outerHeight());
            this.$(".media-outer .slick-arrow").css("margin-top", (b - c) / 2), a.parents(".media-outer").find(".controls").addClass("initialized")
        }, setSliderPaging: function (a, b) {
            this.$(".media-outer .slider-paging .current-slide").text(a), this.$(".media-outer .slider-paging .max-slides").text(b)
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("views/generic-slider-view", ["jquery", "underscore", "backbone", "slick-slider"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.options.mediaFromM = parseInt(window.app.matchMedia.getBreakpoint("screen-m-min"), 10), this.options.mediaFromL = parseInt(window.app.matchMedia.getBreakpoint("screen-l-min"), 10), this.options.mediaFromXL = parseInt(window.app.matchMedia.getBreakpoint("screen-xl-min"), 10), this.slidesPerView = this.$el.data("slides-per-view"), this.slickSliderOptions = {
                rows: 0,
                adaptiveHeight: !1,
                accessibility: !1,
                dots: !0,
                infinite: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                easing: "ease-in",
                slide: ".slide",
                arrows: !1,
                dotsClass: "slider-dots",
                mobileFirst: !0,
                variableWidth: !1,
                prevArrow: '<span class="slick-prev"></span>',
                nextArrow: '<span class="slick-next"></span>',
                responsive: [{
                    breakpoint: this.options.mediaFromM,
                    settings: {slidesToShow: 2, slidesToScroll: 2}
                }, {
                    breakpoint: this.options.mediaFromL,
                    settings: {arrows: !0, slidesToShow: 2, slidesToScroll: 2}
                }, {
                    breakpoint: this.options.mediaFromXL,
                    settings: {
                        arrows: !0,
                        slidesToShow: this.slidesPerView || 2,
                        slidesToScroll: this.slidesPerView || 2
                    }
                }],
                customPaging: function () {
                    return "<span></span>"
                }
            }, this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.onResize)
        }, render: function () {
            return this.slider = this.$el.slick(this.slickSliderOptions), window.app.eventDispatcher.trigger(window.app.applicationEvents.GENERIC_SLIDER_INITIALIZED), this.$el.parents(".module-generic-teaser").length && (this.$el.on("breakpoint", this.onBreakpoint.bind(this)), this.handleSlickDots(this.$el, this.$(".slider-dots").length)), this
        }, onBreakpoint: function (a, c, d) {
            this.handleSlickDots(c.$slider, b.isNull(c.$dots) ? 0 : 1)
        }, handleSlickDots: function (a, b) {
            b ? a.removeClass("no-slider") : a.addClass("no-slider")
        }, updateSlider: function () {
            this.$el.slick("slickSetOption", null, null, !0)
        }, onResize: function () {
            this.updateSlider()
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/generic-teaser-view", ["jquery", "underscore", "backbone", "app/delayed-initialization", "equal-height"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, b.extend(e.prototype, d), this.delayInitialization()
        }, delayedInitialization: function () {
            this.$teasers = this.$(".teaser"), this.teaserCount = this.$teasers.length, this.setupListeners(), this.render(), this.uncover()
        }, setupListeners: function () {
            this.teaserCount > 1 && (this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.updateTeaserHeights.bind(this)), this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.freeTeaserHeight.bind(this)), this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.GENERIC_SLIDER_INITIALIZED, this.updateTeaserHeights.bind(this)))
        }, render: function () {
            return this.teaserCount > 1 && this.calculateTeaserHeight(), this
        }, calculateTeaserHeight: function () {
            var b, c = this.teaserCount;
            this.$teasers.each(function (d, e) {
                var f = a(e), g = "p > .button-primary, p > .button-secondary, p > .button-tertiary",
                    h = f.find(g).length;
                0 === d ? b = f : 0 === Math.round(f.position().left) ? (b.setEqualHeight(), b = f) : (b = b.add(f), d === c - 1 && b.length > 1 && b.setEqualHeight()), h && b.addClass("sticky-button").find(g).parent().addClass("stick-to-bottom")
            }), this.calculateButtonSpaces()
        }, calculateButtonSpaces: function () {
            b.each(this.$teasers, function (b) {
                var c = a(b), d = c.find(".text"), e = 44, f = c.find(".stick-to-bottom a").outerHeight();
                d.css("paddingBottom", e + f)
            })
        }, updateTeaserHeights: function () {
            b.debounce(this.calculateTeaserHeight(), 100)
        }, freeTeaserHeight: function () {
            this.$teasers.height("auto")
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
});/*!
 * VERSION: 1.20.5
 * DATE: 2018-05-21
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 */
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
    "use strict";
    _gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin", "TweenLite"], function (a, b) {
        var c, d, e, f, g = function () {
            a.call(this, "css"), this._overwriteProps.length = 0, this.setRatio = g.prototype.setRatio
        }, h = _gsScope._gsDefine.globals, i = {}, j = g.prototype = new a("css");
        j.constructor = g, g.version = "1.20.5", g.API = 2, g.defaultTransformPerspective = 0, g.defaultSkewType = "compensated", g.defaultSmoothOrigin = !0, j = "px", g.suffixMap = {
            top: j,
            right: j,
            bottom: j,
            left: j,
            width: j,
            height: j,
            fontSize: j,
            padding: j,
            margin: j,
            perspective: j,
            lineHeight: ""
        };
        var k, l, m, n, o, p, q, r, s = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
            t = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
            u = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, v = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,
            w = /(?:\d|\-|\+|=|#|\.)*/g, x = /opacity *= *([^)]*)/i, y = /opacity:([^;]*)/i,
            z = /alpha\(opacity *=.+?\)/i, A = /^(rgb|hsl)/, B = /([A-Z])/g, C = /-([a-z])/gi,
            D = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, E = function (a, b) {
                return b.toUpperCase()
            }, F = /(?:Left|Right|Width)/i, G = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
            H = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i, I = /,(?=[^\)]*(?:\(|$))/gi, J = /[\s,\(]/i,
            K = Math.PI / 180, L = 180 / Math.PI, M = {}, N = {style: {}}, O = _gsScope.document || {
                createElement: function () {
                    return N
                }
            }, P = function (a, b) {
                return O.createElementNS ? O.createElementNS(b || "http://www.w3.org/1999/xhtml", a) : O.createElement(a)
            }, Q = P("div"), R = P("img"), S = g._internals = {_specialProps: i},
            T = (_gsScope.navigator || {}).userAgent || "", U = function () {
                var a = T.indexOf("Android"), b = P("a");
                return m = T.indexOf("Safari") !== -1 && T.indexOf("Chrome") === -1 && (a === -1 || parseFloat(T.substr(a + 8, 2)) > 3), o = m && parseFloat(T.substr(T.indexOf("Version/") + 8, 2)) < 6, n = T.indexOf("Firefox") !== -1, (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(T) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(T)) && (p = parseFloat(RegExp.$1)), !!b && (b.style.cssText = "top:1px;opacity:.55;", /^0.55/.test(b.style.opacity))
            }(), V = function (a) {
                return x.test("string" == typeof a ? a : (a.currentStyle ? a.currentStyle.filter : a.style.filter) || "") ? parseFloat(RegExp.$1) / 100 : 1
            }, W = function (a) {
                _gsScope.console && console.log(a)
            }, X = "", Y = "", Z = function (a, b) {
                b = b || Q;
                var c, d, e = b.style;
                if (void 0 !== e[a]) return a;
                for (a = a.charAt(0).toUpperCase() + a.substr(1), c = ["O", "Moz", "ms", "Ms", "Webkit"], d = 5; --d > -1 && void 0 === e[c[d] + a];) ;
                return d >= 0 ? (Y = 3 === d ? "ms" : c[d], X = "-" + Y.toLowerCase() + "-", Y + a) : null
            }, $ = ("undefined" != typeof window ? window : O.defaultView || {
                getComputedStyle: function () {
                }
            }).getComputedStyle, _ = g.getStyle = function (a, b, c, d, e) {
                var f;
                return U || "opacity" !== b ? (!d && a.style[b] ? f = a.style[b] : (c = c || $(a)) ? f = c[b] || c.getPropertyValue(b) || c.getPropertyValue(b.replace(B, "-$1").toLowerCase()) : a.currentStyle && (f = a.currentStyle[b]), null == e || f && "none" !== f && "auto" !== f && "auto auto" !== f ? f : e) : V(a)
            }, aa = S.convertToPixels = function (a, c, d, e, f) {
                if ("px" === e || !e && "lineHeight" !== c) return d;
                if ("auto" === e || !d) return 0;
                var h, i, j, k = F.test(c), l = a, m = Q.style, n = d < 0, o = 1 === d;
                if (n && (d = -d), o && (d *= 100), "lineHeight" !== c || e) if ("%" === e && c.indexOf("border") !== -1) h = d / 100 * (k ? a.clientWidth : a.clientHeight); else {
                    if (m.cssText = "border:0 solid red;position:" + _(a, "position") + ";line-height:0;", "%" !== e && l.appendChild && "v" !== e.charAt(0) && "rem" !== e) m[k ? "borderLeftWidth" : "borderTopWidth"] = d + e; else {
                        if (l = a.parentNode || O.body, _(l, "display").indexOf("flex") !== -1 && (m.position = "absolute"), i = l._gsCache, j = b.ticker.frame, i && k && i.time === j) return i.width * d / 100;
                        m[k ? "width" : "height"] = d + e
                    }
                    l.appendChild(Q), h = parseFloat(Q[k ? "offsetWidth" : "offsetHeight"]), l.removeChild(Q), k && "%" === e && g.cacheWidths !== !1 && (i = l._gsCache = l._gsCache || {}, i.time = j, i.width = h / d * 100), 0 !== h || f || (h = aa(a, c, d, e, !0))
                } else i = $(a).lineHeight, a.style.lineHeight = d, h = parseFloat($(a).lineHeight), a.style.lineHeight = i;
                return o && (h /= 100), n ? -h : h
            }, ba = S.calculateOffset = function (a, b, c) {
                if ("absolute" !== _(a, "position", c)) return 0;
                var d = "left" === b ? "Left" : "Top", e = _(a, "margin" + d, c);
                return a["offset" + d] - (aa(a, b, parseFloat(e), e.replace(w, "")) || 0)
            }, ca = function (a, b) {
                var c, d, e, f = {};
                if (b = b || $(a, null)) if (c = b.length) for (; --c > -1;) e = b[c], e.indexOf("-transform") !== -1 && Da !== e || (f[e.replace(C, E)] = b.getPropertyValue(e)); else for (c in b) c.indexOf("Transform") !== -1 && Ca !== c || (f[c] = b[c]); else if (b = a.currentStyle || a.style) for (c in b) "string" == typeof c && void 0 === f[c] && (f[c.replace(C, E)] = b[c]);
                return U || (f.opacity = V(a)), d = Ra(a, b, !1), f.rotation = d.rotation, f.skewX = d.skewX, f.scaleX = d.scaleX, f.scaleY = d.scaleY, f.x = d.x, f.y = d.y, Fa && (f.z = d.z, f.rotationX = d.rotationX, f.rotationY = d.rotationY, f.scaleZ = d.scaleZ), f.filters && delete f.filters, f
            }, da = function (a, b, c, d, e) {
                var f, g, h, i = {}, j = a.style;
                for (g in c) "cssText" !== g && "length" !== g && isNaN(g) && (b[g] !== (f = c[g]) || e && e[g]) && g.indexOf("Origin") === -1 && ("number" != typeof f && "string" != typeof f || (i[g] = "auto" !== f || "left" !== g && "top" !== g ? "" !== f && "auto" !== f && "none" !== f || "string" != typeof b[g] || "" === b[g].replace(v, "") ? f : 0 : ba(a, g), void 0 !== j[g] && (h = new sa(j, g, j[g], h))));
                if (d) for (g in d) "className" !== g && (i[g] = d[g]);
                return {difs: i, firstMPT: h}
            }, ea = {width: ["Left", "Right"], height: ["Top", "Bottom"]},
            fa = ["marginLeft", "marginRight", "marginTop", "marginBottom"], ga = function (a, b, c) {
                if ("svg" === (a.nodeName + "").toLowerCase()) return (c || $(a))[b] || 0;
                if (a.getCTM && Oa(a)) return a.getBBox()[b] || 0;
                var d = parseFloat("width" === b ? a.offsetWidth : a.offsetHeight), e = ea[b], f = e.length;
                for (c = c || $(a, null); --f > -1;) d -= parseFloat(_(a, "padding" + e[f], c, !0)) || 0, d -= parseFloat(_(a, "border" + e[f] + "Width", c, !0)) || 0;
                return d
            }, ha = function (a, b) {
                if ("contain" === a || "auto" === a || "auto auto" === a) return a + " ";
                null != a && "" !== a || (a = "0 0");
                var c, d = a.split(" "), e = a.indexOf("left") !== -1 ? "0%" : a.indexOf("right") !== -1 ? "100%" : d[0],
                    f = a.indexOf("top") !== -1 ? "0%" : a.indexOf("bottom") !== -1 ? "100%" : d[1];
                if (d.length > 3 && !b) {
                    for (d = a.split(", ").join(",").split(","), a = [], c = 0; c < d.length; c++) a.push(ha(d[c]));
                    return a.join(",")
                }
                return null == f ? f = "center" === e ? "50%" : "0" : "center" === f && (f = "50%"), ("center" === e || isNaN(parseFloat(e)) && (e + "").indexOf("=") === -1) && (e = "50%"), a = e + " " + f + (d.length > 2 ? " " + d[2] : ""), b && (b.oxp = e.indexOf("%") !== -1, b.oyp = f.indexOf("%") !== -1, b.oxr = "=" === e.charAt(1), b.oyr = "=" === f.charAt(1), b.ox = parseFloat(e.replace(v, "")), b.oy = parseFloat(f.replace(v, "")), b.v = a), b || a
            }, ia = function (a, b) {
                return "function" == typeof a && (a = a(r, q)), "string" == typeof a && "=" === a.charAt(1) ? parseInt(a.charAt(0) + "1", 10) * parseFloat(a.substr(2)) : parseFloat(a) - parseFloat(b) || 0
            }, ja = function (a, b) {
                return "function" == typeof a && (a = a(r, q)), null == a ? b : "string" == typeof a && "=" === a.charAt(1) ? parseInt(a.charAt(0) + "1", 10) * parseFloat(a.substr(2)) + b : parseFloat(a) || 0
            }, ka = function (a, b, c, d) {
                var e, f, g, h, i, j = 1e-6;
                return "function" == typeof a && (a = a(r, q)), null == a ? h = b : "number" == typeof a ? h = a : (e = 360, f = a.split("_"), i = "=" === a.charAt(1), g = (i ? parseInt(a.charAt(0) + "1", 10) * parseFloat(f[0].substr(2)) : parseFloat(f[0])) * (a.indexOf("rad") === -1 ? 1 : L) - (i ? 0 : b), f.length && (d && (d[c] = b + g), a.indexOf("short") !== -1 && (g %= e, g !== g % (e / 2) && (g = g < 0 ? g + e : g - e)), a.indexOf("_cw") !== -1 && g < 0 ? g = (g + 9999999999 * e) % e - (g / e | 0) * e : a.indexOf("ccw") !== -1 && g > 0 && (g = (g - 9999999999 * e) % e - (g / e | 0) * e)), h = b + g), h < j && h > -j && (h = 0), h
            }, la = {
                aqua: [0, 255, 255],
                lime: [0, 255, 0],
                silver: [192, 192, 192],
                black: [0, 0, 0],
                maroon: [128, 0, 0],
                teal: [0, 128, 128],
                blue: [0, 0, 255],
                navy: [0, 0, 128],
                white: [255, 255, 255],
                fuchsia: [255, 0, 255],
                olive: [128, 128, 0],
                yellow: [255, 255, 0],
                orange: [255, 165, 0],
                gray: [128, 128, 128],
                purple: [128, 0, 128],
                green: [0, 128, 0],
                red: [255, 0, 0],
                pink: [255, 192, 203],
                cyan: [0, 255, 255],
                transparent: [255, 255, 255, 0]
            }, ma = function (a, b, c) {
                return a = a < 0 ? a + 1 : a > 1 ? a - 1 : a, 255 * (6 * a < 1 ? b + (c - b) * a * 6 : a < .5 ? c : 3 * a < 2 ? b + (c - b) * (2 / 3 - a) * 6 : b) + .5 | 0
            }, na = g.parseColor = function (a, b) {
                var c, d, e, f, g, h, i, j, k, l, m;
                if (a) if ("number" == typeof a) c = [a >> 16, a >> 8 & 255, 255 & a]; else {
                    if ("," === a.charAt(a.length - 1) && (a = a.substr(0, a.length - 1)), la[a]) c = la[a]; else if ("#" === a.charAt(0)) 4 === a.length && (d = a.charAt(1), e = a.charAt(2), f = a.charAt(3), a = "#" + d + d + e + e + f + f), a = parseInt(a.substr(1), 16), c = [a >> 16, a >> 8 & 255, 255 & a]; else if ("hsl" === a.substr(0, 3)) if (c = m = a.match(s), b) {
                        if (a.indexOf("=") !== -1) return a.match(t)
                    } else g = Number(c[0]) % 360 / 360, h = Number(c[1]) / 100, i = Number(c[2]) / 100, e = i <= .5 ? i * (h + 1) : i + h - i * h, d = 2 * i - e, c.length > 3 && (c[3] = Number(c[3])), c[0] = ma(g + 1 / 3, d, e), c[1] = ma(g, d, e), c[2] = ma(g - 1 / 3, d, e); else c = a.match(s) || la.transparent;
                    c[0] = Number(c[0]), c[1] = Number(c[1]), c[2] = Number(c[2]), c.length > 3 && (c[3] = Number(c[3]))
                } else c = la.black;
                return b && !m && (d = c[0] / 255, e = c[1] / 255, f = c[2] / 255, j = Math.max(d, e, f), k = Math.min(d, e, f), i = (j + k) / 2, j === k ? g = h = 0 : (l = j - k, h = i > .5 ? l / (2 - j - k) : l / (j + k), g = j === d ? (e - f) / l + (e < f ? 6 : 0) : j === e ? (f - d) / l + 2 : (d - e) / l + 4, g *= 60), c[0] = g + .5 | 0, c[1] = 100 * h + .5 | 0, c[2] = 100 * i + .5 | 0), c
            }, oa = function (a, b) {
                var c, d, e, f = a.match(pa) || [], g = 0, h = "";
                if (!f.length) return a;
                for (c = 0; c < f.length; c++) d = f[c], e = a.substr(g, a.indexOf(d, g) - g), g += e.length + d.length, d = na(d, b), 3 === d.length && d.push(1), h += e + (b ? "hsla(" + d[0] + "," + d[1] + "%," + d[2] + "%," + d[3] : "rgba(" + d.join(",")) + ")";
                return h + a.substr(g)
            }, pa = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";
        for (j in la) pa += "|" + j + "\\b";
        pa = new RegExp(pa + ")", "gi"), g.colorStringFilter = function (a) {
            var b, c = a[0] + " " + a[1];
            pa.test(c) && (b = c.indexOf("hsl(") !== -1 || c.indexOf("hsla(") !== -1, a[0] = oa(a[0], b), a[1] = oa(a[1], b)), pa.lastIndex = 0
        }, b.defaultStringFilter || (b.defaultStringFilter = g.colorStringFilter);
        var qa = function (a, b, c, d) {
            if (null == a) return function (a) {
                return a
            };
            var e, f = b ? (a.match(pa) || [""])[0] : "", g = a.split(f).join("").match(u) || [],
                h = a.substr(0, a.indexOf(g[0])), i = ")" === a.charAt(a.length - 1) ? ")" : "",
                j = a.indexOf(" ") !== -1 ? " " : ",", k = g.length, l = k > 0 ? g[0].replace(s, "") : "";
            return k ? e = b ? function (a) {
                var b, m, n, o;
                if ("number" == typeof a) a += l; else if (d && I.test(a)) {
                    for (o = a.replace(I, "|").split("|"), n = 0; n < o.length; n++) o[n] = e(o[n]);
                    return o.join(",")
                }
                if (b = (a.match(pa) || [f])[0], m = a.split(b).join("").match(u) || [], n = m.length, k > n--) for (; ++n < k;) m[n] = c ? m[(n - 1) / 2 | 0] : g[n];
                return h + m.join(j) + j + b + i + (a.indexOf("inset") !== -1 ? " inset" : "")
            } : function (a) {
                var b, f, m;
                if ("number" == typeof a) a += l; else if (d && I.test(a)) {
                    for (f = a.replace(I, "|").split("|"), m = 0; m < f.length; m++) f[m] = e(f[m]);
                    return f.join(",")
                }
                if (b = a.match(u) || [], m = b.length, k > m--) for (; ++m < k;) b[m] = c ? b[(m - 1) / 2 | 0] : g[m];
                return h + b.join(j) + i
            } : function (a) {
                return a
            }
        }, ra = function (a) {
            return a = a.split(","), function (b, c, d, e, f, g, h) {
                var i, j = (c + "").split(" ");
                for (h = {}, i = 0; i < 4; i++) h[a[i]] = j[i] = j[i] || j[(i - 1) / 2 >> 0];
                return e.parse(b, h, f, g)
            }
        }, sa = (S._setPluginRatio = function (a) {
            this.plugin.setRatio(a);
            for (var b, c, d, e, f, g = this.data, h = g.proxy, i = g.firstMPT, j = 1e-6; i;) b = h[i.v], i.r ? b = i.r(b) : b < j && b > -j && (b = 0), i.t[i.p] = b, i = i._next;
            if (g.autoRotate && (g.autoRotate.rotation = g.mod ? g.mod.call(this._tween, h.rotation, this.t, this._tween) : h.rotation), 1 === a || 0 === a) for (i = g.firstMPT, f = 1 === a ? "e" : "b"; i;) {
                if (c = i.t, c.type) {
                    if (1 === c.type) {
                        for (e = c.xs0 + c.s + c.xs1, d = 1; d < c.l; d++) e += c["xn" + d] + c["xs" + (d + 1)];
                        c[f] = e
                    }
                } else c[f] = c.s + c.xs0;
                i = i._next
            }
        }, function (a, b, c, d, e) {
            this.t = a, this.p = b, this.v = c, this.r = e, d && (d._prev = this, this._next = d)
        }), ta = (S._parseToProxy = function (a, b, c, d, e, f) {
            var g, h, i, j, k, l = d, m = {}, n = {}, o = c._transform, p = M;
            for (c._transform = null, M = b, d = k = c.parse(a, b, d, e), M = p, f && (c._transform = o, l && (l._prev = null, l._prev && (l._prev._next = null))); d && d !== l;) {
                if (d.type <= 1 && (h = d.p, n[h] = d.s + d.c, m[h] = d.s, f || (j = new sa(d, "s", h, j, d.r), d.c = 0), 1 === d.type)) for (g = d.l; --g > 0;) i = "xn" + g, h = d.p + "_" + i, n[h] = d.data[i], m[h] = d[i], f || (j = new sa(d, i, h, j, d.rxp[i]));
                d = d._next
            }
            return {proxy: m, end: n, firstMPT: j, pt: k}
        }, S.CSSPropTween = function (a, b, d, e, g, h, i, j, k, l, m) {
            this.t = a, this.p = b, this.s = d, this.c = e, this.n = i || b, a instanceof ta || f.push(this.n), this.r = j ? "function" == typeof j ? j : Math.round : j, this.type = h || 0, k && (this.pr = k, c = !0), this.b = void 0 === l ? d : l, this.e = void 0 === m ? d + e : m, g && (this._next = g, g._prev = this)
        }), ua = function (a, b, c, d, e, f) {
            var g = new ta(a, b, c, d - c, e, -1, f);
            return g.b = c, g.e = g.xs0 = d, g
        }, va = g.parseComplex = function (a, b, c, d, e, f, h, i, j, l) {
            c = c || f || "", "function" == typeof d && (d = d(r, q)), h = new ta(a, b, 0, 0, h, l ? 2 : 1, null, !1, i, c, d), d += "", e && pa.test(d + c) && (d = [c, d], g.colorStringFilter(d), c = d[0], d = d[1]);
            var m, n, o, p, u, v, w, x, y, z, A, B, C, D = c.split(", ").join(",").split(" "),
                E = d.split(", ").join(",").split(" "), F = D.length, G = k !== !1;
            for (d.indexOf(",") === -1 && c.indexOf(",") === -1 || ((d + c).indexOf("rgb") !== -1 || (d + c).indexOf("hsl") !== -1 ? (D = D.join(" ").replace(I, ", ").split(" "), E = E.join(" ").replace(I, ", ").split(" ")) : (D = D.join(" ").split(",").join(", ").split(" "), E = E.join(" ").split(",").join(", ").split(" ")), F = D.length), F !== E.length && (D = (f || "").split(" "), F = D.length), h.plugin = j, h.setRatio = l, pa.lastIndex = 0, m = 0; m < F; m++) if (p = D[m], u = E[m] + "", x = parseFloat(p), x || 0 === x) h.appendXtra("", x, ia(u, x), u.replace(t, ""), !(!G || u.indexOf("px") === -1) && Math.round, !0); else if (e && pa.test(p)) B = u.indexOf(")") + 1, B = ")" + (B ? u.substr(B) : ""), C = u.indexOf("hsl") !== -1 && U, z = u, p = na(p, C), u = na(u, C), y = p.length + u.length > 6, y && !U && 0 === u[3] ? (h["xs" + h.l] += h.l ? " transparent" : "transparent", h.e = h.e.split(E[m]).join("transparent")) : (U || (y = !1), C ? h.appendXtra(z.substr(0, z.indexOf("hsl")) + (y ? "hsla(" : "hsl("), p[0], ia(u[0], p[0]), ",", !1, !0).appendXtra("", p[1], ia(u[1], p[1]), "%,", !1).appendXtra("", p[2], ia(u[2], p[2]), y ? "%," : "%" + B, !1) : h.appendXtra(z.substr(0, z.indexOf("rgb")) + (y ? "rgba(" : "rgb("), p[0], u[0] - p[0], ",", Math.round, !0).appendXtra("", p[1], u[1] - p[1], ",", Math.round).appendXtra("", p[2], u[2] - p[2], y ? "," : B, Math.round), y && (p = p.length < 4 ? 1 : p[3], h.appendXtra("", p, (u.length < 4 ? 1 : u[3]) - p, B, !1))), pa.lastIndex = 0; else if (v = p.match(s)) {
                if (w = u.match(t), !w || w.length !== v.length) return h;
                for (o = 0, n = 0; n < v.length; n++) A = v[n], z = p.indexOf(A, o), h.appendXtra(p.substr(o, z - o), Number(A), ia(w[n], A), "", !(!G || "px" !== p.substr(z + A.length, 2)) && Math.round, 0 === n), o = z + A.length;
                h["xs" + h.l] += p.substr(o)
            } else h["xs" + h.l] += h.l || h["xs" + h.l] ? " " + u : u;
            if (d.indexOf("=") !== -1 && h.data) {
                for (B = h.xs0 + h.data.s, m = 1; m < h.l; m++) B += h["xs" + m] + h.data["xn" + m];
                h.e = B + h["xs" + m]
            }
            return h.l || (h.type = -1, h.xs0 = h.e), h.xfirst || h
        }, wa = 9;
        for (j = ta.prototype, j.l = j.pr = 0; --wa > 0;) j["xn" + wa] = 0, j["xs" + wa] = "";
        j.xs0 = "", j._next = j._prev = j.xfirst = j.data = j.plugin = j.setRatio = j.rxp = null, j.appendXtra = function (a, b, c, d, e, f) {
            var g = this, h = g.l;
            return g["xs" + h] += f && (h || g["xs" + h]) ? " " + a : a || "", c || 0 === h || g.plugin ? (g.l++, g.type = g.setRatio ? 2 : 1, g["xs" + g.l] = d || "", h > 0 ? (g.data["xn" + h] = b + c, g.rxp["xn" + h] = e, g["xn" + h] = b, g.plugin || (g.xfirst = new ta(g, "xn" + h, b, c, g.xfirst || g, 0, g.n, e, g.pr), g.xfirst.xs0 = 0), g) : (g.data = {s: b + c}, g.rxp = {}, g.s = b, g.c = c, g.r = e, g)) : (g["xs" + h] += b + (d || ""), g)
        };
        var xa = function (a, b) {
            b = b || {}, this.p = b.prefix ? Z(a) || a : a, i[a] = i[this.p] = this, this.format = b.formatter || qa(b.defaultValue, b.color, b.collapsible, b.multi), b.parser && (this.parse = b.parser), this.clrs = b.color, this.multi = b.multi, this.keyword = b.keyword, this.dflt = b.defaultValue, this.pr = b.priority || 0
        }, ya = S._registerComplexSpecialProp = function (a, b, c) {
            "object" != typeof b && (b = {parser: c});
            var d, e, f = a.split(","), g = b.defaultValue;
            for (c = c || [g], d = 0; d < f.length; d++) b.prefix = 0 === d && b.prefix, b.defaultValue = c[d] || g, e = new xa(f[d], b)
        }, za = S._registerPluginProp = function (a) {
            if (!i[a]) {
                var b = a.charAt(0).toUpperCase() + a.substr(1) + "Plugin";
                ya(a, {
                    parser: function (a, c, d, e, f, g, j) {
                        var k = h.com.greensock.plugins[b];
                        return k ? (k._cssRegister(), i[d].parse(a, c, d, e, f, g, j)) : (W("Error: " + b + " js file not loaded."), f)
                    }
                })
            }
        };
        j = xa.prototype, j.parseComplex = function (a, b, c, d, e, f) {
            var g, h, i, j, k, l, m = this.keyword;
            if (this.multi && (I.test(c) || I.test(b) ? (h = b.replace(I, "|").split("|"), i = c.replace(I, "|").split("|")) : m && (h = [b], i = [c])), i) {
                for (j = i.length > h.length ? i.length : h.length, g = 0; g < j; g++) b = h[g] = h[g] || this.dflt, c = i[g] = i[g] || this.dflt, m && (k = b.indexOf(m), l = c.indexOf(m), k !== l && (l === -1 ? h[g] = h[g].split(m).join("") : k === -1 && (h[g] += " " + m)));
                b = h.join(", "), c = i.join(", ")
            }
            return va(a, this.p, b, c, this.clrs, this.dflt, d, this.pr, e, f)
        }, j.parse = function (a, b, c, d, f, g, h) {
            return this.parseComplex(a.style, this.format(_(a, this.p, e, !1, this.dflt)), this.format(b), f, g)
        }, g.registerSpecialProp = function (a, b, c) {
            ya(a, {
                parser: function (a, d, e, f, g, h, i) {
                    var j = new ta(a, e, 0, 0, g, 2, e, !1, c);
                    return j.plugin = h, j.setRatio = b(a, d, f._tween, e), j
                }, priority: c
            })
        }, g.useSVGTransformAttr = !0;
        var Aa,
            Ba = "scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),
            Ca = Z("transform"), Da = X + "transform", Ea = Z("transformOrigin"), Fa = null !== Z("perspective"),
            Ga = S.Transform = function () {
                this.perspective = parseFloat(g.defaultTransformPerspective) || 0, this.force3D = !(g.defaultForce3D === !1 || !Fa) && (g.defaultForce3D || "auto")
            }, Ha = _gsScope.SVGElement, Ia = function (a, b, c) {
                var d, e = O.createElementNS("http://www.w3.org/2000/svg", a), f = /([a-z])([A-Z])/g;
                for (d in c) e.setAttributeNS(null, d.replace(f, "$1-$2").toLowerCase(), c[d]);
                return b.appendChild(e), e
            }, Ja = O.documentElement || {}, Ka = function () {
                var a, b, c, d = p || /Android/i.test(T) && !_gsScope.chrome;
                return O.createElementNS && !d && (a = Ia("svg", Ja), b = Ia("rect", a, {
                    width: 100,
                    height: 50,
                    x: 100
                }), c = b.getBoundingClientRect().width, b.style[Ea] = "50% 50%", b.style[Ca] = "scaleX(0.5)", d = c === b.getBoundingClientRect().width && !(n && Fa), Ja.removeChild(a)), d
            }(), La = function (a, b, c, d, e, f) {
                var h, i, j, k, l, m, n, o, p, q, r, s, t, u, v = a._gsTransform, w = Qa(a, !0);
                v && (t = v.xOrigin, u = v.yOrigin), (!d || (h = d.split(" ")).length < 2) && (n = a.getBBox(), 0 === n.x && 0 === n.y && n.width + n.height === 0 && (n = {
                    x: parseFloat(a.hasAttribute("x") ? a.getAttribute("x") : a.hasAttribute("cx") ? a.getAttribute("cx") : 0) || 0,
                    y: parseFloat(a.hasAttribute("y") ? a.getAttribute("y") : a.hasAttribute("cy") ? a.getAttribute("cy") : 0) || 0,
                    width: 0,
                    height: 0
                }), b = ha(b).split(" "), h = [(b[0].indexOf("%") !== -1 ? parseFloat(b[0]) / 100 * n.width : parseFloat(b[0])) + n.x, (b[1].indexOf("%") !== -1 ? parseFloat(b[1]) / 100 * n.height : parseFloat(b[1])) + n.y]), c.xOrigin = k = parseFloat(h[0]), c.yOrigin = l = parseFloat(h[1]), d && w !== Pa && (m = w[0], n = w[1], o = w[2], p = w[3], q = w[4], r = w[5], s = m * p - n * o, s && (i = k * (p / s) + l * (-o / s) + (o * r - p * q) / s, j = k * (-n / s) + l * (m / s) - (m * r - n * q) / s, k = c.xOrigin = h[0] = i, l = c.yOrigin = h[1] = j)), v && (f && (c.xOffset = v.xOffset, c.yOffset = v.yOffset, v = c), e || e !== !1 && g.defaultSmoothOrigin !== !1 ? (i = k - t, j = l - u, v.xOffset += i * w[0] + j * w[2] - i, v.yOffset += i * w[1] + j * w[3] - j) : v.xOffset = v.yOffset = 0), f || a.setAttribute("data-svg-origin", h.join(" "))
            }, Ma = function (a) {
                var b,
                    c = P("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
                    d = this.parentNode, e = this.nextSibling, f = this.style.cssText;
                if (Ja.appendChild(c), c.appendChild(this), this.style.display = "block", a) try {
                    b = this.getBBox(), this._originalGetBBox = this.getBBox, this.getBBox = Ma
                } catch (a) {
                } else this._originalGetBBox && (b = this._originalGetBBox());
                return e ? d.insertBefore(this, e) : d.appendChild(this), Ja.removeChild(c), this.style.cssText = f, b
            }, Na = function (a) {
                try {
                    return a.getBBox()
                } catch (b) {
                    return Ma.call(a, !0)
                }
            }, Oa = function (a) {
                return !(!Ha || !a.getCTM || a.parentNode && !a.ownerSVGElement || !Na(a))
            }, Pa = [1, 0, 0, 1, 0, 0], Qa = function (a, b) {
                var c, d, e, f, g, h, i = a._gsTransform || new Ga, j = 1e5, k = a.style;
                if (Ca ? d = _(a, Da, null, !0) : a.currentStyle && (d = a.currentStyle.filter.match(G), d = d && 4 === d.length ? [d[0].substr(4), Number(d[2].substr(4)), Number(d[1].substr(4)), d[3].substr(4), i.x || 0, i.y || 0].join(",") : ""), c = !d || "none" === d || "matrix(1, 0, 0, 1, 0, 0)" === d, !Ca || !(h = !$(a) || "none" === $(a).display) && a.parentNode || (h && (f = k.display, k.display = "block"), a.parentNode || (g = 1, Ja.appendChild(a)), d = _(a, Da, null, !0), c = !d || "none" === d || "matrix(1, 0, 0, 1, 0, 0)" === d, f ? k.display = f : h && Va(k, "display"), g && Ja.removeChild(a)), (i.svg || a.getCTM && Oa(a)) && (c && (k[Ca] + "").indexOf("matrix") !== -1 && (d = k[Ca], c = 0), e = a.getAttribute("transform"), c && e && (e = a.transform.baseVal.consolidate().matrix, d = "matrix(" + e.a + "," + e.b + "," + e.c + "," + e.d + "," + e.e + "," + e.f + ")", c = 0)), c) return Pa;
                for (e = (d || "").match(s) || [], wa = e.length; --wa > -1;) f = Number(e[wa]), e[wa] = (g = f - (f |= 0)) ? (g * j + (g < 0 ? -.5 : .5) | 0) / j + f : f;
                return b && e.length > 6 ? [e[0], e[1], e[4], e[5], e[12], e[13]] : e
            }, Ra = S.getTransform = function (a, c, d, e) {
                if (a._gsTransform && d && !e) return a._gsTransform;
                var f, h, i, j, k, l, m = d ? a._gsTransform || new Ga : new Ga, n = m.scaleX < 0, o = 2e-5, p = 1e5,
                    q = Fa ? parseFloat(_(a, Ea, c, !1, "0 0 0").split(" ")[2]) || m.zOrigin || 0 : 0,
                    r = parseFloat(g.defaultTransformPerspective) || 0;
                if (m.svg = !(!a.getCTM || !Oa(a)), m.svg && (La(a, _(a, Ea, c, !1, "50% 50%") + "", m, a.getAttribute("data-svg-origin")), Aa = g.useSVGTransformAttr || Ka), f = Qa(a), f !== Pa) {
                    if (16 === f.length) {
                        var s, t, u, v, w, x = f[0], y = f[1], z = f[2], A = f[3], B = f[4], C = f[5], D = f[6], E = f[7],
                            F = f[8], G = f[9], H = f[10], I = f[12], J = f[13], K = f[14], M = f[11], N = Math.atan2(D, H);
                        m.zOrigin && (K = -m.zOrigin, I = F * K - f[12], J = G * K - f[13], K = H * K + m.zOrigin - f[14]), m.rotationX = N * L, N && (v = Math.cos(-N), w = Math.sin(-N), s = B * v + F * w, t = C * v + G * w, u = D * v + H * w, F = B * -w + F * v, G = C * -w + G * v, H = D * -w + H * v, M = E * -w + M * v, B = s, C = t, D = u), N = Math.atan2(-z, H), m.rotationY = N * L, N && (v = Math.cos(-N), w = Math.sin(-N), s = x * v - F * w, t = y * v - G * w, u = z * v - H * w, G = y * w + G * v, H = z * w + H * v, M = A * w + M * v, x = s, y = t, z = u), N = Math.atan2(y, x), m.rotation = N * L, N && (v = Math.cos(N), w = Math.sin(N), s = x * v + y * w, t = B * v + C * w, u = F * v + G * w, y = y * v - x * w, C = C * v - B * w, G = G * v - F * w, x = s, B = t, F = u), m.rotationX && Math.abs(m.rotationX) + Math.abs(m.rotation) > 359.9 && (m.rotationX = m.rotation = 0, m.rotationY = 180 - m.rotationY), N = Math.atan2(B, C), m.scaleX = (Math.sqrt(x * x + y * y + z * z) * p + .5 | 0) / p, m.scaleY = (Math.sqrt(C * C + D * D) * p + .5 | 0) / p, m.scaleZ = (Math.sqrt(F * F + G * G + H * H) * p + .5 | 0) / p, x /= m.scaleX, B /= m.scaleY, y /= m.scaleX, C /= m.scaleY, Math.abs(N) > o ? (m.skewX = N * L, B = 0, "simple" !== m.skewType && (m.scaleY *= 1 / Math.cos(N))) : m.skewX = 0, m.perspective = M ? 1 / (M < 0 ? -M : M) : 0, m.x = I, m.y = J, m.z = K, m.svg && (m.x -= m.xOrigin - (m.xOrigin * x - m.yOrigin * B), m.y -= m.yOrigin - (m.yOrigin * y - m.xOrigin * C))
                    } else if (!Fa || e || !f.length || m.x !== f[4] || m.y !== f[5] || !m.rotationX && !m.rotationY) {
                        var O = f.length >= 6, P = O ? f[0] : 1, Q = f[1] || 0, R = f[2] || 0, S = O ? f[3] : 1;
                        m.x = f[4] || 0, m.y = f[5] || 0, i = Math.sqrt(P * P + Q * Q), j = Math.sqrt(S * S + R * R), k = P || Q ? Math.atan2(Q, P) * L : m.rotation || 0, l = R || S ? Math.atan2(R, S) * L + k : m.skewX || 0, m.scaleX = i, m.scaleY = j, m.rotation = k, m.skewX = l, Fa && (m.rotationX = m.rotationY = m.z = 0, m.perspective = r, m.scaleZ = 1), m.svg && (m.x -= m.xOrigin - (m.xOrigin * P + m.yOrigin * R), m.y -= m.yOrigin - (m.xOrigin * Q + m.yOrigin * S))
                    }
                    Math.abs(m.skewX) > 90 && Math.abs(m.skewX) < 270 && (n ? (m.scaleX *= -1, m.skewX += m.rotation <= 0 ? 180 : -180, m.rotation += m.rotation <= 0 ? 180 : -180) : (m.scaleY *= -1, m.skewX += m.skewX <= 0 ? 180 : -180)), m.zOrigin = q;
                    for (h in m) m[h] < o && m[h] > -o && (m[h] = 0)
                }
                return d && (a._gsTransform = m, m.svg && (Aa && a.style[Ca] ? b.delayedCall(.001, function () {
                    Va(a.style, Ca)
                }) : !Aa && a.getAttribute("transform") && b.delayedCall(.001, function () {
                    a.removeAttribute("transform")
                }))), m
            }, Sa = function (a) {
                var b, c, d = this.data, e = -d.rotation * K, f = e + d.skewX * K, g = 1e5,
                    h = (Math.cos(e) * d.scaleX * g | 0) / g, i = (Math.sin(e) * d.scaleX * g | 0) / g,
                    j = (Math.sin(f) * -d.scaleY * g | 0) / g, k = (Math.cos(f) * d.scaleY * g | 0) / g, l = this.t.style,
                    m = this.t.currentStyle;
                if (m) {
                    c = i, i = -j, j = -c, b = m.filter, l.filter = "";
                    var n, o, q = this.t.offsetWidth, r = this.t.offsetHeight, s = "absolute" !== m.position,
                        t = "progid:DXImageTransform.Microsoft.Matrix(M11=" + h + ", M12=" + i + ", M21=" + j + ", M22=" + k,
                        u = d.x + q * d.xPercent / 100, v = d.y + r * d.yPercent / 100;
                    if (null != d.ox && (n = (d.oxp ? q * d.ox * .01 : d.ox) - q / 2, o = (d.oyp ? r * d.oy * .01 : d.oy) - r / 2, u += n - (n * h + o * i), v += o - (n * j + o * k)), s ? (n = q / 2, o = r / 2, t += ", Dx=" + (n - (n * h + o * i) + u) + ", Dy=" + (o - (n * j + o * k) + v) + ")") : t += ", sizingMethod='auto expand')", b.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1 ? l.filter = b.replace(H, t) : l.filter = t + " " + b, 0 !== a && 1 !== a || 1 === h && 0 === i && 0 === j && 1 === k && (s && t.indexOf("Dx=0, Dy=0") === -1 || x.test(b) && 100 !== parseFloat(RegExp.$1) || b.indexOf(b.indexOf("Alpha")) === -1 && l.removeAttribute("filter")), !s) {
                        var y, z, A, B = p < 8 ? 1 : -1;
                        for (n = d.ieOffsetX || 0, o = d.ieOffsetY || 0, d.ieOffsetX = Math.round((q - ((h < 0 ? -h : h) * q + (i < 0 ? -i : i) * r)) / 2 + u), d.ieOffsetY = Math.round((r - ((k < 0 ? -k : k) * r + (j < 0 ? -j : j) * q)) / 2 + v), wa = 0; wa < 4; wa++) z = fa[wa], y = m[z], c = y.indexOf("px") !== -1 ? parseFloat(y) : aa(this.t, z, parseFloat(y), y.replace(w, "")) || 0, A = c !== d[z] ? wa < 2 ? -d.ieOffsetX : -d.ieOffsetY : wa < 2 ? n - d.ieOffsetX : o - d.ieOffsetY, l[z] = (d[z] = Math.round(c - A * (0 === wa || 2 === wa ? 1 : B))) + "px"
                    }
                }
            }, Ta = S.set3DTransformRatio = S.setTransformRatio = function (a) {
                var b, c, d, e, f, g, h, i, j, k, l, m, o, p, q, r, s, t, u, v, w, x, y, z = this.data, A = this.t.style,
                    B = z.rotation, C = z.rotationX, D = z.rotationY, E = z.scaleX, F = z.scaleY, G = z.scaleZ, H = z.x,
                    I = z.y, J = z.z, L = z.svg, M = z.perspective, N = z.force3D, O = z.skewY, P = z.skewX;
                if (O && (P += O, B += O), ((1 === a || 0 === a) && "auto" === N && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime) || !N) && !J && !M && !D && !C && 1 === G || Aa && L || !Fa) return void (B || P || L ? (B *= K, x = P * K, y = 1e5, c = Math.cos(B) * E, f = Math.sin(B) * E, d = Math.sin(B - x) * -F, g = Math.cos(B - x) * F, x && "simple" === z.skewType && (b = Math.tan(x - O * K), b = Math.sqrt(1 + b * b), d *= b, g *= b, O && (b = Math.tan(O * K), b = Math.sqrt(1 + b * b), c *= b, f *= b)), L && (H += z.xOrigin - (z.xOrigin * c + z.yOrigin * d) + z.xOffset, I += z.yOrigin - (z.xOrigin * f + z.yOrigin * g) + z.yOffset, Aa && (z.xPercent || z.yPercent) && (q = this.t.getBBox(), H += .01 * z.xPercent * q.width, I += .01 * z.yPercent * q.height), q = 1e-6, H < q && H > -q && (H = 0), I < q && I > -q && (I = 0)), u = (c * y | 0) / y + "," + (f * y | 0) / y + "," + (d * y | 0) / y + "," + (g * y | 0) / y + "," + H + "," + I + ")", L && Aa ? this.t.setAttribute("transform", "matrix(" + u) : A[Ca] = (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix(" : "matrix(") + u) : A[Ca] = (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix(" : "matrix(") + E + ",0,0," + F + "," + H + "," + I + ")");
                if (n && (q = 1e-4, E < q && E > -q && (E = G = 2e-5), F < q && F > -q && (F = G = 2e-5), !M || z.z || z.rotationX || z.rotationY || (M = 0)), B || P) B *= K, r = c = Math.cos(B), s = f = Math.sin(B), P && (B -= P * K, r = Math.cos(B), s = Math.sin(B), "simple" === z.skewType && (b = Math.tan((P - O) * K), b = Math.sqrt(1 + b * b), r *= b, s *= b, z.skewY && (b = Math.tan(O * K), b = Math.sqrt(1 + b * b), c *= b, f *= b))), d = -s, g = r; else {
                    if (!(D || C || 1 !== G || M || L)) return void (A[Ca] = (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) translate3d(" : "translate3d(") + H + "px," + I + "px," + J + "px)" + (1 !== E || 1 !== F ? " scale(" + E + "," + F + ")" : ""));
                    c = g = 1, d = f = 0
                }
                k = 1, e = h = i = j = l = m = 0, o = M ? -1 / M : 0, p = z.zOrigin, q = 1e-6, v = ",", w = "0", B = D * K, B && (r = Math.cos(B), s = Math.sin(B), i = -s, l = o * -s, e = c * s, h = f * s, k = r, o *= r, c *= r, f *= r), B = C * K, B && (r = Math.cos(B), s = Math.sin(B), b = d * r + e * s, t = g * r + h * s, j = k * s, m = o * s, e = d * -s + e * r, h = g * -s + h * r, k *= r, o *= r, d = b, g = t), 1 !== G && (e *= G, h *= G, k *= G, o *= G), 1 !== F && (d *= F, g *= F, j *= F, m *= F), 1 !== E && (c *= E, f *= E, i *= E, l *= E), (p || L) && (p && (H += e * -p, I += h * -p, J += k * -p + p), L && (H += z.xOrigin - (z.xOrigin * c + z.yOrigin * d) + z.xOffset, I += z.yOrigin - (z.xOrigin * f + z.yOrigin * g) + z.yOffset), H < q && H > -q && (H = w), I < q && I > -q && (I = w), J < q && J > -q && (J = 0)), u = z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix3d(" : "matrix3d(", u += (c < q && c > -q ? w : c) + v + (f < q && f > -q ? w : f) + v + (i < q && i > -q ? w : i), u += v + (l < q && l > -q ? w : l) + v + (d < q && d > -q ? w : d) + v + (g < q && g > -q ? w : g), C || D || 1 !== G ? (u += v + (j < q && j > -q ? w : j) + v + (m < q && m > -q ? w : m) + v + (e < q && e > -q ? w : e), u += v + (h < q && h > -q ? w : h) + v + (k < q && k > -q ? w : k) + v + (o < q && o > -q ? w : o) + v) : u += ",0,0,0,0,1,0,", u += H + v + I + v + J + v + (M ? 1 + -J / M : 1) + ")", A[Ca] = u
            };
        j = Ga.prototype, j.x = j.y = j.z = j.skewX = j.skewY = j.rotation = j.rotationX = j.rotationY = j.zOrigin = j.xPercent = j.yPercent = j.xOffset = j.yOffset = 0, j.scaleX = j.scaleY = j.scaleZ = 1, ya("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {
            parser: function (a, b, c, d, f, h, i) {
                if (d._lastParsedTransform === i) return f;
                d._lastParsedTransform = i;
                var j, k = i.scale && "function" == typeof i.scale ? i.scale : 0;
                "function" == typeof i[c] && (j = i[c], i[c] = b), k && (i.scale = k(r, a));
                var l, m, n, o, p, s, t, u, v, w = a._gsTransform, x = a.style, y = 1e-6, z = Ba.length, A = i, B = {},
                    C = "transformOrigin", D = Ra(a, e, !0, A.parseTransform),
                    E = A.transform && ("function" == typeof A.transform ? A.transform(r, q) : A.transform);
                if (D.skewType = A.skewType || D.skewType || g.defaultSkewType, d._transform = D, E && "string" == typeof E && Ca) m = Q.style, m[Ca] = E, m.display = "block", m.position = "absolute", E.indexOf("%") !== -1 && (m.width = _(a, "width"), m.height = _(a, "height")), O.body.appendChild(Q), l = Ra(Q, null, !1), "simple" === D.skewType && (l.scaleY *= Math.cos(l.skewX * K)), D.svg && (s = D.xOrigin, t = D.yOrigin, l.x -= D.xOffset, l.y -= D.yOffset, (A.transformOrigin || A.svgOrigin) && (E = {}, La(a, ha(A.transformOrigin), E, A.svgOrigin, A.smoothOrigin, !0), s = E.xOrigin, t = E.yOrigin, l.x -= E.xOffset - D.xOffset, l.y -= E.yOffset - D.yOffset), (s || t) && (u = Qa(Q, !0), l.x -= s - (s * u[0] + t * u[2]), l.y -= t - (s * u[1] + t * u[3]))), O.body.removeChild(Q), l.perspective || (l.perspective = D.perspective), null != A.xPercent && (l.xPercent = ja(A.xPercent, D.xPercent)), null != A.yPercent && (l.yPercent = ja(A.yPercent, D.yPercent)); else if ("object" == typeof A) {
                    if (l = {
                        scaleX: ja(null != A.scaleX ? A.scaleX : A.scale, D.scaleX),
                        scaleY: ja(null != A.scaleY ? A.scaleY : A.scale, D.scaleY),
                        scaleZ: ja(A.scaleZ, D.scaleZ),
                        x: ja(A.x, D.x),
                        y: ja(A.y, D.y),
                        z: ja(A.z, D.z),
                        xPercent: ja(A.xPercent, D.xPercent),
                        yPercent: ja(A.yPercent, D.yPercent),
                        perspective: ja(A.transformPerspective, D.perspective)
                    }, p = A.directionalRotation, null != p) if ("object" == typeof p) for (m in p) A[m] = p[m]; else A.rotation = p;
                    "string" == typeof A.x && A.x.indexOf("%") !== -1 && (l.x = 0, l.xPercent = ja(A.x, D.xPercent)), "string" == typeof A.y && A.y.indexOf("%") !== -1 && (l.y = 0, l.yPercent = ja(A.y, D.yPercent)), l.rotation = ka("rotation" in A ? A.rotation : "shortRotation" in A ? A.shortRotation + "_short" : "rotationZ" in A ? A.rotationZ : D.rotation, D.rotation, "rotation", B), Fa && (l.rotationX = ka("rotationX" in A ? A.rotationX : "shortRotationX" in A ? A.shortRotationX + "_short" : D.rotationX || 0, D.rotationX, "rotationX", B), l.rotationY = ka("rotationY" in A ? A.rotationY : "shortRotationY" in A ? A.shortRotationY + "_short" : D.rotationY || 0, D.rotationY, "rotationY", B)), l.skewX = ka(A.skewX, D.skewX), l.skewY = ka(A.skewY, D.skewY)
                }
                for (Fa && null != A.force3D && (D.force3D = A.force3D, o = !0), n = D.force3D || D.z || D.rotationX || D.rotationY || l.z || l.rotationX || l.rotationY || l.perspective, n || null == A.scale || (l.scaleZ = 1); --z > -1;) v = Ba[z], E = l[v] - D[v], (E > y || E < -y || null != A[v] || null != M[v]) && (o = !0, f = new ta(D, v, D[v], E, f), v in B && (f.e = B[v]), f.xs0 = 0, f.plugin = h, d._overwriteProps.push(f.n));
                return E = A.transformOrigin, D.svg && (E || A.svgOrigin) && (s = D.xOffset, t = D.yOffset, La(a, ha(E), l, A.svgOrigin, A.smoothOrigin), f = ua(D, "xOrigin", (w ? D : l).xOrigin, l.xOrigin, f, C), f = ua(D, "yOrigin", (w ? D : l).yOrigin, l.yOrigin, f, C), s === D.xOffset && t === D.yOffset || (f = ua(D, "xOffset", w ? s : D.xOffset, D.xOffset, f, C), f = ua(D, "yOffset", w ? t : D.yOffset, D.yOffset, f, C)), E = "0px 0px"), (E || Fa && n && D.zOrigin) && (Ca ? (o = !0, v = Ea, E = (E || _(a, v, e, !1, "50% 50%")) + "", f = new ta(x, v, 0, 0, f, -1, C), f.b = x[v], f.plugin = h, Fa ? (m = D.zOrigin, E = E.split(" "), D.zOrigin = (E.length > 2 && (0 === m || "0px" !== E[2]) ? parseFloat(E[2]) : m) || 0, f.xs0 = f.e = E[0] + " " + (E[1] || "50%") + " 0px", f = new ta(D, "zOrigin", 0, 0, f, -1, f.n), f.b = m, f.xs0 = f.e = D.zOrigin) : f.xs0 = f.e = E) : ha(E + "", D)), o && (d._transformType = D.svg && Aa || !n && 3 !== this._transformType ? 2 : 3), j && (i[c] = j), k && (i.scale = k), f
            }, prefix: !0
        }), ya("boxShadow", {
            defaultValue: "0px 0px 0px 0px #999",
            prefix: !0,
            color: !0,
            multi: !0,
            keyword: "inset"
        }), ya("borderRadius", {
            defaultValue: "0px", parser: function (a, b, c, f, g, h) {
                b = this.format(b);
                var i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x,
                    y = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
                    z = a.style;
                for (q = parseFloat(a.offsetWidth), r = parseFloat(a.offsetHeight), i = b.split(" "), j = 0; j < y.length; j++) this.p.indexOf("border") && (y[j] = Z(y[j])), m = l = _(a, y[j], e, !1, "0px"), m.indexOf(" ") !== -1 && (l = m.split(" "), m = l[0], l = l[1]), n = k = i[j], o = parseFloat(m), t = m.substr((o + "").length), u = "=" === n.charAt(1), u ? (p = parseInt(n.charAt(0) + "1", 10), n = n.substr(2), p *= parseFloat(n), s = n.substr((p + "").length - (p < 0 ? 1 : 0)) || "") : (p = parseFloat(n), s = n.substr((p + "").length)), "" === s && (s = d[c] || t), s !== t && (v = aa(a, "borderLeft", o, t), w = aa(a, "borderTop", o, t), "%" === s ? (m = v / q * 100 + "%", l = w / r * 100 + "%") : "em" === s ? (x = aa(a, "borderLeft", 1, "em"), m = v / x + "em", l = w / x + "em") : (m = v + "px", l = w + "px"), u && (n = parseFloat(m) + p + s, k = parseFloat(l) + p + s)), g = va(z, y[j], m + " " + l, n + " " + k, !1, "0px", g);
                return g
            }, prefix: !0, formatter: qa("0px 0px 0px 0px", !1, !0)
        }), ya("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {
            defaultValue: "0px",
            parser: function (a, b, c, d, f, g) {
                return va(a.style, c, this.format(_(a, c, e, !1, "0px 0px")), this.format(b), !1, "0px", f)
            },
            prefix: !0,
            formatter: qa("0px 0px", !1, !0)
        }), ya("backgroundPosition", {
            defaultValue: "0 0", parser: function (a, b, c, d, f, g) {
                var h, i, j, k, l, m, n = "background-position", o = e || $(a, null),
                    q = this.format((o ? p ? o.getPropertyValue(n + "-x") + " " + o.getPropertyValue(n + "-y") : o.getPropertyValue(n) : a.currentStyle.backgroundPositionX + " " + a.currentStyle.backgroundPositionY) || "0 0"),
                    r = this.format(b);
                if (q.indexOf("%") !== -1 != (r.indexOf("%") !== -1) && r.split(",").length < 2 && (m = _(a, "backgroundImage").replace(D, ""), m && "none" !== m)) {
                    for (h = q.split(" "), i = r.split(" "), R.setAttribute("src", m), j = 2; --j > -1;) q = h[j], k = q.indexOf("%") !== -1, k !== (i[j].indexOf("%") !== -1) && (l = 0 === j ? a.offsetWidth - R.width : a.offsetHeight - R.height, h[j] = k ? parseFloat(q) / 100 * l + "px" : parseFloat(q) / l * 100 + "%");
                    q = h.join(" ");
                }
                return this.parseComplex(a.style, q, r, f, g)
            }, formatter: ha
        }), ya("backgroundSize", {
            defaultValue: "0 0", formatter: function (a) {
                return a += "", "co" === a.substr(0, 2) ? a : ha(a.indexOf(" ") === -1 ? a + " " + a : a)
            }
        }), ya("perspective", {defaultValue: "0px", prefix: !0}), ya("perspectiveOrigin", {
            defaultValue: "50% 50%",
            prefix: !0
        }), ya("transformStyle", {prefix: !0}), ya("backfaceVisibility", {prefix: !0}), ya("userSelect", {prefix: !0}), ya("margin", {parser: ra("marginTop,marginRight,marginBottom,marginLeft")}), ya("padding", {parser: ra("paddingTop,paddingRight,paddingBottom,paddingLeft")}), ya("clip", {
            defaultValue: "rect(0px,0px,0px,0px)",
            parser: function (a, b, c, d, f, g) {
                var h, i, j;
                return p < 9 ? (i = a.currentStyle, j = p < 8 ? " " : ",", h = "rect(" + i.clipTop + j + i.clipRight + j + i.clipBottom + j + i.clipLeft + ")", b = this.format(b).split(",").join(j)) : (h = this.format(_(a, this.p, e, !1, this.dflt)), b = this.format(b)), this.parseComplex(a.style, h, b, f, g)
            }
        }), ya("textShadow", {
            defaultValue: "0px 0px 0px #999",
            color: !0,
            multi: !0
        }), ya("autoRound,strictUnits", {
            parser: function (a, b, c, d, e) {
                return e
            }
        }), ya("border", {
            defaultValue: "0px solid #000", parser: function (a, b, c, d, f, g) {
                var h = _(a, "borderTopWidth", e, !1, "0px"), i = this.format(b).split(" "), j = i[0].replace(w, "");
                return "px" !== j && (h = parseFloat(h) / aa(a, "borderTopWidth", 1, j) + j), this.parseComplex(a.style, this.format(h + " " + _(a, "borderTopStyle", e, !1, "solid") + " " + _(a, "borderTopColor", e, !1, "#000")), i.join(" "), f, g)
            }, color: !0, formatter: function (a) {
                var b = a.split(" ");
                return b[0] + " " + (b[1] || "solid") + " " + (a.match(pa) || ["#000"])[0]
            }
        }), ya("borderWidth", {parser: ra("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}), ya("float,cssFloat,styleFloat", {
            parser: function (a, b, c, d, e, f) {
                var g = a.style, h = "cssFloat" in g ? "cssFloat" : "styleFloat";
                return new ta(g, h, 0, 0, e, -1, c, !1, 0, g[h], b)
            }
        });
        var Ua = function (a) {
            var b, c = this.t, d = c.filter || _(this.data, "filter") || "", e = this.s + this.c * a | 0;
            100 === e && (d.indexOf("atrix(") === -1 && d.indexOf("radient(") === -1 && d.indexOf("oader(") === -1 ? (c.removeAttribute("filter"), b = !_(this.data, "filter")) : (c.filter = d.replace(z, ""), b = !0)), b || (this.xn1 && (c.filter = d = d || "alpha(opacity=" + e + ")"), d.indexOf("pacity") === -1 ? 0 === e && this.xn1 || (c.filter = d + " alpha(opacity=" + e + ")") : c.filter = d.replace(x, "opacity=" + e))
        };
        ya("opacity,alpha,autoAlpha", {
            defaultValue: "1", parser: function (a, b, c, d, f, g) {
                var h = parseFloat(_(a, "opacity", e, !1, "1")), i = a.style, j = "autoAlpha" === c;
                return "string" == typeof b && "=" === b.charAt(1) && (b = ("-" === b.charAt(0) ? -1 : 1) * parseFloat(b.substr(2)) + h), j && 1 === h && "hidden" === _(a, "visibility", e) && 0 !== b && (h = 0), U ? f = new ta(i, "opacity", h, b - h, f) : (f = new ta(i, "opacity", 100 * h, 100 * (b - h), f), f.xn1 = j ? 1 : 0, i.zoom = 1, f.type = 2, f.b = "alpha(opacity=" + f.s + ")", f.e = "alpha(opacity=" + (f.s + f.c) + ")", f.data = a, f.plugin = g, f.setRatio = Ua), j && (f = new ta(i, "visibility", 0, 0, f, -1, null, !1, 0, 0 !== h ? "inherit" : "hidden", 0 === b ? "hidden" : "inherit"), f.xs0 = "inherit", d._overwriteProps.push(f.n), d._overwriteProps.push(c)), f
            }
        });
        var Va = function (a, b) {
            b && (a.removeProperty ? ("ms" !== b.substr(0, 2) && "webkit" !== b.substr(0, 6) || (b = "-" + b), a.removeProperty(b.replace(B, "-$1").toLowerCase())) : a.removeAttribute(b))
        }, Wa = function (a) {
            if (this.t._gsClassPT = this, 1 === a || 0 === a) {
                this.t.setAttribute("class", 0 === a ? this.b : this.e);
                for (var b = this.data, c = this.t.style; b;) b.v ? c[b.p] = b.v : Va(c, b.p), b = b._next;
                1 === a && this.t._gsClassPT === this && (this.t._gsClassPT = null)
            } else this.t.getAttribute("class") !== this.e && this.t.setAttribute("class", this.e)
        };
        ya("className", {
            parser: function (a, b, d, f, g, h, i) {
                var j, k, l, m, n, o = a.getAttribute("class") || "", p = a.style.cssText;
                if (g = f._classNamePT = new ta(a, d, 0, 0, g, 2), g.setRatio = Wa, g.pr = -11, c = !0, g.b = o, k = ca(a, e), l = a._gsClassPT) {
                    for (m = {}, n = l.data; n;) m[n.p] = 1, n = n._next;
                    l.setRatio(1)
                }
                return a._gsClassPT = g, g.e = "=" !== b.charAt(1) ? b : o.replace(new RegExp("(?:\\s|^)" + b.substr(2) + "(?![\\w-])"), "") + ("+" === b.charAt(0) ? " " + b.substr(2) : ""), a.setAttribute("class", g.e), j = da(a, k, ca(a), i, m), a.setAttribute("class", o), g.data = j.firstMPT, a.style.cssText = p, g = g.xfirst = f.parse(a, j.difs, g, h)
            }
        });
        var Xa = function (a) {
            if ((1 === a || 0 === a) && this.data._totalTime === this.data._totalDuration && "isFromStart" !== this.data.data) {
                var b, c, d, e, f, g = this.t.style, h = i.transform.parse;
                if ("all" === this.e) g.cssText = "", e = !0; else for (b = this.e.split(" ").join("").split(","), d = b.length; --d > -1;) c = b[d], i[c] && (i[c].parse === h ? e = !0 : c = "transformOrigin" === c ? Ea : i[c].p), Va(g, c);
                e && (Va(g, Ca), f = this.t._gsTransform, f && (f.svg && (this.t.removeAttribute("data-svg-origin"), this.t.removeAttribute("transform")), delete this.t._gsTransform))
            }
        };
        for (ya("clearProps", {
            parser: function (a, b, d, e, f) {
                return f = new ta(a, d, 0, 0, f, 2), f.setRatio = Xa, f.e = b, f.pr = -10, f.data = e._tween, c = !0, f
            }
        }), j = "bezier,throwProps,physicsProps,physics2D".split(","), wa = j.length; wa--;) za(j[wa]);
        j = g.prototype, j._firstPT = j._lastParsedTransform = j._transform = null, j._onInitTween = function (a, b, h, j) {
            if (!a.nodeType) return !1;
            this._target = q = a, this._tween = h, this._vars = b, r = j, k = b.autoRound, c = !1, d = b.suffixMap || g.suffixMap, e = $(a, ""), f = this._overwriteProps;
            var n, p, s, t, u, v, w, x, z, A = a.style;
            if (l && "" === A.zIndex && (n = _(a, "zIndex", e), "auto" !== n && "" !== n || this._addLazySet(A, "zIndex", 0)), "string" == typeof b && (t = A.cssText, n = ca(a, e), A.cssText = t + ";" + b, n = da(a, n, ca(a)).difs, !U && y.test(b) && (n.opacity = parseFloat(RegExp.$1)), b = n, A.cssText = t), b.className ? this._firstPT = p = i.className.parse(a, b.className, "className", this, null, null, b) : this._firstPT = p = this.parse(a, b, null), this._transformType) {
                for (z = 3 === this._transformType, Ca ? m && (l = !0, "" === A.zIndex && (w = _(a, "zIndex", e), "auto" !== w && "" !== w || this._addLazySet(A, "zIndex", 0)), o && this._addLazySet(A, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (z ? "visible" : "hidden"))) : A.zoom = 1, s = p; s && s._next;) s = s._next;
                x = new ta(a, "transform", 0, 0, null, 2), this._linkCSSP(x, null, s), x.setRatio = Ca ? Ta : Sa, x.data = this._transform || Ra(a, e, !0), x.tween = h, x.pr = -1, f.pop()
            }
            if (c) {
                for (; p;) {
                    for (v = p._next, s = t; s && s.pr > p.pr;) s = s._next;
                    (p._prev = s ? s._prev : u) ? p._prev._next = p : t = p, (p._next = s) ? s._prev = p : u = p, p = v
                }
                this._firstPT = t
            }
            return !0
        }, j.parse = function (a, b, c, f) {
            var g, h, j, l, m, n, o, p, s, t, u = a.style;
            for (g in b) {
                if (n = b[g], "function" == typeof n && (n = n(r, q)), h = i[g]) c = h.parse(a, n, g, this, c, f, b); else {
                    if ("--" === g.substr(0, 2)) {
                        this._tween._propLookup[g] = this._addTween.call(this._tween, a.style, "setProperty", $(a).getPropertyValue(g) + "", n + "", g, !1, g);
                        continue
                    }
                    m = _(a, g, e) + "", s = "string" == typeof n, "color" === g || "fill" === g || "stroke" === g || g.indexOf("Color") !== -1 || s && A.test(n) ? (s || (n = na(n), n = (n.length > 3 ? "rgba(" : "rgb(") + n.join(",") + ")"), c = va(u, g, m, n, !0, "transparent", c, 0, f)) : s && J.test(n) ? c = va(u, g, m, n, !0, null, c, 0, f) : (j = parseFloat(m), o = j || 0 === j ? m.substr((j + "").length) : "", "" !== m && "auto" !== m || ("width" === g || "height" === g ? (j = ga(a, g, e), o = "px") : "left" === g || "top" === g ? (j = ba(a, g, e), o = "px") : (j = "opacity" !== g ? 0 : 1, o = "")), t = s && "=" === n.charAt(1), t ? (l = parseInt(n.charAt(0) + "1", 10), n = n.substr(2), l *= parseFloat(n), p = n.replace(w, "")) : (l = parseFloat(n), p = s ? n.replace(w, "") : ""), "" === p && (p = g in d ? d[g] : o), n = l || 0 === l ? (t ? l + j : l) + p : b[g], o !== p && ("" === p && "lineHeight" !== g || (l || 0 === l) && j && (j = aa(a, g, j, o), "%" === p ? (j /= aa(a, g, 100, "%") / 100, b.strictUnits !== !0 && (m = j + "%")) : "em" === p || "rem" === p || "vw" === p || "vh" === p ? j /= aa(a, g, 1, p) : "px" !== p && (l = aa(a, g, l, p), p = "px"), t && (l || 0 === l) && (n = l + j + p))), t && (l += j), !j && 0 !== j || !l && 0 !== l ? void 0 !== u[g] && (n || n + "" != "NaN" && null != n) ? (c = new ta(u, g, l || j || 0, 0, c, -1, g, !1, 0, m, n), c.xs0 = "none" !== n || "display" !== g && g.indexOf("Style") === -1 ? n : m) : W("invalid " + g + " tween value: " + b[g]) : (c = new ta(u, g, j, l - j, c, 0, g, k !== !1 && ("px" === p || "zIndex" === g), 0, m, n), c.xs0 = p))
                }
                f && c && !c.plugin && (c.plugin = f)
            }
            return c
        }, j.setRatio = function (a) {
            var b, c, d, e = this._firstPT, f = 1e-6;
            if (1 !== a || this._tween._time !== this._tween._duration && 0 !== this._tween._time) if (a || this._tween._time !== this._tween._duration && 0 !== this._tween._time || this._tween._rawPrevTime === -1e-6) for (; e;) {
                if (b = e.c * a + e.s, e.r ? b = e.r(b) : b < f && b > -f && (b = 0), e.type) if (1 === e.type) if (d = e.l, 2 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2; else if (3 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3; else if (4 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3 + e.xn3 + e.xs4; else if (5 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3 + e.xn3 + e.xs4 + e.xn4 + e.xs5; else {
                    for (c = e.xs0 + b + e.xs1, d = 1; d < e.l; d++) c += e["xn" + d] + e["xs" + (d + 1)];
                    e.t[e.p] = c
                } else e.type === -1 ? e.t[e.p] = e.xs0 : e.setRatio && e.setRatio(a); else e.t[e.p] = b + e.xs0;
                e = e._next
            } else for (; e;) 2 !== e.type ? e.t[e.p] = e.b : e.setRatio(a), e = e._next; else for (; e;) {
                if (2 !== e.type) if (e.r && e.type !== -1) if (b = e.r(e.s + e.c), e.type) {
                    if (1 === e.type) {
                        for (d = e.l, c = e.xs0 + b + e.xs1, d = 1; d < e.l; d++) c += e["xn" + d] + e["xs" + (d + 1)];
                        e.t[e.p] = c
                    }
                } else e.t[e.p] = b + e.xs0; else e.t[e.p] = e.e; else e.setRatio(a);
                e = e._next
            }
        }, j._enableTransforms = function (a) {
            this._transform = this._transform || Ra(this._target, e, !0), this._transformType = this._transform.svg && Aa || !a && 3 !== this._transformType ? 2 : 3
        };
        var Ya = function (a) {
            this.t[this.p] = this.e, this.data._linkCSSP(this, this._next, null, !0)
        };
        j._addLazySet = function (a, b, c) {
            var d = this._firstPT = new ta(a, b, 0, 0, this._firstPT, 2);
            d.e = c, d.setRatio = Ya, d.data = this
        }, j._linkCSSP = function (a, b, c, d) {
            return a && (b && (b._prev = a), a._next && (a._next._prev = a._prev), a._prev ? a._prev._next = a._next : this._firstPT === a && (this._firstPT = a._next, d = !0), c ? c._next = a : d || null !== this._firstPT || (this._firstPT = a), a._next = b, a._prev = c), a
        }, j._mod = function (a) {
            for (var b = this._firstPT; b;) "function" == typeof a[b.p] && (b.r = a[b.p]), b = b._next
        }, j._kill = function (b) {
            var c, d, e, f = b;
            if (b.autoAlpha || b.alpha) {
                f = {};
                for (d in b) f[d] = b[d];
                f.opacity = 1, f.autoAlpha && (f.visibility = 1)
            }
            for (b.className && (c = this._classNamePT) && (e = c.xfirst, e && e._prev ? this._linkCSSP(e._prev, c._next, e._prev._prev) : e === this._firstPT && (this._firstPT = c._next), c._next && this._linkCSSP(c._next, c._next._next, e._prev), this._classNamePT = null), c = this._firstPT; c;) c.plugin && c.plugin !== d && c.plugin._kill && (c.plugin._kill(b), d = c.plugin), c = c._next;
            return a.prototype._kill.call(this, f)
        };
        var Za = function (a, b, c) {
            var d, e, f, g;
            if (a.slice) for (e = a.length; --e > -1;) Za(a[e], b, c); else for (d = a.childNodes, e = d.length; --e > -1;) f = d[e], g = f.type, f.style && (b.push(ca(f)), c && c.push(f)), 1 !== g && 9 !== g && 11 !== g || !f.childNodes.length || Za(f, b, c)
        };
        return g.cascadeTo = function (a, c, d) {
            var e, f, g, h, i = b.to(a, c, d), j = [i], k = [], l = [], m = [], n = b._internals.reservedProps;
            for (a = i._targets || i.target, Za(a, k, m), i.render(c, !0, !0), Za(a, l), i.render(0, !0, !0), i._enabled(!0), e = m.length; --e > -1;) if (f = da(m[e], k[e], l[e]), f.firstMPT) {
                f = f.difs;
                for (g in d) n[g] && (f[g] = d[g]);
                h = {};
                for (g in f) h[g] = k[e][g];
                j.push(b.fromTo(m[e], c, h, f))
            }
            return j
        }, a.activate([g]), g
    }, !0)
}), _gsScope._gsDefine && _gsScope._gsQueue.pop()(), function (a) {
    "use strict";
    var b = function () {
        return (_gsScope.GreenSockGlobals || _gsScope)[a]
    };
    "undefined" != typeof module && module.exports ? (require("../TweenLite.js"), module.exports = b()) : "function" == typeof define && define.amd && define("gsap.cssplugin", ["TweenLite"], b)
}("CSSPlugin"), define("views/search-view", ["jquery", "underscore", "backbone", "TweenLite", "equal-height", "gsap.cssplugin"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        minSearchPhraseLength: 2,
        currentSearchRequest: null,
        lastSearchTimestamp: 0,
        lastTimeout: null,
        suggestIndex: null,
        keyControlClass: "key-control",
        suggestionLayerSelector: ".suggestion-layer",
        centerContainerSelector: ".center-container",
        $searchInput: void 0,
        events: {
            "click .btn-search": "search",
            "click .suggest": "search",
            "click .view-all a": "preventAction",
            "mouseenter .suggest": "updateSuggestIndexByMouse",
            "mouseleave .suggest": "updateSuggestIndexByMouse",
            "mousemove .suggest": "enableMouseHighlighting"
        },
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.matchMedia = window.app.matchMedia, this.$searchInput = this.$('input[type="search"], input[type="text"]'), this.setupListeners(), this.render(), this.onResize()
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.onResize), this.listenTo(this.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.onViewportChange)
        },
        onResize: function () {
            this.updateSearchLayer()
        },
        onViewportChange: function () {
            this.$(this.suggestionLayerSelector).remove(), this.$searchInput.val("")
        },
        render: function () {
            return this.initSearch(), this
        },
        initSearch: function () {
            this.$searchInput.on("keydown", this.checkSubmit.bind(this)), this.$searchInput.on("keyup", this.updateSearchSuggests.bind(this)), a(document).on("click", function (b) {
                var c = a(b.target);
                this.$(this.suggestionLayerSelector).each(function (b, d) {
                    c.parents(this.suggestionLayerSelector).length || c.parents(".input-container").length || a(d).height(0)
                }.bind(this))
            }.bind(this))
        },
        updateSearchSuggests: function (a) {
            if (this.$searchInput.val().length <= this.minSearchPhraseLength) return this.updateSearchLayer(), b.isUndefined(this.$suggestionLayer) || this.$suggestionLayer.height(0), void (this.suggestIndex = null);
            var c = this.$searchInput.closest("form").find(this.suggestionLayerSelector);
            if (this.$searchInput.val().length >= this.minSearchPhraseLength + 1 && this.handleNavKeyAction(a)) return void c.addClass(this.keyControlClass);
            var d = (new Date).getTime() - this.lastSearchTimestamp;
            this.lastSearchTimestamp = (new Date).getTime();
            var e = 300;
            b.isNull(this.currentSearchRequest) && (e = 0), d < e && clearTimeout(this.lastTimeout), this.lastTimeout = window.setTimeout(this.searchRequest.bind(this), e)
        },
        searchRequest: function () {
            var b = this.$el.find(".btn-search");
            this.searchPhrase = this.$searchInput.val(), this.currentSearchRequest = a.ajax({
                type: "GET",
                data: "term=" + encodeURIComponent(this.searchPhrase),
                url: b.attr("href") || b.data("href"),
                headers: {Accept: "application/json, text/javascript, */*; q=0.01", "Content-Type": "application/json"},
                beforeSend: this.onBeforeSend.bind(this, this.currentSearchRequest),
                success: this.onSuccess.bind(this),
                error: function (a) {
                }
            })
        },
        onBeforeSend: function (a) {
            b.isNull(a) || a.abort()
        },
        onSuccess: function (c) {
            var d = this.$searchInput.data("view-all-title"), e = a('<div class="suggestion-layer"></div>'),
                f = a('<div class="suggests"></div>');
            this.suggestionStr = "", b.isUndefined(c[0].term) || (this.$(this.suggestionLayerSelector).length || e.appendTo(this.$searchInput.parents("form")), this.$suggestionLayer = this.$(this.suggestionLayerSelector), b.each(c, this.createSuggestions.bind(this)), b.isUndefined(d) || (this.suggestionStr += '<div class="suggest view-all"><a href="#">' + this.$searchInput.data("view-all-title") + "</a></div>"), this.$suggestionLayer.html(f.html(this.suggestionStr)), this.$suggestionLayer.height(f.outerHeight()), this.updateSearchLayer())
        },
        createSuggestions: function (a) {
            var c = a.term.match(new RegExp(this.searchPhrase, "gi"));
            b.isNull(c) || (a.term = a.term.replace(new RegExp(c[0], "g"), "<b>" + c[0] + "</b>")), this.suggestionStr += '<div class="suggest">' + a.term + "</div>"
        },
        updateSearchLayer: function () {
            var b = this.$(this.suggestionLayerSelector);
            if (b.is(":visible")) {
                var c = a(window).height(), d = a(".center-wrapper").height(), e = c - d - 61;
                b.height(b.find(".suggests").outerHeight()).css("max-height", e)
            }
        },
        search: function (b) {
            b.preventDefault();
            var c = a(b.target).closest(".suggest"), d = this.$searchInput.closest("form");
            c.length > 0 && !c.hasClass("view-all") && !c.hasClass("btn-search") && this.$searchInput.val(c.text()).change(), this.$searchInput.val().length > this.minSearchPhraseLength && d.submit()
        },
        preventAction: function (a) {
            a.preventDefault()
        },
        updateSuggestIndexByMouse: function (b) {
            this.suggestIndex = a(b.target).closest(".suggest").index(), this.updateSuggestFocus(this.suggestIndex)
        },
        updateSuggestFocus: function (c) {
            var d = null;
            if (b.each(this.$(this.suggestionLayerSelector), function (b) {
                var c = a(b);
                c.height() > 0 && (d = c)
            }), !b.isNull(d)) {
                var e = d.find(".suggest").eq(c);
                e.hasClass("focus") ? e.removeClass("focus") : (e.siblings().removeClass("focus"), e.addClass("focus"))
            }
        },
        handleNavKeyAction: function (a) {
            var c, d = this.$(".suggestion-layer .suggest").length - 1;
            switch (a.keyCode) {
                case 38:
                    b.isNull(this.suggestIndex) ? this.suggestIndex = d : 0 === this.suggestIndex ? this.suggestIndex = d : this.suggestIndex--, c = !0;
                    break;
                case 40:
                    b.isNull(this.suggestIndex) ? this.suggestIndex = 0 : this.suggestIndex === d ? this.suggestIndex = 0 : this.suggestIndex++, c = !0;
                    break;
                default:
                    c = !1
            }
            return c && this.updateSuggestFocus(this.suggestIndex), c
        },
        enableMouseHighlighting: function (b) {
            var c = a(b.target).parents(this.suggestionLayerSelector);
            this.suggestIndex = a(b.target).closest(".suggest").index(), c.length && (c.hasClass(this.keyControlClass) && c.find(".suggest").removeClass("focus"), c.removeClass(this.keyControlClass))
        },
        checkSubmit: function (a) {
            if (13 === a.keyCode) {
                a.preventDefault(), a.stopImmediatePropagation();
                var b = this.$searchInput.closest("form"), c = b.find(this.suggestionLayerSelector),
                    d = c.find(".focus");
                d.length && !d.hasClass("view-all") && this.$searchInput.val(d.text()).change(), b.submit()
            }
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/nav-shopping-cart-view", ["jquery", "underscore", "backbone", "logger"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        logger: d.get("NavShoppingCartView"), initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.el && (this.url = this.$el.data("url"), this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.initItemCountFromUrl())
        }, setupListeners: function () {
            this.listenTo(this.eventDispatcher, "NavShoppingCart:Add", this.increaseItemCount.bind(this)), this.listenTo(this.eventDispatcher, "NavShoppingCart:Init", this.initItemCountFromUrl.bind(this))
        }, initItemCountFromUrl: function () {
            a.ajax({
                cache: !1,
                contentType: "application/json",
                dataType: "json",
                method: "GET",
                url: this.url
            }).done(this.onInitItemCountComplete.bind(this)).fail(this.onInitItemCountFailed.bind(this))
        }, onInitItemCountComplete: function (a) {
            if (!a || !b.isObject(a)) return void this.onInitItemCountFailed();
            var c = parseInt(a.qty);
            "OK" !== a.status || isNaN(c) ? this.onInitItemCountFailed("invalid format") : this.setItemCount(c)
        }, onInitItemCountFailed: function (a, b, c) {
            this.logger.error("failed to init item count", c || a)
        }, increaseItemCount: function () {
            this.setItemCount(this.getItemCount() + 1)
        }, getItemCount: function () {
            return parseInt(this.$el.attr("data-items")) || 0
        }, setItemCount: function (a) {
            this.$el.attr("data-items", a), this.$el.toggleClass("show-badge", a > 0)
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("views/nav-mobile-view", ["jquery", "underscore", "backbone", "mustache", "logger", "views/search-view", "views/nav-shopping-cart-view"], function (a, b, c, d, e, f, g) {
    "use strict";
    var h = c.View.extend({
        logger: e.get("MobileNavigationView"),
        tree: void 0,
        level: 0,
        path: [],
        pathIds: [],
        $navContainer: void 0,
        initialize: function (c) {
            this.options = b.extend({}, this.defaults, b.omit(c, ["el", "$el"])), this.$navContainer = this.$("#mobile-nav-container"), 0 !== this.$navContainer.length && (this.data = this.options.data, this.pathIds = window.RS_pathToPage || [], this.tree = b.isObject(window.RS_mainNavigation) ? a.extend(!0, {}, window.RS_mainNavigation) : {children: []}, this.userLoginNav = b.isObject(window.RS_userNavigationLogin) && b.clone(window.RS_userNavigationLogin), this.initPathIds(), this.level = this.pathIds.length, this.initPath(), this.render(), this.setMenuHeight())
        },
        render: function () {
            return this.renderNavigation(), this.renderCountries(), this
        },
        renderNavigation: function () {
            var c, e = b.findIndex(this.tree.children, function (a) {
                    return a.id === this.pathIds[0]
                }, this), h = this.tree.children[e],
                i = 1 < e || this.level < 2 || !b.has(h, "children") || !b.isArray(h.children) || 0 === h.children.length,
                j = [];
            if (this.mobileLinksTemplate = a("#nav-mobile-links-tmpl").html(), b.isUndefined(this.mobileLinksTemplate) || !b.isString(this.mobileLinksTemplate)) return this;
            d.parse(this.mobileLinksTemplate), this.userLoginNav && (this.tree.children = this.tree.children.concat([this.userLoginNav])), b.each(this.tree.children, function (a) {
                j.push(this.buildNavItem(i, a))
            }.bind(this)), c = d.render(this.mobileLinksTemplate, {
                listId: "nav-main",
                children: j
            }), b.isString(c) && this.$navContainer.prepend(c);
            var k = this.el.querySelector("form.search");
            k && f({el: this.$("form.search")});
            var l = document.getElementById("mobile-shopping-cart");
            return l && g({el: l}), this
        },
        renderCountries: function () {
            var c, e = this.data;
            return b.has(e, "regions") && b.isArray(e.regions) ? (this.countriesTemplate = a("#nav-mobile-countries-tmpl").html(), b.isUndefined(this.countriesTemplate) || !b.isString(this.countriesTemplate) ? this : (c = d.render(this.countriesTemplate, e), b.isString(c) && this.$("#mobile-country-container").prepend(c), this)) : (this.logger.warn("Failed to render countries due to missing regions"), this)
        },
        buildNavItem: function (a, c) {
            var e = b.clone(c), f = e.children;
            return a === !0 && !b.isUndefined(e.altText) && b.isString(e.altText) && "" !== e.altText && (e.text = e.altText), !e.active && b.contains(this.pathIds, e.id) && (e.active = !0), !b.isUndefined(f) && b.isArray(f) && 0 < f.length && (e.toggle = !0, b.each(f, this.prepareChildNavItem.bind(this)), e.sub = d.render(this.mobileLinksTemplate, {children: f})), e
        },
        prepareChildNavItem: function (a) {
            var c = a.children;
            if (!a.active && b.contains(this.pathIds, a.id) && (a.active = !0), b.isArray(c) && 0 !== c.length) {
                var e;
                e = c[0].href === a.href ? c.slice(1) : c, 0 < e.length && (b.each(e, function (a) {
                    !a.active && b.contains(this.pathIds, a.id) && (a.active = !0)
                }.bind(this)), a.toggle = !0, a.sub = d.render(this.mobileLinksTemplate, {children: e}))
            }
        },
        initPathIds: function () {
            b.has(this.tree, "id") && this.tree.id === this.pathIds[0] && this.pathIds.shift()
        },
        initPath: function () {
            for (var a, c, d, e = this.pathIds.slice(); void 0 !== (a = e.shift());) c = 0 === this.path.length ? this.tree : this.path[this.path.length - 1], b.isUndefined(c) || b.isUndefined(c.children) || (d = b.findWhere(c.children, {id: a}), this.path.push(d))
        },
        setMenuHeight: function () {
            var b, c, d;
            "media-to-m" !== window.app.matchMedia.getCurrentMediaQuery() && "media-from-m-to-l" !== window.app.matchMedia.getCurrentMediaQuery() || (b = a("#header").outerHeight(!0), c = this.$(".search").outerHeight(!0), d = 0, this.$("#mobile-nav-container").find("div").each(function () {
                d += a(this).outerHeight(!0)
            }), this.$("#nav-main").css("max-height", window.innerHeight - b - c - d))
        }
    });
    return function (a) {
        return this instanceof h ? this : new h(a)
    }
}), define("views/header-view", ["jquery", "underscore", "backbone", "logger", "views/nav-mobile-view", "views/country-slider-view", "TweenLite", "equal-height", "gsap.cssplugin"], function (a, b, c, d, e, f, g) {
    "use strict";
    var h = c.View.extend({
        menuOpen: !1,
        shareButtonsVisible: !1,
        logger: d.get("HeaderView"),
        events: {
            "click #mobile-menu-toggle": "toggleMenu",
            "click .toggle": "toggleSubMenu",
            "click #language-switcher": "toggleLanguageMenu",
            "click #change-country": "showCountryMenu",
            "click .regions > .back": "hideCountryMenu",
            "click .regions > ul > li > a": "showRegion",
            "click .countries > .back": "hideRegion",
            "click .social": "toggleShareButtons"
        },
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.currentMediaQuery = "", this.$languageMenu = this.$(document.getElementById("language-menu-wrapper")).removeClass("hidden"), this.$menuToggle = this.$(document.getElementById("mobile-menu-toggle")), this.$menuContainer = this.$(document.getElementById("mobile-menu-container")), this.$mainMenuContainer = this.$(document.getElementById("mobile-nav-container")), this.$menu = this.$(document.getElementById("nav-main")), this.$countryContainer = this.$(document.getElementById("mobile-country-container")), this.countriesUrl = this.$el.data("countries-list"), this.eventDispatcher = window.app.eventDispatcher, this.matchMedia = window.app.matchMedia, this.setupListeners(), this.render(), this.onResize(), this.onScroll(), this.navigationOption = this.$el.data("flyout-navigation-options")
        },
        handleFlyoutSubNavigation: function () {
            var a = "hide_international_link" === this.navigationOption || "hide_all" === this.navigationOption,
                b = "hide_sales_link" === this.navigationOption || "hide_all" === this.navigationOption;
            a && (this.$el.find(".regions .link-international").parent().remove(), this.$el.find(".link-international").remove()), b && this.$el.find(".link-sales, .title-sales, .sales-container").remove(), a && b && this.$el.find(".menu-secondary").remove()
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.onResize), this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_SCROLL, this.onScroll);
            var b = a(document.body);
            b.on("click", this.toggleShareButtons.bind(this)), b.on("click", this.toggleLanguageMenuController.bind(this))
        },
        onResize: function () {
            this.setMenuPosition(), this.setFixedHeader(), this.menuOpen === !0 && this.setMenuHeight()
        },
        onScroll: function () {
            this.setFixedHeader()
        },
        render: function () {
            /* Change by Mike 20210413:
            return this.addNavigationToggle(), this.loadCountries(), this
            */
            return this.addNavigationToggle(), this
        },
        onLoadCountriesComplete: function (a, c) {
            "success" === c && a ? (e({
                el: this.$menuContainer[0],
                data: a
            }), f({
                el: this.$languageMenu.find(".country-slider").get(0),
                data: a
            })) : this.onLoadCountriesFailed(), b.isString(this.navigationOption) && this.navigationOption && this.handleFlyoutSubNavigation()
        },
        onLoadCountriesFailed: function () {
            this.logger.error("Failed to load countries.")
        },
        loadCountries: function () {
            a.ajax({
                cache: !1,
                contentType: "application/json",
                dataType: "json",
                method: "GET",
                url: this.countriesUrl
            }).done(this.onLoadCountriesComplete.bind(this)).fail(this.onLoadCountriesFailed.bind(this))
        },
        setMenuPosition: function () {
            0 === this.$menuContainer.length || "media-to-m" !== this.matchMedia.getCurrentMediaQuery() && "media-from-m-to-l" !== this.matchMedia.getCurrentMediaQuery() || (this.$menuContainer.css("display", "none"), this.$menuContainer.css("top", this.$el.outerHeight(!0) - 10), this.$menuContainer.css("display", "block"))
        },
        setFixedHeader: function () {
            return "media-to-m" !== this.matchMedia.getCurrentMediaQuery() && "media-from-m-to-l" !== this.matchMedia.getCurrentMediaQuery() ? (this.$el.removeClass("fixed"), void a("body").css("padding-top", 0)) : void (window.pageYOffset > 0 ? (this.$el.addClass("fixed"), a("body").css("padding-top", this.$el.outerHeight(!0))) : (this.$el.removeClass("fixed"), a("body").css("padding-top", 0)))
        },
        addNavigationToggle: function () {
            this.$menu.find("li").each(function (b, c) {
                var d = a(c);
                d.find("ul").length && d.find("> a").append('<span class="toggle"></span>')
            })
        },
        toggleLanguageMenu: function () {
            this.$languageMenu.toggleClass("active")
        },
        toggleLanguageMenuController: function (b) {
            if (this.$languageMenu.hasClass("active")) {
                var c = a(b.target);
                if (c.closest(this.$languageMenu).length || c.closest("#language-switcher").length) return;
                this.toggleLanguageMenu()
            }
        },
        toggleMenu: function (a) {
            a.preventDefault(), this.menuOpen === !0 ? this.hideMenu() : (this.shareButtonsVisible === !0 && this.hideShareButtons(), this.setMenuPosition(), this.showMenu())
        },
        showMenu: function () {
            0 === this.$menu.length && (this.$menu = this.$("#nav-main")), 0 !== this.$menu.length && (this.menuOpen = !0, this.$menuToggle.addClass("show"), this.setMenuHeight())
        },
        hideMenu: function () {
            this.$menuToggle.removeClass("show"), 0 !== this.$menuContainer.length && (this.$menuContainer.css({height: this.$menu.outerHeight()}), g.to(this.$menuContainer, .25, {
                height: 0,
                onComplete: this.resetMenu,
                onCompleteScope: this
            }), this.menuOpen = !1)
        },
        resetMenu: function () {
            this.$menuContainer.css("height", 0)
        },
        setMenuHeight: function () {
            g.to(this.$menuContainer, .5, {height: window.innerHeight - this.$el.outerHeight()})
        },
        setMenuHeightDelayed: function () {
            window.setTimeout(this.setMenuHeight.bind(this), 100)
        },
        toggleSubMenu: function (b) {
            b.preventDefault(), a(b.target).closest("li").toggleClass("active"), this.showMenu()
        },
        showCountryMenu: function (a) {
            a.preventDefault(), g.to(this.$mainMenuContainer, .25, {marginLeft: "-100%"}), g.to(this.$countryContainer, .25, {marginLeft: 0}), this.setMenuHeightDelayed()
        },
        hideCountryMenu: function (a) {
            a.preventDefault(), g.to(this.$mainMenuContainer, .25, {marginLeft: 0}), g.to(this.$countryContainer, .25, {marginLeft: "100%"}), this.setMenuHeightDelayed()
        },
        showRegion: function (b) {
            b.preventDefault();
            var c = a(b.target), d = c.closest(".regions"), e = c.closest("li").find(".countries");
            e.addClass("active"), this.setRegionHeight(e), g.to(d, .25, {marginLeft: "-100%"}), this.setMenuHeightDelayed()
        },
        hideRegion: function (b) {
            b.preventDefault();
            var c = a(b.target), d = c.closest(".regions");
            g.to(d, .25, {
                marginLeft: 0,
                onComplete: this.resetCountries,
                onCompleteScope: this
            }), this.setMenuHeightDelayed()
        },
        resetCountries: function () {
            this.$countryContainer.find(".countries").removeClass("active")
        },
        setRegionHeight: function (a) {
            var b = a.find("ul");
            b.css("max-height", window.innerHeight - b.offset().top - 10)
        },
        toggleShareButtons: function (b) {
            var c = a(b.target).hasClass("social");
            this.$shareButtonsToggle = this.$shareButtonsToggle && this.$shareButtonsToggle.length > 0 ? this.$shareButtonsToggle : a(document.getElementById("share-bar")).find(".social"), c ? (b.preventDefault(), b.stopPropagation(), this.shareButtonsVisible === !0 ? this.hideShareButtons() : (this.menuOpen === !0 && this.hideMenu(), this.showShareButtons())) : this.hideShareButtons()
        },
        showShareButtons: function () {
            this.shareButtonsVisible = !0, this.$shareButtonsToggle.addClass("share-buttons-visible")
        },
        hideShareButtons: function () {
            this.shareButtonsVisible = !1, this.$shareButtonsToggle.removeClass("share-buttons-visible")
        }
    });
    return function (a) {
        return this instanceof h ? this : new h(a)
    }
}), define("views/howtobuy-linklist-view", ["jquery", "underscore", "backbone", "TweenLite", "views/form-view", "equal-height"], function (a, b, c, d, e) {
    "use strict";
    var f = c.View.extend({
        events: {"change .toggle-request-form": "toggleRequestForm"}, initialize: function (c) {
            this.options = b.extend({}, this.defaults, b.omit(c, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.$header = this.$(".linklist-howtobuy-header"), this.$rohdeSchwarzEntry = this.$(".rohde-schwarz"), this.$linkElement = this.$(".link-content"), this.$requestForm = this.$(".module-form-basic-contact"), this.$requestLayer = this.$(".request-layer"), this.$ajaxContent = this.$requestLayer.find(".ajax-content"), this.initialOpenedForm = a.magnificPopup.instance.st.el.data("form-open"), this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, b.debounce(this.refreshList.bind(this), 100)), this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.freeLinkHeight.bind(this))
        }, render: function () {
            return this.refreshList(), this.$requestForm.length && e({el: this.$requestForm}), this.initialOpenedForm && this.$el.find(".toggle-request-form").click(), this
        }, refreshList: function () {
            this.$rohdeSchwarzEntry.length && this.$header.css("min-height", parseInt(this.$rohdeSchwarzEntry.height()))
        }, freeLinkHeight: function () {
            this.$linkElement.height("auto")
        }, toggleRequestForm: function (b) {
            var c = a.magnificPopup.instance.st.el.data("form-request-url");
            c && (a(b.target).is(":checked") ? this.expandRequestForm() : this.collapseRequestForm(), a.get(c, this.loadRequestForm.bind(this, b)))
        }, loadRequestForm: function (b, c) {
            var f = a(c);
            this.$requestLayer.find(".module-form").length || (this.$ajaxContent.addClass("loading").html(f.removeClass("highlight")), e({el: f}), d.to(this.$requestLayer.find(".ajax-content"), .3, {
                css: {
                    maxHeight: f.outerHeight(),
                    opacity: 1
                }, onComplete: this.freeAjaxContent, onCompleteScope: this
            }))
        }, expandRequestForm: function () {
            var a = this.$requestLayer.find("> :last-child");
            d.to(this.$requestLayer, .3, {
                css: {maxHeight: a.position().top + a.outerHeight()},
                onComplete: this.freeContent,
                onCompleteScope: this
            })
        }, collapseRequestForm: function () {
            this.$requestLayer.css({"max-height": this.$requestLayer.outerHeight()}), d.to(this.$requestLayer, .3, {
                css: {
                    maxHeight: 0,
                    opacity: 0
                }, onComplete: this.resetContent, onCompleteScope: this
            })
        }, freeAjaxContent: function () {
            this.$requestLayer.find(".preloader").addClass("hide"), this.$ajaxContent.removeClass("loading"), this.$ajaxContent.css({"max-height": "none"})
        }, freeContent: function () {
            this.$requestLayer.css({"max-height": "none", opacity: ""})
        }, resetContent: function () {
            this.$requestLayer.css({"max-height": "", opacity: ""})
        }
    });
    return function (a) {
        return this instanceof f ? this : new f(a)
    }
}), define("views/inred-form-multiselect-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        $label: void 0,
        $pane: void 0,
        events: {"click .dropdown-label": "onDropdownLabelClick", 'change input[type="checkbox"]': "onInputChange"},
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.$pane = this.$el.find(".dropdown-pane"), this.$label = this.$el.find(".dropdown-label"), this.render()
        },
        render: function () {
            this.$pane.find("input:checked").each(function (a, b) {
                this.$label.prepend(this.generateMultiDropdownSelected(b))
            }.bind(this))
        },
        onDropdownLabelClick: function () {
            this.$el.hasClass("disabled") || (this.$el.toggleClass("open"), this.$pane.slideToggle(300))
        },
        onInputChange: function (a) {
            this.$el.hasClass("disabled") || (a.currentTarget.checked ? this.$label.prepend(this.generateMultiDropdownSelected(a.currentTarget)) : this.$label.find(".option[data-id=" + a.currentTarget.id + "]").remove());
        },
        generateMultiDropdownSelected: function (b) {
            var c = a('<span class="option" data-id="' + b.id + '"><span class="close"></span></span>');
            return c.append(document.querySelector('label[for="' + b.id + '"]').textContent), c.find(".close").on("click", function (a) {
                a.stopPropagation(), c.remove(), b.checked = !1
            }), c
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/inred-form-notification-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        $close: void 0, initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.render()
        }, render: function () {
            this.$close = a('<div class="close" />'), this.$el.find(".notification").append(this.$close), this.$close.on("click", function () {
                this.$el.hide()
            }.bind(this))
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/job-table-favorite-view", ["jquery", "underscore", "backbone", "logger"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        logger: d.get("JobTableFavoriteView"),
        urlSetFavorite: void 0,
        events: {"click .favorite": "toggleFavorites"},
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.urlSetFavorite = this.options.urlSetFavorite || this.$el.attr("data-rest-favorite")
        },
        toggleFavorites: function (b) {
            var c = a(b.target);
            this.setFavorite(c.attr("data-job-id"), !c.hasClass("active")), c.toggleClass("active"), b.stopPropagation(), b.preventDefault()
        },
        setFavorite: function (a, b) {
            window.app.api({
                method: "POST",
                url: this.urlSetFavorite,
                data: {jobId: a, active: b ? 1 : 0}
            }).done(this.onSetFavoriteComplete.bind(this)).fail(this.onSetFavoriteFailed.bind(this))
        },
        onSetFavoriteComplete: function (a, c) {
            "success" === c && b.isObject(a) && "OK" === a.status || this.onSetFavoriteFailed(a.error)
        },
        onSetFavoriteFailed: function (a, b, c) {
            this.logger.error("Failed to set favorite", c || a)
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("views/job-contact-share-view", ["jquery", "underscore", "backbone", "logger", "views/job-table-favorite-view"], function (a, b, c, d, e) {
    "use strict";
    var f = c.View.extend({
        logger: d.get("JobContactShareView"),
        urlGetFavorite: void 0,
        jobTableFavoriteView: void 0,
        events: {"click .link-favorite": "onLinkFavoriteClick"},
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.urlGetFavorite = this.$el.attr("data-rest-get-favorite"), this.updateFavoriteStatus(this.$el.find(".link-favorite")), this.jobTableFavoriteView = e({
                el: this.el,
                $el: this.$el,
                urlSetFavorite: this.$el.attr("data-rest-set-favorite")
            })
        },
        updateFavoriteStatus: function (b) {
            var c = a(b).attr("data-job-id");
            window.app.api({
                url: this.urlGetFavorite,
                data: {jobId: c}
            }).done(this.onUpdateFavoriteComplete.bind(this, b)).fail(this.onUpdateFavoriteFailed.bind(this))
        },
        onUpdateFavoriteComplete: function (c, d, e) {
            "success" === e && b.isObject(d) && "OK" === d.status ? a(c).toggleClass("active", 1 === d.favorite) : this.onUpdateFavoriteFailed("request failed")
        },
        onUpdateFavoriteFailed: function (a, b, c) {
            this.logger.error("Failed to update favorite", c || a)
        },
        onLinkFavoriteClick: function (b) {
            var c = a(b.target);
            this.jobTableFavoriteView.setFavorite(c.attr("data-job-id"), !c.hasClass("active")), c.toggleClass("active"), b.stopPropagation(), b.preventDefault()
        }
    });
    return function (a) {
        return this instanceof f ? this : new f(a)
    }
}), define("views/tradeshow-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        $form: void 0,
        events: {
            "change .filter-input": "submitForm",
            "change .filter-select": "submitForm",
            "click .active-filters-link": "onFilterLinkClick",
            "click .table-headline-icon": "onSortLinkClicked"
        },
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"]))
        },
        onFilterLinkClick: function (a) {
            var b = a.target;
            if ("active-filters-link" !== b.className && (b = b.parentElement), b.attributes["data-target"]) {
                var c = b.parentElement, d = this.$el.find(b.attributes["data-target"].value);
                c.parentElement.removeChild(c), d.hasClass("filter-select") ? d.val("") : d.prop("checked", !1), this.submitForm()
            }
        },
        onSortLinkClicked: function (b) {
            var c = a(b.target);
            c.hasClass("sorted") ? c.removeClass("sorted") : (this.$el.find(".table-headline-icon").removeClass("sorted"), c.addClass("sorted"))
        },
        submitForm: function () {
            this.$el.find(".tradeshow-filter form").submit()
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/jobboard-filter-view", ["jquery", "underscore", "backbone", "views/tradeshow-view"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        dropdownAnimationDelay: 300,
        searchFilterDropdownSelector: ".job-search-filter-dropdown",
        events: {
            "click .btn-search-toggle": "submitForm",
            "click .job-search-filter": "toggleSearchButtons",
            "click .filter-input-all": "onFilterInputAllChange"
        },
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.setupListeners(), d({
                el: this.el,
                $el: this.$el
            })
        },
        setupListeners: function () {
            a(document.body).on("click", this.onBodyClick.bind(this))
        },
        onBodyClick: function (b) {
            var c = a(b.target);
            c.is(".job-search-filter") || c.is(".job-search-filter-dropdown") || 0 !== c.closest(".job-search-filter, .job-search-filter-dropdown").length || this.toggleFilterDropdown(this.$el.find(".job-search-filter.active"))
        },
        onFilterInputAllChange: function (b) {
            var c = a(b.target).closest(this.searchFilterDropdownSelector);
            c.find(".dropdown-list .filter-input").each(function () {
                a(this).prop("checked", !1)
            }), this.submitForm()
        },
        toggleFilterDropdown: function (b, c) {
            var d = a(b), e = d.parent(), f = d.next();
            f.toggleClass("active"), e.toggleClass("has-active"), d.toggleClass("active"), setTimeout(function () {
                f.toggleClass("ready")
            }, c || 0)
        },
        toggleSearchButtons: function (b) {
            var c = a(b.target);
            c.hasClass("job-search-filter") || (c = c.closest(".job-search-filter"));
            var d = c.hasClass("active"), e = 0;
            d || (this.toggleFilterDropdown(this.$el.find(".job-search-filter.active")), e = this.dropdownAnimationDelay), this.toggleFilterDropdown(c, e)
        },
        submitForm: function () {
            this.$el.find(".job-filter form").submit()
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("views/jobboard-table-view", ["jquery", "underscore", "backbone", "logger", "views/job-table-favorite-view", "views/tradeshow-view"], function (a, b, c, d, e, f) {
    "use strict";
    var g = c.View.extend({
        lastMediaQuery: void 0, logger: d.get("JobboardTableView"), initialize: function (a) {
            this.eventDispatcher = window.app.eventDispatcher, this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.onResize(), this.setupListeners(), e({
                el: this.el,
                $el: this.$el,
                urlSetFavorite: this.$el.attr("data-rest-favorite")
            }), f({el: this.el, $el: this.$el})
        }, setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.onResize)
        }, onResize: function () {
            var a = window.app.matchMedia.getCurrentMediaQuery();
            this.lastMediaQuery && this.lastMediaQuery === a || (this.lastMediaQuery = a, "media-from-l" !== a ? this.moveFavoritesToMobile() : this.moveFavoritesToDesktop())
        }, moveFavoritesToDesktop: function () {
            var b = this.$el.find(".favorite"), c = b.parent(),
                d = this.$el.find(".results .module-accordion .content .accordion-table-list-item.column-1");
            c.each(function (b) {
                a(d[b]).append(this), a(this).removeClass("mobile")
            })
        }, moveFavoritesToMobile: function () {
            var b = this.$el.find(".favorite"), c = b.parent(), d = this.$el.find(".results .module-accordion .title");
            c.each(function (b) {
                a(d[b]).append(this), a(this).addClass("mobile")
            })
        }
    });
    return function (a) {
        return this instanceof g ? this : new g(a)
    }
}),/*!
 * imagesLoaded PACKAGED v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
    function (a, b) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", b) : "object" == typeof module && module.exports ? module.exports = b() : a.EvEmitter = b()
    }("undefined" != typeof window ? window : this, function () {
        function a() {
        }

        var b = a.prototype;
        return b.on = function (a, b) {
            if (a && b) {
                var c = this._events = this._events || {}, d = c[a] = c[a] || [];
                return d.indexOf(b) == -1 && d.push(b), this
            }
        }, b.once = function (a, b) {
            if (a && b) {
                this.on(a, b);
                var c = this._onceEvents = this._onceEvents || {}, d = c[a] = c[a] || {};
                return d[b] = !0, this
            }
        }, b.off = function (a, b) {
            var c = this._events && this._events[a];
            if (c && c.length) {
                var d = c.indexOf(b);
                return d != -1 && c.splice(d, 1), this
            }
        }, b.emitEvent = function (a, b) {
            var c = this._events && this._events[a];
            if (c && c.length) {
                c = c.slice(0), b = b || [];
                for (var d = this._onceEvents && this._onceEvents[a], e = 0; e < c.length; e++) {
                    var f = c[e], g = d && d[f];
                    g && (this.off(a, f), delete d[f]), f.apply(this, b)
                }
                return this
            }
        }, b.allOff = function () {
            delete this._events, delete this._onceEvents
        }, a
    }),/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
    function (a, b) {
        "use strict";
        "function" == typeof define && define.amd ? define("images-loaded", ["ev-emitter/ev-emitter"], function (c) {
            return b(a, c)
        }) : "object" == typeof module && module.exports ? module.exports = b(a, require("ev-emitter")) : a.imagesLoaded = b(a, a.EvEmitter)
    }("undefined" != typeof window ? window : this, function (a, b) {
        function c(a, b) {
            for (var c in b) a[c] = b[c];
            return a
        }

        function d(a) {
            if (Array.isArray(a)) return a;
            var b = "object" == typeof a && "number" == typeof a.length;
            return b ? j.call(a) : [a]
        }

        function e(a, b, f) {
            if (!(this instanceof e)) return new e(a, b, f);
            var g = a;
            return "string" == typeof a && (g = document.querySelectorAll(a)), g ? (this.elements = d(g), this.options = c({}, this.options), "function" == typeof b ? f = b : c(this.options, b), f && this.on("always", f), this.getImages(), h && (this.jqDeferred = new h.Deferred), void setTimeout(this.check.bind(this))) : void i.error("Bad element for imagesLoaded " + (g || a))
        }

        function f(a) {
            this.img = a
        }

        function g(a, b) {
            this.url = a, this.element = b, this.img = new Image
        }

        var h = a.jQuery, i = a.console, j = Array.prototype.slice;
        e.prototype = Object.create(b.prototype), e.prototype.options = {}, e.prototype.getImages = function () {
            this.images = [], this.elements.forEach(this.addElementImages, this)
        }, e.prototype.addElementImages = function (a) {
            "IMG" == a.nodeName && this.addImage(a), this.options.background === !0 && this.addElementBackgroundImages(a);
            var b = a.nodeType;
            if (b && k[b]) {
                for (var c = a.querySelectorAll("img"), d = 0; d < c.length; d++) {
                    var e = c[d];
                    this.addImage(e)
                }
                if ("string" == typeof this.options.background) {
                    var f = a.querySelectorAll(this.options.background);
                    for (d = 0; d < f.length; d++) {
                        var g = f[d];
                        this.addElementBackgroundImages(g)
                    }
                }
            }
        };
        var k = {1: !0, 9: !0, 11: !0};
        return e.prototype.addElementBackgroundImages = function (a) {
            var b = getComputedStyle(a);
            if (b) for (var c = /url\((['"])?(.*?)\1\)/gi, d = c.exec(b.backgroundImage); null !== d;) {
                var e = d && d[2];
                e && this.addBackground(e, a), d = c.exec(b.backgroundImage)
            }
        }, e.prototype.addImage = function (a) {
            var b = new f(a);
            this.images.push(b)
        }, e.prototype.addBackground = function (a, b) {
            var c = new g(a, b);
            this.images.push(c)
        }, e.prototype.check = function () {
            function a(a, c, d) {
                setTimeout(function () {
                    b.progress(a, c, d)
                })
            }

            var b = this;
            return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function (b) {
                b.once("progress", a), b.check()
            }) : void this.complete()
        }, e.prototype.progress = function (a, b, c) {
            this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !a.isLoaded, this.emitEvent("progress", [this, a, b]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, a), this.progressedCount == this.images.length && this.complete(), this.options.debug && i && i.log("progress: " + c, a, b)
        }, e.prototype.complete = function () {
            var a = this.hasAnyBroken ? "fail" : "done";
            if (this.isComplete = !0, this.emitEvent(a, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
                var b = this.hasAnyBroken ? "reject" : "resolve";
                this.jqDeferred[b](this)
            }
        }, f.prototype = Object.create(b.prototype), f.prototype.check = function () {
            var a = this.getIsImageComplete();
            return a ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), void (this.proxyImage.src = this.img.src))
        }, f.prototype.getIsImageComplete = function () {
            return this.img.complete && this.img.naturalWidth
        }, f.prototype.confirm = function (a, b) {
            this.isLoaded = a, this.emitEvent("progress", [this, this.img, b])
        }, f.prototype.handleEvent = function (a) {
            var b = "on" + a.type;
            this[b] && this[b](a)
        }, f.prototype.onload = function () {
            this.confirm(!0, "onload"), this.unbindEvents()
        }, f.prototype.onerror = function () {
            this.confirm(!1, "onerror"), this.unbindEvents()
        }, f.prototype.unbindEvents = function () {
            this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
        }, g.prototype = Object.create(f.prototype), g.prototype.check = function () {
            this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url;
            var a = this.getIsImageComplete();
            a && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents())
        }, g.prototype.unbindEvents = function () {
            this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
        }, g.prototype.confirm = function (a, b) {
            this.isLoaded = a, this.emitEvent("progress", [this, this.element, b])
        }, e.makeJQueryPlugin = function (b) {
            b = b || a.jQuery, b && (h = b, h.fn.imagesLoaded = function (a, b) {
                var c = new e(this, a, b);
                return c.jqDeferred.promise(h(this))
            })
        }, e.makeJQueryPlugin(), e
    }), define("views/lightbox-view", ["jquery", "underscore", "backbone", "images-loaded", "magnific-popup", "slick-slider"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        fullscreenchangeEvents: ["fullscreenchange", "mozfullscreenchange", "webkitfullscreenchange", "MSFullscreenChange"],
        $video: null,
        slickPrevBtn: '<span class="slick-prev"></span>',
        slickNextBtn: '<span class="slick-next"></span>',
        slickSlideSelector: ".slick-slide",
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.$lightboxContext = null, this.lightboxType = "inline", this.mediaGalleryIndex = 0, this.$el.on("click", this.initMagnificPopup.bind(this))
        },
        initMagnificPopup: function (c) {
            var d = this, e = this.$el.attr("data-target");
            e ? (c.preventDefault(), c.stopImmediatePropagation()) : e = this.$el.attr("href"), a.magnificPopup.open({
                enableEscapeKey: !1,
                items: [{src: e, type: this.lightboxType}],
                mainClass: "mfp-fade rs-mfp-lightbox",
                removalDelay: 300,
                preloader: !1,
                callbacks: {
                    beforeOpen: function () {
                        var e = d.$el.parents(".slick-initialized"), f = e.length > 0 ? e.prop("slick") : null;
                        if (f) {
                            var g = a(c.target), h = g.is(d.slickSlideSelector) ? g : g.closest(d.slickSlideSelector),
                                i = d.normalizeIndex(h.data("slick-index"), f.$slides.length);
                            d.mediaGalleryIndex = b.isNumber(i) ? i : f.currentSlide
                        } else d.$el.hasClass("media") ? d.mediaGalleryIndex = d.$el.index() : d.mediaGalleryIndex = 0;
                        d.setMediaGalleryPosition(d.mediaGalleryIndex), d.eventDispatcher.trigger(window.app.applicationEvents.LIGHTBOX_BEFORE_OPEN, a.Event("beforeOpen", {
                            view: d,
                            target: d.el
                        }))
                    },
                    open: this.onLightboxOpen.bind(this),
                    elementParse: this.onLightboxElementParse.bind(this),
                    close: this.onLightboxClose.bind(this)
                }
            })
        },
        normalizeIndex: function (a, c) {
            return b.isNumber(a) ? a < 0 ? c + a : a >= c ? a - c : a : null
        },
        onLightboxElementParse: function (b) {
            var c, d = this;
            d.$mediaContainer = a(b.data.src), d.$previewSlider = d.$mediaContainer.find(".media-big"), d.$thumbnailSlider = d.$mediaContainer.find(".thumbnail-slider"), d.$thumbnailControls = d.$thumbnailSlider.parent().find(".thumbnail-controls"), d.$previewSlider.find("div[data-img-src]").length < 2 && (d.$thumbnailSlider.remove(), d.$thumbnailSlider = null, d.$thumbnailControls.remove(), d.$thumbnailControls = null), c = !!d.$mediaContainer.find("img").length && d.$mediaContainer.find("img"), d.$previewSlider.find("video").each(function (b, c) {
                a(c).on("play", function () {
                    a(c).parents(d.slickSlideSelector).find(".media-title .slider-paging").addClass("hide")
                }), a(c).on("pause ended", function () {
                    a(c).parents(d.slickSlideSelector).find(".media-title .slider-paging").removeClass("hide")
                })
            }), c && (d.$mediaContainer.hasClass("media-gallery-sliders") ? (c.each(function (b, c) {
                var d = a(c);
                d.attr("src", d.parent().data("img-src"))
            }), d.$previewSlider.on("init", function (b, c) {
                d.triggerVideoAutoplay(c.$slides[c.currentSlide]), d.eventDispatcher.trigger(window.app.applicationEvents.LIGHTBOX_GALLERY_READY, a.Event("init", {
                    view: d,
                    target: d.el
                }))
            }), d.$previewSlider.on("afterChange", function (a, b) {
                d.triggerVideoAutoplay(b.$slides[b.currentSlide])
            }), d.$previewSlider.on("setPosition", function (b, c) {
                var e = a(c.$slides[c.currentSlide]), f = parseInt(e.find("img").height()),
                    g = parseInt(d.$mediaContainer.find(".slider-dots li").height());
                d.mediaGalleryIndex = c.currentSlide, d.setSliderPaging(d.mediaGalleryIndex + 1, c.$slides.length), d.$mediaContainer.find(".slider-dots").css("top", f - (g + 30)).addClass("show"), d.calculateSliderControls()
            }), d.$previewSlider.on("breakpoint", function () {
                d.setMediaGalleryPosition(d.mediaGalleryIndex), d.calculatePagingPos()
            }), d.$previewSlider.on("beforeChange", function (b, c, e, f) {
                d.$video = a(c.$slides[e].querySelector("video")), d.$video.length && !d.$video[0].paused && d.$video[0].pause(), d.setSliderPaging(f + 1, c.$slides.length)
            }), setTimeout(function () {
                d.$mediaContainer.imagesLoaded().always(d.onImagesLoaded.bind(d))
            }, 500)) : c.attr("src", d.$mediaContainer.data("img-src")))
        },
        triggerVideoAutoplay: function (b) {
            this.$video = a(b).find("video"), 0 !== this.$video.length && (this.$video[0].currentTime = 0, this.$video[0].play())
        },
        onThumbnailsInitialized: function (a, b) {
            var c = this.isLandscapeFormat() ? 9 : 5;
            b.$slides.length < c && b.$slider.addClass("hide-shadows")
        },
        addOnFullscreenchangeEventListener: function (a) {
            document.addEventListener(a, this.refreshGallery.bind(this))
        },
        removeOnFullscreenchangeEventListener: function (a) {
            document.removeEventListener(a, this)
        },
        onImagesLoaded: function () {
            this.fullscreenchangeEvents.forEach(this.addOnFullscreenchangeEventListener.bind(this)), this.$thumbnailSlider && (this.$thumbnailSlider.on("init", this.onThumbnailsInitialized.bind(this)), this.$thumbnailSlider.slick({
                arrows: !1,
                rows: 0,
                accessibility: !1,
                slidesToShow: this.isLandscapeFormat() ? 6 : 4,
                slidesToScroll: 1,
                asNavFor: null,
                centerMode: !0,
                focusOnSelect: !0,
                initialSlide: this.mediaGalleryIndex,
                mobileFirst: !0,
                touchThreshold: 15,
                responsive: [{
                    breakpoint: 640,
                    settings: {
                        asNavFor: this.$previewSlider,
                        arrows: !0,
                        prevArrow: this.slickPrevBtn,
                        nextArrow: this.slickNextBtn,
                        appendArrows: this.$thumbnailControls,
                        slidesToShow: this.isLandscapeFormat() ? 5 : 4
                    }
                }, {
                    breakpoint: 960,
                    settings: {
                        asNavFor: this.$previewSlider,
                        arrows: !0,
                        prevArrow: this.slickPrevBtn,
                        nextArrow: this.slickNextBtn,
                        appendArrows: this.$thumbnailControls,
                        slidesToShow: this.isLandscapeFormat() ? 8 : 4
                    }
                }]
            })), this.$previewSlider.slick({
                rows: 0,
                accessibility: !1,
                adaptiveHeight: !0,
                dots: !1,
                dotsClass: "slider-dots",
                appendDots: ".media-gallery-sliders .controls",
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !1,
                asNavFor: null,
                initialSlide: this.mediaGalleryIndex,
                mobileFirst: !0,
                prevArrow: this.slickPrevBtn,
                nextArrow: this.slickNextBtn,
                responsive: [{
                    breakpoint: 640,
                    settings: {arrows: !0, asNavFor: this.$mediaContainer.find(".thumbnail-slider"), dots: !1, fade: !0}
                }]
            })
        },
        onLightboxOpen: function () {
            this.$lightboxContext = a(".mfp-container"), a('<div class="cover"><div class="loader"/></div>').appendTo(this.$lightboxContext), this.$lightboxContext.parents(".media-big").length > 0 || this.$mediaContainer.hasClass("media-gallery-sliders") || this.triggerVideoAutoplay(this.$lightboxContext)
        },
        onLightboxClose: function () {
            var b = a("video");
            b.length && b.each(function (a, b) {
                b.pause()
            }), this.$previewSlider.slick("unslick"), this.$thumbnailSlider && this.$thumbnailSlider.slick("unslick"), this.$mediaContainer.hasClass("media-gallery-sliders") && this.fullscreenchangeEvents.forEach(this.removeOnFullscreenchangeEventListener.bind(this))
        },
        setMediaGalleryPosition: function (a) {
            var c = this;
            !b.isUndefined(this.$previewSlider) && this.$previewSlider.hasClass("slick-initialized") && this.$(".media-gallery-sliders").imagesLoaded().always(function () {
                c.$previewSlider.slick("slickGoTo", a)
            })
        },
        setSliderPaging: function (a, b) {
            this.$mediaContainer.find(".slider-paging .current-slide").text(a), this.$mediaContainer.find(".slider-paging .max-slides").text(b)
        },
        calculateSliderControls: function () {
            b.isUndefined(this.$previewSlider) || (this.calculatePagingPos(), setTimeout(this.calculateDelayed.bind(this), 0))
        },
        calculateDelayed: function () {
            var a = this.$previewSlider.find(".slick-active"), b = parseInt(a.find("img, video").height()),
                c = parseInt(this.$previewSlider.find(".slick-arrow").outerHeight());
            this.$previewSlider.find(".slick-arrow").css("margin-top", (b - c) / 2), a.closest(".media-gallery-sliders").addClass("initialized")
        },
        calculatePagingPos: function () {
            var a = window.app.matchMedia.getCurrentMediaQuery(),
                b = this.$mediaContainer.find(".media-big .slick-current"), c = 0;
            "media-to-m" === a && this.isLandscapeFormat() && (c = b.find("img").offset().left - 16), this.$mediaContainer.find(".slider-paging").css("right", c)
        },
        refreshGallery: function () {
            this.$previewSlider.hasClass("slick-initialized") && this.$previewSlider.slick("setPosition")
        },
        isLandscapeFormat: function () {
            return this.$mediaContainer.hasClass("format-9-16")
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/linklist-dropdown-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        $linklistDropdown: void 0,
        mobile: void 0,
        events: {"click .header": "openDropDown"},
        initialize: function (a) {
            this.eventDispatcher = window.app.eventDispatcher, this.setupListeners()
        },
        setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.resetActive.bind(this))
        },
        openDropDown: function (b) {
            this.mobile = window.matchMedia("(max-width: 960px)").matches, this.mobile && (this.$linklistDropdown = a(b.target).parents(".linklist-dropdown"), this.$linklistDropdown.toggleClass("active"))
        },
        resetActive: function () {
            void 0 !== this.$linklistDropdown && (this.mobile = window.matchMedia("(max-width: 960px)").matches, this.mobile || this.$linklistDropdown.removeClass("active"))
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/nav-main-view", ["jquery", "underscore", "backbone", "mustache", "views/search-view", "views/nav-shopping-cart-view", "TweenLite", "gsap.cssplugin"], function (a, b, c, d, e, f, g) {
    "use strict";
    var h = c.View.extend({
        $openSubMenu: void 0,
        $openFlyout: void 0,
        $breadcrumb: void 0,
        activeMenuItem: void 0,
        activeClass: "active",
        readyClass: "ready",
        multiBarClass: "nav-multi-bar",
        smallFlyout: "small",
        staticItem: "static-item",
        flyoutGridOffset: -49,
        searchToggleClass: "btn-search-toggle",
        navFlyoutSelector: "#nav-flyout",
        menuItemsSelector: "a.nav-flyout",
        tree: void 0,
        userLoginNav: void 0,
        level: 0,
        navbars: 0,
        path: [],
        pathIds: [],
        isStaticMenuItem: !1,
        events: {
            "click .list-items a": "showNavList",
            "click nav .nav-flyout": "processFlyout",
            "click .btn-search-toggle": "toggleSearch",
            "click .nav-parent .toggle-main-dropdown": "toggleSubMenu"
        },
        initialize: function (c) {
            return this.options = b.extend({}, this.defaults, b.omit(c, ["el", "$el"])), this.pathIds = window.RS_pathToPage || [], this.tree = !b.isUndefined(window.RS_mainNavigation) && b.isObject(window.RS_mainNavigation) ? a.extend(!0, {}, window.RS_mainNavigation) : {children: []}, this.userLoginNav = !b.isUndefined(window.RS_userNavigationLogin) && b.isObject(window.RS_userNavigationLogin) && b.clone(window.RS_userNavigationLogin), this.$breadcrumb = a("#breadcrumb-navigation"), b.has(this.tree, "children") && b.isArray(this.tree.children) && 0 !== this.tree.children.length ? (this.initPathIds(), this.level = this.pathIds.length, this.initPath(), this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), void this.render()) : void this.renderFallback()
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.recalculateFlyout.bind(this))
        },
        render: function () {
            var c, g = b.findIndex(this.tree.children, function (a) {
                return a.id === this.pathIds[0]
            }, this), h = this.tree.children[g];
            if (this.mainLinksFlyoutTemplate = a("#nav-main-links-flyout-tmpl").html(), this.mainFlyoutTemplate = a("#nav-main-flyout-tmpl").html(), this.mainUserLoginLinkFlyoutTemplate = a("#nav-user-login-link-flyout-tmpl").html(), !b.isString(this.mainLinksFlyoutTemplate) || !b.isString(this.mainFlyoutTemplate) || !b.isString(this.mainUserLoginLinkFlyoutTemplate)) return this;
            d.parse(this.mainLinksFlyoutTemplate), d.parse(this.mainFlyoutTemplate), d.parse(this.mainUserLoginLinkFlyoutTemplate);
            var i = !1;
            if (1 < g || this.level < 2 || !b.has(h, "children") || !b.isArray(h.children) || 0 === h.children.length ? c = this.renderSingleBar() : (c = this.renderMultiBar(), i = !0), b.isString(c)) {
                this.$el.toggleClass(this.multiBarClass, i), this.$el.html(c);
                var j = this.el.querySelector("form.search");
                j && e({el: this.$("form.search")});
                var k = this.el.querySelector(".user-shopping-cart");
                k && f({el: k})
            }
            return this.$el.addClass("rendered"), this.$(this.navFlyoutSelector).find(".hilite").trigger("click"), this
        },
        renderFallback: function () {
            a('<div class="center-wrapper"><div class="center-container empty"></div></div>').appendTo(this.$el), this.$el.addClass("rendered")
        },
        renderSingleBar: function () {
            var c, e = {current: "", flyout: ""}, f = [];
            return this.navbars = 1, b.each(this.tree.children, this.processNavItem.bind(this, f)), this.userLoginNav && (this.processNavItem(f, this.userLoginNav), e.login = d.render(this.mainUserLoginLinkFlyoutTemplate, this.userLoginNav)), e.current = d.render(this.mainLinksFlyoutTemplate, this.tree), e.flyout = d.render(this.mainFlyoutTemplate, {flyouts: f}), c = d.render(a("#nav-main-1-tmpl").html(), e)
        },
        renderMultiBar: function () {
            var c = {toggle: ""}, e = [];
            return this.navbars = 2, b.each(this.tree.children, this.processMultiBarNavItem.bind(this, e, c)), this.userLoginNav && (this.processNavItem(e, this.userLoginNav), c.login = d.render(this.mainUserLoginLinkFlyoutTemplate, this.userLoginNav)), c.siblings = d.render(a("#nav-main-links-tmpl").html(), {children: this.tree.children[0].children}), c.staticItems = d.render(this.mainLinksFlyoutTemplate, {
                children: b.filter(this.tree.children, function (a) {
                    return a.altLocation
                })
            }), c.sub = d.render(this.mainLinksFlyoutTemplate, {
                children: b.filter(this.tree.children, function (a) {
                    return !a.altLocation
                })
            }), c.flyout = d.render(this.mainFlyoutTemplate, {flyouts: e}), d.render(a("#nav-main-2-tmpl").html(), c)
        },
        processNavItem: function (a, c) {
            var d = c.children, e = [];
            b.isArray(d) && (c.hilite = b.contains(this.pathIds, c.id), c.separated = !c.altDisplay, c.cID = c.id, c.singleCol = !0, b.isString(c.altText) && "" !== c.altText && (c.text = c.altText), this.transformTree(e, c), a.push({
                pID: c.id,
                children: e
            }))
        },
        processMultiBarNavItem: function (a, c, d) {
            var e, f = d.children, g = [];
            if (b.isArray(f)) {
                if (d.hilite = b.contains(this.pathIds, d.id), b.isString(d.altText) && "" !== d.altText) {
                    var h = this.path[1], i = h;
                    if (b.has(h, "relatedId") && (i = b.findWhere(f, {id: h.relatedId})), b.isUndefined(i) && !b.contains(f, h)) {
                        var j = b.indexOf(this.path[0].children, h);
                        b.isObject(f[j]) && (i = f[j])
                    }
                    i.separated = !0, d.cID = i.id, e = i.id, c.toggle = i.text, this.transformTree(g, i)
                } else d.separated = !d.altDisplay, d.cID = d.id, d.singleCol = !0, e = d.id, this.transformTree(g, d);
                a.push({pID: e, children: g})
            }
        },
        transformTree: function (a, c, d) {
            var e = [], f = d;
            if (b.isNumber(f) || (f = 0), this.navbars < 2 && 3 < f) return void (c.cID = !1);
            if (c.hilite = b.contains(this.pathIds, c.id), !b.isUndefined(c.children)) {
                b.isUndefined(a[f]) && (a[f] = {level: f + 1, lists: []}), c.children.forEach(function (d) {
                    d.separated = !!c.separated, d.hilite = b.contains(this.pathIds, d.id);
                    var e = d.children;
                    b.isArray(e) && (c.singleCol = !1, d.cID = d.id, this.transformTree(a, d, f + 1))
                }.bind(this));
                var g = c.children.length;
                if (!c.separated && g >= 8) {
                    var h = g >= 16 ? 3 : 2, i = Math.ceil(g / h);
                    b.each(b.chunk(c.children, i), function (a) {
                        e.push(a)
                    })
                }
                0 === e.length ? a[f].lists.push({
                    separated: c.separated,
                    pID: c.id,
                    items: c.children
                }) : (a[f].cols = e.length, e.forEach(function (b) {
                    a[f].lists.push({cols: e.length, separated: c.separated, pID: c.id, items: b})
                }))
            }
        },
        initPathIds: function () {
            b.has(this.tree, "id") && this.tree.id === this.pathIds[0] && this.pathIds.shift()
        },
        initPath: function () {
            for (var a, c, d, e = this.pathIds.slice(); void 0 !== (a = e.shift());) c = 0 === this.path.length ? this.tree : this.path[this.path.length - 1], b.isUndefined(c) || b.isUndefined(c.children) || (d = b.findWhere(c.children, {id: a}), this.path.push(d))
        },
        hideOnOutsideClick: function (b) {
            var c = a(b.target);
            0 < c.parents(this.navFlyoutSelector).length || 0 < c.parents(".nav-current li").length || 0 < c.parents(".nav-parent li").length || 0 < c.parents("#desktop-nav-sub-container li").length || this.$(this.menuItemsSelector).filter("." + this.activeClass).trigger("click")
        },
        toggleSubMenu: function (b) {
            var c = b.currentTarget, d = a(c), e = d.parent(".nav-parent"), f = e.find(".nav-siblings");
            if (this.$flyout && this.$flyoutLayer && this.$flyout.hasClass(this.activeClass + " " + this.readyClass)) {
                var h = this.$(this.menuItemsSelector);
                h.filter("." + this.activeClass).toggleClass(this.activeClass).parent().siblings().find("a").removeClass(this.activeClass), this.toggleFlyout(h), this.activeMenuItem = "undefined", this.$flyout = null, this.$flyoutLayer = null
            }
            0 !== f.length && (b.preventDefault(), this.hideAll(), this.activeMenuItem === c ? (d.removeClass(this.activeClass), this.activeMenuItem = !1) : (a(this.activeMenuItem).removeClass(this.activeClass), d.addClass(this.activeClass), g.to(f, .15, {"max-height": f.find("ul").outerHeight()}), this.$openSubMenu = f, this.activeMenuItem = c))
        },
        processFlyout: function (b) {
            b.preventDefault();
            var c = a(b.target), d = c.data("flyout"), e = this.$(".toggle-main-dropdown");
            this.hasActiveItem = c.parents(".flyout").find("a.nav-flyout." + this.activeClass).not(c).length, this.isStaticMenuItem = c.parents(".nav-static").length, e.hasClass(this.activeClass) && (e.removeClass(this.activeClass), this.activeMenuItem = "undefined", this.hideSubMenu()), this.$flyout = this.$(this.navFlyoutSelector), this.$flyoutLayer = this.$flyout.find('.nav-flyout[data-flyout="' + d + '"]'), this.hasActiveItem ? (this.setToDefault(this.$flyoutLayer.find(".col-primary .list-items")), this.updateFlyoutContent(this.$flyoutLayer, c)) : this.toggleFlyout(c), this.updateMenuItemState(c)
        },
        updateFlyoutContent: function (a, b) {
            this.$flyout.removeClass(this.activeClass), (!this.isStaticMenuItem && !this.$breadcrumb.hasClass("hide") || this.isStaticMenuItem && this.hasActiveItem && this.$breadcrumb.hasClass("hide")) && (b.parents(".flyout").find(".center-wrapper.menu").toggleClass(this.activeClass), this.toggleBreadcrumb()), window.setTimeout(this.updateFlyoutContentDelayed.bind(this, a, b), 160)
        },
        updateFlyoutContentDelayed: function (a, b) {
            a.addClass(this.activeClass).siblings().removeClass(this.activeClass), this.toggleStaticFlyoutPosition(), this.toggleSmallFlyout(b), this.$flyout.addClass(this.activeClass)
        },
        toggleBreadcrumb: function () {
            this.$breadcrumb.toggleClass(this.activeClass), window.setTimeout(this.$breadcrumb.toggleClass.bind(this.$breadcrumb, "hide"), 200)
        },
        toggleSmallFlyout: function (a) {
            a.hasClass(this.smallFlyout) ? (this.$flyout.addClass(this.smallFlyout), this.calcFlyoutPosition(a, this.$flyout)) : this.$flyout.removeClass(this.smallFlyout).css({
                left: this.flyoutGridOffset,
                right: this.flyoutGridOffset,
                transform: ""
            })
        },
        toggleStaticFlyoutPosition: function () {
            this.isStaticMenuItem ? this.$flyout.addClass(this.staticItem) : this.$flyout.removeClass(this.staticItem)
        },
        updateMenuItemState: function (a) {
            var b = 0, c = a.closest(".flyout").find(this.menuItemsSelector).not(a);
            !a.hasClass(this.activeClass) && c.filter("." + this.activeClass).length && (c.removeClass(this.activeClass), b = 380), window.setTimeout(a.toggleClass.bind(a, "active"), b)
        },
        calcFlyoutPosition: function (a, b) {
            if (a.length && b.length) {
                var c = a.parents("nav"), d = a.offset().left - c.offset().left, e = a.outerWidth(),
                    f = d + e / 2 - b.width() / 2, g = 0;
                f < 0 && (f = 0), 2 === this.navbars && a.hasClass("nav-flyout-top") && (g = this.$(".menu-wrapper").outerHeight()), g = g > 0 ? "translateY(-" + g + "px)" : "", b.width() + f > c.width() ? b.css({
                    left: "auto",
                    right: 0,
                    transform: g
                }) : b.css({left: f, right: "auto", transform: g})
            }
        },
        recalculateFlyout: function () {
            this.calcFlyoutPosition(this.$("a").filter("." + this.smallFlyout + "." + this.activeClass), this.$(this.navFlyoutSelector).filter("." + this.smallFlyout + "." + this.activeClass))
        },
        toggleFlyout: function (b) {
            this.$flyoutLayer.addClass(this.activeClass).siblings().removeClass(this.activeClass), b.parents(".center-wrapper").toggleClass(this.activeClass), this.isStaticMenuItem || this.toggleBreadcrumb(), this.toggleSmallFlyout(b), this.$flyout.toggleClass(this.activeClass), window.setTimeout(this.$flyout.toggleClass.bind(this.$flyout, "ready"), 200), this.$flyout.hasClass(this.activeClass) ? a(document).on("click.outsideFlyout", this.hideOnOutsideClick.bind(this)) : a(document).off("click.outsideFlyout"), this.toggleStaticFlyoutPosition()
        },
        showNavList: function (b) {
            var c, d = a(b.target), e = d.data("id");
            e && (b.preventDefault(), c = d.closest('div[class*="col-"]').next().find('ul[data-id="' + e + '"]'), d.addClass(this.activeClass).parent().siblings().find("a").removeClass(this.activeClass), this.setToDefault(c), c.each(function (b, c) {
                a(c).addClass(this.activeClass).siblings(':not([data-id="' + e + '"])').removeClass(this.activeClass)
            }.bind(this)))
        },
        setToDefault: function (a) {
            a.find("a").removeClass(this.activeClass).siblings().find("a").removeClass(this.activeClass), a.parent().nextAll("div").find(".list-items").removeClass(this.activeClass)
        },
        toggleSearch: function (b) {
            b.preventDefault();
            var c = a(b.target), d = c.parent().find("input");
            c.toggleClass(this.searchToggleClass).parent().toggleClass(this.activeClass), c.parent().hasClass(this.activeClass) ? (c.parent().find(".btn-close-search").addClass(this.searchToggleClass), window.setTimeout(d.focus.bind(d), 500), window.setTimeout(d.addClass.bind(d, this.activeClass), 100)) : (d.removeClass(this.activeClass), c.parent().find(".btn-search").addClass(this.searchToggleClass), d.val(""))
        },
        hideAll: function () {
            this.$openSubMenu && this.hideSubMenu(), this.$openFlyout && this.hideFlyout()
        },
        hideSubMenu: function () {
            this.$openSubMenu && g.to(this.$openSubMenu, .15, {
                css: {maxHeight: 51}, onComplete: function () {
                    this.target.css("max-height", 0)
                }
            }), this.$openSubMenu = null
        },
        hideFlyout: function () {
            g.to(this.$openFlyout, .25, {"max-height": 0}), this.$openFlyout = null
        }
    });
    return function (a) {
        return this instanceof h ? this : new h(a)
    }
}), define("views/navigation-view", ["jquery", "underscore", "backbone", "TweenLite", "equal-height", "gsap.cssplugin"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        $openSubMenu: void 0,
        $openFlyout: void 0,
        activeMenuItem: void 0,
        events: {
            "click .nav-parent .toggle-submenu": "toggleSubMenu",
            "click .nav-parent .toggle-main-dropdown": "toggleSubMenu",
            "click .nav-parent .toggle-flyout": "toggleFlyout"
        },
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"]))
        },
        toggleSubMenu: function (b) {
            var c = b.currentTarget, e = a(c), f = e.parent(".nav-parent"), g = f.find(".nav-siblings");
            e.parents(".flyout").length || 0 === g.length || (b.preventDefault(), this.hideAll(), this.activeMenuItem === c ? (e.removeClass("active"), this.activeMenuItem = !1) : (a(this.activeMenuItem).removeClass("active"), e.addClass("active"), d.to(g, .15, {"max-height": g.find("ul").outerHeight()}), this.$openSubMenu = g, this.activeMenuItem = c))
        },
        toggleFlyout: function (c) {
            var e, f = c.currentTarget, g = a(f), h = g.data("flyout"), i = 0;
            b.isUndefined(h) || "" === h || (e = this.$('.desktop-nav-flyout-container[data-menu="' + h + '"]'), 0 !== e.length && (c.preventDefault(), this.hideAll(), this.activeMenuItem === f ? (g.removeClass("active"), this.activeMenuItem = !1) : (a(this.activeMenuItem).removeClass("active"), g.addClass("active"), e.find("ul").each(function () {
                i = Math.max(i, a(this).outerHeight())
            }), d.to(e, .25, {"max-height": i}), this.$openFlyout = e, this.activeMenuItem = f)))
        },
        hideAll: function () {
            this.$openSubMenu && this.hideSubMenu(), this.$openFlyout && this.hideFlyout()
        },
        hideSubMenu: function () {
            d.to(this.$openSubMenu, .15, {
                css: {maxHeight: 51}, onComplete: function () {
                    this.target.css("max-height", 0)
                }
            }), this.$openSubMenu = null
        },
        hideFlyout: function () {
            d.to(this.$openFlyout, .25, {"max-height": 0}), this.$openFlyout = null
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}),/*!
 * clipboard.js v2.0.6
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
    function (a, b) {
        "object" == typeof exports && "object" == typeof module ? module.exports = b() : "function" == typeof define && define.amd ? define("clipboard", [], b) : "object" == typeof exports ? exports.ClipboardJS = b() : a.ClipboardJS = b()
    }(this, function () {
        return function (a) {
            function b(d) {
                if (c[d]) return c[d].exports;
                var e = c[d] = {i: d, l: !1, exports: {}};
                return a[d].call(e.exports, e, e.exports, b), e.l = !0, e.exports
            }

            var c = {};
            return b.m = a, b.c = c, b.d = function (a, c, d) {
                b.o(a, c) || Object.defineProperty(a, c, {enumerable: !0, get: d})
            }, b.r = function (a) {
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(a, "__esModule", {value: !0})
            }, b.t = function (a, c) {
                if (1 & c && (a = b(a)), 8 & c) return a;
                if (4 & c && "object" == typeof a && a && a.__esModule) return a;
                var d = Object.create(null);
                if (b.r(d), Object.defineProperty(d, "default", {
                    enumerable: !0,
                    value: a
                }), 2 & c && "string" != typeof a) for (var e in a) b.d(d, e, function (b) {
                    return a[b]
                }.bind(null, e));
                return d
            }, b.n = function (a) {
                var c = a && a.__esModule ? function () {
                    return a.default
                } : function () {
                    return a
                };
                return b.d(c, "a", c), c
            }, b.o = function (a, b) {
                return Object.prototype.hasOwnProperty.call(a, b)
            }, b.p = "", b(b.s = 6)
        }([function (a, b) {
            function c(a) {
                var b;
                if ("SELECT" === a.nodeName) a.focus(), b = a.value; else if ("INPUT" === a.nodeName || "TEXTAREA" === a.nodeName) {
                    var c = a.hasAttribute("readonly");
                    c || a.setAttribute("readonly", ""), a.select(), a.setSelectionRange(0, a.value.length), c || a.removeAttribute("readonly"), b = a.value
                } else {
                    a.hasAttribute("contenteditable") && a.focus();
                    var d = window.getSelection(), e = document.createRange();
                    e.selectNodeContents(a), d.removeAllRanges(), d.addRange(e), b = d.toString()
                }
                return b
            }

            a.exports = c
        }, function (a, b) {
            function c() {
            }

            c.prototype = {
                on: function (a, b, c) {
                    var d = this.e || (this.e = {});
                    return (d[a] || (d[a] = [])).push({fn: b, ctx: c}), this
                }, once: function (a, b, c) {
                    function d() {
                        e.off(a, d), b.apply(c, arguments)
                    }

                    var e = this;
                    return d._ = b, this.on(a, d, c)
                }, emit: function (a) {
                    var b = [].slice.call(arguments, 1), c = ((this.e || (this.e = {}))[a] || []).slice(), d = 0,
                        e = c.length;
                    for (d; d < e; d++) c[d].fn.apply(c[d].ctx, b);
                    return this
                }, off: function (a, b) {
                    var c = this.e || (this.e = {}), d = c[a], e = [];
                    if (d && b) for (var f = 0, g = d.length; f < g; f++) d[f].fn !== b && d[f].fn._ !== b && e.push(d[f]);
                    return e.length ? c[a] = e : delete c[a], this
                }
            }, a.exports = c, a.exports.TinyEmitter = c
        }, function (a, b, c) {
            function d(a, b, c) {
                if (!a && !b && !c) throw new Error("Missing required arguments");
                if (!h.string(b)) throw new TypeError("Second argument must be a String");
                if (!h.fn(c)) throw new TypeError("Third argument must be a Function");
                if (h.node(a)) return e(a, b, c);
                if (h.nodeList(a)) return f(a, b, c);
                if (h.string(a)) return g(a, b, c);
                throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList")
            }

            function e(a, b, c) {
                return a.addEventListener(b, c), {
                    destroy: function () {
                        a.removeEventListener(b, c)
                    }
                }
            }

            function f(a, b, c) {
                return Array.prototype.forEach.call(a, function (a) {
                    a.addEventListener(b, c)
                }), {
                    destroy: function () {
                        Array.prototype.forEach.call(a, function (a) {
                            a.removeEventListener(b, c)
                        })
                    }
                }
            }

            function g(a, b, c) {
                return i(document.body, a, b, c)
            }

            var h = c(3), i = c(4);
            a.exports = d
        }, function (a, b) {
            b.node = function (a) {
                return void 0 !== a && a instanceof HTMLElement && 1 === a.nodeType
            }, b.nodeList = function (a) {
                var c = Object.prototype.toString.call(a);
                return void 0 !== a && ("[object NodeList]" === c || "[object HTMLCollection]" === c) && "length" in a && (0 === a.length || b.node(a[0]))
            }, b.string = function (a) {
                return "string" == typeof a || a instanceof String
            }, b.fn = function (a) {
                var b = Object.prototype.toString.call(a);
                return "[object Function]" === b
            }
        }, function (a, b, c) {
            function d(a, b, c, d, e) {
                var g = f.apply(this, arguments);
                return a.addEventListener(c, g, e), {
                    destroy: function () {
                        a.removeEventListener(c, g, e)
                    }
                }
            }

            function e(a, b, c, e, f) {
                return "function" == typeof a.addEventListener ? d.apply(null, arguments) : "function" == typeof c ? d.bind(null, document).apply(null, arguments) : ("string" == typeof a && (a = document.querySelectorAll(a)), Array.prototype.map.call(a, function (a) {
                    return d(a, b, c, e, f)
                }))
            }

            function f(a, b, c, d) {
                return function (c) {
                    c.delegateTarget = g(c.target, b), c.delegateTarget && d.call(a, c)
                }
            }

            var g = c(5);
            a.exports = e
        }, function (a, b) {
            function c(a, b) {
                for (; a && a.nodeType !== d;) {
                    if ("function" == typeof a.matches && a.matches(b)) return a;
                    a = a.parentNode
                }
            }

            var d = 9;
            if ("undefined" != typeof Element && !Element.prototype.matches) {
                var e = Element.prototype;
                e.matches = e.matchesSelector || e.mozMatchesSelector || e.msMatchesSelector || e.oMatchesSelector || e.webkitMatchesSelector
            }
            a.exports = c
        }, function (a, b, c) {
            function d(a, b) {
                if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function")
            }

            function e(a, b) {
                if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function")
            }

            function f(a, b) {
                if (!a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !b || "object" != typeof b && "function" != typeof b ? a : b
            }

            function g(a, b) {
                if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function, not " + typeof b);
                a.prototype = Object.create(b && b.prototype, {
                    constructor: {
                        value: a,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), b && (Object.setPrototypeOf ? Object.setPrototypeOf(a, b) : a.__proto__ = b)
            }

            function h(a, b) {
                var c = "data-clipboard-" + a;
                if (b.hasAttribute(c)) return b.getAttribute(c)
            }

            c.r(b);
            var i = c(0), j = c.n(i),
                k = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
                    return typeof a
                } : function (a) {
                    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a
                }, l = function () {
                    function a(a, b) {
                        for (var c = 0; c < b.length; c++) {
                            var d = b[c];
                            d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(a, d.key, d)
                        }
                    }

                    return function (b, c, d) {
                        return c && a(b.prototype, c), d && a(b, d), b
                    }
                }(), m = function () {
                    function a(b) {
                        d(this, a), this.resolveOptions(b), this.initSelection()
                    }

                    return l(a, [{
                        key: "resolveOptions", value: function () {
                            var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            this.action = a.action, this.container = a.container, this.emitter = a.emitter, this.target = a.target, this.text = a.text, this.trigger = a.trigger, this.selectedText = ""
                        }
                    }, {
                        key: "initSelection", value: function () {
                            this.text ? this.selectFake() : this.target && this.selectTarget()
                        }
                    }, {
                        key: "selectFake", value: function () {
                            var a = this, b = "rtl" == document.documentElement.getAttribute("dir");
                            this.removeFake(), this.fakeHandlerCallback = function () {
                                return a.removeFake()
                            }, this.fakeHandler = this.container.addEventListener("click", this.fakeHandlerCallback) || !0, this.fakeElem = document.createElement("textarea"), this.fakeElem.style.fontSize = "12pt", this.fakeElem.style.border = "0", this.fakeElem.style.padding = "0", this.fakeElem.style.margin = "0", this.fakeElem.style.position = "absolute", this.fakeElem.style[b ? "right" : "left"] = "-9999px";
                            var c = window.pageYOffset || document.documentElement.scrollTop;
                            this.fakeElem.style.top = c + "px", this.fakeElem.setAttribute("readonly", ""), this.fakeElem.value = this.text, this.container.appendChild(this.fakeElem), this.selectedText = j()(this.fakeElem), this.copyText()
                        }
                    }, {
                        key: "removeFake", value: function () {
                            this.fakeHandler && (this.container.removeEventListener("click", this.fakeHandlerCallback), this.fakeHandler = null, this.fakeHandlerCallback = null), this.fakeElem && (this.container.removeChild(this.fakeElem), this.fakeElem = null)
                        }
                    }, {
                        key: "selectTarget", value: function () {
                            this.selectedText = j()(this.target), this.copyText()
                        }
                    }, {
                        key: "copyText", value: function () {
                            var a = void 0;
                            try {
                                a = document.execCommand(this.action)
                            } catch (b) {
                                a = !1
                            }
                            this.handleResult(a)
                        }
                    }, {
                        key: "handleResult", value: function (a) {
                            this.emitter.emit(a ? "success" : "error", {
                                action: this.action,
                                text: this.selectedText,
                                trigger: this.trigger,
                                clearSelection: this.clearSelection.bind(this)
                            })
                        }
                    }, {
                        key: "clearSelection", value: function () {
                            this.trigger && this.trigger.focus(), document.activeElement.blur(), window.getSelection().removeAllRanges()
                        }
                    }, {
                        key: "destroy", value: function () {
                            this.removeFake()
                        }
                    }, {
                        key: "action", set: function () {
                            var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "copy";
                            if (this._action = a, "copy" !== this._action && "cut" !== this._action) throw new Error('Invalid "action" value, use either "copy" or "cut"')
                        }, get: function () {
                            return this._action
                        }
                    }, {
                        key: "target", set: function (a) {
                            if (void 0 !== a) {
                                if (!a || "object" !== ("undefined" == typeof a ? "undefined" : k(a)) || 1 !== a.nodeType) throw new Error('Invalid "target" value, use a valid Element');
                                if ("copy" === this.action && a.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                                if ("cut" === this.action && (a.hasAttribute("readonly") || a.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                                this._target = a
                            }
                        }, get: function () {
                            return this._target
                        }
                    }]), a
                }(), n = m, o = c(1), p = c.n(o), q = c(2), r = c.n(q),
                s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
                    return typeof a
                } : function (a) {
                    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a
                }, t = function () {
                    function a(a, b) {
                        for (var c = 0; c < b.length; c++) {
                            var d = b[c];
                            d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(a, d.key, d)
                        }
                    }

                    return function (b, c, d) {
                        return c && a(b.prototype, c), d && a(b, d), b
                    }
                }(), u = function (a) {
                    function b(a, c) {
                        e(this, b);
                        var d = f(this, (b.__proto__ || Object.getPrototypeOf(b)).call(this));
                        return d.resolveOptions(c), d.listenClick(a), d
                    }

                    return g(b, a), t(b, [{
                        key: "resolveOptions", value: function () {
                            var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            this.action = "function" == typeof a.action ? a.action : this.defaultAction, this.target = "function" == typeof a.target ? a.target : this.defaultTarget, this.text = "function" == typeof a.text ? a.text : this.defaultText, this.container = "object" === s(a.container) ? a.container : document.body
                        }
                    }, {
                        key: "listenClick", value: function (a) {
                            var b = this;
                            this.listener = r()(a, "click", function (a) {
                                return b.onClick(a)
                            })
                        }
                    }, {
                        key: "onClick", value: function (a) {
                            var b = a.delegateTarget || a.currentTarget;
                            this.clipboardAction && (this.clipboardAction = null), this.clipboardAction = new n({
                                action: this.action(b),
                                target: this.target(b),
                                text: this.text(b),
                                container: this.container,
                                trigger: b,
                                emitter: this
                            })
                        }
                    }, {
                        key: "defaultAction", value: function (a) {
                            return h("action", a)
                        }
                    }, {
                        key: "defaultTarget", value: function (a) {
                            var b = h("target", a);
                            if (b) return document.querySelector(b)
                        }
                    }, {
                        key: "defaultText", value: function (a) {
                            return h("text", a)
                        }
                    }, {
                        key: "destroy", value: function () {
                            this.listener.destroy(), this.clipboardAction && (this.clipboardAction.destroy(), this.clipboardAction = null)
                        }
                    }], [{
                        key: "isSupported", value: function () {
                            var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["copy", "cut"],
                                b = "string" == typeof a ? [a] : a, c = !!document.queryCommandSupported;
                            return b.forEach(function (a) {
                                c = c && !!document.queryCommandSupported(a)
                            }), c
                        }
                    }]), b
                }(p.a);
            b.default = u
        }]).default
    }), define("views/order-no-view", ["jquery", "underscore", "backbone", "clipboard"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        events: {
            click: "showCopyFeedback",
            "click .hint": "preventAction",
            "click .copy-msg": "preventAction",
            mouseenter: "show",
            mouseleave: "hide"
        }, initialize: function (a) {
            this.eventDispatcher = window.app.eventDispatcher, this.datahint = this.$el.data("hint"), this.dataCopyMsg = this.$el.data("copy-msg"), this.$container = this.$el, this.$hint = null, this.$copyMsg = null, this.copyClass = "copied-to-clipboard", this.stashClass = "messages-stashed", this.timeoutCopy = null, this.timeoutStash = null, this.prepareTooltips(), this.initializeClipboard(), this.render()
        }, render: function () {
            return this.$container.append(this.$hint), this.$container.append(this.$copyMsg), this
        }, show: function () {
            this.unstashMessages(), this.$el.addClass("show")
        }, hide: function () {
            this.$el.removeClass("show"), this.$el.hasClass(this.copyClass) || this.stashMessages()
        }, stashMessages: function () {
            var a = this;
            clearTimeout(this.timeoutStash), this.timeoutStash = window.setTimeout(a.$el.addClass.bind(a.$el, a.stashClass), 400)
        }, unstashMessages: function () {
            this.$el.removeClass(this.stashClass)
        }, preventAction: function (a) {
            this.$container.hasClass(this.copyClass) || a.stopPropagation()
        }, initializeClipboard: function () {
            this.clipboard = new d(this.el)
        }, prepareTooltips: function () {
            var b = this;
            this.$hint = a('<div class="hint"><div class="tooltip-content">' + this.datahint + "</div></div>"), this.$copyMsg = a('<div class="copy-msg"><div class="tooltip-content">' + this.$("p").text() + " " + this.dataCopyMsg + '<span class="btn-close-msg"></span></div></div>'), this.$copyMsg.on("click", function (c) {
                if (a(c.target).hasClass("btn-close-msg")) {
                    var d = a(this);
                    clearTimeout(b.timeoutCopy), b.timeoutCopy = null, d.fadeOut(300, function () {
                        b.$container.removeClass(b.copyClass), d.removeAttr("style")
                    })
                }
            }), this.$el.addClass(this.stashClass)
        }, showCopyFeedback: function (a) {
            a.preventDefault(), a.stopPropagation(), this.unstashMessages(), this.$container.addClass(this.copyClass), clearTimeout(this.timeoutCopy), this.timeoutCopy = window.setTimeout(this.showCopyFeedbackDelayed.bind(this), 5e3)
        }, showCopyFeedbackDelayed: function () {
            this.$container.removeClass(this.copyClass), this.stashMessages()
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), function (a) {
    "function" == typeof define && define.amd ? define("wnumb", [], a) : "object" == typeof exports ? module.exports = a() : window.wNumb = a()
}(function () {
    "use strict";

    function a(a) {
        return a.split("").reverse().join("")
    }

    function b(a, b) {
        return a.substring(0, b.length) === b
    }

    function c(a, b) {
        return a.slice(-1 * b.length) === b
    }

    function d(a, b, c) {
        if ((a[b] || a[c]) && a[b] === a[c]) throw new Error(b)
    }

    function e(a) {
        return "number" == typeof a && isFinite(a)
    }

    function f(a, b) {
        return a = a.toString().split("e"), a = Math.round(+(a[0] + "e" + (a[1] ? +a[1] + b : b))), a = a.toString().split("e"), (+(a[0] + "e" + (a[1] ? +a[1] - b : -b))).toFixed(b)
    }

    function g(b, c, d, g, h, i, j, k, l, m, n, o) {
        var p, q, r, s = o, t = "", u = "";
        return i && (o = i(o)), !!e(o) && (b !== !1 && 0 === parseFloat(o.toFixed(b)) && (o = 0), o < 0 && (p = !0, o = Math.abs(o)), b !== !1 && (o = f(o, b)), o = o.toString(), o.indexOf(".") !== -1 ? (q = o.split("."), r = q[0], d && (t = d + q[1])) : r = o, c && (r = a(r).match(/.{1,3}/g), r = a(r.join(a(c)))), p && k && (u += k), g && (u += g), p && l && (u += l), u += r, u += t, h && (u += h), m && (u = m(u, s)), u)
    }

    function h(a, d, f, g, h, i, j, k, l, m, n, o) {
        var p, q = "";
        return n && (o = n(o)), !(!o || "string" != typeof o) && (k && b(o, k) && (o = o.replace(k, ""), p = !0), g && b(o, g) && (o = o.replace(g, "")), l && b(o, l) && (o = o.replace(l, ""), p = !0), h && c(o, h) && (o = o.slice(0, -1 * h.length)), d && (o = o.split(d).join("")), f && (o = o.replace(f, ".")), p && (q += "-"), q += o, q = q.replace(/[^0-9\.\-.]/g, ""), "" !== q && (q = Number(q), j && (q = j(q)), !!e(q) && q))
    }

    function i(a) {
        var b, c, e, f = {};
        for (void 0 === a.suffix && (a.suffix = a.postfix), b = 0; b < l.length; b += 1) if (c = l[b], e = a[c], void 0 === e) "negative" !== c || f.negativeBefore ? "mark" === c && "." !== f.thousand ? f[c] = "." : f[c] = !1 : f[c] = "-"; else if ("decimals" === c) {
            if (!(e >= 0 && e < 8)) throw new Error(c);
            f[c] = e
        } else if ("encoder" === c || "decoder" === c || "edit" === c || "undo" === c) {
            if ("function" != typeof e) throw new Error(c);
            f[c] = e
        } else {
            if ("string" != typeof e) throw new Error(c);
            f[c] = e
        }
        return d(f, "mark", "thousand"), d(f, "prefix", "negative"), d(f, "prefix", "negativeBefore"), f
    }

    function j(a, b, c) {
        var d, e = [];
        for (d = 0; d < l.length; d += 1) e.push(a[l[d]]);
        return e.push(c), b.apply("", e)
    }

    function k(a) {
        return this instanceof k ? void ("object" == typeof a && (a = i(a), this.to = function (b) {
            return j(a, g, b)
        }, this.from = function (b) {
            return j(a, h, b)
        })) : new k(a)
    }

    var l = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
    return k
}), define("views/oscilloscope-filter-view", ["jquery", "underscore", "backbone", "TweenLite", "views/accordion-item-view", "noUiSlider", "mustache", "wnumb"], function (a, b, c, d, e, f, g, h) {
    "use strict";
    var i = c.View.extend({
        eventDispatcher: void 0,
        filters: {},
        filterOptions: void 0,
        accordionItemsRendered: !1,
        accordionItems: [],
        accordionElems: void 0,
        filterSliderInstances: [],
        products: void 0,
        $activeFilters: [],
        $activeFilterLabels: void 0,
        $activeFilterLabelList: void 0,
        $filterItems: void 0,
        $filterLayer: void 0,
        $filterSlider: void 0,
        events: {
            "change .toggle-filter-layer": "toggleFilterDisplay",
            "click .active-filters li button": "removeFilterItem",
            "click .active-item-value": "removeFilterItemFallback",
            "click .product-filter-apply": "applyFilters",
            "click .product-filter-remove, .active-filters-reset": "resetAllFilters",
            "click .filter-layer .info-icon, .filter-layer .interactions .close": "toggleTooltip",
            'change .filter-layer input[type="checkbox"], .filter-layer input[type="radio"]': "toggleFilter"
        },
        initialize: function (a) {
            this.filterOptions = window[this.$el.attr("data-filterdata")], !b.isUndefined(this.filterOptions) && b.isObject(this.filterOptions) && (this.$filterLayer = this.$(".filter-layer"), this.$activeFilterLabels = this.$(".active-filters"), this.$activeFilterLabelList = this.$activeFilterLabels.find("ul"), this.products = a.products, this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render())
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.renderFilter)
        },
        render: function () {
            return this.prepareFilters(), this
        },
        toggleTooltip: function (b) {
            var c = a(b.target).parent();
            c.parents(".filter-section").siblings().find(".interactions:not(.hide)").addClass("hide"), c.fadeOut(100, function () {
                var a, b, d = c.parents("form.filters");
                c.removeClass("align-right"), c.toggleClass("hide").show(), a = d.offset().left + d.width() + 40, b = c.offset().left + c.outerWidth(), b > a && c.addClass("align-right")
            })
        },
        renderFilter: function () {
            var a = window.app.matchMedia.getCurrentMediaQuery(), b = "media-to-m" === a;
            b ? this.renderAccordion() : this.destroyAccordion()
        },
        prepareFilters: function () {
            var a = g.render(this.$("#filter-tmpl").html(), this.filterOptions);
            this.$(".filters").html(a), this.initFilterSliders(), this.$el.hasClass("initialized") || this.$el.addClass("initialized"), this.renderFilter(), this.$(".filters input:checked").trigger("change"), this.updateFilters()
        },
        applyFilters: function (b) {
            b.preventDefault(), this.updateFilters(), a("html, body").animate({scrollTop: this.$el.offset().top - (a("#header.fixed").outerHeight() || 0) || 0}, 200), this.$(".toggle-filter-layer")[0].checked = !1, this.collapseFilter()
        },
        toggleFilter: function (c) {
            var d, e, f, g = c.target, h = a(g), i = h.data("property");
            g.checked === !0 ? (this.filters.hasOwnProperty(i) || (this.filters[i] = []), d = {
                elem: g,
                $elem: h
            }, e = h.val(), b.isNaN(Number(e)) ? (e.indexOf("|") !== -1 && (f = e.split("|"), d.min = Number(f[0]), d.max = Number(f[1])), d.value = e) : d.value = Number(e), "radio" === g.type ? this.filters[i] = [d] : this.filters[i].push(d)) : this.filters.hasOwnProperty(i) && (this.filters[i] = b.reject(this.filters[i], function (a) {
                return a.elem === g
            }), 0 === this.filters[i].length && delete this.filters[i])
        },
        renderAccordion: function () {
            if (this.accordionElems = this.$(".product-option"), this.accordionItemsRendered === !1) {
                for (var b = 0, c = this.accordionElems.length; b < c; b++) this.accordionItems.push(e({
                    el: this.accordionElems[b],
                    parent: this
                }));
                this.accordionItemsRendered = !0
            }
            a.each(this.accordionItems, this.reinitEvents.bind(this))
        },
        reinitEvents: function (a, b) {
            b.delegateEvents()
        },
        destroyAccordion: function () {
            var b = a.Event("reset", {target: this.el, relatedTarget: this.el});
            this.eventDispatcher.trigger(window.app.applicationEvents.ACCORDION_RESET, b, this)
        },
        toggleFilterDisplay: function (b) {
            a(b.target).is(":checked") ? this.expandFilter() : this.collapseFilter()
        },
        expandFilter: function () {
            var a = this.$filterLayer.find("> :last-child");
            d.to(this.$filterLayer, .3, {
                css: {maxHeight: a.position().top + a.outerHeight(), opacity: 1},
                onComplete: this.freeContent,
                onCompleteScope: this
            })
        },
        collapseFilter: function () {
            this.$filterLayer.css({
                "max-height": this.$filterLayer.outerHeight(),
                opacity: 1
            }), d.to(this.$filterLayer, .3, {
                css: {maxHeight: 0, opacity: 0},
                onComplete: this.resetContent,
                onCompleteScope: this
            })
        },
        freeContent: function () {
            this.$filterLayer.css({"max-height": "none", opacity: ""})
        },
        resetContent: function () {
            this.$filterLayer.css({"max-height": "", opacity: ""})
        },
        initFilterSliders: function () {
            this.$filterSlider = this.$(".slider-bar:not(.noUi-target)"), 0 !== this.$filterSlider.length && a.each(this.filterOptions.filterSections, this.parseFilterSection.bind(this))
        },
        parseFilterSection: function (a, b) {
            return b.sectionClass.search(/\bslider\b/) !== -1 && this.initFilterSlider(b.filterOptions[0]), !0
        },
        initFilterSlider: function (b) {
            var c, d = this.$filterSlider.filter("[data-property=" + b.property + "]")[0], e = h({
                encoder: function (a) {
                    return b.units && a >= 1e3 ? parseInt(a.toString().replace(/(000)*$/g, "")) : a
                }, edit: function (a, c) {
                    return b.units ? a + " " + b.units[b.rangeValues.indexOf(c.toString())] : a + b.unit
                }
            });
            d && (b.range = {}, a.each(b.rangeValues, this.setRangeValue.bind(b, b.rangeValues.length, b.range)), c = f.create(d, {
                animate: !0,
                connect: !0,
                range: b.range,
                tooltips: [e, e],
                start: [b.defaultValues[0], b.defaultValues[1]],
                snap: !0
            }), a(c.target).data("slider", b), c.on("set", this.onSliderChange.bind(this, c, b.rangeValues)), c.set(), this.filterSliderInstances.push(c))
        },
        setRangeValue: function (a, b, c) {
            var d = 100 / (a - 1) * c;
            0 === c ? b.min = parseInt(this.rangeValues[c]) : c === a - 1 ? b.max = parseInt(this.rangeValues[c]) : b[d + "%"] = parseInt(this.rangeValues[c])
        },
        onSliderChange: function (b, c, d, e, f) {
            var g, h, i = b.target, j = a(i), k = j.data("property");
            f[0] !== Number(c[0]) || f[1] !== Number(c[c.length - 1]) ? (this.filters.hasOwnProperty(k) || (this.filters[k] = []), g = f[0], h = f[1], this.filters[k] = [{
                elem: i,
                $elem: j,
                value: [g, h].join("|"),
                min: g,
                max: h
            }]) : delete this.filters[k]
        },
        updateFilters: function () {
            var b;
            this.$activeFilters = [], this.$(".product-option").each(this.populateFiltersData.bind(this)), this.$activeFilterLabelList.empty(), this.renderActiveFilterLabels(), this.$filterItems = this.$(".filters input:checked, .filter-slider .slider-bar"), this.$activeFilterLabelList[0].hasChildNodes() ? this.$activeFilterLabels.addClass("shown") : this.$activeFilterLabels.removeClass("shown"), b = a.Event("update", {
                filters: this.filters,
                $filterContainer: this.$el
            }), this.eventDispatcher.trigger(window.app.applicationEvents.OSCILLOSCOPE_FILTER_UPDATE, b), this.renderCount()
        },
        renderActiveFilterLabels: function () {
            var b = this;
            a.each(this.$activeFilters, function (a, c) {
                var d = c[0], e = c[1], f = b.getRenderedFilterLabel(d, e);
                f && f.appendTo(b.$activeFilterLabelList)
            })
        },
        populateFiltersData: function (b, c) {
            var d, e = this, f = a(c), g = f.find(".title")[0].childNodes[0].nodeValue.trim();
            a.each(f, function (b, c) {
                d = a(c).find("input:checked, .filter-slider .slider-bar"), d.length && e.$activeFilters.push([g, d])
            })
        },
        getRenderedFilterLabel: function (c, d) {
            var e, f, g, h = a('<span class="active-item-title"></span>'), i = [], j = [];
            return a.each(d, function (c, d) {
                var f, g, h, k = a(d), l = a('<span class="active-item-value"></span>'), m = a("<button>").text("X");
                if (k.is("input")) j.push(k), i.push(l.html(k.next().html()).prepend(m)), m.data({
                    filter: k,
                    type: "input"
                }); else {
                    if (f = k[0].noUiSlider, b.isUndefined(f) || !b.isObject(f)) return;
                    if (g = f.options.range, h = f.get(), g.min < parseInt(h[0], 10) || parseInt(h[1], 10) < g.max) {
                        var n = a('<span class="active-item-range"></span>'), o = m.clone(), p = m.clone(),
                            q = l.clone().html(k.find(".noUi-handle-lower").text()).prepend(o),
                            r = l.clone().html(k.find(".noUi-handle-upper").text()).prepend(p);
                        n.append(q, '<span class="separator">-</span>', r), i.push(n), e = {
                            filter: f,
                            type: "slider"
                        }, o.data({filter: f, type: "slider", targetRange: "min"}), p.data({
                            filter: f,
                            type: "slider",
                            targetRange: "max"
                        })
                    }
                }
            }), f = a("<li/>").html(h.html(c)), a.each(i, function (a, b) {
                f.append(b)
            }), j.length && void 0 === e && (e = {
                filter: j,
                type: "input"
            }), g = a("<button>").text("X").prependTo(f), g.data(e), i.length ? f : null
        },
        resetAllFilters: function () {
            this.$filterItems.each(this.resetFilter.bind(this))
        },
        resetFilter: function (b, c) {
            var d, e = a(c);
            e.is("input") ? e.prop("checked") === !0 && e.prop("checked", !1).trigger("change") : e.is(".slider-bar") && (d = e[0].noUiSlider, d.updateOptions({start: [0, d.options.range.max]})), this.updateFilters()
        },
        removeFilterItem: function (b) {
            b.stopPropagation();
            var c, d, e = a(b.target).data(), f = [];
            "input" === e.type ? (c = e.filter, a.each(c, function (b, c) {
                var d = a(c);
                d.prop("checked") === !0 && d.prop("checked", !1).trigger("change")
            })) : "slider" === e.type && (d = e.filter, f = [0, d.options.range.max], "min" === e.targetRange ? f = [0, d.get()[1]] : "max" === e.targetRange && (f = [d.get()[0], d.options.range.max]), d.updateOptions({start: f})), this.updateFilters()
        },
        removeFilterItemFallback: function (b) {
            if (a("html").hasClass("touchevents")) {
                var c = a.Event("click");
                c.target = a(b.target).find("button")[0], this.removeFilterItem(c)
            }
        },
        renderCount: function () {
            var b, c = this.$el.parents(".module").find(".product-list .shown").length;
            this.$el.find(".result").each(function (d, e) {
                b = a(e).find("output"), b.html(c)
            })
        }
    });
    return function (a) {
        return this instanceof i ? this : new i(a)
    }
}), define("app/router", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.Router.extend({
        routes: {"": "defaultRoute", "m(/*args)": "changeModuleState", "pc(/*args)": "openProductComparison"},
        initialize: function () {
            this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), c.history.start()
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.MODULE_STATE, this.onModuleStateChange), this.listenTo(this.eventDispatcher, window.app.applicationEvents.PRODUCT_COMPARISON_OPEN, this.onProductComparisonOpen), this.listenTo(this.eventDispatcher, window.app.applicationEvents.PRODUCT_COMPARISON_CLOSE, this.onProductComparisonClose)
        },
        defaultRoute: function () {
            this.eventDispatcher.trigger(window.app.applicationEvents.ROUTER_DEFAULT)
        },
        onModuleStateChange: function (a) {
            var c, d, e, f, g, h = a.fragment;
            !b.isUndefined(h) && b.isString(h) && "" !== h && (c = window.location.hash, b.isUndefined(c) || !b.isString(c) || "" === c || null === c.match(/m\//) ? g = h : (e = c.split("/"), e.length < 2 ? g = h : (d = a.routeId, f = e[1], f.indexOf(d) !== -1 && (f = f.replace(new RegExp("(--)?" + d + "(:\\d+)+"), ""), f = f.replace(/^-+/, "").replace(/-+$/, "")), g = "" === f ? h : f + "--" + h)), this.navigate("m/" + g, {
                replace: !0,
                trigger: !1
            }))
        },
        changeModuleState: function (c) {
            var d, e, f = {};
            b.each(c.split("--"), function (a) {
                var b = a.split(":");
                e = b.shift(), f[e] = b
            }), d = a.Event("changestate", {
                fragment: c,
                states: f,
                jumpTo: e
            }), this.eventDispatcher.trigger(window.app.applicationEvents.ROUTER_MODULE_STATE, d)
        },
        onProductComparisonOpen: function (a) {
            var c, d = a.fragment;
            !b.isUndefined(d) && b.isString(d) && "" !== d && (c = window.location.hash, !b.isUndefined(c) && b.isString(c) && "" !== c && null !== c.match(/pc\//) || this.navigate("pc/" + a.fragment, {trigger: !1}))
        },
        onProductComparisonClose: function () {
            this.navigate("", {trigger: !1})
        },
        openProductComparison: function (b) {
            var c, d = b.split(":"), e = d.shift();
            c = a.Event("opencomparison", {
                fragment: b,
                products: d,
                listId: e
            }), this.eventDispatcher.trigger(window.app.applicationEvents.ROUTER_COMPARISON_OPEN, c)
        }
    });
    return function () {
        var a;
        return {
            getInstance: function () {
                return void 0 === a && (a = new d), a
            }
        }
    }()
}), define("views/table-product-comparison-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.$tableContainer = this.$(".table-container"), this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.render)
        }, render: function () {
            return this.checkTableWidth(), this
        }, checkTableWidth: function () {
            var a = parseInt(this.$tableContainer.width(), 10), b = parseInt(this.$("table").width(), 10);
            a < b ? this.$tableContainer.addClass("overflow") : this.$tableContainer.removeClass("overflow")
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/table-view", ["jquery", "underscore", "backbone", "equal-height"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.isComparisonTable = "undefined" != typeof this.options.comparisonContainer, this.$tableContainer = this.isComparisonTable ? this.$el : this.$el.find(".table"), this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.initTableContainer.bind(this))
        }, render: function () {
            this.initTableContainer(), this.$tableContainer.on("scroll", this.onScroll.bind(this))
        }, initTableContainer: function () {
            this.initShadows(this.$tableContainer), this.$el.find("span.title").initHeightBoxes()
        }, onScroll: function (b) {
            this.initShadows(a(b.target))
        }, initShadows: function (b) {
            var c = this.isComparisonTable ? b : b.parent(), d = b.is(".table") ? b : b.find(".table"), e = 0;
            this.isComparisonTable && (e = parseInt(a(this.options.comparisonContainer).css("padding-left")));
            var f = parseInt(b.width()), g = parseInt(d.width()), h = parseInt(d.position().left), i = 3;
            h - e < -i ? c.addClass("overflow-left") : c.removeClass("overflow-left"), f - (g + h) < -i ? c.addClass("overflow-right") : c.removeClass("overflow-right")
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/product-comparison-view", ["jquery", "underscore", "backbone", "mustache", "app/router", "views/table-product-comparison-view", "views/table-view", "views/order-no-view", "magnific-popup", "equal-height"], function (a, b, c, d, e, f, g, h) {
    "use strict";
    var i = c.View.extend({
        storageId: void 0,
        $products: void 0,
        $productsCount: void 0,
        $compareButton: void 0,
        $toggleButton: void 0,
        productList: void 0,
        productTemplate: void 0,
        comparisonTable: void 0,
        $lightboxCover: void 0,
        compareAttributes: void 0,
        showMessageClass: "show-message",
        columnSelector: ".table-column",
        columnValuesSelector: ".table-column-values",
        events: {
            "click .compare-products": "compareProducts",
            "click .message": "hideMessage",
            "click .toggle-products.enabled": "toggleProducts",
            "click li[data-product-id]": "removeProductDirectly"
        },
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), e.getInstance(), this.parent = this.options.parent, this.$parent = this.options.$parent, this.productList = this.options.productList, this.compareAttributes = this.options.compareAttributes || null, this.productTemplate = '<li data-product-id="{{id}}">{{name}}</li>', d.parse(this.productTemplate), this.storageId = "rs-" + this.productList, this.orderNoViews = [], this.eventDispatcher = window.app.eventDispatcher, this.listenTo(this.eventDispatcher, window.app.applicationEvents.ROUTER_DEFAULT, this.onRouterDefault), this.listenTo(this.eventDispatcher, window.app.applicationEvents.ROUTER_COMPARISON_OPEN, this.onRouterComparisonOpen), this.setupListeners(), this.render()
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.PRODUCT_COMPARISON_ADD, this.addProduct), this.listenTo(this.eventDispatcher, window.app.applicationEvents.PRODUCT_COMPARISON_REMOVE, this.removeProduct), this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, b.debounce(this.setEqualHeightToRows, 200)), this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, b.debounce(this.adjustAccordion, 200))
        },
        render: function () {
            var a, c = this, d = c.getStoredProducts();
            c.$products = c.$("> ul"), c.$productsCount = c.$(".products-count-current"), c.$compareButton = c.$(".compare-products"), c.$toggleButton = c.$(".toggle-products"), b.each(d, c.initProduct.bind(c)), c.$productsCount.text(d.length), c.setButtonStates(d.length), a = {
                disableOn: function () {
                    return c.checkProductsCount()
                }, removalDelay: 300, tClose: ""
            }, c.$compareButton.not('[href^="#"]').magnificPopup(b.extend({}, a, {
                type: "ajax",
                ajax: {
                    settings: {
                        headers: {Accept: "application/javascript"},
                        cache: !1,
                        method: "POST",
                        dataType: "json",
                        data: {}
                    }
                },
                callbacks: {
                    beforeOpen: c.onBeforeLightboxOpen.bind(c),
                    open: c.onLightboxOpen.bind(c),
                    parseAjax: c.parseLightboxContent.bind(c),
                    ajaxContentAdded: c.onLightboxContentAdded.bind(c),
                    beforeClose: c.onLightboxBeforeClose.bind(c),
                    afterClose: c.onLightboxAfterClose.bind(c)
                }
            })), c.$compareButton.filter('[href^="#"]').magnificPopup(b.extend({}, a, {
                type: "inline",
                callbacks: {
                    change: c.onLightboxContentChanged.bind(c),
                    open: c.onLightboxOpen.bind(c),
                    beforeClose: c.onLightboxBeforeClose.bind(c),
                    afterClose: c.onLightboxAfterClose.bind(c)
                }
            }))
        },
        renderInitialProduct: function (b) {
            var c = d.render(this.productTemplate, b), e = a(c).appendTo(this.$products);
            e.addClass("show")
        },
        renderAddedProduct: function (b, c) {
            var e = d.render(this.productTemplate, b), f = a(e).appendTo(this.$products);
            f.addClass("show"), this.$productsCount.text(c)
        },
        renderRemovedProduct: function (a, b) {
            var c = this.$('li[data-product-id="' + a.id + '"]');
            c.removeClass("show").remove(), this.$productsCount.text(b)
        },
        initProduct: function (b, c, d) {
            var e = this.parent.$('[data-product-id="' + b + '"]'), f = {id: b, name: e.data("product-name")},
                g = a.Event("added", {
                    productId: f.id,
                    productName: f.name,
                    productList: this.productList,
                    productComparison: this,
                    storage: d
                });
            this.renderInitialProduct(f),
                window.setTimeout(this.eventDispatcher.trigger.bind(this.eventDispatcher, window.app.applicationEvents.PRODUCT_COMPARISON_ADDED, g), 0)
        },
        addProduct: function (c) {
            if (c.productComparison === this && c.productComparison.productList === this.productList) {
                var d, e, f = {id: "" + c.productId, name: c.productName}, g = this.getStoredProducts();
                b.contains(g, f.id) || g.unshift(f.id), d = g.slice(0, 3), g.slice(3).shift(), window.localStorage.setItem(this.storageId, window.JSON.stringify(d)), e = a.Event("added", {
                    productId: f.id,
                    productName: f.name,
                    productList: this.productList,
                    productComparison: this,
                    storage: d
                }), this.renderAddedProduct(f, d.length), this.setButtonStates(d.length), this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_COMPARISON_ADDED, e)
            }
        },
        removeProduct: function (c) {
            if (c.productComparison === this && c.productComparison.productList === this.productList) {
                var d, e, f = {id: "" + c.productId, name: c.productName}, g = this.getStoredProducts();
                !b.isUndefined(g) && b.isObject(g) && b.contains(g, f.id) && (d = b.without(g, f.id)), window.localStorage.setItem(this.storageId, window.JSON.stringify(d)), e = a.Event("removed", {
                    productId: f.id,
                    productName: f.name,
                    productList: this.productList,
                    productComparison: this,
                    storage: d
                });
                var h = d ? d.length : 0;
                this.renderRemovedProduct(f, h), this.setButtonStates(h), this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_COMPARISON_REMOVED, e)
            }
        },
        removeProductDirectly: function (b) {
            var c = a(b.target), d = a.Event("remove", {
                productId: c.data("product-id"),
                productName: c.text(),
                productList: this.productList,
                productComparison: this
            });
            this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_COMPARISON_REMOVE, d)
        },
        toggleCompareData: function (b) {
            var c = a(b.target);
            b instanceof Event && b.preventDefault(), "none" === c.parents(this.columnSelector).find(this.columnValuesSelector).css("max-height") || c.hasClass("active") ? this.hideCompareData(c) : this.showCompareData(c)
        },
        showCompareData: function (a) {
            var b = a.parents(this.columnSelector).find(this.columnValuesSelector);
            b.css({maxHeight: "2000px"}), a.addClass("active"), b.addClass("active")
        },
        hideCompareData: function (a) {
            var b = a.parents(this.columnSelector).find(this.columnValuesSelector);
            a.removeClass("active"), b.removeClass("active"), b.css({maxHeight: "0"}), b.removeAttr("style")
        },
        setButtonStates: function (a) {
            a >= 1 ? this.$toggleButton.addClass("enabled") : (this.$toggleButton.removeClass("enabled"), this.$el.removeClass("show-products")), a >= 2 ? (this.$compareButton.addClass("enabled"), this.$el.removeClass(this.showMessageClass)) : this.$compareButton.removeClass("enabled")
        },
        compareProducts: function (a) {
            a.preventDefault(), this.$compareButton.hasClass("enabled") || this.$el.addClass(this.showMessageClass)
        },
        hideMessage: function () {
            this.$el.removeClass(this.showMessageClass)
        },
        toggleProducts: function () {
            this.$toggleButton.hasClass("enabled") && this.$el.toggleClass("show-products")
        },
        getStoredProducts: function () {
            var a = window.JSON.parse(window.localStorage.getItem(this.storageId));
            return !b.isUndefined(a) && b.isObject(a) || (a = []), a
        },
        checkProductsCount: function () {
            return this.getStoredProducts().length > 1
        },
        onRouterDefault: function () {
            a.magnificPopup.instance.isOpen && a.magnificPopup.close()
        },
        onRouterComparisonOpen: function (c) {
            if (c.listId === this.productList && b.isArray(c.products) && 0 !== c.products.length) {
                var d, e, f = this.getStoredProducts();
                b.each(f, function (b) {
                    d = a.Event("remove", {
                        productId: b,
                        productName: void 0,
                        productList: this.productList,
                        productComparison: this
                    }), window.setTimeout(this.eventDispatcher.trigger.bind(this.eventDispatcher, window.app.applicationEvents.PRODUCT_COMPARISON_REMOVE, d), 0)
                }, this), b.each(c.products, function (b) {
                    e = a.Event("add", {
                        productId: b,
                        productName: void 0,
                        productList: this.productList,
                        productComparison: this
                    }), window.setTimeout(this.eventDispatcher.trigger.bind(this.eventDispatcher, window.app.applicationEvents.PRODUCT_COMPARISON_ADD, e), 0)
                }, this), window.setTimeout(this.$compareButton.trigger.bind(this.$compareButton, "click"), 0)
            }
        },
        onBeforeLightboxOpen: function () {
            var b = {command: "ProductComparison", parameter: {products: this.getStoredProducts()}};
            a.magnificPopup.instance.st.ajax.settings.data = window.JSON.stringify(b)
        },
        onLightboxOpen: function () {
            this.$lightboxCover = a('<div class="cover"><div class="loader"/></div>').appendTo(a(".mfp-container")), 2 === this.getStoredProducts().length && a(".table").addClass("product-count-2");
            var b, c, d = this.getStoredProducts();
            d.unshift(this.productList), b = d.join(":"), c = a.Event("opencomparison", {fragment: b}), this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_COMPARISON_OPEN, c)
        },
        parseLightboxContent: function (a) {
            var c = a.data, d = c.products;
            return b.isUndefined(d) || !b.isArray(d) || 0 === d.length ? void (a.data = "<p>No products.</p>") : void (a.data = this.renderProductComparisonTable(d))
        },
        onLightboxContentAdded: function () {
            var b = this;
            this.removeLightboxCover(), this.comparisonTable = f({el: document.querySelector(".module-table-product-comparison")}), g({
                el: document.querySelector(".module-table-product-comparison .table-container"),
                parent: this,
                comparisonContainer: document.querySelector(".module-table-product-comparison .center-container")
            }), a(".mfp-content .order-number-text").each(function (a, c) {
                b.orderNoViews.push(h({el: c}))
            }), a.magnificPopup.instance.contentContainer.find(".collapse-toggle").click(this.toggleCompareData.bind(this)), a.magnificPopup.instance.contentContainer.find(".table-column:first-child .collapse-toggle").click(), this.setEqualHeightToRows()
        },
        onLightboxContentChanged: function (c) {
            var d, e, f, g, h, i = a.magnificPopup.instance, j = window.RS_productComparison,
                k = c.src.replace(/^#/, "");
            b.isObject(j) && b.isObject(j[k]) && b.isObject(j[k].products) && (d = this.getStoredProducts(), e = j[k].products, f = b.filter(e, function (a) {
                return d.indexOf(a.productId) !== -1
            })), g = this.renderProductComparisonTable(f), h = a(g), i.contentContainer.find(".mfp-close").detach().appendTo(h), i.contentContainer.prepend(h), i.content = h, window.setTimeout(this.onLightboxContentAdded.bind(this), 0)
        },
        onLightboxBeforeClose: function () {
            this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_COMPARISON_CLOSE)
        },
        onLightboxAfterClose: function () {
            !b.isUndefined(this.comparisonTable) && b.isObject(this.comparisonTable) && this.comparisonTable.remove()
        },
        removeLightboxCover: function () {
            this.$lightboxCover && 0 !== this.$lightboxCover.length && (this.$lightboxCover.remove(), this.$lightboxCover = null)
        },
        renderProductComparisonTable: function (b) {
            var c;
            this.compareAttributes ? this.mapAttributesToCompareProduct(b) : c = this.getCompareAttributesFromProduct(b);
            var e = a("#product-comparison-table-tmpl").html();
            return d.render(e, {products: b, attributes: c, columns: this.$productsCount.text()})
        },
        getCompareAttributesFromProduct: function (a) {
            for (var c, d, e = [], f = b.keys(a[0].attributes), g = 0, h = f.length; g < h; g++) {
                c = f[g], d = {title: c, values: []};
                for (var i = 0, j = a.length; i < j; i++) d.values.push(a[i].attributes[c]);
                e.push(d)
            }
            return e
        },
        mapAttributesToCompareProduct: function (a) {
            b.each(a, function (a) {
                a.attributes = [], b.each(this.compareAttributes, function (b, c) {
                    c = {label: b, value: a[c] || "-"}, a.attributes.push(c)
                })
            }.bind(this))
        },
        setEqualHeightToRows: function () {
            var c = parseInt(window.app.matchMedia.getBreakpoint("screen-m-min"), 10),
                d = parseInt(window.app.matchMedia.getBreakpoint("screen-l-min"), 10), e = window.innerWidth,
                f = a(".mfp-content .table-column");
            if (c >= e) return void a(".mfp-content .table-row").removeAttr("style");
            c <= e && d >= e && (a(".mfp-content .table-column:nth-child(3)").find(".table-row").removeAttr("style"), f = f.not(":nth-child(3)"));
            var g = f.find(".table-column-heading");
            a(g).find(".text-wrapper").setEqualHeight();
            var h = this.compareAttributes ? Object.keys(this.compareAttributes).length : 0, i = [];
            b.each(f, function (c) {
                b.each(a(c).find(".table-row"), function (b, c) {
                    a(b.parentElement).hasClass("table-column-fixed") || (c -= h), i.push({index: c, value: b})
                })
            });
            var j = b.mapObject(b.groupBy(i, "index"), function (a) {
                return a.map(function (a) {
                    return b.omit(a, "index")
                }).map(function (a) {
                    return a.value
                })
            });
            b.each(Object.keys(j), function (b) {
                a(j[b]).setEqualHeight()
            })
        },
        adjustAccordion: function () {
            var b = parseInt(window.app.matchMedia.getBreakpoint("screen-m-min"), 10), c = window.innerWidth;
            if (b >= c) {
                var d = a(".table-column:first-child .collapse-toggle");
                d.hasClass("active") || d.click()
            }
            b <= c && a(".table-column-values.active").css("max-height", "none")
        }
    });
    return function (a) {
        return this instanceof i ? this : new i(a)
    }
}), define("views/product-equal-height-view", ["jquery", "underscore", "backbone", "views/equal-height-view"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        initialize: function (a) {
            this.setColumnHeight()
        }, setColumnHeight: function () {
            a(".table-head .table-column").each(function () {
                this.setEqualHeight()
            })
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("views/product-filter-view", ["jquery", "underscore", "backbone", "TweenLite", "views/accordion-item-view", "noUiSlider", "mustache"], function (a, b, c, d, e, f, g) {
    "use strict";
    var h = c.View.extend({
        filters: {},
        filterOptions: window.rsProductFilter,
        range: [],
        rangeLabels: [],
        defaultValues: [],
        accordionItemsRendered: !1,
        accordionItems: [],
        filterSliderInstances: [],
        $filterItems: void 0,
        $filterLayer: void 0,
        $filterSlider: void 0,
        events: {
            "change .toggle-filter-layer": "toggleFilterDisplay",
            "click .active-filters button": "removeFilterItem",
            "click .product-filter-apply": "applyFilters",
            "click .product-filter-remove": "resetAllFilters",
            'change .filter-layer input[type="checkbox"], .filter-layer input[type="radio"]': "toggleFilter"
        },
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), !b.isUndefined(this.filterOptions) && b.isObject(this.filterOptions) && (this.$filterLayer = this.$(".filter-layer"), this.$activeFilter = this.$(".active-filters"), this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render())
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.renderFilter)
        },
        render: function () {
            return 0 === this.$activeFilter.length && (this.$activeFilter = a('<ul class="active-filters"></ul>').appendTo(this.$el)), this.prepareFilters(), this
        },
        renderFilter: function () {
            var a = window.app.matchMedia.getCurrentMediaQuery(), b = "media-to-m" === a;
            b ? this.renderAccordion() : this.destroyAccordion()
        },
        prepareFilters: function () {
            var a = g.render(this.$("#filter-tmpl").html(), this.filterOptions);
            this.$(".filters").html(a), this.initFilterSliders(), this.showFilter(), this.renderFilter(), this.$(".filters input:checked").trigger("change"), this.updateFilters()
        },
        showFilter: function () {
            this.$el.hasClass("initialized") || this.$el.addClass("initialized")
        },
        applyFilters: function (b) {
            b.preventDefault(), this.updateFilters();
            var c = a("#header.fixed").outerHeight() || 0;
            a("html, body").animate({scrollTop: this.$activeFilter.offset().top - c || 0}, 200)
        },
        toggleFilter: function (c) {
            var d, e, f, g = c.target, h = a(g), i = h.data("property");
            g.checked === !0 ? (this.filters.hasOwnProperty(i) || (this.filters[i] = []), d = {
                elem: g,
                $elem: h
            }, e = h.val(), b.isNaN(Number(e)) ? (e.indexOf("|") !== -1 && (f = e.split("|"), d.min = Number(f[0]), d.max = Number(f[1])), d.value = e) : d.value = Number(e), "radio" === g.type ? this.filters[i] = [d] : this.filters[i].push(d)) : this.filters.hasOwnProperty(i) && (this.filters[i] = b.reject(this.filters[i], function (a) {
                return a.elem === g
            }), 0 === this.filters[i].length && delete this.filters[i])
        },
        renderAccordion: function () {
            if (this.accordionElems = this.$(".product-option"), this.accordionItemsRendered === !1) {
                for (var b = 0, c = this.accordionElems.length; b < c; b++) this.accordionItems.push(e({
                    el: this.accordionElems[b],
                    parent: this
                }));
                this.accordionItemsRendered = !0
            }
            a.each(this.accordionItems, this.reinitEvents.bind(this))
        },
        reinitEvents: function (a, b) {
            b.delegateEvents()
        },
        destroyAccordion: function () {
            var b = a.Event("reset", {target: this.el, relatedTarget: this.el});
            this.eventDispatcher.trigger(window.app.applicationEvents.ACCORDION_RESET, b, this)
        },
        toggleFilterDisplay: function (b) {
            a(b.target).is(":checked") ? this.expandFilter() : this.collapseFilter()
        },
        expandFilter: function () {
            var a = this.$filterLayer.find("> :last-child");
            d.to(this.$filterLayer, .3, {
                css: {maxHeight: a.position().top + a.outerHeight(), opacity: 1},
                onComplete: this.freeContent,
                onCompleteScope: this
            })
        },
        collapseFilter: function () {
            this.$filterLayer.css({"max-height": this.$filterLayer.outerHeight()}), d.to(this.$filterLayer, .3, {
                css: {
                    maxHeight: 0,
                    opacity: 0
                }, onComplete: this.resetContent, onCompleteScope: this
            })
        },
        freeContent: function () {
            this.$filterLayer.css({"max-height": "none", opacity: ""})
        },
        resetContent: function () {
            this.$filterLayer.css({"max-height": "", opacity: ""})
        },
        initFilterSliders: function () {
            this.$filterSlider = this.$(".slider-bar:not(.noUi-target)"), 0 !== this.$filterSlider.length && a.each(this.filterOptions.filterSections, this.parseFilterSection.bind(this))
        },
        parseFilterSection: function (b, c) {
            return c.sectionClass.search(/\bslider\b/) === -1 || (a.each(c.filterOptions, this.initFilterSlider.bind(this)), !1)
        },
        initFilterSlider: function (b, c) {
            var d, e = this.$filterSlider.eq(b)[0], g = c.defaultValues, h = c.rangeValues;
            this.range.push({}), a.each(h, this.setRangeValue.bind(this, h.length, this.range[b])), this.rangeLabels.push(h), this.defaultValues.push(g), d = f.create(e, {
                animate: !0,
                connect: !0,
                range: this.range[b],
                start: this.getDefaultHandlePositions(b),
                snap: !0
            }), a(d.target).data("defaults", g), d.on("update", this.onSliderUpdate.bind(this, d, h)), d.on("set", this.onSliderChange.bind(this, d, h)), d.set(), this.filterSliderInstances.push(d), this.updateFilters()
        },
        setRangeValue: function (a, b, c) {
            var d = 100 / (a - 1) * c;
            0 === c ? b.min = c : c === a - 1 ? b.max = c : b[d + "%"] = c
        },
        onSliderUpdate: function (b, c, d, e) {
            var f = c[parseInt(d[e])], g = f.match(/(?:\d*\.)?\d+/g), h = a(b.target).prev(".slider-values"),
                i = [h.find(".lower"), h.find(".upper")];
            i[e].html(f).next("input").val(g)
        },
        onSliderChange: function (b, c, d, e, f) {
            var g, h, i = b.target, j = a(i), k = j.data("property");
            0 !== f[0] || f[1] !== c.length - 1 ? (this.filters.hasOwnProperty(k) || (this.filters[k] = []), g = Number(c[f[0]]), h = Number(c[f[1]]), this.filters[k] = [{
                elem: i,
                $elem: j,
                value: [g, h].join("|"),
                min: g,
                max: h
            }]) : delete this.filters[k]
        },
        updateFilters: function () {
            var b;
            this.$filterItems = this.$(".filters input:checked, .slider-values"), this.$activeFilter.empty(), this.$filterItems.each(this.updateFilter.bind(this)), b = a.Event("update", {filters: this.filters}), this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_FILTER_UPDATE, b)
        },
        updateFilter: function (c, d) {
            var e, f, g, h, i, j, k = a(d), l = "";
            if (k.is("input")) l = k.next().html(), h = {filter: k, type: "input"}; else {
                if (e = k.next(".slider-bar")[0].noUiSlider, b.isUndefined(e) || !b.isObject(e)) return;
                f = e.options.range, g = e.get(), (f.min < parseInt(g[0], 10) || parseInt(g[1], 10) < f.max) && (l = k.find(".filter-range").text(), h = {
                    filter: e,
                    type: "slider"
                })
            }
            "" !== l && (i = a("<li/>").text(l), j = a("<button>").text("X").appendTo(i), j.data(h), i.appendTo(this.$activeFilter))
        },
        getDefaultHandlePositions: function (a) {
            var b = this.rangeLabels[a], c = this.defaultValues[a];
            return [b.indexOf(c[0]), b.indexOf(c[1])]
        },
        resetAllFilters: function () {
            this.$filterItems.each(this.resetFilter.bind(this))
        },
        resetFilter: function (b, c) {
            var d, e = a(c);
            e.is("input") ? e.prop("checked") === !0 && e.prop("checked", !1).trigger("change") : e.is(".slider-values") && (d = e.next(".noUi-target")[0].noUiSlider, d.updateOptions({start: [0, d.options.range.max]})), this.updateFilters()
        },
        removeFilterItem: function (b) {
            var c, d, e = a(b.target).data();
            "input" === e.type ? (c = e.filter, c.prop("checked") === !0 && c.prop("checked", !1).trigger("change")) : "slider" === e.type && (d = e.filter, d.updateOptions({start: [0, d.options.range.max]})), this.updateFilters()
        }
    });
    return function (a) {
        return this instanceof h ? this : new h(a)
    }
}), define("views/product-header-view", ["jquery", "underscore", "backbone", "views/howtobuy-linklist-view", "magnific-popup"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        $lightboxCover: void 0, initialize: function (a) {
            var c = this;
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.$badges = this.$(".badges"), this.$(".howtobuy-linklist-open").magnificPopup({
                type: "ajax",
                ajax: {cache: !1},
                callbacks: {
                    open: this.onLightboxOpen.bind(this), ajaxContentAdded: function () {
                        c.onLightboxContentLoaded(this, c)
                    }, afterClose: this.onLightboxAfterClose.bind(this)
                },
                removalDelay: 300,
                tClose: ""
            }), this.render()
        }, render: function () {
            this.$badges.length && this.$badges.find("li").length && this.$el.addClass("hasBadges")
        }, onLightboxOpen: function () {
            this.$lightboxCover = a('<div class="cover"><div class="loader"/></div>').appendTo(a(".mfp-container"))
        }, onLightboxContentLoaded: function (a, b) {
            b.$lightboxCover && 0 !== b.$lightboxCover.length && (b.$lightboxCover.remove(), b.$lightboxCover = null), b.linklistView = d({el: document.querySelector(".module-howtobuy-linklist")})
        }, onLightboxAfterClose: function () {
            !b.isUndefined(this.linklistView) && b.isObject(this.linklistView) && this.linklistView.remove()
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("views/product-key-features-view", ["jquery", "underscore", "backbone", "views/equal-height-view"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), d({
                $el: this.$el,
                el: this.el,
                $targets: this.$(".product-key-features-intro, .product-key-features")
            })
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}),/*!
 * ScrollMagic v2.0.5 (2015-04-29)
 * The javascript library for magical scroll interactions.
 * (c) 2015 Jan Paepke (@janpaepke)
 * Project Website: http://scrollmagic.io
 *
 * @version 2.0.5
 * @license Dual licensed under MIT license and GPL.
 * @author Jan Paepke - e-mail@janpaepke.de
 *
 * @file ScrollMagic main library.
 */
    function (a, b) {
        "function" == typeof define && define.amd ? define("ScrollMagic", b) : "object" == typeof exports ? module.exports = b() : a.ScrollMagic = b()
    }(this, function () {
        "use strict";
        var a = function () {
            e.log(2, "(COMPATIBILITY NOTICE) -> As of ScrollMagic 2.0.0 you need to use 'new ScrollMagic.Controller()' to create a new controller instance. Use 'new ScrollMagic.Scene()' to instance a scene.")
        };
        a.version = "2.0.5", window.addEventListener("mousewheel", function () {
        });
        var b = "data-scrollmagic-pin-spacer";
        a.Controller = function (d) {
            var f, g, h = "ScrollMagic.Controller", i = "FORWARD", j = "REVERSE", k = "PAUSED", l = c.defaults,
                m = this, n = e.extend({}, l, d), o = [], p = !1, q = 0, r = k, s = !0, t = 0, u = !0, v = function () {
                    for (var b in n) l.hasOwnProperty(b) || (E(2, 'WARNING: Unknown option "' + b + '"'), delete n[b]);
                    if (n.container = e.get.elements(n.container)[0], !n.container) throw E(1, "ERROR creating object " + h + ": No valid scroll container supplied"), h + " init failed.";
                    s = n.container === window || n.container === document.body || !document.body.contains(n.container), s && (n.container = window), t = y(), n.container.addEventListener("resize", C), n.container.addEventListener("scroll", C), n.refreshInterval = parseInt(n.refreshInterval) || l.refreshInterval, w(), E(3, "added new " + h + " controller (v" + a.version + ")")
                }, w = function () {
                    n.refreshInterval > 0 && (g = window.setTimeout(D, n.refreshInterval))
                }, x = function () {
                    return n.vertical ? e.get.scrollTop(n.container) : e.get.scrollLeft(n.container)
                }, y = function () {
                    return n.vertical ? e.get.height(n.container) : e.get.width(n.container)
                }, z = this._setScrollPos = function (a) {
                    n.vertical ? s ? window.scrollTo(e.get.scrollLeft(), a) : n.container.scrollTop = a : s ? window.scrollTo(a, e.get.scrollTop()) : n.container.scrollLeft = a
                }, A = function () {
                    if (u && p) {
                        var a = e.type.Array(p) ? p : o.slice(0);
                        p = !1;
                        var b = q;
                        q = m.scrollPos();
                        var c = q - b;
                        0 !== c && (r = c > 0 ? i : j), r === j && a.reverse(), a.forEach(function (b, c) {
                            E(3, "updating Scene " + (c + 1) + "/" + a.length + " (" + o.length + " total)"), b.update(!0)
                        }), 0 === a.length && n.loglevel >= 3 && E(3, "updating 0 Scenes (nothing added to controller)")
                    }
                }, B = function () {
                    f = e.rAF(A)
                }, C = function (a) {
                    E(3, "event fired causing an update:", a.type), "resize" == a.type && (t = y(), r = k), p !== !0 && (p = !0, B())
                }, D = function () {
                    if (!s && t != y()) {
                        var a;
                        try {
                            a = new Event("resize", {bubbles: !1, cancelable: !1})
                        } catch (b) {
                            a = document.createEvent("Event"), a.initEvent("resize", !1, !1)
                        }
                        n.container.dispatchEvent(a)
                    }
                    o.forEach(function (a, b) {
                        a.refresh()
                    }), w()
                }, E = this._log = function (a, b) {
                    n.loglevel >= a && (Array.prototype.splice.call(arguments, 1, 0, "(" + h + ") ->"), e.log.apply(window, arguments))
                };
            this._options = n;
            var F = function (a) {
                if (a.length <= 1) return a;
                var b = a.slice(0);
                return b.sort(function (a, b) {
                    return a.scrollOffset() > b.scrollOffset() ? 1 : -1
                }), b
            };
            return this.addScene = function (b) {
                if (e.type.Array(b)) b.forEach(function (a, b) {
                    m.addScene(a)
                }); else if (b instanceof a.Scene) {
                    if (b.controller() !== m) b.addTo(m); else if (o.indexOf(b) < 0) {
                        o.push(b), o = F(o), b.on("shift.controller_sort", function () {
                            o = F(o)
                        });
                        for (var c in n.globalSceneOptions) b[c] && b[c].call(b, n.globalSceneOptions[c]);
                        E(3, "adding Scene (now " + o.length + " total)")
                    }
                } else E(1, "ERROR: invalid argument supplied for '.addScene()'");
                return m
            }, this.removeScene = function (a) {
                if (e.type.Array(a)) a.forEach(function (a, b) {
                    m.removeScene(a)
                }); else {
                    var b = o.indexOf(a);
                    b > -1 && (a.off("shift.controller_sort"), o.splice(b, 1), E(3, "removing Scene (now " + o.length + " left)"), a.remove())
                }
                return m
            }, this.updateScene = function (b, c) {
                return e.type.Array(b) ? b.forEach(function (a, b) {
                    m.updateScene(a, c)
                }) : c ? b.update(!0) : p !== !0 && b instanceof a.Scene && (p = p || [], p.indexOf(b) == -1 && p.push(b), p = F(p), B()), m
            }, this.update = function (a) {
                return C({type: "resize"}), a && A(), m
            }, this.scrollTo = function (c, d) {
                if (e.type.Number(c)) z.call(n.container, c, d); else if (c instanceof a.Scene) c.controller() === m ? m.scrollTo(c.scrollOffset(), d) : E(2, "scrollTo(): The supplied scene does not belong to this controller. Scroll cancelled.", c); else if (e.type.Function(c)) z = c; else {
                    var f = e.get.elements(c)[0];
                    if (f) {
                        for (; f.parentNode.hasAttribute(b);) f = f.parentNode;
                        var g = n.vertical ? "top" : "left", h = e.get.offset(n.container), i = e.get.offset(f);
                        s || (h[g] -= m.scrollPos()), m.scrollTo(i[g] - h[g], d)
                    } else E(2, "scrollTo(): The supplied argument is invalid. Scroll cancelled.", c)
                }
                return m
            }, this.scrollPos = function (a) {
                return arguments.length ? (e.type.Function(a) ? x = a : E(2, "Provided value for method 'scrollPos' is not a function. To change the current scroll position use 'scrollTo()'."), m) : x.call(m)
            }, this.info = function (a) {
                var b = {
                    size: t,
                    vertical: n.vertical,
                    scrollPos: q,
                    scrollDirection: r,
                    container: n.container,
                    isDocument: s
                };
                return arguments.length ? void 0 !== b[a] ? b[a] : void E(1, 'ERROR: option "' + a + '" is not available') : b
            }, this.loglevel = function (a) {
                return arguments.length ? (n.loglevel != a && (n.loglevel = a), m) : n.loglevel
            }, this.enabled = function (a) {
                return arguments.length ? (u != a && (u = !!a, m.updateScene(o, !0)), m) : u
            }, this.destroy = function (a) {
                window.clearTimeout(g);
                for (var b = o.length; b--;) o[b].destroy(a);
                return n.container.removeEventListener("resize", C), n.container.removeEventListener("scroll", C), e.cAF(f), E(3, "destroyed " + h + " (reset: " + (a ? "true" : "false") + ")"), null
            }, v(), m
        };
        var c = {
            defaults: {
                container: window,
                vertical: !0,
                globalSceneOptions: {},
                loglevel: 2,
                refreshInterval: 100
            }
        };
        a.Controller.addOption = function (a, b) {
            c.defaults[a] = b
        }, a.Controller.extend = function (b) {
            var c = this;
            a.Controller = function () {
                return c.apply(this, arguments), this.$super = e.extend({}, this), b.apply(this, arguments) || this
            }, e.extend(a.Controller, c), a.Controller.prototype = c.prototype, a.Controller.prototype.constructor = a.Controller
        }, a.Scene = function (c) {
            var f, g, h = "ScrollMagic.Scene", i = "BEFORE", j = "DURING", k = "AFTER", l = d.defaults, m = this,
                n = e.extend({}, l, c), o = i, p = 0, q = {start: 0, end: 0}, r = 0, s = !0, t = function () {
                    for (var a in n) l.hasOwnProperty(a) || (v(2, 'WARNING: Unknown option "' + a + '"'), delete n[a]);
                    for (var b in l) D(b);
                    B()
                }, u = {};
            this.on = function (a, b) {
                return e.type.Function(b) ? (a = a.trim().split(" "), a.forEach(function (a) {
                    var c = a.split("."), d = c[0], e = c[1];
                    "*" != d && (u[d] || (u[d] = []), u[d].push({namespace: e || "", callback: b}))
                })) : v(1, "ERROR when calling '.on()': Supplied callback for '" + a + "' is not a valid function!"), m
            }, this.off = function (a, b) {
                return a ? (a = a.trim().split(" "), a.forEach(function (a, c) {
                    var d = a.split("."), e = d[0], f = d[1] || "", g = "*" === e ? Object.keys(u) : [e];
                    g.forEach(function (a) {
                        for (var c = u[a] || [], d = c.length; d--;) {
                            var e = c[d];
                            !e || f !== e.namespace && "*" !== f || b && b != e.callback || c.splice(d, 1)
                        }
                        c.length || delete u[a]
                    })
                }), m) : (v(1, "ERROR: Invalid event name supplied."), m)
            }, this.trigger = function (b, c) {
                if (b) {
                    var d = b.trim().split("."), e = d[0], f = d[1], g = u[e];
                    v(3, "event fired:", e, c ? "->" : "", c || ""), g && g.forEach(function (b, d) {
                        f && f !== b.namespace || b.callback.call(m, new a.Event(e, b.namespace, m, c))
                    })
                } else v(1, "ERROR: Invalid event name supplied.");
                return m
            }, m.on("change.internal", function (a) {
                "loglevel" !== a.what && "tweenChanges" !== a.what && ("triggerElement" === a.what ? y() : "reverse" === a.what && m.update())
            }).on("shift.internal", function (a) {
                w(), m.update()
            });
            var v = this._log = function (a, b) {
                n.loglevel >= a && (Array.prototype.splice.call(arguments, 1, 0, "(" + h + ") ->"), e.log.apply(window, arguments))
            };
            this.addTo = function (b) {
                return b instanceof a.Controller ? g != b && (g && g.removeScene(m), g = b, B(), x(!0), y(!0), w(), g.info("container").addEventListener("resize", z), b.addScene(m), m.trigger("add", {controller: g}), v(3, "added " + h + " to controller"), m.update()) : v(1, "ERROR: supplied argument of 'addTo()' is not a valid ScrollMagic Controller"), m
            }, this.enabled = function (a) {
                return arguments.length ? (s != a && (s = !!a, m.update(!0)), m) : s
            }, this.remove = function () {
                if (g) {
                    g.info("container").removeEventListener("resize", z);
                    var a = g;
                    g = void 0, a.removeScene(m), m.trigger("remove"), v(3, "removed " + h + " from controller")
                }
                return m
            }, this.destroy = function (a) {
                return m.trigger("destroy", {reset: a}), m.remove(), m.off("*.*"), v(3, "destroyed " + h + " (reset: " + (a ? "true" : "false") + ")"), null
            }, this.update = function (a) {
                if (g) if (a) if (g.enabled() && s) {
                    var b, c = g.info("scrollPos");
                    b = n.duration > 0 ? (c - q.start) / (q.end - q.start) : c >= q.start ? 1 : 0, m.trigger("update", {
                        startPos: q.start,
                        endPos: q.end,
                        scrollPos: c
                    }), m.progress(b)
                } else E && o === j && G(!0); else g.updateScene(m, !1);
                return m
            }, this.refresh = function () {
                return x(), y(), m
            }, this.progress = function (a) {
                if (arguments.length) {
                    var b = !1, c = o, d = g ? g.info("scrollDirection") : "PAUSED", e = n.reverse || a >= p;
                    if (0 === n.duration ? (b = p != a, p = a < 1 && e ? 0 : 1, o = 0 === p ? i : j) : a < 0 && o !== i && e ? (p = 0, o = i, b = !0) : a >= 0 && a < 1 && e ? (p = a, o = j, b = !0) : a >= 1 && o !== k ? (p = 1, o = k, b = !0) : o !== j || e || G(), b) {
                        var f = {progress: p, state: o, scrollDirection: d}, h = o != c, l = function (a) {
                            m.trigger(a, f)
                        };
                        h && c !== j && (l("enter"), l(c === i ? "start" : "end")), l("progress"), h && o !== j && (l(o === i ? "start" : "end"), l("leave"))
                    }
                    return m
                }
                return p
            };
            var w = function () {
                q = {start: r + n.offset}, g && n.triggerElement && (q.start -= g.info("size") * n.triggerHook), q.end = q.start + n.duration
            }, x = function (a) {
                if (f) {
                    var b = "duration";
                    C(b, f.call(m)) && !a && (m.trigger("change", {
                        what: b,
                        newval: n[b]
                    }), m.trigger("shift", {reason: b}))
                }
            }, y = function (a) {
                var c = 0, d = n.triggerElement;
                if (g && d) {
                    for (var f = g.info(), h = e.get.offset(f.container), i = f.vertical ? "top" : "left"; d.parentNode.hasAttribute(b);) d = d.parentNode;
                    var j = e.get.offset(d);
                    f.isDocument || (h[i] -= g.scrollPos()), c = j[i] - h[i]
                }
                var k = c != r;
                r = c, k && !a && m.trigger("shift", {reason: "triggerElementPosition"})
            }, z = function (a) {
                n.triggerHook > 0 && m.trigger("shift", {reason: "containerResize"})
            }, A = e.extend(d.validate, {
                duration: function (a) {
                    if (e.type.String(a) && a.match(/^(\.|\d)*\d+%$/)) {
                        var b = parseFloat(a) / 100;
                        a = function () {
                            return g ? g.info("size") * b : 0
                        }
                    }
                    if (e.type.Function(a)) {
                        f = a;
                        try {
                            a = parseFloat(f())
                        } catch (b) {
                            a = -1
                        }
                    }
                    if (a = parseFloat(a), !e.type.Number(a) || a < 0) throw f ? (f = void 0, ['Invalid return value of supplied function for option "duration":', a]) : ['Invalid value for option "duration":', a];
                    return a
                }
            }), B = function (a) {
                a = arguments.length ? [a] : Object.keys(A), a.forEach(function (a, b) {
                    var c;
                    if (A[a]) try {
                        c = A[a](n[a])
                    } catch (b) {
                        c = l[a];
                        var d = e.type.String(b) ? [b] : b;
                        e.type.Array(d) ? (d[0] = "ERROR: " + d[0], d.unshift(1), v.apply(this, d)) : v(1, "ERROR: Problem executing validation callback for option '" + a + "':", b.message)
                    } finally {
                        n[a] = c
                    }
                })
            }, C = function (a, b) {
                var c = !1, d = n[a];
                return n[a] != b && (n[a] = b, B(a), c = d != n[a]), c
            }, D = function (a) {
                m[a] || (m[a] = function (b) {
                    return arguments.length ? ("duration" === a && (f = void 0), C(a, b) && (m.trigger("change", {
                        what: a,
                        newval: n[a]
                    }), d.shifts.indexOf(a) > -1 && m.trigger("shift", {reason: a})), m) : n[a]
                })
            };
            this.controller = function () {
                return g
            }, this.state = function () {
                return o
            }, this.scrollOffset = function () {
                return q.start
            }, this.triggerPosition = function () {
                var a = n.offset;
                return g && (a += n.triggerElement ? r : g.info("size") * m.triggerHook()), a
            };
            var E, F;
            m.on("shift.internal", function (a) {
                var b = "duration" === a.reason;
                (o === k && b || o === j && 0 === n.duration) && G(), b && H()
            }).on("progress.internal", function (a) {
                G()
            }).on("add.internal", function (a) {
                H()
            }).on("destroy.internal", function (a) {
                m.removePin(a.reset)
            });
            var G = function (a) {
                if (E && g) {
                    var b = g.info(), c = F.spacer.firstChild;
                    if (a || o !== j) {
                        var d = {position: F.inFlow ? "relative" : "absolute", top: 0, left: 0},
                            f = e.css(c, "position") != d.position;
                        F.pushFollowers ? n.duration > 0 && (o === k && 0 === parseFloat(e.css(F.spacer, "padding-top")) ? f = !0 : o === i && 0 === parseFloat(e.css(F.spacer, "padding-bottom")) && (f = !0)) : d[b.vertical ? "top" : "left"] = n.duration * p, e.css(c, d), f && H()
                    } else {
                        "fixed" != e.css(c, "position") && (e.css(c, {position: "fixed"}), H());
                        var h = e.get.offset(F.spacer, !0),
                            l = n.reverse || 0 === n.duration ? b.scrollPos - q.start : Math.round(p * n.duration * 10) / 10;
                        h[b.vertical ? "top" : "left"] += l, e.css(F.spacer.firstChild, {top: h.top, left: h.left})
                    }
                }
            }, H = function () {
                if (E && g && F.inFlow) {
                    var a = o === j, b = g.info("vertical"), c = F.spacer.firstChild,
                        d = e.isMarginCollapseType(e.css(F.spacer, "display")), f = {};
                    F.relSize.width || F.relSize.autoFullWidth ? a ? e.css(E, {width: e.get.width(F.spacer)}) : e.css(E, {width: "100%"}) : (f["min-width"] = e.get.width(b ? E : c, !0, !0), f.width = a ? f["min-width"] : "auto"), F.relSize.height ? a ? e.css(E, {height: e.get.height(F.spacer) - (F.pushFollowers ? n.duration : 0)}) : e.css(E, {height: "100%"}) : (f["min-height"] = e.get.height(b ? c : E, !0, !d), f.height = a ? f["min-height"] : "auto"), F.pushFollowers && (f["padding" + (b ? "Top" : "Left")] = n.duration * p, f["padding" + (b ? "Bottom" : "Right")] = n.duration * (1 - p)), e.css(F.spacer, f)
                }
            }, I = function () {
                g && E && o === j && !g.info("isDocument") && G()
            }, J = function () {
                g && E && o === j && ((F.relSize.width || F.relSize.autoFullWidth) && e.get.width(window) != e.get.width(F.spacer.parentNode) || F.relSize.height && e.get.height(window) != e.get.height(F.spacer.parentNode)) && H()
            }, K = function (a) {
                g && E && o === j && !g.info("isDocument") && (a.preventDefault(), g._setScrollPos(g.info("scrollPos") - ((a.wheelDelta || a[g.info("vertical") ? "wheelDeltaY" : "wheelDeltaX"]) / 3 || 30 * -a.detail)))
            };
            this.setPin = function (a, c) {
                var d = {pushFollowers: !0, spacerClass: "scrollmagic-pin-spacer"};
                if (c = e.extend({}, d, c), a = e.get.elements(a)[0], !a) return v(1, "ERROR calling method 'setPin()': Invalid pin element supplied."), m;
                if ("fixed" === e.css(a, "position")) return v(1, "ERROR calling method 'setPin()': Pin does not work with elements that are positioned 'fixed'."), m;
                if (E) {
                    if (E === a) return m;
                    m.removePin()
                }
                E = a;
                var f = E.parentNode.style.display,
                    g = ["top", "left", "bottom", "right", "margin", "marginLeft", "marginRight", "marginTop", "marginBottom"];
                E.parentNode.style.display = "none";
                var h = "absolute" != e.css(E, "position"), i = e.css(E, g.concat(["display"])),
                    j = e.css(E, ["width", "height"]);
                E.parentNode.style.display = f, !h && c.pushFollowers && (v(2, "WARNING: If the pinned element is positioned absolutely pushFollowers will be disabled."), c.pushFollowers = !1), window.setTimeout(function () {
                    E && 0 === n.duration && c.pushFollowers && v(2, "WARNING: pushFollowers =", !0, "has no effect, when scene duration is 0.")
                }, 0);
                var k = E.parentNode.insertBefore(document.createElement("div"), E), l = e.extend(i, {
                    position: h ? "relative" : "absolute",
                    boxSizing: "content-box",
                    mozBoxSizing: "content-box",
                    webkitBoxSizing: "content-box"
                });
                if (h || e.extend(l, e.css(E, ["width", "height"])), e.css(k, l), k.setAttribute(b, ""), e.addClass(k, c.spacerClass), F = {
                    spacer: k,
                    relSize: {
                        width: "%" === j.width.slice(-1),
                        height: "%" === j.height.slice(-1),
                        autoFullWidth: "auto" === j.width && h && e.isMarginCollapseType(i.display)
                    },
                    pushFollowers: c.pushFollowers,
                    inFlow: h
                }, !E.___origStyle) {
                    E.___origStyle = {};
                    var o = E.style,
                        p = g.concat(["width", "height", "position", "boxSizing", "mozBoxSizing", "webkitBoxSizing"]);
                    p.forEach(function (a) {
                        E.___origStyle[a] = o[a] || ""
                    })
                }
                return F.relSize.width && e.css(k, {width: j.width}), F.relSize.height && e.css(k, {height: j.height}), k.appendChild(E), e.css(E, {
                    position: h ? "relative" : "absolute",
                    margin: "auto",
                    top: "auto",
                    left: "auto",
                    bottom: "auto",
                    right: "auto"
                }), (F.relSize.width || F.relSize.autoFullWidth) && e.css(E, {
                    boxSizing: "border-box",
                    mozBoxSizing: "border-box",
                    webkitBoxSizing: "border-box"
                }), window.addEventListener("scroll", I), window.addEventListener("resize", I), window.addEventListener("resize", J), E.addEventListener("mousewheel", K), E.addEventListener("DOMMouseScroll", K), v(3, "added pin"), G(), m
            }, this.removePin = function (a) {
                if (E) {
                    if (o === j && G(!0), a || !g) {
                        var c = F.spacer.firstChild;
                        if (c.hasAttribute(b)) {
                            var d = F.spacer.style,
                                f = ["margin", "marginLeft", "marginRight", "marginTop", "marginBottom"];
                            margins = {}, f.forEach(function (a) {
                                margins[a] = d[a] || ""
                            }), e.css(c, margins)
                        }
                        F.spacer.parentNode.insertBefore(c, F.spacer), F.spacer.parentNode.removeChild(F.spacer), E.parentNode.hasAttribute(b) || (e.css(E, E.___origStyle), delete E.___origStyle)
                    }
                    window.removeEventListener("scroll", I), window.removeEventListener("resize", I), window.removeEventListener("resize", J), E.removeEventListener("mousewheel", K), E.removeEventListener("DOMMouseScroll", K), E = void 0, v(3, "removed pin (reset: " + (a ? "true" : "false") + ")")
                }
                return m
            };
            var L, M = [];
            return m.on("destroy.internal", function (a) {
                m.removeClassToggle(a.reset)
            }), this.setClassToggle = function (a, b) {
                var c = e.get.elements(a);
                return 0 !== c.length && e.type.String(b) ? (M.length > 0 && m.removeClassToggle(), L = b, M = c, m.on("enter.internal_class leave.internal_class", function (a) {
                    var b = "enter" === a.type ? e.addClass : e.removeClass;
                    M.forEach(function (a, c) {
                        b(a, L)
                    })
                }), m) : (v(1, "ERROR calling method 'setClassToggle()': Invalid " + (0 === c.length ? "element" : "classes") + " supplied."), m)
            }, this.removeClassToggle = function (a) {
                return a && M.forEach(function (a, b) {
                    e.removeClass(a, L)
                }), m.off("start.internal_class end.internal_class"), L = void 0, M = [], m
            }, t(), m
        };
        var d = {
            defaults: {duration: 0, offset: 0, triggerElement: void 0, triggerHook: .5, reverse: !0, loglevel: 2},
            validate: {
                offset: function (a) {
                    if (a = parseFloat(a), !e.type.Number(a)) throw['Invalid value for option "offset":', a];
                    return a
                }, triggerElement: function (a) {
                    if (a = a || void 0) {
                        var b = e.get.elements(a)[0];
                        if (!b) throw['Element defined in option "triggerElement" was not found:', a];
                        a = b
                    }
                    return a
                }, triggerHook: function (a) {
                    var b = {onCenter: .5, onEnter: 1, onLeave: 0};
                    if (e.type.Number(a)) a = Math.max(0, Math.min(parseFloat(a), 1)); else {
                        if (!(a in b)) throw['Invalid value for option "triggerHook": ', a];
                        a = b[a]
                    }
                    return a
                }, reverse: function (a) {
                    return !!a
                }, loglevel: function (a) {
                    if (a = parseInt(a), !e.type.Number(a) || a < 0 || a > 3) throw['Invalid value for option "loglevel":', a];
                    return a
                }
            },
            shifts: ["duration", "offset", "triggerHook"]
        };
        a.Scene.addOption = function (b, c, e, f) {
            b in d.defaults ? a._util.log(1, "[static] ScrollMagic.Scene -> Cannot add Scene option '" + b + "', because it already exists.") : (d.defaults[b] = c, d.validate[b] = e, f && d.shifts.push(b))
        }, a.Scene.extend = function (b) {
            var c = this;
            a.Scene = function () {
                return c.apply(this, arguments), this.$super = e.extend({}, this), b.apply(this, arguments) || this
            }, e.extend(a.Scene, c), a.Scene.prototype = c.prototype, a.Scene.prototype.constructor = a.Scene
        }, a.Event = function (a, b, c, d) {
            d = d || {};
            for (var e in d) this[e] = d[e];
            return this.type = a, this.target = this.currentTarget = c, this.namespace = b || "", this.timeStamp = this.timestamp = Date.now(), this
        };
        var e = a._util = function (a) {
            var b, c = {}, d = function (a) {
                return parseFloat(a) || 0
            }, e = function (b) {
                return b.currentStyle ? b.currentStyle : a.getComputedStyle(b)
            }, f = function (b, c, f, g) {
                if (c = c === document ? a : c, c === a) g = !1; else if (!o.DomElement(c)) return 0;
                b = b.charAt(0).toUpperCase() + b.substr(1).toLowerCase();
                var h = (f ? c["offset" + b] || c["outer" + b] : c["client" + b] || c["inner" + b]) || 0;
                if (f && g) {
                    var i = e(c);
                    h += "Height" === b ? d(i.marginTop) + d(i.marginBottom) : d(i.marginLeft) + d(i.marginRight)
                }
                return h
            }, g = function (a) {
                return a.replace(/^[^a-z]+([a-z])/g, "$1").replace(/-([a-z])/g, function (a) {
                    return a[1].toUpperCase()
                })
            };
            c.extend = function (a) {
                for (a = a || {}, b = 1; b < arguments.length; b++) if (arguments[b]) for (var c in arguments[b]) arguments[b].hasOwnProperty(c) && (a[c] = arguments[b][c]);
                return a
            }, c.isMarginCollapseType = function (a) {
                return ["block", "flex", "list-item", "table", "-webkit-box"].indexOf(a) > -1
            };
            var h = 0, i = ["ms", "moz", "webkit", "o"], j = a.requestAnimationFrame, k = a.cancelAnimationFrame;
            for (b = 0; !j && b < i.length; ++b) j = a[i[b] + "RequestAnimationFrame"], k = a[i[b] + "CancelAnimationFrame"] || a[i[b] + "CancelRequestAnimationFrame"];
            j || (j = function (b) {
                var c = (new Date).getTime(), d = Math.max(0, 16 - (c - h)), e = a.setTimeout(function () {
                    b(c + d)
                }, d);
                return h = c + d, e
            }), k || (k = function (b) {
                a.clearTimeout(b)
            }), c.rAF = j.bind(a), c.cAF = k.bind(a);
            var l = ["error", "warn", "log"], m = a.console || {};
            for (m.log = m.log || function () {
            }, b = 0; b < l.length; b++) {
                var n = l[b];
                m[n] || (m[n] = m.log)
            }
            c.log = function (a) {
                (a > l.length || a <= 0) && (a = l.length);
                var b = new Date,
                    c = ("0" + b.getHours()).slice(-2) + ":" + ("0" + b.getMinutes()).slice(-2) + ":" + ("0" + b.getSeconds()).slice(-2) + ":" + ("00" + b.getMilliseconds()).slice(-3),
                    d = l[a - 1], e = Array.prototype.splice.call(arguments, 1),
                    f = Function.prototype.bind.call(m[d], m);
                e.unshift(c), f.apply(m, e)
            };
            var o = c.type = function (a) {
                return Object.prototype.toString.call(a).replace(/^\[object (.+)\]$/, "$1").toLowerCase()
            };
            o.String = function (a) {
                return "string" === o(a)
            }, o.Function = function (a) {
                return "function" === o(a)
            }, o.Array = function (a) {
                return Array.isArray(a)
            }, o.Number = function (a) {
                return !o.Array(a) && a - parseFloat(a) + 1 >= 0
            }, o.DomElement = function (a) {
                return "object" == typeof HTMLElement ? a instanceof HTMLElement : a && "object" == typeof a && null !== a && 1 === a.nodeType && "string" == typeof a.nodeName
            };
            var p = c.get = {};
            return p.elements = function (b) {
                var c = [];
                if (o.String(b)) try {
                    b = document.querySelectorAll(b)
                } catch (a) {
                    return c
                }
                if ("nodelist" === o(b) || o.Array(b)) for (var d = 0, e = c.length = b.length; d < e; d++) {
                    var f = b[d];
                    c[d] = o.DomElement(f) ? f : p.elements(f)
                } else (o.DomElement(b) || b === document || b === a) && (c = [b]);
                return c
            }, p.scrollTop = function (b) {
                return b && "number" == typeof b.scrollTop ? b.scrollTop : a.pageYOffset || 0
            }, p.scrollLeft = function (b) {
                return b && "number" == typeof b.scrollLeft ? b.scrollLeft : a.pageXOffset || 0
            }, p.width = function (a, b, c) {
                return f("width", a, b, c)
            }, p.height = function (a, b, c) {
                return f("height", a, b, c)
            }, p.offset = function (a, b) {
                var c = {top: 0, left: 0};
                if (a && a.getBoundingClientRect) {
                    var d = a.getBoundingClientRect();
                    c.top = d.top, c.left = d.left, b || (c.top += p.scrollTop(), c.left += p.scrollLeft())
                }
                return c
            }, c.addClass = function (a, b) {
                b && (a.classList ? a.classList.add(b) : a.className += " " + b)
            }, c.removeClass = function (a, b) {
                b && (a.classList ? a.classList.remove(b) : a.className = a.className.replace(new RegExp("(^|\\b)" + b.split(" ").join("|") + "(\\b|$)", "gi"), " "))
            }, c.css = function (a, b) {
                if (o.String(b)) return e(a)[g(b)];
                if (o.Array(b)) {
                    var c = {}, d = e(a);
                    return b.forEach(function (a, b) {
                        c[a] = d[g(a)]
                    }), c
                }
                for (var f in b) {
                    var h = b[f];
                    h == parseFloat(h) && (h += "px"), a.style[g(f)] = h
                }
            }, c
        }(window || {});
        return a.Scene.prototype.addIndicators = function () {
            return a._util.log(1, "(ScrollMagic.Scene) -> ERROR calling addIndicators() due to missing Plugin 'debug.addIndicators'. Please make sure to include plugins/debug.addIndicators.js"), this
        }, a.Scene.prototype.removeIndicators = function () {
            return a._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeIndicators() due to missing Plugin 'debug.addIndicators'. Please make sure to include plugins/debug.addIndicators.js"), this
        }, a.Scene.prototype.setTween = function () {
            return a._util.log(1, "(ScrollMagic.Scene) -> ERROR calling setTween() due to missing Plugin 'animation.gsap'. Please make sure to include plugins/animation.gsap.js"), this
        }, a.Scene.prototype.removeTween = function () {
            return a._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeTween() due to missing Plugin 'animation.gsap'. Please make sure to include plugins/animation.gsap.js"), this
        }, a.Scene.prototype.setVelocity = function () {
            return a._util.log(1, "(ScrollMagic.Scene) -> ERROR calling setVelocity() due to missing Plugin 'animation.velocity'. Please make sure to include plugins/animation.velocity.js"), this
        }, a.Scene.prototype.removeVelocity = function () {
            return a._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeVelocity() due to missing Plugin 'animation.velocity'. Please make sure to include plugins/animation.velocity.js"), this
        }, a
    }),/*!
 * ScrollMagic v2.0.5 (2015-04-29)
 * The javascript library for magical scroll interactions.
 * (c) 2015 Jan Paepke (@janpaepke)
 * Project Website: http://scrollmagic.io
 *
 * @version 2.0.5
 * @license Dual licensed under MIT license and GPL.
 * @author Jan Paepke - e-mail@janpaepke.de
 *
 * @file Debug Extension for ScrollMagic.
 */
    function (a, b) {
        "function" == typeof define && define.amd ? define("ScrollMagicIndicators", ["ScrollMagic"], b) : b("object" == typeof exports ? require("scrollmagic") : a.ScrollMagic || a.jQuery && a.jQuery.ScrollMagic)
    }(this, function (a) {
        "use strict";
        var b = "debug.addIndicators", c = window.console || {},
            d = Function.prototype.bind.call(c.error || c.log || function () {
            }, c);
        a || d("(" + b + ") -> ERROR: The ScrollMagic main module could not be found. Please make sure it's loaded before this plugin or use an asynchronous loader like requirejs.");
        var e = "0.85em", f = "9999", g = 15, h = a._util, i = 0;
        a.Scene.extend(function () {
            var a, b = this;
            b.addIndicators = function (c) {
                if (!a) {
                    var d = {
                        name: "",
                        indent: 0,
                        parent: void 0,
                        colorStart: "green",
                        colorEnd: "red",
                        colorTrigger: "blue"
                    };
                    c = h.extend({}, d, c), i++, a = new j(b, c), b.on("add.plugin_addIndicators", a.add), b.on("remove.plugin_addIndicators", a.remove), b.on("destroy.plugin_addIndicators", b.removeIndicators), b.controller() && a.add()
                }
                return b
            }, b.removeIndicators = function () {
                return a && (a.remove(), this.off("*.plugin_addIndicators"), a = void 0), b
            }
        }), a.Controller.addOption("addIndicators", !1), a.Controller.extend(function () {
            var c = this, d = c.info(), e = d.container, f = d.isDocument, i = d.vertical, j = {groups: []},
                k = function () {
                    c._log && (Array.prototype.splice.call(arguments, 1, 0, "(" + b + ")", "->"), c._log.apply(this, arguments))
                };
            c._indicators && k(2, "WARNING: Scene already has a property '_indicators', which will be overwritten by plugin."), this._indicators = j;
            var l = function () {
                j.updateBoundsPositions()
            }, m = function () {
                j.updateTriggerGroupPositions()
            };
            return e.addEventListener("resize", m), f || (window.addEventListener("resize", m), window.addEventListener("scroll", m)), e.addEventListener("resize", l), e.addEventListener("scroll", l), this._indicators.updateBoundsPositions = function (a) {
                for (var b, c, d, f = a ? [h.extend({}, a.triggerGroup, {members: [a]})] : j.groups, k = f.length, l = {}, m = i ? "left" : "top", n = i ? "width" : "height", o = i ? h.get.scrollLeft(e) + h.get.width(e) - g : h.get.scrollTop(e) + h.get.height(e) - g; k--;) for (d = f[k], b = d.members.length, c = h.get[n](d.element.firstChild); b--;) l[m] = o - c, h.css(d.members[b].bounds, l)
            }, this._indicators.updateTriggerGroupPositions = function (a) {
                for (var b, d, k, l, m, n = a ? [a] : j.groups, o = n.length, p = f ? document.body : e, q = f ? {
                    top: 0,
                    left: 0
                } : h.get.offset(p, !0), r = i ? h.get.width(e) - g : h.get.height(e) - g, s = i ? "width" : "height", t = i ? "Y" : "X"; o--;) b = n[o], d = b.element, k = b.triggerHook * c.info("size"), l = h.get[s](d.firstChild.firstChild), m = k > l ? "translate" + t + "(-100%)" : "", h.css(d, {
                    top: q.top + (i ? k : r - b.members[0].options.indent),
                    left: q.left + (i ? r - b.members[0].options.indent : k)
                }), h.css(d.firstChild.firstChild, {"-ms-transform": m, "-webkit-transform": m, transform: m})
            }, this._indicators.updateTriggerGroupLabel = function (a) {
                var b = "trigger" + (a.members.length > 1 ? "" : " " + a.members[0].options.name),
                    c = a.element.firstChild.firstChild, d = c.textContent !== b;
                d && (c.textContent = b, i && j.updateBoundsPositions())
            }, this.addScene = function (b) {
                this._options.addIndicators && b instanceof a.Scene && b.controller() === c && b.addIndicators(), this.$super.addScene.apply(this, arguments)
            }, this.destroy = function () {
                e.removeEventListener("resize", m), f || (window.removeEventListener("resize", m), window.removeEventListener("scroll", m)), e.removeEventListener("resize", l), e.removeEventListener("scroll", l), this.$super.destroy.apply(this, arguments)
            }, c
        });
        var j = function (a, c) {
            var d, e, f = this, g = k.bounds(), j = k.start(c.colorStart), l = k.end(c.colorEnd),
                m = c.parent && h.get.elements(c.parent)[0], n = function () {
                    a._log && (Array.prototype.splice.call(arguments, 1, 0, "(" + b + ")", "->"), a._log.apply(this, arguments))
                };
            c.name = c.name || i, j.firstChild.textContent += " " + c.name, l.textContent += " " + c.name, g.appendChild(j), g.appendChild(l), f.options = c, f.bounds = g, f.triggerGroup = void 0, this.add = function () {
                e = a.controller(), d = e.info("vertical");
                var b = e.info("isDocument");
                m || (m = b ? document.body : e.info("container")), b || "static" !== h.css(m, "position") || h.css(m, {position: "relative"}), a.on("change.plugin_addIndicators", p), a.on("shift.plugin_addIndicators", o), v(), s(), setTimeout(function () {
                    e._indicators.updateBoundsPositions(f)
                }, 0), n(3, "added indicators")
            }, this.remove = function () {
                if (f.triggerGroup) {
                    if (a.off("change.plugin_addIndicators", p), a.off("shift.plugin_addIndicators", o), f.triggerGroup.members.length > 1) {
                        var b = f.triggerGroup;
                        b.members.splice(b.members.indexOf(f), 1), e._indicators.updateTriggerGroupLabel(b), e._indicators.updateTriggerGroupPositions(b), f.triggerGroup = void 0
                    } else u();
                    r(), n(3, "removed indicators")
                }
            };
            var o = function () {
                s()
            }, p = function (a) {
                "triggerHook" === a.what && v()
            }, q = function () {
                var a = e.info("vertical");
                h.css(j.firstChild, {
                    "border-bottom-width": a ? 1 : 0,
                    "border-right-width": a ? 0 : 1,
                    bottom: a ? -1 : c.indent,
                    right: a ? c.indent : -1,
                    padding: a ? "0 8px" : "2px 4px"
                }), h.css(l, {
                    "border-top-width": a ? 1 : 0,
                    "border-left-width": a ? 0 : 1,
                    top: a ? "100%" : "",
                    right: a ? c.indent : "",
                    bottom: a ? "" : c.indent,
                    left: a ? "" : "100%",
                    padding: a ? "0 8px" : "2px 4px"
                }), m.appendChild(g)
            }, r = function () {
                g.parentNode.removeChild(g)
            }, s = function () {
                g.parentNode !== m && q();
                var b = {};
                b[d ? "top" : "left"] = a.triggerPosition(), b[d ? "height" : "width"] = a.duration(), h.css(g, b), h.css(l, {display: a.duration() > 0 ? "" : "none"})
            }, t = function () {
                var b = k.trigger(c.colorTrigger), g = {};
                g[d ? "right" : "bottom"] = 0, g[d ? "border-top-width" : "border-left-width"] = 1, h.css(b.firstChild, g), h.css(b.firstChild.firstChild, {padding: d ? "0 8px 3px 8px" : "3px 4px"}), document.body.appendChild(b);
                var i = {triggerHook: a.triggerHook(), element: b, members: [f]};
                e._indicators.groups.push(i), f.triggerGroup = i, e._indicators.updateTriggerGroupLabel(i), e._indicators.updateTriggerGroupPositions(i)
            }, u = function () {
                e._indicators.groups.splice(e._indicators.groups.indexOf(f.triggerGroup), 1), f.triggerGroup.element.parentNode.removeChild(f.triggerGroup.element), f.triggerGroup = void 0
            }, v = function () {
                var b = a.triggerHook(), c = 1e-4;
                if (!(f.triggerGroup && Math.abs(f.triggerGroup.triggerHook - b) < c)) {
                    for (var d, g = e._indicators.groups, h = g.length; h--;) if (d = g[h], Math.abs(d.triggerHook - b) < c) return f.triggerGroup && (1 === f.triggerGroup.members.length ? u() : (f.triggerGroup.members.splice(f.triggerGroup.members.indexOf(f), 1), e._indicators.updateTriggerGroupLabel(f.triggerGroup), e._indicators.updateTriggerGroupPositions(f.triggerGroup))), d.members.push(f), f.triggerGroup = d, void e._indicators.updateTriggerGroupLabel(d);
                    if (f.triggerGroup) {
                        if (1 === f.triggerGroup.members.length) return f.triggerGroup.triggerHook = b, void e._indicators.updateTriggerGroupPositions(f.triggerGroup);
                        f.triggerGroup.members.splice(f.triggerGroup.members.indexOf(f), 1), e._indicators.updateTriggerGroupLabel(f.triggerGroup), e._indicators.updateTriggerGroupPositions(f.triggerGroup), f.triggerGroup = void 0
                    }
                    t()
                }
            }
        }, k = {
            start: function (a) {
                var b = document.createElement("div");
                b.textContent = "start", h.css(b, {
                    position: "absolute",
                    overflow: "visible",
                    "border-width": 0,
                    "border-style": "solid",
                    color: a,
                    "border-color": a
                });
                var c = document.createElement("div");
                return h.css(c, {position: "absolute", overflow: "visible", width: 0, height: 0}), c.appendChild(b), c
            }, end: function (a) {
                var b = document.createElement("div");
                return b.textContent = "end", h.css(b, {
                    position: "absolute",
                    overflow: "visible",
                    "border-width": 0,
                    "border-style": "solid",
                    color: a,
                    "border-color": a
                }), b
            }, bounds: function () {
                var a = document.createElement("div");
                return h.css(a, {
                    position: "absolute",
                    overflow: "visible",
                    "white-space": "nowrap",
                    "pointer-events": "none",
                    "font-size": e
                }), a.style.zIndex = f, a
            }, trigger: function (a) {
                var b = document.createElement("div");
                b.textContent = "trigger", h.css(b, {position: "relative"});
                var c = document.createElement("div");
                h.css(c, {
                    position: "absolute",
                    overflow: "visible",
                    "border-width": 0,
                    "border-style": "solid",
                    color: a,
                    "border-color": a
                }), c.appendChild(b);
                var d = document.createElement("div");
                return h.css(d, {
                    position: "fixed",
                    overflow: "visible",
                    "white-space": "nowrap",
                    "pointer-events": "none",
                    "font-size": e
                }), d.style.zIndex = f, d.appendChild(c), d
            }
        }
    }), define("views/product-list-compare-button-view", ["jquery", "underscore", "backbone", "logger", "views/product-comparison-view", "ScrollMagic", "ScrollMagicIndicators"], function (a, b, c, d, e, f) {
    "use strict";
    var g = c.View.extend({
        logger: d.get("ProductListCompareButtonView"),
        productComparisonView: void 0,
        productListId: void 0,
        productListSelector: ".product-list",
        compareInputSelector: ".compare",
        compareButtonSelector: ".product-comparison",
        compareAttributes: void 0,
        isSticky: !1,
        duration: 100,
        shortDuration: 50,
        compareLimit: 3,
        offset: 0,
        events: {
            "click .compare:checked:not(:disabled)": "addToComparison",
            "click .compare:not(:checked):not(:disabled)": "removeFromComparison"
        },
        initialize: function (c) {
            this.options = b.extend({}, this.defaults, b.omit(c, ["el", "$el"])), this.productListId = this.options.productListId || this.$el.data("product-list"), this.duration = b.isNumber(this.options.duration) ? this.options.duration : this.duration, this.shortDuration = b.isNumber(this.options.shortDuration) ? this.options.shortDuration : this.shortDuration, this.compareLimit = b.isNumber(this.options.compareLimit) ? this.options.compareLimit : this.compareLimit, this.offset = b.isNumber(this.options.offset) ? this.options.offset : this.offset, this.isSticky = b.isBoolean(this.options.isSticky) ? this.options.isSticky : this.isSticky, this.compareAttributes = b.isObject(this.options.compareAttributes) ? this.options.compareAttributes : null, this.$productList = this.options.$productList || a(this.getProductList()), this.$compareButton = this.options.$compareButton || this.$(this.compareButtonSelector), this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render()
        },
        setupListeners: function () {
            this.isSticky && this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, b.debounce(this.onResize.bind(this), 200)), this.listenTo(this.eventDispatcher, window.app.applicationEvents.PRODUCT_COMPARISON_ADDED, this.renderDelayedCompareCheckbox), this.listenTo(this.eventDispatcher, window.app.applicationEvents.PRODUCT_COMPARISON_REMOVED, this.renderDelayedCompareCheckbox)
        },
        render: function () {
            this.initComparisonView(), this.isSticky && window.setTimeout(this.initScrollScenes.bind(this), 0)
        },
        onResize: function () {
            this.destroyScrollScene(), this.initScrollScenes()
        },
        destroyScrollScene: function () {
            this.scrollController && (this.scrollController = this.scrollController.destroy(!0))
        },
        destroyComparisonView: function () {
            this.productComparisonView && (this.destroyScrollScene(), this.productComparisonView.undelegateEvents(), this.productComparisonView.stopListening(), this.productComparisonView.hideMessage(), this.productComparisonView.setButtonStates(0), this.productComparisonView.$el.find("ul").empty(), this.productComparisonView.$productsCount.text("0"), this.productComparisonView = null)
        },
        initScrollScenes: function () {
            this.productComparisonView && (this.scrollController = new f.Controller({globalSceneOptions: {triggerHook: 1}}), new f.Scene({
                triggerElement: this.$productList.get(0),
                offset: this.offset,
                duration: this.$productList.outerHeight()
            }).setClassToggle(this.productComparisonView.el, "fixed").addTo(this.scrollController))
        },
        initComparisonView: function () {
            0 !== this.$(this.compareInputSelector).length && (this.productComparisonView = e({
                el: this.$compareButton.get(0),
                parent: this,
                $parent: this.$el,
                productList: this.productListId,
                compareAttributes: this.compareAttributes
            }))
        },
        addToComparison: function (b) {
            b.stopPropagation();
            var c = a(b.target).closest("[data-product-id]").data(), d = a.Event("add", {
                productId: c.productId,
                productName: c.productName,
                productList: this.productListId,
                productComparison: this.productComparisonView
            });
            this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_COMPARISON_ADD, d), b.preventDefault()
        },
        removeFromComparison: function (b) {
            b.stopPropagation();
            var c = a(b.target).closest("[data-product-id]").data(), d = a.Event("remove", {
                productId: c.productId,
                productName: c.productName,
                productList: this.productListId,
                productComparison: this.productComparisonView
            });
            this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_COMPARISON_REMOVE, d), b.preventDefault()
        },
        renderDelayedCompareCheckbox: function (a) {
            a.productComparison === this.productComparisonView && this.productListId === a.productList && window.setTimeout(this.renderCompareCheckbox.bind(this, a), 0)
        },
        renderCompareCheckbox: function (a) {
            this.$productList.find('[data-product-id="' + a.productId + '"] ' + this.compareInputSelector).prop({
                checked: "added" === a.type,
                disabled: !1
            }), this.$productList.find(this.compareInputSelector + ":not(:checked)").prop({disabled: a.storage.length >= this.compareLimit})
        },
        getProductList: function () {
            return this.$el.is(this.productListSelector) ? this.el : this.$el.find(this.productListSelector + '[data-product-list="' + this.productListId + '"]')
        }
    });
    return function (a) {
        return this instanceof g ? this : new g(a)
    }
}),/*! iScroll v5.2.0-snapshot ~ (c) 2008-2017 Matteo Spinelli ~ http://cubiq.org/license */
    function (a, b, c) {
        function d(c, d) {
            this.wrapper = "string" == typeof c ? b.querySelector(c) : c, this.scroller = this.wrapper.children[0], this.scrollerStyle = this.scroller.style, this.options = {
                resizeScrollbars: !0,
                mouseWheelSpeed: 20,
                snapThreshold: .334,
                disablePointer: !h.hasPointer,
                disableTouch: h.hasPointer || !h.hasTouch,
                disableMouse: h.hasPointer || h.hasTouch,
                startX: 0,
                startY: 0,
                scrollY: !0,
                directionLockThreshold: 5,
                momentum: !0,
                bounce: !0,
                bounceTime: 600,
                bounceEasing: "",
                preventDefault: !0,
                preventDefaultException: {tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/},
                HWCompositing: !0,
                useTransition: !0,
                useTransform: !0,
                bindToWrapper: "undefined" == typeof a.onmousedown
            };
            for (var e in d) this.options[e] = d[e];
            this.translateZ = this.options.HWCompositing && h.hasPerspective ? " translateZ(0)" : "", this.options.useTransition = h.hasTransition && this.options.useTransition, this.options.useTransform = h.hasTransform && this.options.useTransform, this.options.eventPassthrough = this.options.eventPassthrough === !0 ? "vertical" : this.options.eventPassthrough, this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault, this.options.scrollY = "vertical" != this.options.eventPassthrough && this.options.scrollY, this.options.scrollX = "horizontal" != this.options.eventPassthrough && this.options.scrollX, this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough, this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold, this.options.bounceEasing = "string" == typeof this.options.bounceEasing ? h.ease[this.options.bounceEasing] || h.ease.circular : this.options.bounceEasing, this.options.resizePolling = void 0 === this.options.resizePolling ? 60 : this.options.resizePolling, this.options.tap === !0 && (this.options.tap = "tap"), this.options.useTransition || this.options.useTransform || /relative|absolute/i.test(this.scrollerStyle.position) || (this.scrollerStyle.position = "relative"), "scale" == this.options.shrinkScrollbars && (this.options.useTransition = !1), this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1, this.x = 0, this.y = 0, this.directionX = 0, this.directionY = 0, this._events = {}, this._init(), this.refresh(), this.scrollTo(this.options.startX, this.options.startY), this.enable()
        }

        function e(a, c, d) {
            var e = b.createElement("div"), f = b.createElement("div");
            return d === !0 && (e.style.cssText = "position:absolute;z-index:9999", f.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px"), f.className = "iScrollIndicator", "h" == a ? (d === !0 && (e.style.cssText += ";height:7px;left:2px;right:2px;bottom:0", f.style.height = "100%"), e.className = "iScrollHorizontalScrollbar") : (d === !0 && (e.style.cssText += ";width:7px;bottom:2px;top:2px;right:1px", f.style.width = "100%"), e.className = "iScrollVerticalScrollbar"), e.style.cssText += ";overflow:hidden", c || (e.style.pointerEvents = "none"), e.appendChild(f), e
        }

        function f(c, d) {
            this.wrapper = "string" == typeof d.el ? b.querySelector(d.el) : d.el, this.wrapperStyle = this.wrapper.style, this.indicator = this.wrapper.children[0], this.indicatorStyle = this.indicator.style, this.scroller = c, this.options = {
                listenX: !0,
                listenY: !0,
                interactive: !1,
                resize: !0,
                defaultScrollbars: !1,
                shrink: !1,
                fade: !1,
                speedRatioX: 0,
                speedRatioY: 0
            };
            for (var e in d) this.options[e] = d[e];
            if (this.sizeRatioX = 1, this.sizeRatioY = 1, this.maxPosX = 0, this.maxPosY = 0, this.options.interactive && (this.options.disableTouch || (h.addEvent(this.indicator, "touchstart", this), h.addEvent(a, "touchend", this)), this.options.disablePointer || (h.addEvent(this.indicator, h.prefixPointerEvent("pointerdown"), this), h.addEvent(a, h.prefixPointerEvent("pointerup"), this)), this.options.disableMouse || (h.addEvent(this.indicator, "mousedown", this), h.addEvent(a, "mouseup", this))), this.options.fade) {
                this.wrapperStyle[h.style.transform] = this.scroller.translateZ;
                var f = h.style.transitionDuration;
                if (!f) return;
                this.wrapperStyle[f] = h.isBadAndroid ? "0.0001ms" : "0ms";
                var i = this;
                h.isBadAndroid && g(function () {
                    "0.0001ms" === i.wrapperStyle[f] && (i.wrapperStyle[f] = "0s")
                }), this.wrapperStyle.opacity = "0"
            }
        }

        var g = a.requestAnimationFrame || a.webkitRequestAnimationFrame || a.mozRequestAnimationFrame || a.oRequestAnimationFrame || a.msRequestAnimationFrame || function (b) {
            a.setTimeout(b, 1e3 / 60)
        }, h = function () {
            function d(a) {
                return g !== !1 && ("" === g ? a : g + a.charAt(0).toUpperCase() + a.substr(1))
            }

            var e = {}, f = b.createElement("div").style, g = function () {
                for (var a, b = ["t", "webkitT", "MozT", "msT", "OT"], c = 0, d = b.length; c < d; c++) if (a = b[c] + "ransform", a in f) return b[c].substr(0, b[c].length - 1);
                return !1
            }();
            e.getTime = Date.now || function () {
                return (new Date).getTime()
            }, e.extend = function (a, b) {
                for (var c in b) a[c] = b[c]
            }, e.addEvent = function (a, b, c, d) {
                a.addEventListener(b, c, !!d)
            }, e.removeEvent = function (a, b, c, d) {
                a.removeEventListener(b, c, !!d)
            }, e.prefixPointerEvent = function (b) {
                return a.MSPointerEvent ? "MSPointer" + b.charAt(7).toUpperCase() + b.substr(8) : b
            }, e.momentum = function (a, b, d, e, f, g) {
                var h, i, j = a - b, k = c.abs(j) / d;
                return g = void 0 === g ? 6e-4 : g, h = a + k * k / (2 * g) * (j < 0 ? -1 : 1), i = k / g, h < e ? (h = f ? e - f / 2.5 * (k / 8) : e, j = c.abs(h - a), i = j / k) : h > 0 && (h = f ? f / 2.5 * (k / 8) : 0, j = c.abs(a) + h, i = j / k), {
                    destination: c.round(h),
                    duration: i
                }
            };
            var h = d("transform");
            return e.extend(e, {
                hasTransform: h !== !1,
                hasPerspective: d("perspective") in f,
                hasTouch: "ontouchstart" in a,
                hasPointer: !(!a.PointerEvent && !a.MSPointerEvent),
                hasTransition: d("transition") in f
            }), e.isBadAndroid = function () {
                var b = a.navigator.appVersion;
                if (/Android/.test(b) && !/Chrome\/\d/.test(b)) {
                    var c = b.match(/Safari\/(\d+.\d)/);
                    return !(c && "object" == typeof c && c.length >= 2) || parseFloat(c[1]) < 535.19
                }
                return !1
            }(), e.extend(e.style = {}, {
                transform: h,
                transitionTimingFunction: d("transitionTimingFunction"),
                transitionDuration: d("transitionDuration"),
                transitionDelay: d("transitionDelay"),
                transformOrigin: d("transformOrigin"),
                touchAction: d("touchAction")
            }), e.hasClass = function (a, b) {
                var c = new RegExp("(^|\\s)" + b + "(\\s|$)");
                return c.test(a.className)
            }, e.addClass = function (a, b) {
                if (!e.hasClass(a, b)) {
                    var c = a.className.split(" ");
                    c.push(b), a.className = c.join(" ")
                }
            }, e.removeClass = function (a, b) {
                if (e.hasClass(a, b)) {
                    var c = new RegExp("(^|\\s)" + b + "(\\s|$)", "g");
                    a.className = a.className.replace(c, " ")
                }
            }, e.offset = function (a) {
                for (var b = -a.offsetLeft, c = -a.offsetTop; a = a.offsetParent;) b -= a.offsetLeft, c -= a.offsetTop;
                return {left: b, top: c}
            }, e.preventDefaultException = function (a, b) {
                for (var c in b) if (b[c].test(a[c])) return !0;
                return !1
            }, e.extend(e.eventType = {}, {
                touchstart: 1,
                touchmove: 1,
                touchend: 1,
                mousedown: 2,
                mousemove: 2,
                mouseup: 2,
                pointerdown: 3,
                pointermove: 3,
                pointerup: 3,
                MSPointerDown: 3,
                MSPointerMove: 3,
                MSPointerUp: 3
            }), e.extend(e.ease = {}, {
                quadratic: {
                    style: "cubic-bezier(0.25, 0.46, 0.45, 0.94)", fn: function (a) {
                        return a * (2 - a)
                    }
                }, circular: {
                    style: "cubic-bezier(0.1, 0.57, 0.1, 1)", fn: function (a) {
                        return c.sqrt(1 - --a * a)
                    }
                }, back: {
                    style: "cubic-bezier(0.175, 0.885, 0.32, 1.275)", fn: function (a) {
                        var b = 4;
                        return (a -= 1) * a * ((b + 1) * a + b) + 1
                    }
                }, bounce: {
                    style: "", fn: function (a) {
                        return (a /= 1) < 1 / 2.75 ? 7.5625 * a * a : a < 2 / 2.75 ? 7.5625 * (a -= 1.5 / 2.75) * a + .75 : a < 2.5 / 2.75 ? 7.5625 * (a -= 2.25 / 2.75) * a + .9375 : 7.5625 * (a -= 2.625 / 2.75) * a + .984375
                    }
                }, elastic: {
                    style: "", fn: function (a) {
                        var b = .22, d = .4;
                        return 0 === a ? 0 : 1 == a ? 1 : d * c.pow(2, -10 * a) * c.sin((a - b / 4) * (2 * c.PI) / b) + 1
                    }
                }
            }), e.tap = function (a, c) {
                var d = b.createEvent("Event");
                d.initEvent(c, !0, !0), d.pageX = a.pageX, d.pageY = a.pageY, a.target.dispatchEvent(d)
            }, e.click = function (c) {
                var d, e = c.target;
                /(SELECT|INPUT|TEXTAREA)/i.test(e.tagName) || (d = b.createEvent(a.MouseEvent ? "MouseEvents" : "Event"), d.initEvent("click", !0, !0), d.view = c.view || a, d.detail = 1, d.screenX = e.screenX || 0, d.screenY = e.screenY || 0, d.clientX = e.clientX || 0, d.clientY = e.clientY || 0, d.ctrlKey = !!c.ctrlKey, d.altKey = !!c.altKey, d.shiftKey = !!c.shiftKey, d.metaKey = !!c.metaKey, d.button = 0, d.relatedTarget = null, d._constructed = !0, e.dispatchEvent(d))
            }, e.getTouchAction = function (a, b) {
                var c = "none";
                return "vertical" === a ? c = "pan-y" : "horizontal" === a && (c = "pan-x"), b && "none" != c && (c += " pinch-zoom"), c
            }, e.getRect = function (a) {
                if (a instanceof SVGElement) {
                    var b = a.getBoundingClientRect();
                    return {top: b.top, left: b.left, width: b.width, height: b.height}
                }
                return {top: a.offsetTop, left: a.offsetLeft, width: a.offsetWidth, height: a.offsetHeight}
            }, e
        }();
        d.prototype = {
            version: "5.2.0-snapshot", _init: function () {
                this._initEvents(), (this.options.scrollbars || this.options.indicators) && this._initIndicators(), this.options.mouseWheel && this._initWheel(), this.options.snap && this._initSnap(), this.options.keyBindings && this._initKeys()
            }, destroy: function () {
                this._initEvents(!0), clearTimeout(this.resizeTimeout), this.resizeTimeout = null, this._execEvent("destroy")
            }, _transitionEnd: function (a) {
                a.target == this.scroller && this.isInTransition && (this._transitionTime(), this.resetPosition(this.options.bounceTime) || (this.isInTransition = !1, this._execEvent("scrollEnd")))
            }, _start: function (a) {
                if (1 != h.eventType[a.type]) {
                    var b;
                    if (b = a.which ? a.button : a.button < 2 ? 0 : 4 == a.button ? 1 : 2, 0 !== b) return
                }
                if (this.enabled && (!this.initiated || h.eventType[a.type] === this.initiated)) {
                    !this.options.preventDefault || h.isBadAndroid || h.preventDefaultException(a.target, this.options.preventDefaultException) || a.preventDefault();
                    var d, e = a.touches ? a.touches[0] : a;
                    this.initiated = h.eventType[a.type], this.moved = !1, this.distX = 0, this.distY = 0, this.directionX = 0, this.directionY = 0, this.directionLocked = 0, this.startTime = h.getTime(), this.options.useTransition && this.isInTransition ? (this._transitionTime(), this.isInTransition = !1, d = this.getComputedPosition(), this._translate(c.round(d.x), c.round(d.y)), this._execEvent("scrollEnd")) : !this.options.useTransition && this.isAnimating && (this.isAnimating = !1, this._execEvent("scrollEnd")), this.startX = this.x, this.startY = this.y, this.absStartX = this.x, this.absStartY = this.y, this.pointX = e.pageX, this.pointY = e.pageY, this._execEvent("beforeScrollStart")
                }
            }, _move: function (a) {
                if (this.enabled && h.eventType[a.type] === this.initiated) {
                    this.options.preventDefault && a.preventDefault();
                    var b, d, e, f, g = a.touches ? a.touches[0] : a, i = g.pageX - this.pointX,
                        j = g.pageY - this.pointY, k = h.getTime();
                    if (this.pointX = g.pageX, this.pointY = g.pageY, this.distX += i, this.distY += j, e = c.abs(this.distX), f = c.abs(this.distY), !(k - this.endTime > 300 && e < 10 && f < 10)) {
                        if (this.directionLocked || this.options.freeScroll || (e > f + this.options.directionLockThreshold ? this.directionLocked = "h" : f >= e + this.options.directionLockThreshold ? this.directionLocked = "v" : this.directionLocked = "n"), "h" == this.directionLocked) {
                            if ("vertical" == this.options.eventPassthrough) a.preventDefault(); else if ("horizontal" == this.options.eventPassthrough) return void (this.initiated = !1);
                            j = 0
                        } else if ("v" == this.directionLocked) {
                            if ("horizontal" == this.options.eventPassthrough) a.preventDefault(); else if ("vertical" == this.options.eventPassthrough) return void (this.initiated = !1);
                            i = 0
                        }
                        i = this.hasHorizontalScroll ? i : 0, j = this.hasVerticalScroll ? j : 0, b = this.x + i, d = this.y + j, (b > 0 || b < this.maxScrollX) && (b = this.options.bounce ? this.x + i / 3 : b > 0 ? 0 : this.maxScrollX), (d > 0 || d < this.maxScrollY) && (d = this.options.bounce ? this.y + j / 3 : d > 0 ? 0 : this.maxScrollY), this.directionX = i > 0 ? -1 : i < 0 ? 1 : 0, this.directionY = j > 0 ? -1 : j < 0 ? 1 : 0, this.moved || this._execEvent("scrollStart"), this.moved = !0, this._translate(b, d), k - this.startTime > 300 && (this.startTime = k, this.startX = this.x, this.startY = this.y)
                    }
                }
            }, _end: function (a) {
                if (this.enabled && h.eventType[a.type] === this.initiated) {
                    this.options.preventDefault && !h.preventDefaultException(a.target, this.options.preventDefaultException) && a.preventDefault();
                    var b, d, e = (a.changedTouches ? a.changedTouches[0] : a, h.getTime() - this.startTime),
                        f = c.round(this.x), g = c.round(this.y), i = c.abs(f - this.startX),
                        j = c.abs(g - this.startY), k = 0, l = "";
                    if (this.isInTransition = 0, this.initiated = 0, this.endTime = h.getTime(), !this.resetPosition(this.options.bounceTime)) {
                        if (this.scrollTo(f, g), !this.moved) return this.options.tap && h.tap(a, this.options.tap), this.options.click && h.click(a), void this._execEvent("scrollCancel");
                        if (this._events.flick && e < 200 && i < 100 && j < 100) return void this._execEvent("flick");
                        if (this.options.momentum && e < 300 && (b = this.hasHorizontalScroll ? h.momentum(this.x, this.startX, e, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : {
                            destination: f,
                            duration: 0
                        }, d = this.hasVerticalScroll ? h.momentum(this.y, this.startY, e, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : {
                            destination: g,
                            duration: 0
                        }, f = b.destination, g = d.destination, k = c.max(b.duration, d.duration), this.isInTransition = 1), this.options.snap) {
                            var m = this._nearestSnap(f, g);
                            this.currentPage = m, k = this.options.snapSpeed || c.max(c.max(c.min(c.abs(f - m.x), 1e3), c.min(c.abs(g - m.y), 1e3)), 300), f = m.x, g = m.y, this.directionX = 0, this.directionY = 0, l = this.options.bounceEasing
                        }
                        return f != this.x || g != this.y ? ((f > 0 || f < this.maxScrollX || g > 0 || g < this.maxScrollY) && (l = h.ease.quadratic), void this.scrollTo(f, g, k, l)) : void this._execEvent("scrollEnd")
                    }
                }
            }, _resize: function () {
                var a = this;
                clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(function () {
                    a.refresh()
                }, this.options.resizePolling)
            }, resetPosition: function (a) {
                var b = this.x, c = this.y;
                return a = a || 0, !this.hasHorizontalScroll || this.x > 0 ? b = 0 : this.x < this.maxScrollX && (b = this.maxScrollX), !this.hasVerticalScroll || this.y > 0 ? c = 0 : this.y < this.maxScrollY && (c = this.maxScrollY), (b != this.x || c != this.y) && (this.scrollTo(b, c, a, this.options.bounceEasing), !0)
            }, disable: function () {
                this.enabled = !1
            }, enable: function () {
                this.enabled = !0
            }, refresh: function () {
                h.getRect(this.wrapper), this.wrapperWidth = this.wrapper.clientWidth, this.wrapperHeight = this.wrapper.clientHeight;
                var a = h.getRect(this.scroller);
                this.scrollerWidth = a.width, this.scrollerHeight = a.height, this.maxScrollX = this.wrapperWidth - this.scrollerWidth, this.maxScrollY = this.wrapperHeight - this.scrollerHeight, this.hasHorizontalScroll = this.options.scrollX && this.maxScrollX < 0, this.hasVerticalScroll = this.options.scrollY && this.maxScrollY < 0, this.hasHorizontalScroll || (this.maxScrollX = 0, this.scrollerWidth = this.wrapperWidth), this.hasVerticalScroll || (this.maxScrollY = 0, this.scrollerHeight = this.wrapperHeight), this.endTime = 0, this.directionX = 0, this.directionY = 0, h.hasPointer && !this.options.disablePointer && (this.wrapper.style[h.style.touchAction] = h.getTouchAction(this.options.eventPassthrough, !0), this.wrapper.style[h.style.touchAction] || (this.wrapper.style[h.style.touchAction] = h.getTouchAction(this.options.eventPassthrough, !1))), this.wrapperOffset = h.offset(this.wrapper), this._execEvent("refresh"), this.resetPosition()
            }, on: function (a, b) {
                this._events[a] || (this._events[a] = []), this._events[a].push(b)
            }, off: function (a, b) {
                if (this._events[a]) {
                    var c = this._events[a].indexOf(b);
                    c > -1 && this._events[a].splice(c, 1)
                }
            }, _execEvent: function (a) {
                if (this._events[a]) {
                    var b = 0, c = this._events[a].length;
                    if (c) for (; b < c; b++) this._events[a][b].apply(this, [].slice.call(arguments, 1))
                }
            }, scrollBy: function (a, b, c, d) {
                a = this.x + a, b = this.y + b, c = c || 0, this.scrollTo(a, b, c, d)
            }, scrollTo: function (a, b, c, d) {
                d = d || h.ease.circular, this.isInTransition = this.options.useTransition && c > 0;
                var e = this.options.useTransition && d.style;
                !c || e ? (e && (this._transitionTimingFunction(d.style), this._transitionTime(c)), this._translate(a, b)) : this._animate(a, b, c, d.fn)
            }, scrollToElement: function (a, b, d, e, f) {
                if (a = a.nodeType ? a : this.scroller.querySelector(a)) {
                    var g = h.offset(a);
                    g.left -= this.wrapperOffset.left, g.top -= this.wrapperOffset.top;
                    var i = h.getRect(a), j = h.getRect(this.wrapper);
                    d === !0 && (d = c.round(i.width / 2 - j.width / 2)), e === !0 && (e = c.round(i.height / 2 - j.height / 2)), g.left -= d || 0, g.top -= e || 0, g.left = g.left > 0 ? 0 : g.left < this.maxScrollX ? this.maxScrollX : g.left, g.top = g.top > 0 ? 0 : g.top < this.maxScrollY ? this.maxScrollY : g.top, b = void 0 === b || null === b || "auto" === b ? c.max(c.abs(this.x - g.left), c.abs(this.y - g.top)) : b, this.scrollTo(g.left, g.top, b, f)
                }
            }, _transitionTime: function (a) {
                if (this.options.useTransition) {
                    a = a || 0;
                    var b = h.style.transitionDuration;
                    if (b) {
                        if (this.scrollerStyle[b] = a + "ms", !a && h.isBadAndroid) {
                            this.scrollerStyle[b] = "0.0001ms";
                            var c = this;
                            g(function () {
                                "0.0001ms" === c.scrollerStyle[b] && (c.scrollerStyle[b] = "0s")
                            })
                        }
                        if (this.indicators) for (var d = this.indicators.length; d--;) this.indicators[d].transitionTime(a)
                    }
                }
            }, _transitionTimingFunction: function (a) {
                if (this.scrollerStyle[h.style.transitionTimingFunction] = a, this.indicators) for (var b = this.indicators.length; b--;) this.indicators[b].transitionTimingFunction(a)
            }, _translate: function (a, b) {
                if (this.options.useTransform ? this.scrollerStyle[h.style.transform] = "translate(" + a + "px," + b + "px)" + this.translateZ : (a = c.round(a), b = c.round(b), this.scrollerStyle.left = a + "px", this.scrollerStyle.top = b + "px"), this.x = a, this.y = b, this.indicators) for (var d = this.indicators.length; d--;) this.indicators[d].updatePosition()
            }, _initEvents: function (b) {
                var c = b ? h.removeEvent : h.addEvent, d = this.options.bindToWrapper ? this.wrapper : a;
                c(a, "orientationchange", this), c(a, "resize", this), this.options.click && c(this.wrapper, "click", this, !0), this.options.disableMouse || (c(this.wrapper, "mousedown", this), c(d, "mousemove", this), c(d, "mousecancel", this), c(d, "mouseup", this)), h.hasPointer && !this.options.disablePointer && (c(this.wrapper, h.prefixPointerEvent("pointerdown"), this), c(d, h.prefixPointerEvent("pointermove"), this), c(d, h.prefixPointerEvent("pointercancel"), this), c(d, h.prefixPointerEvent("pointerup"), this)), h.hasTouch && !this.options.disableTouch && (c(this.wrapper, "touchstart", this), c(d, "touchmove", this), c(d, "touchcancel", this), c(d, "touchend", this)), c(this.scroller, "transitionend", this), c(this.scroller, "webkitTransitionEnd", this), c(this.scroller, "oTransitionEnd", this), c(this.scroller, "MSTransitionEnd", this)
            }, getComputedPosition: function () {
                var b, c, d = a.getComputedStyle(this.scroller, null);
                return this.options.useTransform ? (d = d[h.style.transform].split(")")[0].split(", "), b = +(d[12] || d[4]), c = +(d[13] || d[5])) : (b = +d.left.replace(/[^-\d.]/g, ""), c = +d.top.replace(/[^-\d.]/g, "")), {
                    x: b,
                    y: c
                }
            }, _initIndicators: function () {
                function a(a) {
                    if (h.indicators) for (var b = h.indicators.length; b--;) a.call(h.indicators[b])
                }

                var b, c = this.options.interactiveScrollbars, d = "string" != typeof this.options.scrollbars, g = [],
                    h = this;
                this.indicators = [], this.options.scrollbars && (this.options.scrollY && (b = {
                    el: e("v", c, this.options.scrollbars),
                    interactive: c,
                    defaultScrollbars: !0,
                    customStyle: d,
                    resize: this.options.resizeScrollbars,
                    shrink: this.options.shrinkScrollbars,
                    fade: this.options.fadeScrollbars,
                    listenX: !1
                }, this.wrapper.appendChild(b.el), g.push(b)), this.options.scrollX && (b = {
                    el: e("h", c, this.options.scrollbars),
                    interactive: c,
                    defaultScrollbars: !0,
                    customStyle: d,
                    resize: this.options.resizeScrollbars,
                    shrink: this.options.shrinkScrollbars,
                    fade: this.options.fadeScrollbars,
                    listenY: !1
                }, this.wrapper.appendChild(b.el), g.push(b))), this.options.indicators && (g = g.concat(this.options.indicators));
                for (var i = g.length; i--;) this.indicators.push(new f(this, g[i]));
                this.options.fadeScrollbars && (this.on("scrollEnd", function () {
                    a(function () {
                        this.fade()
                    })
                }), this.on("scrollCancel", function () {
                    a(function () {
                        this.fade()
                    })
                }), this.on("scrollStart", function () {
                    a(function () {
                        this.fade(1)
                    })
                }), this.on("beforeScrollStart", function () {
                    a(function () {
                        this.fade(1, !0)
                    })
                })), this.on("refresh", function () {
                    a(function () {
                        this.refresh()
                    })
                }), this.on("destroy", function () {
                    a(function () {
                        this.destroy()
                    }), delete this.indicators
                })
            }, _initWheel: function () {
                h.addEvent(this.wrapper, "wheel", this), h.addEvent(this.wrapper, "mousewheel", this), h.addEvent(this.wrapper, "DOMMouseScroll", this), this.on("destroy", function () {
                    clearTimeout(this.wheelTimeout), this.wheelTimeout = null, h.removeEvent(this.wrapper, "wheel", this), h.removeEvent(this.wrapper, "mousewheel", this), h.removeEvent(this.wrapper, "DOMMouseScroll", this)
                })
            }, _wheel: function (a) {
                if (this.enabled) {
                    a.preventDefault();
                    var b, d, e, f, g = this;
                    if (void 0 === this.wheelTimeout && g._execEvent("scrollStart"), clearTimeout(this.wheelTimeout), this.wheelTimeout = setTimeout(function () {
                        g.options.snap || g._execEvent("scrollEnd"), g.wheelTimeout = void 0
                    }, 400), "deltaX" in a) 1 === a.deltaMode ? (b = -a.deltaX * this.options.mouseWheelSpeed, d = -a.deltaY * this.options.mouseWheelSpeed) : (b = -a.deltaX, d = -a.deltaY); else if ("wheelDeltaX" in a) b = a.wheelDeltaX / 120 * this.options.mouseWheelSpeed, d = a.wheelDeltaY / 120 * this.options.mouseWheelSpeed; else if ("wheelDelta" in a) b = d = a.wheelDelta / 120 * this.options.mouseWheelSpeed; else {
                        if (!("detail" in a)) return;
                        b = d = -a.detail / 3 * this.options.mouseWheelSpeed
                    }
                    if (b *= this.options.invertWheelDirection, d *= this.options.invertWheelDirection, this.hasVerticalScroll || (b = d, d = 0), this.options.snap) return e = this.currentPage.pageX, f = this.currentPage.pageY, b > 0 ? e-- : b < 0 && e++, d > 0 ? f-- : d < 0 && f++, void this.goToPage(e, f);
                    e = this.x + c.round(this.hasHorizontalScroll ? b : 0), f = this.y + c.round(this.hasVerticalScroll ? d : 0), this.directionX = b > 0 ? -1 : b < 0 ? 1 : 0, this.directionY = d > 0 ? -1 : d < 0 ? 1 : 0, e > 0 ? e = 0 : e < this.maxScrollX && (e = this.maxScrollX), f > 0 ? f = 0 : f < this.maxScrollY && (f = this.maxScrollY), this.scrollTo(e, f, 0)
                }
            }, _initSnap: function () {
                this.currentPage = {}, "string" == typeof this.options.snap && (this.options.snap = this.scroller.querySelectorAll(this.options.snap)), this.on("refresh", function () {
                    var a, b, d, e, f, g, i, j = 0, k = 0, l = 0, m = this.options.snapStepX || this.wrapperWidth,
                        n = this.options.snapStepY || this.wrapperHeight;
                    if (this.pages = [], this.wrapperWidth && this.wrapperHeight && this.scrollerWidth && this.scrollerHeight) {
                        if (this.options.snap === !0) for (d = c.round(m / 2), e = c.round(n / 2); l > -this.scrollerWidth;) {
                            for (this.pages[j] = [], a = 0, f = 0; f > -this.scrollerHeight;) this.pages[j][a] = {
                                x: c.max(l, this.maxScrollX),
                                y: c.max(f, this.maxScrollY),
                                width: m,
                                height: n,
                                cx: l - d,
                                cy: f - e
                            }, f -= n, a++;
                            l -= m, j++
                        } else for (g = this.options.snap, a = g.length, b = -1; j < a; j++) i = h.getRect(g[j]), (0 === j || i.left <= h.getRect(g[j - 1]).left) && (k = 0, b++), this.pages[k] || (this.pages[k] = []), l = c.max(-i.left, this.maxScrollX), f = c.max(-i.top, this.maxScrollY), d = l - c.round(i.width / 2), e = f - c.round(i.height / 2), this.pages[k][b] = {
                            x: l,
                            y: f,
                            width: i.width,
                            height: i.height,
                            cx: d,
                            cy: e
                        }, l > this.maxScrollX && k++;
                        this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0), this.options.snapThreshold % 1 === 0 ? (this.snapThresholdX = this.options.snapThreshold, this.snapThresholdY = this.options.snapThreshold) : (this.snapThresholdX = c.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold), this.snapThresholdY = c.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold))
                    }
                }), this.on("flick", function () {
                    var a = this.options.snapSpeed || c.max(c.max(c.min(c.abs(this.x - this.startX), 1e3), c.min(c.abs(this.y - this.startY), 1e3)), 300);
                    this.goToPage(this.currentPage.pageX + this.directionX, this.currentPage.pageY + this.directionY, a)
                })
            }, _nearestSnap: function (a, b) {
                if (!this.pages.length) return {x: 0, y: 0, pageX: 0, pageY: 0};
                var d = 0, e = this.pages.length, f = 0;
                if (c.abs(a - this.absStartX) < this.snapThresholdX && c.abs(b - this.absStartY) < this.snapThresholdY) return this.currentPage;
                for (a > 0 ? a = 0 : a < this.maxScrollX && (a = this.maxScrollX), b > 0 ? b = 0 : b < this.maxScrollY && (b = this.maxScrollY); d < e; d++) if (a >= this.pages[d][0].cx) {
                    a = this.pages[d][0].x;
                    break
                }
                for (e = this.pages[d].length; f < e; f++) if (b >= this.pages[0][f].cy) {
                    b = this.pages[0][f].y;
                    break
                }
                return d == this.currentPage.pageX && (d += this.directionX, d < 0 ? d = 0 : d >= this.pages.length && (d = this.pages.length - 1), a = this.pages[d][0].x), f == this.currentPage.pageY && (f += this.directionY, f < 0 ? f = 0 : f >= this.pages[0].length && (f = this.pages[0].length - 1), b = this.pages[0][f].y), {
                    x: a,
                    y: b,
                    pageX: d,
                    pageY: f
                }
            }, goToPage: function (a, b, d, e) {
                e = e || this.options.bounceEasing, a >= this.pages.length ? a = this.pages.length - 1 : a < 0 && (a = 0), b >= this.pages[a].length ? b = this.pages[a].length - 1 : b < 0 && (b = 0);
                var f = this.pages[a][b].x, g = this.pages[a][b].y;
                d = void 0 === d ? this.options.snapSpeed || c.max(c.max(c.min(c.abs(f - this.x), 1e3), c.min(c.abs(g - this.y), 1e3)), 300) : d, this.currentPage = {
                    x: f,
                    y: g,
                    pageX: a,
                    pageY: b
                }, this.scrollTo(f, g, d, e)
            }, next: function (a, b) {
                var c = this.currentPage.pageX, d = this.currentPage.pageY;
                c++, c >= this.pages.length && this.hasVerticalScroll && (c = 0, d++), this.goToPage(c, d, a, b)
            }, prev: function (a, b) {
                var c = this.currentPage.pageX, d = this.currentPage.pageY;
                c--, c < 0 && this.hasVerticalScroll && (c = 0, d--), this.goToPage(c, d, a, b)
            }, _initKeys: function (b) {
                var c, d = {pageUp: 33, pageDown: 34, end: 35, home: 36, left: 37, up: 38, right: 39, down: 40};
                if ("object" == typeof this.options.keyBindings) for (c in this.options.keyBindings) "string" == typeof this.options.keyBindings[c] && (this.options.keyBindings[c] = this.options.keyBindings[c].toUpperCase().charCodeAt(0)); else this.options.keyBindings = {};
                for (c in d) this.options.keyBindings[c] = this.options.keyBindings[c] || d[c];
                h.addEvent(a, "keydown", this), this.on("destroy", function () {
                    h.removeEvent(a, "keydown", this)
                })
            }, _key: function (a) {
                if (this.enabled) {
                    var b, d = this.options.snap, e = d ? this.currentPage.pageX : this.x,
                        f = d ? this.currentPage.pageY : this.y, g = h.getTime(), i = this.keyTime || 0, j = .25;
                    switch (this.options.useTransition && this.isInTransition && (b = this.getComputedPosition(), this._translate(c.round(b.x), c.round(b.y)), this.isInTransition = !1), this.keyAcceleration = g - i < 200 ? c.min(this.keyAcceleration + j, 50) : 0, a.keyCode) {
                        case this.options.keyBindings.pageUp:
                            this.hasHorizontalScroll && !this.hasVerticalScroll ? e += d ? 1 : this.wrapperWidth : f += d ? 1 : this.wrapperHeight;
                            break;
                        case this.options.keyBindings.pageDown:
                            this.hasHorizontalScroll && !this.hasVerticalScroll ? e -= d ? 1 : this.wrapperWidth : f -= d ? 1 : this.wrapperHeight;
                            break;
                        case this.options.keyBindings.end:
                            e = d ? this.pages.length - 1 : this.maxScrollX, f = d ? this.pages[0].length - 1 : this.maxScrollY;
                            break;
                        case this.options.keyBindings.home:
                            e = 0, f = 0;
                            break;
                        case this.options.keyBindings.left:
                            e += d ? -1 : 5 + this.keyAcceleration >> 0;
                            break;
                        case this.options.keyBindings.up:
                            f += d ? 1 : 5 + this.keyAcceleration >> 0;
                            break;
                        case this.options.keyBindings.right:
                            e -= d ? -1 : 5 + this.keyAcceleration >> 0;
                            break;
                        case this.options.keyBindings.down:
                            f -= d ? 1 : 5 + this.keyAcceleration >> 0;
                            break;
                        default:
                            return
                    }
                    if (d) return void this.goToPage(e, f);
                    e > 0 ? (e = 0, this.keyAcceleration = 0) : e < this.maxScrollX && (e = this.maxScrollX, this.keyAcceleration = 0), f > 0 ? (f = 0, this.keyAcceleration = 0) : f < this.maxScrollY && (f = this.maxScrollY, this.keyAcceleration = 0), this.scrollTo(e, f, 0), this.keyTime = g
                }
            }, _animate: function (a, b, c, d) {
                function e() {
                    var m, n, o, p = h.getTime();
                    return p >= l ? (f.isAnimating = !1, f._translate(a, b), void (f.resetPosition(f.options.bounceTime) || f._execEvent("scrollEnd"))) : (p = (p - k) / c, o = d(p), m = (a - i) * o + i, n = (b - j) * o + j, f._translate(m, n), void (f.isAnimating && g(e)))
                }

                var f = this, i = this.x, j = this.y, k = h.getTime(), l = k + c;
                this.isAnimating = !0, e()
            }, handleEvent: function (a) {
                switch (a.type) {
                    case"touchstart":
                    case"pointerdown":
                    case"MSPointerDown":
                    case"mousedown":
                        this._start(a);
                        break;
                    case"touchmove":
                    case"pointermove":
                    case"MSPointerMove":
                    case"mousemove":
                        this._move(a);
                        break;
                    case"touchend":
                    case"pointerup":
                    case"MSPointerUp":
                    case"mouseup":
                    case"touchcancel":
                    case"pointercancel":
                    case"MSPointerCancel":
                    case"mousecancel":
                        this._end(a);
                        break;
                    case"orientationchange":
                    case"resize":
                        this._resize();
                        break;
                    case"transitionend":
                    case"webkitTransitionEnd":
                    case"oTransitionEnd":
                    case"MSTransitionEnd":
                        this._transitionEnd(a);
                        break;
                    case"wheel":
                    case"DOMMouseScroll":
                    case"mousewheel":
                        this._wheel(a);
                        break;
                    case"keydown":
                        this._key(a);
                        break;
                    case"click":
                        this.enabled && !a._constructed && (a.preventDefault(), a.stopPropagation())
                }
            }
        }, f.prototype = {
            handleEvent: function (a) {
                switch (a.type) {
                    case"touchstart":
                    case"pointerdown":
                    case"MSPointerDown":
                    case"mousedown":
                        this._start(a);
                        break;
                    case"touchmove":
                    case"pointermove":
                    case"MSPointerMove":
                    case"mousemove":
                        this._move(a);
                        break;
                    case"touchend":
                    case"pointerup":
                    case"MSPointerUp":
                    case"mouseup":
                    case"touchcancel":
                    case"pointercancel":
                    case"MSPointerCancel":
                    case"mousecancel":
                        this._end(a)
                }
            }, destroy: function () {
                this.options.fadeScrollbars && (clearTimeout(this.fadeTimeout), this.fadeTimeout = null), this.options.interactive && (h.removeEvent(this.indicator, "touchstart", this), h.removeEvent(this.indicator, h.prefixPointerEvent("pointerdown"), this), h.removeEvent(this.indicator, "mousedown", this), h.removeEvent(a, "touchmove", this), h.removeEvent(a, h.prefixPointerEvent("pointermove"), this), h.removeEvent(a, "mousemove", this), h.removeEvent(a, "touchend", this), h.removeEvent(a, h.prefixPointerEvent("pointerup"), this), h.removeEvent(a, "mouseup", this)), this.options.defaultScrollbars && this.wrapper.parentNode && this.wrapper.parentNode.removeChild(this.wrapper)
            }, _start: function (b) {
                var c = b.touches ? b.touches[0] : b;
                b.preventDefault(), b.stopPropagation(), this.transitionTime(), this.initiated = !0, this.moved = !1, this.lastPointX = c.pageX, this.lastPointY = c.pageY, this.startTime = h.getTime(), this.options.disableTouch || h.addEvent(a, "touchmove", this), this.options.disablePointer || h.addEvent(a, h.prefixPointerEvent("pointermove"), this), this.options.disableMouse || h.addEvent(a, "mousemove", this), this.scroller._execEvent("beforeScrollStart")
            }, _move: function (a) {
                var b, c, d, e, f = a.touches ? a.touches[0] : a;
                h.getTime();
                this.moved || this.scroller._execEvent("scrollStart"), this.moved = !0, b = f.pageX - this.lastPointX, this.lastPointX = f.pageX, c = f.pageY - this.lastPointY, this.lastPointY = f.pageY, d = this.x + b, e = this.y + c, this._pos(d, e), a.preventDefault(), a.stopPropagation()
            }, _end: function (b) {
                if (this.initiated) {
                    if (this.initiated = !1, b.preventDefault(), b.stopPropagation(), h.removeEvent(a, "touchmove", this), h.removeEvent(a, h.prefixPointerEvent("pointermove"), this), h.removeEvent(a, "mousemove", this), this.scroller.options.snap) {
                        var d = this.scroller._nearestSnap(this.scroller.x, this.scroller.y),
                            e = this.options.snapSpeed || c.max(c.max(c.min(c.abs(this.scroller.x - d.x), 1e3), c.min(c.abs(this.scroller.y - d.y), 1e3)), 300);
                        this.scroller.x == d.x && this.scroller.y == d.y || (this.scroller.directionX = 0, this.scroller.directionY = 0, this.scroller.currentPage = d, this.scroller.scrollTo(d.x, d.y, e, this.scroller.options.bounceEasing))
                    }
                    this.moved && this.scroller._execEvent("scrollEnd")
                }
            }, transitionTime: function (a) {
                a = a || 0;
                var b = h.style.transitionDuration;
                if (b && (this.indicatorStyle[b] = a + "ms", !a && h.isBadAndroid)) {
                    this.indicatorStyle[b] = "0.0001ms";
                    var c = this;
                    g(function () {
                        "0.0001ms" === c.indicatorStyle[b] && (c.indicatorStyle[b] = "0s")
                    })
                }
            }, transitionTimingFunction: function (a) {
                this.indicatorStyle[h.style.transitionTimingFunction] = a
            }, refresh: function () {
                this.transitionTime(), this.options.listenX && !this.options.listenY ? this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? "block" : "none" : this.options.listenY && !this.options.listenX ? this.indicatorStyle.display = this.scroller.hasVerticalScroll ? "block" : "none" : this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? "block" : "none", this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll ? (h.addClass(this.wrapper, "iScrollBothScrollbars"), h.removeClass(this.wrapper, "iScrollLoneScrollbar"), this.options.defaultScrollbars && this.options.customStyle && (this.options.listenX ? this.wrapper.style.right = "8px" : this.wrapper.style.bottom = "8px")) : (h.removeClass(this.wrapper, "iScrollBothScrollbars"), h.addClass(this.wrapper, "iScrollLoneScrollbar"), this.options.defaultScrollbars && this.options.customStyle && (this.options.listenX ? this.wrapper.style.right = "2px" : this.wrapper.style.bottom = "2px")), h.getRect(this.wrapper), this.options.listenX && (this.wrapperWidth = this.wrapper.clientWidth, this.options.resize ? (this.indicatorWidth = c.max(c.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8), this.indicatorStyle.width = this.indicatorWidth + "px") : this.indicatorWidth = this.indicator.clientWidth, this.maxPosX = this.wrapperWidth - this.indicatorWidth, "clip" == this.options.shrink ? (this.minBoundaryX = -this.indicatorWidth + 8, this.maxBoundaryX = this.wrapperWidth - 8) : (this.minBoundaryX = 0, this.maxBoundaryX = this.maxPosX), this.sizeRatioX = this.options.speedRatioX || this.scroller.maxScrollX && this.maxPosX / this.scroller.maxScrollX), this.options.listenY && (this.wrapperHeight = this.wrapper.clientHeight, this.options.resize ? (this.indicatorHeight = c.max(c.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8), this.indicatorStyle.height = this.indicatorHeight + "px") : this.indicatorHeight = this.indicator.clientHeight, this.maxPosY = this.wrapperHeight - this.indicatorHeight, "clip" == this.options.shrink ? (this.minBoundaryY = -this.indicatorHeight + 8, this.maxBoundaryY = this.wrapperHeight - 8) : (this.minBoundaryY = 0, this.maxBoundaryY = this.maxPosY), this.maxPosY = this.wrapperHeight - this.indicatorHeight, this.sizeRatioY = this.options.speedRatioY || this.scroller.maxScrollY && this.maxPosY / this.scroller.maxScrollY), this.updatePosition()
            }, updatePosition: function () {
                var a = this.options.listenX && c.round(this.sizeRatioX * this.scroller.x) || 0,
                    b = this.options.listenY && c.round(this.sizeRatioY * this.scroller.y) || 0;
                this.options.ignoreBoundaries || (a < this.minBoundaryX ? ("scale" == this.options.shrink && (this.width = c.max(this.indicatorWidth + a, 8),
                    this.indicatorStyle.width = this.width + "px"), a = this.minBoundaryX) : a > this.maxBoundaryX ? "scale" == this.options.shrink ? (this.width = c.max(this.indicatorWidth - (a - this.maxPosX), 8), this.indicatorStyle.width = this.width + "px", a = this.maxPosX + this.indicatorWidth - this.width) : a = this.maxBoundaryX : "scale" == this.options.shrink && this.width != this.indicatorWidth && (this.width = this.indicatorWidth, this.indicatorStyle.width = this.width + "px"), b < this.minBoundaryY ? ("scale" == this.options.shrink && (this.height = c.max(this.indicatorHeight + 3 * b, 8), this.indicatorStyle.height = this.height + "px"), b = this.minBoundaryY) : b > this.maxBoundaryY ? "scale" == this.options.shrink ? (this.height = c.max(this.indicatorHeight - 3 * (b - this.maxPosY), 8), this.indicatorStyle.height = this.height + "px", b = this.maxPosY + this.indicatorHeight - this.height) : b = this.maxBoundaryY : "scale" == this.options.shrink && this.height != this.indicatorHeight && (this.height = this.indicatorHeight, this.indicatorStyle.height = this.height + "px")), this.x = a, this.y = b, this.scroller.options.useTransform ? this.indicatorStyle[h.style.transform] = "translate(" + a + "px," + b + "px)" + this.scroller.translateZ : (this.indicatorStyle.left = a + "px", this.indicatorStyle.top = b + "px")
            }, _pos: function (a, b) {
                a < 0 ? a = 0 : a > this.maxPosX && (a = this.maxPosX), b < 0 ? b = 0 : b > this.maxPosY && (b = this.maxPosY), a = this.options.listenX ? c.round(a / this.sizeRatioX) : this.scroller.x, b = this.options.listenY ? c.round(b / this.sizeRatioY) : this.scroller.y, this.scroller.scrollTo(a, b)
            }, fade: function (a, b) {
                if (!b || this.visible) {
                    clearTimeout(this.fadeTimeout), this.fadeTimeout = null;
                    var c = a ? 250 : 500, d = a ? 0 : 300;
                    a = a ? "1" : "0", this.wrapperStyle[h.style.transitionDuration] = c + "ms", this.fadeTimeout = setTimeout(function (a) {
                        this.wrapperStyle.opacity = a, this.visible = +a
                    }.bind(this, a), d)
                }
            }
        }, d.utils = h, "undefined" != typeof module && module.exports ? module.exports = d : "function" == typeof define && define.amd ? define("iscroll", [], function () {
            return d
        }) : a.IScroll = d
    }(window, document, Math), define("views/tab-slider-view", ["jquery", "underscore", "backbone", "app/router", "app/delayed-initialization", "iscroll", "slick-slider"], function (a, b, c, d, e, f) {
    "use strict";
    var g = c.View.extend({
        $parent: void 0,
        $controls: void 0,
        $slider: void 0,
        $buttons: void 0,
        initialSlide: 0,
        contentIndex: void 0,
        $tabs: void 0,
        scroller: void 0,
        routeId: void 0,
        eventDispatcher: void 0,
        slickSliderOptions: void 0,
        iscrollOptions: void 0,
        $selectTabNavigation: void 0,
        $selectTabCountry: void 0,
        $countSlides: void 0,
        isSlickInitialized: !1,
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), d.getInstance(), this.$parent = this.$el.parent(".module"), this.routeId = this.$parent.data("route-id"), this.$el.hasClass("mobile-dropdown") ? (this.$selectTabNavigation = this.$el.find(".tab-dropdown"), this.$selectTabCountry = this.$selectTabNavigation.find(".label")) : (this.$selectTabNavigation = this.$el.find(".select-tab-navigation"), this.$selectTabCountry = this.$selectTabNavigation.find(".select-tab-navigation-country")), this.$countSlides = this.$el.find(".slide").length || 0, this.initialSlide = this.$el.data("initial-slide") || 0, this.initialSlide = this.initialSlide > this.$countSlides - 1 ? 0 : this.initialSlide, this.eventDispatcher = window.app.eventDispatcher, this.listenTo(this.eventDispatcher, window.app.applicationEvents.ROUTER_MODULE_STATE, this.onRouterStateChange), b.extend(g.prototype, e), this.delayInitialization()
        },
        delayedInitialization: function () {
            this.$controls = this.$el.children(".controls"), this.slickSliderOptions = {
                rows: 0,
                adaptiveHeight: !0,
                accessibility: !1,
                dots: !0,
                infinite: !0,
                initialSlide: this.initialSlide,
                slidesToShow: 1,
                slidesToScroll: 1,
                touchThreshold: 4,
                easing: "ease-in",
                slide: ".slide",
                arrows: !1,
                appendDots: this.$controls,
                mobileFirst: !0,
                customPaging: function (b, c) {
                    var d = a(b.$slides[c]).data("title");
                    return "<div>" + d + "</div>"
                }
            }, this.iscrollOptions = {
                eventPassthrough: !0,
                bounce: !1,
                click: !1,
                mouseWheel: !1,
                deceleration: .01,
                tap: !0,
                scrollbars: !0,
                fadeScrollbars: !0,
                interactiveScrollbars: !0,
                scrollX: !0,
                scrollY: !1,
                preventDefault: !1,
                snap: !0
            }, this.$buttons = this.$controls.find(".prev, .next").detach(), this.setupListeners(), this.render(), this.uncover();
            var b = a.Event("init", {
                target: this.el,
                slick: this.isSlickInitialized ? this.$el.slick("getSlick") : null
            });
            this.eventDispatcher.trigger(window.app.applicationEvents.TAB_SLIDER_INIT, b, this)
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.ACCORDION_SHOW, this.onContentHeightChange), this.listenTo(this.eventDispatcher, window.app.applicationEvents.ACCORDION_HIDE, this.onContentHeightChange), this.listenTo(this.eventDispatcher, window.app.applicationEvents.PRODUCT_SLIDER_CHANGE, this.onContentHeightChange), this.listenTo(this.eventDispatcher, window.app.applicationEvents.PRODUCT_SLIDER_TRANSITIONEND, this.onContentAfterChange), this.listenTo(this.eventDispatcher, window.app.applicationEvents.AVAILABLE_OPTIONS_CHANGED, this.onAvailableOptionsChange), this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.onResize)
        },
        render: function () {
            return this.$(".slide").length < 2 && this.$(".controls").addClass("hide"), this.$(this.slickSliderOptions.slide).length < 2 ? this : (this.isSlickInitialized = !0, this.$slider = this.$el.slick(b.extend(this.slickSliderOptions, this.options.slickSlider)), this.$tabs = this.$slider.find("." + this.$slider.slick("slickGetOption", "dotsClass")), 0 === this.$tabs.length ? this : (this.renderTabArrows(), this.scroller = new f(this.$controls.get(0), this.iscrollOptions), 0 !== this.$buttons.length && (this.$controls.append(this.$buttons), this.scroller.x > this.scroller.maxScrollX && this.$buttons.filter(".prev").addClass("disabled").parents(".controls").addClass("overflow-right"), this.$buttons.on("click", function (b) {
                var c = a(b.currentTarget);
                this.$buttons.removeClass("disabled"), c.hasClass("prev") ? this.scroller.prev() : c.hasClass("next") && this.scroller.next()
            }.bind(this)), this.scroller.on("scrollEnd", this.onScrollEnd.bind(this)), this.$slider.on("beforeChange", this.onSliderBeforeChange.bind(this))), this.$selectTabNavigation.length && this.$selectTabNavigation.on("click", this.toggleDropdownTabMenu.bind(this)), b.isUndefined(this.routeId) || "" === this.routeId || this.$slider.on("beforeChange", this.sliderNavigate.bind(this)), this.$slider.on("afterChange", this.onSliderAfterChange.bind(this)), this.setDataSlickTabNavigation(this.$controls.find(".slick-active")), this))
        },
        renderTabArrows: function () {
            this.$slider && (this.$tabs.width() <= this.$el.width() ? (this.$el.removeClass("tab-arrows"), this.$buttons.parents(".controls").removeClass("overflow-right overflow-left")) : (this.$el.addClass("tab-arrows"), this.updateArrows()))
        },
        sliderNavigate: function (c, d, e, f) {
            if (e !== f) {
                var g, h, i = [this.routeId, f];
                b.isUndefined(this.contentIndex) || !b.isNumber(this.contentIndex) || isNaN(this.contentIndex) || i.push(this.contentIndex), g = i.join(":"), h = a.Event("changestate", {
                    fragment: g,
                    routeId: this.routeId,
                    slideIndex: f
                }), this.eventDispatcher.trigger(window.app.applicationEvents.MODULE_STATE, h)
            }
        },
        onAvailableOptionsChange: function (b) {
            if (b.availableOptions === this.$parent.get(0) && ("open" === b.type || "close" === b.type) && this.$slider) {
                var c = this.$slider.slick("slickCurrentSlide"),
                    d = a.Event("changestate", {routeId: this.routeId, slideIndex: c});
                "open" === b.type ? (d.fragment = [this.routeId, c, b.contentIndex].join(":"), d.contentIndex = b.contentIndex) : "close" === b.type && (d.fragment = [this.routeId, c].join(":")), this.eventDispatcher.trigger(window.app.applicationEvents.MODULE_STATE, d)
            }
        },
        onRouterStateChange: function (c) {
            if (c.fragment.indexOf(this.routeId) !== -1) {
                b.isUndefined(c.jumpTo) || c.jumpTo !== this.routeId || this.el.scrollIntoView({behavior: "smooth"});
                var d, e = c.states[this.routeId];
                b.isArray(e) ? (this.initialSlide = Number(e.shift()), this.contentIndex = Number(e.shift())) : this.initialSlide = Number(e), !b.isUndefined(this.$slider) && b.isObject(this.$slider) && this.$slider.slick("slickCurrentSlide") !== this.initialSlide && this.$slider.slick("slickGoTo", this.initialSlide), !b.isUndefined(this.contentIndex) && b.isNumber(this.contentIndex) && !isNaN(this.contentIndex) && this.$parent.hasClass("module-available-options") && (d = a.Event("changestate", {
                    availableOptions: this.$parent.get(0),
                    fragment: c.fragment,
                    routeId: this.routeId,
                    slideIndex: this.initialSlide,
                    contentIndex: this.contentIndex
                }), this.eventDispatcher.trigger(window.app.applicationEvents.AVAILABLE_OPTIONS_CHANGE, d))
            }
        },
        onResize: function () {
            this.renderTabArrows()
        },
        onContentHeightChange: function (c, d) {
            if ("undefined" != typeof d.$content) {
                if (!a.contains(this.el, d.$content[0])) return;
                !b.isUndefined(this.$slider) && b.isObject(this.$slider) && this.$slider.children(".slick-list").css("height", this.$slider.children(".slide.slick-active").height()), d.$content.on("transitionend", function () {
                    d.$content.off("transitionend"), this.$slider && this.$slider.slick("slickGoTo", this.$slider.slick("slickCurrentSlide"))
                }.bind(this))
            }
        },
        onContentAfterChange: function (c, d) {
            a.contains(this.el, d.el) && !b.isUndefined(this.$slider) && b.isObject(this.$slider) && this.$slider.slick("slickSetOption", null, null, !0)
        },
        onScrollEnd: function () {
            this.updateArrows()
        },
        updateArrows: function () {
            var a;
            this.scroller && (a = this.$buttons.parents(".controls"), a.removeClass("overflow-right overflow-left"), this.scroller.x >= 0 ? (this.$buttons.filter(".prev").addClass("disabled"), this.$buttons.filter(".next").removeClass("disabled"), a.addClass("overflow-right")) : this.scroller.x <= this.scroller.maxScrollX ? (this.$buttons.filter(".next").addClass("disabled"), this.$buttons.filter(".prev").removeClass("disabled"), a.addClass("overflow-left")) : (this.$buttons.removeClass("disabled"), a.addClass("overflow-left"), a.addClass("overflow-right")))
        },
        onSliderBeforeChange: function (a, b, c, d) {
            if (a.currentTarget === b.$slider.get(0)) {
                this.$controls.removeClass("show"), window.setTimeout(this.eventDispatcher.trigger.bind(this.eventDispatcher, window.app.applicationEvents.TAB_SLIDER_CHANGE, a, this), 0);
                var e = this.$tabs.find("li").eq(d);
                this.setDataSlickTabNavigation(e), c < d ? 0 <= this.scroller.x && this.$el.width() < e.position().left + e.width() ? this.scroller.next() : e.position().left < 0 && this.scroller.prev() : d < c && (this.scroller.x < 0 && e.position().left < 0 ? this.scroller.prev() : this.$el.width() < e.position().left && this.scroller.next())
            }
        },
        onSliderAfterChange: function (a, b) {
            a.currentTarget === b.$slider.get(0) && this.eventDispatcher.trigger(window.app.applicationEvents.TAB_SLIDER_AFTER_CHANGE, a, this)
        },
        toggleDropdownTabMenu: function () {
            var a = this.$controls;
            a.hasClass("show") ? a.removeClass("show") : a.addClass("show")
        },
        setDataSlickTabNavigation: function (a) {
            if (a) {
                var b = a.text();
                b && this.$selectTabCountry.html(b)
            }
        },
        getCurrentSlideIndex: function () {
            return this.$el.slick("slickCurrentSlide")
        }
    });
    return function (a) {
        return this instanceof g ? this : new g(a)
    }
}),/**
 * TinySort is a small script that sorts HTML elements. It sorts by text- or attribute value, or by that of one of it's children.
 * @summary A nodeElement sorting script.
 * @version 2.3.6
 * @license MIT
 * @author Ron Valstar <ron@ronvalstar.nl>
 * @copyright Ron Valstar <ron@ronvalstar.nl>
 * @namespace tinysort
 */
    function (a) {
        "function" == typeof define && define.amd ? define("tiny-sort", [], a) : "object" == typeof exports ? module.exports = a() : window.tinysort = a()
    }(function () {
        "use strict";

        function a(a, d) {
            function h() {
                0 === arguments.length ? r({}) : b(arguments, function (a) {
                    r(B(a) ? {selector: a} : a)
                }), n = I.length
            }

            function r(a) {
                var b = !!a.selector, d = b && ":" === a.selector[0], e = c(a || {}, q);
                I.push(c({
                    hasSelector: b,
                    hasAttr: !(e.attr === g || "" === e.attr),
                    hasData: e.data !== g,
                    hasFilter: d,
                    sortReturnNumber: "asc" === e.order ? 1 : -1
                }, e))
            }

            function s() {
                b(a, function (a, b) {
                    D ? D !== a.parentNode && (J = !1) : D = a.parentNode;
                    var c = I[0], d = c.hasFilter, e = c.selector,
                        f = !e || d && a.matchesSelector(e) || e && a.querySelector(e), g = f ? G : H,
                        h = {elm: a, pos: b, posn: g.length};
                    F.push(h), g.push(h)
                }), C = G.slice(0)
            }

            function t(a, b, c) {
                for (var d = c(a.toString()), e = c(b.toString()), f = 0; d[f] && e[f]; f++) if (d[f] !== e[f]) {
                    var g = Number(d[f]), h = Number(e[f]);
                    return g == d[f] && h == e[f] ? g - h : d[f] > e[f] ? 1 : -1
                }
                return d.length - e.length
            }

            function u(a) {
                for (var b, c, d = [], e = 0, f = -1, g = 0; b = (c = a.charAt(e++)).charCodeAt(0);) {
                    var h = 46 == b || b >= 48 && b <= 57;
                    h !== g && (d[++f] = "", g = h), d[f] += c
                }
                return d
            }

            function v(a, c) {
                var d = 0;
                for (0 !== o && (o = 0); 0 === d && o < n;) {
                    var g = I[o], h = g.ignoreDashes ? l : k;
                    if (b(m, function (a) {
                        var b = a.prepare;
                        b && b(g)
                    }), g.sortFunction) d = g.sortFunction(a, c); else if ("rand" == g.order) d = Math.random() < .5 ? 1 : -1; else {
                        var i = f, p = A(a, g), q = A(c, g), r = "" === p || p === e, s = "" === q || q === e;
                        if (p === q) d = 0; else if (g.emptyEnd && (r || s)) d = r && s ? 0 : r ? 1 : -1; else {
                            if (!g.forceStrings) {
                                var v = B(p) ? p && p.match(h) : f, w = B(q) ? q && q.match(h) : f;
                                if (v && w) {
                                    var x = p.substr(0, p.length - v[0].length),
                                        y = q.substr(0, q.length - w[0].length);
                                    x == y && (i = !f, p = j(v[0]), q = j(w[0]))
                                }
                            }
                            d = p === e || q === e ? 0 : g.natural && (isNaN(p) || isNaN(q)) ? t(p, q, u) : p < q ? -1 : p > q ? 1 : 0
                        }
                    }
                    b(m, function (a) {
                        var b = a.sort;
                        b && (d = b(g, i, p, q, d))
                    }), d *= g.sortReturnNumber, 0 === d && o++
                }
                return 0 === d && (d = a.pos > c.pos ? 1 : -1), d
            }

            function w() {
                var a = G.length === F.length;
                if (J && a) M ? G.forEach(function (a, b) {
                    a.elm.style.order = b
                }) : D ? D.appendChild(x()) : console.warn("parentNode has been removed"); else {
                    var b = I[0], c = b.place, d = "org" === c, e = "start" === c, f = "end" === c, g = "first" === c,
                        h = "last" === c;
                    if (d) G.forEach(y), G.forEach(function (a, b) {
                        z(C[b], a.elm)
                    }); else if (e || f) {
                        var i = C[e ? 0 : C.length - 1], j = i && i.elm.parentNode,
                            k = j && (e && j.firstChild || j.lastChild);
                        k && (k !== i.elm && (i = {elm: k}), y(i), f && j.appendChild(i.ghost), z(i, x()))
                    } else if (g || h) {
                        var l = C[g ? 0 : C.length - 1];
                        z(y(l), x())
                    }
                }
            }

            function x() {
                return G.forEach(function (a) {
                    E.appendChild(a.elm)
                }), E
            }

            function y(a) {
                var b = a.elm, c = i.createElement("div");
                return a.ghost = c, b.parentNode.insertBefore(c, b), a
            }

            function z(a, b) {
                var c = a.ghost, d = c.parentNode;
                d.insertBefore(b, c), d.removeChild(c), delete a.ghost
            }

            function A(a, b) {
                var c, d = a.elm;
                return b.selector && (b.hasFilter ? d.matchesSelector(b.selector) || (d = g) : d = d.querySelector(b.selector)), b.hasAttr ? c = d.getAttribute(b.attr) : b.useVal ? c = d.value || d.getAttribute("value") : b.hasData ? c = d.getAttribute("data-" + b.data) : d && (c = d.textContent), B(c) && (b.cases || (c = c.toLowerCase()), c = c.replace(/\s+/g, " ")), null === c && (c = p), c
            }

            function B(a) {
                return "string" == typeof a
            }

            B(a) && (a = i.querySelectorAll(a)), 0 === a.length && console.warn("No elements to sort");
            var C, D, E = i.createDocumentFragment(), F = [], G = [], H = [], I = [], J = !0,
                K = a.length && a[0].parentNode, L = K.rootNode !== document,
                M = a.length && (d === e || d.useFlex !== !1) && !L && getComputedStyle(K, null).display.indexOf("flex") !== -1;
            return h.apply(g, Array.prototype.slice.call(arguments, 1)), s(), G.sort(v), w(), G.map(function (a) {
                return a.elm
            })
        }

        function b(a, b) {
            for (var c, d = a.length, e = d; e--;) c = d - e - 1, b(a[c], c)
        }

        function c(a, b, c) {
            for (var d in b) (c || a[d] === e) && (a[d] = b[d]);
            return a
        }

        function d(a, b, c) {
            m.push({prepare: a, sort: b, sortBy: c})
        }

        var e, f = !1, g = null, h = window, i = h.document, j = parseFloat, k = /(-?\d+\.?\d*)\s*$/g,
            l = /(\d+\.?\d*)\s*$/g, m = [], n = 0, o = 0, p = String.fromCharCode(4095), q = {
                selector: g,
                order: "asc",
                attr: g,
                data: g,
                useVal: f,
                place: "org",
                returns: f,
                cases: f,
                natural: f,
                forceStrings: f,
                ignoreDashes: f,
                sortFunction: g,
                useFlex: f,
                emptyEnd: f
            };
        return h.Element && function (a) {
            a.matchesSelector = a.matchesSelector || a.mozMatchesSelector || a.msMatchesSelector || a.oMatchesSelector || a.webkitMatchesSelector || function (a) {
                for (var b = this, c = (b.parentNode || b.document).querySelectorAll(a), d = -1; c[++d] && c[d] != b;) ;
                return !!c[d]
            }
        }(Element.prototype), c(d, {loop: b}), c(a, {plugin: d, defaults: q})
    }), define("views/product-list-table-slider-view", ["jquery", "underscore", "backbone", "logger", "views/tab-slider-view", "views/product-list-compare-button-view", "tiny-sort"], function (a, b, c, d, e, f, g) {
    "use strict";
    var h = c.View.extend({
        logger: d.get("ProductListTableSliderView"),
        $tabSlider: void 0,
        tabSliderView: void 0,
        compareButtonView: void 0,
        compareButtonSelector: ".product-comparison",
        $compareButton: void 0,
        currentProductListPosition: 0,
        productListSelector: ".product-list",
        productListIdPrefix: "product-list-",
        productLists: void 0,
        revertSortDataKey: "index",
        slickSliderOptions: {swipe: !1, infinite: !1},
        events: {"click .table-header-col.sortable": "onSortableColumnClick"},
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.$compareButton = this.$(this.compareButtonSelector), this.productLists = this.el.querySelectorAll(this.productListSelector), this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render()
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.TAB_SLIDER_INIT, this.onTabSliderInit.bind(this)), this.listenTo(this.eventDispatcher, window.app.applicationEvents.TAB_SLIDER_CHANGE, this.onTabSliderBeforeChange.bind(this)), this.listenTo(this.eventDispatcher, window.app.applicationEvents.TAB_SLIDER_AFTER_CHANGE, this.onTabSliderAfterChange.bind(this)), this.listenTo(this.eventDispatcher, window.app.applicationEvents.ACCORDION_HIDE, this.onAccordionHide.bind(this)), this.listenTo(this.eventDispatcher, window.app.applicationEvents.ACCORDION_SHOWN, this.onAccordionShown.bind(this))
        },
        render: function () {
            this.initTabSlider()
        },
        initTabSlider: function () {
            this.$tabSlider = this.$(".tab-slider"), 0 !== this.$tabSlider.length && (this.tabSliderView = e({
                el: this.$tabSlider.get(0),
                $el: this.$tabSlider,
                slickSlider: this.slickSliderOptions
            }))
        },
        destroyCompareButton: function () {
            this.$compareButton.removeClass("show"), this.compareButtonView && (this.compareButtonView.destroyComparisonView(), this.compareButtonView = null)
        },
        initCompareButton: function () {
            if (!this.compareButtonView) {
                var c = this.$el.find(".module-accordion-group"), d = a(c[this.currentProductListPosition]);
                if (d.hasClass("with-compare") && 0 !== d.find(".module-accordion.active").length) {
                    var e = this.getProductList(this.currentProductListPosition);
                    if (!e) return void this.logger.warn("unknown product list at position", this.currentProductListPosition);
                    var g = e.dataset.productList;
                    if (!b.isObject(window.RS_productComparison) || !b.isObject(window.RS_productComparison[g])) return void this.logger.error("missing or invalid compare data for", g);
                    var h = window.RS_productComparison[g];
                    this.$compareButton.find(".compare-products").attr("href", "#" + g), this.compareButtonView = new f({
                        el: this.el,
                        $el: this.$el,
                        $compareButton: this.$compareButton,
                        productListId: g,
                        $productList: a(e),
                        isSticky: !0,
                        compareAttributes: h && h.attributes
                    }), this.$compareButton.addClass("show")
                }
            }
        },
        onAccordionHide: function (a, b) {
            var c = this.getProductList(this.currentProductListPosition);
            b && b.$el.closest(this.productListSelector).is(c) && this.destroyCompareButton()
        },
        onAccordionShown: function (a, b) {
            var c = this.getProductList(this.currentProductListPosition);
            b && b.$el.closest(this.productListSelector).is(c) && this.initCompareButton()
        },
        onTabSliderInit: function (a, c) {
            this.$tabSlider && 0 !== this.$tabSlider.length && a.target === this.$tabSlider.get(0) && (this.currentProductListPosition = b.isObject(c) ? c.initialSlide : 0, this.initCompareButton())
        },
        onTabSliderBeforeChange: function (a) {
            this.tabSliderView && a.target === this.tabSliderView.el && this.destroyCompareButton()
        },
        onTabSliderAfterChange: function (a) {
            this.tabSliderView && a.target === this.tabSliderView.el && (this.currentProductListPosition = this.tabSliderView.getCurrentSlideIndex(), this.initCompareButton())
        },
        onSortableColumnClick: function (b) {
            var c = a(b.target);
            c.hasClass(".sortable") || (c = c.closest(".sortable"));
            var d = c.closest(this.productListSelector);
            0 === d.length && this.logger.warn("Failed to get product list for sorting");
            var e = d.find(".product-list-item");
            if (0 !== e.length) {
                var f = e.get(0), g = this.getNextSortOrder(c), h = c.attr("data-key").toLowerCase();
                "asc" === g && f.attributes["data-" + h + "-min"] && (h += "-min"), "desc" === g && f.attributes["data-" + h + "-max"] && (h += "-max");
                var i = a(f.parentElement);
                i.addClass("fade-out"), d.find(".sortable").removeClass("sorted-asc sorted-desc"), setTimeout(function () {
                    c.toggleClass("sorted-asc", "asc" === g), c.toggleClass("sorted-desc", "desc" === g), g || (g = "asc", h = this.revertSortDataKey), this.sort(e.get(), g, h), i.removeClass("fade-out")
                }.bind(this), 250)
            }
        },
        getNextSortOrder: function (b) {
            var c = a(b);
            return c.hasClass("sorted-asc") ? null : c.hasClass("sorted-desc") ? "asc" : "desc"
        },
        sort: function (a, b, c) {
            g(a, {data: c, order: b})
        },
        getProductList: function (a) {
            return this.productLists[a] || null
        }
    });
    return function (a) {
        return this instanceof h ? this : new h(a)
    }
}), function (a) {
    "use strict";

    function b(b, e) {
        this.element = b, this.options = a.extend({}, d, e), this._defaults = d, this._name = c, this.init()
    }

    var c = "simpleSelect", d = {event: "keyup.simpleSelect change.simpleSelect"};
    b.prototype = {
        init: function () {
            var b = this;
            this.$element = a(this.element), this.$cover = a("<span />").insertAfter(this.$element), this.setCoverText(), this.$element.on(this.options.event, function () {
                b.setCoverText()
            })
        }, setCoverText: function () {
            var a = this.$element.find(":selected");
            a.hasClass("default") ? this.$cover.addClass("default") : this.$cover.removeClass("default"), a.length || (a = this.$element.find("option").first()), a.length && this.$cover.text(a.text())
        }
    }, a.fn[c] = function (d) {
        return this.each(function () {
            a.data(this, "plugin_" + c) || a.data(this, "plugin_" + c, new b(this, d))
        })
    }
}(jQuery), define("simple-select", ["jquery"], function () {
}), define("views/product-list-view", ["jquery", "underscore", "backbone", "views/product-comparison-view", "views/product-list-compare-button-view", "views/oscilloscope-filter-view", "tiny-sort", "equal-height", "simple-select", "ScrollMagic", "ScrollMagicIndicators"], function (a, b, c, d, e, f, g) {
    "use strict";
    var h = c.View.extend({
        productComparison: void 0,
        productList: void 0,
        productFilter: void 0,
        $productList: null,
        $productListElements: null,
        productListSelector: ".product-list",
        productListContainer: ".product-list-container",
        interactionsSelector: ".interactions",
        colTitleSelector: ".col-title",
        colTitleTextSelector: ".col-title-text",
        sortIconSelector: ".sort-icon",
        moduleAccordionSelector: ".module-accordion",
        sortingEnabledClass: "sorting-enabled",
        events: {
            "click .product-list .interactions .info-icon": "showToolTip",
            "click .product-list .interactions .close": "closeToolTip",
            "click .sorting-enabled .col-title-text": "initSort",
            "click .sorting-enabled .sort-icon": "initSort",
            "click .product-list li": "redirectToProductPage"
        },
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.$productListContainer = this.$(this.productListContainer), this.$columnHead = this.$(".col-head"), this.$tooltips = this.$(this.interactionsSelector), this.$openedTooltips = this.$tooltips.not(".hide"), this.$productRows = this.$(".list-row"), this.$productList = this.$("[data-product-list]"), this.duration = 100, this.shortDuration = 50, this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render()
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, b.debounce(this.onResize.bind(this), 200)), this.listenTo(this.eventDispatcher, window.app.applicationEvents.OSCILLOSCOPE_FILTER_UPDATE, this.toggleFilter)
        },
        render: function () {
            this.initOscilloscopeFilter(), this.initTable(), this.initSortDropdown(), e({
                el: this.el,
                $el: this.$el,
                isSticky: !0,
                $productList: this.$productList,
                productListId: this.$productList.data("product-list"),
                duration: this.duration,
                shortDuration: this.shortDuration
            }), this.$(".select-properties").each(this.bindOnChangeForFilterSelect.bind(this))
        },
        onResize: function () {
            this.calcTableComponents(), this.closeToolTips()
        },
        bindOnChangeForFilterSelect: function (b, c) {
            a(c).on("change", this.initSortByDropdown.bind(this))
        },
        initOscilloscopeFilter: function () {
            var b = this.$(".module-oscilloscope-filter");
            b.length ? this.productFilter = f({
                el: b[0],
                products: this.$productRows
            }) : this.$productRows.each(function (b, c) {
                a(c).parent().addClass("shown")
            })
        },
        initTable: function () {
            this.$listPrimary = a(".list-primary"), this.$listSecondary = a(".list-secondary"), this.$listPrimary.each(function (b, c) {
                var d = a(c), e = d.find("> div").length;
                e <= 2 && d.removeClass("col-1 col-2 col-3 col-4 col-5").addClass("col-" + e), 0 === d.find(".thumbnail").length && d.addClass("no-thumbnail"), d.find(".product-title a").length && d.parents("li").first().addClass("linked")
            }), this.$listSecondary.each(function (b, c) {
                var d = a(c), e = d.find("> div").length;
                e <= 7 && (d.removeClass("col-1 col-2 col-3 col-4 col-5").addClass("col-" + e), 0 === d.find(".price").length && 0 === d.find(".col-small").length && d.addClass("equal-cols"))
            }), this.$(this.colTitleSelector).each(function (b, c) {
                var d = a(c);
                0 !== d.find(".more-info-title, .more-info-content, .close, .info-icon").length && d.addClass("more-info"), 0 !== d.find(this.sortIconSelector).length && d.addClass(this.sortingEnabledClass)
            }.bind(this)), setTimeout(this.calcTableComponents(), 0)
        },
        calcTableComponents: function () {
            var b, c = this.$(".controls");
            this.$columnHead.initHeightBoxes("auto"), this.$columnHead.find(this.colTitleSelector).removeAttr("style"), 0 !== c.length && c.find(".col-content").removeAttr("style"), parseInt(window.app.matchMedia.getBreakpoint("screen-xl-min"), 10) <= window.innerWidth && (this.$columnHead.initHeightBoxes(), b = a(this.$(".product-list > li.shown:first-child .col-head")[0]), this.$("hr").css("top", Math.ceil(b.height() + 46)), this.calcTitleContainerWidth(), 0 !== c.length && this.$(".product-list > li").each(function (b, c) {
                var d = a(c), e = d.find(".controls .col-content:first"), f = [];
                d.find(".col-content").each(function (b, c) {
                    f.push(Math.ceil(a(c).height()))
                }), e.css("margin-top", Math.ceil((Math.max.apply(Math, f) - e.height()) / 2))
            })), this.$productListContainer.addClass("initialized"), this.eventDispatcher.trigger(window.app.applicationEvents.ACCORDION_RECALCULATE)
        },
        calcTitleContainerWidth: function () {
            this.$columnHead.find(this.colTitleTextSelector).each(function (b, c) {
                var d = a(c), e = d.parent();
                e.width("auto"), e.width(Math.ceil(d.width()))
            })
        },
        showToolTip: function (b) {
            b.stopPropagation(), this.initToolTip(a(b.target).parent())
        },
        initToolTip: function (b) {
            var c, d, e = a(b), f = e.parents(this.moduleAccordionSelector), g = 28,
                h = Math.ceil(e.offset().left + e.width() - g), i = Math.ceil(a(window).outerWidth()),
                j = Math.ceil(i - f.width()), k = i - h - j,
                l = Math.ceil(f.height() + f.offset().top - b.offset().top);
            if (e.parents(this.productListSelector).find(this.interactionsSelector).css("right", 0), e.hasClass("hide")) {
                if (this.$tooltips.removeClass("open-left open-top").addClass("hide"), e.removeClass("hide"), c = Math.ceil(e.width()), d = Math.ceil(e.height()), e.addClass("hide"), k < c && e.addClass("open-left"), l < d && e.addClass("open-top"), parseInt(window.app.matchMedia.getBreakpoint("screen-xl-min"), 10) <= window.innerWidth) {
                    if (!e.hasClass("open-left")) {
                        var m = parseInt(e.parent().css("padding-right")), n = m + 3;
                        e.css("right", n)
                    }
                } else e.removeAttr("style");
                e.hide().removeClass("hide").fadeIn(this.duration)
            }
        },
        closeToolTip: function (b) {
            b.stopPropagation();
            var c = this, d = a(b.target).parents(this.interactionsSelector);
            d.fadeOut(this.shortDuration, function () {
                c.$tooltips.removeAttr("style"), c.$tooltips.removeClass("open-left open-top"), d.addClass("hide").show()
            })
        },
        closeToolTips: function () {
            var a = this;
            this.$openedTooltips = this.$(".interactions:not(.hide)"), this.$openedTooltips.fadeOut(this.shortDuration, function () {
                a.$tooltips.removeAttr("style"), a.$openedTooltips.removeClass("open-left open-top align-right").addClass("hide").fadeIn(a.duration)
            })
        },
        initSortDropdown: function () {
            var c = this, d = this.$("li:first-child .sorting-enabled"), e = [], f = this.$(".simple-select"),
                g = f.data("suffix-desc"), h = f.data("suffix-asc"), i = f.data("default-option-text"),
                j = b.isUndefined(g) ? null : g, k = b.isUndefined(h) ? null : h, l = b.isUndefined(i) ? "Sort By" : i,
                m = this.getDropdownOption("", l),
                n = this.$(".list-row:first").find("." + this.sortingEnabledClass).parents(".col-head").parent(),
                o = !1, p = this.$(".list-row").length;
            n.each(function (b, d) {
                var e = a(d).attr("class"), f = c.$("." + e);
                f.length !== p ? f.removeClass(this.sortingEnabledClass) : o = !0
            }.bind(this)), o || f.remove(), d.each(function (b, c) {
                var d = a(c), f = d.parents(".col-head").parent().attr("class").split("|"),
                    g = d.find(this.colTitleTextSelector).html();
                f = f.toString().split(" ")[0], e.push([f, g])
            }.bind(this)), b.each(e, function (a) {
                var d = a[0], e = a[1], f = c.$("." + d).find(".sorting-enabled");
                f.length === p ? (b.isNull(j) || (m += c.getDropdownOption(d + "|desc", e + " " + j)), b.isNull(k) || (m += c.getDropdownOption(d + "|asc", e + " " + k))) : (f.removeClass(this.sortingEnabledClass), f.find(this.sortIconSelector).remove())
            }.bind(this)), f.length && f.find("select").html(m).simpleSelect().parent().addClass("show")
        },
        getDropdownOption: function (a, b) {
            return '<option value="' + a + '">' + b + "</option>"
        },
        initSort: function (b) {
            var c = a(b.target), d = "desc", e = c.parents(".col-head").parent().attr("class"),
                f = c.parents(this.colTitleSelector), g = "desc";
            f.hasClass("desc") && (d = "asc"), e = e.split(" ")[0], this.$(".simple-select").length && "media-from-l" !== window.app.matchMedia.getCurrentMediaQuery() ? c.parents(this.moduleAccordionSelector).find("select").val(e + "|" + d).change() : (f.hasClass("desc") && (g = "asc"), this.sort(c, g))
        },
        initSortByDropdown: function (a) {
            var b = a.target.value.split("|");
            if (b.length > 1) {
                var c = this.$el.find(".product-list > li:first-child ." + b[0] + " .col-title-text");
                this.sort(c, b[1])
            }
        },
        sort: function (a, c) {
            var d = a.parents(".list-row"), e = a.parents(".col-head").parent().attr("class").split(" ")[0],
                f = e + "-min", g = e + "-max", h = d.data(f), i = d.data(g);
            this.closeToolTips(), a.parents(this.moduleAccordionSelector).find(this.productListContainer).addClass("fade-out"), this.$columnHead.find(this.colTitleSelector).removeClass("asc desc"), a.parents(this.moduleAccordionSelector).find(this.productListContainer + " ." + e + " .sorting-enabled").addClass(c), b.isUndefined(h) || b.isUndefined(i) || ("desc" === c ? e = g : "asc" === c && (e = f)), window.setTimeout(this.sortDelayed.bind(this, e, c, a.parents(this.moduleAccordionSelector)), 250)
        },
        sortDelayed: function (b, c, d) {
            var e = "bandwidth-min" === b, f = "bandwidth-max" === b, h = null, i = null, j = null, k = null;
            g.defaults.order = c, g.defaults.sortFunction = null, (e || f) && (g.defaults.sortFunction = function (c, d) {
                return j = a(c.elm).find(".list-row"), k = a(d.elm).find(".list-row"), h = j.data(b), i = k.data(b), h < i ? -1 : 1
            }), this.$productListElements = d.find("ul.product-list>li"), g(this.$productListElements, {
                selector: ".list-row",
                data: b
            }).forEach(this.onRowSwapped.bind(this))
        },
        onRowSwapped: function (a, b) {
            b + 1 === this.$productListElements.length && (this.calcTableComponents(), this.$productListContainer.removeClass("fade-out"))
        },
        redirectToProductPage: function (c) {
            var d, e = a(c.target);
            e.is("a") || e.parents(this.interactionsSelector).length || e.prev("input.compare").length || e.is(this.colTitleTextSelector) || e.is(this.sortIconSelector) || e.is("img") || (d = e.closest("li").find(".product-title a").attr("href"), b.isNull(d) || b.isUndefined(d) || !d.length || (window.location.href = d))
        },
        toggleFilter: function (c) {
            if (c.$filterContainer && this.$el.has(c.$filterContainer).length) {
                if (b.isEmpty(c.filters)) return this.$productRows.each(function (b, c) {
                    a(c).parent().addClass("shown")
                }), void this.calcTableComponents();
                this.$productRows.each(function (d, e) {
                    var f, g, h, i, j, k = a(e).data(), l = !1, m = !1;
                    for (var n in c.filters) if (c.filters.hasOwnProperty(n) && (k.hasOwnProperty(n + "Min") || k.hasOwnProperty(n + "Max"))) {
                        f = c.filters[n], g = [k[n + "Min"], k[n + "Max"]];
                        for (j in f) f.hasOwnProperty(j) && (h = f[j], m = b.isUndefined(h.min) || b.isUndefined(h.max) ? !b.isEmpty(g) && h.value >= g[0] && h.value <= g[1] : g[0] >= h.min && g[0] <= h.max || g[1] >= h.min && g[1] <= h.max, m && (l = !0))
                    } else if (c.filters.hasOwnProperty(n) && k.hasOwnProperty(n)) {
                        f = c.filters[n], g = k[n];
                        for (j in f) if (f.hasOwnProperty(j)) {
                            h = f[j], b.isNaN(Number(g)) && g.indexOf("|") !== -1 && (i = g.split("|"), m = 0 === h.min ? h.max >= parseInt(i[1]) : h.min <= parseInt(i[0]) && h.max >= parseInt(i[1]));
                            var o = b.isString(g) && !b.isEmpty(g) && m,
                                p = !b.isUndefined(h.min) && !b.isUndefined(h.max) && h.min <= g && g <= h.max,
                                q = (b.isUndefined(h.min) || b.isUndefined(h.max)) && h.value === g,
                                r = b.isString(g) && !b.isEmpty(g) && h.value === g;
                            (o || b.isNumber(g) && p || q || r) && (l = !0)
                        }
                    }
                    l ? a(e).parent().addClass("shown") : a(e).parent().removeClass("shown")
                }), this.calcTableComponents()
            }
        }
    });
    return function (a) {
        return this instanceof h ? this : new h(a)
    }
}), define("views/product-options-downloads-view", ["jquery", "underscore", "backbone", "views/accordion-item-view", "images-loaded", "slick-slider"], function (a, b, c, d, e) {
    "use strict";
    var f = c.View.extend({
        currentDisplay: void 0,
        accordionItemsRendered: !1,
        tabsNavRendered: !1,
        $container: void 0,
        accordionElems: void 0,
        accordionItems: [],
        firstInitialization: !0,
        defaults: {
            slickSliderOptions: {
                rows: 0,
                arrows: !1,
                accessibility: !1,
                adaptiveHeight: !0,
                dots: !0,
                easing: "ease-in",
                infinite: !1,
                mobileFirst: !0,
                slide: ".product-option",
                touchThreshold: 4
            }
        },
        events: {"click .product-options-models .linked": "onModelsTableRowClick"},
        initialize: function (c) {
            this.$nav = a('<div class="product-options-nav" />'), this.defaults.slickSliderOptions.customPaging = this.customPaging.bind(this), this.defaults.slickSliderOptions.appendDots = this.$nav, this.options = b.extend({}, this.defaults, b.omit(c, ["el", "$el"])), this.$container = this.$(".product-options"), this.accordionElems = this.el.querySelectorAll(".product-option"), this.eventDispatcher = window.app.eventDispatcher, e.makeJQueryPlugin(a), this.setupListeners(), this.render(), this.renderModelsTable()
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.render), this.$container.on("afterChange", this.onAfterChange.bind(this))
        },
        render: function () {
            var a = window.app.matchMedia.getMediaQueries(), b = "media-to-m" === a.currentMediaQuery;
            return a.currentMediaQuery === a.lastMediaQuery || b === !0 && "accordion" === this.currentDisplay || b === !1 && "tabs" === this.currentDisplay ? this : (b ? ("tabs" === this.currentDisplay && this.destroyTabs(), this.renderAccordion()) : ("accordion" === this.currentDisplay && this.destroyAccordion(), this.renderTabs()), this)
        },
        refreshView: function () {
            this.firstInitialization ? (this.$container.slick("slickGoTo", this.$container.slick("slickCurrentSlide")), this.firstInitialization = !1) : this.$container.slick("setOption", "", null, !0)
        },
        onAfterChange: function () {
            this.$container.imagesLoaded().done(this.refreshView.bind(this))
        },
        renderAccordion: function () {
            if (this.accordionItemsRendered === !1) {
                for (var a = 0, b = this.accordionElems.length; a < b; a++) this.accordionItems.push(d({
                    el: this.accordionElems[a],
                    parent: this
                }));
                this.accordionItemsRendered = !0
            }
            this.currentDisplay = "accordion"
        },
        destroyAccordion: function () {
            var b = a.Event("reset", {target: this.el, relatedTarget: this.el});
            this.eventDispatcher.trigger(window.app.applicationEvents.ACCORDION_RESET, b, this), this.currentDisplay = null
        },
        renderTabs: function () {
            this.$nav.prependTo(this.el), this.$container.slick(this.options.slickSliderOptions), this.currentDisplay = "tabs"
        },
        destroyTabs: function () {
            this.$nav.detach(), this.$container.slick("unslick"), this.currentDisplay = null
        },
        customPaging: function (b, c) {
            return '<button type="button">' + a(b.$slides[c]).find(".title").text() + "</button>"
        },
        renderModelsTable: function () {
            this.$(".product-options-models tr").each(this.renderModelsTableRows.bind(this))
        },
        renderModelsTableRows: function (c, d) {
            var e = d.querySelector("a");
            b.isObject(e) && !b.isUndefined(e.href) && "" !== e.href && a(d).addClass("linked")
        },
        onModelsTableRowClick: function (a) {
            a.preventDefault(), location.href = a.currentTarget.querySelector("a").href
        }
    });
    return function (a) {
        return this instanceof f ? this : new f(a)
    }
}), define("views/product-related-products-view", ["jquery", "underscore", "backbone", "slick-slider"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.slickSliderOptions = {
                rows: 0,
                adaptiveHeight: !0,
                accessibility: !1,
                dots: !0,
                infinite: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                touchThreshold: 4,
                easing: "ease-in",
                slide: ".product",
                appendArrows: this.$(".controls"),
                dotsClass: "slider-dots",
                arrows: !0,
                mobileFirst: !0,
                prevArrow: '<span class="slick-prev"></span>',
                nextArrow: '<span class="slick-next"></span>',
                responsive: [{
                    breakpoint: 1100,
                    settings: {appendArrows: this.$(".related-products"), dots: !0, slidesToShow: 4, slidesToScroll: 4}
                }, {
                    breakpoint: 640,
                    settings: {appendArrows: this.$(".related-products"), dots: !0, slidesToShow: 2, slidesToScroll: 2}
                }, {breakpoint: 1, settings: this.$(".product").length <= 4 ? "unslick" : {dots: !0}}],
                customPaging: function () {
                    return "<span></span>"
                }
            }, this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.render)
        }, render: function () {
            var a = this.$el.find(".related-products");
            return a.hasClass("slick-initialized") || a.slick(this.slickSliderOptions), a.addClass("initialized"), this
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/video-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        events: {
            ended: "onEnded",
            play: "onPlay",
            pause: "onPause",
            seeked: "onSeeked",
            waiting: "onWaiting"
        }, initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.render(), this.title = this.$el.attr("title") || "", this.filename = this.$el.data("filename") || "", this.alreadyStarted = !1, this.paused = !1, this.seeked = !1
        }, onPlay: function () {
            var a = "";
            this.seeked && !this.paused || (this.alreadyStarted || (a = "start", window.app.trackEvent("", null, ["DCSext.video_title", this.title, "DCSext.video_filename", this.filename, "DCSext.video_status", a, "WT.dl", "51"], !1)), this.paused = !1, this.alreadyStarted = !0, this.eventDispatcher.trigger(window.app.applicationEvents.TEASER_STAGE_STOP_AUTOPLAY))
        }, onPause: function () {
            this.paused = !0, this.seeked = !1
        }, onEnded: function () {
            this.alreadyStarted = !1, this.eventDispatcher.trigger(window.app.applicationEvents.VIDEO_ENDED)
        }, onSeeked: function () {
            this.seeked = !0
        }, render: function () {
            return this
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/product-slider-view", ["jquery", "underscore", "backbone", "app/delayed-initialization", "views/video-view", "images-loaded", "slick-slider", "magnific-popup"], function (a, b, c, d, e) {
    "use strict";
    var f = c.View.extend({
        $lightboxSrc: void 0,
        $lightboxImageContainer: void 0,
        videoView: void 0,
        delayBetweenClicks: 0,
        arrowClickTimeout: 650,
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, b.extend(f.prototype, d), this.delayInitialization()
        },
        delayedInitialization: function () {
            this.$imageContainer = this.$(".images"), this.$controls = this.$(".controls"), this.slideCount = this.$imageContainer.find(".image-container").length, this.matchMedia = window.app.matchMedia, this.setupListeners(), this.render(), this.uncover()
        },
        setupListeners: function () {
            1 < this.slideCount && this.listenTo(this.eventDispatcher, window.app.applicationEvents.TAB_SLIDER_CHANGE, function () {
                this.$controls.slick("setSlideClasses", this.$imageContainer.slick("slickCurrentSlide"))
            }.bind(this)), this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, b.debounce(this.onResize, 100))
        },
        render: function () {
            return this.initLightbox(), this.initSlider(), this
        },
        initSlider: function () {
            this.lastTimestamp = 0, 1 < this.slideCount ? (this.$imageContainer.on("beforeChange", this.onSliderBeforeChange.bind(this)), this.$imageContainer.on("afterChange", this.triggerSlickRefresh.bind(this)), this.$imageContainer.slick({
                rows: 0,
                adaptiveHeight: !1,
                accessibility: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                easing: "ease-in",
                arrows: !1,
                mobileFirst: !0,
                asNavFor: this.$controls
            }), this.$controls.slick({
                rows: 0,
                adaptiveHeight: !1,
                accessibility: !1,
                arrows: !1,
                slidesToShow: 4,
                slidesToScroll: 1,
                easing: "ease-in",
                focusOnSelect: !0,
                mobileFirst: !0,
                asNavFor: this.$imageContainer
            }), this.initNavArrows(), this.$imageContainer.imagesLoaded().always(this.onImageLoadingDone.bind(this))) : this.$controls.addClass("hide")
        },
        initNavArrows: function () {
            var a = '<span class="slick-prev slick-arrow" style=""></span>',
                b = '<span class="slick-next slick-arrow" style=""></span>', c = 4 < this.slideCount;
            this.delayBetweenClicks = 0, this.$controls.prepend(a + b), c || (this.$imageContainer.slick("slickSetOption", {asNavFor: ""}), this.$controls.slick("slickSetOption", {slidesToShow: this.slideCount}), this.$controls.width(this.$controls.find(".slick-track").width())), this.$(".slick-prev, .slick-next").on("click", this.onSlickArrowClick.bind(this))
        },
        onSlickArrowClick: function (b) {
            var c = a(b.target), d = this.arrowClickTimeout, e = 4 < this.slideCount,
                f = this.$controls.find(".slick-slide"), g = this.$imageContainer.slick("slickCurrentSlide"),
                h = (new Date).getTime() - this.lastTimestamp;
            if (this.lastTimestamp = (new Date).getTime(), h <= d && this.delayBetweenClicks <= d) return void (this.delayBetweenClicks += d - h);
            if (this.delayBetweenClicks = 0, c.hasClass("slick-prev") ? 0 === g ? g = f.length - 1 : g-- : c.hasClass("slick-next") && (g === f.length - 1 ? g = 0 : g++), e) {
                if (c.hasClass("slick-prev")) return void this.$imageContainer.slick("slickPrev");
                this.$imageContainer.slick("slickNext")
            } else this.$controls.find(".slick-slide").eq(g).trigger("click")
        },
        updateSlider: function () {
            this.$imageContainer.hasOwnProperty("slick") && this.$imageContainer.slick("refresh"), this.$controls.hasOwnProperty("slick") && this.$controls.slick("refresh"), this.triggerSlickRefresh(null, null), this.$controls.find(".slick-track").css({transform: "translate3d(0px, 0px, 0px)"})
        },
        onImageLoadingDone: function () {
            this.$imageContainer.hasOwnProperty("slick") && this.$imageContainer.slick("slickGoTo", this.$imageContainer.slick("slickCurrentSlide")), this.$content = this.$el.parents(".slick-list"), this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_SLIDER_CHANGE, null, this)
        },
        onSliderBeforeChange: function (a) {
            this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_SLIDER_CHANGE, a, this), this.$imageContainer.on("transitionend", this.onSliderTransitionEnd.bind(this))
        },
        triggerSlickRefresh: function (a) {
            this.$content = this.$el.parents(".slick-list"), this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_SLIDER_CHANGE, a, this)
        },
        onSliderTransitionEnd: function (a) {
            this.$imageContainer.off("transitionend"), this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_SLIDER_TRANSITIONEND, a, this)
        },
        initLightbox: function () {
            var b = this, c = this.$imageContainer.find(".lightbox-content");
            this.$lightboxSrc = a('<div class="lightbox-slider"></div>'), this.$lightboxImageContainer = a('<div class="images"/>').appendTo(this.$lightboxSrc), c.each(function (d, e) {
                var f, g = a(e).clone(), h = g.find("img"), i = [d + 1, c.length].join("/"),
                    j = a('<span class="counter"/>').text(i);
                0 !== h.length ? (h.attr("src", g.data("img-src")), j.insertAfter(h)) : (f = g.find("video"), 0 !== f.length && j.insertAfter(f)), g.appendTo(b.$lightboxImageContainer)
            }), this.$imageContainer.magnificPopup({
                delegate: ".image, .video, .lightbox, .video-container",
                type: "inline",
                callbacks: {
                    elementParse: this.onLightboxParse.bind(this),
                    open: this.onLightboxOpen.bind(this),
                    beforeClose: this.onLightboxBeforeClose.bind(this),
                    afterClose: this.onLightboxAfterClose.bind(this)
                },
                closeBtnInside: !1,
                removalDelay: 300
            })
        },
        initLightboxSlider: function (a) {
            var b = a || 0;
            this.$lightboxImageContainer.on("setPosition", this.updateLightboxSliderControls.bind(this)).on("init afterChange", this.maybeStartVideo.bind(this)).on("beforeChange", this.maybePauseVideo.bind(this)), this.$lightboxImageContainer.slick({
                rows: 0,
                accessibility: !1,
                infinite: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: b,
                easing: "ease-in",
                arrows: !1,
                appendArrows: ".lightbox-slider",
                dots: !0,
                mobileFirst: !0,
                prevArrow: '<span class="slick-prev"></span>',
                nextArrow: '<span class="slick-next"></span>',
                responsive: [{
                    breakpoint: parseInt(this.matchMedia.getBreakpoint("screen-m-min"), 10),
                    settings: {arrows: !0, dots: !1}
                }],
                customPaging: function () {
                    return "<span></span>"
                }
            })
        },
        updateLightboxSlider: function () {
            this.$lightboxImageContainer.hasClass("slick-initialized") && this.$lightboxImageContainer.slick("refresh")
        },
        destroyLightboxSlider: function () {
            this.$lightboxImageContainer.hasClass("slick-initialized") && this.$lightboxImageContainer.slick("unslick");
        },
        updateLightboxSliderControls: function (a, c) {
            var d, e = c.$slides.eq(c.currentSlide), f = 0, g = e.find("> img"), h = e.find("video");
            if (0 !== g.length ? f = g.height() : 0 !== h.length && (f = h.height()), !b.isUndefined(c.$dots) && b.isObject(c.$dots) && 0 !== c.$dots.length && (d = 0 === h.length ? "block" : "none", c.$dots.css({
                display: d,
                top: Math.round(f)
            })), !b.isUndefined(c.$nextArrow) && b.isObject(c.$nextArrow) && 0 !== c.$nextArrow.length) {
                var i = Math.round(f / 2), j = {"padding-top": i};
                c.$nextArrow.css(j), c.$prevArrow.css(j)
            }
        },
        maybeStartVideo: function (a, b) {
            var c = b.$slides.eq(b.currentSlide).find("video");
            c.length && c[0].play()
        },
        maybePauseVideo: function (a, b) {
            var c = b.$slides.eq(b.currentSlide).find("video");
            c.length && c[0].pause()
        },
        onResize: function () {
            this.updateSlider(), a.magnificPopup.instance.isOpen === !0 && this.updateLightboxSlider()
        },
        onLightboxParse: function (a) {
            a.src = this.$lightboxSrc, this.videoView || (this.videoView = e({el: a.src.find("video").get()}))
        },
        onLightboxOpen: function () {
            1 < this.slideCount && this.initLightboxSlider(a(a.magnificPopup.instance.st.el).closest(".image-container").index() - 1)
        },
        onLightboxBeforeClose: function () {
            this.$lightboxImageContainer.find("video").each(function (a, b) {
                b.pause(), b.currentTime = 0
            })
        },
        onLightboxAfterClose: function () {
            this.videoView && (this.videoView.undelegateEvents(), this.videoView.stopListening()), this.videoView = null, this.destroyLightboxSlider()
        }
    });
    return function (a) {
        return this instanceof f ? this : new f(a)
    }
}), function (a) {
    var b;
    if ("function" == typeof define && define.amd && (define("Cookies", a), b = !0), "object" == typeof exports && (module.exports = a(), b = !0), !b) {
        var c = window.Cookies, d = window.Cookies = a();
        d.noConflict = function () {
            return window.Cookies = c, d
        }
    }
}(function () {
    function a() {
        for (var a = 0, b = {}; a < arguments.length; a++) {
            var c = arguments[a];
            for (var d in c) b[d] = c[d]
        }
        return b
    }

    function b(a) {
        return a.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent)
    }

    function c(d) {
        function e() {
        }

        function f(b, c, f) {
            if ("undefined" != typeof document) {
                f = a({path: "/"}, e.defaults, f), "number" == typeof f.expires && (f.expires = new Date(1 * new Date + 864e5 * f.expires)), f.expires = f.expires ? f.expires.toUTCString() : "";
                try {
                    var g = JSON.stringify(c);
                    /^[\{\[]/.test(g) && (c = g)
                } catch (a) {
                }
                c = d.write ? d.write(c, b) : encodeURIComponent(String(c)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), b = encodeURIComponent(String(b)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                var h = "";
                for (var i in f) f[i] && (h += "; " + i, f[i] !== !0 && (h += "=" + f[i].split(";")[0]));
                return document.cookie = b + "=" + c + h
            }
        }

        function g(a, c) {
            if ("undefined" != typeof document) {
                for (var e = {}, f = document.cookie ? document.cookie.split("; ") : [], g = 0; g < f.length; g++) {
                    var h = f[g].split("="), i = h.slice(1).join("=");
                    c || '"' !== i.charAt(0) || (i = i.slice(1, -1));
                    try {
                        var j = b(h[0]);
                        if (i = (d.read || d)(i, j) || b(i), c) try {
                            i = JSON.parse(i)
                        } catch (a) {
                        }
                        if (e[j] = i, a === j) break
                    } catch (a) {
                    }
                }
                return a ? e[a] : e
            }
        }

        return e.set = f, e.get = function (a) {
            return g(a, !1)
        }, e.getJSON = function (a) {
            return g(a, !0)
        }, e.remove = function (b, c) {
            f(b, "", a(c, {expires: -1}))
        }, e.defaults = {}, e.withConverter = c, e
    }

    return c(function () {
    })
}), define("views/product-teaser-view", ["underscore", "backbone", "Cookies", "mustache", "views/table-product-comparison-view", "views/table-view", "views/equal-height-view", "magnific-popup"], function (a, b, c, d, e, f, g) {
    "use strict";
    var h = b.View.extend({
        product: void 0,
        visible: !0,
        currentDisplay: void 0,
        comparisonView: void 0,
        $lightboxCover: void 0,
        cookie: "rs-product-comparison",
        events: {
            "click .product-compare-add": "addToComparison",
            "click .product-compare-remove": "removeFromComparison",
            "click .product-compare-open": "checkComparison"
        },
        initialize: function (b) {
            this.options = a.extend({}, this.defaults, a.omit(b, ["el", "$el"])), this.product = this.$el.data(), this.initEqualHeight(), this.$compareButtons = this.$(".product-compare"), this.$compareLink = this.$(".product-compare-open"), this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render()
        },
        initEqualHeight: function () {
            var a = this.$(".product-image, .product-info");
            a.length < 2 || g({$el: this.$el, el: this.el, $targets: a})
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.PRODUCT_COMPARISON_STORE_ADD, this.renderButtons), this.listenTo(this.eventDispatcher, window.app.applicationEvents.PRODUCT_COMPARISON_STORE_REMOVE, this.renderButtons), this.listenTo(this.eventDispatcher, window.app.applicationEvents.PRODUCT_FILTER_UPDATE, this.toggleDisplay)
        },
        render: function () {
            var a = this;
            if (this.$compareLink.magnificPopup({
                type: "ajax",
                ajax: {
                    settings: {
                        headers: {Accept: "application/javascript"},
                        cache: !1,
                        method: "POST",
                        dataType: "json",
                        data: {}
                    }
                },
                disableOn: function () {
                    return a.checkProductsAmount()
                },
                callbacks: {
                    beforeOpen: this.onBeforeLightboxOpen.bind(this),
                    open: this.onLightboxOpen.bind(this),
                    parseAjax: this.parseLightboxContent.bind(this),
                    ajaxContentAdded: this.onLightboxContentAdded.bind(this),
                    afterClose: this.onLightboxAfterClose.bind(this)
                },
                removalDelay: 300,
                tClose: ""
            }), this.stored()) {
                var c = b.$.Event("add", {
                    target: this.el,
                    currentTarget: this.el,
                    relatedTarget: this.el,
                    productId: this.product.productId,
                    storage: [],
                    add: this.product.productId
                });
                this.renderButtons(c)
            }
            return this
        },
        renderButtons: function (b) {
            "add" !== b.type || a.isUndefined(b.add) || b.add !== this.product.productId ? a.isUndefined(b.remove) || b.remove !== this.product.productId || this.$compareButtons.removeClass("added") : this.$compareButtons.addClass("added"), this.checkProductsAmount() ? this.$compareButtons.removeClass("disabled") : this.$compareButtons.addClass("disabled")
        },
        checkProductsAmount: function () {
            return c.getJSON(this.cookie).length > 1
        },
        toggleDisplay: function (b) {
            var c, d, e, f, g, h, i = b.filters, j = [];
            if (a.isEmpty(i)) return void this.show();
            for (var k in i) if (i.hasOwnProperty(k)) {
                c = i[k], e = this.$el.data("filter-" + k), f = [];
                for (var l in c) c.hasOwnProperty(l) && (d = c[l], a.isNaN(Number(e)) && e.indexOf("|") !== -1 && (g = e.split("|"), h = 0 === d.min ? d.max >= g[1] : d.min >= g[0] && d.max <= g[1]), (a.isString(e) && !a.isEmpty(e) && h || a.isNumber(e) && !a.isUndefined(d.min) && !a.isUndefined(d.max) && d.min <= e && e <= d.max || a.isUndefined(d.min) || a.isUndefined(d.max) && d.value === e || a.isString(e) && !a.isEmpty(e) && d.value === e) && f.push(d.value));
                0 === f.length && j.push(k)
            }
            0 !== j.length ? this.hide() : this.show()
        },
        show: function () {
            this.$el.addClass("show").removeClass("filtered"), this.visible = !0
        },
        hide: function () {
            this.$el.addClass("filtered").removeClass("show"), this.visible = !1
        },
        checkComparison: function (a) {
            a.preventDefault()
        },
        addToComparison: function (d) {
            d.preventDefault();
            var e, f, g, h = this.product.productId, i = c.getJSON(this.cookie);
            !a.isUndefined(i) && a.isObject(i) || (i = []), a.contains(i, h) || i.unshift(h), e = i.slice(0, 3), g = i.slice(3).shift(), c.set(this.cookie, e, {expires: 7}), f = b.$.Event("add", {
                target: this.el,
                relatedTarget: this.el,
                productId: h,
                storage: e,
                add: h,
                remove: g
            }), this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_COMPARISON_STORE_ADD, f)
        },
        removeFromComparison: function (d) {
            d.preventDefault();
            var e, f, g = this.product.productId, h = c.getJSON(this.cookie);
            !a.isUndefined(h) && a.isObject(h) && a.contains(h, g) && (e = a.without(h, g)), c.set(this.cookie, e, {expires: 7}), f = b.$.Event("remove", {
                target: this.el,
                relatedTarget: this.el,
                productId: g,
                storage: e,
                remove: g
            }), this.eventDispatcher.trigger(window.app.applicationEvents.PRODUCT_COMPARISON_STORE_REMOVE, f)
        },
        stored: function () {
            var b = c.getJSON(this.cookie);
            return !(a.isUndefined(b) || !a.isObject(b)) && a.contains(b, this.product.productId)
        },
        getProductsFromStorage: function () {
            var b = c.getJSON(this.cookie);
            return !a.isUndefined(b) && a.isObject(b) ? b : []
        },
        onBeforeLightboxOpen: function () {
            var a = {command: "ProductComparison", parameter: {products: this.getProductsFromStorage()}};
            b.$.magnificPopup.instance.st.ajax.settings.data = JSON.stringify(a)
        },
        onLightboxOpen: function () {
            this.$lightboxCover = b.$('<div class="cover"><div class="loader"/></div>').appendTo(b.$(".mfp-container"))
        },
        parseLightboxContent: function (c) {
            var e, f, g, h, i, j = c.data, k = j.products, l = [];
            if (a.isUndefined(k) || !a.isArray(k) || 0 === k.length) return void (c.data = "<p>No products.</p>");
            e = a.keys(k[0].attributes);
            for (var m = 0, n = e.length; m < n; m++) {
                f = e[m], g = {title: f, values: []};
                for (var o = 0, p = k.length; o < p; o++) g.values.push(k[o].attributes[f]);
                l.push(g)
            }
            h = b.$("#product-comparison-table-tmpl").html(), i = d.render(h, {products: k, attributes: l}), c.data = i
        },
        onLightboxContentAdded: function () {
            this.$lightboxCover && 0 !== this.$lightboxCover.length && (this.$lightboxCover.remove(), this.$lightboxCover = null), this.comparisonView = e({el: document.querySelector(".module-table-product-comparison")}), f({
                el: document.querySelector(".module-table-product-comparison .table-container"),
                parent: this,
                comparisonContainer: document.querySelector(".module-table-product-comparison .center-container")
            })
        },
        onLightboxAfterClose: function () {
            !a.isUndefined(this.comparisonView) && a.isObject(this.comparisonView) && this.comparisonView.remove()
        }
    });
    return function (a) {
        return this instanceof h ? this : new h(a)
    }
}), define("views/quicklinks-view", ["jquery", "underscore", "backbone", "slick-slider"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        slickSliderOptions: void 0,
        $slider: void 0,
        $elements: void 0,
        $loadMore: void 0,
        eventDispatcher: void 0,
        isMobile: void 0,
        isTablet: void 0,
        defaults: {slidesToShowDesktop: 5, slidesToShowTablet: 4, slidesToShowMobile: 5, groupMobile: 5},
        initialize: function (a) {
            var c = window.app.matchMedia.getBreakpoints();
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.$slider = this.$el.find(".slider-wrapper"), this.$elements = this.$slider.children(), this.$loadMore = this.$(".show-more").on("click", this.showMore.bind(this)), this.slickSliderOptions = {
                rows: 0,
                adaptiveHeight: !1,
                accessibility: !1,
                dots: !0,
                infinite: !1,
                slidesToShow: this.options.slidesToShowDesktop,
                slidesToScroll: this.options.slidesToShowDesktop,
                easing: "ease-in",
                arrows: !0,
                dotsClass: "slider-dots",
                prevArrow: '<span class="slick-prev"></span>',
                nextArrow: '<span class="slick-next"></span>',
                customPaging: function () {
                    return "<span></span>"
                },
                responsive: [{breakpoint: parseInt(c["screen-l-min"]), settings: "unslick"}]
            }, this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render(window.app.matchMedia.getCurrentMediaQuery())
        },
        setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.onViewportChange)
        },
        render: function (a) {
            return this.isMobile = this.checkMobile(a), this.isTablet = this.checkTablet(a), this.$loadMore.removeClass("shown"), this.isMobile && this.$elements.length > this.options.slidesToShowMobile ? (this.$loadMore.addClass("shown"), this.$elements.filter(":gt(" + (this.options.slidesToShowMobile - 1) + ")").addClass("hidden")) : this.isTablet && this.$elements.length > this.options.slidesToShowTablet ? (this.$loadMore.addClass("shown"), this.$elements.filter(":gt(" + (this.options.slidesToShowTablet - 1) + ")").addClass("hidden")) : this.isMobile || this.isTablet || (this.$elements.removeClass("hidden"), this.$elements.length > this.options.slidesToShowDesktop && this.$slider.slick(this.slickSliderOptions)), this
        },
        checkTablet: function (a) {
            return "media-from-m-to-l" === a
        },
        checkMobile: function (a) {
            return "media-to-m" === a
        },
        onViewportChange: function (a) {
            this.render(a.currentMediaQuery)
        },
        showMore: function () {
            this.isMobile ? this.$elements.filter(":hidden:lt(" + this.options.slidesToShowMobile + ")").removeClass("hidden") : this.isTablet && this.$elements.length > this.options.slidesToShowTablet && this.$elements.filter(":hidden:lt(" + this.options.slidesToShowTablet + ")").removeClass("hidden"), 0 === this.$elements.filter(":hidden").length && this.$loadMore.removeClass("shown")
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/search-sort-filter-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        form: void 0,
        $form: void 0,
        elements: void 0,
        trackedFocus: !1,
        isSuccess: !1,
        $messages: void 0,
        $notifications: void 0,
        generalDataProtectionContainer: ".general-data-protection-container",
        events: {"change form select": "submitForm"},
        initialize: function (c) {
            this.options = b.extend({}, this.defaults, b.omit(c, ["el", "$el"])), this.form = this.el.querySelector("form"), this.$form = a(this.form), this.elements = this.form.elements
        },
        submitForm: function (a) {
            a.preventDefault(), console.log(a.target), this.$form.submit()
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/searchbar-view", ["jquery", "underscore", "backbone", "views/search-view"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        events: {"click .btn-search > input": "search"}, initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.$form = this.$el.find("form.search"), this.render()
        }, render: function () {
            d({el: this.$form})
        }, search: function (a) {
            a.preventDefault(), this.$form.submit()
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("views/share-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        matchMedia: void 0, events: {"click a": "openSharingWindow"}, initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.matchMedia = window.app.matchMedia, this.title = document.title.split("®").join("(R)"), this.url = document.URL, this.render()
        }, render: function () {
            return this.$("a").each(function (b, c) {
                var d = a(c).attr("href");
                d = d.replace("{title}", encodeURIComponent(this.title)), d = d.replace("{url}", encodeURIComponent(this.url)), a(c).attr("href", d)
            }.bind(this)), this
        }, openSharingWindow: function (b) {
            var c = a(b.currentTarget).attr("href");
            if (c && "#" !== c && 0 !== c.indexOf("mailto:")) {
                b.preventDefault();
                var d,
                    e = "media-to-m" === this.matchMedia.getCurrentMediaQuery() || "media-from-m-to-l" === this.matchMedia.getCurrentMediaQuery(),
                    f = window.screenX, g = e ? null : 570, h = e ? null : 390, i = f < 0 ? window.screen.width + f : f,
                    j = parseInt(i + (window.outerWidth - g) / 2, 10),
                    k = parseInt(window.screenY + (window.outerHeight - h) / 2.5, 10), l = [];
                g && l.push("width=" + g), h && l.push("height=" + h), l.push("left=" + j), l.push("top=" + k), l.push("scrollbars=1"), l.push("location=1,toolbar=0"), d = l.join(","), window.open(c, "share", d)
            }
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/simple-banner-view", ["jquery", "underscore", "backbone", "TweenLite", "gsap.cssplugin"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        events: {"click .confirm, .close": "hide"}, initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.showDelayed), this.listenTo(this.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.showDelayed)
        }, render: function () {
            this.$el.prependTo("body"), this.showDelayed()
        }, showDelayed: function () {
            window.setTimeout(this.show.bind(this), 10)
        }, show: function () {
            d.to(this.$el, .5, {height: this.$(".center-wrapper").outerHeight(!0)})
        }, hide: function () {
            this.stopListening(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE), this.stopListening(this.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE), d.to(this.$el, .5, {
                height: 0,
                onComplete: this.remove,
                onCompleteScope: this
            })
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("views/styled-dropdown-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.$label = this.$(".label"), this.$pane = this.$(".pane"), this.render()
        }, render: function () {
            this.$label.on("click", function () {
                this.$el.toggleClass("open"), this.$pane.slideToggle(300)
            }.bind(this)), this.$pane.find(".option").on("click", function (a) {
                var b = this.$label.html();
                this.$label.html(a.currentTarget.innerHTML), a.currentTarget.innerHTML = b, this.$label.trigger("click")
            }.bind(this))
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/teaser-customer-voice-view", ["jquery", "underscore", "backbone", "slick-slider"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.sliderPrimary = null, this.sliderSecondary = null, this.slickSliderOptions = {
                rows: 0,
                adaptiveHeight: !0,
                accessibility: !1,
                infinite: !0,
                slidesToScroll: 1,
                touchThreshold: 4,
                easing: "ease-in",
                slide: ".slide",
                arrows: !0,
                mobileFirst: !0,
                prevArrow: '<span class="slick-prev"></span>',
                nextArrow: '<span class="slick-next"></span>',
                customPaging: function (a, b) {
                    return '<span class="index">' + (b + 1) + "</span>"
                }
            }, this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.reInitSlider)
        }, render: function () {
            return this.sliderPrimary = this.$el.find(".slider-primary").slick(this.getPrimarySliderOptions()), this.sliderSecondary = this.$el.find(".slider-secondary").slick(this.getSecondarySliderOptions()), this
        }, reInitSlider: function () {
            this.sliderPrimary.slick("unslick"), this.sliderSecondary.slick("unslick"), this.sliderPrimary = null, this.sliderSecondary = null, this.render()
        }, getPrimarySliderOptions: function () {
            var a = window.app.matchMedia.getCurrentMediaQuery(), b = this.slickSliderOptions;
            return b.appendDots = this.$("> .controls"), b.appendArrows = this.$("> .controls"), b.asNavFor = this.$(".slider-secondary"), b.dots = !0, b.focusOnSelect = !1, b.slidesToShow = 1, "media-to-m" !== a ? b.fade = !0 : b.fade = !1, b
        }, getSecondarySliderOptions: function () {
            var a = window.app.matchMedia.getCurrentMediaQuery(), b = this.slickSliderOptions;
            return b.appendArrows = this.$(".slider-secondary"), b.asNavFor = this.$(".slider-primary"), b.dots = !1, b.focusOnSelect = !0, b.slidesToShow = 1, "media-to-m" !== a && (b.centerMode = !0, b.centerPadding = 0, b.fade = !1, b.slidesToShow = 3), b
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/teaser-hotspot-view", ["jquery", "underscore", "backbone", "slick-slider"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.$controls = this.$(".controls"), this.$sliderContainer = this.$el.find(".slider"), this.hotspotsInitialized = !1, this.hotspotsStr = this.$sliderContainer.data("hotspots"), this.hotspots = "undefined" != typeof this.hotspotsStr ? this.hotspotsStr : null, this.slickSliderOptions = {
                rows: 0,
                adaptiveHeight: !0,
                accessibility: !1,
                dots: !0,
                infinite: !0,
                slidesToShow: 1,
                slidesToScroll: 1,
                touchThreshold: 4,
                easing: "ease-in",
                slide: ".slide",
                appendArrows: this.$controls,
                appendDots: this.$controls,
                arrows: !0,
                mobileFirst: !0,
                prevArrow: '<span class="slick-prev"></span>',
                nextArrow: '<span class="slick-next"></span>',
                customPaging: function (a, b) {
                    return '<span class="index">' + (b + 1) + "</span>"
                }
            }, this.render()
        }, render: function () {
            return this.slider = null, this.$sliderContainer.on("init", this.parseHotspots.bind(this)), this.$sliderContainer.on("setPosition", this.initializeHotspots.bind(this)), this.slider = this.$el.find(".slider").slick(this.slickSliderOptions), this.slider.slick("slickGoTo", this.slider.slick("slickCurrentSlide")), this
        }, initializeHotspots: function () {
            if (!b.isNull(this.slider)) if (this.hotspotsInitialized) this.hideHotspots(), this.showHotspots(), a(this.slider[0].slick.$slider).find(".slick-current .image li").eq(this.slider.slick("slickCurrentSlide")).addClass("slick-active").siblings().removeClass("slick-active"); else {
                var c = this.hotspots;
                this.slider[0].slick.$slides.each(function (b, d) {
                    a(d).find(".image li").each(function (b, d) {
                        a(d).css("left", c[b][0] + "%").css("top", c[b][1] + "%")
                    })
                }), this.showHotspots(), this.hotspotsInitialized = !0
            }
        }, showHotspots: function () {
            a(this.slider[0].slick.$slider).find(".slick-current .image .slick-dots").addClass("active")
        }, hideHotspots: function () {
            a(this.slider[0].slick.$slider).find(".image .slick-dots").removeClass("active")
        }, parseHotspots: function () {
            !b.isNull(this.hotspots) && this.hotspots.length > 2 && (this.$(".slick-dots").clone(!0).appendTo(this.$(".image")), this.hotspots = this.hotspots.replace(/[% ]/g, "").split(","), a.each(this.hotspots, this.valueToArray.bind(this)))
        }, valueToArray: function (a, b) {
            this.hotspots[a] = b.split("|")
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/teaser-linklist-picture-view", ["jquery", "underscore", "backbone", "equal-height"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.$teaser = this.$(".teaser"), this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, b.debounce(this.calculateTeaserHeight.bind(this), 300)), this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.freeTeaserHeight.bind(this))
        }, render: function () {
            return this.calculateTeaserHeight(), this
        }, calculateTeaserHeight: function () {
            var a = window.app.matchMedia.getCurrentMediaQuery();
            "media-to-m" !== a && this.$teaser.setEqualHeight()
        }, freeTeaserHeight: function () {
            this.$teaser.height("auto")
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/teaser-offset-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        offset: 0, image: void 0, initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.image = this.el.querySelector("img"), this.offset = parseInt(this.$el.data("offset")) || 0, this.offset <= 0 || (this.normalizeOffset(), this.setupListeners(), this.render())
        }, setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, b.debounce(this.render.bind(this), 200))
        }, render: function () {
            var b = a(this.image).closest(".stage-image, .stage-media"), c = b.outerHeight();
            if (c) {
                var d = (1 / c * this.image.height - 1) * this.offset;
                isNaN(d) || d <= 0 || (this.image.style.top = "-" + d + "%")
            }
        }, normalizeOffset: function () {
            this.offset = Math.min(this.offset, 100)
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/teaser-promo-view", ["jquery", "underscore", "backbone", "views/equal-height-view"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), d({
                $el: this.$el,
                el: this.el,
                $targets: this.$(".teaser-promo-primary, .teaser-promo-secondary")
            })
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("views/teaser-slider-view", ["jquery", "underscore", "backbone", "slick-slider"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (c) {
            this.options = b.extend({}, this.defaults, b.omit(c, ["el", "$el"])), this.options.mediaFromM = parseInt(window.app.matchMedia.getBreakpoint("screen-m-min"), 10), this.options.mediaFromL = parseInt(window.app.matchMedia.getBreakpoint("screen-l-min"), 10), this.slickSliderOptions = {
                rows: 0,
                adaptiveHeight: !0,
                accessibility: !1,
                dots: !0,
                infinite: !0,
                slidesToShow: 1,
                slidesToScroll: 1,
                touchThreshold: 4,
                easing: "ease-in",
                slide: ".slide",
                arrows: !1,
                appendDots: this.$(".controls"),
                mobileFirst: !0,
                prevArrow: '<span class="slick-prev"></span>',
                nextArrow: '<span class="slick-next"></span>',
                responsive: [{
                    breakpoint: this.options.mediaFromM,
                    settings: {arrows: !0, appendArrows: this.$(".slider")}
                }, {breakpoint: this.options.mediaFromL, settings: {arrows: !0, appendArrows: this.$(".slider")}}],
                customPaging: function (b, c) {
                    var d = a(b.$slides[c]).data("title");
                    return '<div><span class="index">' + (c + 1) + '</span><span class="title">' + d + "</span></div>"
                }
            }, this.eventDispatcher = window.app.eventDispatcher, this.$controls = this.$(".controls"), this.setupListeners(), this.render(), this.onResize()
        }, setupListeners: function () {
            this.listenTo(this.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.onResize)
        }, render: function () {
            return this.$el.find(".slider").on("init", this.onSliderInit.bind(this)), this.$el.find(".slider").on("breakpoint", this.onSliderInit.bind(this)), this.slider = this.$el.find(".slider").slick(this.slickSliderOptions), this
        }, onResize: function () {
            var a = window.app.matchMedia.getCurrentMediaQuery(), b = this.slider.find(".slick-list");
            "media-to-m" === a ? this.$controls.insertAfter(b) : (b.insertAfter(this.$controls), this.onSliderInit())
        }, onSliderInit: function () {
            var a = this.$(".slick-dots");
            a.addClass("dots-" + a.find("li").length)
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}),/*! Simple JavaScript Inheritance
 * By John Resig http://ejohn.org/
 * MIT Licensed.
 */
    function () {
        "use strict";
        var a = !1;
        window.JQClass = function () {
        }, JQClass.classes = {}, JQClass.extend = function b(c) {
            function d() {
                !a && this._init && this._init.apply(this, arguments)
            }

            var e = this.prototype;
            a = !0;
            var f = new this;
            a = !1;
            for (var g in c) if ("function" == typeof c[g] && "function" == typeof e[g]) f[g] = function (a, b) {
                return function () {
                    var c = this._super;
                    this._super = function (b) {
                        return e[a].apply(this, b || [])
                    };
                    var d = b.apply(this, arguments);
                    return this._super = c, d
                }
            }(g, c[g]); else if ("object" == typeof c[g] && "object" == typeof e[g] && "defaultOptions" === g) {
                var h, i = e[g], j = c[g], k = {};
                for (h in i) k[h] = i[h];
                for (h in j) k[h] = j[h];
                f[g] = k
            } else f[g] = c[g];
            return d.prototype = f, d.prototype.constructor = d, d.extend = b, d
        }
    }(),/*! Abstract base class for collection plugins v1.0.2.
	Written by Keith Wood (wood.keith{at}optusnet.com.au) December 2013.
	Licensed under the MIT license (http://keith-wood.name/licence.html). */
    function ($) {
        "use strict";

        function camelCase(a) {
            return a.replace(/-([a-z])/g, function (a, b) {
                return b.toUpperCase()
            })
        }

        JQClass.classes.JQPlugin = JQClass.extend({
            name: "plugin", defaultOptions: {}, regionalOptions: {}, deepMerge: !0, _getMarker: function () {
                return "is-" + this.name
            }, _init: function () {
                $.extend(this.defaultOptions, this.regionalOptions && this.regionalOptions[""] || {});
                var a = camelCase(this.name);
                $[a] = this, $.fn[a] = function (b) {
                    var c = Array.prototype.slice.call(arguments, 1), d = this, e = this;
                    return this.each(function () {
                        if ("string" == typeof b) {
                            if ("_" === b[0] || !$[a][b]) throw"Unknown method: " + b;
                            var f = $[a][b].apply($[a], [this].concat(c));
                            if (f !== d && void 0 !== f) return e = f, !1
                        } else $[a]._attach(this, b)
                    }), e
                }
            }, setDefaults: function (a) {
                $.extend(this.defaultOptions, a || {})
            }, _attach: function (a, b) {
                if (a = $(a), !a.hasClass(this._getMarker())) {
                    a.addClass(this._getMarker()), b = $.extend(this.deepMerge, {}, this.defaultOptions, this._getMetadata(a), b || {});
                    var c = $.extend({name: this.name, elem: a, options: b}, this._instSettings(a, b));
                    a.data(this.name, c), this._postAttach(a, c), this.option(a, b)
                }
            }, _instSettings: function (a, b) {
                return {}
            }, _postAttach: function (a, b) {
            }, _getMetadata: function (elem) {
                try {
                    var data = elem.data(this.name.toLowerCase()) || "";
                    data = data.replace(/(\\?)'/g, function (a, b) {
                        return b ? "'" : '"'
                    }).replace(/([a-zA-Z0-9]+):/g, function (a, b, c) {
                        var d = data.substring(0, c).match(/"/g);
                        return d && d.length % 2 !== 0 ? b + ":" : '"' + b + '":'
                    }).replace(/\\:/g, ":"), data = $.parseJSON("{" + data + "}");
                    for (var key in data) if (data.hasOwnProperty(key)) {
                        var value = data[key];
                        "string" == typeof value && value.match(/^new Date\(([-0-9,\s]*)\)$/) && (data[key] = eval(value))
                    }
                    return data
                } catch (a) {
                    return {}
                }
            }, _getInst: function (a) {
                return $(a).data(this.name) || {}
            }, option: function (a, b, c) {
                a = $(a);
                var d = a.data(this.name), e = b || {};
                return !b || "string" == typeof b && "undefined" == typeof c ? (e = (d || {}).options, e && b ? e[b] : e) : void (a.hasClass(this._getMarker()) && ("string" == typeof b && (e = {}, e[b] = c), this._optionsChanged(a, d, e), $.extend(d.options, e)))
            }, _optionsChanged: function (a, b, c) {
            }, destroy: function (a) {
                a = $(a), a.hasClass(this._getMarker()) && (this._preDestroy(a, this._getInst(a)), a.removeData(this.name).removeClass(this._getMarker()))
            }, _preDestroy: function (a, b) {
            }
        }), $.JQPlugin = {
            createPlugin: function (a, b) {
                "object" == typeof a && (b = a, a = "JQPlugin"), a = camelCase(a);
                var c = camelCase(b.name);
                JQClass.classes[c] = JQClass.classes[a].extend(b), new JQClass.classes[c]
            }
        }
    }(jQuery),/*! http://keith-wood.name/countdown.html
	Countdown for jQuery v2.1.0.
	Written by Keith Wood (wood.keith{at}optusnet.com.au) January 2008.
	Available under the MIT (http://keith-wood.name/licence.html) license.
	Please attribute the author if you use it. */
    function (a) {
        "use strict";
        var b = "countdown", c = 0, d = 1, e = 2, f = 3, g = 4, h = 5, i = 6;
        a.JQPlugin.createPlugin({
            name: b,
            defaultOptions: {
                until: null,
                since: null,
                timezone: null,
                serverSync: null,
                format: "dHMS",
                layout: "",
                compact: !1,
                padZeroes: !1,
                significant: 0,
                description: "",
                expiryUrl: "",
                expiryText: "",
                alwaysExpire: !1,
                onExpiry: null,
                onTick: null,
                tickInterval: 1
            },
            regionalOptions: {
                "": {
                    labels: ["Years", "Months", "Weeks", "Days", "Hours", "Minutes", "Seconds"],
                    labels1: ["Year", "Month", "Week", "Day", "Hour", "Minute", "Second"],
                    compactLabels: ["y", "m", "w", "d"],
                    whichLabels: null,
                    digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                    timeSeparator: ":",
                    isRTL: !1
                }
            },
            _rtlClass: b + "-rtl",
            _sectionClass: b + "-section",
            _amountClass: b + "-amount",
            _periodClass: b + "-period",
            _rowClass: b + "-row",
            _holdingClass: b + "-holding",
            _showClass: b + "-show",
            _descrClass: b + "-descr",
            _timerElems: [],
            _init: function () {
                function b(a) {
                    var h = a < 1e12 ? e ? window.performance.now() + window.performance.timing.navigationStart : d() : a || d();
                    h - g >= 1e3 && (c._updateElems(), g = h), f(b)
                }

                var c = this;
                this._super(), this._serverSyncs = [];
                var d = "function" == typeof Date.now ? Date.now : function () {
                        return (new Date).getTime()
                    }, e = window.performance && "function" == typeof window.performance.now,
                    f = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || null,
                    g = 0;
                !f || a.noRequestAnimationFrame ? (a.noRequestAnimationFrame = null, a.countdown._timer = setInterval(function () {
                    c._updateElems()
                }, 1e3)) : (g = window.animationStartTime || window.webkitAnimationStartTime || window.mozAnimationStartTime || window.oAnimationStartTime || window.msAnimationStartTime || d(), f(b))
            },
            UTCDate: function (a, b, c, d, e, f, g, h) {
                "object" == typeof b && b instanceof Date && (h = b.getMilliseconds(), g = b.getSeconds(), f = b.getMinutes(), e = b.getHours(), d = b.getDate(), c = b.getMonth(), b = b.getFullYear());
                var i = new Date;
                return i.setUTCFullYear(b), i.setUTCDate(1), i.setUTCMonth(c || 0), i.setUTCDate(d || 1), i.setUTCHours(e || 0), i.setUTCMinutes((f || 0) - (Math.abs(a) < 30 ? 60 * a : a)), i.setUTCSeconds(g || 0), i.setUTCMilliseconds(h || 0), i
            },
            periodsToSeconds: function (a) {
                return 31557600 * a[0] + 2629800 * a[1] + 604800 * a[2] + 86400 * a[3] + 3600 * a[4] + 60 * a[5] + a[6]
            },
            resync: function () {
                var b = this;
                a("." + this._getMarker()).each(function () {
                    var c = a.data(this, b.name);
                    if (c.options.serverSync) {
                        for (var d = null, e = 0; e < b._serverSyncs.length; e++) if (b._serverSyncs[e][0] === c.options.serverSync) {
                            d = b._serverSyncs[e];
                            break
                        }
                        if (b._eqNull(d[2])) {
                            var f = a.isFunction(c.options.serverSync) ? c.options.serverSync.apply(this, []) : null;
                            d[2] = (f ? (new Date).getTime() - f.getTime() : 0) - d[1]
                        }
                        c._since && c._since.setMilliseconds(c._since.getMilliseconds() + d[2]), c._until.setMilliseconds(c._until.getMilliseconds() + d[2])
                    }
                });
                for (var c = 0; c < b._serverSyncs.length; c++) b._eqNull(b._serverSyncs[c][2]) || (b._serverSyncs[c][1] += b._serverSyncs[c][2], delete b._serverSyncs[c][2])
            },
            _instSettings: function (a, b) {
                return {_periods: [0, 0, 0, 0, 0, 0, 0]}
            },
            _addElem: function (a) {
                this._hasElem(a) || this._timerElems.push(a)
            },
            _hasElem: function (b) {
                return a.inArray(b, this._timerElems) > -1
            },
            _removeElem: function (b) {
                this._timerElems = a.map(this._timerElems, function (a) {
                    return a === b ? null : a
                })
            },
            _updateElems: function () {
                for (var a = this._timerElems.length - 1; a >= 0; a--) this._updateCountdown(this._timerElems[a])
            },
            _optionsChanged: function (b, c, d) {
                d.layout && (d.layout = d.layout.replace(/&lt;/g, "<").replace(/&gt;/g, ">")), this._resetExtraLabels(c.options, d);
                var e = c.options.timezone !== d.timezone;
                a.extend(c.options, d), this._adjustSettings(b, c, !this._eqNull(d.until) || !this._eqNull(d.since) || e);
                var f = new Date;
                (c._since && c._since < f || c._until && c._until > f) && this._addElem(b[0]), this._updateCountdown(b, c)
            },
            _updateCountdown: function (b, c) {
                if (b = b.jquery ? b : a(b), c = c || this._getInst(b)) {
                    if (b.html(this._generateHTML(c)).toggleClass(this._rtlClass, c.options.isRTL), "pause" !== c._hold && a.isFunction(c.options.onTick)) {
                        var d = "lap" !== c._hold ? c._periods : this._calculatePeriods(c, c._show, c.options.significant, new Date);
                        1 !== c.options.tickInterval && this.periodsToSeconds(d) % c.options.tickInterval !== 0 || c.options.onTick.apply(b[0], [d])
                    }
                    var e = "pause" !== c._hold && (c._since ? c._now.getTime() < c._since.getTime() : c._now.getTime() >= c._until.getTime());
                    if (e && !c._expiring) {
                        if (c._expiring = !0, this._hasElem(b[0]) || c.options.alwaysExpire) {
                            if (this._removeElem(b[0]), a.isFunction(c.options.onExpiry) && c.options.onExpiry.apply(b[0], []), c.options.expiryText) {
                                var f = c.options.layout;
                                c.options.layout = c.options.expiryText, this._updateCountdown(b[0], c), c.options.layout = f
                            }
                            c.options.expiryUrl && (window.location = c.options.expiryUrl)
                        }
                        c._expiring = !1
                    } else "pause" === c._hold && this._removeElem(b[0])
                }
            },
            _resetExtraLabels: function (a, b) {
                var c = null;
                for (c in b) c.match(/[Ll]abels[02-9]|compactLabels1/) && (a[c] = b[c]);
                for (c in a) c.match(/[Ll]abels[02-9]|compactLabels1/) && "undefined" == typeof b[c] && (a[c] = null)
            },
            _eqNull: function (a) {
                return "undefined" == typeof a || null === a
            },
            _adjustSettings: function (b, c, d) {
                for (var e = null, f = 0; f < this._serverSyncs.length; f++) if (this._serverSyncs[f][0] === c.options.serverSync) {
                    e = this._serverSyncs[f][1];
                    break
                }
                var g = null, h = null;
                if (this._eqNull(e)) {
                    var i = a.isFunction(c.options.serverSync) ? c.options.serverSync.apply(b[0], []) : null;
                    g = new Date, h = i ? g.getTime() - i.getTime() : 0, this._serverSyncs.push([c.options.serverSync, h])
                } else g = new Date, h = c.options.serverSync ? e : 0;
                var j = c.options.timezone;
                j = this._eqNull(j) ? -g.getTimezoneOffset() : j, (d || !d && this._eqNull(c._until) && this._eqNull(c._since)) && (c._since = c.options.since, this._eqNull(c._since) || (c._since = this.UTCDate(j, this._determineTime(c._since, null)), c._since && h && c._since.setMilliseconds(c._since.getMilliseconds() + h)), c._until = this.UTCDate(j, this._determineTime(c.options.until, g)), h && c._until.setMilliseconds(c._until.getMilliseconds() + h)), c._show = this._determineShow(c)
            },
            _preDestroy: function (a, b) {
                this._removeElem(a[0]), a.empty()
            },
            pause: function (a) {
                this._hold(a, "pause")
            },
            lap: function (a) {
                this._hold(a, "lap")
            },
            resume: function (a) {
                this._hold(a, null)
            },
            toggle: function (b) {
                var c = a.data(b, this.name) || {};
                this[c._hold ? "resume" : "pause"](b)
            },
            toggleLap: function (b) {
                var c = a.data(b, this.name) || {};
                this[c._hold ? "resume" : "lap"](b)
            },
            _hold: function (b, c) {
                var d = a.data(b, this.name);
                if (d) {
                    if ("pause" === d._hold && !c) {
                        d._periods = d._savePeriods;
                        var e = d._since ? "-" : "+";
                        d[d._since ? "_since" : "_until"] = this._determineTime(e + d._periods[0] + "y" + e + d._periods[1] + "o" + e + d._periods[2] + "w" + e + d._periods[3] + "d" + e + d._periods[4] + "h" + e + d._periods[5] + "m" + e + d._periods[6] + "s"), this._addElem(b)
                    }
                    d._hold = c, d._savePeriods = "pause" === c ? d._periods : null, a.data(b, this.name, d), this._updateCountdown(b, d)
                }
            },
            getTimes: function (b) {
                var c = a.data(b, this.name);
                return c ? "pause" === c._hold ? c._savePeriods : c._hold ? this._calculatePeriods(c, c._show, c.options.significant, new Date) : c._periods : null
            },
            _determineTime: function (a, b) {
                var c = this, d = function (a) {
                    var b = new Date;
                    return b.setTime(b.getTime() + 1e3 * a), b
                }, e = function (a) {
                    a = a.toLowerCase();
                    for (var b = new Date, d = b.getFullYear(), e = b.getMonth(), f = b.getDate(), g = b.getHours(), h = b.getMinutes(), i = b.getSeconds(), j = /([+-]?[0-9]+)\s*(s|m|h|d|w|o|y)?/g, k = j.exec(a); k;) {
                        switch (k[2] || "s") {
                            case"s":
                                i += parseInt(k[1], 10);
                                break;
                            case"m":
                                h += parseInt(k[1], 10);
                                break;
                            case"h":
                                g += parseInt(k[1], 10);
                                break;
                            case"d":
                                f += parseInt(k[1], 10);
                                break;
                            case"w":
                                f += 7 * parseInt(k[1], 10);
                                break;
                            case"o":
                                e += parseInt(k[1], 10), f = Math.min(f, c._getDaysInMonth(d, e));
                                break;
                            case"y":
                                d += parseInt(k[1], 10), f = Math.min(f, c._getDaysInMonth(d, e))
                        }
                        k = j.exec(a)
                    }
                    return new Date(d, e, f, g, h, i, 0)
                }, f = this._eqNull(a) ? b : "string" == typeof a ? e(a) : "number" == typeof a ? d(a) : a;
                return f && f.setMilliseconds(0), f
            },
            _getDaysInMonth: function (a, b) {
                return 32 - new Date(a, b, 32).getDate()
            },
            _normalLabels: function (a) {
                return a
            },
            _generateHTML: function (b) {
                var j = this;
                b._periods = b._hold ? b._periods : this._calculatePeriods(b, b._show, b.options.significant, new Date);
                var k = !1, l = 0, m = b.options.significant, n = a.extend({}, b._show), o = null;
                for (o = c; o <= i; o++) k = k || "?" === b._show[o] && b._periods[o] > 0, n[o] = "?" !== b._show[o] || k ? b._show[o] : null, l += n[o] ? 1 : 0, m -= b._periods[o] > 0 ? 1 : 0;
                var p = [!1, !1, !1, !1, !1, !1, !1];
                for (o = i; o >= c; o--) b._show[o] && (b._periods[o] ? p[o] = !0 : (p[o] = m > 0, m--));
                var q = b.options.compact ? b.options.compactLabels : b.options.labels,
                    r = b.options.whichLabels || this._normalLabels, s = function (a) {
                        var c = b.options["compactLabels" + r(b._periods[a])];
                        return n[a] ? j._translateDigits(b, b._periods[a]) + (c ? c[a] : q[a]) + " " : ""
                    }, t = b.options.padZeroes ? 2 : 1, u = function (a) {
                        var c = b.options["labels" + r(b._periods[a])];
                        return !b.options.significant && n[a] || b.options.significant && p[a] ? '<span class="' + j._sectionClass + '"><span class="' + j._amountClass + '">' + j._minDigits(b, b._periods[a], t) + '</span><span class="' + j._periodClass + '">' + (c ? c[a] : q[a]) + "</span></span>" : ""
                    };
                return b.options.layout ? this._buildLayout(b, n, b.options.layout, b.options.compact, b.options.significant, p) : (b.options.compact ? '<span class="' + this._rowClass + " " + this._amountClass + (b._hold ? " " + this._holdingClass : "") + '">' + s(c) + s(d) + s(e) + s(f) + (n[g] ? this._minDigits(b, b._periods[g], 2) : "") + (n[h] ? (n[g] ? b.options.timeSeparator : "") + this._minDigits(b, b._periods[h], 2) : "") + (n[i] ? (n[g] || n[h] ? b.options.timeSeparator : "") + this._minDigits(b, b._periods[i], 2) : "") : '<span class="' + this._rowClass + " " + this._showClass + (b.options.significant || l) + (b._hold ? " " + this._holdingClass : "") + '">' + u(c) + u(d) + u(e) + u(f) + u(g) + u(h) + u(i)) + "</span>" + (b.options.description ? '<span class="' + this._rowClass + " " + this._descrClass + '">' + b.options.description + "</span>" : "")
            },
            _buildLayout: function (b, j, k, l, m, n) {
                for (var o = b.options[l ? "compactLabels" : "labels"], p = b.options.whichLabels || this._normalLabels, q = function (a) {
                    return (b.options[(l ? "compactLabels" : "labels") + p(b._periods[a])] || o)[a]
                }, r = function (a, c) {
                    return b.options.digits[Math.floor(a / c) % 10]
                }, s = {
                    desc: b.options.description,
                    sep: b.options.timeSeparator,
                    yl: q(c),
                    yn: this._minDigits(b, b._periods[c], 1),
                    ynn: this._minDigits(b, b._periods[c], 2),
                    ynnn: this._minDigits(b, b._periods[c], 3),
                    y1: r(b._periods[c], 1),
                    y10: r(b._periods[c], 10),
                    y100: r(b._periods[c], 100),
                    y1000: r(b._periods[c], 1e3),
                    ol: q(d),
                    on: this._minDigits(b, b._periods[d], 1),
                    onn: this._minDigits(b, b._periods[d], 2),
                    onnn: this._minDigits(b, b._periods[d], 3),
                    o1: r(b._periods[d], 1),
                    o10: r(b._periods[d], 10),
                    o100: r(b._periods[d], 100),
                    o1000: r(b._periods[d], 1e3),
                    wl: q(e),
                    wn: this._minDigits(b, b._periods[e], 1),
                    wnn: this._minDigits(b, b._periods[e], 2),
                    wnnn: this._minDigits(b, b._periods[e], 3),
                    w1: r(b._periods[e], 1),
                    w10: r(b._periods[e], 10),
                    w100: r(b._periods[e], 100),
                    w1000: r(b._periods[e], 1e3),
                    dl: q(f),
                    dn: this._minDigits(b, b._periods[f], 1),
                    dnn: this._minDigits(b, b._periods[f], 2),
                    dnnn: this._minDigits(b, b._periods[f], 3),
                    d1: r(b._periods[f], 1),
                    d10: r(b._periods[f], 10),
                    d100: r(b._periods[f], 100),
                    d1000: r(b._periods[f], 1e3),
                    hl: q(g),
                    hn: this._minDigits(b, b._periods[g], 1),
                    hnn: this._minDigits(b, b._periods[g], 2),
                    hnnn: this._minDigits(b, b._periods[g], 3),
                    h1: r(b._periods[g], 1),
                    h10: r(b._periods[g], 10),
                    h100: r(b._periods[g], 100),
                    h1000: r(b._periods[g], 1e3),
                    ml: q(h),
                    mn: this._minDigits(b, b._periods[h], 1),
                    mnn: this._minDigits(b, b._periods[h], 2),
                    mnnn: this._minDigits(b, b._periods[h], 3),
                    m1: r(b._periods[h], 1),
                    m10: r(b._periods[h], 10),
                    m100: r(b._periods[h], 100),
                    m1000: r(b._periods[h], 1e3),
                    sl: q(i),
                    sn: this._minDigits(b, b._periods[i], 1),
                    snn: this._minDigits(b, b._periods[i], 2),
                    snnn: this._minDigits(b, b._periods[i], 3),
                    s1: r(b._periods[i], 1),
                    s10: r(b._periods[i], 10),
                    s100: r(b._periods[i], 100),
                    s1000: r(b._periods[i], 1e3)
                }, t = k, u = c; u <= i; u++) {
                    var v = "yowdhms".charAt(u), w = new RegExp("\\{" + v + "<\\}([\\s\\S]*)\\{" + v + ">\\}", "g");
                    t = t.replace(w, !m && j[u] || m && n[u] ? "$1" : "")
                }
                return a.each(s, function (a, b) {
                    var c = new RegExp("\\{" + a + "\\}", "g");
                    t = t.replace(c, b)
                }), t
            },
            _minDigits: function (a, b, c) {
                return b = "" + b, b.length >= c ? this._translateDigits(a, b) : (b = "0000000000" + b, this._translateDigits(a, b.substr(b.length - c)))
            },
            _translateDigits: function (a, b) {
                return ("" + b).replace(/[0-9]/g, function (b) {
                    return a.options.digits[b]
                })
            },
            _determineShow: function (a) {
                var b = a.options.format, j = [];
                return j[c] = b.match("y") ? "?" : b.match("Y") ? "!" : null, j[d] = b.match("o") ? "?" : b.match("O") ? "!" : null, j[e] = b.match("w") ? "?" : b.match("W") ? "!" : null, j[f] = b.match("d") ? "?" : b.match("D") ? "!" : null, j[g] = b.match("h") ? "?" : b.match("H") ? "!" : null, j[h] = b.match("m") ? "?" : b.match("M") ? "!" : null, j[i] = b.match("s") ? "?" : b.match("S") ? "!" : null, j
            },
            _calculatePeriods: function (a, b, j, k) {
                a._now = k, a._now.setMilliseconds(0);
                var l = new Date(a._now.getTime());
                a._since ? k.getTime() < a._since.getTime() ? a._now = k = l : k = a._since : (l.setTime(a._until.getTime()), k.getTime() > a._until.getTime() && (a._now = k = l));
                var m = [0, 0, 0, 0, 0, 0, 0];
                if (b[c] || b[d]) {
                    var n = this._getDaysInMonth(k.getFullYear(), k.getMonth()),
                        o = this._getDaysInMonth(l.getFullYear(), l.getMonth()),
                        p = l.getDate() === k.getDate() || l.getDate() >= Math.min(n, o) && k.getDate() >= Math.min(n, o),
                        q = function (a) {
                            return 60 * (60 * a.getHours() + a.getMinutes()) + a.getSeconds()
                        },
                        r = Math.max(0, 12 * (l.getFullYear() - k.getFullYear()) + l.getMonth() - k.getMonth() + (l.getDate() < k.getDate() && !p || p && q(l) < q(k) ? -1 : 0));
                    m[c] = b[c] ? Math.floor(r / 12) : 0, m[d] = b[d] ? r - 12 * m[c] : 0, k = new Date(k.getTime());
                    var s = k.getDate() === n, t = this._getDaysInMonth(k.getFullYear() + m[c], k.getMonth() + m[d]);
                    k.getDate() > t && k.setDate(t), k.setFullYear(k.getFullYear() + m[c]), k.setMonth(k.getMonth() + m[d]), s && k.setDate(t)
                }
                var u = Math.floor((l.getTime() - k.getTime()) / 1e3), v = null, w = function (a, c) {
                    m[a] = b[a] ? Math.floor(u / c) : 0, u -= m[a] * c
                };
                if (w(e, 604800), w(f, 86400), w(g, 3600), w(h, 60), w(i, 1), u > 0 && !a._since) {
                    var x = [1, 12, 4.3482, 7, 24, 60, 60], y = i, z = 1;
                    for (v = i; v >= c; v--) b[v] && (m[y] >= z && (m[y] = 0, u = 1), u > 0 && (m[v]++, u = 0, y = v, z = 1)), z *= x[v]
                }
                if (j) for (v = c; v <= i; v++) j && m[v] ? j-- : j || (m[v] = 0);
                return m
            }
        })
    }(jQuery), define("jquery-countdown", ["jquery"], function () {
}), define("views/teaser-stage-counter-view", ["jquery", "underscore", "backbone", "jquery-countdown"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        $counter: void 0,
        $container: void 0,
        expirationDateStr: void 0,
        expirationTimeStr: void 0,
        expirationDate: void 0,
        expirationTime: void 0,
        hideOnDateStr: void 0,
        hideOnTimeStr: void 0,
        hideOnDate: void 0,
        hideOnTime: void 0,
        expirationDateObj: void 0,
        hideOnDateObj: void 0,
        labelsSingular: void 0,
        labelsPlural: void 0,
        countdownOptions: void 0,
        hasTime: !1,
        hasTimeToHide: !1,
        alternateContent: "",
        alternateMedia: "enable-alternate-media",
        alternateText: "enable-alternate-text",
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.$counter = this.$(".counter"), this.$hiddenCounter = this.$(".hidden-counter"), this.hideOnDateStr = this.$counter.data("hide-on-date"), this.hideOnTimeStr = this.$counter.data("hide-on-time"), this.expirationDateStr = this.$counter.data("expiration-date"), this.expirationTimeStr = this.$counter.data("expiration-time"), this.labelsSingular = this.$counter.data("labels-singular"), this.labelsPlural = this.$counter.data("labels-plural"), this.timezone = this.$counter.data("gmt-timezone"), this.timezone = this.$counter.data("gmt-timezone"), this.hideOnTimezone = this.$counter.data("hide-gmt-timezone"), this.exchangeMediaOnExpiry = this.$counter.data("swap-media-on-expiry"), this.exchangeTextOnExpiry = this.$counter.data("swap-text-on-expiry"), this.render()
        },
        render: function () {
            "undefined" != typeof this.expirationDateStr && (this.expirationDate = this.expirationDateStr.split("-")), "undefined" != typeof this.expirationTimeStr && (this.expirationTime = this.expirationTimeStr.split(":"), this.hasTime = !0), "undefined" != typeof this.hideOnDateStr && (this.hideOnDate = this.hideOnDateStr.split("-")), "undefined" != typeof this.hideOnTimeStr && (this.hideOnTime = this.hideOnTimeStr.split(":"), this.hasTimeToHide = !0), "undefined" != typeof this.labelsSingular && (this.labelsSingular = this.labelsSingular.split(",")), "undefined" != typeof this.labelsPlural && (this.labelsPlural = this.labelsPlural.split(",")), this.hasTime ? this.expirationDateObj = new Date(this.expirationDate[0], this.expirationDate[1] - 1, this.expirationDate[2], this.expirationTime[0], this.expirationTime[1]) : this.expirationDateObj = new Date(this.expirationDate[0], this.expirationDate[1] - 1, this.expirationDate[2]), this.countdownOptions = {
                until: this.expirationDateObj,
                layout: this.$counter.html(),
                tickInterval: 10,
                onExpiry: this.checkDates.bind(this)
            }, this.countdownOptions.timezone = this.getTimeZone(this.timezone), "undefined" != typeof this.labelsSingular && "undefined" != typeof this.labelsPlural && (this.countdownOptions.labels = a.merge(["", "", ""], this.labelsSingular, ""), this.countdownOptions.labels1 = a.merge(["", "", ""], this.labelsPlural, ""), this.countdownOptions.whichLabels = function (a) {
                return 1 === a ? 0 : 1
            }), this.$counter.countdown(this.countdownOptions), "undefined" != typeof this.hideOnDateStr && (this.hasTimeToHide ? this.hideOnDateObj = new Date(this.hideOnDate[0], this.hideOnDate[1] - 1, this.hideOnDate[2], this.hideOnTime[0], this.hideOnTime[1]) : this.hideOnDateObj = new Date(this.hideOnDate[0], this.hideOnDate[1] - 1, this.hideOnDate[2]), this.countdownOptions2 = {
                until: this.hideOnDateObj,
                tickInterval: 10,
                onExpiry: this.hideCounter.bind(this, !0)
            }, this.countdownOptions2.timezone = this.getTimeZone(this.hideOnTimezone), this.$hiddenCounter.countdown(this.countdownOptions2), this.isDateExpiredToHideCounter() && this.hideCounter(!1)), "undefined" != typeof this.expirationDateObj && this.isExpired() && this.prepareForContentExchange(!1), this.$el.addClass("initialized")
        },
        getTimeZone: function (a) {
            if ("undefined" != typeof a) {
                if (a.indexOf(":") >= 1) {
                    var b = a.split(":");
                    return b[0] + "." + 100 * b[1] / 60
                }
                return a
            }
        },
        hideCounter: function (a) {
            this.$counter.parents(".counter-container").addClass(a ? "hide-animated" : "hide"), this.prepareForContentExchange(a)
        },
        isExpired: function () {
            return new Date > this.expirationDateObj
        },
        isDateExpiredToHideCounter: function () {
            return new Date > this.hideOnDateObj
        },
        checkDates: function () {
            "undefined" != typeof this.hideOnDateStr && this.expirationDateObj.getTime() === this.hideOnDateObj.getTime() ? this.hideCounter(!0) : this.prepareForContentExchange(!0)
        },
        prepareForContentExchange: function (a) {
            this.exchangeMediaOnExpiry && this.exchangeTextOnExpiry ? (this.$container = this.$(".stage-media,.text-overlay"), this.alternateContent = this.alternateMedia + " " + this.alternateText) : this.exchangeMediaOnExpiry ? (this.$container = this.$(".stage-media"), this.alternateContent = this.alternateMedia) : this.exchangeTextOnExpiry && (this.$container = this.$(".text-overlay"), this.alternateContent = this.alternateText), (this.exchangeMediaOnExpiry || this.exchangeTextOnExpiry) && this.exchangeContents(a)
        },
        exchangeContents: function (a) {
            a ? window.setTimeout(this.exchangeContentsDelayed.bind(this), 1e3) : this.$container.parents(".countdown").find(".stage-container").addClass(this.alternateContent)
        },
        exchangeContentsDelayed: function () {
            this.exchangeMediaOnExpiry && this.$container.parents(".countdown").find(".stage-container").addClass(this.alternateContent), this.exchangeTextOnExpiry && !this.exchangeMediaOnExpiry && this.$container.find(".default-content").fadeOut(this.onFadeOutComplete.bind(this))
        },
        onFadeOutComplete: function () {
            this.$container.parents(".countdown").find(".stage-container").addClass(this.alternateContent), this.exchangeTextOnExpiry && this.$container.find(".alternate-content").fadeIn(this.onFadeInComplete.bind(this))
        },
        onFadeInComplete: function () {
            this.$container.find(".default-content,.alternate-content").removeAttr("style")
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/teaser-stage-image-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.eventDispatcher = window.app.eventDispatcher, this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.renderHeadline.bind(this)), this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.renderHeadline.bind(this))
        }, render: function () {
            return this.renderHeadline(), this
        }, renderHeadline: function () {
            var c, d = this.$(".stage-image .headline, .stage-image h1:not(.headline)"), e = d.get(0),
                f = a.trim(d.text()), g = a("<span />").text(f), h = g.get(0), i = f.split(" ");
            if (!b.isUndefined(e)) return d.html(g), Math.floor(h.offsetWidth) <= Math.ceil(e.offsetWidth) ? (d.html(f), this) : (c = b.map(i, function (a) {
                return "<span>" + a + "</span>"
            }), d.html(c.join(" ")).find("span").each(function (b, c) {
                var d = a(c);
                Math.floor(c.offsetWidth) <= Math.ceil(e.offsetWidth) ? d.replaceWith(d.text()) : d.addClass("total-breakdown")
            }), this)
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/teaser-stage-media-video-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        stageMediaSelector: ".stage-media",
        textOverlaySelector: ".text-overlay",
        videoElementSelector: ".video-element",
        videoFadeContentSelector: ".text-overlay, .stage-media .play, .counter-container",
        initialize: function () {
            this.eventDispatcher = window.app.eventDispatcher, this.$stageImage = this.$el.find(this.stageMediaSelector), this.$fadeContent = null, this.$btnPlay = a('<span class="btn play"/>'), this.$videoElement = this.$el.find(".video-element"), this.$video = this.$el.find("video"), this.videoFadingDelay = 300, this.setupListeners(), this.render()
        },
        setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.VIDEO_ENDED, this.onVideoEnded.bind(this)), this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.onViewportChange.bind(this))
        },
        render: function () {
            return this.initVideoButton(), this
        },
        initVideoButton: function () {
            var b = this;
            this.$el.find(this.videoElementSelector).parent().append(this.$btnPlay), this.$btnPlay.on("click", function () {
                b.$fadeContent = b.$el.find(b.videoFadeContentSelector), a(window).width() < 1025 && (b.$fadeContent = b.$el.find(".stage-media .play, .counter-container")), b.$fadeContent.fadeOut(b.videoFadingDelay, function () {
                    b.$videoElement.addClass("active"), b.$videoElement.fadeIn(b.videoFadingDelay, function () {
                        b.$video[0].play()
                    }), b.eventDispatcher.trigger(window.app.applicationEvents.TEASER_STAGE_STOP_AUTOPLAY)
                })
            })
        },
        onVideoEnded: function () {
            this.$videoElement.fadeOut(this.videoFadingDelay, function () {
                this.$videoElement.removeClass("active"), this.$el.find(this.videoFadeContentSelector).fadeIn(this.videoFadingDelay)
            }.bind(this))
        },
        onViewportChange: function () {
            if (this.$fadeContent = this.$el.find(this.videoFadeContentSelector), this.$fadeContent.show(), a(window).width() >= 1024) {
                if (!this.$el.find(".video-element.active").length) return void (this.$fadeContent = this.$el.find(this.textOverlaySelector));
                this.$fadeContent.hide()
            }
        },
        onPositionChanged: function () {
            this.$video.pause()
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/teaser-stage-new-video-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        videoFadeContentSelector: ".text-overlay, .stage-media .play, .counter-container",
        stageMediaSelector: ".stage-media",
        textOverlaySelector: ".text-overlay",
        videoElementSelector: ".video-element",
        initialize: function (b) {
            this.eventDispatcher = window.app.eventDispatcher, this.$teaserStage = b.teaserStage, this.$stageImage = this.$el.find(this.stageMediaSelector), this.$fadeContent = null, this.$btnPlay = this.$el.find(".btn.play"), 0 === this.$btnPlay.length && (this.$btnPlay = a('<span class="btn play"/>')), this.$videoElement = this.$el.find(".video-element"), this.$video = this.$el.find("video"), this.videoFadingDelay = 300, this.setupListeners(), this.render()
        },
        setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.VIDEO_ENDED, this.onVideoEnded.bind(this)), this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.onViewportChange.bind(this)), this.$video.length && this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.VIDEO_STAGE_SLIDER_CHANGED, this.onPositionChanged.bind(this))
        },
        render: function () {
            return this.initVideoButton(), this
        },
        initVideoButton: function () {
            var b = this;
            this.$el.length && (this.$el.find(this.videoElementSelector).parent().append(this.$btnPlay), this.$btnPlay.on("click", function () {
                b.$fadeContent = b.$el.find(b.videoFadeContentSelector), a(window).width() < 1025 && (b.$fadeContent = b.$el.find(".stage-media .play, .counter-container")), b.$fadeContent.fadeOut(b.videoFadingDelay, function () {
                    b.$videoElement.addClass("active"), b.$videoElement.fadeIn(300, function () {
                        b.$video[0].play()
                    }), b.eventDispatcher.trigger(window.app.applicationEvents.TEASER_STAGE_STOP_AUTOPLAY)
                })
            }))
        },
        onVideoEnded: function () {
            var a = this;
            this.$videoElement.fadeOut(this.videoFadingDelay, function () {
                a.$videoElement.removeClass("active"), a.$teaserStage.find(a.videoFadeContentSelector).fadeIn(a.videoFadingDelay), a.eventDispatcher.trigger(window.app.applicationEvents.TEASER_STAGE_START_AUTOPLAY)
            })
        },
        onViewportChange: function () {
            if (this.$fadeContent = this.$teaserStage.find(this.videoFadeContentSelector), this.$fadeContent.show(), a(window).width() >= 1024) {
                if (!this.$teaserStage.find(".video-element.active").length) return void (this.$fadeContent = this.$teaserStage.find(this.textOverlaySelector));
                this.$fadeContent.hide()
            }
        },
        onPositionChanged: function () {
            this.$video.each(function (a, b) {
                b.pause()
            })
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/teaser-stage-new-view", ["jquery", "underscore", "backbone", "views/teaser-stage-new-video-view", "slick-slider"], function (a, b, c, d) {
    "use strict";
    var e = c.View.extend({
        initialize: function (a) {
            this.eventDispatcher = window.app.eventDispatcher, this.teaserStageVideos = [], this.autoplay = this.$el.data("autoplay"), this.$slider = this.$(".stage-slider"), this.setupListeners(), this.render()
        }, setupListeners: function () {
            this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.TEASER_STAGE_STOP_AUTOPLAY, this.stopAutoplay.bind(this)), this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.TEASER_STAGE_START_AUTOPLAY, this.startAutoplay.bind(this)), this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.VIEWPORT_CHANGE, this.triggerArrowResize.bind(this)), this.listenTo(window.app.eventDispatcher, window.app.applicationEvents.WINDOW_RESIZE, this.triggerArrowResize.bind(this))
        }, render: function () {
            var b = this;
            return this.$(".video-element").each(function (c, e) {
                b.teaserStageVideos.push(d({el: a(e).closest(".module"), teaserStage: b.$el}))
            }), this.$el.is(".module-teaser-stage-slider") && this.$(".module").length > 1 && (this.$slider.on("beforeChange", function () {
                b.eventDispatcher.trigger(window.app.applicationEvents.VIDEO_STAGE_SLIDER_CHANGED), b.startAutoplay()
            }), this.$slider.slick({
                rows: 0,
                autoplay: !!this.autoplay,
                autoplaySpeed: this.autoplay,
                adaptiveHeight: !0,
                accessibility: !1,
                appendDots: this.$(".stage-controls"),
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !1,
                dots: !0,
                dotsClass: "slider-dots",
                mobileFirst: !0,
                responsive: [{
                    breakpoint: 640,
                    settings: {
                        arrows: !0,
                        appendArrows: this.$(".stage-controls"),
                        prevArrow: '<span class="slick-prev"></span>',
                        nextArrow: '<span class="slick-next"></span>'
                    }
                }],
                customPaging: function () {
                    return "<span></span>"
                }
            }), this.setArrowPosition()), this
        }, startAutoplay: function () {
            this.$slider.slick("slickPlay")
        }, stopAutoplay: function () {
            this.$slider.slick("slickPause")
        }, triggerArrowResize: function () {
            window.setTimeout(this.setArrowPosition.bind(this), 100)
        }, setArrowPosition: function () {
            this.currentMediaQuery = window.app.matchMedia.getCurrentMediaQuery();
            var b, c, d = this.$(".slick-arrow"), e = a(window).width();
            ("media-from-m-to-l" === this.currentMediaQuery || e > 960 && e < 1101) && d.length ? (b = this.$(".stage-media"), c = b.height() / 2 - d.height() / 2, d.css("top", c).css("marginTop", 0).css("transform", "none")) : d.removeAttr("style")
        }
    });
    return function (a) {
        return this instanceof e ? this : new e(a)
    }
}), define("views/video-detail-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        events: {"click button.play": "fadeToVideo", "click .video-share-button": "initShare"},
        initialize: function (c) {
            this.options = b.extend({}, this.defaults, b.omit(c, ["el", "$el"])), this.$btnPlay = a('<button type="button" class="btn play"></button>'), this.$video = this.$("video"), this.$preview = this.$(".video-preview"), this.$shareBtn = this.$(".video-share-button"), this.$shareLayer = this.$(".video-share-layer"), this.render()
        },
        render: function () {
            return this.$preview.append(this.$btnPlay), this
        },
        fadeToVideo: function () {
            var a = this.$video;
            this.$preview.find("img").add(this.$btnPlay).fadeOut(400, function () {
                a.fadeIn(300, function () {
                    a[0].play()
                })
            })
        },
        initShare: function () {
            this.$shareLayer.fadeToggle(300), this.$shareBtn.toggleClass("active")
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/video-teaser-view", ["jquery", "underscore", "backbone"], function (a, b, c) {
    "use strict";
    var d = c.View.extend({
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.render()
        }, render: function () {
            a('<button type="button" class="btn play" />').appendTo(this.$(".image"))
        }
    });
    return function (a) {
        return this instanceof d ? this : new d(a)
    }
}), define("views/video-load-more-view", ["jquery", "underscore", "backbone", "mustache", "views/video-teaser-view", "equal-height"], function (a, b, c, d, e) {
    "use strict";
    var f = c.View.extend({
        $teasersContainer: void 0,
        $loadMoreButton: void 0,
        moreVideosUrl: void 0,
        events: {"click .controls a": "loadMoreVideos"},
        initialize: function (a) {
            this.options = b.extend({}, this.defaults, b.omit(a, ["el", "$el"])), this.$teasersContainer = this.$(".teasers-2, .teasers-3, .teasers-4"), this.$loadMoreButton = this.$(".controls a"), this.moreVideosUrl = this.$loadMoreButton.attr("href"), this.render()
        },
        render: function () {
            return this.videoTeaserTemplate = a("#video-teaser-tmpl").html(), b.isUndefined(this.videoTeaserTemplate) || !b.isString(this.videoTeaserTemplate) ? this : void d.parse(this.videoTeaserTemplate)
        },
        renderLoadedVideos: function (c) {
            if (b.has(c, "videos") && b.isArray(c.videos)) {
                var f = d.render(this.videoTeaserTemplate, c),
                    g = a(f).filter(".video-teaser").appendTo(this.$teasersContainer);
                g.each(function (a, b) {
                    e({el: b})
                }), window.setTimeout(g.setEqualHeight.bind(g), 100), this.enableButton()
            }
        },
        disableButton: function () {
            this.$loadMoreButton.addClass("disabled")
        },
        enableButton: function () {
            this.$loadMoreButton.removeClass("disabled")
        },
        onLoadMoreComplete: function (a, b) {
            "success" === b && a ? this.renderLoadedVideos(a) : this.onLoadMoreFailed()
        },
        onLoadMoreFailed: function () {
        },
        loadMoreVideos: function () {
            return event.preventDefault(), !this.$loadMoreButton.hasClass("disabled") && (this.disableButton(), void a.ajax({
                cache: !1,
                method: "GET",
                url: this.moreVideosUrl
            }).done(this.onLoadMoreComplete.bind(this)).fail(this.onLoadMoreFailed.bind(this)))
        }
    });
    return function (a) {
        return this instanceof f ? this : new f(a)
    }
}), define("app/app", ["jquery", "underscore", "backbone", "logger", "app/event-dispatcher", "app/browser-events", "app/match-media", "../views/accordion-item-view", "../views/activity-view", "../views/add-to-cart-view", "../views/app-view", "../views/application-table-view", "../views/available-options-view", "../views/button-lightbox-view", "../views/captcha-slider-view", "../views/contact-grid-view", "../views/contact-locator-view", "../views/country-overview-view", "../views/country-slider-view", "../views/coverflow-teaser-view", "../views/editorial-images-view", "../views/equal-height-view", "../views/facts-and-figures-view", "../views/faq-view", "../views/footnote-item-view", "../views/footnote-view", "../views/form-view", "../views/generic-content-view", "../views/generic-slider-view", "../views/generic-teaser-view", "../views/google-maps-view", "../views/header-view", "../views/howtobuy-linklist-view", "../views/inred-form-multiselect-view", "../views/inred-form-notification-view", "../views/job-contact-share-view", "../views/job-table-favorite-view", "../views/jobboard-filter-view", "../views/jobboard-table-view", "../views/lightbox-view", "../views/linklist-dropdown-view", "../views/nav-main-view", "../views/nav-mobile-view", "../views/nav-shopping-cart-view", "../views/navigation-view", "../views/order-no-view", "../views/oscilloscope-filter-view", "../views/product-comparison-view", "../views/product-equal-height-view", "../views/product-filter-view", "../views/product-header-view", "../views/product-key-features-view", "../views/product-list-compare-button-view", "../views/product-list-table-slider-view", "../views/product-list-view", "../views/product-options-downloads-view", "../views/product-related-products-view", "../views/product-slider-view", "../views/product-teaser-view", "../views/quicklinks-view", "../views/search-sort-filter-view", "../views/search-view", "../views/searchbar-view", "../views/share-view", "../views/simple-banner-view", "../views/styled-dropdown-view", "../views/tab-slider-view", "../views/table-product-comparison-view", "../views/table-view", "../views/teaser-customer-voice-view", "../views/teaser-hotspot-view", "../views/teaser-linklist-picture-view", "../views/teaser-offset-view", "../views/teaser-promo-view", "../views/teaser-slider-view", "../views/teaser-stage-counter-view", "../views/teaser-stage-image-view", "../views/teaser-stage-media-video-view", "../views/teaser-stage-new-video-view", "../views/teaser-stage-new-view", "../views/tradeshow-view", "../views/video-detail-view", "../views/video-load-more-view", "../views/video-teaser-view", "../views/video-view"], function (a, b, c, d, e, f, g) {
    "use strict";

    function h() {
        this.eventDispatcher = {}, this.matchMedia = {}, this.views = [], this.logger = d.get("app"), this.formTrackingFields = [{
            name: "sku",
            data: "sku"
        }, {name: "m4c_purpose", data: "purpose", default: ""}, {
            name: "m4c_ioi",
            data: "ioi",
            default: ""
        }, {
            name: "m4c_title",
            data: "m4ctitle",
            default: ""
        }], this.m4cTrackingFields = {
            interactions: {
                interactionData: [{
                    name: "m4c_interactionType",
                    data: "interactionType",
                    default: ""
                }, {name: "m4c_campaignId", data: "campaignID", default: ""}, {
                    name: "m4c_ioi",
                    data: "itemOfInterests",
                    default: [],
                    split: "|"
                }, {name: "m4c_productInterest1", data: "productInterest1", default: ""}, {
                    name: "leadSourceID",
                    data: "leadSourceID",
                    default: ""
                }]
            }
        }, this.applicationEvents = {
            VIEWPORT_CHANGE: "viewport:change",
            WINDOW_RESIZE: "window:resize",
            WINDOW_SCROLL: "window:scroll",
            GENERIC_SLIDER_INITIALIZED: "generic-slider:initialized",
            ACCORDION_OPEN: "accordion:open",
            ACCORDION_SHOW: "accordion:show",
            ACCORDION_SHOWN: "accordion:shown",
            ACCORDION_HIDE: "accordion:hide",
            ACCORDION_RESET: "accordion:reset",
            ACCORDION_RECALCULATE: "accordion:recalculate",
            PRODUCT_FILTER_UPDATE: "productFilter:update",
            PRODUCT_COMPARISON_ADD: "productComparison:add",
            PRODUCT_COMPARISON_ADDED: "productComparison:added",
            PRODUCT_COMPARISON_REMOVE: "productComparison:remove",
            PRODUCT_COMPARISON_REMOVED: "productComparison:removed",
            PRODUCT_COMPARISON_STORE_ADD: "productComparisonStore:add",
            PRODUCT_COMPARISON_STORE_REMOVE: "productComparisonStore:remove",
            PRODUCT_COMPARISON_OPEN: "productComparison:open",
            PRODUCT_COMPARISON_CLOSE: "productComparison:close",
            TAB_SLIDER_INIT: "tabSlider:init",
            TAB_SLIDER_CHANGE: "tabSlider:beforeChange",
            TAB_SLIDER_AFTER_CHANGE: "tabSlider:afterChange",
            AVAILABLE_OPTIONS_CHANGE: "availableOptions:change",
            AVAILABLE_OPTIONS_CHANGED: "availableOptions:changed",
            AVAILABLE_OPTIONS_OPEN: "availableOptions:open",
            PRODUCT_SLIDER_CHANGE: "productSlider:change",
            PRODUCT_SLIDER_TRANSITIONEND: "productSlider:transitionend",
            MODULE_STATE: "module:state",
            ROUTER_DEFAULT: "router:default",
            ROUTER_MODULE_STATE: "router:moduleState",
            ROUTER_COMPARISON_OPEN: "router:openComparison",
            OSCILLOSCOPE_FILTER_UPDATE: "oscilloscopeFilter:update",
            VIDEO_ENDED: "video:ended",
            VIDEO_STAGE_SLIDER_CHANGED: "teaserStage.video:positionChanged",
            TEASER_STAGE_STOP_AUTOPLAY: "teaserStage.slider:stop",
            TEASER_STAGE_START_AUTOPLAY: "teaserStage.slider:start",
            GOOGLE_MAPS_LOAD: "googleMaps:load",
            GOOGLE_MAPS_UPDATE: "googleMaps:update",
            GOOGLE_MAPS_OPEN_INFO_WINDOW: "googleMaps:openInfoWindow",
            GOOGLE_MAPS_LOADING_ERROR: "googleMaps:error",
            GOOGLE_MAPS_PLACE_LOADED: "googleMaps:placeLoaded",
            LIGHTBOX_BEFORE_OPEN: "lightbox:beforeOpen",
            LIGHTBOX_GALLERY_READY: "lightbox:galleryReady"
        }
    }

    return h.prototype.initialize = function () {
        this.eventDispatcher = e.getInstance(), this.initConfig(), f.getInstance(), this.matchMedia = g.getInstance(), this.initViews(this.views)
    }, h.prototype.initConfig = function () {
        d.useDefaults(), d.setLevel(d.ERROR)
    }, h.prototype.initViews = function (c, d) {
        var e = d || document, f = a(e.querySelectorAll("[data-view]"));
        return f.each(function (d, e) {
            var f = a(e).data("view").replace(/\./g, "/");
            b.each(f.split(" "), function (a) {
                require(["views/{name}-view".replace("{name}", a)], function (a) {
                    c.push(new a({el: e}))
                })
            })
        }), f.length
    }, h.prototype.trackEvent = function (a, c, d, e) {
        return e ? (console.log(a, "Adobe Type"), console.log(c, "Adobe Data"), void console.log(d, "Webtrends Data")) : (b.isString(a) && b.isObject(c) && this.trackAdobeEvent(a, c), void (b.isArray(d) && this.trackWebtrendsEvent(d)))
    }, h.prototype.trackAdobeEvent = function (a, c) {
        "undefined" != typeof window._satellite && b.isObject(c) ? (window.digitalData = window.digitalData || {}, window.digitalData[a] = c, this.logger.info("trackAdobeEvent", a, window.digitalData), window._satellite.track(a)) : c ? console.warn("No trackingdata defined") : console.warn(c, "_satellite object not defined.")
    }, h.prototype.trackWebtrendsEvent = function (a) {
        "undefined" != typeof window.Webtrends && b.isArray(a) && a.length ? window.Webtrends.multiTrack({argsa: a}) : 0 === a.length ? console.warn("No arguments defined") : console.warn(a, "Webtrends object not defined")
    }, h.prototype.getTrackingDataFromForm = function (a) {
        var c = {}, d = a.elements;
        if (!d) return c;
        var e;
        return b.each(this.formTrackingFields, function (a) {
            e = d[a.name], e && e.value ? c[a.data] = e.value : a.hasOwnProperty("default") && (c[a.data] = a.default)
        }), c
    }, h.prototype.addM4CDataToAdobeTrackingFromForm = function (a) {
        if (!a.elements) return void this.logger.error("Invalid element.");
        var c, d, e = {}, f = a.elements;
        b.each(this.m4cTrackingFields.interactions.interactionData, function (a) {
            return c = f[a.name], c && c.value ? (d = a.split ? c.value.split(a.split) : c.value, void (e[a.data] = d)) : void (e[a.data] = a.hasOwnProperty("default") ? a.default : "")
        }), window.digitalData = window.digitalData || {}, window.digitalData.m4c = {interactions: {interactionData: e}}
    }, h.prototype.addFormResponseDataToAdobeTracking = function (c) {
        var d = c["hidden-values"], e = b.isObject(d) ? d.hashedEmail : null,
            f = b.isObject(d) ? d.interactionID : null;
        window.digitalData = window.digitalData || {}, a.extend(!0, window.digitalData, {
            visitor: {hashedEmail: e},
            m4c: {interactions: {interactionData: {interactionID: f}}}
        })
    }, h.prototype.api = function (b) {
        var c = b || {};
        return a.ajax({
            cache: !1,
            headers: {Accept: "application/json"},
            dataType: "json",
            method: c.method || "GET",
            url: c.url,
            data: c.data
        })
    }, function () {
        var a;
        return {
            getInstance: function () {
                return void 0 === a && (a = new h), a
            }
        }
    }()
}), requirejs.config({
    paths: {
        jquery: "vendor/jquery-3.5.1",
        underscore: "vendor/underscore-1.9.1",
        "underscore-noconflict": "vendor/underscore-noconflict",
        backbone: "vendor/backbone-1.4.0",
        "backbone-noconflict": "vendor/backbone-noconflict",
        "equal-height": "vendor/equal-height",
        "slick-slider": "vendor/jquery-slick-slider",
        "magnific-popup": "vendor/jquery.magnific-popup-1.1.0",
        noUiSlider: "vendor/nouislider",
        wnumb: "vendor/wNumb",
        mustache: "vendor/mustache",
        TweenLite: "vendor/gsap/TweenLite",
        "gsap.cssplugin": "vendor/gsap/plugins/CSSPlugin",
        Cookies: "vendor/js.cookie-2.2.0",
        "images-loaded": "vendor/imagesloaded.pkgd",
        "jquery-countdown": "vendor/jquery.countdown",
        iscroll: "vendor/iscroll",
        swiper: "vendor/swiper.min",
        "tiny-sort": "vendor/tinysort",
        "simple-select": "vendor/simple-select",
        ScrollMagic: "vendor/ScrollMagic",
        ScrollMagicIndicators: "vendor/debug.addIndicators",
        ScrollMagicAnimation: "vendor/gsap/animation.gsap",
        clipboard: "vendor/clipboard",
        logger: "vendor/logger-1.6.0"
    },
    map: {
        "*": {underscore: "underscore-noconflict", backbone: "backbone-noconflict"},
        "underscore-noconflict": {underscore: "underscore"},
        "backbone-noconflict": {backbone: "backbone"}
    },
    shim: {"simple-select": ["jquery"], "images-loaded": ["jquery"], "jquery-countdown": ["jquery"]}
}), require(["app/app"], function (a) {
    "use strict";
    var b = a.getInstance();
    window.app = b, b.initialize()
}), define("main", function () {
});